/*! @twilio/flex-ui-core.js 2.3.2
The following license applies to all parts of this software except as documented below.

Copyright (c) 2018 Twilio, Inc.
All rights reserved.

 Licensed under the Apache License, Version 2.0 (the “License”);
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an “AS IS” BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.


This software includes react under the following license.

Copyright (c) Facebook, Inc. and its affiliates.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes redux under the following license.
Copyright (c) 2015-present Dan Abramov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes semver under the following license.
Copyright (c) Isaac Z. Schlueter and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.


This software includes loglevel under the following license.
Copyright (c) 2013 Tim Perry

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.


This software includes hoist-non-react-statics under the following license.

Software License Agreement (BSD License)
========================================

Copyright (c) 2015, Yahoo! Inc. All rights reserved.
----------------------------------------------------

Redistribution and use of this software in source and binary forms, with or
without modification, are permitted provided that the following conditions are
met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.
  * Neither the name of Yahoo! Inc. nor the names of YUI's contributors may be
    used to endorse or promote products derived from this software without
    specific prior written permission of Yahoo! Inc.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.FlexCore = t() : (e.Twilio = e.Twilio || {}, e.Twilio.FlexCore = t());
}(window, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/assets/", n(n.s = 80);
  }([function (e, t) {
    e.exports = require("react");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.rootStyleObjectToString = t.styleObjectToString = t.getBackgroundWithHoverCSS = t.styled = t.withTheme = void 0;
    var o = n(29),
      i = r(n(14)),
      a = n(29);
    Object.defineProperty(t, "withTheme", {
      enumerable: !0,
      get: function () {
        return a.withTheme;
      }
    }), t.styled = i.default;
    t.getBackgroundWithHoverCSS = function (e, t, n, r) {
      if (void 0 === n && (n = !1), void 0 === r && (r = !1), !e) return "";
      var o = "rgba(0, 0, 0, 0.2)",
        i = "rgba(0, 0, 0, 0.3)";
      if (t && (o = "rgba(255, 255, 255, 0.2)", i = "rgba(255, 255, 255, 0.3)"), n) return "\n            background-image: linear-gradient(to top, " + e + ", " + e + ");\n            background-color: " + o + ";\n            background-blend-mode: color;\n        ";
      var a = "\n        background-image: linear-gradient(to top, " + e + ", " + e + ") !important;\n    ";
      return r || (a = a + "\n            &:hover {\n                background-color: " + o + ";\n                background-blend-mode: color;\n            }\n            &:active {\n                background-color: " + i + ";\n                background-blend-mode: color;\n            }\n        "), a;
    };
    t.styleObjectToString = function (e) {
      return "string" == typeof e ? e : (0, o.css)([e]).styles;
    };
    t.rootStyleObjectToString = function (e) {
      if ("string" == typeof e) return e;
      var n = Object.entries(e).reduce(function (e, t) {
        var n = t[0],
          r = t[1];
        return "object" == typeof r ? e.propertiesWithSelector[n] = r : e.propertiesWithoutSelector[n] = r, e;
      }, {
        propertiesWithoutSelector: {},
        propertiesWithSelector: {}
      });
      return (0, t.styleObjectToString)({
        body: n.propertiesWithoutSelector
      }) + (0, t.styleObjectToString)(n.propertiesWithSelector);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CompiledTemplate = t.Template = t.templates = void 0;
    var r = n(10);
    Object.defineProperty(t, "Template", {
      enumerable: !0,
      get: function () {
        return r.Template;
      }
    }), Object.defineProperty(t, "CompiledTemplate", {
      enumerable: !0,
      get: function () {
        return r.CompiledTemplate;
      }
    });
    var o = r.templates;
    t.templates = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.log = void 0;
    var a = i(n(172)).getLogger("twilio-flex-ui-core");
    t.log = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SvgContainerProps = t.IconProps = t.Icon = void 0;
    var r = n(205);
    Object.defineProperty(t, "Icon", {
      enumerable: !0,
      get: function () {
        return r.Icon;
      }
    });
    var o = n(396);
    Object.defineProperty(t, "IconProps", {
      enumerable: !0,
      get: function () {
        return o.IconProps;
      }
    }), Object.defineProperty(t, "SvgContainerProps", {
      enumerable: !0,
      get: function () {
        return o.SvgContainerProps;
      }
    });
  }, function (e, t) {
    e.exports = require("@emotion/css");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexBoxColumn = t.FlexBoxProperties = t.FlexBox = void 0;
    var r = n(93);
    Object.defineProperty(t, "FlexBox", {
      enumerable: !0,
      get: function () {
        return r.FlexBox;
      }
    }), Object.defineProperty(t, "FlexBoxProperties", {
      enumerable: !0,
      get: function () {
        return r.FlexBoxProperties;
      }
    });
    var o = n(185);
    Object.defineProperty(t, "FlexBoxColumn", {
      enumerable: !0,
      get: function () {
        return o.FlexBoxColumn;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      s = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      l = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && s(t, e, n);
        return l(t, e), t;
      },
      u = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || s(t, e, n);
      },
      d = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DefaultContentFragment = t.ContentFragment = t.DynamicComponent = void 0;
    var f = n(5),
      p = n(29),
      h = d(n(14)),
      v = c(n(0)),
      m = c(n(6)),
      g = n(27),
      b = n(12),
      y = n(16),
      _ = (n(3), n(9));
    u(n(25), t);
    var O = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return this.props.children;
      }, t;
    }(v.Component);
    t.ContentFragment = O;
    var C = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return this.props.children;
      }, t;
    }(v.Component);
    t.DefaultContentFragment = C;
    var P = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }
        return o(t, e), t.prototype.componentDidCatch = function (e) {
          if ((0, g.isCoreError)(e)) throw e;
          throw b.ErrorManager.createAndProcessError(y.ErrorMessages.DYNAMIC_COMPONENT_GENERIC_MESSAGE, {
            wrappedError: e,
            description: "An error has been detected inside the " + this.props.name + " DynamicComponent",
            context: "DynamicComponent"
          });
        }, t.prototype.parseFragment = function (e, n, r, o, i, a) {
          var s,
            l = [],
            c = !1,
            u = function (e, n) {
              var r = v.Children.map(e.props.children, function (r, o) {
                return {
                  sortOrder: void 0 === e.props.sortOrder ? l.length + o : e.props.sortOrder,
                  node: r = n ? t.cloneElementWithProps(r, i) : r
                };
              });
              e.props.replace ? (s = r, c = c || void 0 === e.props.align) : l.push.apply(l, r);
            },
            d = v.Children.only(n),
            f = d.props.children;
          "start" === e && (v.Children.toArray(f).find(function (e) {
            return v.isValidElement(e) && e.type === O;
          }) || u(d, !1));
          var p = function (t) {
              var n = t;
              if (!v.isValidElement(n) || n.type !== O) return !1;
              if (n.props.if && !n.props.if(i)) return !1;
              var r = n.props.align;
              return r === e || "start" === e && void 0 === r;
            },
            h = function (e, t) {
              v.Children.toArray(e).filter(p).forEach(function (e) {
                u(e, t);
              });
            };
          h(f, !1), h(r, !0), h(o, !0);
          var m = s && s.length > 0 ? s : l;
          if (a.length > 0) {
            var g = a.filter(function (e) {
              return !e.options.if || e.options.if(i);
            });
            m = m.filter(function (e) {
              return !g.find(function (t) {
                return !!v.isValidElement(e.node) && e.node.key === t.key;
              });
            });
          }
          if (m.find(function (e) {
            if (!v.isValidElement(e.node)) return !1;
            var t = e.node;
            return t.type !== C && (null === t.key || void 0 === t.key);
          })) throw b.ErrorManager.createAndProcessError(y.ErrorMessages.DYNAMIC_COMPONENT_ELEMENTS_WITHOUT_KEY, {
            context: "DynamicComponent",
            description: "Elements without key in " + this.props.name
          });
          var P = _.Utils.stableSort(m, function (e, t) {
            return e.sortOrder - t.sortOrder;
          }).map(function (e) {
            return e.node;
          });
          return this.props.renderChildren && (P = this.props.renderChildren(P, e)), {
            replacedDefault: c,
            items: P
          };
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = e.customChildren,
            r = e.childProps,
            o = e.contentStore,
            i = e.name,
            s = e.vertical,
            l = e.noContainers,
            c = e.subContainer,
            u = v.Children.only(t),
            d = a(a({}, r), {
              theme: this.props.theme
            }),
            p = this.parseFragment("start", t, n, o.fragments, d, o.removeRequests),
            h = null,
            g = null,
            _ = null;
          if (l && c) throw b.ErrorManager.createAndProcessError(y.ErrorMessages.DYNAMIC_COMPONENT_MUTUALLY_EXCLUSIVE, {
            description: "noContainers and subContainer prop cannot be both set!",
            context: "DynamicComponent"
          });
          l || (g = c ? v.cloneElement(c, {
            vertical: s,
            key: "start",
            className: (0, f.cx)("Twilio-" + i + "-default", j && E),
            overflow: "hidden"
          }, p.items) : v.createElement(m.FlexBox, {
            vertical: s,
            key: "start",
            className: (0, f.cx)("Twilio-" + i + "-default", j && E),
            overflow: "hidden"
          }, p.items)), p.replacedDefault || (h = this.parseFragment("end", t, n, o.fragments, d, o.removeRequests), l || (j && h.items.push(v.createElement(k, null, i, "-end")), _ = v.createElement(m.FlexBox, {
            vertical: s,
            key: "end",
            className: (0, f.cx)("Twilio-" + i + "-end", j && E),
            noGrow: !0,
            overflow: "hidden"
          }, h.items)));
          var O = (0, f.css)(this.props.rootContainerStyles),
            P = l ? [p.items, h ? h.items : []] : [g, _];
          if (l && 0 === p.items.length && (!h || 0 === h.items.length)) {
            var M = v.Children.only(t);
            if (M.props.children) P = [v.Children.toArray(M.props.children).find(function (e) {
              return v.isValidElement(e) && e.type === C;
            })];
          }
          return j && P.push(v.createElement(k, null, i)), v.cloneElement(u, {
            className: (0, f.cx)("Twilio", "Twilio-" + i, O, j && w)
          }, P);
        }, t.cloneElementWithProps = function (e, t) {
          var n = e;
          return v.isValidElement(e) && "string" != typeof e.type ? v.cloneElement(n, a(a({}, t), e.props), n.props.children) : e;
        }, t.displayName = "DynamicComponent", t.defaultProps = {
          rootContainerStyles: "display: flex;\n            position: relative;\n            overflow-x: hidden;"
        }, t;
      }(v.PureComponent),
      M = (0, p.withTheme)(P);
    t.DynamicComponent = M;
    var j = !1,
      w = "DynamicComponentDebug",
      E = "DynamicComponentContainerDebug";
    j && (0, f.injectGlobal)(S || (S = i(["\n        .", ",\n        .", ",\n        .", " {\n            border-color: transparent;\n        }\n        .", " {\n            position: relative;\n        }\n        .", ":hover {\n            border: 3px solid red;\n        }\n        .", ":hover {\n            border: 2px solid green;\n        }\n        .", ":hover > .DebugLabel,\n        .", ":hover > .DebugLabel {\n            display: flex;\n        }\n        .", " > * {\n            border: 1px solid transparent;\n        }\n        .", ":hover > *:hover {\n            border: 1px solid blue;\n        }\n        .", " > .DebugLabel {\n            color: red;\n        }\n        .", " > .DebugLabel {\n            color: green;\n        }\n    "], ["\n        .", ",\n        .", ",\n        .", " {\n            border-color: transparent;\n        }\n        .", " {\n            position: relative;\n        }\n        .", ":hover {\n            border: 3px solid red;\n        }\n        .", ":hover {\n            border: 2px solid green;\n        }\n        .", ":hover > .DebugLabel,\n        .", ":hover > .DebugLabel {\n            display: flex;\n        }\n        .", " > * {\n            border: 1px solid transparent;\n        }\n        .", ":hover > *:hover {\n            border: 1px solid blue;\n        }\n        .", " > .DebugLabel {\n            color: red;\n        }\n        .", " > .DebugLabel {\n            color: green;\n        }\n    "])), w, E, "DynamicComponentContainerItemDebug", E, w, E, E, w, E, E, w, E);
    var S,
      x,
      T,
      A = (0, h.default)("div")(x || (x = i(["\n    margin: auto;\n    background: yellow;\n    z-index: 10000;\n"], ["\n    margin: auto;\n    background: yellow;\n    z-index: 10000;\n"]))),
      I = (0, h.default)("div")(T || (T = i(["\n    display: none;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    pointer-events: none;\n"], ["\n    display: none;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    pointer-events: none;\n"]))),
      k = function (e) {
        var t = e.children;
        return v.createElement(I, {
          className: "DebugLabel"
        }, v.createElement(A, null, t));
      };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatModule = void 0;
    var r = n(52),
      o = n(12),
      i = function (e) {
        return e;
      },
      a = function () {
        function e() {}
        return e.init = function (t, n, r) {
          void 0 === n && (n = i), e.localStateCallback = n, e.localStore = t, e._parentEvents = r;
        }, Object.defineProperty(e, "state", {
          get: function () {
            if (!e.localStateCallback) throw o.ErrorManager.createAndProcessError("Trying to get ChatModule state without ChatModule being initialized", {
              context: "ChatModule"
            });
            return e.stateCallback(e.localStore.getState());
          },
          enumerable: !1,
          configurable: !0
        }), e.dispatch = function (t) {
          if (!e.localStore) throw o.ErrorManager.createAndProcessError("Trying to dispatch an action against ChatModule state without ChatModule being initialized", {
            context: "ChatModule"
          });
          return e.localStore.dispatch(t);
        }, Object.defineProperty(e, "events", {
          get: function () {
            return e.localEvents;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "parentEvents", {
          get: function () {
            return e._parentEvents;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "stateCallback", {
          get: function () {
            return e.localStateCallback;
          },
          enumerable: !1,
          configurable: !0
        }), e.localEvents = new r.ChatEventEmitter(), e;
      }();
    t.ChatModule = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      l = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      c = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      },
      u = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.fetchMediaContent = t.Utils = void 0;
    var d = u(n(173)),
      f = u(n(174)),
      p = a(n(0)),
      h = n(3),
      v = n(2),
      m = "((?:\\s|^))(((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:app)|(?:biz|buzz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|credit|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\\:\\d{1,5})?)((?:\\/|\\?)(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?(?:\\b|$))",
      g = function () {
        function e() {}
        return e.stableSort = function (e, t) {
          var n = e.map(function (e, t) {
            return {
              index: t,
              value: e
            };
          });
          return n.sort(function (e, n) {
            return t(e.value, n.value) || e.index - n.index;
          }), n.map(function (e) {
            return e.value;
          });
        }, e.merge = function (t, n, r) {
          void 0 === r && (r = !0);
          var o = Object.assign({}, t);
          return e.mergeInto(o, n, r);
        }, e.mergeInto = function (t, n, r) {
          return void 0 === r && (r = !0), Object.keys(n).forEach(function (o) {
            var i = n[o],
              a = !1;
            "object" != typeof i || null === i || i instanceof Array || Object.getPrototypeOf(i) !== Object.prototype || (i = e.merge(t[o] || {}, i, r), a = !0), (r || void 0 === t[o] || a) && (t[o] = i);
          }), t;
        }, e.mergeArrayItems = function (e) {
          return e.reduce(function (e, t) {
            return e.concat(t);
          }, []);
        }, e.updateDefaultProps = function (e, t) {
          var n = this;
          t && 0 !== Object.keys(t).length && Object.keys(t).forEach(function (r) {
            var o = e[r];
            if (!o) return h.log.warn("updateDefaultProps, component does not exist:", r);
            var i = t[r];
            if (o.defaultProps) {
              var a = !1;
              Object.keys(i).forEach(function (e) {
                if (void 0 === o.defaultProps[e]) {
                  var t = i[e];
                  o.overrideProps && t !== o.overrideProps[e] && (o.overrideProps[e] = t, a = !0), delete i[e];
                } else h.log.warn("updateDefaultProps, component.defaultProps[propName] has been explicity set and cannot be overridden:", r, e);
              }), a && Object.prototype.hasOwnProperty.call(o, "updateAll") && o.updateAll();
            }
            return n.updateDefaultProps(o, i);
          });
        }, e.getNameForMember = function (e, t, n, r) {
          return n && e ? n : t || n || r;
        }, e.formatString = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          for (var r = 0; r < t.length; r++) {
            var o = new RegExp("\\{" + r + "\\}", "gm");
            e = e.replace(o, t[r]);
          }
          return e;
        }, e.parseVersion = function (e) {
          if (e) {
            var t = e.split(new RegExp("[.+-]"));
            if (!(t.length < 3)) return {
              major: parseInt(t[0], 10),
              minor: parseInt(t[1], 10),
              build: parseInt(t[2], 10)
            };
          }
        }, e.isGreaterThanTargetVersion = function (e, t) {
          return !(!e || !t) && (e.major > t.major || e.major === t.major && (e.minor > t.minor || e.minor === t.minor && e.build >= t.build));
        }, e.copyMap = function (e) {
          if (e) {
            var t = new Map();
            return e.forEach(function (e, n) {
              t.set(n, e);
            }), t;
          }
        }, e.isSameDate = function (e, t) {
          return e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
        }, e.isToday = function (e) {
          var t = new Date();
          return this.isSameDate(t, e);
        }, e.isYesterday = function (e) {
          var t = new Date();
          return t.setDate(t.getDate() - 1), this.isSameDate(e, t);
        }, e.formatSeparatorDate = function (e) {
          return this.isToday(e) ? v.templates.Today() : this.isYesterday(e) ? v.templates.Yesterday() : e.toLocaleDateString();
        }, e.parseText = function (e) {
          var t = this,
            n = [];
          e = e.trim();
          var r = new RegExp(/[\n\r]/),
            o = e.split(r);
          return o.forEach(function (e, r) {
            for (var i, a = 0; i = t.urlRegexp.exec(e);) {
              n.push(e.substr(a, i.index + i[1].length - a));
              var s = i[2],
                l = s;
              t.simpleUrlRegexp.exec(s) || (l = "http://" + s), n.push(p.createElement("a", {
                href: l,
                key: a,
                target: "_blank"
              }, [s])), a = i.index + i[0].length;
            }
            a < e.length && n.push(e.substr(a, e.length)), r < o.length - 1 && n.push(p.createElement("br", {
              key: r
            }));
          }), n;
        }, e.parseMDText = function (e) {
          var t = this;
          void 0 === e && (e = "");
          var n = "(^|[^~])~([^~\\n]+)~([^~]|$)",
            r = "\\[[\\sx]\\]",
            o = "^ *\\| *",
            i = m,
            a = "^>(?:.+)\n(?=>)",
            s = ["(?:^(?!(?:-|\\*)|(?:\\d\\.))(?:.+?)\n)", "(?:\n(?!-|\\*|(?:\\d\\.)|\n))"].join("|");
          return e.replace(new RegExp(n + "|" + a + "|" + r + "|" + o + "|" + s + "|" + i, "gm"), function (e) {
            if (e.match(n)) return e.replace(/~/g, "~~");
            if (e.match(/^>(.+)\n$/)) return e + "\n \n\n";
            if (e.match(new RegExp(r + "|" + o))) return "\\" + e;
            if (e.match(/^(.*)\n$/)) return e + "\n";
            if (e.match(i)) {
              var a = " " === e.charAt(0);
              a && (e = e.substring(1));
              var s = e;
              return t.simpleUrlRegexp.exec(e) || (s = "http://" + e), (a ? " " : "") + "[" + e + "](" + s + ")";
            }
            return e;
          });
        }, e.formatTimeDurationInFull = function (e, t, n, r) {
          var o = e + "d:",
            i = t + ":",
            a = n + ":",
            s = String(r);
          return 0 === e && (o = ""), t < 10 && (i = "0" + i), 0 === t && (i = ""), n < 10 && (a = "0" + a), r < 10 && (s = "0" + s), o + i + a + s;
        }, e.formatTimeDurationInCompact = function (e, t, n, r) {
          return e > 0 ? e + "d" : t > 0 ? t + "h" : n > 0 ? n + "m" : r + "s";
        }, e.formatTimeDurationInShort = function (e, t, n, r) {
          return e > 0 ? e + "d" + (0 === t ? "" : " " + t + "h") : t > 0 ? t + "h" + (0 === n ? "" : " " + n + "min") : n > 0 ? n + ":" + (r < 10 ? "0" + r : "" + r) : r + "s";
        }, e.formatTimeDuration = function (t, n) {
          void 0 === n && (n = "full");
          var r = t < 0;
          r && (t = -t);
          var o,
            i = new Date(t),
            a = Math.floor(t / 864e5),
            s = i.getUTCHours(),
            l = i.getUTCMinutes(),
            c = i.getSeconds();
          return o = "compact" === n ? e.formatTimeDurationInCompact(a, s, l, c) : "short" === n ? e.formatTimeDurationInShort(a, s, l, c) : e.formatTimeDurationInFull(a, s, l, c), r ? "-" + o : o;
        }, e.areEqual = function (e, t) {
          if ("object" == typeof e && "object" == typeof t) {
            if (Object.keys(e).length < Object.keys(t).length) {
              var n = e;
              e = t, t = n;
            }
            return Object.keys(e).every(function (n) {
              return e[n] === t[n];
            });
          }
          return e === t;
        }, e.haveSameValues = function (e, t, n) {
          var o = this;
          void 0 === n && (n = {});
          var i = r(r({}, e), t);
          return Object.keys(i).every(function (r) {
            var i = e[r],
              a = t[r];
            if (n.equalUndefinedToEmptyArray && (void 0 === i && (i = []), void 0 === a && (a = [])), "object" != typeof i || "object" != typeof a) return i === a;
            if (!Array.isArray(i) || !Array.isArray(a)) return !Array.isArray(i) && !Array.isArray(a) && o.haveSameValues(i, a);
            var s = c(c([], i, !0), a, !0).filter(function (e, t, n) {
              return t === n.indexOf(e);
            });
            return s.length === i.length && s.length === a.length;
          });
        }, e.simpleUrlRegexp = new RegExp("^https?://[^\\s]+", "i"), e.urlRegexp = RegExp(m, "gi"), e.getRandomValue = function () {
          var e = new Uint32Array(1);
          return window.crypto.getRandomValues(e), e[0] / 4294967296;
        }, e.startCase = function (e) {
          return (0, f.default)(e);
        }, e.formatTimeStamp = function (e, t) {
          var n = new Date(e);
          return Intl.DateTimeFormat("en-US", {
            timeStyle: t
          }).format(n);
        }, e;
      }();
    t.Utils = g;
    t.fetchMediaContent = function (e, t) {
      return void 0 === t && (t = "media content"), s(void 0, void 0, void 0, function () {
        var n, r, o;
        return l(this, function (i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 3,, 4]), [4, e.getContentTemporaryUrl()];
            case 1:
              return r = i.sent(), [4, d.default.get(r)];
            case 2:
              return n = i.sent().data, [3, 4];
            case 3:
              return o = i.sent(), h.log.error("Couldn't fetch " + t + " from newly-fetched url - " + o.message), [3, 4];
            case 4:
              return [2, n];
          }
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Template = t.templates = t.initWithStrings = void 0;
    var u = l(n(0)),
      d = n(3),
      f = /{{{\s*\S+\s*}}}/g;
    function p(e) {
      function t(t) {
        return "{{{{raw}}}}" !== (n = t[0]) && "{{{{/raw}}}}" !== n && !((r = t.index) > 0 && "\\" === e.charAt(r - 1));
        var n, r;
      }
      for (var n; null !== (n = f.exec(e));) if (t(n)) return !0;
      return !1;
    }
    var h = {};
    t.templates = h, t.initWithStrings = function (e) {
      Object.keys(e).forEach(function (t) {
        var n,
          r = e[t];
        if (p(r)) d.log.error("Unsafe template detected, use {{unsafeString [variableName]}} to render unescaped string. Template key: ", t, "Template:", r), n = function () {
          return "UNSAFE template: " + t;
        };else {
          var o = Handlebars.compile(r);
          n = function (e) {
            return o(e, {
              allowProtoMethodsByDefault: !0,
              allowProtoPropertiesByDefault: !0
            });
          };
        }
        h[t] = n;
      });
    };
    var v = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.escapeHtml = function (e) {
          if (void 0 === e) return "";
          var t = document.createElement("div");
          return t.appendChild(document.createTextNode(e)), t.innerHTML;
        }, t;
      }
      return o(t, e), t.prototype.render = function () {
        var e = this,
          t = this.props,
          n = t.source,
          r = t.code,
          o = c(t, ["source", "code"]),
          a = i(i({}, o), {
            forceUpdate: o.forceUpdate || function () {
              return e.forceUpdate();
            }
          }),
          s = n || !!r && h[r],
          l = s ? s(a) : this.escapeHtml(r);
        return "<" === l.substr(0, 1) ? u.createElement("div", {
          className: this.props.className,
          dangerouslySetInnerHTML: {
            __html: l
          }
        }) : u.createElement("span", {
          className: this.props.className,
          dangerouslySetInnerHTML: {
            __html: l
          }
        });
      }, t.defaultProps = {
        className: "Twilio"
      }, t;
    }(u.Component);
    t.Template = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationHelper = t.ConversationListener = t.Actions = t.reduce = t.ACTION_UPDATE_LAST_SCROLL_POSITION = t.ACTION_SHOW_SCROLL_DOWN_BUTTON = t.ACTION_UPDATE_MESSAGE_STATE = t.ACTION_MEDIA_MESSAGE_REJECTED = t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE = t.ACTION_ADD_PENDING_MEDIA_MESSAGE = t.ACTION_LOAD_CONVERSATION = t.ACTION_UPDATE_CONVERSATION = t.ACTION_TYPING_ENDED = t.ACTION_TYPING_STARTED = t.ACTION_UPDATED_MESSAGE = t.ACTION_UPDATED_PARTICIPANT = t.ACTION_REMOVED_PARTICIPANT = t.ACTION_REMOVED_MESSAGE = t.ACTION_LOAD_CONVERSATION_MESSAGES = t.ACTION_CONSUME_MESSAGE = t.ACTION_INIT_CONVERSATION_PARTICIPANTS = t.ACTION_UNLOAD_CONVERSATION = t.ACTION_INIT_CONVERSATION = t.ACTION_USER_UPDATED = t.ACTION_ADDED_PARTICIPANT = t.ACTION_ADDED_MESSAGE = t.DeliveryStatus = void 0;
    var s = n(8),
      l = n(84),
      c = n(44);
    Object.defineProperty(t, "ConversationHelper", {
      enumerable: !0,
      get: function () {
        return c.ConversationHelper;
      }
    });
    var u,
      d = n(27),
      f = n(12),
      p = n(3),
      h = n(54),
      v = n(13),
      m = n(24),
      g = n(9),
      b = n(87),
      y = n(55);
    !function (e) {
      e.Sent = "sent", e.Pending = "pending", e.Undelivered = "undelivered", e.Failed = "failed";
    }(u = t.DeliveryStatus || (t.DeliveryStatus = {}));
    var _ = {
        currentPaginator: void 0,
        isLoadingParticipants: !1,
        isLoadingMessages: !1,
        isLoadingConversation: !1,
        errorWhileLoadingConversation: !1,
        lastReadMessageIndex: -1,
        lastReadMessageByCurrentUserIndex: 0,
        listener: void 0,
        participants: new Map(),
        unreadMessages: [],
        messages: [],
        pendingMessages: [],
        source: void 0,
        typers: [],
        showScrollDownBtn: !1,
        lastScrollPosition: 0
      },
      O = function () {};
    t.ACTION_ADDED_MESSAGE = "CONVERSATION_ADD_MESSAGE", t.ACTION_ADDED_PARTICIPANT = "CONVERSATION_ADD_PARTICIPANT", t.ACTION_USER_UPDATED = "CONVERSATION_USER_UPDATED", t.ACTION_INIT_CONVERSATION = "CONVERSATION_INIT", t.ACTION_UNLOAD_CONVERSATION = "CONVERSATION_UNLOAD", t.ACTION_INIT_CONVERSATION_PARTICIPANTS = "CONVERSATION_INIT_PARTICIPANTS", t.ACTION_CONSUME_MESSAGE = "ACTION_CONSUME_MESSAGE", t.ACTION_LOAD_CONVERSATION_MESSAGES = "CONVERSATION_LOAD_MESSAGES", t.ACTION_REMOVED_MESSAGE = "CONVERSATION_REMOVE_MESSAGE", t.ACTION_REMOVED_PARTICIPANT = "CONVERSATION_REMOVE_PARTICIPANT", t.ACTION_UPDATED_PARTICIPANT = "CONVERSATION_UPDATED_PARTICIPANT", t.ACTION_UPDATED_MESSAGE = "CONVERSATION_UPDATE_MESSAGE", t.ACTION_TYPING_STARTED = "CONVERSATION_TYPING_STARTED", t.ACTION_TYPING_ENDED = "CONVERSATION_TYPING_ENDED", t.ACTION_UPDATE_CONVERSATION = "CONVERSATION_UPDATE", t.ACTION_LOAD_CONVERSATION = "CONVERSATION_LOAD", t.ACTION_ADD_PENDING_MEDIA_MESSAGE = "ACTION_ADD_PENDING_MEDIA_MESSAGE", t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE = "ACTION_REMOVE_PENDING_MEDIA_MESSAGE", t.ACTION_MEDIA_MESSAGE_REJECTED = "ACTION_MEDIA_MESSAGE_REJECTED", t.ACTION_UPDATE_MESSAGE_STATE = "ACTION_UPDATE_MESSAGE_STATE", t.ACTION_SHOW_SCROLL_DOWN_BUTTON = "SHOW_SCROLL_DOWN_BUTTON", t.ACTION_UPDATE_LAST_SCROLL_POSITION = "UPDATE_LAST_SCROLL_POSITION";
    var C = function (e) {
      var t,
        n = e.identity,
        r = e.updatedMessage,
        o = e.bodyAttachment,
        i = e.conversationState,
        s = i.messages.findIndex(function (e) {
          return e.index === r.index;
        }),
        l = a([], i.messages, !0);
      return l[s] = j({
        message: r,
        identity: n,
        nextMessage: s < l.length - 1 ? l[s + 1].source : void 0,
        previousMessage: s > 0 ? l[s - 1].source : void 0,
        conversationState: i,
        bodyAttachment: o || (null === (t = l[s]) || void 0 === t ? void 0 : t.bodyAttachment)
      }), l;
    };
    t.reduce = function (e, n) {
      var o, i, s, l, c, u;
      switch (void 0 === e && (e = _), n.type) {
        case t.ACTION_INIT_CONVERSATION:
          var d = n.payload;
          return r(r({}, _), {
            source: d.conversation,
            listener: d.listener
          });
        case t.ACTION_UNLOAD_CONVERSATION:
          return e.listener && e.listener.stop(), r({}, _);
        case t.ACTION_INIT_CONVERSATION_PARTICIPANTS + "_PENDING":
          return r(r({}, e), {
            isLoadingParticipants: !0
          });
        case t.ACTION_INIT_CONVERSATION_PARTICIPANTS + "_FULFILLED":
          var f = n.payload;
          return r(r({}, e), {
            participants: f,
            isLoadingParticipants: !1
          });
        case t.ACTION_INIT_CONVERSATION_PARTICIPANTS + "_REJECTED":
          return r(r({}, e), {
            isLoadingParticipants: !1
          });
        case t.ACTION_LOAD_CONVERSATION_MESSAGES + "_PENDING":
          return r(r({}, e), {
            isLoadingMessages: !0
          });
        case t.ACTION_LOAD_CONVERSATION_MESSAGES + "_REJECTED":
          return r(r({}, e), {
            isLoadingMessages: !1
          });
        case t.ACTION_LOAD_CONVERSATION_MESSAGES + "_FULFILLED":
          if (!(V = n.meta.chatState) || !V.session.client) return e;
          var p,
            h = V.session.client.user.identity,
            v = n.payload,
            m = v.items.map(function (t) {
              return j({
                message: t,
                identity: h,
                conversationState: e
              });
            }),
            b = e.messages.length && e.messages[0];
          if (b && v.items.length && b.index <= v.items[v.items.length - 1].index && b.index >= v.items[0].index) {
            var y = e.messages.filter(function (e) {
              return !m.find(function (t) {
                return t.index === e.index;
              });
            });
            m = m.concat(y);
          } else m = m.concat(e.messages);
          for (var O = 0; O < Math.min(v.items.length + 1, m.length); O++) m[O] = j({
            message: m[O].source,
            identity: h,
            conversationState: e,
            nextMessage: O < m.length - 1 ? m[O + 1].source : void 0,
            previousMessage: O > 0 ? m[O - 1].source : void 0,
            bodyAttachment: null === (o = m[O]) || void 0 === o ? void 0 : o.bodyAttachment
          });
          p = null != (null === (i = e.source) || void 0 === i ? void 0 : i.lastReadMessageIndex) ? e.source.lastReadMessageIndex : "closed" === (null === (l = null === (s = e.source) || void 0 === s ? void 0 : s.state) || void 0 === l ? void 0 : l.current) ? m[m.length - 1].index : m.length ? null === (c = e.source) || void 0 === c ? void 0 : c.lastReadMessageIndex : -1;
          var P = m.filter(function (e) {
            return e.index > p;
          });
          return r(r({}, e), {
            isLoadingMessages: !1,
            currentPaginator: v,
            messages: m,
            lastReadMessageIndex: p,
            lastReadMessageByCurrentUserIndex: p,
            unreadMessages: P
          });
        case t.ACTION_ADD_PENDING_MEDIA_MESSAGE:
          var M = n.payload.media,
            E = (V = n.meta.chatState) && V.session.client ? V.session.client.user.identity : "",
            S = e.pendingMessages.length,
            x = S > 0 ? e.pendingMessages[S - 1] : e.messages[e.messages.length - 1],
            T = {
              index: S,
              groupWithNext: !1,
              groupWithPrevious: !!x && x.source.author === E,
              isFromMe: !0,
              isSending: !0,
              source: {
                index: S,
                media: M,
                author: E,
                type: "media",
                sid: null,
                body: n.payload.body || null,
                dateCreated: new Date(),
                timestamp: new Date(),
                conversation: n.payload.conversation,
                channel: n.payload.channel
              }
            };
          return r(r({}, e), {
            pendingMessages: a(a([], e.pendingMessages, !0), [T], !1)
          });
        case t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE:
          var A = n.payload.media;
          return r(r({}, e), {
            pendingMessages: e.pendingMessages.filter(function (e) {
              var t, n, r;
              return (null === (t = e.source.media) || void 0 === t ? void 0 : t.sid) !== A.sid && (null === (n = e.source.media) || void 0 === n ? void 0 : n.filename) !== A.filename && (null === (r = e.source.media) || void 0 === r ? void 0 : r.contentType) !== A.contentType;
            })
          });
        case t.ACTION_MEDIA_MESSAGE_REJECTED:
          var I = n.payload.media;
          return r(r({}, e), {
            pendingMessages: e.pendingMessages.map(function (e) {
              var t;
              return (null === (t = e.source.media) || void 0 === t ? void 0 : t.sid) === I.sid ? r(r({}, e), {
                isSending: !1,
                error: !0
              }) : e;
            })
          });
        case t.ACTION_ADDED_MESSAGE:
          if (!(V = n.meta.chatState) || !V.session.client) return e;
          var k = n.payload;
          if (e.messages.find(function (e) {
            return e.index === k.index;
          })) return e;
          var N = V.session.client.user.identity,
            B = j({
              message: k,
              identity: N,
              conversationState: e
            }),
            D = a(a([], e.messages, !0), [B], !1);
          for (O = Math.max(D.length - 2, 0); O < D.length; O++) D[O] = j({
            message: D[O].source,
            identity: N,
            conversationState: e,
            nextMessage: O < D.length - 1 ? D[O + 1].source : void 0,
            previousMessage: O > 0 ? D[O - 1].source : void 0,
            bodyAttachment: null === (u = D[O]) || void 0 === u ? void 0 : u.bodyAttachment
          });
          P = void 0;
          P = B.isFromMe ? e.unreadMessages : a(a([], e.unreadMessages, !0), [B], !1);
          var L = [];
          return e.pendingMessages.length && (L = e.pendingMessages.map(function (t, n) {
            var o = 0 === n ? B : e.pendingMessages[n - 1];
            return r(r({}, t), {
              groupWithPrevious: t.source.author === o.source.author
            });
          })), r(r({}, e), {
            messages: D,
            unreadMessages: P,
            pendingMessages: L
          });
        case t.ACTION_REMOVED_MESSAGE:
          if (!(V = n.meta.chatState) || !V.session.client) return e;
          var z = n.payload,
            F = e.messages.findIndex(function (e) {
              return e.index === z.index;
            });
          (D = e.messages.slice()).splice(F, 1);
          for (O = Math.max(0, F - 1); O <= Math.min(F, D.length - 1); O++) D[O] = j({
            message: D[O].source,
            identity: V.session.client.user.identity,
            nextMessage: O < D.length - 1 ? D[O + 1].source : void 0,
            previousMessage: O > 0 ? D[O - 1].source : void 0,
            conversationState: e
          });
          return r(r({}, e), {
            messages: D
          });
        case t.ACTION_UPDATED_MESSAGE:
          if (!(V = n.meta.chatState) || !V.session.client) return e;
          var R = n.payload;
          return r(r({}, e), {
            messages: C({
              identity: V.session.client.user.identity,
              conversationState: e,
              updatedMessage: R,
              bodyAttachment: n.payload.bodyAttachment
            })
          });
        case t.ACTION_UPDATE_MESSAGE_STATE:
          if (!(V = n.meta.chatState) || !V.session.client) return e;
          var H = n.payload,
            W = (R = H.message, H.bodyAttachment);
          return r(r({}, e), {
            messages: C({
              identity: V.session.client.user.identity,
              conversationState: e,
              updatedMessage: R,
              bodyAttachment: W
            })
          });
        case t.ACTION_ADDED_PARTICIPANT:
          var U = n.payload;
          return (J = g.Utils.copyMap(e.participants)).set(U.source.identity || U.source.sid, U), r(r({}, e), {
            participants: J
          });
        case t.ACTION_REMOVED_PARTICIPANT:
          U = n.payload;
          return (J = g.Utils.copyMap(e.participants)).delete(U.source.identity || U.source.sid) ? r(r({}, e), {
            participants: J
          }) : e;
        case t.ACTION_UPDATED_PARTICIPANT:
          var V,
            G = n.payload,
            q = null !== G.lastReadMessageIndex ? G.lastReadMessageIndex : -1;
          if ((V = n.meta.chatState) && V.session.client && G.identity === V.session.client.user.identity) {
            var K = e.messages.filter(function (e) {
              return e.index > q;
            });
            P = e.unreadMessages;
            return -1 === q ? P = e.messages : K.length ? P.length !== K.length && (P = K) : P = [], r(r({}, e), {
              lastReadMessageByCurrentUserIndex: q,
              unreadMessages: P
            });
          }
          return r(r({}, e), {
            lastReadMessageIndex: q
          });
        case t.ACTION_TYPING_STARTED:
          var Y = n.payload;
          if (-1 === e.typers.findIndex(function (e) {
            return e.source.identity === Y.source.identity;
          })) {
            var $ = e.typers.slice();
            return $.push(Y), r(r({}, e), {
              typers: $
            });
          }
          return e;
        case t.ACTION_TYPING_ENDED:
          var Q = n.payload,
            Z = e.typers.filter(function (e) {
              return e.source.identity !== Q.source.identity;
            });
          return r(r({}, e), {
            typers: Z
          });
        case t.ACTION_USER_UPDATED:
          var J,
            X = n.payload;
          return X && (U = e.participants.get(X.identity)) ? ((J = g.Utils.copyMap(e.participants)).set(X.identity, w(U.source, X.friendlyName, X.isOnline)), r(r({}, e), {
            participants: J
          })) : e;
        case t.ACTION_UPDATE_CONVERSATION:
          return r(r({}, e), n.payload);
        case t.ACTION_LOAD_CONVERSATION + "_PENDING":
          return r(r({}, e), {
            isLoadingConversation: !0,
            errorWhileLoadingConversation: !1
          });
        case t.ACTION_LOAD_CONVERSATION + "_FULFILLED":
          return r(r({}, e), {
            isLoadingConversation: !1,
            errorWhileLoadingConversation: !1
          });
        case t.ACTION_LOAD_CONVERSATION + "_REJECTED":
          return r(r({}, e), {
            isLoadingConversation: !1,
            errorWhileLoadingConversation: !0
          });
        case t.ACTION_SHOW_SCROLL_DOWN_BUTTON:
          var ee = n.payload;
          return r(r({}, e), {
            showScrollDownBtn: ee
          });
        case t.ACTION_UPDATE_LAST_SCROLL_POSITION:
          var te = n.payload;
          return r(r({}, e), {
            lastScrollPosition: te
          });
        default:
          return e;
      }
    };
    var P = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function () {
          return this._dispatcher || s.ChatModule.dispatch;
        },
        set: function (e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.dispatchConversationAction = function (e, t, n, r) {
        this.dispatcher({
          type: t,
          payload: n,
          meta: {
            conversationSid: e,
            channelSid: e,
            chatState: r
          }
        });
      }, e.init = function (e) {
        return o(this, void 0, void 0, function () {
          var n, r, o, a, l, c, u, h;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                (n = s.ChatModule.state.conversations[e.sid]) && n.listener && n.listener.stop(), r = new M(e), this.dispatchConversationAction(e.sid, t.ACTION_INIT_CONVERSATION, {
                  conversation: e,
                  listener: r
                }), o = [], a = e.getParticipants().then(function (e) {
                  var t = new Map();
                  return e.forEach(function (e) {
                    e.identity && e.getUser().then(function (e) {
                      r.startListeningUser(e);
                    }).catch(function () {});
                  }), Promise.all(e.map(function (e) {
                    var n;
                    return e.identity ? e.getUser().then(function (n) {
                      n.unsubscribe(), o.push(n), t.set(e.identity, w(e, n.friendlyName, n.isOnline));
                    }) : (t.set(e.sid, w(e, (null === (n = e.bindings.email) || void 0 === n ? void 0 : n.name) || "", !1)), Promise.resolve());
                  })).then(function () {
                    return t;
                  });
                }).catch(function (t) {
                  return Promise.reject(f.ErrorManager.createAndProcessError("Failed to load conversation participants", {
                    type: d.CoreErrorType.chatSDK,
                    description: "Failed to load participants for conversation " + e.sid,
                    context: "ConversationState.init",
                    wrappedError: t
                  }));
                }), i.label = 1;
              case 1:
                return i.trys.push([1, 4,, 5]), this.dispatchConversationAction(e.sid, t.ACTION_INIT_CONVERSATION_PARTICIPANTS, a), [4, a];
              case 2:
                return l = i.sent(), this.dispatchConversationAction(e.sid, b.ACTION_CACHE_USERS, o), c = e.getMessages(this.MESSAGE_LOAD_COUNT).catch(function (t) {
                  return Promise.reject(f.ErrorManager.createAndProcessError("Failed to load conversation messages", {
                    type: d.CoreErrorType.chatSDK,
                    description: "Failed to load messages for conversation " + e.sid,
                    context: "ConversationState.init",
                    wrappedError: t
                  }));
                }), this.dispatchConversationAction(e.sid, t.ACTION_LOAD_CONVERSATION_MESSAGES, c, s.ChatModule.state), [4, c];
              case 3:
                return u = i.sent(), this.loadUserForMissingMembers(u, l), [3, 5];
              case 4:
                return h = i.sent(), p.log.debug("Failed to update conversation state", h), [3, 5];
              case 5:
                return [2];
            }
          });
        });
      }, e.unload = function (e) {
        p.log.debug("ConversationState | Unloading conversation: " + e), this.dispatchConversationAction(e, t.ACTION_UNLOAD_CONVERSATION);
      }, e.loadMessagesFromHistory = function (e) {
        var n = this;
        if (!e.source || !e.currentPaginator) return !1;
        if (!e.currentPaginator.hasPrevPage || e.isLoadingMessages) return !1;
        var r = e.currentPaginator.prevPage();
        return this.dispatchConversationAction(e.source.sid, t.ACTION_LOAD_CONVERSATION_MESSAGES, r, s.ChatModule.state), r.then(function (t) {
          return n.loadUserForMissingMembers(t, e.participants);
        }).catch(function (t) {
          var n;
          return Promise.reject(f.ErrorManager.createAndProcessError("Failed to load conversation messages", {
            type: d.CoreErrorType.chatSDK,
            description: "Failed to load previous messages for conversation " + (null === (n = e.source) || void 0 === n ? void 0 : n.sid),
            context: "ConversationState.loadMessagesFromHistory",
            wrappedError: t
          }));
        });
      }, e.loadUserForMissingMembers = function (e, t) {
        e.items.forEach(function (e) {
          t.has(e.author) || b.Actions.fetchUser(e.author);
        });
      }, e.updateLastReadMessageIndex = function (e, t) {
        e.source && c.ConversationHelper.isUserParticipantOfConversation(e) && e.source.updateLastReadMessageIndex(t);
      }, e.removeAllListeners = function () {
        p.log.debug("Conversation state removeAllListeners"), Object.keys(s.ChatModule.state.conversations).forEach(function (e) {
          var t = s.ChatModule.state.conversations[e];
          t.listener && t.listener.stop();
        });
      }, e.initWithConversationSid = function (e) {
        var n = this;
        if (e) {
          var r = s.ChatModule.state.conversations[e];
          r && (r.listener || r.isLoadingConversation) || (s.ChatModule.state.session.client ? (this.dispatchConversationAction(e, t.ACTION_LOAD_CONVERSATION + "_PENDING", {}), s.ChatModule.state.session.client.getConversationBySid(e).then(function (r) {
            n.dispatchConversationAction(e, t.ACTION_LOAD_CONVERSATION + "_FULFILLED", {}), n.init(r);
          }).catch(function (r) {
            n.dispatchConversationAction(e, t.ACTION_LOAD_CONVERSATION + "_REJECTED", {}), p.log.debug(r, "Cannot retrieve conversation", e);
          })) : p.log.debug("ChatModule: No conversation client found on the state when initialising ConversationState"));
        } else p.log.warn("ConversationSid is invalid ", e);
      }, e.addPendingMessage = function (e, n, r, o) {
        var i = this.getMediaFromFile(e);
        this.dispatchConversationAction(n.sid, t.ACTION_ADD_PENDING_MEDIA_MESSAGE, {
          media: i,
          conversation: n,
          channel: r,
          body: o
        }, s.ChatModule.state);
      }, e.removePendingMessage = function (e, n) {
        var r = this.getMediaFromFile(e);
        this.dispatchConversationAction(n.sid, t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE, {
          media: r
        });
      }, e.rejectMediaMessage = function (e, n) {
        var r = this.getMediaFromFile(e);
        this.dispatchConversationAction(n.sid, t.ACTION_MEDIA_MESSAGE_REJECTED, {
          media: r
        });
      }, e.getMediaFromFile = function (e) {
        return {
          sid: e.name,
          filename: e.name,
          contentType: e.type,
          size: e.size
        };
      }, e.addMessageBody = function (e, n) {
        this.dispatchConversationAction(e.conversation.sid, t.ACTION_UPDATE_MESSAGE_STATE, {
          message: e,
          bodyAttachment: n
        }, s.ChatModule.state);
      }, e.showScrollDownBtn = function (e, n) {
        return !!e.source && (this.dispatchConversationAction(e.source.sid, t.ACTION_SHOW_SCROLL_DOWN_BUTTON, n), !0);
      }, e.storeLastScrollPosition = function (e, n) {
        return !!e && (this.dispatchConversationAction(e, t.ACTION_UPDATE_LAST_SCROLL_POSITION, n), !0);
      }, e.MESSAGE_LOAD_COUNT = 20, e;
    }();
    t.Actions = P;
    var M = function () {
      function e(e) {
        var n = this;
        this._listening = !1, this.handleMessageAdded = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_ADDED_MESSAGE, e, s.ChatModule.state), n.showNewMessageNotification(e);
          var r = s.ChatModule.state.session.client,
            o = r && r.user.identity === e.author;
          e.media && !o && m.TelemetryBridge.emit(m.TelemetryBridgeMessageType.MEDIA_MESSAGE_RECEIVED, e);
        }, this.handleMessageUpdated = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_UPDATED_MESSAGE, e.message, s.ChatModule.state);
        }, this.handleMessageRemoved = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_REMOVED_MESSAGE, e, s.ChatModule.state);
        }, this.handleParticipantJoined = function (e) {
          return o(n, void 0, void 0, function () {
            var n, r, o, a;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return b.Actions.fetchUser(e.identity), e.identity ? [4, e.getUser()] : [3, 2];
                case 1:
                  return r = i.sent(), n = w(e, r.friendlyName, r.isOnline), this.startListeningUser(r), [3, 3];
                case 2:
                  n = w(e, (null === (a = null === (o = e.bindings) || void 0 === o ? void 0 : o.email) || void 0 === a ? void 0 : a.name) || "", !1), i.label = 3;
                case 3:
                  return this.dispatchMessageOrMemberAction(t.ACTION_ADDED_PARTICIPANT, n), [2];
              }
            });
          });
        }, this.handleParticipantLeft = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_REMOVED_PARTICIPANT, w(e, "", !1)), e.identity && e.getUser().then(function (e) {
            n.stopListeningUser(e);
          });
        }, this.handleParticipantUpdated = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_UPDATED_PARTICIPANT, e.participant, s.ChatModule.state);
        }, this.handleTypingStarted = function (e) {
          e.getUser().then(function (r) {
            n.dispatchMessageOrMemberAction(t.ACTION_TYPING_STARTED, w(e, r.friendlyName, r.isOnline));
          });
        }, this.handleTypingEnded = function (e) {
          e.getUser().then(function (r) {
            n.dispatchMessageOrMemberAction(t.ACTION_TYPING_ENDED, w(e, r.friendlyName, r.isOnline));
          });
        }, this.handleUserUpdated = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_USER_UPDATED, e.user);
        }, this.handleConversationUpdated = function (e) {
          P.dispatchConversationAction(e.conversation.sid, t.ACTION_UPDATE_CONVERSATION, {});
        }, this._users = new Map(), this._conversation = e, this.start();
      }
      return e.prototype.start = function () {
        this._listening || (this._conversation.addListener("messageAdded", this.handleMessageAdded), this._conversation.addListener("messageRemoved", this.handleMessageRemoved), this._conversation.addListener("messageUpdated", this.handleMessageUpdated), this._conversation.addListener("participantJoined", this.handleParticipantJoined), this._conversation.addListener("participantLeft", this.handleParticipantLeft), this._conversation.addListener("typingStarted", this.handleTypingStarted), this._conversation.addListener("typingEnded", this.handleTypingEnded), this._conversation.addListener("participantUpdated", this.handleParticipantUpdated), this._conversation.on("updated", this.handleConversationUpdated), this._listening = !0);
      }, e.prototype.stop = function () {
        var e = this;
        this._listening && (this._conversation.removeListener("messageAdded", this.handleMessageAdded), this._conversation.removeListener("messageRemoved", this.handleMessageRemoved), this._conversation.removeListener("messageUpdated", this.handleMessageUpdated), this._conversation.removeListener("participantJoined", this.handleParticipantJoined), this._conversation.removeListener("participantLeft", this.handleParticipantLeft), this._conversation.removeListener("typingStarted", this.handleTypingStarted), this._conversation.removeListener("typingEnded", this.handleTypingEnded), this._conversation.removeListener("participantUpdated", this.handleParticipantUpdated), this._conversation.removeListener("updated", this.handleConversationUpdated), this._users.forEach(function (t) {
          e.stopListeningUser(t.user);
        }), this._listening = !1);
      }, e.prototype.startListeningUser = function (e) {
        var t = this;
        if (!this._users.has(e.identity)) {
          var n = new O();
          n.user = e, n.callback = function (e) {
            t.handleUserUpdated(e);
          }, e.addListener("updated", n.callback), this._users.set(e.identity, n);
        }
      }, e.prototype.stopListeningUser = function (e) {
        if (this._users.has(e.identity)) {
          var t = this._users.get(e.identity);
          t && t.user.removeListener("updated", t.callback);
        }
      }, e.prototype.dispatchMessageOrMemberAction = function (e, t, n) {
        P.dispatchConversationAction(this._conversation.sid, e, t, n);
      }, e.prototype.showNewMessageNotification = function (e) {
        return o(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return s.ChatModule.state.session.client ? (t = s.ChatModule.state.session.client.user.identity, [4, e.conversation.getParticipants().catch(function (t) {
                  return Promise.reject(f.ErrorManager.createAndProcessError("Failed to load conversation participants", {
                    type: d.CoreErrorType.chatSDK,
                    description: "Failed to load participants for conversation " + e.conversation.sid,
                    context: "ConversationState.showNewMessageNotification",
                    wrappedError: t
                  }));
                })]) : [2];
              case 1:
                return n = i.sent(), e.author !== t && n.find(function (e) {
                  return e.identity === t;
                }) ? (r = e.conversation.sid, (o = s.ChatModule.state.conversations[r]) ? (a = new c.ConversationHelper(o), v.Notifications.showNotification(h.NewChatMessage, {
                  lastMessage: a.lastMessage,
                  conversationSid: r
                }), [2]) : [2]) : [2];
            }
          });
        });
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e;
    }();
    function j(e) {
      var t = e.message,
        n = e.identity,
        r = e.nextMessage,
        o = e.previousMessage,
        i = e.conversationState,
        a = e.bodyAttachment,
        s = t.author,
        c = !!r && t.author === r.author,
        d = !!o && t.author === o.author,
        f = u.Pending,
        p = !1;
      t.aggregatedDeliveryReceipt && ("all" === t.aggregatedDeliveryReceipt.failed ? (f = u.Failed, p = !0) : "all" === t.aggregatedDeliveryReceipt.undelivered ? (f = u.Undelivered, p = !0) : (f = u.Sent, p = !1)), t.channel = (0, y.ConversationToChannel)(t.conversation), t.timestamp = t.dateCreated;
      var h = (0, l.getChatReducerOptions)().hasSupportForChannels ? (0, y.ConvoMessageToChatMessage)(t) : t;
      if (i) {
        var v = i && i.participants && i.participants.get(t.author);
        s = v && v.friendlyName;
      }
      var m = t.author === n;
      return {
        groupWithNext: c,
        groupWithPrevious: d,
        isFromMe: m,
        index: t.index,
        source: h,
        authorName: s,
        bodyAttachment: a,
        deliveryStatus: f,
        error: m && p
      };
    }
    function w(e, t, n) {
      return {
        friendlyName: t,
        source: e,
        online: n
      };
    }
    t.ConversationListener = M;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorManager = void 0;
    var r = n(27),
      o = n(3),
      i = function () {
        function e() {}
        return e.prototype.processError = function (e) {
          return this.errorProcessingOverride ? this.errorProcessingOverride(e) : ((0, r.isCoreError)(e) ? o.log.error(e.logLine) : o.log.error(e.message), e);
        }, e.prototype.createAndProcessError = function (e, t) {
          void 0 === t && (t = {});
          var n = new r.CoreError(e, t);
          return this.processError(n);
        }, e;
      }();
    t.ErrorManager = new i();
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Notifications = t.NotificationManager = t.NotificationType = t.NotificationEvent = t.DefaultNotificationHandlerType = t.NotificationIds = void 0;
    var c = n(38),
      u = n(12),
      d = n(16),
      f = n(3),
      p = l(n(54));
    t.NotificationIds = p;
    var h,
      v = n(9);
    !function (e) {
      e.Browser = "browser", e.InApp = "inapp", e.ScreenReader = "screenreader";
    }(t.DefaultNotificationHandlerType || (t.DefaultNotificationHandlerType = {})), function (e) {
      e.notificationAdded = "notificationAdded", e.notificationDismissed = "notificationDismissed", e.beforeAddNotification = "beforeAddNotification", e.notificationStatusChanged = "notificationStatusChanged";
    }(h = t.NotificationEvent || (t.NotificationEvent = {})), function (e) {
      e.information = "information", e.success = "success", e.warning = "warning", e.error = "error";
    }(t.NotificationType || (t.NotificationType = {}));
    var m = function (e) {
      function t() {
        var t = e.call(this) || this;
        return t.registeredNotifications = new Map(), t.activeNotifications = [], t.handlers = {}, t.setMaxListeners(100), t;
      }
      return o(t, e), t.prototype.registerNotification = function (e) {
        if (e = i({}, e), this.registeredNotifications.get(e.id)) throw u.ErrorManager.createAndProcessError(d.ErrorMessages.NOTIFICATION_ALREADY_REGISTERED, {
          context: "NotificationManager"
        });
        void 0 === e.timeout && (e.timeout = t.defaultTimeout), void 0 === e.closeButton && (e.closeButton = !0), this.registeredNotifications.set(e.id, e);
      }, t.prototype.showNotificationSingle = function (e) {
        this.activeNotifications.filter(function (t) {
          return t.id === e;
        }).length || this.showNotification(e);
      }, t.prototype.showNotification = function (e, t, n) {
        var r = this;
        if ("string" != typeof e) return f.log.error("Attempting to call showNotification with the id which is not a string"), null;
        var o = this.registeredNotifications.get(e);
        if (!o) return f.log.warn("Attempting to show a notification that has been deleted or hasn't been registered"), null;
        var i = v.Utils.merge({}, o);
        if (i.context = t, i.instanceId = e + Date.now().toString(), n) {
          var a = [];
          null == n || n.forEach(function (e) {
            var t;
            a.push({
              content: null === (t = r.registeredNotifications.get(e.id)) || void 0 === t ? void 0 : t.content,
              context: e.context
            });
          }), i.dropdownContent = a;
        }
        var s = this.listeners("beforeAddNotification");
        if (s.length > 0) {
          var l = !1,
            c = function () {
              l = !0;
            };
          if (f.log.debug('Executing "beforeAddNotification" listeners with', i), s.forEach(function (e) {
            try {
              e(i, c);
            } catch (e) {
              f.log.error("Error from beforeAddNotification:", e);
            }
          }), l) return f.log.info("Notification " + e + " cancelled by beforeAddNotification event"), null;
          f.log.debug('Completed "beforeAddNotification" listeners with', i);
        }
        return this.activeNotifications.push(i), f.log.debug('Emitting "notificationAdded" event for', i), this.emit(h.notificationAdded, i), i;
      }, t.prototype.dismissNotification = function (e) {
        var t = this.activeNotifications.indexOf(e);
        t > -1 && (this.activeNotifications.splice(t, 1), this.emit(h.notificationDismissed, e));
      }, t.prototype.dismissNotificationById = function (e) {
        var t = this;
        this.activeNotifications.filter(function (t) {
          return t.id === e;
        }).forEach(function (e) {
          t.dismissNotification(e);
        });
      }, t.prototype.dismissAll = function () {
        var e = this;
        this.activeNotifications.slice().forEach(function (t) {
          e.dismissNotification(t);
        });
      }, t.prototype.registerHandler = function (e) {
        var t = e.id;
        f.log.debug("registering notification handler " + t), this.handlers[t] && f.log.info("replacing notification handler " + t), this.handlers[t] = e;
      }, t.prototype.toggleNotificationHandler = function (e, t) {
        this.handlers[e] ? this.handlers[e].enabled = t : f.log.warn("handler with id " + e + " doesn't exist");
      }, t.prototype.isNotificationHandlerEnabled = function (e) {
        return this.handlers[e] && this.handlers[e].enabled;
      }, t.prototype.isNotificationActive = function (e) {
        return this.activeNotifications.some(function (t) {
          return t.id === e;
        });
      }, t.defaultTimeout = 8e3, t;
    }(c.EventEmitter);
    t.NotificationManager = m, t.Notifications = new m();
  }, function (e, t) {
    e.exports = require("@emotion/styled");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconButtonProps = t.IconButton = void 0;
    var r = n(415);
    Object.defineProperty(t, "IconButton", {
      enumerable: !0,
      get: function () {
        return r.IconButton;
      }
    }), Object.defineProperty(t, "IconButtonProps", {
      enumerable: !0,
      get: function () {
        return r.IconButtonProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessages = void 0, function (e) {
      e.DYNAMIC_COMPONENT_NAME_MISSING = "name is missing", e.DYNAMIC_COMPONENT_GENERIC_MESSAGE = "An error has been detected inside DynamicComponent", e.DYNAMIC_COMPONENT_ELEMENTS_WITHOUT_KEY = "Elements without key in DynamicComponent", e.DYNAMIC_COMPONENT_MUTUALLY_EXCLUSIVE = "Mutually exclusive properties are set", e.DYNAMIC_CONTENT_STORE_CHILD_INVALID = "Child provided is not a valid React element", e.DYNAMIC_CONTENT_STORE_NO_KEY = "No key prop provided", e.ACTION_PENDING = "Action is pending", e.ACTION_DOESNT_EXIST = "Action does not exist", e.ACTION_BLOCKED = "Action is blocked", e.ACTION_ON_BEFORE = "Error on before event", e.ACTION_NOT_INVOKED = "Action with payload was not invoked", e.NOTIFICATION_ALREADY_REGISTERED = "Notification already registered", e.NOTIFICATION_INVALID_FILTER = "Invalid filter provided", e.NO_CHAT_CLIENT = "No chat client", e.CHAT_CHANNEL_LOAD_FAILED = "Failed to load chat channel", e.FILE_ATTACHMENT_READ_ONLY = "File attachment is read only", e.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_TYPE = "Failed to send message. Invalid file type", e.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_SIZE = "Failed to send message. Invalid file size", e.FILE_ATTACHMENT_DOWNLOAD_INVALID_TYPE = "Failed to download. Invalid file type", e.FILE_ATTACHMENT_DOWNLOAD_INVALID_SIZE = "Failed to download. Invalid file size", e.FILE_ATTACHMENT_ATTACH_INVALID_TYPE = "Failed to attach. Invalid file type", e.FILE_ATTACHMENT_ATTACH_INVALID_SIZE = "Failed to attach. Invalid file size", e.FILE_ATTACHMENT_ATTACH_INVALID_OVERALL_SIZE = "Failed to attach. Invalid the maximum overall size of attachments is above the maximum allowed.", e.FILE_ATTACHMENT_ATTACH_TOO_MANY = "Failed to attach. Maximum amount of attachments reached", e.FILE_ATTACHMENT_ATTACH_DUPLICATE = "Failed to attach. File already attached.", e.FILE_ATTACHMENT_MULTIPLE_DISABLED = "Multiple files cannot be attached simultaneously.", e.FILE_ATTACHMENT_GENERIC_ERROR = "Unable to send media", e.FILE_ATTACHMENT_DISABLED = "File attachment is disabled", e.FILE_ATTACHMENT_NOT_A_PARTICIPANT = "Failed to download. You are not a chat participant.", e.FILE_ATTACHMENT_UNABLE_TO_DOWNLOAD = "Unabled to download media", e.AUDIO_PLAYER_MEDIA_URL_MISSING = "A mediaUrl must be provided", e.MEDIA_QUEUE_SIZE = "Media cannot be enqueued: size limit reached", e.MEDIA_ALREADY_ENQUEUED = "Media cannot be enqueued: it has enqueued already", e.SEND_TYPING_FAILED = "Failed to send typing indicator", e.SET_INPUT_TEXT_FAILED = "Failed to set input text", e.FAILED_TO_SEND_MESSAGE_TO_CHANNEL = "Failed to send message to channel", e.EMAIL_DRAFT_UNABLE_TO_RETRIEVE = "The content of the email couldn't be retrieved. Refresh to try again.", e.EMAIL_DRAFT_UNABLE_TO_SAVE = "The content of the email couldn't be saved", e.FAILED_TO_FETCH_GOOGLE_CCAI_TRANSCRIPT = "Failed to load virtual agent transcript", e.FAILED_TO_REFETCH_GOOGLE_CCAI_TRANSCRIPT = "Failed to load transcript. Confirm reason for call with customer.";
    }(t.ErrorMessages || (t.ErrorMessages = {}));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ButtonThemeProps = t.LinkProps = t.Link = t.ButtonProps = t.Button = void 0;
    var r = n(100);
    Object.defineProperty(t, "Button", {
      enumerable: !0,
      get: function () {
        return r.Button;
      }
    }), Object.defineProperty(t, "ButtonProps", {
      enumerable: !0,
      get: function () {
        return r.ButtonProps;
      }
    });
    var o = n(401);
    Object.defineProperty(t, "Link", {
      enumerable: !0,
      get: function () {
        return o.Link;
      }
    }), Object.defineProperty(t, "LinkProps", {
      enumerable: !0,
      get: function () {
        return o.LinkProps;
      }
    });
    var i = n(402);
    Object.defineProperty(t, "ButtonThemeProps", {
      enumerable: !0,
      get: function () {
        return i.ButtonThemeProps;
      }
    });
  }, function (e, t) {
    e.exports = require("@udecode/plate-core");
  }, function (e, t) {
    e.exports = require("@udecode/plate-common");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getDerivedFileLimits = t.getSupportedFileExtensionRegex = t.getFileIcon = t.canAttachFile = t.isFileAttachmentReadOnly = t.isFileAttachmentEnabled = t.isValidFileType = t.getAllowedFileExtensions = t.ALLOWED_FILE_EXTENSIONS = t.MAX_FILE_COUNT = t.MAX_FILE_SIZE = t.FILE_TYPES = void 0;
    var r = n(28),
      o = n(8),
      i = n(11);
    t.FILE_TYPES = {
      jpg: {
        extension: /(\.jpg)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      jpeg: {
        extension: /(\.jpeg)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      png: {
        extension: /(\.png)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      heic: {
        extension: /(\.heic)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      gif: {
        extension: /(\.gif)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      amr: {
        extension: /(\.amr)$/i,
        type: /^(audio)/i,
        iconName: "FileAudio"
      },
      mp3: {
        extension: /(\.mp3)$/i,
        type: /^(audio)/i,
        iconName: "FileAudio"
      },
      mp4: {
        extension: /(\.mp4)$/i,
        type: /^(video)/i,
        iconName: "Video"
      },
      pdf: {
        extension: /(\.pdf)$/i,
        type: /^(application\/pdf)$/,
        iconName: "Pdf"
      },
      txt: {
        extension: /(\.txt)$/i,
        type: /^(document)/i,
        iconName: "GenericDoc"
      }
    }, t.MAX_FILE_SIZE = 10485760, t.MAX_FILE_COUNT = 1, t.ALLOWED_FILE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "txt", "pdf"];
    t.getAllowedFileExtensions = function (e) {
      var n = r.ChatManager.getFileAttachmentConfigFromConversationSid(e);
      return (null == n ? void 0 : n.acceptedExtensions) && Array.isArray(n.acceptedExtensions) ? n.acceptedExtensions : t.ALLOWED_FILE_EXTENSIONS;
    };
    t.isValidFileType = function (e, n) {
      if (!e) return !1;
      var r = (0, t.getAllowedFileExtensions)(n),
        o = Object.values(t.FILE_TYPES).find(function (t) {
          return e.name && e.name.match(t.extension) && e.type && e.type.match(t.type);
        });
      if (o) return Boolean(r.find(function (e) {
        return ("." + e).match(o.extension);
      }));
      var i = (/^(.+)\.(.+)?/.exec(e.name) || [])[2];
      return r.indexOf(i) > -1;
    };
    t.isFileAttachmentEnabled = function (e) {
      var t = o.ChatModule.state.conversations[e],
        n = new i.ConversationHelper(t).conversationType,
        a = r.ChatManager.isCBM(e);
      if (!t || !a && "web" !== n) return !1;
      var s = r.ChatManager.getFileAttachmentConfigFromConversationSid(e);
      return void 0 === (null == s ? void 0 : s.enabled) || s.enabled;
    };
    t.isFileAttachmentReadOnly = function (e) {
      var t = r.ChatManager.getFileAttachmentConfigFromConversationSid(e);
      return void 0 !== (null == t ? void 0 : t.readOnly) && t.readOnly;
    };
    t.canAttachFile = function (e, n, r) {
      var o;
      if ("email" === r) return !0;
      var i = null === (o = n.source) || void 0 === o ? void 0 : o.sid,
        a = (0, t.getDerivedFileLimits)(n).fileCountLimit;
      return (e.attachedFiles || []).length < a && ("web" !== r || !!n.messages.length) && !(0, t.isFileAttachmentReadOnly)(i);
    };
    t.getFileIcon = function (e) {
      var n = Object.values(t.FILE_TYPES).find(function (t) {
        return e.name && e.name.match(t.extension) && e.type && e.type.match(t.type);
      });
      return n ? n.iconName : "GenericDoc";
    };
    t.getSupportedFileExtensionRegex = function (e) {
      var n = e || "",
        r = Object.values(t.FILE_TYPES).find(function (e) {
          return n.match(e.extension);
        });
      return r ? r.extension : void 0;
    };
    t.getDerivedFileLimits = function (e) {
      var n,
        o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p,
        h,
        v,
        m = t.MAX_FILE_SIZE,
        g = t.MAX_FILE_SIZE,
        b = t.MAX_FILE_COUNT,
        y = (null === (o = null === (n = e.source) || void 0 === n ? void 0 : n.limits) || void 0 === o ? void 0 : o.mediaAttachmentSizeLimitInMb) ? 1024 * (null === (a = null === (i = e.source) || void 0 === i ? void 0 : i.limits) || void 0 === a ? void 0 : a.mediaAttachmentSizeLimitInMb) * 1024 : void 0,
        _ = (null === (l = null === (s = e.source) || void 0 === s ? void 0 : s.limits) || void 0 === l ? void 0 : l.mediaAttachmentsTotalSizeLimitInMb) ? 1024 * (null === (u = null === (c = e.source) || void 0 === c ? void 0 : c.limits) || void 0 === u ? void 0 : u.mediaAttachmentsTotalSizeLimitInMb) * 1024 : void 0,
        O = null === (f = null === (d = e.source) || void 0 === d ? void 0 : d.limits) || void 0 === f ? void 0 : f.mediaAttachmentsCountLimit;
      if (null == e ? void 0 : e.source) {
        var C = r.ChatManager.getFileAttachmentConfigFromConversationSid(e.source.sid);
        p = void 0 !== C.numberOfAttachments ? C.numberOfAttachments : t.MAX_FILE_COUNT, h = void 0 !== C.maxFileSize ? C.maxFileSize : t.MAX_FILE_SIZE, v = void 0 !== C.maxTotalFileSize ? C.maxTotalFileSize : t.MAX_FILE_SIZE;
      }
      return y && h ? m = Math.min(y, h) : y && (m = y), _ && v ? g = Math.min(_, v) : _ && (g = _), O && p ? b = Math.min(O, p) : O && (b = O), {
        fileSizeLimit: m,
        totalFileSizeLimit: g,
        fileCountLimit: b
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvasContext = void 0;
    var a = i(n(0));
    t.MessagingCanvasContext = a.createContext(void 0);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FieldErrorMessage = t.FieldContainer = t.Description = t.Label = t.Form = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(1);
    t.Form = (0, c.styled)("form")(o || (o = r(["\n    display: flex;\n    flex-flow: column;\n    font-size: 14px;\n    background: #fff;\n    width: 100%;\n    box-sizing: border-box;\n    flex-grow: 1;\n    flex-shrink: 0;\n"], ["\n    display: flex;\n    flex-flow: column;\n    font-size: 14px;\n    background: #fff;\n    width: 100%;\n    box-sizing: border-box;\n    flex-grow: 1;\n    flex-shrink: 0;\n"]))), t.Label = (0, c.styled)("label")(i || (i = r(["\n    display: inline-block;\n    margin-bottom: 10px;\n    font-size: 12px;\n"], ["\n    display: inline-block;\n    margin-bottom: 10px;\n    font-size: 12px;\n"]))), t.Description = (0, c.styled)("div")(a || (a = r(["\n    font-size: 14px;\n"], ["\n    font-size: 14px;\n"]))), t.FieldContainer = (0, c.styled)("div")(s || (s = r(["\n    display: block;\n    clear: both;\n    margin-top: 20px;\n    width: 100%;\n"], ["\n    display: block;\n    clear: both;\n    margin-top: 20px;\n    width: 100%;\n"]))), t.FieldErrorMessage = (0, c.styled)("div")(l || (l = r(["\n    color: ", ";\n    font-size: 12px;\n    margin-top: 4px;\n"], ["\n    color: ", ";\n    font-size: 12px;\n    margin-top: 4px;\n"])), function (e) {
      return e.theme.tokens.textColors.colorTextError;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.ActionsImpl = void 0;
    var i = n(38),
      a = n(27),
      s = n(12),
      l = n(16),
      c = n(3),
      u = function () {
        function e() {
          this.actions = new Map(), this.replacedActions = new Map(), this.payloadUpdateFunctions = new Map(), this.pendingInvocations = new Map(), this.blockedActions = new Map(), this.emitter = new i.EventEmitter(), this.emitter.setMaxListeners(0);
        }
        return e.prototype.registerAction = function (e, t, n) {
          c.log.info("registerAction", e), this.actions.set(e, t), this.payloadUpdateFunctions.set(e, n);
        }, e.prototype.invokeAction = function (e, t) {
          return r(this, void 0, Promise, function () {
            var n, r, i, u, d, f, p, h, v, m, g;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if (c.log.debug('Action "' + e + '" invoked with', t), !(n = this.actions.get(e))) throw s.ErrorManager.createAndProcessError(l.ErrorMessages.ACTION_DOESNT_EXIST, {
                    description: "Action " + e + " does not exist!",
                    context: "Actions"
                  });
                  if (this.findPendingActions(e, t).first) throw s.ErrorManager.createAndProcessError(l.ErrorMessages.ACTION_PENDING, {
                    description: "Action " + e + " is pending",
                    context: "Actions"
                  });
                  if (this.findBlockedActions(e, t).first) throw s.ErrorManager.createAndProcessError(l.ErrorMessages.ACTION_BLOCKED, {
                    description: "Action " + e + " has been blocked",
                    context: "Actions"
                  });
                  if ((r = this.payloadUpdateFunctions.get(e)) && (t = r(t), c.log.debug("Action: updated payload for " + e, t)), i = !1, u = function () {
                    i = !0;
                  }, this.registerInvocation(e, t), d = "before" + e, !this.emitter.listeners(d).length) return [3, 4];
                  c.log.debug('Executing "' + d + '" listeners with', t), o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), [4, this.customEmit(d, t, u)];
                case 2:
                  return o.sent(), [3, 4];
                case 3:
                  return f = o.sent(), s.ErrorManager.createAndProcessError(l.ErrorMessages.ACTION_ON_BEFORE, {
                    description: 'Error on "' + d + '":',
                    context: "Actions",
                    wrappedError: f
                  }), [3, 4];
                case 4:
                  if (i) throw this.unregisterInvocation(e, t), c.log.info("Action " + e + " cancelled by before event"), new Error("Action " + e + " cancelled by before event");
                  p = this.replacedActions.get(e), h = null, o.label = 5;
                case 5:
                  return o.trys.push([5, 10,, 11]), p ? [4, this.invokeReplacedActions(e, p, t, n)] : [3, 7];
                case 6:
                  return h = o.sent(), [3, 9];
                case 7:
                  return c.log.debug('Executing action function "' + e + '" with', t), [4, n(t)];
                case 8:
                  h = o.sent(), o.label = 9;
                case 9:
                  return [3, 11];
                case 10:
                  if (v = o.sent(), this.unregisterInvocation(e, t), (0, a.isCoreError)(v)) throw v;
                  throw m = "string" == typeof v ? v : v.message, s.ErrorManager.createAndProcessError(m, {
                    description: "Error in action " + e + " body: " + m,
                    context: "Actions",
                    wrappedError: v
                  });
                case 11:
                  c.log.debug('Executing "after' + e + '" listeners with', t), o.label = 12;
                case 12:
                  return o.trys.push([12, 14,, 15]), [4, this.customEmit("after" + e, t)];
                case 13:
                  return o.sent(), [3, 15];
                case 14:
                  return g = o.sent(), c.log.error("Error on after" + e + ":", g), [3, 15];
                case 15:
                  return this.unregisterInvocation(e, t), [2, h];
              }
            });
          });
        }, e.prototype.invokeReplacedActions = function (e, t, n, i) {
          return r(this, void 0, Promise, function () {
            var r;
            return o(this, function (o) {
              return r = function (e, n) {
                if (e >= 0) {
                  return t[e](n, i, function (t) {
                    return r(e - 1, t);
                  });
                }
                return i(n);
              }, c.log.debug("Running replaced actions (count: " + t.length + ") for " + e + " with", n), [2, r(t.length - 1, n)];
            });
          });
        }, e.prototype.catchErrorIfIsPromise = function (e, t) {
          return t && t.catch ? t.catch(function (t) {
            c.log.error("Error on " + e + ":", t);
          }) : t;
        }, e.prototype.customEmit = function (e) {
          for (var t = this, n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
          var o = this.emitter.listeners(e);
          return Promise.all(o.map(function (r) {
            return t.catchErrorIfIsPromise(e, r.apply(void 0, n));
          }));
        }, e.prototype.replaceAction = function (e, t) {
          c.log.debug("Actions: Replacing action", e, "with", t);
          var n = this.replacedActions.get(e);
          n ? n.push(t) : this.replacedActions.set(e, [t]);
        }, e.prototype.addListener = function (e, t) {
          return c.log.debug('Adding Actions listener for event "' + String(e) + '"', t), this.emitter.addListener(e, t);
        }, e.prototype.on = function (e, t) {
          return c.log.warn("Please use `addListener` instead"), this.addListener(e, t);
        }, e.prototype.removeListener = function (e, t) {
          return c.log.debug("Removing Actions listener ", t, ' for event "' + String(e) + '" '), this.emitter.removeListener(e, t);
        }, e.prototype.registerInvocation = function (e, t) {
          c.log.debug("registerInvocation", e, t);
          var n = this.pendingInvocations.get(e) || [];
          this.pendingInvocations.has(e) || this.pendingInvocations.set(e, n), n.push({
            action: e,
            payload: t
          }), this.customEmit("invocationBegin");
        }, e.prototype.unregisterInvocation = function (e, t) {
          c.log.debug("unregisterInvocation", e, t);
          var n = this.pendingInvocations.get(e) || [],
            r = n.findIndex(function (n) {
              return n.action === e && n.payload === t;
            });
          if (r < 0) throw s.ErrorManager.createAndProcessError(l.ErrorMessages.ACTION_NOT_INVOKED, {
            context: "Actions"
          });
          n.splice(r, 1), this.customEmit("invocationEnd");
        }, e.prototype.findPendingActions = function (e, t) {
          var n = this,
            r = (Array.isArray(e) ? e : [e]).map(function (e) {
              return (n.pendingInvocations.get(e) || []).find(function (n) {
                return d(t, e)(n.payload);
              });
            }),
            o = {};
          return r.forEach(function (e) {
            void 0 !== e && (o[e.action] = e.payload, o.first || (o.first = e));
          }), o;
        }, e.prototype.findBlockedActions = function (e, t) {
          var n = this,
            r = (Array.isArray(e) ? e : [e]).map(function (e) {
              return (n.blockedActions.get(e) || []).find(function (n) {
                return d(t, e)(n.payload);
              });
            }),
            o = {};
          return r.forEach(function (e) {
            void 0 !== e && (o[e.action] = e.payload, o.first || (o.first = e));
          }), o;
        }, e.prototype.blockAction = function (e, t) {
          this.setActionBlocked(!0, e, t);
        }, e.prototype.unblockAction = function (e, t) {
          this.setActionBlocked(!1, e, t);
        }, e.prototype.setActionBlocked = function (e, t, n) {
          c.log.debug("Set action " + t + " blocked=" + e, n);
          var r = this.blockedActions.get(t) || [];
          this.blockedActions.has(t) || this.blockedActions.set(t, r);
          var o = !1;
          if (e) r.push({
            action: t,
            payload: n
          }), o = !0;else {
            var i = r.filter(function (e) {
              return !d(n, t)(e.payload);
            });
            (o = i.length !== r.length) && this.blockedActions.set(t, i);
          }
          o && this.customEmit("actionBlockedChanged", e, t, n);
        }, e;
      }();
    t.ActionsImpl = u, t.Actions = new u();
    var d = function (e, t) {
      return function (n) {
        return void 0 === e || e === n || "function" == typeof e && !!e(n, t) || "object" == typeof e && "object" == typeof n && Object.keys(e).every(function (t) {
          return n[t] === e[t];
        });
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TelemetryBridge = t.TelemetryBridgeMessageType = void 0;
    var i = n(38);
    !function (e) {
      e.MEDIA_MESSAGE_SENT = "MEDIA_MESSAGE_SENT", e.MEDIA_MESSAGE_RECEIVED = "MEDIA_MESSAGE_RECEIVED", e.DYNAMIC_COMPONENT_PROGRAMMABILITY = "DYNAMIC_COMPONENT_PROGRAMMABILITY", e.UI_INTERACTION_EVENT = "UI_INTERACTION_EVENT", e.ERROR_EVENT = "ERROR_EVENT";
    }(t.TelemetryBridgeMessageType || (t.TelemetryBridgeMessageType = {}));
    var a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.emit = function (t, n) {
        return e.prototype.emit.call(this, t, n);
      }, t;
    }(i.EventEmitter);
    t.TelemetryBridge = new a();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DynamicContentStore = void 0;
    var s = a(n(0)),
      l = n(7),
      c = n(12),
      u = n(16),
      d = n(3),
      f = n(24),
      p = function () {
        function e(e) {
          var t = this;
          this._removeRequests = [], this.registeredFragments = [], this.registeredWrappers = new Array(), this.removeRegistration = function (e) {
            t.registeredFragments = t.registeredFragments.filter(function (t) {
              return t !== e;
            });
          }, this._name = e;
        }
        return Object.defineProperty(e.prototype, "name", {
          get: function () {
            return this._name;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.add = function (e, t) {
          var n = this;
          if (void 0 === t && (t = void 0), !s.isValidElement(e)) throw c.ErrorManager.createAndProcessError(u.ErrorMessages.DYNAMIC_CONTENT_STORE_CHILD_INVALID, {
            description: "Child provided to " + this.name + " is not a valid React element",
            context: "DynamicContentStore"
          });
          if (void 0 === e.key || null === e.key) throw c.ErrorManager.createAndProcessError(u.ErrorMessages.DYNAMIC_CONTENT_STORE_NO_KEY, {
            description: "No key prop provided when adding component to " + this.name,
            context: "DynamicContentStore"
          });
          var r = s.createElement(l.ContentFragment, t, e);
          return d.log.debug("Adding component ", e, 'with key "' + e.key + '" to "' + this.name + '"'), f.TelemetryBridge.emit(f.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, {
            name: this.name,
            command: "add",
            callType: "dynamic_component",
            options: t
          }), this.registeredFragments.push(r), function () {
            return n.removeRegistration(r);
          };
        }, e.prototype.remove = function (e, t) {
          var n = this;
          void 0 === t && (t = {});
          var o = {
            key: e,
            options: t
          };
          return this._removeRequests.push(o), d.log.debug('Removing component with key "' + e + '" from "' + this.name + '"'), f.TelemetryBridge.emit(f.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, {
            name: this.name,
            command: "remove",
            callType: "dynamic_component",
            options: r(r({}, t), {
              key: e
            })
          }), function () {
            n._removeRequests = n._removeRequests.filter(function (e) {
              return e !== o;
            });
          };
        }, e.prototype.replace = function (e, t) {
          return void 0 === t && (t = {}), t.replace = !0, d.log.debug('Replacing component with key "' + e.key + '" with', e, 'in "' + this.name + '"'), f.TelemetryBridge.emit(f.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, {
            name: this.name,
            command: "replace",
            callType: "dynamic_component",
            options: t
          }), this.add(e, t);
        }, e.prototype.addWrapper = function (e) {
          console.warn("Warning! `Content.addWrapper()` is an experimental api. This feature may be changed or removed at any time. we do not recommend using them in production environments."), this.registeredWrappers.push(e);
        }, e.prototype.getAllWrappers = function () {
          return this.registeredWrappers;
        }, Object.defineProperty(e.prototype, "fragments", {
          get: function () {
            return this.registeredFragments;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "removeRequests", {
          get: function () {
            return this._removeRequests;
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.DynamicContentStore = p;
  }, function (e, t) {
    e.exports = require("@material-ui/core/styles");
  }, function (e, t, n) {
    "use strict";

    var r,
      o,
      i,
      a = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isCoreError = t.CoreError = t.CoreErrorSeverity = t.CoreErrorType = void 0, function (e) {
      e.app = "app", e.chatSDK = "chatSDK";
    }(o = t.CoreErrorType || (t.CoreErrorType = {})), function (e) {
      e.user = "user", e.normal = "normal", e.severe = "severe";
    }(i = t.CoreErrorSeverity || (t.CoreErrorSeverity = {}));
    var s = function (e) {
      function t(n, r) {
        void 0 === r && (r = {});
        var a = e.call(this, n) || this;
        return a.content = r, a.content.type || (a.content.type = o.app), a.content.severity || (a.content.severity = i.normal), a.time = new Date(), Object.setPrototypeOf(a, t.prototype), a;
      }
      return a(t, e), Object.defineProperty(t.prototype, "type", {
        get: function () {
          return this.content.type;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "logLine", {
        get: function () {
          var e = this.content,
            t = e.description,
            n = e.context,
            r = e.wrappedError,
            o = t || this.message,
            i = "";
          return r && (r.message ? i = '\n\nOriginal error:\n"' + r.message + '"' : "string" == typeof r && (i = '\n\nOriginal error:\n"' + r + '"')), this.time.toLocaleString() + " - " + (n || "") + ": " + o + i;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }(Error);
    t.CoreError = s;
    t.isCoreError = function (e) {
      return e instanceof s;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatManager = void 0;
    var r,
      o,
      i = function (e) {
        return {};
      },
      a = function (e) {
        return !1;
      },
      s = !1,
      l = !1,
      c = function () {
        function e() {}
        return e.initialize = function (e) {
          var t = e.channelConfigCallback,
            n = e.isCBMCallback,
            c = e.initialChatManagerConfig,
            u = e.initialConversationClient,
            d = e.disableOrganicMessageSorting,
            f = e.useLegacyUnloadConversationChecks;
          i = t, a = n, r = c, o = u, s = !!d, l = !!f;
        }, e.getChannelConfigFromConversationSid = function (e) {
          return i(e);
        }, e.getFileAttachmentConfigFromConversationSid = function (t) {
          return e.getChannelConfigFromConversationSid(t).fileAttachment || {};
        }, e.isCBM = function (e) {
          return a(e);
        }, e.shouldUseMessageInputV2 = function () {
          return null == r ? void 0 : r.useMessageInputV2;
        }, e.isOrganicMessageSortingDisabled = function () {
          return s;
        }, e.shouldUseLegacyUnloadConversationChecks = function () {
          return l;
        }, e.getConversationsClient = function () {
          return o;
        }, e.destroy = function () {
          i = function () {
            return {};
          }, a = function () {
            return !1;
          }, r = void 0, o = void 0, s = !1;
        }, e;
      }();
    t.ChatManager = c;
  }, function (e, t) {
    e.exports = require("@emotion/react");
  }, function (e, t) {
    e.exports = require("react-redux");
  }, function (e, t) {
    e.exports = require("slate");
  }, function (e, t) {
    e.exports = require("@material-ui/core");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionStateListener = void 0;
    var l = s(n(0)),
      c = n(23),
      u = n(9),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            pendingActions: c.Actions.findPendingActions(t.props.action, t.props.payload),
            blockedActions: c.Actions.findBlockedActions(t.props.action, t.props.payload)
          }, t.handleInvocationsChanged = function () {
            var e = c.Actions.findPendingActions(t.props.action, t.props.payload),
              n = c.Actions.findBlockedActions(t.props.action, t.props.payload);
            u.Utils.areEqual(t.state.pendingActions, e) && u.Utils.areEqual(t.state.blockedActions, n) || t.setState(function () {
              return {
                pendingActions: e,
                blockedActions: n
              };
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          e !== this.props && this.handleInvocationsChanged();
        }, t.prototype.componentDidMount = function () {
          c.Actions.addListener("invocationBegin", this.handleInvocationsChanged), c.Actions.addListener("invocationEnd", this.handleInvocationsChanged), c.Actions.addListener("actionBlockedChanged", this.handleInvocationsChanged);
        }, t.prototype.componentWillUnmount = function () {
          c.Actions.removeListener("invocationBegin", this.handleInvocationsChanged), c.Actions.removeListener("invocationEnd", this.handleInvocationsChanged), c.Actions.removeListener("actionBlockedChanged", this.handleInvocationsChanged);
        }, t.prototype.render = function () {
          return this.props.children({
            disabled: !!this.state.pendingActions.first || !!this.state.blockedActions.first
          });
        }, t;
      }(l.Component);
    t.ActionStateListener = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createNewProxy = void 0;
    t.createNewProxy = function (e, t) {
      return void 0 === t && (t = {}), new Proxy(e, {
        get: function (n, r) {
          var o = n[r],
            i = t[r] || [],
            a = i[0],
            s = i[1];
          return a ? "method" === a ? function () {
            for (var t = [], r = 0; r < arguments.length; r++) t[r] = arguments[r];
            return s(t, function () {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              return o.apply(n, e.length ? e : t);
            }, e);
          } : s(o, e) : "function" == typeof o ? function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            return o.apply(n, e);
          } : o;
        }
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.current = t.ClientListener = t.Actions = t.reduce = t.ACTION_CHAT_SESSION_UNINIT = t.ACTION_APP_ACTIVE = t.ACTION_CLIENT_CONNECTION = t.ACTION_INIT_SESSION = void 0;
    var o = n(8),
      i = n(3),
      a = n(11),
      s = {
        connectionState: "",
        client: void 0,
        listener: void 0,
        isActive: !0
      };
    t.ACTION_INIT_SESSION = "CHAT_SESSION_INIT", t.ACTION_CLIENT_CONNECTION = "CHAT_SESSION_CLIENT_CONNECTION", t.ACTION_APP_ACTIVE = "CHAT_SESSION_APP_ACTIVE", t.ACTION_CHAT_SESSION_UNINIT = "CHAT_SESSION_UNINIT", t.reduce = function (e, n) {
      switch (void 0 === e && (e = s), n.type) {
        case t.ACTION_INIT_SESSION:
          var o = n.payload;
          e.listener && e.listener.stop();
          var i = new c(o);
          return r(r({}, s), {
            listener: i,
            client: o,
            connectionState: o.connectionState
          });
        case t.ACTION_CLIENT_CONNECTION:
          var a = n.payload;
          return r(r({}, e), {
            connectionState: a
          });
        case t.ACTION_APP_ACTIVE:
          return r(r({}, e), {
            isActive: n.payload
          });
        case t.ACTION_CHAT_SESSION_UNINIT:
          return s;
        default:
          return e;
      }
    };
    var l = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function () {
          return this._dispatcher || o.ChatModule.dispatch;
        },
        set: function (e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.init = function (e) {
        this.dispatcher({
          type: t.ACTION_INIT_SESSION,
          payload: e
        });
      }, e.dispatchConnectionState = function (e) {
        this.dispatcher({
          type: t.ACTION_CLIENT_CONNECTION,
          payload: e
        });
      }, e.setActive = function (e) {
        this.dispatcher({
          type: t.ACTION_APP_ACTIVE,
          payload: e
        });
      }, e.shutdown = function () {
        i.log.debug("ChatSession state logout"), a.Actions.removeAllListeners();
        var e = o.ChatModule.state.session.listener;
        e && e.stop();
        var n = o.ChatModule.state.session.client;
        n && (n.removeAllListeners(), n.shutdown().catch(function () {
          i.log.warn("Failed to shutdown Chat Client gracefully");
        })), this.dispatcher({
          type: t.ACTION_CHAT_SESSION_UNINIT
        });
      }, e;
    }();
    t.Actions = l;
    var c = function () {
      function e(e) {
        this._listening = !1, this.handleConnectionStateChanged = function (e) {
          l.dispatchConnectionState(e);
        }, this._client = e, this.start();
      }
      return e.prototype.start = function () {
        this._listening || (this._client.addListener("connectionStateChanged", this.handleConnectionStateChanged), this._listening = !0);
      }, e.prototype.stop = function () {
        this._listening && (this._client.removeListener("connectionStateChanged", this.handleConnectionStateChanged), this._listening = !1);
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e;
    }();
    t.ClientListener = c, t.current = function () {
      return o.ChatModule.state.session;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tryInvokeAction = void 0;
    var i = n(23);
    t.tryInvokeAction = function (e, t) {
      return r(this, void 0, Promise, function () {
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2,, 3]), [4, i.Actions.invokeAction(e, t)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return n.sent(), [3, 3];
            case 3:
              return [2];
          }
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LinkPanelField = t.LinkPanelButtonsContainer = t.LinkPanelTitle = t.LinkPanelWrapper = t.LinkPanelCloseIcon = t.StyledPopover = t.CompactViewContainer = t.Wrapper = t.ExpandToolbarButton = t.StyledToolbarFileAttachment = t.ToolbarSeparator = t.ToolbarButton = void 0;
    var l,
      c,
      u,
      d,
      f,
      p,
      h,
      v,
      m,
      g,
      b,
      y = s(n(115)),
      _ = n(26),
      O = a(n(0)),
      C = n(70),
      P = n(1),
      M = n(41),
      j = function (e) {
        return "\n    padding: " + e.tokens.spacings.space20 + ";\n    border: " + e.tokens.borderWidths.borderWidth10 + " solid transparent;\n    color: " + e.tokens.textColors.colorTextIcon + ";\n    background: transparent;\n    width: " + e.tokens.sizings.sizeIcon50 + ";\n    height: " + e.tokens.sizings.sizeIcon50 + ";\n    display:flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    margin: 0 " + e.tokens.spacings.space10 + ";\n    border-radius: " + e.tokens.radii.borderRadius20 + ";\n\n    &:hover {\n        border-color: " + e.tokens.borderColors.colorBorderPrimaryStronger + ";\n        color: " + e.tokens.textColors.colorTextLinkStronger + ";\n    }\n    \n    " + (0, P.styleObjectToString)(e.Chat.EmailEditor.ToolbarButton.Default) + ";\n\n\n    &.active {\n        background: " + e.tokens.backgroundColors.colorBackgroundPrimaryStronger + ";\n        color: " + e.tokens.textColors.colorTextInverse + ";\n\n        &:hover {\n            color: " + e.tokens.textColors.colorTextLinkStrong + ";\n            background: " + e.tokens.backgroundColors.colorBackgroundStrong + ";\n            border-color: transparent;\n        }\n        \n        " + (0, P.styleObjectToString)(e.Chat.EmailEditor.ToolbarButton.Active) + ";\n    }";
      },
      w = P.styled.button(l || (l = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
        return j(e.theme);
      });
    t.ToolbarButton = function (e) {
      var t = e.icon,
        n = e.onMouseDown,
        r = e.active;
      return O.createElement(w, {
        onMouseDown: n,
        className: r ? "active" : "",
        type: "button"
      }, t);
    }, t.ToolbarSeparator = P.styled.div(c || (c = r(["\n    width: 0;\n    border-right: ", " solid\n        ", ";\n    margin: 0 ", ";\n    ", ";\n"], ["\n    width: 0;\n    border-right: ", " solid\n        ", ";\n    margin: 0 ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderWeak;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.Chat.EmailEditor.ToolbarSeparator;
    }), t.StyledToolbarFileAttachment = (0, P.styled)(C.AttachFileButton)(u || (u = r(["\n    ", ";\n    width: 30px;\n    height: 30px;\n    ", ";\n"], ["\n    ", ";\n    width: 30px;\n    height: 30px;\n    ", ";\n"])), function (e) {
      return j(e.theme);
    }, function (e) {
      return e.theme.Chat.EmailEditor.ToolbarFileAttachmentButton;
    }), t.ExpandToolbarButton = (0, P.styled)("a")(d || (d = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return j(e.theme);
    }), t.Wrapper = P.styled.div(f || (f = r(["\n    display: flex;\n    flex: 1 1 0;\n    overflow: hidden;\n\n    ", ";\n"], ["\n    display: flex;\n    flex: 1 1 0;\n    overflow: hidden;\n\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailEditor.ToolbarWrapper;
    }), t.CompactViewContainer = P.styled.div(p || (p = r(["\n    display: flex;\n    flex: 1 1 0;\n    padding: ", ";\n\n    ", ";\n"], ["\n    display: flex;\n    flex: 1 1 0;\n    padding: ", ";\n\n    ", ";\n"])), function (e) {
      return "" + e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.Chat.EmailEditor.ToolbarCompactViewWrapper;
    }), t.StyledPopover = (0, _.withStyles)(function (e) {
      return M({
        paper: {
          border: e.tokens.borderWidths.borderWidth10 + " solid " + e.tokens.borderColors.colorBorderWeak,
          boxShadow: "0 3px 4px 2px rgba(0,0,0,.1)"
        }
      }, e.Chat.EmailEditor.ToolbarPopover);
    })(y.default), t.LinkPanelCloseIcon = (0, P.styled)("button")(h || (h = r(["\n    padding: 0;\n    border: none;\n    background: none;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    border-radius: ", ";\n\n    &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px ", ";\n    }\n\n    ", ";\n"], ["\n    padding: 0;\n    border: none;\n    background: none;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    border-radius: ", ";\n\n    &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px ", ";\n    }\n\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius20;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextLink;
    }, function (e) {
      return e.theme.Chat.EmailEditor.LinkPanelCloseIcon;
    }), t.LinkPanelWrapper = (0, P.styled)("div")(v || (v = r(["\n    width: 260px;\n    box-sizing: border-box;\n    padding: ", ";\n    ", ";\n"], ["\n    width: 260px;\n    box-sizing: border-box;\n    padding: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space70 + " " + e.theme.tokens.spacings.space50 + " " + e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.Chat.EmailEditor.LinkPanelWrapper;
    }), t.LinkPanelTitle = (0, P.styled)("p")(m || (m = r(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: bold;\n    margin-bottom: ", ";\n    ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: bold;\n    margin-bottom: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize40;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight40;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.Chat.EmailEditor.LinkPanelTitle;
    }), t.LinkPanelButtonsContainer = (0, P.styled)("div")(g || (g = r(["\n    overflow: visible;\n    ", ";\n"], ["\n    overflow: visible;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailEditor.LinkPanelButtonsContainer;
    }), t.LinkPanelField = P.styled.div(b || (b = r(["\n    margin-bottom: ", ";\n    ", ";\n"], ["\n    margin-bottom: ", ";\n    ", ";\n"])), function (e) {
      return e.last ? e.theme.tokens.spacings.space30 : e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.Chat.EmailEditor.LinkPanelField;
    });
  }, function (e, t) {
    e.exports = require("events");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.wrapOriginalMethodPromiseResults = t.mapOldPropertyToNew = t.mapOldMethodToNew = t.logDeprecated = void 0;
    var a = n(3);
    t.logDeprecated = function (e, t) {
      return a.log.warn('"' + e + '" method is now deprecated. Please use "' + t + '" instead.');
    };
    t.mapOldMethodToNew = function (e, n) {
      return function (r, o, i) {
        return (0, t.logDeprecated)(e, n), i[n]();
      };
    };
    t.mapOldPropertyToNew = function (e, n) {
      return function (r, o) {
        return (0, t.logDeprecated)(e, n), o[n];
      };
    };
    t.wrapOriginalMethodPromiseResults = function (e, t) {
      return void 0 === t && (t = []), function (n, a) {
        return r(void 0, void 0, void 0, function () {
          var n;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, a()];
              case 1:
                return n = r.sent(), [2, e.apply(void 0, i([n], t, !1))];
            }
          });
        });
      };
    };
  }, function (e, t) {
    e.exports = require("@material-ui/core/Input");
  }, function (e, t) {
    e.exports = require("lodash.merge");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CircularProgressProps = t.CircularProgressThemeProps = t.CircularProgress = void 0;
    var r = n(457);
    Object.defineProperty(t, "CircularProgress", {
      enumerable: !0,
      get: function () {
        return r.CircularProgress;
      }
    });
    var o = n(459);
    Object.defineProperty(t, "CircularProgressThemeProps", {
      enumerable: !0,
      get: function () {
        return o.CircularProgressThemeProps;
      }
    }), Object.defineProperty(t, "CircularProgressProps", {
      enumerable: !0,
      get: function () {
        return o.CircularProgressProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withDefaultPropsUpdate = void 0;
    var c = l(n(0)),
      u = n(96),
      d = function () {
        var e = this;
        this.callbacks = [], this.update = function (t) {
          e.callbacks.forEach(function (e) {
            return e(t);
          });
        }, this.on = function (t) {
          e.callbacks.push(t);
        }, this.off = function (t) {
          e.callbacks = e.callbacks.filter(function (e) {
            return e !== t;
          });
        };
      };
    t.withDefaultPropsUpdate = function (e) {
      var t = e,
        n = function (e) {
          function n() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.updateCb = function () {
              t.forceUpdate();
            }, t;
          }
          return o(n, e), n.getInitialDefaultProps = function () {
            return t.defaultProps;
          }, n.updateAll = function () {
            this.callbacks.update();
          }, n.prototype.componentDidMount = function () {
            n.callbacks.on(this.updateCb);
          }, n.prototype.componentWillUnmount = function () {
            n.callbacks.off(this.updateCb);
          }, n.prototype.render = function () {
            return c.createElement(t, i({}, function (e, t) {
              if ("object" != typeof e || "object" != typeof t) return e;
              var n = Object.keys(t);
              if (0 === n.length) return e;
              var r = i({}, e);
              return n.forEach(function (e) {
                void 0 === r[e] && (r[e] = t[e]);
              }), r;
            }(this.props, n.overrideProps)));
          }, n.overrideProps = {}, n.defaultProps = function (e) {
            if ("object" != typeof e) return e;
            var t = {};
            return Object.keys(e).forEach(function (e) {
              t[e] = void 0;
            }), t;
          }(t.defaultProps), n.displayName = t.displayName, n.callbacks = new d(), n;
        }(c.Component);
      return u(n, t, {
        updateAll: !0
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatChannelHelper = t.ConversationHelper = void 0;
    var l = s(n(53)),
      c = n(3),
      u = function () {
        function e(e) {
          this.conversation = e;
        }
        return Object.defineProperty(e.prototype, "lastMessage", {
          get: function () {
            var e = this.conversation && Array.isArray(this.conversation.pendingMessages) && this.conversation.pendingMessages[this.conversation.pendingMessages.length - 1],
              t = this.conversation && Array.isArray(this.conversation.messages) && this.conversation.messages[this.conversation.messages.length - 1];
            return e && (!t || e.source.dateCreated > t.source.dateCreated) ? e : t;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "typers", {
          get: function () {
            return this.conversation.typers;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isCustomerOnline", {
          get: function () {
            return this.conversation ? Array.from(this.conversation.participants.values()).some(function (e) {
              var t = e.source.attributes,
                n = !!t && t[l.CHANNEL_MEMBER_TYPE];
              return !(!n || n !== l.CHANNEL_CUSTOMER_MEMBER_TYPE) && !!e.online;
            }) : (c.log.error("Error determine if customer is online. No conversation defined"), !1);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "conversationType", {
          get: function () {
            var e;
            if (!this.conversation) return c.log.error("Error determining conversation type. No conversation defined"), null;
            if (!(null === (e = this.conversation.source) || void 0 === e ? void 0 : e.attributes)) return c.log.error("Error determining conversation type. No conversation attributes defined"), null;
            var t = this.conversation.source.attributes,
              n = t.channel_type;
            return t.conversation_type || n;
          },
          enumerable: !1,
          configurable: !0
        }), e.isUserParticipantOfConversation = function (e) {
          var t;
          return "joined" === (null === (t = null == e ? void 0 : e.source) || void 0 === t ? void 0 : t.status);
        }, e.getEmailParticipants = function (e) {
          for (var t = e.participants.values(), n = [], r = [], o = t.next(); !o.done;) {
            var i = o.value,
              a = i.source.bindings.email;
            if (a) {
              var s = a.address;
              i.friendlyName && (s = i.friendlyName + " (" + a.address + ")"), "cc" === a.level ? r.push(s) : n.push(s);
            }
            o = t.next();
          }
          return [n, r];
        }, e;
      }();
    t.ConversationHelper = u;
    var d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), Object.defineProperty(t.prototype, "channelType", {
        get: function () {
          return c.log.warn("Method deprecated. Please use conversationType"), this.conversationType;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }(u);
    t.ChatChannelHelper = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConvoUserToChatUser = t.proxyOnUserUpdated = void 0;
    var a = n(34),
      s = n(39),
      l = n(3),
      c = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          return o(this, function (e) {
            return l.log.warn("'subscribe' method is now deprecated. User is now subscribed by default."), [2, n];
          });
        });
      },
      u = function (e, n) {
        var r,
          o = e[0],
          a = e[1],
          s = e.slice(2),
          l = n;
        if (["userSubscribed", "userUnsubscribed"].includes(o)) {
          r = l.apply(void 0, i([o, function (e) {
            for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
            var o = (0, t.ConvoUserToChatUser)(e);
            a.apply(void 0, i([o], n, !1));
          }], s, !1));
        } else r = ["updated"].includes(o) ? (0, t.proxyOnUserUpdated)(l, "updated", a, s) : l();
        return (0, t.ConvoUserToChatUser)(r);
      };
    t.proxyOnUserUpdated = function (e, n, r, o) {
      return e.apply(void 0, i([n, function (e) {
        for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
        r.apply(void 0, i([{
          user: (0, t.ConvoUserToChatUser)(e.user),
          updateReasons: e.updateReasons.map(function (e) {
            return e.replace(/reachability[A-Z]/g, function (e) {
              return e[e.length - 1].toLocaleLowerCase();
            });
          })
        }], n, !1));
      }], o, !1));
    };
    t.ConvoUserToChatUser = function (e) {
      return (0, a.createNewProxy)(e, {
        online: ["property", (0, s.mapOldPropertyToNew)("online", "isOnline")],
        notifiable: ["property", (0, s.mapOldPropertyToNew)("notifiable", "isNotifiable")],
        subscribe: ["method", c],
        addListener: ["method", u]
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_TOGGLE_REPLY_MODE = t.ACTION_DETACH_CONVERSATION_FILES = t.ACTION_ATTACH_CONVERSATION_FILES = t.ACTION_UPDATE_CONVERSATION_INPUT = void 0;
    var l = n(8),
      c = a(n(35)),
      u = a(n(11)),
      d = {},
      f = {
        inputText: "",
        selectionStart: 0,
        selectionEnd: 0,
        attachedFiles: [],
        isReplyModeActive: !1
      };
    t.ACTION_UPDATE_CONVERSATION_INPUT = "CONVERSATION_INPUT_UPDATE", t.ACTION_ATTACH_CONVERSATION_FILES = "CONVERSATION_FILES_ATTACH", t.ACTION_DETACH_CONVERSATION_FILES = "CONVERSATION_FILES_DETACH", t.ACTION_TOGGLE_REPLY_MODE = "TOGGLE_REPLY_MODE", t.reduce = function (e, n) {
      var o, i, a, l, p;
      if (void 0 === e && (e = d), n.type === c.ACTION_CHAT_SESSION_UNINIT) return d;
      if (!n.meta) return e;
      var h = n.meta.conversationSid;
      if (!h) return e;
      switch (n.type) {
        case u.ACTION_INIT_CONVERSATION:
          return r(r({}, e), ((o = {})[h] = f, o));
        case u.ACTION_UNLOAD_CONVERSATION:
          var v = r({}, e);
          return delete v[h], v;
        case t.ACTION_UPDATE_CONVERSATION_INPUT:
          return r(r({}, e), ((i = {})[h] = r(r(r({}, e[h]), n.payload), {
            isReplyModeActive: !(!n.payload.inputText && !n.payload.htmlValue)
          }), i));
        case t.ACTION_ATTACH_CONVERSATION_FILES:
          return r(r({}, e), ((a = {})[h] = r(r({}, e[h]), {
            isReplyModeActive: !0,
            attachedFiles: s(s([], e[h].attachedFiles || [], !0), n.payload.attachedFiles, !0)
          }), a));
        case t.ACTION_DETACH_CONVERSATION_FILES:
          var m = n.payload.attachedFile,
            g = m.name,
            b = m.size,
            y = m.type;
          return r(r({}, e), ((l = {})[h] = r(r({}, e[h]), {
            isReplyModeActive: !0,
            attachedFiles: (e[h].attachedFiles || []).filter(function (e) {
              return e.name !== g || e.size !== b || e.type !== y;
            })
          }), l));
        case t.ACTION_TOGGLE_REPLY_MODE:
          return r(r({}, e), ((p = {})[h] = r(r({}, e[h]), {
            isReplyModeActive: n.payload
          }), p));
        default:
          return e;
      }
    };
    var p = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function () {
          return this._dispatcher || l.ChatModule.dispatch;
        },
        set: function (e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.setInputText = function (e, n, r, o, i) {
        void 0 === r && (r = 0), void 0 === o && (o = 0), e.source && this.dispatcher({
          type: t.ACTION_UPDATE_CONVERSATION_INPUT,
          payload: {
            inputText: n,
            selectionStart: r,
            selectionEnd: o,
            htmlValue: i
          },
          meta: {
            conversationSid: e.source.sid
          }
        });
      }, e.attachFiles = function (e, n) {
        e.source && this.dispatcher({
          type: t.ACTION_ATTACH_CONVERSATION_FILES,
          payload: {
            attachedFiles: n
          },
          meta: {
            conversationSid: e.source.sid
          }
        });
      }, e.detachFile = function (e, n) {
        e.source && this.dispatcher({
          type: t.ACTION_DETACH_CONVERSATION_FILES,
          payload: {
            attachedFile: n
          },
          meta: {
            conversationSid: e.source.sid
          }
        });
      }, e.toggleReplyStateActivation = function (e, n) {
        e.source && this.dispatcher({
          type: t.ACTION_TOGGLE_REPLY_MODE,
          payload: n,
          meta: {
            conversationSid: e.source.sid
          }
        });
      }, e;
    }();
    t.Actions = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Animations = void 0;
    var o,
      i,
      a = n(5),
      s = (0, a.keyframes)(o || (o = r(["\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n"], ["\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n"]))),
      l = (0, a.keyframes)(i || (i = r(["\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
    t.Animations = {
      FADE_IN_DURATION: .15,
      FADE_OUT_DURATION: .07,
      SLIDE_IN_DURATION: .18,
      SLIDE_OUT_DURATION: .05,
      SPIN_DURATION: 1.5,
      FadeInOutTransition: function (e, t, n, r) {
        return void 0 === t && (t = .15), void 0 === n && (n = .07), void 0 === r && (r = 0), "\n    transition: visibility " + (e ? t : n) + "s ease-in " + r + "s, opacity " + (e ? t : n) + "s " + (e ? "ease-in" : "ease-out") + " " + r + "s;\n    opacity: " + (e ? 1 : 0) + ";\n    visibility: " + (e ? "visible" : "hidden") + ";\n    pointer-events: " + (e ? "inherit" : "none") + ";\n  ";
      },
      SlideInTransition: function (e, t, n) {
        return void 0 === t && (t = .18), void 0 === n && (n = .05), "\n    transition: all " + (e ? t : n) + "s " + (e ? "ease-in" : "ease-out") + ";\n";
      },
      AppearKeyFrames: s,
      AppearAnimation: function (e, t) {
        return void 0 === e && (e = .15), void 0 === t && (t = 0), "animation: " + s + " " + e + "s ease-in " + t + "s 1 normal both;";
      },
      SpinKeyFrames: l,
      SpinAnimation: function (e) {
        return void 0 === e && (e = 1.5), "animation: " + l + " " + e + "s linear infinite;";
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilePreview = void 0;
    var r = n(413);
    Object.defineProperty(t, "FilePreview", {
      enumerable: !0,
      get: function () {
        return r.FilePreview;
      }
    });
  }, function (e, t) {
    e.exports = require("@udecode/plate-link");
  }, function (e, t) {
    e.exports = require("@udecode/plate-list");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NAVIGATION_INTERCEPTED_MESSAGE = t.LINK_CLICK_MESSAGE = t.HEIGHT_MESSAGE = t.POST_MESSAGE_IDENTIFIER = void 0, t.POST_MESSAGE_IDENTIFIER = "SeamlessIframe", t.HEIGHT_MESSAGE = "HEIGHT_MESSAGE", t.LINK_CLICK_MESSAGE = "LINK_CLICK_MESSAGE", t.NAVIGATION_INTERCEPTED_MESSAGE = "NAVIGATION_INTERCEPTED_MESSAGE";
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatEventEmitter = t.ChatEvent = void 0;
    var i,
      a = n(38);
    !function (e) {
      e[e.chatInputFocus = 0] = "chatInputFocus", e[e.chatInputBlur = 1] = "chatInputBlur", e[e.chatInputRowsChanged = 2] = "chatInputRowsChanged", e[e.chatMessagePosted = 3] = "chatMessagePosted", e[e.chatMediaMessagePosted = 4] = "chatMediaMessagePosted", e[e.chatMediaDownloaded = 5] = "chatMediaDownloaded";
    }(i = t.ChatEvent || (t.ChatEvent = {}));
    var s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.emitInputFocus = function (e) {
        this.emit(i[i.chatInputFocus], e);
      }, t.prototype.emitInputBlur = function (e) {
        this.emit(i[i.chatInputBlur], e);
      }, t.prototype.emitMessagePosted = function (e, t) {
        this.emit(i[i.chatMessagePosted], e, t);
      }, t.prototype.emitMediaMessagePosted = function (e, t) {
        this.emit(i[i.chatMediaMessagePosted], e, t);
      }, t.prototype.emitMediaDownloaded = function (e) {
        this.emit(i[i.chatMediaDownloaded], e);
      }, t;
    }(a.EventEmitter);
    t.ChatEventEmitter = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CHANNEL_AGENT_MEMBER_TYPE = t.CHANNEL_CUSTOMER_MEMBER_TYPE = t.CHANNEL_MEMBER_TYPE = t.CHANNEL_STATUS_INACTIVE = t.CHANNEL_STATUS_ACTIVE = t.CHANNEL_STATUS_ATTRIBUTE = void 0, t.CHANNEL_STATUS_ATTRIBUTE = "status", t.CHANNEL_STATUS_ACTIVE = "ACTIVE", t.CHANNEL_STATUS_INACTIVE = "INACTIVE", t.CHANNEL_MEMBER_TYPE = "member_type", t.CHANNEL_CUSTOMER_MEMBER_TYPE = "guest", t.CHANNEL_AGENT_MEMBER_TYPE = "agent";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailRemoveParticipantFailed = t.EmailAddParticipantFailed = t.EmailSuccessfullySent = t.DownloadFileInvalidSize = t.DownloadFileInvalidType = t.AttachFileDisabled = t.AttachFileMultipleNotSupported = t.AttachFileInvalidMaxAmount = t.AttachFileInvalidOverallSize = t.AttachFileInvalidSize = t.AttachFileInvalidType = t.AttachFileDuplicate = t.AttachFileMultipleFailure = t.SendMessageFailed = t.SendMediaMessageInvalidSize = t.SendMediaMessageInvalidType = t.NewChatMessage = t.UNKNOWN = void 0, t.UNKNOWN = "UNKNOWN", t.NewChatMessage = "NewChatMessage", t.SendMediaMessageInvalidType = "SendMediaMessageInvalidType", t.SendMediaMessageInvalidSize = "SendMediaMessageInvalidSize", t.SendMessageFailed = "SendMessageFailed", t.AttachFileMultipleFailure = "AttachFileMultipleFailure", t.AttachFileDuplicate = "AttachFileDuplicate", t.AttachFileInvalidType = "AttachFileInvalidType", t.AttachFileInvalidSize = "AttachFileInvalidSize", t.AttachFileInvalidOverallSize = "AttachFileInvalidOverallSize", t.AttachFileInvalidMaxAmount = "AttachFileInvalidMaxAmount", t.AttachFileMultipleNotSupported = "AttachFileMultipleNotSupported", t.AttachFileDisabled = "AttachFileDisabled", t.DownloadFileInvalidType = "DownloadFileInvalidType", t.DownloadFileInvalidSize = "DownloadFileInvalidSize", t.EmailSuccessfullySent = "EmailSuccessfullySent", t.EmailAddParticipantFailed = "EmailAddParticipantFailed", t.EmailRemoveParticipantFailed = "EmailRemoveParticipantFailed";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProxyPaginator = t.ParticipantToMember = t.ConvoUserToChatUser = t.ConvoMessageToChatMessage = t.ConversationToChannel = t.ConvoClientToChatClient = void 0, (0, n(88).initBridges)();
    var r = n(88);
    Object.defineProperty(t, "ConvoClientToChatClient", {
      enumerable: !0,
      get: function () {
        return r.ConvoClientToChatClient;
      }
    });
    var o = n(89);
    Object.defineProperty(t, "ConversationToChannel", {
      enumerable: !0,
      get: function () {
        return o.ConversationToChannel;
      }
    });
    var i = n(56);
    Object.defineProperty(t, "ConvoMessageToChatMessage", {
      enumerable: !0,
      get: function () {
        return i.ConvoMessageToChatMessage;
      }
    });
    var a = n(45);
    Object.defineProperty(t, "ConvoUserToChatUser", {
      enumerable: !0,
      get: function () {
        return a.ConvoUserToChatUser;
      }
    });
    var s = n(57);
    Object.defineProperty(t, "ParticipantToMember", {
      enumerable: !0,
      get: function () {
        return s.ParticipantToMember;
      }
    });
    var l = n(58);
    Object.defineProperty(t, "ProxyPaginator", {
      enumerable: !0,
      get: function () {
        return l.ProxyPaginator;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConvoMessageToChatMessage = t.proxyOnMessageUpdated = t.setTransformers = void 0;
    var a,
      s,
      l = n(34),
      c = n(39);
    t.setTransformers = function (e, t) {
      a = e, s = t;
    };
    var u = function (e, t) {
        return r(void 0, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, a(t.conversation)];
          });
        });
      },
      d = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return (0, c.logDeprecated)("getMember", "getParticipant"), [4, n.getParticipant()];
              case 1:
                return e = t.sent(), [2, s(e)];
            }
          });
        });
      },
      f = function (e, n) {
        var r,
          o = e[0],
          i = e[1],
          a = e.slice(2),
          s = n;
        return r = ["updated"].includes(o) ? (0, t.proxyOnMessageUpdated)(n, o, i, a) : s(), (0, t.ConvoMessageToChatMessage)(r);
      };
    t.proxyOnMessageUpdated = function (e, n, r, o) {
      return e.apply(void 0, i([n, function (e) {
        for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
        r.apply(void 0, i([{
          message: (0, t.ConvoMessageToChatMessage)(e.message),
          updateReasons: e.updateReasons
        }], n, !1));
      }], o, !1));
    };
    t.ConvoMessageToChatMessage = function (e) {
      return (0, l.createNewProxy)(e, {
        channel: ["property", u],
        memberSid: ["property", (0, c.mapOldPropertyToNew)("memberSid", "participantSid")],
        getMember: ["method", d],
        remove: ["method", (0, c.wrapOriginalMethodPromiseResults)(t.ConvoMessageToChatMessage)],
        updateAttributes: ["method", (0, c.wrapOriginalMethodPromiseResults)(t.ConvoMessageToChatMessage)],
        updateBody: ["method", (0, c.wrapOriginalMethodPromiseResults)(t.ConvoMessageToChatMessage)],
        addListener: ["method", f]
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArray || function (e, t, n) {
      if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
      return e.concat(r || Array.prototype.slice.call(t));
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantToMember = t.proxyOnParticipantUpdated = t.setConversationTransformer = void 0;
    var o,
      i = n(45),
      a = n(34),
      s = n(39);
    t.setConversationTransformer = function (e) {
      o = e;
    };
    var l = function (e, t, n) {
        return (0, s.logDeprecated)("getUserDescriptor", "getUser"), n.getUser.apply(n, e);
      },
      c = function (e, t) {
        return (0, s.logDeprecated)("lastConsumedMessageIndex", "lastReadMessageIndex"), t.lastReadMessageIndex;
      },
      u = function (e, t) {
        return t.lastReadTimestamp;
      },
      d = function (e, t) {
        return o(t.conversation);
      };
    t.proxyOnParticipantUpdated = function (e, n, o, i) {
      return e.apply(void 0, r([n, function (e) {
        for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
        o.apply(void 0, r([{
          member: (0, t.ParticipantToMember)(e.participant),
          updateReasons: e.updateReasons.map(function (e) {
            return e.replace("lastReadMessageIndex", "lastConsumedMessageIndex").replace("lastReadTimestamp", "lastConsumptionTimestamp");
          })
        }], n, !1));
      }], i, !1));
    };
    var f = function (e, n) {
      var o,
        i = e[0],
        a = e[1],
        s = e.slice(2),
        l = n;
      if (["typingEnded", "typingStarted"].includes(i)) {
        o = l.apply(void 0, r([i, function (e) {
          for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
          var s = (0, t.ParticipantToMember)(e);
          a.apply(void 0, r([i, s], n, !1));
        }], s, !1));
      } else o = ["updated"].includes(i) ? (0, t.proxyOnParticipantUpdated)(l, i, a, s) : l();
      return (0, t.ParticipantToMember)(o);
    };
    t.ParticipantToMember = function (e) {
      if (!o) throw Error("please set a ConversationTransformer");
      return (0, a.createNewProxy)(e, {
        getUserDescriptor: ["method", l],
        getUser: ["method", (0, s.wrapOriginalMethodPromiseResults)(i.ConvoUserToChatUser)],
        updateAttributes: ["method", (0, s.wrapOriginalMethodPromiseResults)(t.ParticipantToMember)],
        lastConsumedMessageIndex: ["property", c],
        lastConsumptionTimestamp: ["property", u],
        channel: ["property", d],
        addListener: ["method", f]
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ProxyPaginator = void 0;
    var i = n(34),
      a = function (e) {
        return function (t) {
          return t.map(e);
        };
      },
      s = function (e) {
        return function (t, n) {
          return r(void 0, void 0, void 0, function () {
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, n()];
                case 1:
                  return [2, l(t.sent(), e)];
              }
            });
          });
        };
      };
    function l(e, t) {
      return (0, i.createNewProxy)(e, {
        items: ["property", a(t)],
        nextPage: ["method", s(t)],
        prevPage: ["method", s(t)]
      });
    }
    t.ProxyPaginator = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(183), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VisibilityContextProvider = void 0;
    var a = i(n(0));
    t.VisibilityContextProvider = a.createContext(!0);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IcnDirectory = t.IcnDialpadLarge = t.IcnDialpad = t.IcnDefaultAvatarBold = t.IcnDefaultAvatar = t.IcnDebuggerWarning = t.IcnDataBold = t.IcnData = t.IcnDashboardsBold = t.IcnDashboards = t.IcnDashboardBold = t.IcnDashboard = t.IcnCopy = t.IcnConnectionError = t.IcnCogs = t.IcnCloseLarge = t.IcnClose = t.IcnClock = t.IcnChannel = t.IcnCallSmall = t.IcnCallBold = t.IcnCall = t.IcnBulbBold = t.IcnBulb = t.IcnBold = t.IcnBellBold = t.IcnBell = t.IcnBackArrow = t.IcnAttachment = t.IcnArrowUp = t.IcnArrowRight = t.IcnArrowLeft = t.IcnArrowDown = t.IcnAppDegraded = t.IcnAnalyzeBold = t.IcnAnalyze = t.IcnAlertTriangle = t.IcnAlertError = t.IcnAlert = t.IcnAgentsViewBold = t.IcnAgentsView = t.IcnAgentsBold = t.IcnAgents = t.IcnAgentNotifyBold = t.IcnAgentNotify = t.IcnAgentBold = t.IcnAgent = t.IcnAdd = t.IcnAcceptLarge = t.IcnAccept = void 0, t.IcnInfo = t.IcnIncomingTransferBold = t.IcnIncomingTransfer = t.IcnIncomingCallBold = t.IcnIncomingCall = t.IcnHoldOffLarge = t.IcnHoldOff = t.IcnHoldLargeBold = t.IcnHoldLarge = t.IcnHoldBoldSmall = t.IcnHoldBold = t.IcnHold = t.IcnHelpBold = t.IcnHelp = t.IcnHangupLarge = t.IcnHangupBold = t.IcnHangup = t.IcnHamburgerNotify = t.IcnHamburger = t.IcnGroupCallBold = t.IcnGroupCall = t.IcnGreyIndicator = t.IcnGreenIndicator = t.IcnGenericTaskBold = t.IcnGenericTask = t.IcnGenericImage = t.IcnGenericDoc = t.IcnFullscreen = t.IcnFormat = t.IcnFolder = t.IcnFlexDebugger = t.IcnFlexBanner = t.IcnFilterUp = t.IcnFilterTrigger = t.IcnFilter = t.IcnFileAudio = t.IcnFileAttachment = t.IcnFacebookBold = t.IcnFacebook = t.IcnEyeBold = t.IcnEye = t.IcnError = t.IcnEmptyContent = t.IcnEmpty = t.IcnEmailBold = t.IcnEmail = t.IcnEdit = t.IcnDragHandle = t.IcnDownload = t.IcnDirectoryBold = void 0, t.IcnSearch = t.IcnResize = t.IcnRead = t.IcnQueuesBold = t.IcnQueues = t.IcnQueue = t.IcnQuestionnairesBold = t.IcnQuestionnaires = t.IcnPointerArrowDown = t.IcnPlay = t.IcnPdf = t.IcnPause = t.IcnParticipant = t.IcnOutboundCallBold = t.IcnOutboundCall = t.IcnOrderedList = t.IcnOpenInNewWindow = t.IcnOpen = t.IcnNotificationOperational = t.IcnNotificationDegraded = t.IcnNoData = t.IcnNoCRM = t.IcnNoChat = t.IcnNewTask = t.IcnMuteLargeBold = t.IcnMuteLarge = t.IcnMuteBold = t.IcnMute = t.IcnMore = t.IcnMonitorSmall = t.IcnMonitorOffLarge = t.IcnMonitorBoldLarge = t.IcnMinus = t.IcnMinimize = t.IcnMessaging = t.IcnMessageBold = t.IcnMessage = t.IcnLogoutBold = t.IcnLogout = t.IcnLoading = t.IcnLink = t.IcnLineBold = t.IcnLine = t.IcnLeaveCallLarge = t.IcnLeaveCall = t.IcnItalic = t.IcnInspectionsBold = t.IcnInspections = t.IcnInformation = t.IcnInfoBold = void 0, t.IcnWhatsappBold = t.IcnWhatsapp = t.IcnWarning = t.IcnVolumeBold = t.IcnVolume = t.IcnVoiceSmall = t.IcnVoiceBold = t.IcnVoice = t.IcnVirtualAgent = t.IcnVideoBold = t.IcnVideo = t.IcnUser = t.IcnUnorderedList = t.IcnUnderline = t.IcnTwilio = t.IcnTransferLarge = t.IcnTransferBold = t.IcnTransfer = t.IcnThumbupBold = t.IcnThumbup = t.IcnThumbdownBold = t.IcnThumbdown = t.IcnTasksSmall = t.IcnTasksLarge = t.IcnSupportabilityBold = t.IcnSupportability = t.IcnSupervisorBold = t.IcnSupervisor = t.IcnSuggested = t.IcnSuccess = t.IcnStrikethrough = t.IcnSpeechSearchesBold = t.IcnSpeechSearches = t.IcnSmsBold = t.IcnSmsAlt = t.IcnSms = t.IcnSideMenuOn = t.IcnSideMenuOff = t.IcnSettingsBold = t.IcnSettings = t.IcnSendLarge = void 0;
    var o = n(206);
    Object.defineProperty(t, "IcnAccept", {
      enumerable: !0,
      get: function () {
        return r(o).default;
      }
    });
    var i = n(207);
    Object.defineProperty(t, "IcnAcceptLarge", {
      enumerable: !0,
      get: function () {
        return r(i).default;
      }
    });
    var a = n(208);
    Object.defineProperty(t, "IcnAdd", {
      enumerable: !0,
      get: function () {
        return r(a).default;
      }
    });
    var s = n(209);
    Object.defineProperty(t, "IcnAgent", {
      enumerable: !0,
      get: function () {
        return r(s).default;
      }
    });
    var l = n(210);
    Object.defineProperty(t, "IcnAgentBold", {
      enumerable: !0,
      get: function () {
        return r(l).default;
      }
    });
    var c = n(211);
    Object.defineProperty(t, "IcnAgentNotify", {
      enumerable: !0,
      get: function () {
        return r(c).default;
      }
    });
    var u = n(212);
    Object.defineProperty(t, "IcnAgentNotifyBold", {
      enumerable: !0,
      get: function () {
        return r(u).default;
      }
    });
    var d = n(213);
    Object.defineProperty(t, "IcnAgents", {
      enumerable: !0,
      get: function () {
        return r(d).default;
      }
    });
    var f = n(214);
    Object.defineProperty(t, "IcnAgentsBold", {
      enumerable: !0,
      get: function () {
        return r(f).default;
      }
    });
    var p = n(215);
    Object.defineProperty(t, "IcnAgentsView", {
      enumerable: !0,
      get: function () {
        return r(p).default;
      }
    });
    var h = n(216);
    Object.defineProperty(t, "IcnAgentsViewBold", {
      enumerable: !0,
      get: function () {
        return r(h).default;
      }
    });
    var v = n(217);
    Object.defineProperty(t, "IcnAlert", {
      enumerable: !0,
      get: function () {
        return r(v).default;
      }
    });
    var m = n(218);
    Object.defineProperty(t, "IcnAlertError", {
      enumerable: !0,
      get: function () {
        return r(m).default;
      }
    });
    var g = n(219);
    Object.defineProperty(t, "IcnAlertTriangle", {
      enumerable: !0,
      get: function () {
        return r(g).default;
      }
    });
    var b = n(220);
    Object.defineProperty(t, "IcnAnalyze", {
      enumerable: !0,
      get: function () {
        return r(b).default;
      }
    });
    var y = n(221);
    Object.defineProperty(t, "IcnAnalyzeBold", {
      enumerable: !0,
      get: function () {
        return r(y).default;
      }
    });
    var _ = n(222);
    Object.defineProperty(t, "IcnAppDegraded", {
      enumerable: !0,
      get: function () {
        return r(_).default;
      }
    });
    var O = n(98);
    Object.defineProperty(t, "IcnArrowDown", {
      enumerable: !0,
      get: function () {
        return r(O).default;
      }
    });
    var C = n(223);
    Object.defineProperty(t, "IcnArrowLeft", {
      enumerable: !0,
      get: function () {
        return r(C).default;
      }
    });
    var P = n(224);
    Object.defineProperty(t, "IcnArrowRight", {
      enumerable: !0,
      get: function () {
        return r(P).default;
      }
    });
    var M = n(99);
    Object.defineProperty(t, "IcnArrowUp", {
      enumerable: !0,
      get: function () {
        return r(M).default;
      }
    });
    var j = n(225);
    Object.defineProperty(t, "IcnAttachment", {
      enumerable: !0,
      get: function () {
        return r(j).default;
      }
    });
    var w = n(226);
    Object.defineProperty(t, "IcnBackArrow", {
      enumerable: !0,
      get: function () {
        return r(w).default;
      }
    });
    var E = n(227);
    Object.defineProperty(t, "IcnBell", {
      enumerable: !0,
      get: function () {
        return r(E).default;
      }
    });
    var S = n(228);
    Object.defineProperty(t, "IcnBellBold", {
      enumerable: !0,
      get: function () {
        return r(S).default;
      }
    });
    var x = n(229);
    Object.defineProperty(t, "IcnBold", {
      enumerable: !0,
      get: function () {
        return r(x).default;
      }
    });
    var T = n(230);
    Object.defineProperty(t, "IcnBulb", {
      enumerable: !0,
      get: function () {
        return r(T).default;
      }
    });
    var A = n(231);
    Object.defineProperty(t, "IcnBulbBold", {
      enumerable: !0,
      get: function () {
        return r(A).default;
      }
    });
    var I = n(232);
    Object.defineProperty(t, "IcnCall", {
      enumerable: !0,
      get: function () {
        return r(I).default;
      }
    });
    var k = n(233);
    Object.defineProperty(t, "IcnCallBold", {
      enumerable: !0,
      get: function () {
        return r(k).default;
      }
    });
    var N = n(234);
    Object.defineProperty(t, "IcnCallSmall", {
      enumerable: !0,
      get: function () {
        return r(N).default;
      }
    });
    var B = n(235);
    Object.defineProperty(t, "IcnChannel", {
      enumerable: !0,
      get: function () {
        return r(B).default;
      }
    });
    var D = n(236);
    Object.defineProperty(t, "IcnClock", {
      enumerable: !0,
      get: function () {
        return r(D).default;
      }
    });
    var L = n(237);
    Object.defineProperty(t, "IcnClose", {
      enumerable: !0,
      get: function () {
        return r(L).default;
      }
    });
    var z = n(238);
    Object.defineProperty(t, "IcnCloseLarge", {
      enumerable: !0,
      get: function () {
        return r(z).default;
      }
    });
    var F = n(239);
    Object.defineProperty(t, "IcnCogs", {
      enumerable: !0,
      get: function () {
        return r(F).default;
      }
    });
    var R = n(240);
    Object.defineProperty(t, "IcnConnectionError", {
      enumerable: !0,
      get: function () {
        return r(R).default;
      }
    });
    var H = n(241);
    Object.defineProperty(t, "IcnCopy", {
      enumerable: !0,
      get: function () {
        return r(H).default;
      }
    });
    var W = n(242);
    Object.defineProperty(t, "IcnDashboard", {
      enumerable: !0,
      get: function () {
        return r(W).default;
      }
    });
    var U = n(243);
    Object.defineProperty(t, "IcnDashboardBold", {
      enumerable: !0,
      get: function () {
        return r(U).default;
      }
    });
    var V = n(244);
    Object.defineProperty(t, "IcnDashboards", {
      enumerable: !0,
      get: function () {
        return r(V).default;
      }
    });
    var G = n(245);
    Object.defineProperty(t, "IcnDashboardsBold", {
      enumerable: !0,
      get: function () {
        return r(G).default;
      }
    });
    var q = n(246);
    Object.defineProperty(t, "IcnData", {
      enumerable: !0,
      get: function () {
        return r(q).default;
      }
    });
    var K = n(247);
    Object.defineProperty(t, "IcnDataBold", {
      enumerable: !0,
      get: function () {
        return r(K).default;
      }
    });
    var Y = n(248);
    Object.defineProperty(t, "IcnDebuggerWarning", {
      enumerable: !0,
      get: function () {
        return r(Y).default;
      }
    });
    var $ = n(249);
    Object.defineProperty(t, "IcnDefaultAvatar", {
      enumerable: !0,
      get: function () {
        return r($).default;
      }
    });
    var Q = n(250);
    Object.defineProperty(t, "IcnDefaultAvatarBold", {
      enumerable: !0,
      get: function () {
        return r(Q).default;
      }
    });
    var Z = n(251);
    Object.defineProperty(t, "IcnDialpad", {
      enumerable: !0,
      get: function () {
        return r(Z).default;
      }
    });
    var J = n(252);
    Object.defineProperty(t, "IcnDialpadLarge", {
      enumerable: !0,
      get: function () {
        return r(J).default;
      }
    });
    var X = n(253);
    Object.defineProperty(t, "IcnDirectory", {
      enumerable: !0,
      get: function () {
        return r(X).default;
      }
    });
    var ee = n(254);
    Object.defineProperty(t, "IcnDirectoryBold", {
      enumerable: !0,
      get: function () {
        return r(ee).default;
      }
    });
    var te = n(255);
    Object.defineProperty(t, "IcnDownload", {
      enumerable: !0,
      get: function () {
        return r(te).default;
      }
    });
    var ne = n(256);
    Object.defineProperty(t, "IcnDragHandle", {
      enumerable: !0,
      get: function () {
        return r(ne).default;
      }
    });
    var re = n(257);
    Object.defineProperty(t, "IcnEdit", {
      enumerable: !0,
      get: function () {
        return r(re).default;
      }
    });
    var oe = n(258);
    Object.defineProperty(t, "IcnEmail", {
      enumerable: !0,
      get: function () {
        return r(oe).default;
      }
    });
    var ie = n(259);
    Object.defineProperty(t, "IcnEmailBold", {
      enumerable: !0,
      get: function () {
        return r(ie).default;
      }
    });
    var ae = n(260);
    Object.defineProperty(t, "IcnEmpty", {
      enumerable: !0,
      get: function () {
        return r(ae).default;
      }
    });
    var se = n(261);
    Object.defineProperty(t, "IcnEmptyContent", {
      enumerable: !0,
      get: function () {
        return r(se).default;
      }
    });
    var le = n(262);
    Object.defineProperty(t, "IcnError", {
      enumerable: !0,
      get: function () {
        return r(le).default;
      }
    });
    var ce = n(263);
    Object.defineProperty(t, "IcnEye", {
      enumerable: !0,
      get: function () {
        return r(ce).default;
      }
    });
    var ue = n(264);
    Object.defineProperty(t, "IcnEyeBold", {
      enumerable: !0,
      get: function () {
        return r(ue).default;
      }
    });
    var de = n(265);
    Object.defineProperty(t, "IcnFacebook", {
      enumerable: !0,
      get: function () {
        return r(de).default;
      }
    });
    var fe = n(266);
    Object.defineProperty(t, "IcnFacebookBold", {
      enumerable: !0,
      get: function () {
        return r(fe).default;
      }
    });
    var pe = n(267);
    Object.defineProperty(t, "IcnFileAttachment", {
      enumerable: !0,
      get: function () {
        return r(pe).default;
      }
    });
    var he = n(268);
    Object.defineProperty(t, "IcnFileAudio", {
      enumerable: !0,
      get: function () {
        return r(he).default;
      }
    });
    var ve = n(269);
    Object.defineProperty(t, "IcnFilter", {
      enumerable: !0,
      get: function () {
        return r(ve).default;
      }
    });
    var me = n(270);
    Object.defineProperty(t, "IcnFilterTrigger", {
      enumerable: !0,
      get: function () {
        return r(me).default;
      }
    });
    var ge = n(271);
    Object.defineProperty(t, "IcnFilterUp", {
      enumerable: !0,
      get: function () {
        return r(ge).default;
      }
    });
    var be = n(272);
    Object.defineProperty(t, "IcnFlexBanner", {
      enumerable: !0,
      get: function () {
        return r(be).default;
      }
    });
    var ye = n(273);
    Object.defineProperty(t, "IcnFlexDebugger", {
      enumerable: !0,
      get: function () {
        return r(ye).default;
      }
    });
    var _e = n(274);
    Object.defineProperty(t, "IcnFolder", {
      enumerable: !0,
      get: function () {
        return r(_e).default;
      }
    });
    var Oe = n(275);
    Object.defineProperty(t, "IcnFormat", {
      enumerable: !0,
      get: function () {
        return r(Oe).default;
      }
    });
    var Ce = n(276);
    Object.defineProperty(t, "IcnFullscreen", {
      enumerable: !0,
      get: function () {
        return r(Ce).default;
      }
    });
    var Pe = n(277);
    Object.defineProperty(t, "IcnGenericDoc", {
      enumerable: !0,
      get: function () {
        return r(Pe).default;
      }
    });
    var Me = n(278);
    Object.defineProperty(t, "IcnGenericImage", {
      enumerable: !0,
      get: function () {
        return r(Me).default;
      }
    });
    var je = n(279);
    Object.defineProperty(t, "IcnGenericTask", {
      enumerable: !0,
      get: function () {
        return r(je).default;
      }
    });
    var we = n(280);
    Object.defineProperty(t, "IcnGenericTaskBold", {
      enumerable: !0,
      get: function () {
        return r(we).default;
      }
    });
    var Ee = n(281);
    Object.defineProperty(t, "IcnGreenIndicator", {
      enumerable: !0,
      get: function () {
        return r(Ee).default;
      }
    });
    var Se = n(282);
    Object.defineProperty(t, "IcnGreyIndicator", {
      enumerable: !0,
      get: function () {
        return r(Se).default;
      }
    });
    var xe = n(283);
    Object.defineProperty(t, "IcnGroupCall", {
      enumerable: !0,
      get: function () {
        return r(xe).default;
      }
    });
    var Te = n(284);
    Object.defineProperty(t, "IcnGroupCallBold", {
      enumerable: !0,
      get: function () {
        return r(Te).default;
      }
    });
    var Ae = n(285);
    Object.defineProperty(t, "IcnHamburger", {
      enumerable: !0,
      get: function () {
        return r(Ae).default;
      }
    });
    var Ie = n(286);
    Object.defineProperty(t, "IcnHamburgerNotify", {
      enumerable: !0,
      get: function () {
        return r(Ie).default;
      }
    });
    var ke = n(287);
    Object.defineProperty(t, "IcnHangup", {
      enumerable: !0,
      get: function () {
        return r(ke).default;
      }
    });
    var Ne = n(288);
    Object.defineProperty(t, "IcnHangupBold", {
      enumerable: !0,
      get: function () {
        return r(Ne).default;
      }
    });
    var Be = n(289);
    Object.defineProperty(t, "IcnHangupLarge", {
      enumerable: !0,
      get: function () {
        return r(Be).default;
      }
    });
    var De = n(290);
    Object.defineProperty(t, "IcnHelp", {
      enumerable: !0,
      get: function () {
        return r(De).default;
      }
    });
    var Le = n(291);
    Object.defineProperty(t, "IcnHelpBold", {
      enumerable: !0,
      get: function () {
        return r(Le).default;
      }
    });
    var ze = n(292);
    Object.defineProperty(t, "IcnHold", {
      enumerable: !0,
      get: function () {
        return r(ze).default;
      }
    });
    var Fe = n(293);
    Object.defineProperty(t, "IcnHoldBold", {
      enumerable: !0,
      get: function () {
        return r(Fe).default;
      }
    });
    var Re = n(294);
    Object.defineProperty(t, "IcnHoldBoldSmall", {
      enumerable: !0,
      get: function () {
        return r(Re).default;
      }
    });
    var He = n(295);
    Object.defineProperty(t, "IcnHoldLarge", {
      enumerable: !0,
      get: function () {
        return r(He).default;
      }
    });
    var We = n(296);
    Object.defineProperty(t, "IcnHoldLargeBold", {
      enumerable: !0,
      get: function () {
        return r(We).default;
      }
    });
    var Ue = n(297);
    Object.defineProperty(t, "IcnHoldOff", {
      enumerable: !0,
      get: function () {
        return r(Ue).default;
      }
    });
    var Ve = n(298);
    Object.defineProperty(t, "IcnHoldOffLarge", {
      enumerable: !0,
      get: function () {
        return r(Ve).default;
      }
    });
    var Ge = n(299);
    Object.defineProperty(t, "IcnIncomingCall", {
      enumerable: !0,
      get: function () {
        return r(Ge).default;
      }
    });
    var qe = n(300);
    Object.defineProperty(t, "IcnIncomingCallBold", {
      enumerable: !0,
      get: function () {
        return r(qe).default;
      }
    });
    var Ke = n(301);
    Object.defineProperty(t, "IcnIncomingTransfer", {
      enumerable: !0,
      get: function () {
        return r(Ke).default;
      }
    });
    var Ye = n(302);
    Object.defineProperty(t, "IcnIncomingTransferBold", {
      enumerable: !0,
      get: function () {
        return r(Ye).default;
      }
    });
    var $e = n(303);
    Object.defineProperty(t, "IcnInfo", {
      enumerable: !0,
      get: function () {
        return r($e).default;
      }
    });
    var Qe = n(304);
    Object.defineProperty(t, "IcnInfoBold", {
      enumerable: !0,
      get: function () {
        return r(Qe).default;
      }
    });
    var Ze = n(305);
    Object.defineProperty(t, "IcnInformation", {
      enumerable: !0,
      get: function () {
        return r(Ze).default;
      }
    });
    var Je = n(306);
    Object.defineProperty(t, "IcnInspections", {
      enumerable: !0,
      get: function () {
        return r(Je).default;
      }
    });
    var Xe = n(307);
    Object.defineProperty(t, "IcnInspectionsBold", {
      enumerable: !0,
      get: function () {
        return r(Xe).default;
      }
    });
    var et = n(308);
    Object.defineProperty(t, "IcnItalic", {
      enumerable: !0,
      get: function () {
        return r(et).default;
      }
    });
    var tt = n(309);
    Object.defineProperty(t, "IcnLeaveCall", {
      enumerable: !0,
      get: function () {
        return r(tt).default;
      }
    });
    var nt = n(310);
    Object.defineProperty(t, "IcnLeaveCallLarge", {
      enumerable: !0,
      get: function () {
        return r(nt).default;
      }
    });
    var rt = n(311);
    Object.defineProperty(t, "IcnLine", {
      enumerable: !0,
      get: function () {
        return r(rt).default;
      }
    });
    var ot = n(312);
    Object.defineProperty(t, "IcnLineBold", {
      enumerable: !0,
      get: function () {
        return r(ot).default;
      }
    });
    var it = n(313);
    Object.defineProperty(t, "IcnLink", {
      enumerable: !0,
      get: function () {
        return r(it).default;
      }
    });
    var at = n(314);
    Object.defineProperty(t, "IcnLoading", {
      enumerable: !0,
      get: function () {
        return r(at).default;
      }
    });
    var st = n(315);
    Object.defineProperty(t, "IcnLogout", {
      enumerable: !0,
      get: function () {
        return r(st).default;
      }
    });
    var lt = n(316);
    Object.defineProperty(t, "IcnLogoutBold", {
      enumerable: !0,
      get: function () {
        return r(lt).default;
      }
    });
    var ct = n(317);
    Object.defineProperty(t, "IcnMessage", {
      enumerable: !0,
      get: function () {
        return r(ct).default;
      }
    });
    var ut = n(318);
    Object.defineProperty(t, "IcnMessageBold", {
      enumerable: !0,
      get: function () {
        return r(ut).default;
      }
    });
    var dt = n(319);
    Object.defineProperty(t, "IcnMessaging", {
      enumerable: !0,
      get: function () {
        return r(dt).default;
      }
    });
    var ft = n(320);
    Object.defineProperty(t, "IcnMinimize", {
      enumerable: !0,
      get: function () {
        return r(ft).default;
      }
    });
    var pt = n(321);
    Object.defineProperty(t, "IcnMinus", {
      enumerable: !0,
      get: function () {
        return r(pt).default;
      }
    });
    var ht = n(322);
    Object.defineProperty(t, "IcnMonitorBoldLarge", {
      enumerable: !0,
      get: function () {
        return r(ht).default;
      }
    });
    var vt = n(323);
    Object.defineProperty(t, "IcnMonitorOffLarge", {
      enumerable: !0,
      get: function () {
        return r(vt).default;
      }
    });
    var mt = n(324);
    Object.defineProperty(t, "IcnMonitorSmall", {
      enumerable: !0,
      get: function () {
        return r(mt).default;
      }
    });
    var gt = n(325);
    Object.defineProperty(t, "IcnMore", {
      enumerable: !0,
      get: function () {
        return r(gt).default;
      }
    });
    var bt = n(326);
    Object.defineProperty(t, "IcnMute", {
      enumerable: !0,
      get: function () {
        return r(bt).default;
      }
    });
    var yt = n(327);
    Object.defineProperty(t, "IcnMuteBold", {
      enumerable: !0,
      get: function () {
        return r(yt).default;
      }
    });
    var _t = n(328);
    Object.defineProperty(t, "IcnMuteLarge", {
      enumerable: !0,
      get: function () {
        return r(_t).default;
      }
    });
    var Ot = n(329);
    Object.defineProperty(t, "IcnMuteLargeBold", {
      enumerable: !0,
      get: function () {
        return r(Ot).default;
      }
    });
    var Ct = n(330);
    Object.defineProperty(t, "IcnNewTask", {
      enumerable: !0,
      get: function () {
        return r(Ct).default;
      }
    });
    var Pt = n(331);
    Object.defineProperty(t, "IcnNoChat", {
      enumerable: !0,
      get: function () {
        return r(Pt).default;
      }
    });
    var Mt = n(332);
    Object.defineProperty(t, "IcnNoCRM", {
      enumerable: !0,
      get: function () {
        return r(Mt).default;
      }
    });
    var jt = n(333);
    Object.defineProperty(t, "IcnNoData", {
      enumerable: !0,
      get: function () {
        return r(jt).default;
      }
    });
    var wt = n(334);
    Object.defineProperty(t, "IcnNotificationDegraded", {
      enumerable: !0,
      get: function () {
        return r(wt).default;
      }
    });
    var Et = n(335);
    Object.defineProperty(t, "IcnNotificationOperational", {
      enumerable: !0,
      get: function () {
        return r(Et).default;
      }
    });
    var St = n(336);
    Object.defineProperty(t, "IcnOpen", {
      enumerable: !0,
      get: function () {
        return r(St).default;
      }
    });
    var xt = n(337);
    Object.defineProperty(t, "IcnOpenInNewWindow", {
      enumerable: !0,
      get: function () {
        return r(xt).default;
      }
    });
    var Tt = n(338);
    Object.defineProperty(t, "IcnOrderedList", {
      enumerable: !0,
      get: function () {
        return r(Tt).default;
      }
    });
    var At = n(339);
    Object.defineProperty(t, "IcnOutboundCall", {
      enumerable: !0,
      get: function () {
        return r(At).default;
      }
    });
    var It = n(340);
    Object.defineProperty(t, "IcnOutboundCallBold", {
      enumerable: !0,
      get: function () {
        return r(It).default;
      }
    });
    var kt = n(341);
    Object.defineProperty(t, "IcnParticipant", {
      enumerable: !0,
      get: function () {
        return r(kt).default;
      }
    });
    var Nt = n(342);
    Object.defineProperty(t, "IcnPause", {
      enumerable: !0,
      get: function () {
        return r(Nt).default;
      }
    });
    var Bt = n(343);
    Object.defineProperty(t, "IcnPdf", {
      enumerable: !0,
      get: function () {
        return r(Bt).default;
      }
    });
    var Dt = n(344);
    Object.defineProperty(t, "IcnPlay", {
      enumerable: !0,
      get: function () {
        return r(Dt).default;
      }
    });
    var Lt = n(345);
    Object.defineProperty(t, "IcnPointerArrowDown", {
      enumerable: !0,
      get: function () {
        return r(Lt).default;
      }
    });
    var zt = n(346);
    Object.defineProperty(t, "IcnQuestionnaires", {
      enumerable: !0,
      get: function () {
        return r(zt).default;
      }
    });
    var Ft = n(347);
    Object.defineProperty(t, "IcnQuestionnairesBold", {
      enumerable: !0,
      get: function () {
        return r(Ft).default;
      }
    });
    var Rt = n(348);
    Object.defineProperty(t, "IcnQueue", {
      enumerable: !0,
      get: function () {
        return r(Rt).default;
      }
    });
    var Ht = n(349);
    Object.defineProperty(t, "IcnQueues", {
      enumerable: !0,
      get: function () {
        return r(Ht).default;
      }
    });
    var Wt = n(350);
    Object.defineProperty(t, "IcnQueuesBold", {
      enumerable: !0,
      get: function () {
        return r(Wt).default;
      }
    });
    var Ut = n(351);
    Object.defineProperty(t, "IcnRead", {
      enumerable: !0,
      get: function () {
        return r(Ut).default;
      }
    });
    var Vt = n(352);
    Object.defineProperty(t, "IcnResize", {
      enumerable: !0,
      get: function () {
        return r(Vt).default;
      }
    });
    var Gt = n(353);
    Object.defineProperty(t, "IcnSearch", {
      enumerable: !0,
      get: function () {
        return r(Gt).default;
      }
    });
    var qt = n(354);
    Object.defineProperty(t, "IcnSendLarge", {
      enumerable: !0,
      get: function () {
        return r(qt).default;
      }
    });
    var Kt = n(355);
    Object.defineProperty(t, "IcnSettings", {
      enumerable: !0,
      get: function () {
        return r(Kt).default;
      }
    });
    var Yt = n(356);
    Object.defineProperty(t, "IcnSettingsBold", {
      enumerable: !0,
      get: function () {
        return r(Yt).default;
      }
    });
    var $t = n(357);
    Object.defineProperty(t, "IcnSideMenuOff", {
      enumerable: !0,
      get: function () {
        return r($t).default;
      }
    });
    var Qt = n(358);
    Object.defineProperty(t, "IcnSideMenuOn", {
      enumerable: !0,
      get: function () {
        return r(Qt).default;
      }
    });
    var Zt = n(359);
    Object.defineProperty(t, "IcnSms", {
      enumerable: !0,
      get: function () {
        return r(Zt).default;
      }
    });
    var Jt = n(360);
    Object.defineProperty(t, "IcnSmsAlt", {
      enumerable: !0,
      get: function () {
        return r(Jt).default;
      }
    });
    var Xt = n(361);
    Object.defineProperty(t, "IcnSmsBold", {
      enumerable: !0,
      get: function () {
        return r(Xt).default;
      }
    });
    var en = n(362);
    Object.defineProperty(t, "IcnSpeechSearches", {
      enumerable: !0,
      get: function () {
        return r(en).default;
      }
    });
    var tn = n(363);
    Object.defineProperty(t, "IcnSpeechSearchesBold", {
      enumerable: !0,
      get: function () {
        return r(tn).default;
      }
    });
    var nn = n(364);
    Object.defineProperty(t, "IcnStrikethrough", {
      enumerable: !0,
      get: function () {
        return r(nn).default;
      }
    });
    var rn = n(365);
    Object.defineProperty(t, "IcnSuccess", {
      enumerable: !0,
      get: function () {
        return r(rn).default;
      }
    });
    var on = n(366);
    Object.defineProperty(t, "IcnSuggested", {
      enumerable: !0,
      get: function () {
        return r(on).default;
      }
    });
    var an = n(367);
    Object.defineProperty(t, "IcnSupervisor", {
      enumerable: !0,
      get: function () {
        return r(an).default;
      }
    });
    var sn = n(368);
    Object.defineProperty(t, "IcnSupervisorBold", {
      enumerable: !0,
      get: function () {
        return r(sn).default;
      }
    });
    var ln = n(369);
    Object.defineProperty(t, "IcnSupportability", {
      enumerable: !0,
      get: function () {
        return r(ln).default;
      }
    });
    var cn = n(370);
    Object.defineProperty(t, "IcnSupportabilityBold", {
      enumerable: !0,
      get: function () {
        return r(cn).default;
      }
    });
    var un = n(371);
    Object.defineProperty(t, "IcnTasksLarge", {
      enumerable: !0,
      get: function () {
        return r(un).default;
      }
    });
    var dn = n(372);
    Object.defineProperty(t, "IcnTasksSmall", {
      enumerable: !0,
      get: function () {
        return r(dn).default;
      }
    });
    var fn = n(373);
    Object.defineProperty(t, "IcnThumbdown", {
      enumerable: !0,
      get: function () {
        return r(fn).default;
      }
    });
    var pn = n(374);
    Object.defineProperty(t, "IcnThumbdownBold", {
      enumerable: !0,
      get: function () {
        return r(pn).default;
      }
    });
    var hn = n(375);
    Object.defineProperty(t, "IcnThumbup", {
      enumerable: !0,
      get: function () {
        return r(hn).default;
      }
    });
    var vn = n(376);
    Object.defineProperty(t, "IcnThumbupBold", {
      enumerable: !0,
      get: function () {
        return r(vn).default;
      }
    });
    var mn = n(377);
    Object.defineProperty(t, "IcnTransfer", {
      enumerable: !0,
      get: function () {
        return r(mn).default;
      }
    });
    var gn = n(378);
    Object.defineProperty(t, "IcnTransferBold", {
      enumerable: !0,
      get: function () {
        return r(gn).default;
      }
    });
    var bn = n(379);
    Object.defineProperty(t, "IcnTransferLarge", {
      enumerable: !0,
      get: function () {
        return r(bn).default;
      }
    });
    var yn = n(380);
    Object.defineProperty(t, "IcnTwilio", {
      enumerable: !0,
      get: function () {
        return r(yn).default;
      }
    });
    var _n = n(381);
    Object.defineProperty(t, "IcnUnderline", {
      enumerable: !0,
      get: function () {
        return r(_n).default;
      }
    });
    var On = n(382);
    Object.defineProperty(t, "IcnUnorderedList", {
      enumerable: !0,
      get: function () {
        return r(On).default;
      }
    });
    var Cn = n(383);
    Object.defineProperty(t, "IcnUser", {
      enumerable: !0,
      get: function () {
        return r(Cn).default;
      }
    });
    var Pn = n(384);
    Object.defineProperty(t, "IcnVideo", {
      enumerable: !0,
      get: function () {
        return r(Pn).default;
      }
    });
    var Mn = n(385);
    Object.defineProperty(t, "IcnVideoBold", {
      enumerable: !0,
      get: function () {
        return r(Mn).default;
      }
    });
    var jn = n(386);
    Object.defineProperty(t, "IcnVirtualAgent", {
      enumerable: !0,
      get: function () {
        return r(jn).default;
      }
    });
    var wn = n(387);
    Object.defineProperty(t, "IcnVoice", {
      enumerable: !0,
      get: function () {
        return r(wn).default;
      }
    });
    var En = n(388);
    Object.defineProperty(t, "IcnVoiceBold", {
      enumerable: !0,
      get: function () {
        return r(En).default;
      }
    });
    var Sn = n(389);
    Object.defineProperty(t, "IcnVoiceSmall", {
      enumerable: !0,
      get: function () {
        return r(Sn).default;
      }
    });
    var xn = n(390);
    Object.defineProperty(t, "IcnVolume", {
      enumerable: !0,
      get: function () {
        return r(xn).default;
      }
    });
    var Tn = n(391);
    Object.defineProperty(t, "IcnVolumeBold", {
      enumerable: !0,
      get: function () {
        return r(Tn).default;
      }
    });
    var An = n(392);
    Object.defineProperty(t, "IcnWarning", {
      enumerable: !0,
      get: function () {
        return r(An).default;
      }
    });
    var In = n(393);
    Object.defineProperty(t, "IcnWhatsapp", {
      enumerable: !0,
      get: function () {
        return r(In).default;
      }
    });
    var kn = n(394);
    Object.defineProperty(t, "IcnWhatsappBold", {
      enumerable: !0,
      get: function () {
        return r(kn).default;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BadgeVariants = void 0, function (e) {
      e.standard = "standard", e.dot = "dot", e.danger = "danger";
    }(t.BadgeVariants || (t.BadgeVariants = {}));
  }, function (e, t) {
    e.exports = require("lodash.debounce");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ButtonSpinnerContainer = t.Links = t.EmailFileContainer = t.SubmitButtonContainer = t.Footer = t.InputFieldInput = t.InputFieldLabel = t.InputFieldContainer = t.Form = t.Reply = void 0;
    var i,
      a,
      s,
      l,
      c,
      u,
      d,
      f,
      p,
      h = n(26),
      v = n(17),
      m = n(1),
      g = o(n(40)),
      b = n(41);
    t.Reply = (0, m.styled)(v.Button)(i || (i = r(["\n    margin: 0 ", " ", ";\n    align-self: start;\n    ", ";\n"], ["\n    margin: 0 ", " ", ";\n    align-self: start;\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.Chat.EmailEditor.EntrypointButton;
    }), t.Form = (0, m.styled)("form")(a || (a = r(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    ", ";\n"], ["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailEditor.Form;
    }), t.InputFieldContainer = m.styled.div(s || (s = r(["\n    display: flex;\n    align-items: baseline;\n    ", ";\n\n    ", ";\n    ", ";\n"], ["\n    display: flex;\n    align-items: baseline;\n    ", ";\n\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailEditor.InputField.Default;
    }, function (e) {
      return e.hasBorder && "\n            border-bottom: " + e.theme.tokens.borderWidths.borderWidth10 + " solid " + e.theme.tokens.borderColors.colorBorderWeak + ";\n        ";
    }, function (e) {
      return e.hasBorder && e.theme.Chat.EmailEditor.InputField.WithBorder;
    }), t.InputFieldLabel = m.styled.label(l || (l = r(["\n    font-size: ", ";\n    color: ", ";\n    line-height: ", ";\n    ", ";\n"], ["\n    font-size: ", ";\n    color: ", ";\n    line-height: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.Chat.EmailEditor.InputFieldLabel;
    }), t.InputFieldInput = (0, h.withStyles)(function (e) {
      return b({
        root: {
          flex: "1 1 auto",
          "&, &.Mui-focused": {
            border: "none",
            boxShadow: "none"
          }
        },
        input: {
          paddingLeft: e.tokens.spacings.space30
        }
      }, e.Chat.EmailEditor.InputFieldInput);
    })(g.default), t.Footer = m.styled.div(c || (c = r(["\n    order: 3;\n    display: flex;\n    margin: ", ";\n    padding: ", ";\n    border-top: 1px solid ", ";\n    ", ";\n"], ["\n    order: 3;\n    display: flex;\n    margin: ", ";\n    padding: ", ";\n    border-top: 1px solid ", ";\n    ", ";\n"])), function (e) {
      var t = e.theme.tokens.spacings;
      return t.space30 + " -" + t.space40 + " -" + t.space20;
    }, function (e) {
      var t = e.theme.tokens.spacings;
      return t.space30 + " " + t.space40 + " 0";
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderWeak;
    }, function (e) {
      return e.theme.Chat.EmailEditor.Footer;
    }), t.SubmitButtonContainer = m.styled.div(u || (u = r(["\n    margin-left: auto;\n    padding-left: ", ";\n    ", ";\n"], ["\n    margin-left: auto;\n    padding-left: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.Chat.EmailEditor.SubmitButtonContainer;
    }), t.EmailFileContainer = m.styled.div(d || (d = r(["\n    margin-top: ", ";\n    display: inline-flex;\n    flex-wrap: wrap;\n    max-width: 100%;\n    gap: ", ";\n    order: 3;\n    ", ";\n"], ["\n    margin-top: ", ";\n    display: inline-flex;\n    flex-wrap: wrap;\n    max-width: 100%;\n    gap: ", ";\n    order: 3;\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.Chat.EmailEditor.FileContainer;
    }), t.Links = m.styled.div(f || (f = r(["\n    display: flex;\n\n    > a {\n        color: ", ";\n        margin-left: ", ";\n\n        &:hover {\n            color: ", ";\n        }\n        ", ";\n    }\n"], ["\n    display: flex;\n\n    > a {\n        color: ", ";\n        margin-left: ", ";\n\n        &:hover {\n            color: ", ";\n        }\n        ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.textColors.colorTextLink;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextLinkStrong;
    }, function (e) {
      return e.theme.Chat.EmailEditor.CCFieldToggle;
    }), t.ButtonSpinnerContainer = m.styled.div(p || (p = r(["\n    display: flex;\n    animation: 2s linear infinite rotate;\n\n    @keyframes rotate {\n        0% {\n            transform: rotate(0);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n\n    ", ";\n"], ["\n    display: flex;\n    animation: 2s linear infinite rotate;\n\n    @keyframes rotate {\n        0% {\n            transform: rotate(0);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailEditor.ButtonSpinnerContainer;
    });
  }, function (e, t) {
    e.exports = require("@udecode/plate-basic-marks");
  }, function (e, t) {
    e.exports = require("@udecode/plate-paragraph");
  }, function (e, t) {
    e.exports = require("@udecode/plate-table");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ELEMENT_SPAN = void 0, t.ELEMENT_SPAN = "span";
  }, function (e, t) {
    e.exports = require("@material-ui/core/Fade");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AttachFileButton = void 0;
    var r = n(439);
    Object.defineProperty(t, "AttachFileButton", {
      enumerable: !0,
      get: function () {
        return r.AttachFileButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListItem = t.Avatar = void 0;
    var i = n(121);
    Object.defineProperty(t, "Avatar", {
      enumerable: !0,
      get: function () {
        return i.Avatar;
      }
    });
    var a = n(122);
    Object.defineProperty(t, "MessageListItem", {
      enumerable: !0,
      get: function () {
        return a.MessageListItem;
      }
    }), o(n(124), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubble = void 0;
    var i = n(462);
    Object.defineProperty(t, "MessageBubble", {
      enumerable: !0,
      get: function () {
        return i.MessageBubble;
      }
    }), o(n(73), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledBlockQuote = t.MediaMessageActions = t.MediaMessageContainer = t.MediaMessageErrorContainer = t.MediaContainer = t.BodyContainer = t.TimeContainer = t.UserNameContainer = t.HeaderContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      d,
      f,
      p,
      h = n(6),
      v = n(1);
    t.Container = (0, v.styled)(h.FlexBoxColumn)(o || (o = r(["\n    overflow-x: hidden;\n\n    ", ";\n\n    ", ";\n\n    background: ", ";\n    border-radius: ", ";\n    margin-left: ", ";\n    padding: ", ";\n    ", ";\n    box-shadow: ", ";\n"], ["\n    overflow-x: hidden;\n\n    ", ";\n\n    ", ";\n\n    background: ", ";\n    border-radius: ", ";\n    margin-left: ", ";\n    padding: ", ";\n    ", ";\n    box-shadow: ", ";\n"])), function (e) {
      var t;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) ? e.theme.Chat.MessageListItem.FromMe.Bubble : e.theme.Chat.MessageListItem.FromOthers.Bubble;
    }, function (e) {
      var t,
        n = e.theme.tokens.textColors.colorTextWeakest,
        r = e.theme.tokens.textColors.colorTextLink;
      return e.theme.isLight || (n = e.theme.tokens.textColors.colorTextLink, r = e.theme.tokens.textColors.colorText), "\n                    & a {\n                        color: " + ((null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) ? n : r) + ";\n                        text-decoration: underline;\n                    }";
    }, function (e) {
      return "Minimal" === e.messageStyle ? "transparent" : void 0;
    }, function (e) {
      return "Rounded" === e.messageStyle || "Wide" === e.messageStyle ? e.theme.tokens.radii.borderRadius30 : "0px";
    }, function (e) {
      var t;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) && "Minimal" !== e.messageStyle && "Wide" !== e.messageStyle ? "44px" : "0px";
    }, function (e) {
      return "Minimal" === e.messageStyle ? 0 : e.theme.tokens.spacings.space40;
    }, function (e) {
      var t, n;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.error) && (null === (n = e.theme.Chat.MessageListItem.FromMe.Bubble) || void 0 === n ? void 0 : n.disabled);
    }, function (e) {
      var t = e.theme.isLight ? e.theme.tokens.boxShadows.shadowFocus : e.theme.tokens.boxShadows.shadowFocusInverse;
      return e.inFocus ? t : "none";
    }), t.HeaderContainer = (0, v.styled)(h.FlexBox)(i || (i = r(["\n    justify-content: ", ";\n    align-items: center;\n\n    ", ";\n\n    ", ";\n"], ["\n    justify-content: ", ";\n    align-items: center;\n\n    ", ";\n\n    ", ";\n"])), function (e) {
      return "Minimal" === e.messageStyle ? "flex-start" : "space-between";
    }, function (e) {
      var t;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) ? e.theme.Chat.MessageListItem.FromMe.Header : e.theme.Chat.MessageListItem.FromOthers.Header;
    }, function (e) {
      var t, n;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.error) && (null === (n = e.theme.Chat.MessageListItem.FromMe.Header) || void 0 === n ? void 0 : n.disabled);
    }), t.UserNameContainer = (0, v.styled)("div")(a || (a = r(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 0 1 auto;\n    margin-right: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n"], ["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 0 1 auto;\n    margin-right: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }), t.TimeContainer = (0, v.styled)("div")(s || (s = r(["\n    font-size: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    flex: 0 0 auto;\n"], ["\n    font-size: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    flex: 0 0 auto;\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }), t.BodyContainer = (0, v.styled)("div")(l || (l = r(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    overflow-y: hidden;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    font-size: ", ";\n    line-height: ", ";\n"], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    overflow-y: hidden;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    font-size: ", ";\n    line-height: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight20;
    }), t.MediaContainer = (0, v.styled)(h.FlexBox)(c || (c = r(["\n    flex-wrap: wrap;\n    justify-content: space-between;\n"], ["\n    flex-wrap: wrap;\n    justify-content: space-between;\n"]))), t.MediaMessageErrorContainer = (0, v.styled)(t.BodyContainer)(u || (u = r(["\n    font-style: italic;\n"], ["\n    font-style: italic;\n"]))), t.MediaMessageContainer = (0, v.styled)("button")(d || (d = r(["\n    display: flex;\n    align-items: center;\n    border: none;\n    outline: none;\n    text-align: left;\n    justify-content: space-between;\n    cursor: pointer;\n    width: 200px;\n    max-width: calc(100% - ", ");\n    padding: 0;\n    overflow: hidden;\n    margin-top: ", ";\n    &:nth-of-type(odd):not(:only-child) {\n        margin-right: ", ";\n    }\n    border-width: ", ";\n    border-radius: ", ";\n    border-color: ", ';\n    border-style: solid;\n    &[aria-disabled="true"] {\n        cursor: ', ";\n    }\n    ", "\n\n    &:focus-visible {\n        box-shadow: ", ";\n    }\n\n    ", ";\n\n    ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    border: none;\n    outline: none;\n    text-align: left;\n    justify-content: space-between;\n    cursor: pointer;\n    width: 200px;\n    max-width: calc(100% - ", ");\n    padding: 0;\n    overflow: hidden;\n    margin-top: ", ";\n    &:nth-of-type(odd):not(:only-child) {\n        margin-right: ", ";\n    }\n    border-width: ", ";\n    border-radius: ", ";\n    border-color: ", ';\n    border-style: solid;\n    &[aria-disabled="true"] {\n        cursor: ', ";\n    }\n    ", "\n\n    &:focus-visible {\n        box-shadow: ", ";\n    }\n\n    ", ";\n\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius20;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorder;
    }, function (e) {
      var t;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isSending) ? "default" : "not-allowed";
    }, function (e) {
      var t, n, r;
      return !(null === (t = e.message) || void 0 === t ? void 0 : t.error) && "\n    &:hover {\n        " + (0, v.getBackgroundWithHoverCSS)((null === (n = e.message) || void 0 === n ? void 0 : n.isFromMe) ? e.theme.Chat.MessageListItem.FromMe.Media.Container.background : e.theme.Chat.MessageListItem.FromOthers.Media.Container.background, (null === (r = e.message) || void 0 === r ? void 0 : r.isFromMe) ? e.theme.Chat.MessageListItem.FromMe.Media.Container.lightHover : e.theme.Chat.MessageListItem.FromOthers.Media.Container.lightHover, !0) + "\n        .Twilio-Media-MessageBubble-Action {\n            visibility: visible;\n        }\n    }";
    }, function (e) {
      return e.theme.tokens.boxShadows.shadowFocus;
    }, function (e) {
      var t;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) ? e.theme.Chat.MessageListItem.FromMe.Media.Container : e.theme.Chat.MessageListItem.FromOthers.Media.Container;
    }, function (e) {
      var t, n;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.error) && (null === (n = e.theme.Chat.MessageListItem.FromMe.Media.Container) || void 0 === n ? void 0 : n.disabled);
    }), t.MediaMessageActions = (0, v.styled)("div")(f || (f = r(["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    ", "\n"], ["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    ", "\n"])), function (e) {
      var t;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) ? e.theme.Chat.MessageListItem.FromMe.Media.Actions : e.theme.Chat.MessageListItem.FromOthers.Media.Actions;
    }), t.StyledBlockQuote = (0, v.styled)("blockquote")(p || (p = r(['\n    position: relative;\n    padding-left: 8px;\n    margin: 0;\n    font-style: italic;\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        width: 2px;\n        opacity: 0.4;\n        background-color: ', ";\n    }\n"], ['\n    position: relative;\n    padding-left: 8px;\n    margin: 0;\n    font-style: italic;\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        width: 2px;\n        opacity: 0.4;\n        background-color: ', ";\n    }\n"])), function (e) {
      var t = e.theme;
      return e.message.isFromMe ? t.Chat.MessageListItem.FromMe.Bubble.color : t.Chat.MessageListItem.FromOthers.Bubble.color;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputV2 = t.MessageInput = void 0;
    var r = n(476);
    Object.defineProperty(t, "MessageInput", {
      enumerable: !0,
      get: function () {
        return r.MessageInput;
      }
    });
    var o = n(133);
    Object.defineProperty(t, "MessageInputV2", {
      enumerable: !0,
      get: function () {
        return o.MessageInputV2;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageList = void 0;
    var i = n(483);
    Object.defineProperty(t, "MessageList", {
      enumerable: !0,
      get: function () {
        return i.MessageList;
      }
    }), o(n(138), t), o(n(139), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArray || function (e, t, n) {
      if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
      return e.concat(r || Array.prototype.slice.call(t));
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BaseNotificationHandler = void 0;
    var o = n(12),
      i = n(16),
      a = n(3),
      s = n(13),
      l = function () {
        function e() {
          var e = this;
          this.handledNotifications = new Set(), this._enabled = !0, this._filters = [], this.handleNotificationAdded = function (t) {
            a.log.debug('Received "notificationAdded" event with', t), e.shouldProcess(t) && (e.handledNotifications.add(t), e.handleNotification(t));
          }, this.handleNotificationDismissed = function (t) {
            e.handledNotifications.has(t) && (e.handledNotifications.delete(t), e.dismissNotification(t));
          }, s.Notifications.addListener(s.NotificationEvent.notificationAdded, this.handleNotificationAdded), s.Notifications.addListener(s.NotificationEvent.notificationDismissed, this.handleNotificationDismissed);
        }
        return Object.defineProperty(e.prototype, "enabled", {
          get: function () {
            return this._enabled;
          },
          set: function (e) {
            a.log.debug("Notification handler " + this.id + " enabled=" + e), this._enabled = e;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.getFilters = function () {
          return r([], this._filters, !0);
        }, e.prototype.clearFilters = function () {
          a.log.debug("Notification handler " + this.id + " clearFilters"), this._filters = [];
        }, e.prototype.addFilter = function (e) {
          var t = this;
          if ("function" != typeof e) throw o.ErrorManager.createAndProcessError(i.ErrorMessages.NOTIFICATION_INVALID_FILTER, {
            context: "NotificationsFramework"
          });
          return a.log.debug("Adding new filter to " + this.id), this._filters.push(e), function () {
            t._filters = t._filters.filter(function (t) {
              return t !== e;
            });
          };
        }, e.prototype.isFiltered = function (e) {
          return this._filters.length > 0 && this._filters.some(function (t) {
            return !t(e);
          });
        }, e.prototype.shouldProcess = function (e) {
          return !!this.enabled && !!this.canHandleNotification(e) && !this.isFiltered(e);
        }, e;
      }();
    t.BaseNotificationHandler = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ContentContainer = t.Container = void 0;
    var o,
      i,
      a = n(6),
      s = n(1);
    t.Container = (0, s.styled)(a.FlexBoxColumn)(o || (o = r(["\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 12px;\n    width: 100%;\n    ", "\n"], ["\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 12px;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessagingCanvas.Container;
    }), t.ContentContainer = (0, s.styled)(a.FlexBoxColumn)(i || (i = r(["\n    height: 0px;\n    width: 100%;\n    max-width: 640px;\n    align-self: center;\n"], ["\n    height: 0px;\n    width: 100%;\n    max-width: 640px;\n    align-self: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ColumnDefinition = void 0;
    var l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return null;
      }, t;
    }(s(n(0)).Component);
    t.ColumnDefinition = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PREFERENCE_STORE = t.DB_NAME = void 0, t.DB_NAME = "preference-db", t.PREFERENCE_STORE = "preference-store";
    var r = {
      version: 1,
      databaseName: t.DB_NAME,
      type: "PERSISTENCE",
      stores: [{
        name: "preference-store",
        key: "id"
      }]
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      },
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FrameConstants = t.ConvoClientToChatClient = t.FileAttachmentConfig = t.withHOC = t.ComponentWrapper = t.TelemetryBridgeMessageType = t.TelemetryBridge = t.ErrorMessages = t.ErrorManager = t.CountryManager = t.ChatStateCallback = t.ChatModule = t.ChatManager = void 0, i(n(33), t), i(n(23), t), i(n(175), t), i(n(52), t);
    var s = n(28);
    Object.defineProperty(t, "ChatManager", {
      enumerable: !0,
      get: function () {
        return s.ChatManager;
      }
    });
    var l = n(8);
    Object.defineProperty(t, "ChatModule", {
      enumerable: !0,
      get: function () {
        return l.ChatModule;
      }
    }), Object.defineProperty(t, "ChatStateCallback", {
      enumerable: !0,
      get: function () {
        return l.ChatStateCallback;
      }
    }), i(n(180), t), i(n(44), t), i(n(27), t);
    var c = n(59);
    Object.defineProperty(t, "CountryManager", {
      enumerable: !0,
      get: function () {
        return c.CountryManager;
      }
    }), i(n(7), t), i(n(186), t), i(n(94), t);
    var u = n(12);
    Object.defineProperty(t, "ErrorManager", {
      enumerable: !0,
      get: function () {
        return u.ErrorManager;
      }
    });
    var d = n(16);
    Object.defineProperty(t, "ErrorMessages", {
      enumerable: !0,
      get: function () {
        return d.ErrorMessages;
      }
    }), i(n(188), t), i(n(95), t), i(n(13), t), i(n(194), t);
    var f = n(24);
    Object.defineProperty(t, "TelemetryBridge", {
      enumerable: !0,
      get: function () {
        return f.TelemetryBridge;
      }
    }), Object.defineProperty(t, "TelemetryBridgeMessageType", {
      enumerable: !0,
      get: function () {
        return f.TelemetryBridgeMessageType;
      }
    }), i(n(10), t), i(n(9), t), i(n(60), t), i(n(195), t);
    var p = n(196);
    Object.defineProperty(t, "ComponentWrapper", {
      enumerable: !0,
      get: function () {
        return p.ComponentWrapper;
      }
    }), Object.defineProperty(t, "withHOC", {
      enumerable: !0,
      get: function () {
        return p.withHOC;
      }
    }), i(n(198), t);
    var h = n(20);
    Object.defineProperty(t, "FileAttachmentConfig", {
      enumerable: !0,
      get: function () {
        return h.FileAttachmentConfig;
      }
    }), i(n(614), t), i(n(169), t), i(n(618), t);
    var v = n(55);
    Object.defineProperty(t, "ConvoClientToChatClient", {
      enumerable: !0,
      get: function () {
        return v.ConvoClientToChatClient;
      }
    }), i(n(621), t), i(n(626), t), i(n(630), t), i(n(631), t), i(n(633), t), i(n(43), t);
    var m = n(634),
      g = a(n(53));
    t.FrameConstants = g, n(635);
    var b = n(637);
    m.ChatActions.registerActions(), (0, b.registerNotifications)();
  }, function (e, t) {
    e.exports = require("uuid");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AudioErrorCode = void 0, function (e) {
      e[e.NotAllowed = 0] = "NotAllowed", e[e.InvalidMedia = 1] = "InvalidMedia", e[e.Other = 2] = "Other";
    }(t.AudioErrorCode || (t.AudioErrorCode = {}));
  }, function (e, t) {
    e.exports = require("memoize-one");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getChatReducerOptions = t.setChatReducerOptions = void 0;
    var o = {
        hasSupportForChannels: !1
      },
      i = {};
    t.setChatReducerOptions = function (e) {
      return i = r(r({}, o), e);
    };
    t.getChatReducerOptions = function () {
      return i;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reduce = void 0;
    var s = a(n(86)),
      l = n(35),
      c = n(11),
      u = {};
    t.reduce = function (e, t) {
      var n;
      if (void 0 === e && (e = u), t.type === l.ACTION_CHAT_SESSION_UNINIT) return u;
      var o = null === (n = null == t ? void 0 : t.meta) || void 0 === n ? void 0 : n.channelSid;
      if (!o) return e;
      var i = e[o],
        a = s.reduce(i, t);
      if (i !== a) {
        var d = r({}, e);
        switch (t.type) {
          case c.ACTION_UNLOAD_CONVERSATION:
            delete d[o];
            break;
          default:
            d[o] = a;
        }
        return d;
      }
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChannelHelper = t.reduce = void 0;
    var i = n(3),
      a = n(9),
      s = n(11),
      l = n(55),
      c = {
        currentPaginator: void 0,
        inputText: "",
        isLoadingMembers: !1,
        isLoadingMessages: !1,
        isLoadingChannel: !1,
        errorWhileLoadingChannel: !1,
        lastConsumedMessageIndex: 0,
        lastConsumedMessageByCurrentUserIndex: 0,
        listener: void 0,
        members: new Map(),
        unconsumedMessages: [],
        messages: [],
        pendingMessages: [],
        source: void 0,
        typers: []
      };
    function u(e) {
      var t = e.message,
        n = e.nextMessage,
        r = e.previousMessage,
        o = e.identity,
        i = e.channelState,
        a = t.author,
        s = !!n && t.author === n.author,
        l = !!r && t.author === r.author;
      if (i) {
        var c = i && i.members && i.members.get(t.author);
        a = c && c.friendlyName;
      }
      return {
        groupWithNext: s,
        groupWithPrevious: l,
        isFromMe: t.author === o,
        index: t.index,
        source: t,
        authorName: a
      };
    }
    t.reduce = function (e, t) {
      switch (void 0 === e && (e = c), t.type) {
        case s.ACTION_INIT_CONVERSATION:
          var n = t.payload;
          return r(r({}, c), {
            source: (0, l.ConversationToChannel)(n.conversation),
            listener: n.listener
          });
        case s.ACTION_UNLOAD_CONVERSATION:
          return r({}, c);
        case s.ACTION_INIT_CONVERSATION_PARTICIPANTS + "_PENDING":
          return r(r({}, e), {
            isLoadingMembers: !0
          });
        case s.ACTION_INIT_CONVERSATION_PARTICIPANTS + "_FULFILLED":
          var i = t.payload,
            d = new Map(Array.from(i).map(function (e) {
              var t = e[0],
                n = e[1];
              return [t, r(r({}, n), {
                source: (0, l.ParticipantToMember)(n.source)
              })];
            }));
          return r(r({}, e), {
            members: d,
            isLoadingMembers: !1
          });
        case s.ACTION_INIT_CONVERSATION_PARTICIPANTS + "_REJECTED":
          return r(r({}, e), {
            isLoadingMembers: !1
          });
        case s.ACTION_LOAD_CONVERSATION_MESSAGES + "_PENDING":
          return r(r({}, e), {
            isLoadingMessages: !0
          });
        case s.ACTION_LOAD_CONVERSATION_MESSAGES + "_REJECTED":
          return r(r({}, e), {
            isLoadingMessages: !1
          });
        case s.ACTION_LOAD_CONVERSATION_MESSAGES + "_FULFILLED":
          if (!(F = t.meta.chatState) || !F.session.client) return e;
          var f = F.session.client.user.identity,
            p = (0, l.ProxyPaginator)(t.payload, l.ConvoMessageToChatMessage),
            h = p.items.map(function (t) {
              return u({
                message: t,
                identity: f,
                channelState: e
              });
            }),
            v = e.messages.length && e.messages[0];
          if (v && p.items.length && v.index <= p.items[p.items.length - 1].index && v.index >= p.items[0].index) {
            var m = e.messages.filter(function (e) {
              return !h.find(function (t) {
                return t.index === e.index;
              });
            });
            h = h.concat(m);
          } else h = h.concat(e.messages);
          for (var g = 0; g < Math.min(p.items.length + 1, h.length); g++) h[g] = u({
            message: h[g].source,
            identity: f,
            nextMessage: g < h.length - 1 ? h[g + 1].source : void 0,
            previousMessage: g > 0 ? h[g - 1].source : void 0,
            channelState: e
          });
          var b = e.source ? e.source.lastConsumedMessageIndex : 0,
            y = h.filter(function (e) {
              return e.index > b;
            });
          return r(r({}, e), {
            isLoadingMessages: !1,
            currentPaginator: p,
            messages: h,
            lastConsumedMessageByCurrentUserIndex: b,
            unconsumedMessages: y
          });
        case s.ACTION_ADD_PENDING_MEDIA_MESSAGE:
          var _ = t.payload.media,
            O = (F = t.meta.chatState) && F.session.client ? F.session.client.user.identity : "",
            C = e.pendingMessages.length,
            P = C > 0 ? e.pendingMessages[C - 1] : e.messages[e.messages.length - 1],
            M = {
              index: C,
              groupWithNext: !1,
              groupWithPrevious: !!P && P.source.author === O,
              isFromMe: !0,
              isSending: !0,
              source: {
                index: C,
                media: _,
                author: O,
                type: "media",
                sid: null,
                body: null,
                timestamp: new Date(),
                channel: (0, l.ConversationToChannel)(t.payload.conversation)
              }
            };
          return r(r({}, e), {
            pendingMessages: o(o([], e.pendingMessages, !0), [M], !1)
          });
        case s.ACTION_REMOVE_PENDING_MEDIA_MESSAGE:
          var j = t.payload.media;
          return r(r({}, e), {
            pendingMessages: e.pendingMessages.filter(function (e) {
              return e.source.media.sid !== j.sid && e.source.media.filename !== j.filename && e.source.media.contentType !== j.contentType;
            })
          });
        case s.ACTION_MEDIA_MESSAGE_REJECTED:
          var w = t.payload.media;
          return r(r({}, e), {
            pendingMessages: e.pendingMessages.map(function (e) {
              return e.source.media.sid === w.sid ? r(r({}, e), {
                isSending: !1,
                error: !0
              }) : e;
            })
          });
        case s.ACTION_ADDED_MESSAGE:
          if (!(F = t.meta.chatState) || !F.session.client) return e;
          var E = (0, l.ConvoMessageToChatMessage)(t.payload);
          if (e.messages.find(function (e) {
            return e.index === E.index;
          })) return e;
          var S = F.session.client.user.identity,
            x = u({
              message: E,
              identity: S,
              channelState: e
            }),
            T = o(o([], e.messages, !0), [x], !1);
          for (g = Math.max(T.length - 2, 0); g < T.length; g++) T[g] = u({
            message: T[g].source,
            identity: S,
            nextMessage: g < T.length - 1 ? T[g + 1].source : void 0,
            previousMessage: g > 0 ? T[g - 1].source : void 0,
            channelState: e
          });
          var A = F.messageList,
            I = A.activeChatChannel,
            k = A.isScrollToBottom;
          y = void 0;
          y = x.isFromMe ? e.unconsumedMessages : I === (e.source || {}).sid && k ? [] : o(o([], e.unconsumedMessages, !0), [x], !1);
          var N = [];
          return e.pendingMessages.length && (N = e.pendingMessages.map(function (t, n) {
            var o = 0 === n ? x : e.pendingMessages[n - 1];
            return r(r({}, t), {
              groupWithPrevious: t.source.author === o.source.author
            });
          })), r(r({}, e), {
            messages: T,
            unconsumedMessages: y,
            pendingMessages: N
          });
        case s.ACTION_REMOVED_MESSAGE:
          if (!(F = t.meta.chatState) || !F.session.client) return e;
          var B = (0, l.ConvoMessageToChatMessage)(t.payload),
            D = e.messages.findIndex(function (e) {
              return e.index === B.index;
            });
          (T = e.messages.slice()).splice(D, 1);
          for (g = Math.max(0, D - 1); g <= Math.min(D, T.length - 1); g++) T[g] = u({
            message: T[g].source,
            identity: F.session.client.user.identity,
            nextMessage: g < T.length - 1 ? T[g + 1].source : void 0,
            previousMessage: g > 0 ? T[g - 1].source : void 0,
            channelState: e
          });
          return r(r({}, e), {
            messages: T
          });
        case s.ACTION_UPDATED_MESSAGE:
          if (!(F = t.meta.chatState) || !F.session.client) return e;
          var L = (0, l.ConvoMessageToChatMessage)(t.payload);
          D = e.messages.findIndex(function (e) {
            return e.index === L.index;
          });
          return (T = e.messages.slice())[D] = u({
            message: L,
            identity: F.session.client.user.identity,
            nextMessage: D < T.length - 1 ? T[D + 1].source : void 0,
            previousMessage: D > 0 ? T[D - 1].source : void 0,
            channelState: e
          }), r(r({}, e), {
            messages: T
          });
        case s.ACTION_ADDED_PARTICIPANT:
          var z = r(r({}, t.payload), {
            source: (0, l.ParticipantToMember)(t.payload)
          });
          return (q = a.Utils.copyMap(e.members)).set(z.source.identity, z), r(r({}, e), {
            members: q
          });
        case s.ACTION_REMOVED_PARTICIPANT:
          z = t.payload;
          return (q = a.Utils.copyMap(e.members)).delete(z.source.identity) ? r(r({}, e), {
            members: q
          }) : e;
        case s.ACTION_UPDATED_PARTICIPANT:
          var F,
            R = t.payload,
            H = R.lastConsumedMessageIndex;
          if ((F = t.meta.chatState) && F.session.client && R.identity === F.session.client.user.identity) {
            y = [];
            return y = e.messages.find(function (e) {
              return e.index > H;
            }) ? e.unconsumedMessages : [], r(r({}, e), {
              lastConsumedMessageByCurrentUserIndex: H,
              unconsumedMessages: y
            });
          }
          return r(r({}, e), {
            lastConsumedMessageIndex: H
          });
        case s.ACTION_TYPING_STARTED:
          var W = t.payload;
          if (-1 === e.typers.findIndex(function (e) {
            return e.source.identity === W.source.identity;
          })) {
            var U = e.typers.slice();
            return U.push(W), r(r({}, e), {
              typers: U
            });
          }
          return e;
        case s.ACTION_TYPING_ENDED:
          var V = t.payload,
            G = e.typers.filter(function (e) {
              return e.source.identity !== V.source.identity;
            });
          return r(r({}, e), {
            typers: G
          });
        case s.ACTION_USER_UPDATED:
          var q,
            K = (0, l.ConvoUserToChatUser)(t.payload);
          return K && (z = e.members.get(K.identity)) ? ((q = a.Utils.copyMap(e.members)).set(K.identity, function (e, t, n) {
            return {
              friendlyName: t,
              source: e,
              online: n
            };
          }(z.source, K.friendlyName, K.online)), r(r({}, e), {
            members: q
          })) : e;
        case s.ACTION_UPDATE_CONVERSATION:
          return r(r({}, e), t.payload);
        case s.ACTION_LOAD_CONVERSATION + "_PENDING":
          return r(r({}, e), {
            isLoadingChannel: !0,
            errorWhileLoadingChannel: !1
          });
        case s.ACTION_LOAD_CONVERSATION + "_FULFILLED":
          return r(r({}, e), {
            isLoadingChannel: !1,
            errorWhileLoadingChannel: !1
          });
        case s.ACTION_LOAD_CONVERSATION + "_REJECTED":
          return r(r({}, e), {
            isLoadingChannel: !1,
            errorWhileLoadingChannel: !0
          });
        default:
          return e;
      }
    };
    var d = function () {
      function e() {}
      return e.isUserMemberOfChannel = function (e) {
        return i.log.warn("Deprecated method. User ConversationHelper.isUserParticipantOfConversation"), e && e.source && "joined" === e.source.status;
      }, e;
    }();
    t.ChannelHelper = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_CACHE_USERS = void 0;
    var o = n(8),
      i = n(3),
      a = n(11);
    t.ACTION_CACHE_USERS = "CHAT_CACHE_USERS", t.reduce = function (e, n) {
      var o;
      switch (void 0 === e && (e = {}), n.type) {
        case a.ACTION_USER_UPDATED:
          var i = n.payload;
          return r(r({}, e), ((o = {})[i.identity] = i, o));
        case t.ACTION_CACHE_USERS:
          var s = n.payload;
          if (!s || !s.length) return e;
          var l = r({}, e);
          return s.forEach(function (e) {
            l[e.identity] = e;
          }), l;
        default:
          return e;
      }
    };
    var s = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function () {
          return o.ChatModule.dispatch;
        },
        enumerable: !1,
        configurable: !0
      }), e.dispatchCachedUsers = function (e) {
        this.dispatcher({
          type: t.ACTION_CACHE_USERS,
          payload: e
        });
      }, e.fetchUser = function (t) {
        var n = this;
        if (this.userDescriptorRequestCache.has(t)) {
          var r = this.userDescriptorRequestCache.get(t);
          return Promise.resolve(r);
        }
        var a = o.ChatModule.state.session.client;
        return a ? (this.userDescriptorRequestCache.set(t, null), a.getUser(t).then(function (t) {
          return n.userDescriptorRequestCache.set(t.identity, t), e.dispatchCachedUsers([t]), t;
        }).catch(function (e) {
          return i.log.warn("User descriptor could not be retrieved for identity '" + t + "'. " + e), n.userDescriptorRequestCache.delete(t), null;
        })) : Promise.reject(Error("no client"));
      }, e.userDescriptorRequestCache = new Map(), e;
    }();
    t.Actions = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConvoClientToChatClient = t.initBridges = void 0;
    var a,
      s = n(3),
      l = n(89),
      c = n(56),
      u = n(45),
      d = n(34),
      f = n(57),
      p = n(58),
      h = n(39);
    !function (e) {
      e.channelAdded = "conversationAdded", e.channelJoined = "conversationJoined", e.channelLeft = "conversationLeft", e.channelRemoved = "conversationRemoved", e.channelUpdated = "conversationUpdated", e.memberJoined = "participantJoined", e.memberLeft = "participantLeft", e.memberUpdated = "participantUpdated";
    }(a || (a = {}));
    var v = function (e, n) {
        var r,
          o = e[0],
          d = e[1],
          p = e.slice(2),
          h = a[o],
          v = n;
        if (h && s.log.warn('"' + o + '" event is now deprecated. Please use "' + h + '" instead.'), ["channelAdded", "channelJoined", "channelLeft", "channelRemoved"].includes(o)) {
          var m = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            var r = (0, l.ConversationToChannel)(e);
            d.apply(void 0, i([r], t, !1));
          };
          r = v.apply(void 0, i([o.replace("channel", "conversation"), m], p, !1));
        } else if (["channelUpdated"].includes(o)) r = (0, l.proxyOnConversationUpdated)(v, o.replace("channel", "conversation"), d, p);else if (["channelInvited"].includes(o)) s.log.warn("'channelInvited' event is deprecated in Conversations SDK."), r = v();else if (["messageAdded", "messageRemoved"].includes(o)) {
          m = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            var r = (0, c.ConvoMessageToChatMessage)(e);
            d.apply(void 0, i([r], t, !1));
          };
          r = v.apply(void 0, i([o, m], p, !1));
        } else if (["messageUpdated"].includes(o)) r = (0, c.proxyOnMessageUpdated)(v, o, d, p);else if (["typingEnded", "typingStarted"].includes(o)) {
          m = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            var r = (0, f.ParticipantToMember)(e);
            d.apply(void 0, i([o, r], t, !1));
          };
          r = v.apply(void 0, i([o, m], p, !1));
        } else if (["userSubscribed", "userUnsubscribed"].includes(o)) {
          m = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            var r = (0, f.ParticipantToMember)(e);
            d.apply(void 0, i([o, r], t, !1));
          };
          r = v.apply(void 0, i([o, m], p, !1));
        } else if ("userUpdated" === o) r = (0, u.proxyOnUserUpdated)(v, o, d, p);else if (["memberJoined", "memberLeft"].includes(o)) {
          m = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            var r = (0, f.ParticipantToMember)(e);
            d.apply(void 0, i([r], t, !1));
          };
          r = v.apply(void 0, i([o.replace("member", "participant"), m], p, !1));
        } else r = "memberUpdated" === o ? (0, f.proxyOnParticipantUpdated)(v, "participantUpdated", d, p) : v();
        return (0, t.ConvoClientToChatClient)(r);
      },
      m = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          var t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return (0, h.logDeprecated)("channel.getUserDescriptor", "conversation.getUser"), [4, n.getUser.apply(n, e)];
              case 1:
                return t = r.sent(), [2, (0, u.ConvoUserToChatUser)(t)];
            }
          });
        });
      },
      g = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          var t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return (0, h.logDeprecated)("getChannelBySid", "getConversationBySid"), [4, n.getConversationBySid.apply(n, e)];
              case 1:
                return t = r.sent(), [2, (0, l.ConversationToChannel)(t)];
            }
          });
        });
      },
      b = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          var t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return (0, h.logDeprecated)("getChannelByUniqueName", "getConversationByUniqueName"), [4, n.getConversationByUniqueName.apply(n, e)];
              case 1:
                return t = r.sent(), [2, (0, l.ConversationToChannel)(t)];
            }
          });
        });
      },
      y = function () {
        return s.log.warn("'client.getLocalChannels' is not supported anymore in Conversations SDK. "), [];
      },
      _ = function (e) {
        return function (t, n, i) {
          return r(void 0, void 0, void 0, function () {
            var t;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return (0, h.logDeprecated)(e, "getSubscribedConversations"), [4, i.getSubscribedConversations()];
                case 1:
                  return t = n.sent(), [2, (0, p.ProxyPaginator)(t, l.ConversationToChannel)];
              }
            });
          });
        };
      },
      O = !1;
    t.initBridges = function () {
      return !O && ((0, f.setConversationTransformer)(l.ConversationToChannel), (0, c.setTransformers)(l.ConversationToChannel, f.ParticipantToMember), O = !0);
    };
    t.ConvoClientToChatClient = function (e) {
      return (0, d.createNewProxy)(e, {
        addListener: ["method", v],
        getChannelBySid: ["method", g],
        getChannelByUniqueName: ["method", b],
        getLocalChannels: ["method", y],
        getPublicChannelDescriptors: ["method", _("getPublicChannelDescriptors")],
        getSubscribedChannels: ["method", _("getSubscribedChannels")],
        getSubscribedUsers: ["method", (0, h.wrapOriginalMethodPromiseResults)(u.ConvoUserToChatUser)],
        getUser: ["method", (0, h.wrapOriginalMethodPromiseResults)(u.ConvoUserToChatUser)],
        getUserDescriptor: ["method", m],
        getUserChannelDescriptors: ["method", function () {
          s.log.warn('"getUserChannelDescriptors" is not supported anymore in ConversationsSDK');
        }]
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConversationToChannel = t.proxyOnConversationUpdated = void 0;
    var a,
      s = n(3),
      l = n(56),
      c = n(45),
      u = n(34),
      d = n(57),
      f = n(58),
      p = n(39),
      h = function () {
        return s.log.warn("Method deprecated. All Conversations are going to be marked as 'private'"), !0;
      },
      v = function () {
        return s.log.warn("Method deprecated. All Conversations are going to be marked as 'private'"), "private";
      },
      m = function (e, t) {
        return (0, p.logDeprecated)("lastConsumedMessageIndex", "lastReadMessageIndex"), t.lastReadMessageIndex;
      },
      g = function (e) {
        return function (t, n, i) {
          return r(void 0, void 0, void 0, function () {
            var n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return (0, p.logDeprecated)("getMemberBy" + e, "getParticipantBy" + e), "Identity" !== e ? [3, 2] : [4, i.getParticipantByIdentity.apply(i, t)];
                case 1:
                  return n = r.sent(), [3, 4];
                case 2:
                  return [4, i.getParticipantBySid.apply(i, t)];
                case 3:
                  n = r.sent(), r.label = 4;
                case 4:
                  return [2, (0, d.ParticipantToMember)(n)];
              }
            });
          });
        };
      },
      b = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return (0, p.logDeprecated)("getMembers", "getParticipants"), [4, n.getParticipants()];
              case 1:
                return [2, e.sent().map(d.ParticipantToMember)];
            }
          });
        });
      },
      y = function (e, t, n) {
        return r(void 0, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return (0, p.logDeprecated)("getUserDescriptors", "N/A"), [4, n.getParticipants()];
              case 1:
                return e = t.sent(), [4, Promise.all(e.map(function (e) {
                  return r(void 0, void 0, void 0, function () {
                    return o(this, function (t) {
                      return [2, e.getUser()];
                    });
                  });
                }))];
              case 2:
                return [2, t.sent().map(c.ConvoUserToChatUser)];
            }
          });
        });
      };
    !function (e) {
      e.memberJoined = "participantJoined", e.memberLeft = "participantLeft", e.memberUpdated = "participantUpdated";
    }(a || (a = {}));
    t.proxyOnConversationUpdated = function (e, n, r, o) {
      return e.apply(void 0, i([n, function (e) {
        for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
        r.apply(void 0, i([{
          channel: (0, t.ConversationToChannel)(e.conversation),
          updateReasons: e.updateReasons.map(function (e) {
            return e.replace("lastReadMessageIndex", "lastConsumedMessageIndex");
          })
        }], n, !1));
      }], o, !1));
    };
    var _ = function (e, n) {
      var r,
        o = e[0],
        c = e[1],
        u = e.slice(2),
        f = a[o],
        p = n;
      if (f && s.log.warn('"' + o + '" event is now deprecated. Please use "' + f + '" instead.'), ["messageAdded", "messageRemoved", "messageUpdated"].includes(o)) {
        var h = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          var r = (0, l.ConvoMessageToChatMessage)(e);
          c.apply(void 0, i([r], t, !1));
        };
        r = p.apply(void 0, i([o, h], u, !1));
      } else if (["memberJoined", "memberLeft"].includes(o)) {
        h = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          var r = (0, d.ParticipantToMember)(e);
          c.apply(void 0, i([r], t, !1));
        };
        r = p.apply(void 0, i([o.replace("member", "participant"), h], u, !1));
      } else if ("memberUpdated" === o) r = (0, d.proxyOnParticipantUpdated)(p, "participantUpdated", c, u);else if ("removed" === o) {
        h = function (e) {
          for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
          var a = (0, t.ConversationToChannel)(e);
          c.apply(void 0, i([o, a], n, !1));
        };
        r = p.apply(void 0, i([o, h], u, !1));
      } else if (["typingEnded", "typingStarted"].includes(o)) {
        h = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          var r = (0, d.ParticipantToMember)(e);
          c.apply(void 0, i([o, r], t, !1));
        };
        r = p.apply(void 0, i([o, h], u, !1));
      } else r = "updated" === o ? (0, t.proxyOnConversationUpdated)(p, o, c, u) : p();
      return (0, t.ConversationToChannel)(r);
    };
    t.ConversationToChannel = function (e) {
      return (0, u.createNewProxy)(e, {
        isPrivate: ["property", h],
        lastConsumedMessageIndex: ["property", m],
        type: ["property", v],
        advanceLastConsumedMessageIndex: ["method", (0, p.mapOldMethodToNew)("advanceLastConsumedMessageIndex", "advanceLastReadMessageIndex")],
        getMemberByIdentity: ["method", g("Identity")],
        getMemberBySid: ["method", g("Sid")],
        getMembers: ["method", b],
        getMembersCount: ["method", (0, p.mapOldMethodToNew)("getMembersCount", "getParticipantsCount")],
        getUnconsumedMessages: ["method", (0, p.mapOldMethodToNew)("getUnconsumedMessages", "getUnreadMessagesCount")],
        removeMember: ["method", (0, p.mapOldMethodToNew)("removeMember", "removeParticipant")],
        setAllMessagesConsumed: ["method", (0, p.mapOldMethodToNew)("setAllMessagesConsumed", "setAllMessagesRead")],
        setNoMessagesConsumed: ["method", (0, p.mapOldMethodToNew)("setNoMessagesConsumed", "setAllMessagesUnread")],
        updateLastConsumedMessageIndex: ["method", (0, p.mapOldMethodToNew)("updateLastConsumedMessageIndex", "updateLastReadMessageIndex")],
        getUserDescriptors: ["method", y],
        invite: ["method", (0, p.mapOldMethodToNew)("invite", "add")],
        delete: ["method", (0, p.wrapOriginalMethodPromiseResults)(t.ConversationToChannel)],
        join: ["method", (0, p.wrapOriginalMethodPromiseResults)(t.ConversationToChannel)],
        leave: ["method", (0, p.wrapOriginalMethodPromiseResults)(t.ConversationToChannel)],
        updateAttributes: ["method", (0, p.wrapOriginalMethodPromiseResults)(t.ConversationToChannel)],
        updateFriendlyName: ["method", (0, p.wrapOriginalMethodPromiseResults)(t.ConversationToChannel)],
        updateUniqueName: ["method", (0, p.wrapOriginalMethodPromiseResults)(t.ConversationToChannel)],
        getMessages: ["method", (0, p.wrapOriginalMethodPromiseResults)(f.ProxyPaginator, [l.ConvoMessageToChatMessage])],
        addListener: ["method", _]
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_CHANGE_CONVERSATION = t.ACTION_CHANGE_SCROLL_POSITION = void 0;
    var o = n(8);
    t.ACTION_CHANGE_SCROLL_POSITION = "CHAT_CHANGE_SCROLL_POSITION", t.ACTION_CHANGE_CONVERSATION = "CHAT_CHANGE_CONVERSATION";
    var i = {
      isScrollToBottom: !1,
      activeChatChannel: "",
      activeConversation: ""
    };
    t.reduce = function (e, n) {
      switch (void 0 === e && (e = i), n.type) {
        case t.ACTION_CHANGE_SCROLL_POSITION:
          return r(r({}, e), {
            isScrollToBottom: n.payload
          });
        case t.ACTION_CHANGE_CONVERSATION:
          return r(r({}, e), {
            activeChatChannel: n.payload,
            activeConversation: n.payload
          });
        default:
          return e;
      }
    };
    var a = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function () {
          return o.ChatModule.dispatch;
        },
        enumerable: !1,
        configurable: !0
      }), e.updateScrollPosition = function (e) {
        o.ChatModule.dispatch({
          type: t.ACTION_CHANGE_SCROLL_POSITION,
          payload: e
        });
      }, e.updateActiveConversation = function (e) {
        var n = o.ChatModule.state.messageList,
          r = n.activeChatChannel;
        n.activeConversation !== e && r !== e && o.ChatModule.dispatch({
          type: t.ACTION_CHANGE_CONVERSATION,
          payload: e
        });
      }, e;
    }();
    t.Actions = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reduce = void 0;
    var s = a(n(35)),
      l = a(n(11)),
      c = {};
    t.reduce = function (e, t) {
      var n;
      if (void 0 === e && (e = c), t.type === s.ACTION_CHAT_SESSION_UNINIT) return c;
      var o = null === (n = null == t ? void 0 : t.meta) || void 0 === n ? void 0 : n.conversationSid;
      if (!o) return e;
      var i = e[o],
        a = l.reduce(i, t);
      if (i !== a) {
        var u = r({}, e);
        switch (t.type) {
          case l.ACTION_UNLOAD_CONVERSATION:
            delete u[o];
            break;
          default:
            u[o] = a;
        }
        return u;
      }
      return e;
    };
  }, function (e, t) {
    e.exports = require("lodash.isequal");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexBox = void 0;
    var l = n(5),
      c = s(n(0)),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = t.css(this.props);
          return c.createElement("div", {
            className: e
          }, this.props.children);
        }, t.css = function (e) {
          void 0 === e && (e = {});
          var t = e.className,
            n = void 0 === t ? "" : t,
            r = e.noGrow,
            o = void 0 !== r && r,
            i = e.vertical,
            a = void 0 !== i && i,
            s = e.noShrink,
            c = void 0 !== s && s,
            u = e.allowWrap,
            d = void 0 !== u && u,
            f = e.overflow,
            p = void 0 === f ? void 0 : f;
          return (0, l.cx)(n, (0, l.css)({
            display: "flex",
            flexWrap: d ? "wrap" : "nowrap",
            flexGrow: o ? 0 : 1,
            flexShrink: c ? 0 : 1,
            flexDirection: a ? "column" : "row",
            overflowX: "hidden" === p ? "hidden" : void 0
          }));
        }, t;
      }(c.PureComponent);
    t.FlexBox = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailDraftHelper = void 0;
    var a = n(27),
      s = n(12),
      l = n(16),
      c = i(n(187)),
      u = function () {
        function e(e) {
          this.emailDraftStorage = new c.default(c.StorageType.SESSION, e), this.conversationSid = e;
        }
        return e.prototype.saveDraft = function (t) {
          try {
            this.emailDraftStorage.add(t);
            var n = e.savedConversationSidsStorage.get() || [];
            n.includes(this.conversationSid) || (n.push(this.conversationSid), e.savedConversationSidsStorage.add(n));
          } catch (t) {
            e.handleError(t, l.ErrorMessages.EMAIL_DRAFT_UNABLE_TO_SAVE);
          }
        }, e.prototype.retrieveDraft = function () {
          try {
            return this.emailDraftStorage.get();
          } catch (t) {
            return e.handleError(t, l.ErrorMessages.EMAIL_DRAFT_UNABLE_TO_RETRIEVE), null;
          }
        }, e.prototype.deleteDraft = function () {
          var t = this;
          this.emailDraftStorage.remove();
          var n = e.savedConversationSidsStorage.get() || [],
            r = null == n ? void 0 : n.filter(function (e) {
              return e !== t.conversationSid;
            });
          e.savedConversationSidsStorage.add(r);
        }, e.removeDraftsOnLogout = function () {
          var t = e.savedConversationSidsStorage.get();
          t && t.length > 0 && t.forEach(function (t) {
            e.savedConversationSidsStorage.remove(t);
          }), e.savedConversationSidsStorage.remove();
        }, e.handleError = function (e, t) {
          s.ErrorManager.createAndProcessError(t, {
            type: a.CoreErrorType.app,
            context: this.ErrorContext,
            wrappedError: e
          });
        }, e.ErrorContext = "EmailDraft", e.SAVED_CONVERSATIONS_KEY = "twilio_flex_email_saved_drafts", e.savedConversationSidsStorage = new c.default(c.StorageType.SESSION, e.SAVED_CONVERSATIONS_KEY), e;
      }();
    t.EmailDraftHelper = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Markdown = void 0;
    var r = n(192);
    Object.defineProperty(t, "Markdown", {
      enumerable: !0,
      get: function () {
        return r.Markdown;
      }
    });
  }, function (e, t) {
    e.exports = require("hoist-non-react-statics");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AriaLive = void 0, function (e) {
      e.Off = "off", e.Polite = "polite", e.Assertive = "assertive";
    }(t.AriaLive || (t.AriaLive = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M15.887 10.203a.626.626 0 01.922 0 .723.723 0 010 .979l-4.35 4.615a.626.626 0 01-.923 0l-4.345-4.61a.723.723 0 010-.978.626.626 0 01.922 0l3.884 4.12 3.89-4.126z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M8.113 14.797a.626.626 0 01-.922 0 .723.723 0 010-.979l4.35-4.615a.626.626 0 01.923 0l4.345 4.61a.723.723 0 010 .978.626.626 0 01-.922 0l-3.884-4.12-3.89 4.126z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      s = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      l = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && s(t, e, n);
        return l(t, e), t;
      },
      u = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      },
      d = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Button = void 0;
    var f,
      p = n(5),
      h = d(n(400)),
      v = n(26),
      m = c(n(0)),
      g = n(1),
      b = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this.props,
            n = t.className,
            r = t.disabled,
            o = (t.roundCorners, t.themeOverride),
            s = t.children,
            l = t.variant,
            c = t.startIcon,
            d = t.endIcon,
            v = t.fullWidth,
            g = t.theme,
            b = t.classes,
            y = t.onClick,
            _ = u(t, ["className", "disabled", "roundCorners", "themeOverride", "children", "variant", "startIcon", "endIcon", "fullWidth", "theme", "classes", "onClick"]),
            O = (0, p.css)(f || (f = i(["\n            &:disabled {\n                background: ", ";\n            }\n            ", "\n            ", "\n        "], ["\n            &:disabled {\n                background: ", ";\n            }\n            ", "\n            ", "\n        "])), (null == o ? void 0 : o.disabledColor) || (null === (e = g.Button) || void 0 === e ? void 0 : e.disabledColor), g.Button, o),
            C = ["success", "destructive", "link"].includes(l) ? "default" : l;
          return m.createElement(h.default, a({
            variant: "contained",
            color: C,
            className: (0, p.cx)("Twilio-Button", "success" === l && (null == b ? void 0 : b.successVariant), "destructive" === l && (null == b ? void 0 : b.destructiveVariant), "link" === l && (null == b ? void 0 : b.linkVariant), O, n),
            "aria-disabled": r,
            onClick: function (e) {
              r || y && y(e);
            },
            startIcon: c,
            endIcon: d,
            fullWidth: v
          }, _), s);
        }, t.displayName = "Button", t.defaultProps = {
          className: "",
          disabled: !1,
          roundCorners: !0,
          themeOverride: {},
          variant: "default",
          size: "medium",
          fullWidth: !1
        }, t;
      }(m.PureComponent);
    t.Button = (0, g.withTheme)((0, v.withStyles)(function (e) {
      return {
        successVariant: {
          background: e.tokens.backgroundColors.colorBackgroundSuccess,
          color: e.tokens.textColors.colorTextWeakest,
          borderColor: e.tokens.borderColors.colorBorderSuccess,
          "&:hover": {
            borderColor: e.tokens.borderColors.colorBorderPrimaryStronger,
            background: e.tokens.backgroundColors.colorBackgroundSuccessStronger
          },
          "&:active": {
            background: e.tokens.backgroundColors.colorBackgroundSuccessStrong,
            borderColor: e.tokens.borderColors.colorBorderPrimaryStronger
          },
          "&:disabled": {
            background: e.tokens.backgroundColors.colorBackgroundSuccess,
            borderColor: e.tokens.borderColors.colorBorderSuccess,
            color: e.tokens.textColors.colorTextWeakest
          }
        },
        destructiveVariant: {
          background: e.tokens.backgroundColors.colorBackgroundDestructive,
          color: e.tokens.textColors.colorTextWeakest,
          borderColor: e.tokens.borderColors.colorBorderDestructive,
          "&:hover": {
            borderColor: e.tokens.borderColors.colorBorderDestructiveStronger,
            background: e.tokens.backgroundColors.colorBackgroundDestructiveStronger
          },
          "&:active": {
            background: e.tokens.backgroundColors.colorBackgroundDestructiveStrong,
            borderColor: e.tokens.borderColors.colorBorderDestructiveStronger
          },
          "&:disabled": {
            background: e.tokens.backgroundColors.colorBackgroundDestructive,
            borderColor: e.tokens.borderColors.colorBorderDestructive,
            color: e.tokens.textColors.colorTextWeakest
          }
        },
        linkVariant: {
          background: "none",
          color: e.tokens.textColors.colorTextLink,
          borderColor: "transparent",
          fontWeight: e.tokens.fontWeights.fontWeightBold,
          minWidth: 0,
          "&:hover": {
            borderColor: "transparent",
            background: "none",
            color: e.tokens.textColors.colorTextLinkStrong
          },
          "&:active": {
            background: "none",
            borderColor: "transparent",
            color: e.tokens.textColors.colorTextLinkStrong
          },
          "&:disabled": {
            background: "none",
            borderColor: "transparent",
            color: e.tokens.textColors.colorTextLink
          }
        }
      };
    })(b));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailEditor = void 0;
    var a = i(n(0)),
      s = n(30),
      l = n(8),
      c = n(7),
      u = n(46),
      d = n(10),
      f = n(2),
      p = n(102),
      h = n(410),
      v = n(411),
      m = n(64);
    t.EmailEditor = Object.assign((0, s.connect)(function (e, t) {
      return {
        conversation: l.ChatModule.stateCallback(e).conversations[t.conversationSid],
        connectionState: l.ChatModule.stateCallback(e).session.connectionState,
        messageState: l.ChatModule.stateCallback(e).conversationInput[t.conversationSid]
      };
    })(function (e) {
      var n = e.conversation,
        r = e.messageState;
      return a.useEffect(function () {
        n.currentPaginator && !n.messages.length && u.Actions.toggleReplyStateActivation(n, !0);
      }, [n]), e.disabledReason ? null : r.isReplyModeActive ? a.createElement(c.DynamicComponent, {
        contentStore: t.EmailEditor.Content,
        name: t.EmailEditor.displayName,
        noContainers: !0,
        childProps: e,
        rootContainerStyles: "\n                overflow: visible;\n                min-width: 0;\n            "
      }, a.createElement(h.Wrapper, null, a.createElement(p.EmailAccordion, {
        key: "email-editor-accordion",
        defaultOpen: !0,
        header: a.createElement(h.Title, null, a.createElement(d.Template, {
          source: f.templates.EmailEditorTitle
        })),
        body: a.createElement(v.EmailEditorBody, {
          disabledReason: e.disabledReason,
          participants: e.participants,
          conversation: e.conversation,
          conversationSid: e.conversationSid,
          messageState: e.messageState,
          connectionState: e.connectionState
        }),
        accordionId: e.conversationSid,
        strongBackgroundHeader: !0
      }))) : a.createElement(m.Reply, {
        size: "small",
        variant: "primary",
        onClick: function () {
          return u.Actions.toggleReplyStateActivation(n, !0);
        },
        id: "email-reply-button"
      }, a.createElement(d.Template, {
        source: f.templates.EmailEditorReply
      }));
    }), {
      displayName: "EmailEditor",
      Content: new c.DynamicContentStore("EmailEditor")
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailAccordion = void 0;
    var r = n(405);
    Object.defineProperty(t, "EmailAccordion", {
      enumerable: !0,
      get: function () {
        return r.EmailAccordion;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.useStateRef = void 0;
    var a = i(n(0));
    t.useStateRef = function (e) {
      var t = a.useState(e),
        n = t[0],
        r = t[1],
        o = a.useRef(n);
      return {
        state: n,
        dispatch: a.useCallback(function (e) {
          o.current = "function" == typeof e ? e(o.current) : e, r(o.current);
        }, []),
        ref: o
      };
    };
  }, function (e, t) {
    e.exports = require("@udecode/plate-html-serializer");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RemoveFileButton = t.FileBox = t.FileBoxContainer = t.TextAreaInnerContainer = t.CharLimit = t.TextAreaContainer = t.TextArea = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      d = n(6),
      f = n(15),
      p = n(1);
    t.TextArea = (0, p.styled)("textarea")(o || (o = r(["\n    min-height: ", ";\n    ", ";\n    display: block;\n    border: 0;\n    font-family: ", ";\n    width: 100%;\n    resize: none;\n    outline: none;\n    box-sizing: border-box;\n    padding-left: ", ";\n    padding-right: ", ";\n    overflow-x: hidden;\n    overflow-y: auto;\n    ", ';\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        caret-color: transparent;\n        cursor: not-allowed;\n        background-color: ', ";\n    }\n    ", "\n"], ["\n    min-height: ", ";\n    ", ";\n    display: block;\n    border: 0;\n    font-family: ", ";\n    width: 100%;\n    resize: none;\n    outline: none;\n    box-sizing: border-box;\n    padding-left: ", ";\n    padding-right: ", ";\n    overflow-x: hidden;\n    overflow-y: auto;\n    ", ';\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        caret-color: transparent;\n        cursor: not-allowed;\n        background-color: ', ";\n    }\n    ", "\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare100;
    }, function (e) {
      var t = e.theme.tokens.lineHeights.lineHeight20,
        n = e.theme.tokens.spacings.space30,
        r = e.theme.tokens.spacings.space30;
      return "\n        max-height: " + ((0 !== t ? 16 * parseFloat(t.match(/[\d\\.]+/)[0]) * 6 : 0) + (0 !== n ? 16 * parseInt(n, 10) : 0) + (0 !== r ? 16 * parseInt(r, 10) : 0)) + "px;\n        font-size: " + e.theme.tokens.fontSizes.fontSize30 + ";\n        line-height: " + t + ";\n        padding-top: " + n + ";\n        padding-bottom: " + r + ";\n        ";
    }, function (e) {
      return e.theme.tokens.fonts.fontFamilyText;
    }, function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "0px";
    }, function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "4px";
    }, function (e) {
      return e.theme.Chat.MessageInput.Container;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackground;
    }, function (e) {
      return !e.legacy && '\n        :: placeholder {\n            font-style: "italic";\n        }\n    ';
    }), t.TextAreaContainer = (0, p.styled)("div")(i || (i = r(["\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    ", ";\n    background: ", ";\n    ", "\n"], ["\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    ", ";\n    background: ", ";\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageInput.Container;
    }, function (e) {
      return "Bubble" === e.areaStyle ? void 0 : "transparent";
    }, function (e) {
      return !e.legacy && e.showFocus && "\n        box-shadow: " + e.theme.tokens.boxShadows.shadowFocus + ";\n        border-radius: " + e.theme.tokens.radii.borderRadius20 + ";\n    ";
    }), t.CharLimit = (0, p.styled)("p")(a || (a = r(["\n    padding-bottom: 8px;\n    padding-left: ", ";\n    padding-right: ", ";\n    text-align: left;\n    color: ", ";\n"], ["\n    padding-bottom: 8px;\n    padding-left: ", ";\n    padding-right: ", ";\n    text-align: left;\n    color: ", ";\n"])), function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "0px";
    }, function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "4px";
    }, function (e) {
      return e.inputTextLength >= .9 * e.charLimit ? e.theme.tokens.textColors.colorTextError : e.theme.tokens.textColors.colorTextErrorWeak;
    }), t.TextAreaInnerContainer = (0, p.styled)("div")(s || (s = r(["\n    flex-grow: 1;\n    min-width: 0;\n"], ["\n    flex-grow: 1;\n    min-width: 0;\n"]))), t.FileBoxContainer = (0, p.styled)(d.FlexBox)(l || (l = r(["\n    flex-wrap: wrap;\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    margin-top: ", ";\n"], ["\n    flex-wrap: wrap;\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    margin-top: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.legacy ? e.theme.tokens.spacings.space0 : e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.legacy ? e.theme.tokens.spacings.space0 : e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.legacy ? e.theme.tokens.spacings.space0 : e.theme.tokens.spacings.space20;
    }), t.FileBox = (0, p.styled)(d.FlexBox)(c || (c = r(["\n    margin-left: ", ";\n    margin-top: ", ";\n    max-width: 204px;\n    flex-basis: 204px;\n    justify-content: space-between;\n    border-width: ", ";\n    border-style: solid;\n    border-radius: ", ";\n    ", ";\n"], ["\n    margin-left: ", ";\n    margin-top: ", ";\n    max-width: 204px;\n    flex-basis: 204px;\n    justify-content: space-between;\n    border-width: ", ";\n    border-style: solid;\n    border-radius: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius20;
    }, function (e) {
      return e.theme.Chat.MessageInput.FileBox;
    }), t.RemoveFileButton = (0, p.styled)(f.IconButton, {
      shouldForwardProp: function (e) {
        return "legacy" !== e;
      }
    })(u || (u = r(["\n    align-self: ", ";\n    flex-shrink: 0;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    &:focus-visible {\n        border-width: ", ";\n        border-style: solid;\n        border-color: ", ";\n    }\n    ", "\n"], ["\n    align-self: ", ";\n    flex-shrink: 0;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    &:focus-visible {\n        border-width: ", ";\n        border-style: solid;\n        border-color: ", ";\n    }\n    ", "\n"])), function (e) {
      return e.legacy ? "flex-start" : "center";
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return !e.legacy && "\n        width: 20px;\n        height: 20px;\n        margin: " + e.theme.tokens.spacings.space40 + ";\n        border-radius: " + e.theme.tokens.radii.borderRadius0 + ";\n        color: " + e.theme.tokens.textColors.colorTextIcon + ";\n        &:focus-visible {\n            border: none;\n            box-shadow: " + e.theme.tokens.boxShadows.shadowFocus + ";\n            background-color: " + e.theme.tokens.backgroundColors.colorBackgroundNeutralWeakest + ";\n            color: " + e.theme.tokens.textColors.colorTextLinkStronger + ';\n        }\n        &:hover[aria-disabled="false"] {\n            color: ' + e.theme.tokens.textColors.colorTextLinkStronger + ';\n        }\n        &[aria-disabled="true"] {\n            opacity: 0.4;\n            cursor: not-allowed;\n        }\n    ';
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ParticipantLevelType = void 0, function (e) {
      e.to = "to", e.cc = "cc";
    }(t.ParticipantLevelType || (t.ParticipantLevelType = {}));
  }, function (e, t) {
    e.exports = require("@twilio-paste/core/anchor");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CloseButton = t.Tile = t.StyledChipInput = void 0;
    var i,
      a,
      s = o(n(14)),
      l = n(26),
      c = o(n(420)),
      u = n(15),
      d = n(41);
    t.StyledChipInput = (0, l.withStyles)(function (e) {
      var t = e.tokens.spacings,
        n = e.Chat.EmailEditor;
      return d({
        root: {
          width: "100%"
        },
        inputRoot: {
          border: "none",
          "&:focus-within": {
            minWidth: "100%"
          },
          "&.Mui-focused": {
            border: "none",
            boxShadow: "none"
          }
        },
        chipContainer: {
          marginBottom: 0,
          alignItems: "center"
        },
        label: {
          paddingLeft: t.space10,
          paddingRight: t.space10
        }
      }, n.ChipInput);
    })(c.default), t.Tile = s.default.div(i || (i = r(["\n    padding: ", ";\n    background: ", ";\n    border-radius: ", ";\n    height: ", ";\n    margin: ", ";\n\n    display: flex;\n    min-width: 0;\n    align-items: center;\n\n    > span {\n        display: block;\n        color: ", ";\n        font-size: ", ";\n        font-weight: ", ";\n        padding-bottom: 1px;\n        flex: 1 0 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", ";\n"], ["\n    padding: ", ";\n    background: ", ";\n    border-radius: ", ";\n    height: ", ";\n    margin: ", ";\n\n    display: flex;\n    min-width: 0;\n    align-items: center;\n\n    > span {\n        display: block;\n        color: ", ";\n        font-size: ", ";\n        font-weight: ", ";\n        padding-bottom: 1px;\n        flex: 1 0 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", ";\n"])), function (e) {
      return "0 " + e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackground;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight40;
    }, function (e) {
      return e.theme.tokens.spacings.space20 + " 0 " + e.theme.tokens.spacings.space20 + " " + e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightSemibold;
    }, function (e) {
      return e.theme.Chat.EmailEditor.ChipInputTile;
    }), t.CloseButton = (0, s.default)(u.IconButton)(a || (a = r(["\n    margin: ", ";\n    display: inline-flex;\n    width: ", ";\n    height: ", ";\n    background-color: transparent;\n    color: ", ";\n\n    svg {\n        margin-top: 1px;\n    }\n\n    ", ";\n"], ["\n    margin: ", ";\n    display: inline-flex;\n    width: ", ";\n    height: ", ";\n    background-color: transparent;\n    color: ", ";\n\n    svg {\n        margin-top: 1px;\n    }\n\n    ", ";\n"])), function (e) {
      return "0 -" + e.theme.tokens.spacings.space30 + " 0 0";
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight40;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight40;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.theme.Chat.EmailEditor.ChipInputCloseButton;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HTMLEditor = t.MIN_HEIGHT_VALUE = void 0;
    var i = n(29),
      a = n(65),
      s = n(110),
      l = n(111),
      c = n(18),
      u = n(112),
      d = n(104),
      f = n(113),
      p = n(49),
      h = n(50),
      v = n(66),
      m = n(67),
      g = n(422),
      b = o(n(0)),
      y = n(1),
      _ = n(423),
      O = n(425),
      C = n(426),
      P = n(427),
      M = n(428),
      j = n(429),
      w = n(431),
      E = n(434),
      S = n(68);
    t.MIN_HEIGHT_VALUE = 160;
    var x = [v.ELEMENT_PARAGRAPH, u.ELEMENT_H1, h.ELEMENT_UL, h.ELEMENT_OL, h.ELEMENT_LI, u.ELEMENT_H3, u.ELEMENT_H2, u.ELEMENT_H4, u.ELEMENT_H5, u.ELEMENT_H6, m.ELEMENT_TABLE, m.ELEMENT_TD, m.ELEMENT_TR, m.ELEMENT_TH, S.ELEMENT_SPAN, p.ELEMENT_LINK],
      T = ((r = {})[a.MARK_BOLD] = (0, P.getPluginComponent)("strong"), r[a.MARK_ITALIC] = (0, P.getPluginComponent)("em"), r[a.MARK_UNDERLINE] = (0, P.getPluginComponent)("u"), r[a.MARK_STRIKETHROUGH] = (0, P.getPluginComponent)("s"), r[a.MARK_CODE] = (0, P.getPluginComponent)("code"), r),
      A = [(0, c.createReactPlugin)(), (0, c.createHistoryPlugin)(), (0, w.createResetNodePlugin)(j.optionsResetBlockTypePlugin), (0, g.createTrailingBlockPlugin)({
        type: v.ELEMENT_PARAGRAPH
      }), (0, M.createNoNewlineOnPastePlugin)(), (0, h.createListPlugin)(), (0, v.createParagraphPlugin)(), (0, s.createBlockquotePlugin)(), (0, l.createCodeBlockPlugin)(), (0, p.createLinkPlugin)(), (0, u.createHeadingPlugin)(), (0, C.createCustomTablePlugin)(), (0, a.createCodePlugin)(), (0, f.createImagePlugin)(), (0, E.createSpanPlugin)(), (0, a.createBoldPlugin)(), (0, a.createItalicPlugin)(), (0, a.createUnderlinePlugin)(), (0, a.createStrikethroughPlugin)()];
    A.push((0, d.createDeserializeHTMLPlugin)({
      plugins: A
    })), t.HTMLEditor = function (e) {
      var n = (0, i.useTheme)(),
        r = x.reduce(function (e, t) {
          return e[t] = (0, P.getPluginComponent)(t), e;
        }, T),
        o = (0, O.createPlateOptions)(x.reduce(function (e, t) {
          return e[t] = (0, P.getPluginOptions)(t), e;
        }, {})),
        a = (0, c.useStoreEditorState)(),
        s = {
          readOnly: e.readOnly,
          style: {
            border: "none",
            minHeight: t.MIN_HEIGHT_VALUE,
            fontSize: n.tokens.fontSizes.fontSize30,
            lineHeight: n.tokens.lineHeights.lineHeight30,
            paddingTop: n.tokens.spacings.space50,
            fontFamily: n.tokens.fonts.fontFamilyText,
            maxHeight: Math.floor(.4 * window.innerHeight),
            overflow: "auto"
          },
          onBlur: function () {
            return a && (a.blurSelection = a.selection), !0;
          }
        },
        l = "\n        body {\n            font-family: " + n.tokens.fonts.fontFamilyText + ";\n            font-size: " + n.tokens.fontSizes.fontSize30 + ";\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            line-height: " + n.tokens.lineHeights.lineHeight30 + ";\n            margin: 0;\n            word-break: break-word; \n            white-space: pre-line;\n            color: " + n.tokens.textColors.colorText + ";\n            background: " + n.tokens.backgroundColors.colorBackgroundBody + ";\n        }\n        a {\n            color: " + n.tokens.textColors.colorTextLink + ";\n        }\n        p {\n            margin-top: 0;\n            margin-bottom: 0;\n        }\n        " + (0, y.rootStyleObjectToString)(n.Chat.EmailEditor.MessageIframe) + "\n    ";
      return b.default.createElement(_.IframeWrapper, {
        styles: l,
        title: "HTMLEditor",
        scrollToBottom: e.scrollToBottom
      }, b.default.createElement(c.Plate, {
        plugins: A,
        components: r,
        options: o,
        editableProps: s,
        value: e.value,
        onChange: e.onChange
      }, e.children));
    };
  }, function (e, t) {
    e.exports = require("@udecode/plate-block-quote");
  }, function (e, t) {
    e.exports = require("@udecode/plate-code-block");
  }, function (e, t) {
    e.exports = require("@udecode/plate-heading");
  }, function (e, t) {
    e.exports = require("@udecode/plate-image");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.focusOnEditor = void 0;
    var r = n(31),
      o = n(438);
    t.focusOnEditor = function (e, t) {
      o.ReactEditor.isFocused(e) || (o.ReactEditor.focus(e), r.Transforms.select(e, t || r.Editor.end(e, [])));
    };
  }, function (e, t) {
    e.exports = require("@material-ui/core/Popover");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getEditorSelection = void 0;
    t.getEditorSelection = function (e) {
      return e.selection || e.blurSelection;
    };
  }, function (e, t) {
    e.exports = require("@material-ui/core/InputLabel");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailMessageItem = void 0;
    var s = a(n(0)),
      l = n(0),
      c = n(21),
      u = n(450);
    t.EmailMessageItem = function (e) {
      var t = (0, l.useContext)(c.MessagingCanvasContext);
      return s.createElement(u.EmailMessageItemImpl, r({}, e, {
        conversationSid: t.sid,
        avatarUrl: t.avatarCallback && t.avatarCallback(e.message.source.author)
      }));
    }, t.EmailMessageItem.defaultProps = {
      defaultOpen: !1
    }, t.EmailMessageItem.displayName = u.displayName, t.EmailMessageItem.Content = u.Content;
  }, function (e, t) {
    e.exports = require("dompurify");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LinkExternalIcon = t.MediaMessageContainer = t.MediaMessageActions = t.EmailFileContainer = t.HTMLWrapper = t.BodyComponent = t.Wrapper = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      d = n(4),
      f = n(1);
    t.Wrapper = (0, f.styled)("div")(o || (o = r(["\n    width: 100%;\n    position: relative;\n\n    // Each Wrapper preceded by another Wrapper\n    & + & {\n        ", "\n\n        &:before {\n            position: absolute;\n            height: ", ";\n            left: ", ";\n            width: 1px;\n            border-left: ", " solid\n                ", ';\n            content: " ";\n\n            ', "\n        }\n    }\n\n    ", ";\n"], ["\n    width: 100%;\n    position: relative;\n\n    // Each Wrapper preceded by another Wrapper\n    & + & {\n        ", "\n\n        &:before {\n            position: absolute;\n            height: ", ";\n            left: ", ";\n            width: 1px;\n            border-left: ", " solid\n                ", ';\n            content: " ";\n\n            ', "\n        }\n    }\n\n    ", ";\n"])), function (e) {
      return e.disableOrganicMessageSorting ? "margin-bottom: " + e.theme.tokens.spacings.space70 + ";" : "margin-top: " + e.theme.tokens.spacings.space70 + ";";
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare70;
    }, function (e) {
      return e.theme.tokens.spacings.space60;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderWeak;
    }, function (e) {
      return e.disableOrganicMessageSorting ? "top: 100%;" : "bottom: 100%;";
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Wrapper;
    }), t.BodyComponent = (0, f.styled)("div")(i || (i = r(["\n    word-break: break-word; // Breaking on new lines extremely long words\n    white-space: pre-line; // Making sure to preserve new lines stored in the message\n    font-size: ", ";\n    line-height: ", ";\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", ";\n"], ["\n    word-break: break-word; // Breaking on new lines extremely long words\n    white-space: pre-line; // Making sure to preserve new lines stored in the message\n    font-size: ", ";\n    line-height: ", ";\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Body.Wrapper;
    }), t.HTMLWrapper = (0, f.styled)("div")(a || (a = r(["\n    ", ";\n\n    ", "\n"], ["\n    ", ";\n\n    ", "\n"])), function (e) {
      return e.theme.Chat.EmailMessageItem.Body.HTMLWrapper;
    }, function (e) {
      return e.isLoading && "\n            position: absolute;\n            width: 100%;\n            top: 0;\n            opacity: 0;\n            pointer-events: none;\n    ";
    }), t.EmailFileContainer = f.styled.div(s || (s = r(["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n    max-width: 100%;\n    margin-top: ", ";\n    ", ";\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n    max-width: 100%;\n    margin-top: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Body.FileAttachmentsContainer;
    }), t.MediaMessageActions = f.styled.div(l || (l = r(["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: ", ";\n"], ["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: ", ";\n"])), function (e) {
      return e.isVisible ? "block" : "hidden";
    }), t.MediaMessageContainer = f.styled.button(c || (c = r(["\n    display: flex;\n    align-items: center;\n    outline: none;\n    text-align: left;\n    justify-content: space-between;\n    cursor: pointer;\n    max-width: 100%;\n    padding: 0;\n    background-color: ", ";\n    border-width: ", ";\n    border-radius: ", ";\n    border-color: ", ";\n    flex: 0 0 calc(50% - 0.25rem);\n    min-width: 220px;\n    border-style: solid;\n    &:hover {\n        .Twilio-Media-MessageBubble-Action {\n            visibility: visible;\n        }\n    }\n\n    ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    outline: none;\n    text-align: left;\n    justify-content: space-between;\n    cursor: pointer;\n    max-width: 100%;\n    padding: 0;\n    background-color: ", ";\n    border-width: ", ";\n    border-radius: ", ";\n    border-color: ", ";\n    flex: 0 0 calc(50% - 0.25rem);\n    min-width: 220px;\n    border-style: solid;\n    &:hover {\n        .Twilio-Media-MessageBubble-Action {\n            visibility: visible;\n        }\n    }\n\n    ", ";\n"])), function (e) {
      return e.theme.tokens.backgroundColors.colorBackground;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius20;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorder;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Body.FileAttachment;
    }), t.LinkExternalIcon = (0, f.styled)(d.Icon)(u || (u = r(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.textColors.colorText;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Avatar = void 0;
    var a = i(n(0)),
      s = n(4),
      l = n(461);
    t.Avatar = function (e) {
      return "Minimal" === e.messageStyle ? a.createElement(l.AvatarLine, {
        className: "Twilio-ChatItem-AvatarLine",
        message: e.message
      }) : (t = e.message.isFromMe || e.message.groupWithNext ? null : e.avatarUrl ? a.createElement("img", {
        src: e.avatarUrl,
        alt: ""
      }) : a.createElement(s.Icon, {
        icon: "DefaultAvatar",
        sizeMultiplier: e.sizeMultiplier
      }), a.createElement(l.StyledAvatarDiv, {
        className: "Twilio-ChatItem-Avatar",
        messageStyle: e.messageStyle,
        message: e.message,
        sizeMultiplier: e.sizeMultiplier
      }, t));
      var t;
    }, t.Avatar.defaultProps = {
      sizeMultiplier: 1,
      avatarUrl: ""
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListItem = void 0;
    var u = l(n(0)),
      d = n(72),
      f = n(21),
      p = n(465),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return u.createElement(f.MessagingCanvasContext.Consumer, null, function (t) {
            return u.createElement(p.MessageListItemImpl, i({}, e.getChildProps(t)));
          });
        }, t.prototype.getChildProps = function (e) {
          var t = this.props,
            n = (t.children, c(t, ["children"])),
            r = e.avatarCallback,
            o = e.hasMarkdownSupport,
            a = e.sid;
          return i(i({}, n), {
            hasMarkdownSupport: o,
            channelSid: a,
            conversationSid: a,
            avatarUrl: this.props.avatarUrl || !!r && r(this.props.message.source.author)
          });
        }, t.displayName = p.displayName, t.Content = p.store, t.Bubble = d.MessageBubble, t.defaultProps = {
          useFriendlyName: !0
        }, t;
      }(u.PureComponent);
    t.MessageListItem = h;
  }, function (e, t) {
    e.exports = require("mime-types");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaErrorContainer = t.MessageReadContainer = t.StyledSpike = t.BubbleContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(6),
      u = n(1),
      d = n(466);
    t.Container = (0, u.styled)("div")(o || (o = r(["\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n    min-width: 0;\n    margin-top: ", ";\n"], ["\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n    min-width: 0;\n    margin-top: ", ";\n"])), function (e) {
      var t = e.messageStyle,
        n = e.message,
        r = e.theme;
      return "Minimal" === t ? r.tokens.spacings.space70 : (null == n ? void 0 : n.groupWithPrevious) ? r.tokens.spacings.space20 : "Rounded" === t ? r.tokens.spacings.space60 : r.tokens.spacings.space40;
    }), t.BubbleContainer = (0, u.styled)("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    max-width: ", ";\n    min-width: ", ";\n\n    margin-left: ", ";\n    margin-right: ", ";\n    &:focus-visible {\n        outline: none;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    max-width: ", ";\n    min-width: ", ";\n\n    margin-left: ", ";\n    margin-right: ", ";\n    &:focus-visible {\n        outline: none;\n    }\n"])), function (e) {
      return "Wide" === e.messageStyle ? "auto" : e.isFromMe ? "476px" : "432px";
    }, function (e) {
      return "Wide" === e.messageStyle ? "100%" : "100px";
    }, function (e) {
      var t = e.messageStyle,
        n = e.isFromMe;
      return "Minimal" === t || "Wide" === t ? "0px" : n ? "auto" : "0px";
    }, function (e) {
      var t = e.messageStyle,
        n = e.isFromMe;
      return "Minimal" === t || "Wide" === t ? "8px" : n ? "0px" : "44px";
    }), t.StyledSpike = (0, u.styled)(d.Spike)(a || (a = r(["\n    align-self: ", ";\n    color: ", ";\n"], ["\n    align-self: ", ";\n    color: ", ";\n"])), function (e) {
      return e.reverse ? "flex-end" : "flex-start";
    }, function (e) {
      return e.reverse ? e.theme.Chat.MessageListItem.FromMe.Bubble.background : e.theme.Chat.MessageListItem.FromOthers.Bubble.background;
    }), t.MessageReadContainer = (0, u.styled)(c.FlexBox)(s || (s = r(["\n    align-items: center;\n    margin-left: auto;\n    font-size: 10px;\n\n    .Twilio-Icon {\n        margin-left: 4px;\n    }\n\n    ", "\n"], ["\n    align-items: center;\n    margin-left: auto;\n    font-size: 10px;\n\n    .Twilio-Icon {\n        margin-left: 4px;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageListItem.ReadStatus;
    }), t.MediaErrorContainer = (0, u.styled)(c.FlexBox)(l || (l = r(["\n    align-items: center;\n    margin-left: auto;\n    font-size: ", ";\n    ", ";\n    margin-top: ", ";\n    .Twilio-Icon {\n        margin-right: ", ";\n    }\n"], ["\n    align-items: center;\n    margin-left: auto;\n    font-size: ", ";\n    ", ";\n    margin-top: ", ";\n    .Twilio-Icon {\n        margin-right: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.Chat.MessageListItem.ErrorStatus;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.spacings.space10;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineDateSeparator = void 0;
    var r = n(469);
    Object.defineProperty(t, "InlineDateSeparator", {
      enumerable: !0,
      get: function () {
        return r.InlineDateSeparator;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineMessageProps = t.InlineMessage = void 0;
    var i = n(471);
    Object.defineProperty(t, "InlineMessage", {
      enumerable: !0,
      get: function () {
        return i.InlineMessage;
      }
    }), Object.defineProperty(t, "InlineMessageProps", {
      enumerable: !0,
      get: function () {
        return i.InlineMessageProps;
      }
    }), o(n(127), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(6),
      a = n(1);
    t.Container = (0, a.styled)(i.FlexBox)(o || (o = r(["\n    padding-top: ", ";\n    padding-bottom: ", ";\n"], ["\n    padding-top: ", ";\n    padding-bottom: ", ";\n"])), function (e) {
      return e.isSeparator ? e.theme.tokens.spacings.space40 : e.theme.tokens.spacings.space110;
    }, function (e) {
      return e.message.groupWithPrevious || "Squared" !== e.messageStyle ? e.isSeparator ? e.theme.tokens.spacings.space40 : e.message.groupWithPrevious ? "Minimal" === e.messageStyle ? e.theme.tokens.spacings.space50 : e.theme.tokens.spacings.space100 : e.theme.tokens.spacings.space60 : e.theme.tokens.spacings.space80;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineNewMessageSeparator = void 0;
    var r = n(472);
    Object.defineProperty(t, "InlineNewMessageSeparator", {
      enumerable: !0,
      get: function () {
        return r.InlineNewMessageSeparator;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTray = void 0;
    var i = n(474);
    Object.defineProperty(t, "MessageCanvasTray", {
      enumerable: !0,
      get: function () {
        return i.MessageCanvasTray;
      }
    }), o(n(130), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionButton = t.Container = void 0;
    var o,
      i,
      a = n(17),
      s = n(6),
      l = n(1);
    t.Container = (0, l.styled)(s.FlexBoxColumn)(o || (o = r(["\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n    width: 100%;\n    min-height: 140px;\n\n    p {\n        margin-top: 4px;\n        margin-bottom: 12px;\n        margin-left: 47px;\n        margin-right: 47.5px;\n    }\n\n    .MessageCanvasTrayContent {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        margin-top: 20px;\n        h5 {\n            font-size: 18px;\n            font-weight: normal;\n            margin: 0px;\n        }\n    }\n\n    ", "\n"], ["\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n    width: 100%;\n    min-height: 140px;\n\n    p {\n        margin-top: 4px;\n        margin-bottom: 12px;\n        margin-left: 47px;\n        margin-right: 47.5px;\n    }\n\n    .MessageCanvasTrayContent {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        margin-top: 20px;\n        h5 {\n            font-size: 18px;\n            font-weight: normal;\n            margin: 0px;\n        }\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageCanvasTray.Container;
    }), t.ActionButton = (0, l.styled)(a.Button)(i || (i = r(["\n    margin-bottom: 21px;\n"], ["\n    margin-bottom: 21px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      u = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      d = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputImpl = t.contentStoreV2 = t.displayNameV2 = t.contentStore = t.displayName = void 0;
    var f = d(n(63)),
      p = l(n(0)),
      h = n(23),
      v = n(33),
      m = n(28),
      g = n(7),
      b = n(20),
      y = n(3),
      _ = n(36),
      O = n(24),
      C = n(2),
      P = n(70),
      M = n(1),
      j = n(132),
      w = n(480),
      E = n(482);
    t.displayName = "MessageInput", t.contentStore = new g.DynamicContentStore(t.displayName), t.displayNameV2 = "MessageInputV2", t.contentStoreV2 = new g.DynamicContentStore(t.displayNameV2);
    var S = function (e) {
        function n(t) {
          var n = e.call(this, t) || this;
          n.state = {
            inputText: "",
            selectionStart: 0,
            selectionEnd: 0,
            attachedFiles: [],
            hasChildInFocus: !1
          }, n._inputElementRef = p.createRef(), n.onMessageChange = function (e) {
            n.setState(e, function () {
              n.debouncedSetInputText();
            });
          }, n.debouncedSetInputText = (0, f.default)(function () {
            var e = n.props,
              t = e.conversation,
              r = e.channel;
            (0, _.tryInvokeAction)("SetInputText", {
              conversation: t,
              channel: r,
              body: n.state.inputText,
              selectionStart: n.state.selectionStart,
              selectionEnd: n.state.selectionEnd
            });
          }, 100), n.getInputTextLength = function () {
            var e = n.state.inputText;
            return e && e.trim().length || 0;
          }, n.sendMessage = function (e) {
            if (!e) {
              var t = n.props,
                r = t.conversation,
                o = t.charLimit,
                a = t.disabledReason,
                s = t.messageState,
                l = t.channel,
                c = n.state.inputText.trim();
              if (n.getInputTextLength() > o) y.log.warn("The entered character number exceeds the limit");else if (void 0 === a) {
                var u = null == s ? void 0 : s.attachedFiles;
                u && u.forEach(function (e) {
                  O.TelemetryBridge.emit(O.TelemetryBridgeMessageType.MEDIA_MESSAGE_SENT, e), m.ChatManager.shouldUseMessageInputV2() || ((0, _.tryInvokeAction)("DetachFile", {
                    file: e,
                    conversation: r,
                    channel: l
                  }), (0, _.tryInvokeAction)("SendMediaMessage", {
                    conversation: r,
                    channel: l,
                    file: e
                  }));
                }), m.ChatManager.shouldUseMessageInputV2() || (0, _.tryInvokeAction)("SetInputText", {
                  conversation: r,
                  channel: l,
                  body: ""
                }), m.ChatManager.shouldUseMessageInputV2() ? (0, _.tryInvokeAction)("SendMessage", i({
                  body: c,
                  conversation: r,
                  channel: l
                }, u && {
                  attachedFiles: u
                })) : "" !== c && (0, _.tryInvokeAction)("SendMessage", {
                  body: c,
                  conversation: r,
                  channel: l
                }), n._inputElementRef.current && n._inputElementRef.current.focus();
              } else y.log.warn("Message sending is not enabled");
            }
          }, n.handleFileChange = function (e) {
            return c(n, void 0, void 0, function () {
              var t, n, r, o, i;
              return u(this, function (a) {
                switch (a.label) {
                  case 0:
                    if (t = this.props, n = t.conversationSid, r = t.channelSid, o = e.target.files ? Array.from(e.target.files) : [], !e.target.files) return [3, 4];
                    a.label = 1;
                  case 1:
                    return a.trys.push([1, 3,, 4]), [4, h.Actions.invokeAction("AttachFiles", {
                      files: o,
                      conversationSid: n,
                      channelSid: r
                    })];
                  case 2:
                    return a.sent(), [3, 4];
                  case 3:
                    return i = a.sent(), y.log.error(i), [2, Promise.reject()];
                  case 4:
                    return this._inputElementRef.current && this._inputElementRef.current.focus(), [2, Promise.resolve()];
                }
              });
            });
          }, n.removeAttachedFile = function (e) {
            var t = n.props,
              r = t.conversationSid,
              o = t.messageState,
              i = t.channelSid;
            e || (e = (null == o ? void 0 : o.attachedFiles)[0]), (0, _.tryInvokeAction)("DetachFile", {
              file: e,
              conversationSid: r,
              channelSid: i
            });
          }, n.attachFiles = function (e) {
            return c(n, void 0, void 0, function () {
              var t, n, r;
              return u(this, function (o) {
                switch (o.label) {
                  case 0:
                    return e ? (t = this.props, n = t.conversationSid, r = t.channelSid, [4, (0, _.tryInvokeAction)("AttachFiles", {
                      files: e,
                      conversationSid: n,
                      channelSid: r
                    })]) : [2];
                  case 1:
                    return o.sent(), [2];
                }
              });
            });
          }, n.getStoredState = n.getStoredState.bind(n), n.resetFromStoredState = n.resetFromStoredState.bind(n);
          var r = n.getStoredState();
          return n.state = i(i({}, r), {
            hasChildInFocus: !1
          }), n;
        }
        return o(n, e), n.prototype.getStoredState = function () {
          return this.props.messageState || {
            inputText: this.state.inputText,
            selectionStart: this.state.selectionStart,
            selectionEnd: this.state.selectionEnd,
            attachedFiles: this.state.attachedFiles
          };
        }, n.prototype.resetFromStoredState = function () {
          var e = this.getStoredState();
          e.inputText === this.state.inputText && e.selectionStart === this.state.selectionStart && e.selectionEnd === this.state.selectionEnd || this.setState({
            inputText: e.inputText,
            selectionStart: e.selectionStart,
            selectionEnd: e.selectionEnd
          });
        }, n.prototype.generateSendButtonAriaLabel = function () {
          var e,
            t = this.props,
            n = t.disabledReason,
            r = t.charLimit,
            o = t.sendButtonAriaProps,
            i = t.connectionState,
            a = t.messageState,
            s = this.getInputTextLength(),
            l = s > r;
          return void 0 !== n ? C.templates.DisabledSendButtonAriaLabel({
            disabledReason: n
          }) : l ? C.templates.CharLimitReachedSendMessageAriaLabel({
            currentCharCount: s,
            maxCharCount: r
          }) : "connected" !== i ? C.templates.NotConnectedSendMessageAriaLabel() : 0 !== s || (null === (e = null == a ? void 0 : a.attachedFiles) || void 0 === e ? void 0 : e.length) ? o && o.ariaLabel : C.templates.NoInputSendMessageAriaLabel();
        }, n.prototype.generateAttachFileButtonAriaLabel = function (e) {
          var t = this.props,
            n = t.disabledReason,
            r = t.conversation;
          return void 0 !== n ? C.templates.DisabledAttachFileButtonAriaLabel({
            disabledReason: n
          }) : e ? (null == r ? void 0 : r.messages.length) ? C.templates.AttachFileImageTooltip() : C.templates.NoMessagesConversationAriaLabel() : C.templates.AttachedFileLimitAriaLabel();
        }, n.prototype.componentDidMount = function () {
          h.Actions.addListener("afterSetInputText", this.resetFromStoredState);
        }, n.prototype.componentWillUnmount = function () {
          h.Actions.removeListener("afterSetInputText", this.resetFromStoredState);
        }, n.prototype.render = function () {
          var e,
            n = this,
            r = this.props,
            o = r.areaStyle,
            a = r.connectionState,
            s = r.conversation,
            l = r.disabledReason,
            c = r.returnKeySendsMessage,
            u = r.charLimit,
            d = r.conversationSid,
            f = r.sendButtonAriaProps,
            h = r.textAreaAriaProps,
            m = r.messageState,
            y = r.channel,
            _ = r.theme,
            O = r.hideSendButton,
            M = r.legacy,
            S = r.rows,
            x = this.getInputTextLength(),
            T = "connected" !== a || 0 === x && !(null === (e = null == m ? void 0 : m.attachedFiles) || void 0 === e ? void 0 : e.length) || void 0 !== l || x > u,
            A = l || C.templates.InputPlaceHolder(),
            I = function (e) {
              return e.conversation.source.sid === d;
            },
            k = i(i({}, this.state), {
              attachedFiles: null == m ? void 0 : m.attachedFiles
            }),
            N = (0, b.canAttachFile)(k, s),
            B = this.generateSendButtonAriaLabel(),
            D = this.generateAttachFileButtonAriaLabel(N),
            L = void 0 !== l || !N;
          return p.createElement(v.ActionStateListener, {
            action: "SendMessage",
            payload: I
          }, function (e) {
            var r, i, a, v, m;
            return p.createElement(g.DynamicComponent, {
              contentStore: M ? t.contentStore : t.contentStoreV2,
              childProps: n.props,
              name: M ? t.displayName : t.displayNameV2,
              customChildren: n.props.children,
              vertical: !0,
              rootContainerStyles: "\n                        > :first-child {\n                            min-width: 0;\n                            overflow: visible;\n                        };\n                    "
            }, M ? p.createElement(E.Container, {
              noGrow: !0,
              noShrink: !0,
              areaStyle: o
            }, p.createElement(E.TextAreaContainer, {
              key: "textarea",
              hasChildInFocus: n.state.hasChildInFocus,
              legacy: !0
            }, (0, b.isFileAttachmentEnabled)(d) && !(0, b.isFileAttachmentReadOnly)(d) && p.createElement("div", null, p.createElement(P.AttachFileButton, {
              disabled: L,
              ariaLabel: D,
              onChange: n.handleFileChange,
              className: "Twilio-MessageInputArea-AttachFileButton",
              themeOverride: null == _ ? void 0 : _.Chat.MessageInput.AttachFileButton,
              onFocus: function () {
                n.dispatchFocusChange(!0);
              },
              onBlur: function () {
                n.dispatchFocusChange(!1);
              },
              conversationSid: d,
              legacy: M,
              multipleFiles: !0
            })), p.createElement(w.MessageInputArea, {
              forwardedInputRef: n._inputElementRef,
              conversationSid: d,
              conversation: s,
              channelSid: null === (r = null == y ? void 0 : y.source) || void 0 === r ? void 0 : r.sid,
              channel: y,
              disabled: e.disabled || void 0 !== l,
              disabledReason: l,
              placeholder: A,
              onSendMessage: function () {
                n.sendMessage(e.disabled || T);
              },
              areaStyle: o,
              returnKeySendsMessage: c,
              charLimit: u,
              inputTextLength: x,
              onChange: n.onMessageChange,
              messageState: k,
              textAreaAriaProps: h,
              onRemoveAttachedFile: n.removeAttachedFile,
              onPasteFiles: n.attachFiles,
              onFocus: function () {
                n.dispatchFocusChange(!0);
              },
              onBlur: function () {
                n.dispatchFocusChange(!1);
              },
              legacy: M
            }), p.createElement(E.StyledSendMessageButton, {
              className: "Twilio-MessageInput-SendButton",
              icon: "SendLarge",
              onClick: function () {
                return n.sendMessage(e.disabled || T);
              },
              title: l || C.templates.SendMessageTooltip(),
              "aria-disabled": e.disabled || T,
              themeOverride: null === (v = null === (a = null === (i = n.props.theme) || void 0 === i ? void 0 : i.Chat) || void 0 === a ? void 0 : a.MessageInput) || void 0 === v ? void 0 : v.Button,
              "aria-label": B,
              "aria-live": f && f.ariaLive,
              onFocus: function () {
                n.dispatchFocusChange(!0);
              },
              onBlur: function () {
                n.dispatchFocusChange(!1);
              }
            }))) : p.createElement(E.Container, {
              noGrow: !0,
              noShrink: !0,
              areaStyle: o
            }, p.createElement(E.TextAreaContainer, {
              key: "textarea",
              legacy: !1
            }, p.createElement(w.MessageInputArea, {
              forwardedInputRef: n._inputElementRef,
              conversationSid: d,
              conversation: s,
              channelSid: null === (m = null == y ? void 0 : y.source) || void 0 === m ? void 0 : m.sid,
              channel: y,
              disabled: e.disabled || void 0 !== l,
              disabledReason: l,
              placeholder: A,
              onSendMessage: function () {
                n.sendMessage(e.disabled || T);
              },
              areaStyle: o,
              returnKeySendsMessage: c,
              charLimit: u,
              inputTextLength: x,
              onChange: n.onMessageChange,
              messageState: k,
              textAreaAriaProps: h,
              onRemoveAttachedFile: n.removeAttachedFile,
              onPasteFiles: n.attachFiles,
              legacy: M,
              rows: S,
              isSending: e.disabled
            })), p.createElement(j.MessageInputActions, {
              theme: _,
              conversationSid: d,
              attachFileButtonAriaLabel: D,
              handleFileChange: n.handleFileChange,
              sendMessage: n.sendMessage,
              attachFileDisabled: L,
              sendDisabled: e.disabled || T,
              disabledReason: l || C.templates.SendMessageTooltip(),
              sendButtonArialabel: B,
              sendButtonAriaProps: f,
              matchSendMessagePayloadPredicate: I,
              hideSendButton: Boolean(O),
              key: "actions"
            })));
          });
        }, n.prototype.dispatchFocusChange = function (e) {
          this.setState(function (t) {
            return i(i({}, t), {
              hasChildInFocus: e
            });
          });
        }, n;
      }(p.PureComponent),
      x = (0, M.withTheme)(S);
    t.MessageInputImpl = x;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputActionsProps = t.MessageInputActions = void 0;
    var r = n(477);
    Object.defineProperty(t, "MessageInputActions", {
      enumerable: !0,
      get: function () {
        return r.MessageInputActions;
      }
    });
    var o = n(479);
    Object.defineProperty(t, "MessageInputActionsProps", {
      enumerable: !0,
      get: function () {
        return o.MessageInputActionsProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputV2 = void 0;
    var u = c(n(0)),
      d = n(30),
      f = n(8),
      p = n(43),
      h = n(21),
      v = n(131),
      m = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          var e = this;
          return u.createElement(h.MessagingCanvasContext.Consumer, null, function (t) {
            return u.createElement(g, i({}, e.props, {
              legacy: !1,
              conversationSid: t.sid,
              channelSid: t.sid,
              key: t.sid
            }));
          });
        }, t.displayName = v.displayNameV2, t.Content = v.contentStoreV2, t.defaultProps = {
          areaStyle: "Bubble",
          returnKeySendsMessage: !0,
          sendButtonAriaProps: {
            ariaLabel: "Send Message"
          },
          textAreaAriaProps: {
            ariaLabel: "Type Message"
          },
          hideSendButton: !1,
          rows: 1
        }, t = l([p.withDefaultPropsUpdate], t);
      }(u.PureComponent);
    t.MessageInputV2 = m;
    var g = (0, d.connect)(function (e, t) {
      return {
        channel: f.ChatModule.stateCallback(e).channels[t.conversationSid],
        conversation: f.ChatModule.stateCallback(e).conversations[t.conversationSid],
        connectionState: f.ChatModule.stateCallback(e).session.connectionState,
        messageState: f.ChatModule.stateCallback(e).conversationInput[t.conversationSid]
      };
    })(v.MessageInputImpl);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WelcomeMessage = void 0;
    var l = s(n(0)),
      c = n(7),
      u = n(25),
      d = n(2),
      f = n(1),
      p = n(21),
      h = n(484),
      v = n(135),
      m = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return l.createElement(p.MessagingCanvasContext.Consumer, null, function (n) {
            return l.createElement(c.DynamicComponent, {
              contentStore: t.Content,
              childProps: e.props,
              name: t.friendlyName,
              vertical: !0
            }, l.createElement(v.Container, null, l.createElement(v.IconContainer, {
              key: "icon",
              icon: n.welcomeMessageIcon || "Message"
            }), l.createElement(h.TextContainer, {
              key: "text",
              source: n.welcomeMessageText || d.templates.WelcomeMessage
            })));
          });
        }, t.friendlyName = "WelcomeMessage", t.Content = new u.DynamicContentStore("WelcomeMessage"), t;
      }(l.PureComponent),
      g = (0, f.withTheme)(m);
    t.WelcomeMessage = g;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconContainer = t.Container = void 0;
    var s = a(n(0)),
      l = n(1),
      c = n(4);
    t.Container = (0, l.styled)("div")(u || (u = r(["\n    display: flex;\n    overflow: visible;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-right: auto;\n    margin-left: auto;\n    flex: 1 100%;\n    ", "\n"], ["\n    display: flex;\n    overflow: visible;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-right: auto;\n    margin-left: auto;\n    flex: 1 100%;\n    ", "\n"])), function (e) {
      return e.theme.tokens.spacings.space60;
    }, function (e) {
      return e.theme.tokens.spacings.space60;
    }, function (e) {
      return e.theme.Chat.WelcomeMessage.Container;
    });
    var u,
      d,
      f = (0, l.styled)("div")(d || (d = r(["\n    margin-bottom: ", ";\n    height: ", ";\n    width: ", ";\n    align-self: center;\n    ", "\n"], ["\n    margin-bottom: ", ";\n    height: ", ";\n    width: ", ";\n    align-self: center;\n    ", "\n"])), function (e) {
        return e.theme.tokens.spacings.space20;
      }, function (e) {
        return e.theme.tokens.sizings.sizeSquare70;
      }, function (e) {
        return e.theme.tokens.sizings.sizeSquare70;
      }, function (e) {
        return e.theme.Chat.WelcomeMessage.Icon;
      });
    t.IconContainer = function (e) {
      var t = e.icon;
      return s.createElement(f, {
        className: "Twilio-WelcomeMessage-IconContainer"
      }, s.createElement(c.Icon, {
        icon: t
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageLoader = void 0;
    var r = n(486);
    Object.defineProperty(t, "MessageLoader", {
      enumerable: !0,
      get: function () {
        return r.MessageLoader;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(488), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.ListOuterContainer = t.ListContainer = void 0;
    var o,
      i,
      a,
      s = n(1),
      l = "\n    display: flex;\n    flex-flow: column-reverse;\n    flex-grow: 1;\n    min-width: 0;\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n";
    t.ListContainer = (0, s.styled)("div")(o || (o = r(["\n    display: flex;\n    flex-flow: column;\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    &:focus-visible {\n        box-shadow: ", ";\n    }\n"], ["\n    display: flex;\n    flex-flow: column;\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n\n    ", "\n\n    &:focus-visible {\n        box-shadow: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.spacingBottom ? e.theme.tokens.spacings.space50 : "0";
    }, function (e) {
      return e.disableOrganicMessageSorting && l;
    }, function (e) {
      return e.theme.tokens.boxShadows.shadowFocusInset;
    }), t.ListOuterContainer = (0, s.styled)("div")(i || (i = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.disableOrganicMessageSorting ? "\n        display:flex;\n        flex-direction:column;\n        min-height: 0;\n    " : l;
    }), t.Container = (0, s.styled)("div")(a || (a = r(["\n    display: flex;\n    flex-direction: column;\n    overflow: ", ";\n    margin-top: auto;\n    position: relative;\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: ", ";\n    margin-top: auto;\n    position: relative;\n"])), function (e) {
      return e.overflowVisible ? "visible" : "hidden";
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypingIndicator = void 0;
    var a = i(n(0)),
      s = n(9),
      l = n(2),
      c = n(491);
    t.TypingIndicator = function (e) {
      var t = e.memberDisplayOptions,
        n = e.typers,
        r = "";
      return 1 === n.length && (r = s.Utils.getNameForMember(t.theirFriendlyNameOverride, t.theirDefaultName, n[0].friendlyName, n[0].source.identity)), a.createElement(c.TypingIndicatorDiv, {
        className: "Twilio-TypingIndicator",
        key: "TypingIndicator"
      }, 1 === n.length && a.createElement(l.Template, {
        source: l.templates.TypingIndicator,
        name: r
      }), n.length > 1 && a.createElement(l.Template, {
        source: l.templates.TypingIndicatorMultiple,
        count: n.length
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBar = t.NotificationBarItem = void 0;
    var r = n(141);
    Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function () {
        return r.NotificationBarItem;
      }
    });
    var o = n(504);
    Object.defineProperty(t, "NotificationBar", {
      enumerable: !0,
      get: function () {
        return o.NotificationBar;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarItem = void 0;
    var r = n(495);
    Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function () {
        return r.NotificationBarItem;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DropdownList = t.ActionItemContainer = t.ActionsContainer = t.MessageContainer = t.NotificationContainer = t.NotificationBarContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u = n(13),
      d = n(1);
    t.NotificationBarContainer = (0, d.styled)("div")(o || (o = r(["\n    display: flex;\n    position: absolute;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n"], ["\n    display: flex;\n    position: absolute;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n"]))), t.NotificationContainer = (0, d.styled)("div")(i || (i = r(["\n    display: flex;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: start;\n    box-sizing: border-box;\n    border-bottom-width: 2px;\n    border-bottom-style: solid;\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    ", ";\n\n    background: ", ";\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: start;\n    box-sizing: border-box;\n    border-bottom-width: 2px;\n    border-bottom-style: solid;\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    ", ";\n\n    background: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }, function (e) {
      switch (e.type) {
        case u.NotificationType.success:
          return "\n                    background: " + e.theme.tokens.backgroundColors.colorBackgroundSuccessWeakest + ";\n                    border-color: " + e.theme.tokens.borderColors.colorBorderSuccess + ";\n                ";
        case u.NotificationType.warning:
          return "\n                    background: " + e.theme.tokens.backgroundColors.colorBackgroundWarningWeakest + ";\n                    border-color: " + e.theme.tokens.borderColors.colorBorderWarning + ";\n                ";
        case u.NotificationType.error:
          return "\n                    background: " + e.theme.tokens.backgroundColors.colorBackgroundErrorWeakest + ";\n                    border-color: " + e.theme.tokens.borderColors.colorBorderError + ";\n                ";
        default:
          return "\n                    background: " + e.theme.tokens.backgroundColors.colorBackground + ";\n                    border-color: " + e.theme.tokens.borderColors.colorBorderPrimary + ";\n                ";
      }
    }, function (e) {
      return e.backgroundColor;
    }), t.MessageContainer = (0, d.styled)("div")(a || (a = r(["\n    margin-left: ", ";\n    margin-right: ", ";\n    flex-grow: 2;\n    word-break: break-word;\n\n    & > span:first-child {\n        line-height: ", ";\n    }\n"], ["\n    margin-left: ", ";\n    margin-right: ", ";\n    flex-grow: 2;\n    word-break: break-word;\n\n    & > span:first-child {\n        line-height: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight40;
    }), t.ActionsContainer = (0, d.styled)("div")(s || (s = r(["\n    display: flex;\n    margin-right: ", ";\n    & > .Twilio-NotificationBar-ActionItemContainer:last-child {\n        &:after {\n            ", ";\n        }\n        padding-right: ", ";\n    }\n"], ["\n    display: flex;\n    margin-right: ", ";\n    & > .Twilio-NotificationBar-ActionItemContainer:last-child {\n        &:after {\n            ", ";\n        }\n        padding-right: ", ";\n    }\n"])), function (e) {
      return e.closeButton ? "8px" : "12px";
    }, function (e) {
      return e.closeButton && 'content: ""';
    }, function (e) {
      return !e.closeButton && 0;
    }), t.ActionItemContainer = (0, d.styled)("div")(l || (l = r(['\n    display: flex;\n    align-items: center;\n    position: relative;\n    &:before,\n    &:after {\n        height: 16px;\n        width: 1px;\n        position: absolute;\n        left: 0;\n        /* Hard coded the color here as we don\'t have notification theme object.\n        Will need to update it once we have it. */\n        background: #000;\n        opacity: 0.2;\n    }\n    &:after {\n        left: auto;\n        right: 0;\n    }\n    & + &:before {\n        content: "";\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    position: relative;\n    &:before,\n    &:after {\n        height: 16px;\n        width: 1px;\n        position: absolute;\n        left: 0;\n        /* Hard coded the color here as we don\'t have notification theme object.\n        Will need to update it once we have it. */\n        background: #000;\n        opacity: 0.2;\n    }\n    &:after {\n        left: auto;\n        right: 0;\n    }\n    & + &:before {\n        content: "";\n    }\n']))), t.DropdownList = (0, d.styled)("ul")(c || (c = r(["\n    list-style-type: disc;\n    list-style-position: inside;\n    color: ", ";\n    margin-top: ", ";\n    margin-left: ", ";\n\n    & > li span {\n        position: relative;\n        left: -", ";\n    }\n"], ["\n    list-style-type: disc;\n    list-style-position: inside;\n    color: ", ";\n    margin-top: ", ";\n    margin-left: ", ";\n\n    & > li span {\n        position: relative;\n        left: -", ";\n    }\n"])), function (e) {
      return e.theme.tokens.textColors.colorTextError;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarActionProps = t.NotificationBarAction = void 0;
    var r = n(499);
    Object.defineProperty(t, "NotificationBarAction", {
      enumerable: !0,
      get: function () {
        return r.NotificationBarAction;
      }
    });
    var o = n(500);
    Object.defineProperty(t, "NotificationBarActionProps", {
      enumerable: !0,
      get: function () {
        return o.NotificationBarActionProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InAppNotificationHandler = t.InAppNotificationHandlerImpl = void 0;
    var i = n(3),
      a = n(13),
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.id = a.DefaultNotificationHandlerType.InApp, t.activeNotifications = [], t;
        }
        return o(t, e), t.prototype.canHandleNotification = function (e) {
          var t = !e.isApplicable || e.isApplicable(e);
          return !!e.content && t;
        }, t.prototype.handleNotification = function (e) {
          i.log.debug("InAppNotificationHandler handling notitification and notifying of change", e), this.activeNotifications.push(e), this.notifyChanged();
        }, t.prototype.dismissNotification = function (e) {
          this.activeNotifications = this.activeNotifications.filter(function (t) {
            return t !== e;
          }), this.notifyChanged();
        }, t.prototype.getActiveNotifications = function () {
          return this.activeNotifications;
        }, t.prototype.notifyChanged = function () {
          a.Notifications.emit(a.NotificationEvent.notificationStatusChanged);
        }, t;
      }(n(76).BaseNotificationHandler);
    t.InAppNotificationHandlerImpl = s, t.InAppNotificationHandler = new s(), a.Notifications.registerHandler(t.InAppNotificationHandler);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconContainer = t.MessageChatMetaItemContainer = t.MessageMetaContainer = void 0;
    var o,
      i,
      a,
      s = n(1);
    t.MessageMetaContainer = (0, s.styled)("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n"]))), t.MessageChatMetaItemContainer = (0, s.styled)("div")(i || (i = r(["\n    width: 100%;\n"], ["\n    width: 100%;\n"]))), t.IconContainer = (0, s.styled)("div")(a || (a = r(["\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: ", ";\n    & .Twilio-Icon-Content {\n        padding: ", ";\n    }\n"], ["\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: ", ";\n    & .Twilio-Icon-Content {\n        padding: ", ";\n    }\n"])), function (e) {
      return "VIRTUAL_AGENT" === e.variant ? e.theme.IconContainer.VirtualAgent.width : "TRANSCRIPT_LIST_ITEM" === e.variant ? e.theme.IconContainer.TranscriptListItem.width : e.theme.IconContainer.Customer.width;
    }, function (e) {
      return "VIRTUAL_AGENT" === e.variant ? e.theme.IconContainer.VirtualAgent.height : "TRANSCRIPT_LIST_ITEM" === e.variant ? e.theme.IconContainer.TranscriptListItem.height : e.theme.IconContainer.Customer.height;
    }, function (e) {
      return "VIRTUAL_AGENT" === e.variant ? e.theme.IconContainer.VirtualAgent.backgroundColor : e.theme.IconContainer.Customer.backgroundColor;
    }, function (e) {
      return "VIRTUAL_AGENT" === e.variant ? e.theme.IconContainer.VirtualAgent.color : e.theme.IconContainer.Customer.color;
    }, function (e) {
      return e.theme.tokens.radii.borderRadiusCircle;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessagingCanvasImpl = t.TranscriptMessagingCanvasContext = void 0;
    var r = n(147);
    Object.defineProperty(t, "TranscriptMessagingCanvasContext", {
      enumerable: !0,
      get: function () {
        return r.TranscriptMessagingCanvasContext;
      }
    });
    var o = n(511);
    Object.defineProperty(t, "TranscriptMessagingCanvasImpl", {
      enumerable: !0,
      get: function () {
        return o.TranscriptMessagingCanvasImpl;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessagingCanvasContext = void 0;
    var o = r(n(0));
    t.TranscriptMessagingCanvasContext = o.default.createContext(void 0);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Loader = t.IconArrowDown = t.IconArrowUp = t.HeaderCellContentWrapper = t.SubHeaderCellContentWrapper = t.SubHeaderRow = t.SubHeaderCell = t.HeaderCellWithSubheader = t.StyledTableRow = t.StickyTableHead = void 0;
    var l = n(32),
      c = a(n(0)),
      u = s(n(98)),
      d = s(n(99)),
      f = n(42),
      p = n(1);
    t.StickyTableHead = (0, l.withStyles)({
      root: {
        position: "sticky",
        top: "0",
        zIndex: 1
      }
    })(l.TableHead), t.StyledTableRow = (0, p.styled)(l.TableRow, {
      shouldForwardProp: function (e) {
        return !["isDragTarget", "bottomBorderActive", "isDragging"].includes(e);
      }
    })(v || (v = r(["\n    cursor: ", ";\n    border-top: 0px solid ", ";\n    border-bottom: 0px solid ", ";\n    border-top-width: ", ";\n    border-bottom-width: ", ";\n    transition: border-width 0.2s;\n    ", "\n"], ["\n    cursor: ", ";\n    border-top: 0px solid ", ";\n    border-bottom: 0px solid ", ";\n    border-top-width: ", ";\n    border-bottom-width: ", ";\n    transition: border-width 0.2s;\n    ", "\n"])), function (e) {
      return e.onClick ? "pointer" : "default";
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderPrimaryWeaker;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderPrimaryWeaker;
    }, function (e) {
      return e.isDragTarget && !e.bottomBorderActive ? "4px" : "0";
    }, function (e) {
      return e.isDragTarget && e.bottomBorderActive ? "4px" : "0";
    }, function (e) {
      return e.isDragging && {
        opacity: .2
      };
    }), t.HeaderCellWithSubheader = (0, l.withStyles)(function (e) {
      return {
        head: {
          verticalAlign: "bottom",
          paddingBottom: e.tokens.spacings.space20,
          borderBottomWidth: e.tokens.borderWidths.borderWidth0
        }
      };
    })(l.TableCell), t.SubHeaderCell = (0, l.withStyles)(function (e) {
      return {
        head: {
          paddingBottom: e.tokens.spacings.space40
        }
      };
    })(l.TableCell), t.SubHeaderRow = (0, l.withStyles)(function (e) {
      return {
        head: {
          height: e.tokens.sizings.sizeSquare110
        }
      };
    })(l.TableRow), t.SubHeaderCellContentWrapper = (0, p.styled)("span")(m || (m = r(["\n    position: relative;\n    padding-right: ", ";\n    vertical-align: top;\n    font-weight: initial;\n    font-size: ", ";\n\n    ", ";\n    ", ";\n"], ["\n    position: relative;\n    padding-right: ", ";\n    vertical-align: top;\n    font-weight: initial;\n    font-size: ", ";\n\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.DataTable.SubHeader.root;
    }, function (e) {
      var t = e.clickable,
        n = e.theme;
      return t && n.DataTable.SubHeader.clickable;
    }), t.HeaderCellContentWrapper = (0, p.styled)("span")(g || (g = r(["\n    position: relative;\n    padding-right: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    vertical-align: middle;\n\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    position: relative;\n    padding-right: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    vertical-align: middle;\n\n    ", ";\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space70;
    }, function (e) {
      return e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.theme.DataTable.Header.root;
    }, function (e) {
      var t = e.hasSubHeader,
        n = e.theme;
      return t && n.DataTable.Header.withSubHeader;
    }, function (e) {
      var t = e.clickable,
        n = e.theme;
      return t && n.DataTable.Header.clickable;
    });
    var h = function (e) {
      return "\n    position: absolute;\n    font-size: " + e.tokens.fontSizes.fontSize70 + ";\n";
    };
    t.IconArrowUp = (0, p.styled)(d.default)(b || (b = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      var t = e.theme;
      return h(t);
    }), t.IconArrowDown = (0, p.styled)(u.default)(y || (y = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      var t = e.theme;
      return h(t);
    });
    var v,
      m,
      g,
      b,
      y,
      _,
      O = p.styled.div(_ || (_ = r(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: ", ";\n    padding-top: ", ";\n    width: 100%;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: ", ";\n    padding-top: ", ";\n    width: 100%;\n"])), function (e) {
        return e.theme.tokens.spacings.space50;
      }, function (e) {
        return e.theme.tokens.spacings.space50;
      });
    t.Loader = function () {
      return c.createElement(O, null, c.createElement(f.CircularProgress, {
        animating: !0,
        size: 40,
        borderWidth: 3
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dialpad = void 0;
    var c = l(n(0)),
      u = n(150),
      d = n(534),
      f = n(535);
    function p(e) {
      return /[0-9#*+]/.test(e);
    }
    var h = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.ignoreTargets = ["INPUT", "TEXTAREA"], n.onKeyDownHandler = function (e) {
          var t,
            r,
            o,
            i = e.target.tagName,
            a = (null === (t = n.props.inputRef) || void 0 === t ? void 0 : t.current) === e.target,
            s = n.ignoreTargets.indexOf(i) > -1 && !a;
          a || s || "BACKSPACE" === e.key.toUpperCase() && (null === (o = (r = n.props).onUndo) || void 0 === o || o.call(r));
        }, n.onKeyPressHandler = function (e) {
          var t,
            r = e.target.tagName,
            o = e.key;
          if (!n.state.animate[o]) {
            var a = (null === (t = n.props.inputRef) || void 0 === t ? void 0 : t.current) === e.target;
            !(n.ignoreTargets.indexOf(r) > -1 && !a) && p(o) && (a || n.props.onClick(e.key), n.setState(function (e) {
              var t;
              return {
                animate: i(i({}, e.animate), (t = {}, t[o] = !0, t))
              };
            }));
          }
        }, n.onKeyUpHandler = function (e) {
          var t = e.target.tagName,
            r = e.key,
            o = n.props.inputRef && n.props.inputRef.current === e.target;
          !(n.ignoreTargets.indexOf(t) > -1 && !o) && p(r) && n.setState(function (e) {
            var t;
            return {
              animate: i(i({}, e.animate), (t = {}, t[r] = !1, t))
            };
          });
        }, n.toggleAnimate = function (e) {
          n.setState(function (t) {
            var n;
            return {
              animate: i(i({}, t.animate), (n = {}, n[e] = !t.animate[e], n))
            };
          });
        }, n.focusJump = function () {
          var e,
            t = document.querySelector(".Twilio-Dialpad-Button-1");
          null !== t && (null === (e = t) || void 0 === e || e.focus());
        }, n.state = {
          animate: {}
        }, n;
      }
      return o(t, e), t.prototype.componentDidMount = function () {
        window.addEventListener("keydown", this.onKeyDownHandler), window.addEventListener("keypress", this.onKeyPressHandler), window.addEventListener("keyup", this.onKeyUpHandler), this.props.inOutboundDialer || this.focusJump();
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("keydown", this.onKeyDownHandler), window.removeEventListener("keypress", this.onKeyPressHandler), window.removeEventListener("keyup", this.onKeyUpHandler);
      }, t.prototype.render = function () {
        var e = this.props,
          t = e.onClick,
          n = e.disabled,
          r = e.compact,
          o = e.inOutboundDialer,
          a = this.state.animate,
          s = {
            handleClick: t,
            disabled: n,
            compact: r,
            inOutboundDialer: o,
            toggleAnimate: this.toggleAnimate
          };
        return c.createElement(u.DialpadLayout, null, c.createElement(u.Row, null, c.createElement(d.DialpadButton, i({
          animate: a[1],
          value: f.DialpadButtons.ONE,
          options: "—"
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[2],
          value: f.DialpadButtons.TWO,
          options: "ABC"
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[3],
          value: f.DialpadButtons.THREE,
          options: "DEF"
        }, s))), c.createElement(u.Row, null, c.createElement(d.DialpadButton, i({
          animate: a[4],
          value: f.DialpadButtons.FOUR,
          options: "GHI"
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[5],
          value: f.DialpadButtons.FIVE,
          options: "JKL"
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[6],
          value: f.DialpadButtons.SIX,
          options: "MNO"
        }, s))), c.createElement(u.Row, null, c.createElement(d.DialpadButton, i({
          animate: a[7],
          value: f.DialpadButtons.SEVEN,
          options: "PQRS"
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[8],
          value: f.DialpadButtons.EIGHT,
          options: "TUV"
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[9],
          value: f.DialpadButtons.NINE,
          options: "WXYZ"
        }, s))), c.createElement(u.Row, null, c.createElement(d.DialpadButton, i({
          animate: a["*"],
          value: f.DialpadButtons.ASTERISK
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a[0],
          value: f.DialpadButtons.ZERO,
          options: "+",
          longPressable: !0
        }, s)), c.createElement(d.DialpadButton, i({
          animate: a["#"],
          value: f.DialpadButtons.HASH
        }, s))));
      }, t;
    }(c.PureComponent);
    t.Dialpad = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Description = t.Caption = t.Button = t.DialpadLayout = t.Row = void 0;
    var i,
      a,
      s,
      l,
      c,
      u = o(n(14)),
      d = n(1);
    t.Row = u.default.div(i || (i = r(["\n    display: flex;\n    flex-direction: row;\n    flex-grow: 0;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-grow: 0;\n"]))), t.DialpadLayout = u.default.div(a || (a = r(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n"]))), t.Button = u.default.div(s || (s = r(["\n    width: 33.33%;\n    display: flex;\n    flex-grow: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 200ms;\n    ", ";\n\n    height: ", ';\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        cursor: not-allowed;\n    }\n    &:focus-visible {\n        border-width: ', ";\n        border-style: solid;\n        border-color: ", ";\n    }\n"], ["\n    width: 33.33%;\n    display: flex;\n    flex-grow: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 200ms;\n    ", ";\n\n    height: ", ';\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        cursor: not-allowed;\n    }\n    &:focus-visible {\n        border-width: ', ";\n        border-style: solid;\n        border-color: ", ";\n    }\n"])), function (e) {
      return e.disabled ? e.theme.Dialpad.Button.Container.disabled : (0, d.getBackgroundWithHoverCSS)(e.theme.Dialpad.Button.Container.backgroundColor, e.theme.Dialpad.Button.Container.lightHover, e.animate);
    }, function (e) {
      return e.compact ? "38px" : "56px";
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }), t.Caption = (0, u.default)("span")(l || (l = r(["\n    ", "\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    ", "\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (e) {
      return e.theme.Dialpad.Button.Caption;
    }, function (e) {
      return e.compact ? e.theme.tokens.fontSizes.fontSize30 : e.theme.tokens.fontSizes.fontSize50;
    }, function (e) {
      return e.compact ? e.theme.tokens.lineHeights.lineHeight30 : e.theme.tokens.lineHeights.lineHeight50;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }), t.Description = (0, u.default)("span")(c || (c = r(["\n    font-size: ", ";\n    line-height: ", ";\n    margin-left: ", "; /* Visually aligns caption under corresponding digit */\n    ", "\n\n    height: ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    margin-left: ", "; /* Visually aligns caption under corresponding digit */\n    ", "\n\n    height: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize10;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.theme.tokens.spacings.space10;
    }, function (e) {
      return e.theme.Dialpad.Button.Description;
    }, function (e) {
      return e.compact ? "8x" : "10px";
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallButton = t.DialerActions = t.DialerContainer = t.ClearInputButton = t.PhoneInputContainer = t.PhoneInput = void 0;
    var i,
      a,
      s,
      l,
      c,
      u,
      d = o(n(14)),
      f = o(n(40)),
      p = n(15);
    t.PhoneInput = (0, d.default)(f.default)(i || (i = r(["\n    display: flex;\n    flex-grow: 1;\n    font-size: 12px;\n    line-height: 1.33;\n    letter-spacing: normal;\n    input {\n        padding-right: 26px;\n    }\n"], ["\n    display: flex;\n    flex-grow: 1;\n    font-size: 12px;\n    line-height: 1.33;\n    letter-spacing: normal;\n    input {\n        padding-right: 26px;\n    }\n"]))), t.PhoneInputContainer = (0, d.default)("div")(a || (a = r(["\n    display: flex;\n    position: relative;\n    margin-bottom: 16px;\n"], ["\n    display: flex;\n    position: relative;\n    margin-bottom: 16px;\n"]))), t.ClearInputButton = (0, d.default)("button")(s || (s = r(["\n    display: flex;\n    align-items: center;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    visibility: ", ";\n    padding: 4px;\n    cursor: pointer;\n    color: ", ";\n    position: absolute;\n    outline: none;\n    border: none;\n    background: none;\n    padding: ", ";\n    :focus-visible {\n        padding: ", ";\n        border: ", " solid\n            ", ";\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    visibility: ", ";\n    padding: 4px;\n    cursor: pointer;\n    color: ", ";\n    position: absolute;\n    outline: none;\n    border: none;\n    background: none;\n    padding: ", ";\n    :focus-visible {\n        padding: ", ";\n        border: ", " solid\n            ", ";\n    }\n"])), function (e) {
      return e.isVisible ? "visible" : "hidden";
    }, function (e) {
      return e.theme.tokens.textColors.colorTextIconInverse;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }), t.DialerContainer = (0, d.default)("div")(l || (l = r(["\n    width: 100%;\n"], ["\n    width: 100%;\n"]))), t.DialerActions = (0, d.default)("div")(c || (c = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 16px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 16px;\n"]))), t.CallButton = (0, d.default)(p.IconButton)(u || (u = r(["\n    ", ";\n"], ["\n    ", ";\n"])), function (e) {
      return e.theme.Dialer.CallButton;
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core/MenuItem");
  }, function (e, t) {
    e.exports = require("@material-ui/core/Select");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createMuiTheme = t.getHover = void 0;
    var o = n(541);
    t.getHover = function (e, t) {
      var n = "rgba(0, 0, 0, 0.2)";
      t && (n = "rgba(255, 255, 255, 0.2)");
      var o = {
        backgroundColor: "" + n,
        backgroundBlendMode: "color"
      };
      return e && (o = r(r({}, o), {
        backgroundImage: "linear-gradient(to top, " + e + ", " + e + ")"
      })), o;
    }, t.createMuiTheme = function (e, t) {
      var n = e.textColors.colorText,
        i = {};
      return {
        palette: {
          action: {
            hover: "rgba(0, 0, 0, 0)"
          },
          primary: {
            main: e.backgroundColors.colorBackgroundPrimary,
            dark: e.backgroundColors.colorBackgroundPrimaryStronger
          },
          secondary: {
            main: e.backgroundColors.colorBackgroundBody,
            dark: e.backgroundColors.colorBackgroundPrimaryWeakest
          },
          success: {
            main: e.backgroundColors.colorBackgroundSuccess,
            dark: e.backgroundColors.colorBackgroundSuccessStronger
          },
          error: {
            main: e.backgroundColors.colorBackgroundDestructive,
            dark: e.backgroundColors.colorBackgroundDestructiveStronger
          },
          text: {
            primary: n,
            secondary: n,
            hint: n
          }
        },
        overrides: {
          MuiBreadcrumbs: {
            root: {
              fontSize: e.fontSizes.fontSize20,
              paddingBottom: e.spacings.space70
            },
            separator: {
              color: e.textColors.colorTextWeak,
              fontSize: e.fontSizes.fontSize30
            },
            li: {
              "& .MuiTypography-root": {
                fontSize: e.fontSizes.fontSize20
              }
            }
          },
          MuiButton: {
            contained: {
              alignSelf: "center",
              textTransform: "initial",
              boxShadow: "none",
              borderRadius: e.radii.borderRadius20,
              padding: e.spacings.space30 + " " + e.spacings.space40,
              fontSize: e.fontSizes.fontSize30,
              fontWeight: e.fontWeights.fontWeightSemibold,
              lineHeight: e.lineHeights.lineHeight30,
              borderWidth: e.borderWidths.borderWidth10,
              borderStyle: "solid",
              whiteSpace: "nowrap",
              "&:hover": {
                background: e.backgroundColors.colorBackgroundStrong,
                boxShadow: "none"
              },
              "&:active": {
                background: "rgba(255,255,255,0.3)",
                boxShadow: "none"
              },
              "&:focus-visible": {
                border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderNeutral,
                boxShadow: "0 0 0 " + e.borderWidths.borderWidth30 + " " + e.borderColors.colorBorderNeutral
              },
              "&$disabled": {
                opacity: .4
              },
              "&[aria-disabled=true]": {
                opacity: .4,
                cursor: "not-allowed"
              }
            },
            containedSizeSmall: {
              padding: e.spacings.space20 + " " + e.spacings.space30,
              minWidth: e.spacings.space10,
              fontSize: e.fontSizes.fontSize30
            },
            containedPrimary: {
              background: e.backgroundColors.colorBackgroundPrimary,
              color: e.textColors.colorTextWeakest,
              borderColor: e.borderColors.colorBorderPrimary,
              "&:hover": {
                borderColor: e.borderColors.colorBorderPrimaryStrong,
                background: e.backgroundColors.colorBackgroundPrimaryStronger
              },
              "&:focus-visible": {
                background: e.backgroundColors.colorBackgroundPrimaryStronger,
                border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderNeutral,
                boxShadow: "0 0 0 " + e.borderWidths.borderWidth30 + " " + e.borderColors.colorBorderNeutral
              },
              "&:active": {
                background: e.backgroundColors.colorBackgroundPrimaryStrong,
                borderColor: e.borderColors.colorBorderPrimaryStronger
              },
              "&$disabled": {
                background: e.backgroundColors.colorBackgroundPrimary,
                borderColor: e.borderColors.colorBorderPrimary,
                color: e.textColors.colorTextWeakest
              }
            },
            containedSecondary: {
              background: e.backgroundColors.colorBackgroundBody,
              color: e.textColors.colorText,
              borderColor: e.borderColors.colorBorder,
              "&:hover": {
                background: e.backgroundColors.colorBackgroundPrimaryWeakest,
                borderColor: e.borderColors.colorBorderPrimaryStrong
              },
              "&:focus-visible": {
                background: e.backgroundColors.colorBackgroundPrimaryWeakest,
                border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderNeutral,
                boxShadow: "0 0 0 " + e.borderWidths.borderWidth30 + " " + e.borderColors.colorBorderNeutral
              },
              "&:active": {
                background: e.backgroundColors.colorBackgroundPrimaryWeaker,
                borderColor: e.borderColors.colorBorderPrimaryStrong
              },
              "&$disabled": {
                background: e.backgroundColors.colorBackgroundBody,
                borderColor: e.borderColors.colorBorderPrimary,
                color: e.textColors.colorText
              }
            },
            endIcon: {
              marginLeft: e.spacings.space20,
              marginRight: e.spacings.space0,
              marginTop: "-" + e.spacings.space10,
              marginBottom: "-" + e.spacings.space10
            },
            startIcon: {
              marginLeft: e.spacings.space0,
              marginRight: e.spacings.space20,
              marginTop: "-" + e.spacings.space10,
              marginBottom: "-" + e.spacings.space10
            }
          },
          MuiIconButton: {
            root: {
              width: e.sizings.sizeSquare100,
              height: e.sizings.sizeSquare100,
              color: "inherit",
              background: "inherit",
              alignSelf: "center",
              borderColor: "transparent",
              borderWidth: e.borderWidths.borderWidth10,
              borderStyle: "solid",
              "&:hover": {
                borderWidth: e.borderWidths.borderWidth10,
                backgroundColor: e.backgroundColors.colorBackgroundStrong
              },
              "&:focus-visible": {
                borderWidth: e.borderWidths.borderWidth30,
                borderColor: e.borderColors.colorBorderNeutral,
                background: e.backgroundColors.colorBackgroundStrong
              },
              "&:active": {
                background: "rgba(255,255,255,0.3)"
              },
              "&:hover:focus-visible": {
                outline: 0
              },
              "&$disabled": {
                color: "inherit",
                opacity: .4
              },
              "&[aria-disabled=true]": {
                opacity: .4,
                cursor: "not-allowed",
                "&:hover:focus-visible": {
                  borderWidth: e.borderWidths.borderWidth30
                }
              }
            },
            sizeSmall: {
              width: e.sizings.sizeSquare80,
              height: e.sizings.sizeSquare80
            },
            colorPrimary: {
              color: e.textColors.colorTextWeakest,
              background: e.backgroundColors.colorBackgroundPrimary,
              borderColor: e.borderColors.colorBorderPrimary,
              "&:focus-visible": {
                borderWidth: e.borderWidths.borderWidth30,
                borderColor: e.borderColors.colorBorderNeutral,
                background: e.backgroundColors.colorBackgroundPrimaryStronger
              },
              "&:hover": {
                borderColor: e.borderColors.colorBorderPrimaryStrong,
                backgroundColor: e.backgroundColors.colorBackgroundPrimaryStronger
              },
              "&:active": {
                background: e.backgroundColors.colorBackgroundPrimaryStrong,
                borderColor: e.borderColors.colorBorderPrimaryStronger
              },
              "&$disabled": {
                background: e.backgroundColors.colorBackgroundPrimary,
                borderColor: e.borderColors.colorBorderPrimary,
                color: e.textColors.colorTextWeakest,
                opacity: .4
              }
            },
            colorSecondary: {
              background: e.backgroundColors.colorBackgroundBody,
              color: e.textColors.colorTextIcon,
              borderColor: e.borderColors.colorBorder,
              "&:focus-visible": {
                background: e.backgroundColors.colorBackgroundPrimaryWeakest,
                borderWidth: e.borderWidths.borderWidth30,
                borderColor: e.borderColors.colorBorderNeutral
              },
              "&:hover": {
                background: e.backgroundColors.colorBackgroundPrimaryWeakest,
                borderColor: e.borderColors.colorBorderStrong
              },
              "&:active": {
                background: e.backgroundColors.colorBackgroundPrimaryWeaker,
                borderColor: e.borderColors.colorBorderStrong
              },
              "&$disabled": {
                background: e.backgroundColors.colorBackgroundBody,
                borderColor: e.borderColors.colorBorder,
                color: e.textColors.colorTextIcon,
                opacity: .4
              }
            }
          },
          MuiFormLabel: {
            root: {
              marginBottom: e.spacings.space30,
              marginTop: e.spacings.space30,
              color: e.textColors.colorText,
              fontSize: e.fontSizes.fontSize30,
              fontWeight: e.fontWeights.fontWeightSemibold,
              lineHeight: e.lineHeights.lineHeight20
            }
          },
          MuiFormHelperText: {
            root: {
              fontSize: e.fontSizes.fontSize30,
              lineHeight: e.lineHeights.lineHeight30,
              color: e.textColors.colorText,
              padding: e.spacings.space0,
              margin: e.spacings.space0,
              "&$error": {
                color: e.textColors.colorTextError
              }
            }
          },
          MuiInput: {
            root: {
              color: n,
              boxShadow: "none",
              background: e.backgroundColors.colorBackgroundBody,
              borderWidth: e.borderWidths.borderWidth10,
              borderStyle: "solid",
              borderColor: e.borderColors.colorBorder,
              borderRadius: e.radii.borderRadius20,
              fontSize: e.fontSizes.fontSize30,
              fontWeight: e.fontWeights.fontWeightNormal,
              lineHeight: e.lineHeights.lineHeight20,
              overflow: "hidden",
              "&$disabled": {
                borderColor: e.borderColors.colorBorder,
                color: e.textColors.colorText,
                opacity: .4,
                cursor: "not-allowed",
                "& input": {
                  cursor: "not-allowed"
                }
              },
              "&[aria-disabled=true]": {
                opacity: .4,
                caretColor: "transparent",
                cursor: "not-allowed",
                color: e.textColors.colorText,
                "& input": {
                  cursor: "not-allowed"
                }
              },
              "&$error": {
                border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderError,
                boxShadow: "none"
              },
              "&$focused": {
                background: e.backgroundColors.colorBackgroundBody,
                border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderNeutral,
                boxShadow: "0 0 0 " + e.borderWidths.borderWidth30 + " " + e.borderColors.colorBorderNeutral
              }
            },
            input: {
              paddingTop: e.spacings.space30,
              paddingBottom: e.spacings.space30,
              paddingLeft: e.spacings.space40,
              paddingRight: e.spacings.space40,
              minHeight: e.sizings.sizeSquare100,
              boxSizing: "border-box"
            }
          },
          MuiInputAdornment: {
            root: {
              background: e.backgroundColors.colorBackground,
              height: "100%",
              maxHeight: "100%",
              padding: e.spacings.space0 + " " + e.spacings.space30,
              margin: e.spacings.space0,
              boxSizing: "border-box"
            },
            positionStart: {
              marginRight: e.spacings.space0
            }
          },
          MuiMenuItem: {
            root: {
              color: e.textColors.colorText,
              paddingTop: e.spacings.space30,
              paddingBottom: e.spacings.space30,
              paddingLeft: e.spacings.space70,
              paddingRight: e.spacings.space70,
              fontSize: e.fontSizes.fontSize30,
              lineHeight: e.lineHeights.lineHeight30,
              "&:hover": {
                backgroundColor: e.backgroundColors.colorBackgroundPrimaryWeakest
              },
              "&:focus-visible": {
                backgroundColor: e.backgroundColors.colorBackgroundPrimaryWeakest
              }
            }
          },
          MuiPaper: {
            root: {
              backgroundColor: e.backgroundColors.colorBackgroundBody,
              fontFamily: e.fonts.fontFamilyText
            }
          },
          MuiModal: {
            root: {
              fontFamily: e.fonts.fontFamilyText
            }
          },
          MuiSelect: {
            root: {
              backgroundColor: e.backgroundColors.colorBackgroundBody,
              borderColor: e.borderColors.colorBorder,
              paddingRight: e.spacings.space90
            },
            select: {
              "&[aria-pressed='true'] ~ .Twilio-Dropdown": {
                transform: "scaleY(-1)"
              },
              "&$disabled": {
                borderColor: i.disabledColor,
                color: i.disabledColor,
                cursor: "not-allowed",
                "& ~ div > svg": {
                  color: "inherit"
                }
              },
              fontSize: e.fontSizes.fontSize30,
              paddingRight: e.spacings.space90 + " !important",
              borderRadius: e.radii.borderRadius20
            },
            icon: {
              top: 6,
              right: e.spacings.space30,
              color: e.textColors.colorTextIcon
            }
          },
          MuiList: {
            root: {
              borderRadius: e.radii.borderRadius20,
              border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderWeak
            }
          },
          MuiListItem: {
            root: {
              fontSize: e.fontSizes.fontSize30
            },
            button: {
              "&:hover": {
                backgroundColor: e.backgroundColors.colorBackgroundPrimaryWeakest
              },
              "&:focus-visible": {
                backgroundColor: e.backgroundColors.colorBackgroundPrimaryWeakest
              }
            }
          },
          MuiListSubheader: {
            root: {
              paddingTop: e.spacings.space50,
              paddingBottom: e.spacings.space30,
              lineHeight: e.lineHeights.lineHeight30,
              fontWeight: e.fontWeights.fontWeightBold
            }
          },
          MuiLink: {
            root: {
              color: e.textColors.colorTextLink,
              cursor: "pointer"
            }
          },
          MuiTable: {
            root: {
              tableLayout: "fixed",
              borderRadius: e.radii.borderRadius20
            }
          },
          MuiTableHead: {
            root: {
              backgroundColor: e.backgroundColors.colorBackground
            }
          },
          MuiTableRow: {
            head: {
              height: e.spacings.space120,
              paddingTop: e.spacings.space40,
              paddingBottom: e.spacings.space40,
              "&:hover": {
                background: "transparent"
              }
            },
            root: {
              height: e.sizings.sizeSquare140,
              "&$selected": {
                backgroundColor: "inherit",
                background: e.backgroundColors.colorBackgroundRowStriped
              },
              "&$hover:hover": {
                background: e.backgroundColors.colorBackgroundRowStriped,
                backgroundColor: e.backgroundColors.colorBackgroundRowStriped
              }
            }
          },
          MuiTableCell: {
            root: {
              padding: e.spacings.space0,
              borderBottom: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderWeaker,
              fontSize: e.fontSizes.fontSize30,
              color: e.textColors.colorText,
              "&:first-child": {
                paddingLeft: e.spacings.space30
              }
            },
            head: {
              borderBottomWidth: e.borderWidths.borderWidth20,
              borderBottom: e.borderWidths.borderWidth20 + " solid " + e.borderColors.colorBorderWeaker,
              fontSize: e.fontSizes.fontSize30,
              fontWeight: e.fontWeights.fontWeightSemibold,
              lineHeight: e.lineHeights.lineHeight30,
              "&:first-child": {
                paddingLeft: e.spacings.space40
              }
            },
            body: {
              fontSize: e.fontSizes.fontSize30,
              color: e.textColors.colorText,
              verticalAlign: "middle"
            }
          },
          MuiSwitch: {
            root: {
              overflow: "visible",
              fontSize: e.fontSizes.fontSize30,
              lineHeight: e.lineHeights.lineHeight30,
              padding: e.spacings.space0,
              marginRight: e.spacings.space40,
              width: e.sizings.sizeSquare120,
              height: e.sizings.sizeSquare70,
              "& .Mui-focusVisible + $track": {
                boxShadow: "0 0 0 4px " + e.borderColors.colorBorderNeutral
              },
              "&:hover $track": {
                backgroundColor: e.backgroundColors.colorBackgroundStrongest
              },
              "&:hover $checked.Mui-checked + $track": {
                backgroundColor: e.backgroundColors.colorBackgroundSuccessStrong
              }
            },
            track: {
              width: e.sizings.sizeSquare120,
              height: e.sizings.sizeSquare70,
              backgroundColor: e.backgroundColors.colorBackgroundStronger,
              borderRadius: e.sizings.sizeSquare40,
              opacity: 1
            },
            switchBase: r({
              width: e.sizings.sizeSquare50,
              height: e.sizings.sizeSquare50,
              padding: e.spacings.space0,
              margin: e.spacings.space20,
              border: e.borderWidths.borderWidth0,
              color: e.backgroundColors.colorBackgroundBody,
              "&.Mui-disabled.Mui-checked + $track:hover": {
                backgroundColor: e.backgroundColors.colorBackgroundAvailable
              },
              "&.MuiSwitch-switchBase.Mui-checked:hover": {
                background: "transparent"
              },
              "&.MuiSwitch-switchBase:hover": {
                background: "transparent"
              },
              "&$checked.Mui-checked": {
                color: e.backgroundColors.colorBackgroundBody
              },
              "&$checked.Mui-checked + $track": {
                backgroundColor: e.backgroundColors.colorBackgroundSuccess,
                opacity: 1
              }
            }, !t && {
              "&.MuiSwitch-switchBase.Mui-disabled + $track": {
                backgroundColor: e.backgroundColors.colorBackgroundStronger,
                opacity: 1
              },
              "&.MuiSwitch-switchBase.Mui-disabled.Mui-checked +$track": {
                backgroundColor: e.backgroundColors.colorBackgroundAvailable
              },
              "&.MuiSwitch-switchBase.Mui-disabled": {
                opacity: 1,
                color: e.backgroundColors.colorBackgroundBody
              }
            }),
            thumb: {
              width: e.sizings.sizeSquare50,
              height: e.sizings.sizeSquare50,
              borderWidth: e.borderWidths.borderWidth0
            }
          },
          MuiTabs: {
            root: {
              borderBottom: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderWeak,
              minHeight: "auto"
            },
            indicator: {
              backgroundColor: e.backgroundColors.colorBackgroundPrimary
            }
          },
          MuiTab: {
            root: {
              fontSize: e.fontSizes.fontSize30,
              fontWeight: e.fontWeights.fontWeightBold,
              lineHeight: e.lineHeights.lineHeight20,
              marginRight: e.spacings.space70,
              minHeight: "auto",
              padding: e.spacings.space30,
              textTransform: "normal",
              "&.MuiTab-textColorInherit:not(.Mui-selected)": {
                opacity: 1,
                color: e.textColors.colorText
              },
              "&$selected": {
                color: e.textColors.colorTextLink
              },
              "&.MuiButtonBase-root": {
                minWidth: "auto"
              }
            }
          },
          MuiFormGroup: {},
          MuiFormControlLabel: {
            root: {
              padding: e.spacings.space0,
              marginLeft: e.spacings.space0,
              marginRight: e.spacings.space40,
              fontSize: e.fontSizes.fontSize30,
              color: e.textColors.colorText,
              lineHeight: e.lineHeights.lineHeight20,
              "&$disabled": {
                cursor: "not-allowed"
              }
            },
            label: r({
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              alignSelf: "center",
              margin: e.spacings.space0,
              marginRight: e.spacings.space30
            }, !t && {
              "&$disabled": {
                color: e.textColors.colorTextWeak
              }
            })
          },
          MuiInputLabel: {
            root: {
              marginBottom: e.spacings.space20,
              marginTop: e.spacings.space20,
              color: e.textColors.colorText,
              fontSize: e.fontSizes.fontSize30,
              fontWeight: e.fontWeights.fontWeightSemibold,
              lineHeight: e.lineHeights.lineHeight20
            }
          },
          MuiCheckbox: {
            root: {
              border: "none",
              borderRadius: e.radii.borderRadius10,
              background: "none",
              padding: e.spacings.space0,
              margin: e.spacings.space30,
              marginLeft: e.spacings.space10,
              width: e.sizings.sizeSquare50,
              height: e.sizings.sizeSquare50,
              "&:focus-visible": {
                border: "none",
                background: "none",
                boxShadow: "0 0 0 " + e.borderWidths.borderWidth30 + " " + e.borderColors.colorBorderNeutral
              },
              "&$colorPrimary": {
                color: e.borderColors.colorBorder,
                "&:hover": {
                  color: e.borderColors.colorBorderPrimary,
                  background: "none",
                  border: "none"
                },
                "&:focus-visible": {
                  color: e.borderColors.colorBorderPrimaryStrong
                },
                "&$checked": {
                  color: e.borderColors.colorBorderNeutral,
                  "&:hover": {
                    color: e.borderColors.colorBorderPrimaryStrong
                  },
                  "&:focus-visible": {
                    color: e.borderColors.colorBorderPrimaryStrong
                  }
                },
                "&$disabled": {
                  background: "none",
                  border: "none",
                  color: e.borderColors.colorBorder,
                  opacity: "0.4",
                  "&$checked": {
                    color: e.borderColors.colorBorderNeutral
                  }
                }
              },
              "&$colorSecondary": {
                color: e.borderColors.colorBorderError,
                "&:hover": {
                  color: e.borderColors.colorBorderPrimary,
                  background: "none",
                  border: "none"
                },
                "&$checked": {
                  color: e.borderColors.colorBorderError,
                  "&:hover": {
                    color: e.borderColors.colorBorderPrimaryStrong
                  }
                },
                "&$disabled": {
                  background: "none",
                  border: "none",
                  color: e.borderColors.colorBorder,
                  opacity: "0.4",
                  "&$checked": {
                    color: e.borderColors.colorBorderNeutral
                  }
                }
              }
            }
          },
          MuiDialog: {
            paper: {
              background: e.backgroundColors.colorBackgroundBody,
              color: e.textColors.colorText
            }
          },
          MuiAccordion: {
            root: {
              backgroundColor: "inherit",
              border: e.borderWidths.borderWidth10 + " solid " + e.borderColors.colorBorderWeak,
              boxShadow: "none",
              boxSizing: "border-box",
              position: "static"
            }
          },
          MuiPopover: {
            root: {
              fontFamily: e.fonts.fontFamilyText
            }
          }
        },
        props: {
          MuiButtonBase: {
            disableRipple: !0
          },
          MuiInput: {
            disableUnderline: !0
          },
          MuiSelect: {
            MenuProps: {
              anchorOrigin: {
                horizontal: "left",
                vertical: "bottom"
              },
              getContentAnchorEl: null,
              marginThreshold: 0
            },
            IconComponent: o.SelectDropDownIcon
          }
        },
        typography: {
          useNextVariants: !0,
          fontFamily: e.fonts.fontFamilyText
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersList = t.FiltersListItemType = void 0;
    var u = c(n(92)),
      d = l(n(0)),
      f = n(9),
      p = n(6),
      h = n(548),
      v = n(549),
      m = n(552),
      g = n(555);
    !function (e) {
      e.multiValue = "multiValue";
    }(t.FiltersListItemType || (t.FiltersListItemType = {}));
    var b = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          currentFilters: {},
          expandedFilterId: "",
          selectedLegacyFilterQuery: ""
        }, t.hasFilterApplied = function () {
          return !f.Utils.haveSameValues(t.props.defaultFilters, t.state.currentFilters, {
            equalUndefinedToEmptyArray: !0
          }) || "" !== t.state.selectedLegacyFilterQuery;
        }, t.hasAllChangesApplied = function () {
          return f.Utils.haveSameValues(t.props.appliedFilters, t.state.currentFilters, {
            equalUndefinedToEmptyArray: !0
          }) && t.props.appliedLegacyFilterQuery === t.state.selectedLegacyFilterQuery;
        }, t.handleFilterChange = function (e) {
          return function (n) {
            t.setState(function (t) {
              var r;
              return {
                currentFilters: i(i({}, t.currentFilters), (r = {}, r[e] = n, r))
              };
            });
          };
        }, t.handleSubmit = function (e) {
          e.preventDefault(), t.applyFilters();
        }, t.handleReset = function (e) {
          e.preventDefault();
          var n = t.props.defaultFilters;
          t.setState({
            currentFilters: i({}, n),
            selectedLegacyFilterQuery: ""
          }), t.props.applyFilters(n);
        }, t.handleExpandClick = function (e) {
          t.setState(function (t) {
            return {
              expandedFilterId: t.expandedFilterId === e ? "" : e
            };
          });
        }, t.handleSelectLegacyFilter = function (e) {
          t.setState({
            selectedLegacyFilterQuery: e
          });
        }, t;
      }
      return o(t, e), t.getDerivedStateFromProps = function (e, t) {
        return i(i({}, t), {
          currentFilters: (0, u.default)(e.appliedFilters, t.lastAppliedFilters) ? t.currentFilters : e.appliedFilters,
          lastAppliedFilters: e.appliedFilters
        });
      }, t.getDefaultFilterValues = function (e) {
        return e.reduce(function (e, t) {
          if (!t.options) return e;
          var n = t.options.filter(function (e) {
            return e.default;
          }).map(function (e) {
            return e.value;
          });
          return n.length && (e[t.id] = n), e;
        }, {});
      }, t.prototype.render = function () {
        var e = this,
          t = this.props,
          n = t.label,
          r = t.resetLabel,
          o = t.applyLabel,
          a = t.filters,
          s = t.actionsDisabled;
        return d.createElement(h.Form, {
          onSubmit: this.handleSubmit
        }, d.createElement(p.FlexBox, {
          vertical: !0
        }, a.map(function (t) {
          return d.createElement(m.FiltersListItem, i({}, t, {
            key: t.id,
            handleChange: e.handleFilterChange(t.id),
            currentValue: e.state.currentFilters[t.id],
            isExpanded: e.state.expandedFilterId === t.id,
            handleExpandClick: e.handleExpandClick,
            showExpandToggle: a.length > 1
          }));
        }), this.props.legacyFilters && this.props.legacyFilters.length > 0 && d.createElement(g.LegacyFiltersItem, {
          filters: this.props.legacyFilters,
          onSelectLegacyFilterQuery: this.handleSelectLegacyFilter,
          selectedLegacyFilterQuery: this.state.selectedLegacyFilterQuery
        })), d.createElement(v.FiltersListButtons, {
          label: n,
          handleResetClick: this.handleReset,
          applyLabel: o,
          resetLabel: r,
          applyButtonDisabled: s,
          resetButtonDisabled: !this.hasFilterApplied() && this.hasAllChangesApplied() || s
        }));
      }, t.prototype.applyFilters = function () {
        this.props.applyFilters(this.state.currentFilters, this.state.selectedLegacyFilterQuery);
      }, t.defaultProps = {
        actionsDisabled: !1
      }, t;
    }(d.Component);
    t.FiltersList = b;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FieldContainer = t.ExpandIconWrapper = t.ExpandIconButton = t.Label = t.Title = t.Header = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      d = n(15),
      f = n(1);
    t.Container = f.styled.div(o || (o = r(["\n    padding: ", ";\n    transition: background-color 0.2s, padding-bottom 0.2s;\n    ", ";\n    ", "\n"], ["\n    padding: ", ";\n    transition: background-color 0.2s, padding-bottom 0.2s;\n    ", ";\n    ", "\n"])), function (e) {
      var t = e.theme;
      return t.tokens.spacings.space30 + " " + t.tokens.spacings.space0;
    }, function (e) {
      return e.theme.FilterList.ItemContainer;
    }, function (e) {
      return e.showExpandToggle && e.isExpanded && e.theme.FilterList.ItemContainerExpanded;
    }), t.Header = f.styled.label(i || (i = r(["\n    padding: ", ";\n    flex-grow: 1;\n    display: flex;\n    align-items: flex-start;\n    cursor: ", ";\n"], ["\n    padding: ", ";\n    flex-grow: 1;\n    display: flex;\n    align-items: flex-start;\n    cursor: ", ";\n"])), function (e) {
      var t = e.theme;
      return t.tokens.spacings.space0 + " " + t.tokens.spacings.space50;
    }, function (e) {
      return e.showExpandToggle ? "pointer" : "default";
    }), t.Title = f.styled.h4(a || (a = r(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    margin-bottom: ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    margin-bottom: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }), t.Label = f.styled.div(s || (s = r(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightNormal;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextWeak;
    }), t.ExpandIconButton = (0, f.styled)(d.IconButton)(l || (l = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return !e.isExpanded && "transform: rotate(-90deg);";
    }), t.ExpandIconWrapper = f.styled.div(c || (c = r(["\n    margin-left: ", ";\n    margin-right: ", ";\n    margin-top: ", ";\n"], ["\n    margin-left: ", ";\n    margin-right: ", ";\n    margin-top: ", ";\n"])), function (e) {
      return "-" + e.theme.tokens.spacings.space30;
    }, function (e) {
      return "-" + e.theme.tokens.spacings.space20;
    }, function (e) {
      return "-" + e.theme.tokens.spacings.space20;
    }), t.FieldContainer = f.styled.div(u || (u = r(["\n    display: ", ";\n    padding: ", ";\n"], ["\n    display: ", ";\n    padding: ", ";\n"])), function (e) {
      return e.isExpanded || !e.showExpandToggle ? "block" : "none";
    }, function (e) {
      var t = e.theme;
      return t.tokens.spacings.space30 + " " + t.tokens.spacings.space50;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.StyledSelect = void 0;
    var i,
      a,
      s = n(1),
      l = o(n(153)),
      c = n(22);
    t.StyledSelect = (0, s.styled)(l.default)(i || (i = r(['\n    width: 100%;\n\n    [class*="MuiSelect-selectMenu"] {\n        border-color: ', ";\n    }\n"], ['\n    width: 100%;\n\n    [class*="MuiSelect-selectMenu"] {\n        border-color: ', ";\n    }\n"])), function (e) {
      return e.error ? e.theme.tokens.textColors.colorTextError : "";
    }), t.Container = (0, s.styled)(c.FieldContainer)(a || (a = r(["\n    select {\n        width: 100%;\n        display: block;\n        clear: both;\n    }\n\n    ", "\n"], ["\n    select {\n        width: 100%;\n        display: block;\n        clear: both;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.FormComponents.Select;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(559), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(561), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(563), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(564), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(566), t), o(n(163), t);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThumbButton = t.ThumbDirections = void 0;
    var l = s(n(0)),
      c = n(4),
      u = n(568);
    !function (e) {
      e[e.up = 0] = "up", e[e.down = 1] = "down";
    }(t.ThumbDirections || (t.ThumbDirections = {}));
    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleClick = function () {
          t.props.handleClick(t.props.direction);
        }, t;
      }
      return o(t, e), t.prototype.render = function () {
        return l.createElement(u.ThumbButtonContainer, null, l.createElement("div", {
          role: "presentation",
          className: this.props.selected ? "circle-selected" : "circle",
          onClick: this.handleClick
        }, l.createElement(c.Icon, {
          icon: this.props.selected ? this.props.icon + "-bold" : this.props.icon
        })));
      }, t;
    }(l.PureComponent);
    t.ThumbButton = d;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LegendItem = t.LabelPosition = void 0;
    var l,
      c = s(n(0)),
      u = n(572);
    !function (e) {
      e.Start = "start", e.End = "end";
    }(l = t.LabelPosition || (t.LabelPosition = {}));
    var d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.label,
          n = e.color,
          r = e.displayValue,
          o = e.value,
          i = e.showLabel,
          a = e.renderMarker,
          s = i && c.createElement(u.Label, null, t);
        return c.createElement(u.ItemWrapper, {
          className: "Twilio-LegendItem-ItemWrapper"
        }, this.props.labelPosition === l.Start && s, c.createElement(u.ValueWrapper, null, a ? a(this.props) : c.createElement(u.Disc, {
          className: "Twilio-LegendItem-Disk",
          "aria-label": t,
          color: n
        }), c.createElement(u.Value, {
          className: "Twilio-LegendItem-Value",
          "data-test": t
        }, r || o)), this.props.labelPosition === l.End && s);
      }, t.defaultProps = {
        showLabel: !0,
        labelPosition: l.End
      }, t;
    }(c.PureComponent);
    t.LegendItem = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledUl = void 0;
    var o,
      i = n(1);
    t.StyledUl = (0, i.styled)("ul")(o || (o = r(["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n        display: flex;\n    }\n\n    ", "\n    ", "\n"], ["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n        display: flex;\n    }\n\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.Menu.Items;
    }, function (e) {
      return e.styleOverride && e.styleOverride.Items;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopupProps = t.ModalPopup = void 0;
    var r = n(578);
    Object.defineProperty(t, "ModalPopup", {
      enumerable: !0,
      get: function () {
        return r.ModalPopup;
      }
    }), Object.defineProperty(t, "ModalPopupProps", {
      enumerable: !0,
      get: function () {
        return r.ModalPopupProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScreenReaderNotificationHandler = t.ScreenReaderNotificationHandlerImpl = void 0;
    var i = n(13),
      a = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.id = i.DefaultNotificationHandlerType.ScreenReader, t;
        }
        return o(t, e), t.prototype.canHandleNotification = function (e) {
          var t = !e.isApplicable || e.isApplicable(e);
          return !!e.content && t;
        }, t.prototype.handleNotification = function (e) {
          this.activeNotification = e, this.notifyChanged();
        }, t.prototype.dismissNotification = function () {
          this.activeNotification = null, this.notifyChanged();
        }, t.prototype.getActiveNotifications = function () {
          return this.activeNotification;
        }, t.prototype.notifyChanged = function () {
          i.Notifications.emit(i.NotificationEvent.notificationStatusChanged);
        }, t;
      }(n(76).BaseNotificationHandler);
    t.ScreenReaderNotificationHandlerImpl = a, t.ScreenReaderNotificationHandler = new a(), i.Notifications.registerHandler(t.ScreenReaderNotificationHandler);
  }, function (e, t) {
    e.exports = require("@dnd-kit/core");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Strings = t.languages = void 0;
    var o = r(n(616)),
      i = n(617);
    Object.defineProperty(t, "Strings", {
      enumerable: !0,
      get: function () {
        return i.Strings;
      }
    });
    var a = {
      default: o.default
    };
    t.languages = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      l = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TXN_WRITE = void 0;
    var c = i(n(623)),
      u = l(n(624));
    t.TXN_WRITE = "readwrite";
    var d = !1,
      f = new Map(),
      p = function () {
        function e() {}
        return e.openDB = function () {
          return a(this, void 0, void 0, function () {
            var e, t, n, r;
            return s(this, function (o) {
              switch (o.label) {
                case 0:
                  if (d) return [2, f];
                  e = function (e) {
                    var t, n, r, o;
                    return s(this, function (i) {
                      switch (i.label) {
                        case 0:
                          return t = e.databaseName, n = e.version, r = e.stores, [4, c.openDB(t, n, {
                            upgrade: function (e, t, n) {
                              0 !== t && n && n > t && r.forEach(function (t) {
                                var n = t.name;
                                e.deleteObjectStore(n);
                              }), r.forEach(function (t) {
                                var n = t.name,
                                  r = t.key,
                                  o = t.config,
                                  i = (void 0 === o ? {} : o).autoIncrement;
                                e.createObjectStore(n, {
                                  keyPath: r,
                                  autoIncrement: i
                                }), console.info("STORE CREATED: " + n);
                              });
                            }
                          })];
                        case 1:
                          return o = i.sent(), console.info("DB OPENED: " + t), f.set(t, o), [2];
                      }
                    });
                  }, t = 0, n = u.default, o.label = 1;
                case 1:
                  return t < n.length ? (r = n[t], [5, e(r)]) : [3, 4];
                case 2:
                  o.sent(), o.label = 3;
                case 3:
                  return t++, [3, 1];
                case 4:
                  return d = !0, [2, f];
              }
            });
          });
        }, e;
      }();
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.useDB = void 0;
    var a = n(0),
      s = i(n(170));
    t.useDB = function () {
      var e = this,
        t = (0, a.useState)(),
        n = t[0],
        i = t[1];
      return (0, a.useEffect)(function () {
        r(e, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, s.default.openDB()];
              case 1:
                return e = t.sent(), i(e), [2];
            }
          });
        });
      }, []), n;
    };
  }, function (e, t) {
    e.exports = require("loglevel");
  }, function (e, t) {
    e.exports = require("axios");
  }, function (e, t) {
    e.exports = require("lodash.startcase");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AudioErrorCode = t.AudioPlayerError = t.MediaData = t.AudioPlayerManager = void 0;
    var r = n(176);
    Object.defineProperty(t, "AudioPlayerManager", {
      enumerable: !0,
      get: function () {
        return r.AudioPlayerManager;
      }
    }), Object.defineProperty(t, "MediaData", {
      enumerable: !0,
      get: function () {
        return r.MediaData;
      }
    });
    var o = n(82);
    Object.defineProperty(t, "AudioPlayerError", {
      enumerable: !0,
      get: function () {
        return o.AudioPlayerError;
      }
    }), Object.defineProperty(t, "AudioErrorCode", {
      enumerable: !0,
      get: function () {
        return o.AudioErrorCode;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AudioPlayerManager = void 0;
    var o = n(81),
      i = n(3),
      a = r(n(177)),
      s = n(178),
      l = function () {
        function e() {
          var e = this;
          this.onAudioEnd = function (t, n) {
            return function () {
              t(), e.medias.delete(n);
            };
          }, this.repeatableMediaManager = this.initMediaManager(), this.nonRepeatableMediaManager = this.initMediaManager(1), this.medias = new Map();
        }
        return e.prototype.initMediaManager = function (e) {
          return {
            queue: new s.MediaQueue(e),
            audioPlayer: new a.default()
          };
        }, e.prototype.getMediaManager = function (e) {
          return e.repeatable ? this.repeatableMediaManager : this.nonRepeatableMediaManager;
        }, e.prototype.play = function (e, t) {
          var n = this,
            r = (0, o.v4)();
          try {
            var a = this.getMediaManager(e);
            a.queue.enqueue(r, function (o) {
              a.audioPlayer.play(e.url, e.repeatable, n.onAudioEnd(o, r), t);
            }), this.medias.set(r, e);
          } catch (e) {
            i.log.warn(e);
          }
          return r;
        }, e.prototype.stop = function (e) {
          if (this.medias.has(e)) {
            var t = this.medias.get(e),
              n = this.getMediaManager(t);
            n.queue.isProcessing(e) && n.audioPlayer.stop(), n.queue.dequeue(e), this.medias.delete(e);
          }
        }, e.prototype.toggleSound = function (e) {
          this.repeatableMediaManager.audioPlayer.toggleSound(e), this.nonRepeatableMediaManager.audioPlayer.toggleSound(e);
        }, e;
      }();
    t.AudioPlayerManager = new l();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(12),
      i = n(16),
      a = n(3),
      s = n(82),
      l = function () {
        function e() {
          var e = this;
          this.isPlaying = !1, this.handleAudioEnded = function () {
            e.isPlaying = !1, e.audio.removeEventListener("ended", e.handleAudioEnded), e.onAudioEnd();
          }, this.audio = new Audio(), this.playInitialAudio();
        }
        return e.prototype.playInitialAudio = function () {
          var e = new Audio("https://media.twiliocdn.com/sdk/js/client/sounds/releases/1.0.0/incoming.mp3");
          e.muted = !0, e.play().then(function () {
            e.pause(), a.log.info("Initial audio play successful");
          }).catch(function () {
            return a.log.warn("Could not play initial audio");
          });
        }, e.prototype.play = function (e, t, n, r) {
          if (!e) throw o.ErrorManager.createAndProcessError(i.ErrorMessages.AUDIO_PLAYER_MEDIA_URL_MISSING, {
            description: "Trying to play a media element without providing a mediaUrl",
            context: "AudioPlayer"
          });
          this.audio.src = e, this.audio.currentTime = 0, this.audio.loop = t, this.onAudioEnd = n, this.onError = r, this.audio.addEventListener("ended", this.handleAudioEnded), this.playAudio();
        }, e.prototype.playAudio = function () {
          var e = this;
          this.audio.play().then(function () {
            e.isPlaying = !0, a.log.info("Play successful");
          }).catch(function (t) {
            e.handlePlayError(t);
          });
        }, e.prototype.handlePlayError = function (e) {
          a.log.warn("Error playing audio: " + e);
          var t = this.getAudioPlayerError(e);
          this.onError && this.onError(t), t.code === s.AudioErrorCode.NotAllowed ? this.handlePlayNotAllowedError() : this.audio.dispatchEvent(new Event("ended"));
        }, e.prototype.getAudioPlayerError = function (e) {
          var t = {
            name: e.name,
            message: e.message
          };
          switch (e.name) {
            case "NotAllowedError":
              return r({
                code: s.AudioErrorCode.NotAllowed
              }, t);
            case "NotSupportedError":
              return r({
                code: s.AudioErrorCode.InvalidMedia
              }, t);
            default:
              return r({
                code: s.AudioErrorCode.Other
              }, t);
          }
        }, e.prototype.handlePlayNotAllowedError = function () {
          var e = this,
            t = function () {
              window.removeEventListener("click", n);
            },
            n = function () {
              t(), e.playAudio();
            },
            r = function () {
              t(), e.audio.removeEventListener("ended", r);
            };
          window.addEventListener("click", n), this.audio.addEventListener("ended", r);
        }, e.prototype.stop = function () {
          this.isPlaying && this.audio.pause(), this.audio.dispatchEvent(new Event("ended"));
        }, e.prototype.toggleSound = function (e) {
          this.audio.muted = e;
        }, e;
      }();
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaQueue = void 0;
    var o = r(n(179)),
      i = n(12),
      a = n(16),
      s = function () {
        function e(e) {
          var t = this;
          void 0 === e && (e = 1 / 0), this.onCurrentJobFinished = function (e) {
            t.currentJob = void 0, t.deleteJob(e);
          }, this.deleteJob = function (e) {
            t.jobs.forEach(function (n, r) {
              n === e && t.jobs.delete(r);
            });
          }, this.queue = new o.default({
            concurrency: 1,
            autostart: !0
          }), this.maxQueueSize = e, this.jobs = new Map(), this.subscribeToEvents();
        }
        return e.prototype.subscribeToEvents = function () {
          var e = this;
          this.queue.on("start", function (t) {
            e.currentJob = t;
          }), this.queue.on("success", function (t, n) {
            e.onCurrentJobFinished(n);
          }), this.queue.on("timeout", function (t, n) {
            e.onCurrentJobFinished(n), t();
          });
        }, e.prototype.enqueue = function (e, t) {
          if (this.queue.length + (this.currentJob ? 1 : 0) >= this.maxQueueSize) throw i.ErrorManager.createAndProcessError(a.ErrorMessages.MEDIA_QUEUE_SIZE, {
            context: "AudioPlayer"
          });
          if (this.jobs.has(e)) throw i.ErrorManager.createAndProcessError(a.ErrorMessages.MEDIA_ALREADY_ENQUEUED, {
            context: "AudioPlayer"
          });
          var n = function (e) {
            t(e);
          };
          this.queue.push(n), this.jobs.set(e, n);
        }, e.prototype.dequeue = function (e) {
          if (this.jobs.has(e)) {
            var t = this.jobs.get(e),
              n = this.queue.indexOf(t);
            n >= 0 && this.queue.splice(n, 1), this.jobs.delete(e);
          }
        }, e.prototype.isProcessing = function (e) {
          var t = this.jobs.get(e);
          return !!t && !!this.currentJob && this.currentJob === t;
        }, e;
      }();
    t.MediaQueue = s;
  }, function (e, t) {
    e.exports = require("queue");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.setChatReducerOptions = t.chatReducer = void 0;
    var s = a(n(83)),
      l = n(181),
      c = n(84);
    Object.defineProperty(t, "setChatReducerOptions", {
      enumerable: !0,
      get: function () {
        return c.setChatReducerOptions;
      }
    });
    var u = i(n(85)),
      d = i(n(182)),
      f = i(n(90)),
      p = i(n(35)),
      h = i(n(87)),
      v = i(n(46)),
      m = i(n(91)),
      g = n(92),
      b = {},
      y = function () {
        return b;
      },
      _ = (0, s.default)(function (e) {
        return void 0 === e && (e = {}), (0, l.combineReducers)({
          conversations: m.reduce,
          session: p.reduce,
          users: h.reduce,
          conversationInput: v.reduce,
          messageList: f.reduce,
          channels: e.hasSupportForChannels ? u.reduce : y,
          channelInput: e.hasSupportForChannels ? d.reduce : y
        });
      }, g);
    t.chatReducer = function () {
      return _((0, c.getChatReducerOptions)());
    };
  }, function (e, t) {
    e.exports = require("redux");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reduce = void 0;
    var l = a(n(35)),
      c = n(46),
      u = a(n(11)),
      d = {},
      f = {
        inputText: "",
        attachedFiles: []
      };
    t.reduce = function (e, t) {
      var n, o, i, a;
      if (void 0 === e && (e = d), t.type === l.ACTION_CHAT_SESSION_UNINIT) return d;
      if (!t.meta) return e;
      var p = t.meta.channelSid;
      if (!p) return e;
      switch (t.type) {
        case u.ACTION_INIT_CONVERSATION:
          return r(r({}, e), ((n = {})[p] = f, n));
        case u.ACTION_UNLOAD_CONVERSATION:
          var h = r({}, e);
          return delete h[p], h;
        case c.ACTION_UPDATE_CONVERSATION_INPUT:
          return r(r({}, e), ((o = {})[p] = r(r({}, t.payload), {
            attachedFiles: []
          }), o));
        case c.ACTION_ATTACH_CONVERSATION_FILES:
          return r(r({}, e), ((i = {})[p] = r(r({}, e[p]), {
            attachedFiles: s(s([], e[p].attachedFiles || [], !0), [t.payload.attachedFile], !1)
          }), i));
        case c.ACTION_DETACH_CONVERSATION_FILES:
          var v = t.payload.attachedFile,
            m = v.name,
            g = v.size,
            b = v.type;
          return r(r({}, e), ((a = {})[p] = r(r({}, e[p]), {
            attachedFiles: (e[p].attachedFiles || []).filter(function (e) {
              return e.name !== m || e.size !== g || e.type !== b;
            })
          }), a));
        default:
          return e;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountryManager = void 0;
    var i,
      a = n(184),
      s = [],
      l = function (e) {
        var t = e.callingCodes;
        return Boolean(t && t.length > 0 && t[0]);
      };
    t.CountryManager = {
      getAllCountries: function () {
        return r(void 0, void 0, void 0, function () {
          var e, t;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return s.length ? [3, 2] : [4, r(void 0, void 0, Promise, function () {
                  return o(this, function (e) {
                    switch (e.label) {
                      case 0:
                        return e.trys.push([0, 3,, 4]), [4, fetch("https://assets.flex.twilio.com/assets/countries.json")];
                      case 1:
                        return [4, e.sent().json()];
                      case 2:
                        return [2, e.sent()];
                      case 3:
                        return e.sent(), [2, []];
                      case 4:
                        return [2];
                    }
                  });
                })];
              case 1:
                e = n.sent(), t = e.filter(l), s = t.reduce(function (e, t) {
                  var n = t.callingCodes.map(function (e) {
                    return {
                      name: t.name,
                      alpha2Code: t.alpha2Code,
                      key: "" + t.alpha2Code + e,
                      code: e
                    };
                  });
                  return e.push.apply(e, n), e;
                }, []), n.label = 2;
              case 2:
                return [2, s];
            }
          });
        });
      },
      getAllCountriesFlagPositions: function () {
        return r(void 0, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return i ? [3, 2] : [4, r(void 0, void 0, Promise, function () {
                  return o(this, function (e) {
                    switch (e.label) {
                      case 0:
                        return e.trys.push([0, 3,, 4]), [4, fetch("https://assets.flex.twilio.com/assets/flagPositions.json")];
                      case 1:
                        return [4, e.sent().json()];
                      case 2:
                        return [2, e.sent()];
                      case 3:
                        return e.sent(), [2, {}];
                      case 4:
                        return [2];
                    }
                  });
                })];
              case 1:
                i = e.sent(), e.label = 2;
              case 2:
                return [2, i];
            }
          });
        });
      },
      getFlagPositionFromCode: function (e) {
        return r(void 0, void 0, Promise, function () {
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, t.CountryManager.getAllCountriesFlagPositions()];
              case 1:
                return [2, n.sent()[e]];
            }
          });
        });
      },
      getCountryCodeForRegion: function (e) {
        return r(void 0, void 0, Promise, function () {
          var n, r;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, t.CountryManager.getAllCountries()];
              case 1:
                return n = o.sent(), [2, (r = n.find(function (t) {
                  return t.alpha2Code === e;
                })) ? Number(r.code) : null];
            }
          });
        });
      },
      getCountryKeyFromNumber: function (e) {
        return r(void 0, void 0, Promise, function () {
          var n, r, i, s, l, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return n = a.PhoneNumberUtil.getInstance(), r = t.CountryManager.formatPhoneNumberWithCountryCode(e), [4, t.CountryManager.getAllCountries()];
              case 1:
                return i = o.sent(), r ? (s = i.filter(function (e) {
                  return 0 === r.substr(1).indexOf(e.code);
                }).sort(function (e, t) {
                  var n = Number(e.code && e.code.length) || 0;
                  return (Number(t.code && t.code.length) || 0) - n;
                }).reduce(function (e, t) {
                  var n = Number(e.code && e.code.length) || 0;
                  return (Number(t.code && t.code.length) || 0) > n ? t : e;
                }, {})).code ? (l = Number(s.code), c = n.getRegionCodeForCountryCode(l), Number(n.getCountryCodeForRegion(c)) === l ? [2, "" + c + l] : [2, s.key]) : [2, null] : [2, null];
            }
          });
        });
      },
      formatPhoneNumberWithCountryCode: function (e, t, n) {
        if (void 0 === n && (n = a.PhoneNumberFormat.E164), !e || e.length <= 1) return e;
        var r = /^(0{2}|\+)(.+)/,
          o = null;
        if (r.test(e)) {
          o = e.replace(r, "+$2");
        }
        try {
          var i = a.PhoneNumberUtil.getInstance(),
            s = i.parseAndKeepRawInput(o || e, t),
            l = s.getExtension();
          return o = i.format(s, n), l && n !== a.PhoneNumberFormat.INTERNATIONAL ? o + "#" + l : o;
        } catch (e) {
          return o;
        }
      }
    };
  }, function (e, t) {
    e.exports = require("google-libphonenumber");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexBoxColumn = void 0;
    var u = l(n(0)),
      d = n(93),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = c(e, ["children"]),
            r = i(i({}, n), {
              vertical: !0
            });
          return u.createElement(d.FlexBox, i({}, r), t);
        }, t;
      }(u.PureComponent);
    t.FlexBoxColumn = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StorageType = void 0, function (e) {
      e[e.SESSION = 0] = "SESSION";
    }(r = t.StorageType || (t.StorageType = {}));
    var o = function () {
      function e(e, t) {
        this.key = t, e === r.SESSION && (this.storage = sessionStorage);
      }
      return e.prototype.add = function (e) {
        this.storage.setItem(this.key, JSON.stringify(e));
      }, e.prototype.remove = function (e) {
        e ? this.storage.removeItem(e) : this.storage.removeItem(this.key);
      }, e.prototype.get = function () {
        var e = this.storage.getItem(this.key);
        return e ? JSON.parse(e) : null;
      }, e;
    }();
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      },
      i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AbstractTelemetryEventsDelegate = void 0, o(n(189), t);
    var a = n(191);
    Object.defineProperty(t, "AbstractTelemetryEventsDelegate", {
      enumerable: !0,
      get: function () {
        return i(a).default;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      c = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexSDKManager = t.FlexSDKManagerImpl = void 0;
    var u = s(n(190)),
      d = n(38),
      f = n(12),
      p = n(3),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onTokenUpdated = function (e) {
            return l(t, void 0, void 0, function () {
              var t;
              return c(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, this.validateToken(e)];
                  case 1:
                    return t = n.sent(), this.emit(u.ClientEvent.TokenUpdated, {
                      token: e,
                      roles: t.roles,
                      expiration: t.dateExpired,
                      identity: t.identity
                    }), [2];
                }
              });
            });
          }, t.onTokenExpired = function () {
            t.emit(u.ClientEvent.TokenExpired, void 0);
          }, t;
        }
        return o(t, e), t.prototype.setClient = function (e) {
          this.client = e;
        }, t.prototype.initialize = function (e, t) {
          return l(this, void 0, void 0, function () {
            var n, r;
            return c(this, function (o) {
              switch (o.label) {
                case 0:
                  if (this.client) return [2];
                  o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), n = this, [4, u.createClient(e, t)];
                case 2:
                  return n.client = o.sent(), this.client.addListener(u.ClientEvent.TokenUpdated, this.onTokenUpdated), this.client.addListener(u.ClientEvent.TokenExpired, this.onTokenExpired), [3, 4];
                case 3:
                  throw r = o.sent(), f.ErrorManager.createAndProcessError("FlexSDK - initialize: flex SDK client could not be initialized", {
                    wrappedError: r
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.validateToken = function (e) {
          return l(this, void 0, Promise, function () {
            var t;
            return c(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getAccountConfig(e)];
                case 1:
                  return t = n.sent().accountSid, [2, u.auth(t).validateToken(e)];
              }
            });
          });
        }, t.prototype.getClient = function () {
          return this.client;
        }, t.prototype.destroy = function () {
          return l(this, void 0, void 0, function () {
            var e;
            return c(this, function (t) {
              switch (t.label) {
                case 0:
                  if (!this.client) return [2];
                  t.label = 1;
                case 1:
                  return t.trys.push([1, 3, 4, 5]), this.client.removeListener(u.ClientEvent.TokenUpdated, this.onTokenUpdated), this.client.removeListener(u.ClientEvent.TokenExpired, this.onTokenExpired), [4, this.client.destroy()];
                case 2:
                  return t.sent(), [3, 5];
                case 3:
                  return e = t.sent(), p.log.error("FlexSDK - destroy: flex SDK client could not be destroyed", e), [3, 5];
                case 4:
                  return this.client = void 0, [7];
                case 5:
                  return [2];
              }
            });
          });
        }, t.prototype.updateToken = function (e) {
          return l(this, void 0, void 0, function () {
            var t;
            return c(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!this.client) return [2];
                  n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), [4, this.client.updateToken(e)];
                case 2:
                  return n.sent(), [3, 4];
                case 3:
                  return t = n.sent(), p.log.error("FlexSDK - update token: flex SDK client could not update a token", t), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.getAccountConfig = function (e, t) {
          return l(this, void 0, Promise, function () {
            return c(this, function (n) {
              return [2, u.getAccountConfig(e, t)];
            });
          });
        }, t.prototype.getFeaturesConfig = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              return [2, u.getFeaturesConfig(e)];
            });
          });
        }, t.prototype.setAccountConfig = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              if (!this.client) throw new Error("FlexSDK - set account config: flex SDK client not initialised");
              return [2, this.client.config.account.set(e)];
            });
          });
        }, t.prototype.getPublicConfig = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              return [2, u.getPublicConfig(e)];
            });
          });
        }, t.prototype.getIdentifiers = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              return [2, this.client.profileConnector.getIdentifiers(e)];
            });
          });
        }, t.prototype.getTraits = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              return [2, this.client.profileConnector.getTraits(e)];
            });
          });
        }, t.prototype.findProfileByIdentifiers = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              return [2, this.client.profileConnector.findProfileByIdentifiers(e)];
            });
          });
        }, t.prototype.hasPermission = function (e, t) {
          return u.hasPermission(e, t);
        }, t.prototype.fetchVirtualAgentTranscript = function (e) {
          return l(this, void 0, Promise, function () {
            return c(this, function (t) {
              return [2, this.client.virtualAgentData.getV1VirtualAgentData(e)];
            });
          });
        }, t;
      }(d.EventEmitter);
    t.FlexSDKManagerImpl = h, t.FlexSDKManager = new h();
  }, function (e, t) {
    e.exports = require("@twilio/flex-sdk");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(3),
      l = function () {
        function e() {}
        return e.prototype.initialize = function (e) {
          var t = e.createTelemetryClient(this.getSchemaName());
          this.eventGroup = t.createEventGroup(this.getEventGroupName());
        }, e.prototype.getEventGroupName = function () {}, e.prototype.report = function (e) {
          return o(this, void 0, Promise, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!this.eventGroup) return [2];
                  n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), [4, this.eventGroup.addEvents(r({
                    eventName: this.getEventName()
                  }, e))];
                case 2:
                  return n.sent(), [3, 4];
                case 3:
                  return t = n.sent(), s.log.error("FlexSDK: Can't report a \"" + this.getEventName() + '" event', t), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.prototype.groupReport = function (e) {
          return o(this, void 0, Promise, function () {
            var t,
              n,
              o = this;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (!this.eventGroup) return [2];
                  i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, (n = this.eventGroup).addEvents.apply(n, e.reduce(function (e, t) {
                    return a(a([], e, !0), [r({
                      eventName: o.getEventName()
                    }, t)], !1);
                  }, []))];
                case 2:
                  return i.sent(), [3, 4];
                case 3:
                  return t = i.sent(), s.log.error("FlexSDK: Can't report a \"" + this.getEventName() + '" event', t), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e;
      }();
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Markdown = void 0;
    var c,
      u,
      d,
      f,
      p,
      h,
      v,
      m,
      g,
      b,
      y,
      _,
      O,
      C,
      P = l(n(14)),
      M = l(n(193)),
      j = s(n(0)),
      w = n(9),
      E = {
        h1: (0, P.default)("h1")(c || (c = r(["\n        font-size: 24px;\n        font-weight: bold;\n        line-height: 36px;\n        margin: 0;\n    "], ["\n        font-size: 24px;\n        font-weight: bold;\n        line-height: 36px;\n        margin: 0;\n    "]))),
        h2: (0, P.default)("h2")(u || (u = r(["\n        font-size: 20px;\n        font-weight: bold;\n        line-height: 32px;\n        margin: 0;\n    "], ["\n        font-size: 20px;\n        font-weight: bold;\n        line-height: 32px;\n        margin: 0;\n    "]))),
        h3: (0, P.default)("h3")(d || (d = r(["\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 28px;\n        margin: 0;\n    "], ["\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 28px;\n        margin: 0;\n    "]))),
        h4: (0, P.default)("h4")(f || (f = r(["\n        font-size: 16px;\n        font-weight: bold;\n        line-height: 24px;\n        margin: 0;\n    "], ["\n        font-size: 16px;\n        font-weight: bold;\n        line-height: 24px;\n        margin: 0;\n    "]))),
        h5: (0, P.default)("h5")(p || (p = r(["\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 20px;\n        margin: 0;\n    "], ["\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 20px;\n        margin: 0;\n    "]))),
        h6: (0, P.default)("h6")(h || (h = r(["\n        font-size: 12px;\n        font-weight: bold;\n        line-height: 16px;\n        margin: 0;\n    "], ["\n        font-size: 12px;\n        font-weight: bold;\n        line-height: 16px;\n        margin: 0;\n    "]))),
        a: (0, P.default)("a")(v || (v = r(["\n        color: ", ";\n        &:hover {\n            text-decoration: none;\n        }\n    "], ["\n        color: ", ";\n        &:hover {\n            text-decoration: none;\n        }\n    "])), function (e) {
          return e.theme.tokens.textColors.colorTextLink;
        }),
        p: (0, P.default)("p")(m || (m = r(["\n        margin: 0;\n    "], ["\n        margin: 0;\n    "]))),
        pre: (0, P.default)("pre")(g || (g = r(["\n        margin: 0;\n        white-space: pre-wrap;\n    "], ["\n        margin: 0;\n        white-space: pre-wrap;\n    "]))),
        em: (0, P.default)("em")(b || (b = r(["\n        font-style: italic;\n    "], ["\n        font-style: italic;\n    "]))),
        strong: (0, P.default)("strong")(y || (y = r(["\n        font-weight: bold;\n    "], ["\n        font-weight: bold;\n    "]))),
        code: (0, P.default)("code")(_ || (_ = r(["\n        font-family: ", ";\n    "], ["\n        font-family: ", ";\n    "])), function (e) {
          return e.theme.tokens.fonts.fontFamilyCode;
        }),
        ul: (0, P.default)("ul")(O || (O = r(["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: disc;\n            margin-left: 1.5em;\n        }\n    "], ["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: disc;\n            margin-left: 1.5em;\n        }\n    "]))),
        ol: (0, P.default)("ol")(C || (C = r(["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: decimal;\n            margin-left: 1.5em;\n        }\n    "], ["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: decimal;\n            margin-left: 1.5em;\n        }\n    "])))
      },
      S = {
        img: function () {
          return null;
        }
      };
    t.Markdown = function (e) {
      var t = e.enableImages || !1,
        n = o({}, E);
      t || Object.assign(n, S);
      var r = w.Utils.merge({
        overrides: n,
        disableParsingRawHTML: !0
      }, e.options || {});
      return j.createElement(M.default, {
        options: r
      }, e.children);
    };
  }, function (e, t) {
    e.exports = require("markdown-to-jsx");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StateMachine = void 0;
    var r = n(3),
      o = function () {
        function e(e) {
          this._handlers = {
            enter: {},
            leave: {},
            change: []
          }, this._name = e;
        }
        return Object.defineProperty(e.prototype, "state", {
          get: function () {
            return this._state;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.onChange = function (e) {
          var t = this;
          return this._handlers.change.push(e), function () {
            t._handlers.change = t._handlers.change.filter(function (t) {
              return t !== e;
            });
          };
        }, e.prototype.onEnter = function (e, t) {
          var n = this,
            r = e.toString();
          return this._handlers.enter[r] || (this._handlers.enter[r] = []), this._handlers.enter[r].push(t), function () {
            n._handlers.enter[r] = n._handlers.enter[r].filter(function (e) {
              return e !== t;
            });
          };
        }, e.prototype.onLeave = function (e, t) {
          var n = this,
            r = e.toString();
          return this._handlers.leave[r] || (this._handlers.leave[r] = []), this._handlers.leave[r].push(t), function () {
            n._handlers.leave[r] = n._handlers.leave[r].filter(function (e) {
              return e !== t;
            });
          };
        }, e.prototype.transitionTo = function (e) {
          r.log.debug("StateMachine", this._name, "transitionTo:", e);
          var t = this._state;
          if (void 0 !== t) {
            var n = this._handlers.leave[t.toString()];
            n && n.forEach(function (n) {
              return n(e, t);
            });
          }
          this._state = e, this._handlers.change.forEach(function (n) {
            return n(e, t);
          });
          var o = this._handlers.enter[e.toString()];
          o && o.forEach(function (n) {
            return n(e, t);
          });
        }, e;
      }();
    t.StateMachine = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.resetCSS = t.injectFont = void 0;
    t.injectFont = function () {
      var e = document.createElement("link");
      e.rel = "stylesheet", e.href = "https://assets.twilio.com/public_assets/paste-fonts/main-1.2.0/fonts.css", document.head.appendChild(e);
    }, t.resetCSS = function () {
      var e = document.createElement("style");
      e.type = "text/css", e.appendChild(document.createTextNode("\n        /* http://meyerweb.com/eric/tools/css/reset/\n        v2.0 | 20110126\n        License: none (public domain)\n        */\n        html, body, div, span, applet, object, iframe,\n        h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n        a, abbr, acronym, address, big, cite, code,\n        del, dfn, em, img, ins, kbd, q, s, samp,\n        small, strike, strong, sub, sup, tt, var,\n        b, u, i, center,\n        dl, dt, dd, ol, ul, li,\n        fieldset, form, label, legend,\n        table, caption, tbody, tfoot, thead, tr, th, td,\n        article, aside, canvas, details, embed,\n        figure, figcaption, footer, header, hgroup,\n        menu, nav, output, ruby, section, summary,\n        time, mark, audio, video {\n            margin: 0;\n            padding: 0;\n            border: 0;\n            font-size: 100%;\n            font: inherit;\n            vertical-align: baseline;\n        }\n        /* HTML5 display-role reset for older browsers */\n        article, aside, details, figcaption, figure,\n        footer, header, hgroup, menu, nav, section {\n            display: block;\n        }\n        body {\n            line-height: normal;\n        }\n        ol, ul {\n            list-style: none;\n        }\n        blockquote, q {\n            quotes: none;\n        }\n        blockquote:before, blockquote:after,\n        q:before, q:after {\n            content: '';\n            content: none;\n        }\n        table {\n            border-collapse: collapse;\n            border-spacing: 0;\n        }\n    "));
      var t = document.querySelector("link[rel='stylesheet'], style, title");
      t && t.parentNode === document.head ? document.head.insertBefore(e, t) : document.head.appendChild(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withHOC = void 0;
    var l = s(n(96)),
      c = s(n(197)),
      u = a(n(0)),
      d = (0, c.default)(function (e, t) {
        var n = t;
        return e.forEach(function (e) {
          n = e(n);
        }), n;
      }, function (e, t) {
        return void 0 === e && (e = []), (t.displayName || t.name || "Component") + "-" + e.length;
      });
    t.withHOC = function (e, t) {
      var n = e.displayName || e.name || "Component",
        o = function (o) {
          var i = d(t, e);
          return u.createElement(i, r({
            key: n
          }, o));
        };
      return o.displayName = "WithHOC(" + n + ")", (0, l.default)(o, e);
    };
  }, function (e, t) {
    e.exports = require("lodash.memoize");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Ticker = t.withTheme = t.Tokens = t.ThemeSupport = t.ThemeProps = t.Theme = t.styled = t.PropsWithTheme = t.getBackgroundWithHoverCSS = t.ExtendedMuiTheme = t.CoreThemeColors = t.CoreThemeBaseplates = t.NotificationBarItem = t.NotificationBar = t.BadgeVariants = t.BadgeThemeProps = t.BadgeProps = t.BadgeChildrenProps = t.Badge = void 0, o(n(199), t), o(n(47), t), o(n(97), t), o(n(202), t);
    var i = n(397);
    Object.defineProperty(t, "Badge", {
      enumerable: !0,
      get: function () {
        return i.Badge;
      }
    }), Object.defineProperty(t, "BadgeChildrenProps", {
      enumerable: !0,
      get: function () {
        return i.BadgeChildrenProps;
      }
    }), Object.defineProperty(t, "BadgeProps", {
      enumerable: !0,
      get: function () {
        return i.BadgeProps;
      }
    }), Object.defineProperty(t, "BadgeThemeProps", {
      enumerable: !0,
      get: function () {
        return i.BadgeThemeProps;
      }
    }), Object.defineProperty(t, "BadgeVariants", {
      enumerable: !0,
      get: function () {
        return i.BadgeVariants;
      }
    }), o(n(17), t), o(n(403), t), o(n(42), t), o(n(519), t), o(n(522), t), o(n(525), t), o(n(526), t), o(n(532), t), o(n(543), t), o(n(544), t), o(n(547), t), o(n(6), t), o(n(556), t), o(n(15), t), o(n(4), t), o(n(570), t), o(n(574), t), o(n(166), t), o(n(580), t);
    var a = n(140);
    Object.defineProperty(t, "NotificationBar", {
      enumerable: !0,
      get: function () {
        return a.NotificationBar;
      }
    }), Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function () {
        return a.NotificationBarItem;
      }
    }), o(n(583), t), o(n(585), t), o(n(588), t), o(n(591), t), o(n(595), t), o(n(598), t), o(n(601), t);
    var s = n(1);
    Object.defineProperty(t, "CoreThemeBaseplates", {
      enumerable: !0,
      get: function () {
        return s.CoreThemeBaseplates;
      }
    }), Object.defineProperty(t, "CoreThemeColors", {
      enumerable: !0,
      get: function () {
        return s.CoreThemeColors;
      }
    }), Object.defineProperty(t, "ExtendedMuiTheme", {
      enumerable: !0,
      get: function () {
        return s.ExtendedMuiTheme;
      }
    }), Object.defineProperty(t, "getBackgroundWithHoverCSS", {
      enumerable: !0,
      get: function () {
        return s.getBackgroundWithHoverCSS;
      }
    }), Object.defineProperty(t, "PropsWithTheme", {
      enumerable: !0,
      get: function () {
        return s.PropsWithTheme;
      }
    }), Object.defineProperty(t, "styled", {
      enumerable: !0,
      get: function () {
        return s.styled;
      }
    }), Object.defineProperty(t, "Theme", {
      enumerable: !0,
      get: function () {
        return s.Theme;
      }
    }), Object.defineProperty(t, "ThemeProps", {
      enumerable: !0,
      get: function () {
        return s.ThemeProps;
      }
    }), Object.defineProperty(t, "ThemeSupport", {
      enumerable: !0,
      get: function () {
        return s.ThemeSupport;
      }
    }), Object.defineProperty(t, "Tokens", {
      enumerable: !0,
      get: function () {
        return s.Tokens;
      }
    }), Object.defineProperty(t, "withTheme", {
      enumerable: !0,
      get: function () {
        return s.withTheme;
      }
    });
    var l = n(607);
    Object.defineProperty(t, "Ticker", {
      enumerable: !0,
      get: function () {
        return l.Ticker;
      }
    }), o(n(609), t), o(n(612), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AggregatedDataTile = void 0;
    var r = n(200);
    Object.defineProperty(t, "AggregatedDataTile", {
      enumerable: !0,
      get: function () {
        return r.AggregatedDataTile;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AggregatedDataTile = void 0;
    var l = s(n(0)),
      c = n(201),
      u = n(5),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.title,
            n = e.content,
            r = e.description,
            o = e.children,
            i = e.className;
          return l.createElement(c.TileWrapper, {
            className: (0, u.cx)("Twilio-AggregatedDataTile", i)
          }, l.createElement(c.Title, {
            className: "Twilio-AggregatedDataTile-Title"
          }, t), o || l.createElement(c.Content, {
            className: "Twilio-AggregatedDataTile-Content"
          }, n), r && l.createElement(c.Description, {
            className: "Twilio-AggregatedDataTile-Description"
          }, r));
        }, t;
      }(l.PureComponent);
    t.AggregatedDataTile = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Description = t.Content = t.Title = t.TileWrapper = void 0;
    var o,
      i,
      a,
      s,
      l = n(1);
    t.TileWrapper = (0, l.styled)("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    border-style: solid;\n    border-width: ", ";\n    border-radius: ", ";\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    border-style: solid;\n    border-width: ", ";\n    border-radius: ", ";\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space70;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth20;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius20;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderWeaker;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundBody;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }), t.Title = (0, l.styled)("p")(i || (i = r(["\n    min-height: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    min-height: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare70;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize40;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight40;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }), t.Content = (0, l.styled)("div")(a || (a = r(["\n    margin-top: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    margin-top: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize90;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight90;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }), t.Description = (0, l.styled)("div")(s || (s = r(["\n    font-size: ", ";\n    line-height: ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvatarProps = t.Avatar = void 0;
    var r = n(203);
    Object.defineProperty(t, "Avatar", {
      enumerable: !0,
      get: function () {
        return r.Avatar;
      }
    }), Object.defineProperty(t, "AvatarProps", {
      enumerable: !0,
      get: function () {
        return r.AvatarProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Avatar = void 0;
    var c = n(5),
      u = l(n(0)),
      d = n(2),
      f = n(204),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            verifiedImages: {}
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.validateImageUrl(this.props.imageUrl);
        }, t.prototype.componentDidUpdate = function (e) {
          e.imageUrl !== this.props.imageUrl && this.validateImageUrl(this.props.imageUrl);
        }, t.prototype.validateImageUrl = function (e) {
          var t = this;
          if (e && !this.state.verifiedImages[e]) {
            var n = new Image();
            n.src = e, n.onload = function () {
              t.setState(function (t) {
                var n;
                return {
                  verifiedImages: i(i({}, t.verifiedImages), (n = {}, n[e] = !0, n))
                };
              });
            };
          }
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.available,
            n = e.large,
            r = e.showAvailabilityIcon,
            o = e.noStyling,
            i = this.state.verifiedImages[this.props.imageUrl] && this.props.imageUrl,
            a = o ? f.UnstyledAvatarContainer : f.AvatarContainer,
            s = this.props.available ? "available" : "not available";
          return u.createElement(a, {
            className: (0, c.cx)("Twilio-Avatar", this.props.className),
            large: n
          }, u.createElement(f.StyledAvatarWrapper, null, i ? u.createElement(f.StyledAvatarImage, {
            src: i,
            "aria-label": d.templates.UserImageAriaLabel({
              status: s
            }),
            "data-test": "worker-avatar"
          }) : u.createElement(f.StyledDefaultAvatarIcon, {
            sizeMultiplier: n ? 2 : 1,
            icon: "DefaultAvatar",
            "aria-label": d.templates.DefaultUserImageAriaLabel({
              status: s
            })
          })), r && u.createElement(f.StyledAvailabilityIcon, {
            className: "Twilio-Avatar-AvailabilityIcon",
            available: t,
            large: n
          }));
        }, t.defaultProps = {
          showAvailabilityIcon: !0
        }, t;
      }(u.PureComponent);
    t.Avatar = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledAvailabilityIcon = t.StyledDefaultAvatarIcon = t.StyledAvatarImage = t.StyledAvatarWrapper = t.UnstyledAvatarContainer = t.AvatarContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u = n(1),
      d = n(4);
    t.AvatarContainer = (0, u.styled)("div")(o || (o = r(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    border-radius: 1000px;\n    border-style: solid;\n    border-width: ", "px;\n    ", "\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    border-radius: 1000px;\n    border-style: solid;\n    border-width: ", "px;\n    ", "\n"])), function (e) {
      return e.large ? 2 : 1;
    }, function (e) {
      return e.theme.Avatar.Container;
    }), t.UnstyledAvatarContainer = (0, u.styled)("div")(i || (i = r(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n"]))), t.StyledAvatarWrapper = (0, u.styled)("div")(a || (a = r(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    border-radius: 1000px;\n    overflow: hidden;\n"], ["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    border-radius: 1000px;\n    overflow: hidden;\n"]))), t.StyledAvatarImage = (0, u.styled)("img")(s || (s = r(["\n    margin: auto;\n    display: block;\n    width: 100%;\n    height: 100%;\n"], ["\n    margin: auto;\n    display: block;\n    width: 100%;\n    height: 100%;\n"]))), t.StyledDefaultAvatarIcon = (0, u.styled)(d.Icon)(l || (l = r(["\n    margin: auto;\n"], ["\n    margin: auto;\n"]))), t.StyledAvailabilityIcon = (0, u.styled)("div")(c || (c = r(["\n    display: flex;\n    position: absolute;\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 0;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 100px;\n    background-color: ", ";\n    ", ";\n"], ["\n    display: flex;\n    position: absolute;\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 0;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 100px;\n    background-color: ", ";\n    ", ";\n"])), function (e) {
      return e.large ? 16 : 14;
    }, function (e) {
      return e.large ? 16 : 14;
    }, function (e) {
      return e.available ? e.theme.tokens.backgroundColors.colorBackgroundAvailable : e.theme.tokens.backgroundColors.colorBackgroundOffline;
    }, function (e) {
      return e.theme.Avatar.AvailabilityIcon;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Icon = void 0;
    var l = s(n(0)),
      c = s(n(61)),
      u = n(3),
      d = n(395),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this.props,
            n = t.icon,
            r = t.className,
            o = t.sizeMultiplier;
          "string" == typeof n ? e = n : l.isValidElement(n) && (e = n.props.className);
          var i = "Twilio-Icon Twilio-Icon-" + (e || "Custom") + " " + (r || ""),
            a = o || 1;
          if (l.isValidElement(n)) return l.createElement(d.SvgContainer, {
            className: i,
            contentSize: 24 * a
          }, n);
          var s = c["Icn" + n];
          return s || (u.log.error("Icon " + n + " missing"), s = c.IcnHelp), l.createElement(d.SvgContainer, {
            className: i,
            contentSize: 24 * a
          }, l.createElement(s, {
            className: "Twilio-Icon-Content"
          }));
        }, t;
      }(l.PureComponent);
    t.Icon = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M10.081 14.568l5.898-6.38a.576.576 0 01.845 0 .671.671 0 010 .912l-6.009 6.485a1 1 0 01-1.467 0l-2.172-2.343a.672.672 0 01-.004-.91.567.567 0 01.835-.003l2.074 2.239z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M9.852 15.21l7.372-7.975a.72.72 0 011.056 0 .84.84 0 010 1.14l-7.695 8.305a1 1 0 01-1.467 0L6.22 13.552a.84.84 0 01-.005-1.136.709.709 0 011.044-.005l2.593 2.798z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M16.51 12.573h-3.937v3.937a.573.573 0 11-1.147 0v-3.937H7.49a.573.573 0 110-1.147h3.937V7.49a.573.573 0 011.147 0v3.937h3.936a.573.573 0 010 1.147z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zm7.734-3.656L5.656 8.296 12 11.75l6.422-3.453-6.344-3.235zm7.563 6.437a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 1.062.578-1.328.672 6.344 3.453 6.422-3.453-1.25-.64 1.062-.579 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 1.063.578-1.235.563 6.344 3.453 6.422-3.453-1.172-.578 1.062-.579 1.407.688z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zM19.64 11.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 5.43 3.002c.301.149.517.227.648.235.13.008.31-.047.54-.164l4.632-2.464 1.062-.578 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 5.67 3.188c.175.105.342.158.502.16.16.003.32-.045.483-.145l5.83-3.218L19.64 15z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zm7.734-3.656L5.656 8.296 12 11.75l6.422-3.453-6.344-3.235zm7.563 6.437a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 1.062.578-1.328.672 6.344 3.453 6.422-3.453-1.25-.64 1.062-.579 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 1.063.578-1.235.563 6.344 3.453 6.422-3.453-1.172-.578 1.062-.579 1.407.688z",
        fill: "currentColor"
      }), s.createElement("circle", {
        stroke: "currentColor",
        fill: "#EA1010",
        cx: 19,
        cy: 5,
        r: 4.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zM19.64 11.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 5.43 3.002c.301.149.517.227.648.235.13.008.31-.047.54-.164l4.632-2.464 1.062-.578 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 5.67 3.188c.175.105.342.158.502.16.16.003.32-.045.483-.145l5.83-3.218L19.64 15z",
        fill: "currentColor"
      }), s.createElement("circle", {
        stroke: "currentColor",
        fill: "#EA1010",
        cx: 19,
        cy: 5,
        r: 4.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M15.656 17.05l.422.234c.281.156.422.359.422.609v1.264c0 .24-.083.44-.25.601a.825.825 0 01-.594.242H4.844a.825.825 0 01-.594-.242.803.803 0 01-.25-.6v-1.265c0-.23.14-.427.422-.593l.422-.25L8.078 15.3c-.594-.468-1.005-1.092-1.234-1.873-.23-.78-.344-1.4-.344-1.857V9.463c0-.353.11-.705.328-1.053.219-.349.505-.664.86-.945a4.66 4.66 0 011.21-.686 3.734 3.734 0 011.368-.266c.468 0 .927.089 1.375.266.448.176.846.405 1.195.686.349.281.63.596.844.945.213.348.32.7.32 1.053v2.108c0 .51-.102 1.144-.305 1.904s-.596 1.374-1.18 1.842l3.141 1.733zM15.5 19v-.89a.417.417 0 00-.11-.078l-.124-.062a.076.076 0 01-.04-.016.51.51 0 00-.054-.031l-3.14-1.733a1.056 1.056 0 01-.36-.335.92.92 0 01-.156-.46.911.911 0 01.07-.485.973.973 0 01.305-.39c.427-.333.718-.81.875-1.428.156-.62.234-1.127.234-1.522V9.463c0-.364-.273-.78-.82-1.248a2.852 2.852 0 00-1.914-.703c-.709 0-1.347.234-1.914.703-.568.468-.852.884-.852 1.248v2.108c0 .395.094.902.281 1.522.188.619.495 1.095.922 1.428.125.104.221.234.29.39a.911.911 0 01.07.484.92.92 0 01-.157.46.922.922 0 01-.36.32L5.314 17.94a.07.07 0 00-.032.007.122.122 0 00-.031.024.433.433 0 00-.133.062L5 18.111v.89h10.5zm3.656-4.433l.422.234c.281.156.422.359.422.609v1.249c0 .239-.083.44-.25.6a.825.825 0 01-.594.242H17.5a5.72 5.72 0 00-.195-.577 1.015 1.015 0 00-.32-.422H19v-.89a4.483 4.483 0 00-.11-.07.436.436 0 00-.124-.054.098.098 0 00-.04-.024.429.429 0 01-.054-.023l-3.188-1.733a1.056 1.056 0 01-.359-.335.92.92 0 01-.156-.46.911.911 0 01.07-.485.973.973 0 01.305-.39c.427-.343.726-.825.898-1.444.172-.62.258-1.121.258-1.506V6.98c0-.374-.281-.796-.844-1.264a2.941 2.941 0 00-1.937-.702 3.181 3.181 0 00-1.906.64 2.457 2.457 0 00-.626-.11 270.4 270.4 0 01-.64-.03 4.506 4.506 0 011.406-1.078A3.852 3.852 0 0113.72 4c.469 0 .93.091 1.383.273.453.182.856.414 1.21.695.355.28.641.598.86.952.219.354.328.708.328 1.061V9.09c0 .5-.11 1.131-.328 1.896-.219.765-.62 1.377-1.203 1.835l3.187 1.748z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M15.656 17.05l.422.234c.281.156.422.359.422.609v1.264c0 .24-.083.44-.25.601a.825.825 0 01-.594.242H4.844a.825.825 0 01-.594-.242.803.803 0 01-.25-.6v-1.265c0-.23.14-.427.422-.593l.422-.25L8.078 15.3c-.594-.468-1.005-1.092-1.234-1.873-.23-.78-.344-1.4-.344-1.857V9.463c0-.353.11-.705.328-1.053.219-.349.505-.664.86-.945a4.66 4.66 0 011.21-.686 3.734 3.734 0 011.368-.266c.468 0 .927.089 1.375.266.448.176.846.405 1.195.686.349.281.63.596.844.945.213.348.32.7.32 1.053v2.108c0 .51-.102 1.144-.305 1.904s-.596 1.374-1.18 1.842l3.141 1.733zm3.5-2.482l.422.234c.281.156.422.359.422.609v1.249c0 .239-.083.44-.25.6a.825.825 0 01-.594.242H17.5a5.72 5.72 0 00-.195-.577 1.015 1.015 0 00-.32-.422c-1.337-.622-2.26-1.1-2.768-1.434 1.136-1.12.913-3.81.942-5.089.023-1.054-.265-2.137-1.1-2.999-1.41-1.456-3.304-1.456-3.512-1.467a4.506 4.506 0 011.406-1.077A3.852 3.852 0 0113.72 4c.469 0 .93.091 1.383.273.453.182.856.414 1.21.695.355.28.641.598.86.952.219.354.328.708.328 1.061V9.09c0 .5-.11 1.131-.328 1.896-.219.765-.62 1.377-1.203 1.835l3.187 1.748z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.557 15.067a4.5 4.5 0 014.5 4.5.5.5 0 11-1 0 3.5 3.5 0 00-3.5-3.5H8.51a3.5 3.5 0 00-3.5 3.5.5.5 0 11-1 0 4.5 4.5 0 014.5-4.5zM12 3a5 5 0 110 10 5 5 0 010-10zm0 1a4 4 0 100 8 4 4 0 000-8z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.007 15.213a4 4 0 014 4V20H3.978v-.787a4 4 0 014-4h8.029zM12 3a5 5 0 110 10 5 5 0 010-10z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M12 4c1.462 0 2.814.365 4.058 1.096a7.582 7.582 0 012.846 2.846A7.868 7.868 0 0120 12a7.868 7.868 0 01-1.096 4.058 7.582 7.582 0 01-2.846 2.846A7.868 7.868 0 0112 20a7.868 7.868 0 01-4.058-1.096 7.726 7.726 0 01-2.846-2.866A7.833 7.833 0 014 12c0-1.449.365-2.795 1.096-4.038a7.873 7.873 0 012.866-2.866A7.833 7.833 0 0112 4zm0 13a1 1 0 100-2 1 1 0 000 2zm0-10a1 1 0 00-1 1v5a1 1 0 002 0V8a1 1 0 00-1-1z",
        fill: "currentcolor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.497 3.02l7.483 7.483a2.117 2.117 0 010 2.994l-7.483 7.483a2.117 2.117 0 01-2.994 0L3.02 13.497a2.117 2.117 0 010-2.994l7.483-7.483a2.117 2.117 0 012.994 0zM13.2 15.6a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm-1.212-7.2h.024c.733.009 1.287.71 1.173 1.493l-.513 2.685c-.05.355-.334.622-.668.622h-.008c-.334 0-.62-.267-.668-.622l-.513-2.685C10.7 9.11 11.263 8.4 11.988 8.4z",
        fill: "currentcolor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12.446 4.07a1 1 0 01.448.45l6.992 14.034A1 1 0 0118.991 20H4.996a1 1 0 01-.894-1.446l7.002-14.035a1 1 0 011.342-.448zM12 15a1 1 0 100 2 1 1 0 000-2zm0-6a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z",
        fill: "currentcolor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        stroke: "currentColor",
        d: "M19 4.5h-9a.5.5 0 00-.5.5v1.5H5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1.5H19a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5z"
      }), s.createElement("path", {
        fill: "currentColor",
        d: "M12 11h2v4h-2zM15 7h2v8h-2z"
      }), s.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M10 4h9a1 1 0 011 1v12a1 1 0 01-1 1h-9a1 1 0 01-1-1V5a1 1 0 011-1zm0 13h9V5h-9v12z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        stroke: "currentColor",
        d: "M7.5 6.5H5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.51.51 0 00.008 0H9.982l-.168-.007A2.5 2.5 0 017.5 17V6.5zm11.5-2h-9a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zm-7.5 6h3v5h-3v-5zm6-4v9h-3v-9h3z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 2.013l4.988 4.99a1.411 1.411 0 010 1.995L9 13.987a1.411 1.411 0 01-1.995 0l-4.99-4.99a1.411 1.411 0 010-1.995l4.99-4.989a1.411 1.411 0 011.995 0zM8.801 10.4a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-.809-4.8h.017c.488.006.858.474.782.995l-.342 1.79c-.033.237-.223.415-.446.415H8c-.223 0-.413-.178-.446-.415l-.342-1.79c-.076-.521.3-.995.782-.995z",
        fill: "#D61F1F"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M13.797 15.887c.27.255.27.668 0 .922a.723.723 0 01-.979 0l-4.615-4.35a.626.626 0 010-.923l4.61-4.345a.723.723 0 01.978 0c.27.254.271.667 0 .922l-4.12 3.884 4.126 3.89z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M9.203 8.113a.626.626 0 010-.922.723.723 0 01.979 0l4.615 4.35c.27.255.27.668 0 .923l-4.61 4.345a.723.723 0 01-.978 0 .626.626 0 010-.922l4.12-3.884-4.126-3.89z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.125 10c.237 0 .442.088.615.264.173.176.26.384.26.625v8.222c0 .24-.087.45-.26.625a.833.833 0 01-.615.264H7.875a.833.833 0 01-.615-.264.862.862 0 01-.26-.625V10.89c0-.24.087-.45.26-.625a.833.833 0 01.615-.264h12.25zM20 11H8v8h12v-8zM9 18l2.5-3 1.974 2.368L16 14l3 4H9zm3.043-15c.27 0 .496.096.68.29A.984.984 0 0113 4v5h-1V4H8v4H4v8h2v1H3.957a.898.898 0 01-.68-.29A.977.977 0 013 16V7l4-4zM7 4.5L4.5 7H7V4.5z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M12.797 15.887c.27.255.27.668 0 .922a.723.723 0 01-.979 0l-4.615-4.35a.626.626 0 010-.923l4.61-4.345a.723.723 0 01.978 0 .625.625 0 010 .922l-4.12 3.884 4.126 3.89z"
      }), s.createElement("path", {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 1.25,
        d: "M8 12h10"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12.011 20.011c1.41 0 2.54-.773 2.86-2h3.402c.55 0 .893-.52.683-1.002l-.267-.577a18.124 18.124 0 01-1.677-7.349c0-2.845-2.187-5.083-5-5.083C9.2 4 7.026 6.236 7.026 9.1a18.181 18.181 0 01-1.692 7.33l-.268.576c-.223.454.138 1.005.682 1.005h3.403c.32 1.227 1.45 2 2.86 2zm-5.844-3l.074-.16A19.19 19.19 0 008.027 9.11C8.027 6.782 9.759 5 12.01 5c2.256 0 4 1.785 4 4.09a19.132 19.132 0 001.771 7.762l.074.159h-3.758l-.195.747c-.2.762-.916 1.253-1.892 1.253-.976 0-1.693-.49-1.892-1.253l-.195-.747H6.167z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12.011 20.011c1.41 0 2.54-.773 2.86-2h3.402c.55 0 .893-.52.683-1.002l-.267-.577a18.124 18.124 0 01-1.677-7.349c0-2.845-2.187-5.083-5-5.083C9.2 4 7.026 6.236 7.026 9.1a18.181 18.181 0 01-1.692 7.33l-.268.576c-.223.454.138 1.005.682 1.005h3.403c.32 1.227 1.45 2 2.86 2z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M13.298 9.629a.244.244 0 01-.015-.327c.415-.5.688-1.12.784-1.784a3.728 3.728 0 00-.241-1.957 3.421 3.421 0 00-1.19-1.5 3.058 3.058 0 00-1.755-.561H7.22a1.66 1.66 0 00-1.217.544c-.323.348-.504.82-.504 1.313v9.286c0 .492.181.965.504 1.313s.761.544 1.218.544h3.616c.74.001 1.462-.24 2.072-.69a3.91 3.91 0 001.345-1.835 4.238 4.238 0 00.145-2.334 4.017 4.017 0 00-1.105-2.012h.003zm-6.076-4.04c0-.061.022-.12.063-.164a.208.208 0 01.152-.068h3.444c.4 0 .782.171 1.065.476.283.305.441.718.441 1.15 0 .43-.159.843-.441 1.148a1.453 1.453 0 01-1.065.476H7.437a.208.208 0 01-.152-.068.242.242 0 01-.063-.164V5.589zm3.619 9.054H7.437a.208.208 0 01-.152-.068.242.242 0 01-.063-.164v-3.715c0-.061.022-.12.063-.164a.207.207 0 01.152-.068h3.404c.514 0 1.007.22 1.37.612.363.392.567.923.567 1.478 0 .554-.204 1.085-.567 1.477a1.868 1.868 0 01-1.37.612z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12 4c.839 0 1.623.148 2.354.445a6.11 6.11 0 011.904 1.203 5.62 5.62 0 011.275 1.782c.311.682.467 1.409.467 2.18 0 1.093-.227 1.926-.68 2.5a9.269 9.269 0 01-1.41 1.453c-.363.291-.652.544-.868.757a1.05 1.05 0 00-.322.774v.844c0 .01-.003.02-.009.03a.065.065 0 00-.008.032h.017v1.453c0 .76-.25 1.375-.748 1.844-.499.469-1.15.703-1.955.703-.827 0-1.49-.234-1.989-.703-.498-.469-.748-1.083-.748-1.844V16h.017c0-.01-.002-.02-.008-.031a.065.065 0 01-.009-.031v-.844c0-.198-.096-.388-.288-.57a14.88 14.88 0 00-.765-.665c-.488-.406-.98-.924-1.48-1.554C6.25 11.675 6 10.776 6 9.609c0-.77.156-1.497.467-2.18a5.62 5.62 0 011.275-1.78 6.11 6.11 0 011.904-1.204A6.195 6.195 0 0112 4zm-.017 15c.521 0 .926-.135 1.215-.406.29-.271.434-.651.434-1.14v-.688a5.093 5.093 0 01-.697.164A5.55 5.55 0 0112 17a6.19 6.19 0 01-.943-.063 4.52 4.52 0 01-.689-.156v.672c0 .48.142.857.425 1.133.283.276.68.414 1.19.414zm3.212-6.188a7.083 7.083 0 001.199-1.226c.345-.453.518-1.112.518-1.977 0-.635-.124-1.231-.374-1.789a4.62 4.62 0 00-1.037-1.468 4.829 4.829 0 00-1.563-.993C13.338 5.12 12.69 5 12 5c-.691 0-1.337.12-1.938.36-.6.239-1.121.57-1.563.992A4.62 4.62 0 007.462 7.82a4.331 4.331 0 00-.374 1.79c0 .947.195 1.674.586 2.18.391.504.819.95 1.284 1.335.34.281.66.573.96.875.3.302.45.667.45 1.094v.64c.114.063.295.125.544.188.25.062.606.094 1.071.094.453 0 .807-.034 1.062-.102a3.83 3.83 0 00.587-.195v-.625c0-.542.167-.985.501-1.328.334-.344.689-.662 1.062-.954z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12 4c.839 0 1.623.148 2.354.445a6.11 6.11 0 011.904 1.203 5.62 5.62 0 011.275 1.782c.311.682.467 1.409.467 2.18 0 1.093-.227 1.926-.68 2.5a9.269 9.269 0 01-1.41 1.453c-.363.291-.652.544-.868.757a1.05 1.05 0 00-.322.774v.844c0 .01-.003.02-.009.03a.065.065 0 00-.008.032h.017v1.453c0 .76-.25 1.375-.748 1.844-.499.469-1.15.703-1.955.703-.827 0-1.49-.234-1.989-.703-.498-.469-.748-1.083-.748-1.844V16h.017c0-.01-.002-.02-.008-.031a.065.065 0 01-.009-.031v-.844c0-.198-.096-.388-.288-.57a14.88 14.88 0 00-.765-.665c-.488-.406-.98-.924-1.48-1.554C6.25 11.675 6 10.776 6 9.609c0-.77.156-1.497.467-2.18a5.62 5.62 0 011.275-1.78 6.11 6.11 0 011.904-1.204A6.195 6.195 0 0112 4zm-.017 15c.521 0 .926-.135 1.215-.406.29-.271.434-.651.434-1.14v-.688a5.093 5.093 0 01-.697.164A5.55 5.55 0 0112 17a6.19 6.19 0 01-.943-.063 4.52 4.52 0 01-.689-.156v.672c0 .48.142.857.425 1.133.283.276.68.414 1.19.414z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M6.924 4.57a.29.29 0 00-.116.023.621.621 0 00-.1.054c-.431.308-.84.652-1.225 1.032-.385.38-.608.658-.67.832.02.463.136.969.347 1.518.21.55.51 1.132.901 1.749.39.616.866 1.263 1.425 1.941a32.29 32.29 0 001.903 2.095c.72.72 1.42 1.359 2.103 1.918.683.56 1.333 1.033 1.95 1.418.615.385 1.198.685 1.748.901.55.216 1.055.334 1.517.355.175-.072.452-.3.832-.686.38-.385.724-.794 1.033-1.225a.292.292 0 00.069-.139.817.817 0 00.008-.092 28.76 28.76 0 00-.601-.4c-.298-.196-.617-.406-.956-.632l-1.525-1.017h-.015a.65.65 0 00-.108.015.654.654 0 00-.2.093 27.775 27.775 0 00-1.371.77l-.555.308-.509-.37c-.184-.133-.485-.37-.9-.708a21.965 21.965 0 01-1.565-1.449 28.089 28.089 0 01-1.456-1.571c-.344-.41-.583-.714-.716-.909l-.354-.508.308-.54c.195-.349.362-.644.5-.886.14-.241.229-.403.27-.485a.813.813 0 00.092-.323c-.061-.103-.19-.303-.385-.601a97.481 97.481 0 00-.624-.94 97.48 97.48 0 01-.624-.94 11.001 11.001 0 00-.4-.585c0-.01-.005-.016-.016-.016h-.015zm.01-.96c.165 0 .319.03.463.092a.753.753 0 01.338.277l.378.554c.21.309.436.645.678 1.01.241.364.467.703.678 1.016.21.314.341.511.393.594a.999.999 0 01.123.57c-.01.226-.077.462-.2.708-.072.124-.196.34-.37.648-.175.308-.313.56-.416.754.113.165.331.442.655.832.323.39.788.889 1.394 1.495.616.616 1.12 1.086 1.51 1.41.39.323.667.541.832.654.185-.102.434-.244.747-.423.313-.18.532-.3.655-.362.133-.072.264-.126.393-.162.128-.036.254-.054.377-.054.093 0 .18.013.262.038.082.026.16.06.231.1l.609.393a373.833 373.833 0 012.041 1.348c.308.206.493.334.555.386.205.133.331.352.377.655.046.303-.038.613-.254.932l-.277.362c-.185.241-.411.506-.678.793a7.786 7.786 0 01-.855.794c-.303.241-.573.362-.81.362h-.015c-.677-.02-1.376-.185-2.095-.493a13.117 13.117 0 01-2.126-1.164 19.865 19.865 0 01-2.026-1.556 36.632 36.632 0 01-1.795-1.671 34.26 34.26 0 01-1.664-1.795 20.545 20.545 0 01-1.548-2.026A13.27 13.27 0 014.33 8.562c-.309-.713-.473-1.404-.493-2.072-.01-.246.105-.519.346-.816.242-.298.506-.58.794-.848.287-.267.552-.493.793-.678.241-.185.367-.282.378-.292.123-.083.251-.144.385-.185.133-.041.267-.062.4-.062z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M6.934 3.61c.165 0 .319.03.463.092a.753.753 0 01.338.277l.378.554c.21.309.436.645.678 1.01.241.364.467.703.678 1.016.21.314.341.511.393.594a.999.999 0 01.123.57c-.01.226-.077.462-.2.708-.072.124-.196.34-.37.648-.175.308-.313.56-.416.754.113.165.331.442.655.832.323.39.788.889 1.394 1.495.616.616 1.12 1.086 1.51 1.41.39.323.667.541.832.654.185-.102.434-.244.747-.423.313-.18.532-.3.655-.362.133-.072.264-.126.393-.162.128-.036.254-.054.377-.054.093 0 .18.013.262.038.082.026.16.06.231.1l.609.393a373.833 373.833 0 012.041 1.348c.308.206.493.334.555.386.205.133.331.352.377.655.046.303-.038.613-.254.932l-.277.362c-.185.241-.411.506-.678.793a7.786 7.786 0 01-.855.794c-.303.241-.573.362-.81.362h-.015c-.677-.02-1.376-.185-2.095-.493a13.117 13.117 0 01-2.126-1.164 19.865 19.865 0 01-2.026-1.556 36.632 36.632 0 01-1.795-1.671 34.26 34.26 0 01-1.664-1.795 20.545 20.545 0 01-1.548-2.026A13.27 13.27 0 014.33 8.562c-.309-.713-.473-1.404-.493-2.072-.01-.246.105-.519.346-.816.242-.298.506-.58.794-.848.287-.267.552-.493.793-.678.241-.185.367-.282.378-.292.123-.083.251-.144.385-.185.133-.041.267-.062.4-.062z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("defs", null, s.createElement("path", {
        d: "M7.388 5.055a1.296 1.296 0 00-.34.164c-.01.009-.121.096-.335.26-.214.163-.447.365-.702.6-.255.239-.49.489-.703.753-.214.265-.316.506-.307.724.018.593.164 1.205.437 1.839.272.633.615 1.26 1.029 1.88.414.62.87 1.22 1.37 1.798.502.58.992 1.11 1.474 1.592.483.484 1.012.978 1.59 1.484.576.505 1.175.965 1.793 1.38.618.415 1.246.76 1.882 1.033.637.272 1.255.42 1.856.438h.013c.21 0 .448-.108.716-.322a6.91 6.91 0 00.757-.704c.236-.255.436-.49.6-.704l.246-.322c.19-.282.266-.558.225-.826-.04-.27-.152-.463-.334-.582a8.825 8.825 0 00-.492-.341l-.893-.595c-.322-.214-.628-.415-.915-.602-.285-.186-.464-.303-.538-.348a.977.977 0 00-.204-.089.758.758 0 00-.231-.034c-.11 0-.222.016-.335.047-.114.032-.23.08-.349.144-.108.055-.3.162-.579.321-.277.16-.497.285-.661.377-.146-.1-.391-.295-.737-.581a20.684 20.684 0 01-1.337-1.252c-.536-.537-.948-.98-1.235-1.326a12.18 12.18 0 01-.579-.737c.09-.174.214-.397.369-.67.154-.275.264-.465.327-.574.11-.22.168-.43.177-.63a.879.879 0 00-.11-.505 25.962 25.962 0 00-.346-.527c-.187-.277-.387-.578-.6-.902a72.02 72.02 0 00-.6-.895l-.336-.493a.673.673 0 00-.299-.246A1.037 1.037 0 007.742 5c-.117 0-.236.019-.354.055z",
        id: "IcnCallSmall_svg__a"
      })), s.createElement("use", {
        fill: "currentColor",
        xlinkHref: "#IcnCallSmall_svg__a",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.5 4a2.5 2.5 0 012.49 2.283l.827.236a.5.5 0 01.084.929l-.084.033-.818.233L20 12a6 6 0 01-6 6v2h1.5a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L15.5 21h-2a.5.5 0 01-.492-.41L13 20.5V18h-3v2h1.5a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L11.5 21h-2a.5.5 0 01-.492-.41L9 20.5V18H4.733a1 1 0 01-.745-1.666L14.105 5.002A3.002 3.002 0 0116.343 4H17.5zm0 1h-1.157a2 2 0 00-1.373.546l-.119.122L4.733 17H14a4.999 4.999 0 004.995-4.783L19 12V6.5a1.5 1.5 0 00-1.356-1.493L17.5 5zM17 6a1 1 0 110 2 1 1 0 010-2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        d: "M12 3a9 9 0 110 18 9 9 0 010-18zm0 1a8 8 0 100 16 8 8 0 000-16zm0 3a.5.5 0 01.492.41l.008.09v4.293l3.354 3.353a.5.5 0 01-.638.765l-.07-.057-3.5-3.5-.011-.013a.503.503 0 01-.033-.039l.044.052a.502.502 0 01-.138-.264l-.003-.016a.503.503 0 01-.005-.062V7.5A.5.5 0 0112 7z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M15.595 9.216L12.81 12l2.784 2.784a.573.573 0 11-.811.811L12 12.81l-2.784 2.784a.573.573 0 11-.811-.811L11.19 12 8.405 9.216a.573.573 0 11.811-.811L12 11.19l2.784-2.784a.573.573 0 01.811.811z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M17.392 7.825L13.216 12l4.176 4.175a.86.86 0 11-1.216 1.216L12 13.217l-4.175 4.176a.86.86 0 01-1.216-1.216L10.783 12 6.608 7.825a.86.86 0 011.216-1.216L12 10.783l4.175-4.176a.86.86 0 111.216 1.216z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M20.164 12.356l-.021-.004-1.264-.278-.075-.3a1.642 1.642 0 00-.094-.275 8.251 8.251 0 00-.15-.314l-.122-.245.14-.235.526-.884a.736.736 0 00.11-.324c.006-.05-.003-.075-.044-.116l-.527-.527a.18.18 0 00-.158-.06.611.611 0 00-.31.092l-1.082.692-.254-.127a4.647 4.647 0 00-.614-.254l-.271-.09-.06-.28-.21-.978a.652.652 0 00-.157-.279.176.176 0 00-.152-.07h-.75c-.059 0-.08.01-.11.048a.783.783 0 00-.156.326l-.315 1.231-.266.083a3.671 3.671 0 00-.64.269l-.258.137-.246-.156-.881-.56a.556.556 0 00-.29-.084c-.07-.004-.105.01-.156.063l-.526.514c-.039.041-.049.07-.042.126a.834.834 0 00.107.339l.688 1.14-.111.241c-.045.098-.09.199-.135.304-.039.09-.07.18-.096.269l-.082.287-.292.064-.982.215a.53.53 0 00-.26.142c-.057.05-.076.094-.076.162v.75c0 .05.01.068.048.098a.895.895 0 00.32.166l1.255.303.08.28c.026.088.055.17.089.247.04.09.08.178.124.265l.123.246-.142.235-.55.913a.834.834 0 00-.108.34c-.007.056.003.085.029.112l.552.541c.038.04.073.054.143.05a.567.567 0 00.304-.093l1.113-.707.258.137c.101.055.207.104.316.148.112.046.224.086.336.12l.27.085.066.275.233.953c.03.112.084.22.168.328.03.039.049.048.098.048h.75c.069 0 .112-.02.162-.075a.543.543 0 00.146-.281l.273-1.257.278-.087c.109-.034.21-.071.303-.111.1-.043.201-.09.302-.14l.254-.127.239.153.847.54c.08.053.18.084.306.09a.18.18 0 00.158-.059l.527-.527c.041-.041.05-.066.044-.116a.76.76 0 00-.12-.341l-.66-1.11.134-.25c.046-.086.087-.173.123-.262.039-.095.076-.196.112-.304l.088-.263.27-.065.963-.232a.901.901 0 00.328-.168c.039-.03.048-.049.048-.098v-.75c0-.068-.02-.112-.075-.162a.53.53 0 00-.26-.142zm.086-.493c.18.032.35.12.51.264a.69.69 0 01.24.533v.75c0 .203-.08.367-.24.492a1.4 1.4 0 01-.51.258l-.973.235c-.039.117-.08.228-.123.334a3.206 3.206 0 01-.146.31l.515.867c.102.157.164.336.188.54a.613.613 0 01-.188.527l-.527.527a.677.677 0 01-.539.205 1.104 1.104 0 01-.55-.17l-.845-.539c-.109.055-.218.106-.328.152-.109.047-.226.09-.351.13l-.211.972c-.031.18-.12.35-.264.51a.69.69 0 01-.533.24h-.75a.595.595 0 01-.492-.24 1.4 1.4 0 01-.258-.51l-.234-.96a4.801 4.801 0 01-.375-.136 3.853 3.853 0 01-.364-.17l-.867.551c-.148.102-.33.158-.545.17a.65.65 0 01-.533-.205l-.539-.527a.628.628 0 01-.176-.528 1.33 1.33 0 01.176-.539l.55-.914a6.454 6.454 0 01-.134-.287 2.423 2.423 0 01-.111-.31l-.973-.235a1.4 1.4 0 01-.51-.258.595.595 0 01-.24-.492v-.75c0-.21.08-.389.24-.533.16-.145.33-.232.51-.264l.96-.21c.032-.11.071-.22.118-.329.047-.11.094-.215.14-.316l-.55-.914a1.33 1.33 0 01-.176-.54.628.628 0 01.176-.527l.539-.527a.65.65 0 01.533-.205c.215.012.397.068.545.17l.867.55a4.26 4.26 0 01.727-.304l.246-.961c.04-.18.121-.35.246-.51a.606.606 0 01.504-.24h.75c.21 0 .387.08.527.24.141.16.23.326.27.498l.21.985a5.226 5.226 0 01.68.28l.844-.538c.157-.102.34-.158.551-.17.211-.012.39.057.54.205l.526.527c.149.149.211.325.188.528a1.233 1.233 0 01-.188.539l-.515.867c.055.11.107.22.158.334.05.113.092.232.123.357l.961.211zm-5.386-.71c-.474 0-.868.162-1.209.5-.339.338-.503.734-.503 1.217 0 .483.164.878.503 1.216.34.338.735.501 1.209.501.482 0 .88-.163 1.22-.501.339-.338.503-.733.503-1.216s-.164-.88-.503-1.216a1.65 1.65 0 00-1.22-.502zm0-.5a2.15 2.15 0 011.572.646c.434.431.651.955.651 1.57 0 .617-.217 1.14-.65 1.571a2.15 2.15 0 01-1.573.647 2.136 2.136 0 01-1.561-.647 2.132 2.132 0 01-.65-1.57c0-.616.216-1.14.65-1.571a2.136 2.136 0 011.56-.647z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), s.createElement("path", {
        d: "M7.895 5.655c-.012-.007-.01-.007-.024-.002a.27.27 0 00-.123.074l-.548.6-.216-.044a2.656 2.656 0 00-.377-.05l-.222-.013-.1-.198-.27-.525a.296.296 0 00-.102-.102c-.012-.008-.01-.007-.021-.004l-.426.114a.372.372 0 00-.028.164l.009.804-.184.116a2.078 2.078 0 00-.31.24l-.166.155-.217-.068-.592-.186a.24.24 0 00-.128 0c-.015.003-.01 0-.019.017l-.22.37c.025.063.056.11.091.145l.603.58-.035.204a7.06 7.06 0 00-.03.191 1.24 1.24 0 00-.013.157l-.003.232-.207.107-.532.275a.224.224 0 00-.088.087c-.01.015-.01.016-.006.03l.112.418a.43.43 0 00.16.035l.819-.02.117.194c.025.043.052.082.08.117.036.044.072.087.11.129l.141.16-.06.206-.174.605a.401.401 0 00-.007.171l.389.22c.004.002-.003.001.011-.004a.246.246 0 00.12-.074l.565-.614.22.051a2.451 2.451 0 00.396.051l.22.01.106.192.278.508a.435.435 0 00.114.128l.42-.112c.013-.004.013-.004.022-.02a.233.233 0 00.03-.137l-.04-.814.192-.12c.055-.035.104-.07.149-.105.049-.04.098-.08.146-.123l.165-.146.21.066.568.18a.269.269 0 00.141.002c.014-.003.013-.002.02-.014l.22-.38a.36.36 0 00-.098-.138l-.585-.57.05-.214c.013-.053.023-.106.03-.16.007-.058.012-.12.016-.184l.013-.215.19-.103.513-.28a.435.435 0 00.128-.113l-.112-.42c-.004-.013-.004-.013-.02-.022a.224.224 0 00-.12-.031l-.018.001-.822.038-.117-.211a.878.878 0 00-.086-.129 4.787 4.787 0 00-.131-.154l-.141-.159.058-.204.166-.59a.339.339 0 00.01-.153l-.38-.22zm1.426 1.393a.604.604 0 01.331.072.408.408 0 01.22.268l.114.428a.352.352 0 01-.062.318.828.828 0 01-.252.226l-.52.283c-.004.073-.01.142-.019.21-.008.066-.02.133-.036.2l.428.416a.73.73 0 01.19.279.363.363 0 01-.027.33l-.22.382a.4.4 0 01-.277.2.653.653 0 01-.341-.013l-.565-.179a3.642 3.642 0 01-.164.137 2.174 2.174 0 01-.18.128l.028.588a.604.604 0 01-.073.331.408.408 0 01-.268.22l-.428.114a.352.352 0 01-.318-.062.828.828 0 01-.226-.252l-.28-.513a2.84 2.84 0 01-.47-.06l-.41.447a.619.619 0 01-.286.18.385.385 0 01-.336-.035l-.388-.22a.371.371 0 01-.181-.274.787.787 0 01.017-.335l.175-.606a3.817 3.817 0 01-.12-.143 1.433 1.433 0 01-.112-.16l-.592.014a.828.828 0 01-.33-.07.352.352 0 01-.213-.244l-.115-.428a.408.408 0 01.056-.341.604.604 0 01.25-.23l.518-.267c0-.067.006-.135.016-.205.01-.07.021-.137.032-.202l-.454-.438a.787.787 0 01-.183-.281.371.371 0 01.02-.329l.227-.383a.385.385 0 01.273-.2.619.619 0 01.337.014l.58.182a2.52 2.52 0 01.368-.285l-.006-.587a.745.745 0 01.062-.329.359.359 0 01.252-.214l.428-.115a.398.398 0 01.338.057c.105.07.182.15.23.243l.272.53a3.091 3.091 0 01.43.057l.4-.437a.653.653 0 01.29-.182.4.4 0 01.338.035l.382.22c.108.063.17.153.188.273a.73.73 0 01-.024.337l-.162.574c.048.054.095.11.141.167.047.057.088.118.125.185l.582-.026zm-2.848.51a.875.875 0 00-.65.27.873.873 0 00-.27.653c0 .261.088.472.27.654.184.182.394.269.65.269.26 0 .472-.087.655-.27a.873.873 0 00.27-.653.873.873 0 00-.27-.653.883.883 0 00-.655-.27zm0-.388c.363 0 .673.127.93.382.256.255.385.565.385.93 0 .364-.129.673-.385.928a1.271 1.271 0 01-.93.383c-.36 0-.667-.128-.924-.383a1.26 1.26 0 01-.385-.929c0-.364.129-.674.385-.929.257-.255.565-.382.924-.382z",
        fill: "currentColor",
        fillRule: "nonzero",
        opacity: .25
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12 16a2 2 0 110 4 2 2 0 010-4zm5.2-.764l-.74.764A5.185 5.185 0 0015 14.326l.001-1.23a6.197 6.197 0 012.2 2.14zM9 13.096v1.23a5.185 5.185 0 00-1.459 1.673l-.74-.764a6.197 6.197 0 012.198-2.14zM13 4v10h-2V4h2zm7.114 8.232l-.724.747a9.216 9.216 0 00-4.389-3.283V8.605a10.221 10.221 0 015.113 3.627zM9 8.604v1.091a9.216 9.216 0 00-4.39 3.283l-.723-.747A10.22 10.22 0 019 8.604zm14.001.654L22.28 10A13.237 13.237 0 0015 5.384V4.32c3.193.694 5.99 2.472 8.001 4.937zm-14-4.937L9 5.384A13.237 13.237 0 001.72 9.999L1 9.257c2.01-2.465 4.808-4.243 8-4.936z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        fill: "#707578",
        fillRule: "evenodd",
        d: "M13.469 2.5c.63 0 1.15.48 1.212 1.094l.007.125-.001 1.593h1.407c.73 0 1.331.558 1.4 1.271l.006.136v9.375c0 .776-.63 1.406-1.406 1.406H6.719c-.777 0-1.407-.63-1.407-1.406v-1.407H3.719c-.631 0-1.15-.48-1.213-1.094L2.5 13.47v-9.75c0-.631.48-1.15 1.094-1.213L3.72 2.5h9.75zm2.625 3.75H6.719a.469.469 0 00-.469.469v9.375c0 .259.21.468.469.468h9.375c.259 0 .468-.21.468-.468V6.719a.469.469 0 00-.468-.469zm-2.625-2.813h-9.75a.281.281 0 00-.274.217l-.007.065v9.75c0 .133.092.244.216.274l.065.007 1.593-.001v-7.03c0-.731.558-1.332 1.271-1.4l.136-.006 7.031-.001V3.719a.281.281 0 00-.217-.274l-.064-.007z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M15.453 8.375a.525.525 0 01.297-.04c.104.017.193.06.266.134a.516.516 0 01.117.265.456.456 0 01-.055.297l-2.36 4.64a.348.348 0 01-.085.11.574.574 0 01-.117.078l-4.782 1.985a.24.24 0 01-.093.039.673.673 0 01-.11.008.43.43 0 01-.18-.04.5.5 0 01-.148-.101.458.458 0 01-.133-.258.504.504 0 01.04-.289l2.25-4.515a.452.452 0 01.203-.203l4.89-2.11zm-5.86 6.016l2.735-1.063-1.375-1.719-1.36 2.782zm3.548-1.641l1.375-2.828L11.75 11l1.39 1.75zM12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4zm0 15.016c.969 0 1.878-.185 2.727-.555a7.064 7.064 0 002.218-1.508 7.228 7.228 0 001.5-2.226c.37-.85.555-1.758.555-2.727 0-.969-.185-1.878-.555-2.727a7.131 7.131 0 00-1.5-2.218 7.131 7.131 0 00-2.218-1.5A6.753 6.753 0 0012 5c-.969 0-1.878.185-2.727.555-.849.37-1.588.87-2.218 1.5-.63.63-1.13 1.37-1.5 2.218A6.753 6.753 0 005 12c0 .969.185 1.878.555 2.727.37.849.87 1.59 1.5 2.226a7.064 7.064 0 002.218 1.508c.85.37 1.758.555 2.727.555z",
        fill: "currentColor"
      }), s.createElement("circle", {
        stroke: "currentColor",
        strokeWidth: .2,
        opacity: .198,
        cx: 12,
        cy: 12,
        r: 7.9
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M15.453 8.375a.525.525 0 01.297-.04c.104.017.193.06.266.134a.516.516 0 01.117.265.456.456 0 01-.055.297l-2.36 4.64a.348.348 0 01-.085.11.574.574 0 01-.117.078l-4.782 1.985a.24.24 0 01-.093.039.673.673 0 01-.11.008.43.43 0 01-.18-.04.5.5 0 01-.148-.101.458.458 0 01-.133-.258.504.504 0 01.04-.289l2.25-4.515a.452.452 0 01.203-.203l4.89-2.11zm-5.86 6.016l2.735-1.063-1.375-1.719-1.36 2.782zm3.548-1.641l1.375-2.828L11.75 11l1.39 1.75zM12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 4a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h12zm0 1H6a1 1 0 00-1 1v7.74l1.278-1.278a1.3 1.3 0 011.839 0l2.118 2.119a.3.3 0 00.424 0L15.24 10h-1.75a.5.5 0 010-1h3.017a.5.5 0 01.5.5v3.018a.5.5 0 11-1 0l-.001-1.869-4.638 4.639a1.3 1.3 0 01-1.839 0L7.41 13.169a.3.3 0 00-.424 0L5 15.154V18a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.985 13.17a.3.3 0 01.424 0l2.12 2.118a1.3 1.3 0 001.838 0l4.638-4.639v1.869a.5.5 0 101 0V9.5a.5.5 0 00-.5-.5H13.49a.5.5 0 000 1h1.749l-4.58 4.58a.3.3 0 01-.424 0l-2.118-2.118a1.3 1.3 0 00-1.839 0L4 14.74V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-1.994z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M6 9v10h2V9H6zm0-1h2a1 1 0 011 1v10a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1zm5 5v6h2v-6h-2zm0-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1zm5-7v14h2V5h-2zm0-1h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M6 8h2a1 1 0 011 1v10a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1zm5 4h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1zm5-8h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M15.042 8.375h-6.5c-.645 0-1.167.522-1.167 1.167v7.041c0 .645.522 1.167 1.167 1.167h4.927v.781h-1.813a.625.625 0 000 1.25h4.875a.625.625 0 000-1.25H14.72v-.781h4.927c.644 0 1.166-.522 1.166-1.167V12.2h-1.25v4.3H8.626V9.625h5.707c.035-.086.077-.172.127-.256l.583-.994z",
        fill: "#fff"
      }), s.createElement("path", {
        d: "M14.426 11.203l-1.357 2.716-.969-1.452a.829.829 0 00-.688-.368h-1.01a.625.625 0 100 1.25h.784l1.246 1.868a.828.828 0 001.429-.088l1.533-3.067a1.933 1.933 0 01-.968-.86zM16.108 12.2l.52.78a.828.828 0 00.69.369h.396a.625.625 0 00.34-1.149h-1.946z",
        fill: "#fff"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.678 9.875l-3.89-6.629a.922.922 0 00-1.578 0l-3.89 6.629c-.346.59.092 1.325.79 1.325h7.779c.698 0 1.136-.735.79-1.325zM19.993 5.8h.012c.367.004.644.355.587.746l-.257 1.343c-.024.178-.167.311-.334.311h-.004c-.167 0-.31-.133-.334-.31l-.256-1.344c-.057-.39.224-.746.586-.746zM20 10a.6.6 0 100-1.2.6.6 0 000 1.2z",
        fill: "#E36A19"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.789 3.246l3.89 6.629c.346.59-.092 1.325-.79 1.325h-7.78c-.697 0-1.135-.735-.789-1.325l3.89-6.629a.922.922 0 011.579 0zm-.78 2.554h-.013c-.362 0-.643.355-.586.746l.256 1.343c.025.178.167.311.334.311h.004c.167 0 .31-.133.334-.31l.257-1.344c.057-.39-.22-.742-.587-.746zm.593 3.6a.6.6 0 11-1.2 0 .6.6 0 011.2 0z",
        fill: "#F47C22"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1.2,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("circle", {
        cx: 12,
        cy: 7.896,
        r: 5.26
      }), s.createElement("path", {
        d: "M9.662 9.638c.778.78 1.557 1.17 2.338 1.17.782 0 1.564-.39 2.348-1.17M4.499 21.337c.04-2.067.774-3.756 2.199-5.067C8.123 14.958 9.89 14.31 12 14.325M19.501 21.338c-.04-2.067-.774-3.757-2.199-5.068-1.425-1.312-3.192-1.96-5.302-1.945",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "nonzero"
      }, s.createElement("path", {
        d: "M12 13.756a5.86 5.86 0 110-11.72 5.86 5.86 0 010 11.72zm-2.762-3.694c.881.884 1.804 1.345 2.762 1.345s1.883-.46 2.771-1.343a.6.6 0 10-.846-.851c-.68.676-1.32.994-1.925.994-.604 0-1.24-.318-1.913-.992a.6.6 0 10-.85.847z"
      }), s.createElement("path", {
        d: "M12.01 13.725c2.252-.013 4.162.69 5.699 2.103 1.547 1.425 2.348 3.27 2.392 5.498a.6.6 0 01-.62.611c-5.075.007-7.155.003-7.485 0-1.961-.014-7.178.007-7.51 0a.6.6 0 01-.587-.611c.044-2.228.845-4.073 2.392-5.498 1.54-1.417 3.455-2.12 5.713-2.103h.006z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M8 7a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-4 4a1 1 0 110-2 1 1 0 010 2z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M8 7a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-4 4a1 1 0 110-2 1 1 0 010 2z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M17.448 4c.431 0 .798.146 1.1.438.301.291.452.645.452 1.062v13c0 .417-.15.77-.453 1.063a1.523 1.523 0 01-1.099.437H7.118c-.194 0-.418-.062-.671-.188-.253-.125-.38-.395-.38-.812v-2.016h-.534a.487.487 0 01-.347-.148.473.473 0 010-.695.501.501 0 01.347-.141h.534v-2h-.534a.487.487 0 01-.347-.148.473.473 0 010-.696.501.501 0 01.347-.14h.534v-2.032H5.55a.492.492 0 01-.502-.484.492.492 0 01.501-.484h.518V8h-.566A.492.492 0 015 7.516c0-.136.048-.253.145-.352a.479.479 0 01.356-.148h.566V5.03c0-.25.086-.484.259-.703.172-.219.442-.328.808-.328h10.314zM7.031 19h8V5h-8v2.016h.485c.135 0 .25.05.343.148.094.099.141.216.141.352 0 .135-.047.25-.14.343A.468.468 0 017.515 8H7.03v2.016h.532c.135 0 .25.046.343.14.094.094.14.209.14.344 0 .135-.046.25-.14.344a.468.468 0 01-.343.14H7.03v2.032h.516c.135 0 .252.046.351.14a.455.455 0 01.149.344.48.48 0 01-.149.352.48.48 0 01-.351.148H7.03v2h.516c.135 0 .252.047.351.14a.455.455 0 01.149.344.48.48 0 01-.149.352.48.48 0 01-.351.148H7.03V19zM18 18.5v-13c0-.135-.065-.253-.195-.352A.74.74 0 0017.344 5H16.03v14h1.313a.74.74 0 00.461-.148c.13-.1.195-.217.195-.352z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M17.031 4c.417 0 .771.146 1.063.438.291.291.437.645.437 1.062v13c0 .417-.146.77-.437 1.063A1.447 1.447 0 0117.03 20H7.047c-.188 0-.404-.062-.649-.188-.244-.125-.367-.395-.367-.812v-2.016h-.515a.463.463 0 01-.336-.148.48.48 0 01-.149-.352c0-.135.05-.25.149-.343A.476.476 0 015.516 16h.515v-2h-.515a.463.463 0 01-.336-.148.48.48 0 01-.149-.352c0-.135.05-.25.149-.344a.476.476 0 01.336-.14h.515v-2.032h-.5a.468.468 0 01-.343-.14.468.468 0 01-.141-.344c0-.135.047-.25.14-.344a.468.468 0 01.344-.14h.5V8h-.547a.468.468 0 01-.343-.14A.468.468 0 015 7.515c0-.136.047-.253.14-.352a.455.455 0 01.344-.148h.547V5.03c0-.25.084-.484.25-.703.167-.219.427-.328.782-.328h9.968zm.5 14.5v-13a.48.48 0 00-.148-.352A.48.48 0 0017.03 5h-1v14h1a.48.48 0 00.352-.148.48.48 0 00.148-.352z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        d: "M14.5 15a.5.5 0 110 1h-9a.5.5 0 110-1h9zM10 2.5a.5.5 0 01.5.5v9.792l4.146-4.146a.5.5 0 01.708.708l-5 5-.042.037-.062.042-.06.03-.062.02-.056.012L10 14.5l-.053-.003-.075-.014-.063-.02-.076-.04-.055-.04-5.032-5.03a.5.5 0 11.708-.707L9.5 12.792V3a.5.5 0 01.5-.5z",
        fill: "#121C2D",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 16",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M9.5 2a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
        stroke: "currentColor"
      }), s.createElement("circle", {
        cx: 2,
        cy: 2,
        r: 1.5,
        stroke: "currentColor"
      }), s.createElement("path", {
        d: "M9.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
        stroke: "currentColor"
      }), s.createElement("circle", {
        cx: 2,
        cy: 8,
        r: 1.5,
        stroke: "currentColor"
      }), s.createElement("path", {
        d: "M9.5 14a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
        stroke: "currentColor"
      }), s.createElement("circle", {
        cx: 2,
        cy: 14,
        r: 1.5,
        stroke: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M16.5 19a.5.5 0 110 1h-12a.5.5 0 110-1h12zm3-3a.5.5 0 110 1h-9a.5.5 0 110-1h9zM13.396 5.103l2.5 2.5L6.72 16.78a.75.75 0 01-.53.22H4.75a.75.75 0 01-.75-.75v-1.44a.75.75 0 01.22-.53l9.176-9.177zM16.53 3.03l1.44 1.44a.75.75 0 010 1.06l-1.367 1.366-2.5-2.5L15.47 3.03a.75.75 0 011.06 0z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19 6a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h14zm0 3.543l-6.41 2.748a1.5 1.5 0 01-1.18 0L5 9.544V17h14V9.543zM19 7H5v1.456l6.803 2.916a.5.5 0 00.394 0L19 8.455V7z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M20 7.441l-7.776 3.888a.5.5 0 01-.448 0L4 7.441V7a1 1 0 011-1h14a1 1 0 011 1v.441zm0 1.118V17a1 1 0 01-1 1H5a1 1 0 01-1-1V8.559l7.33 3.665a1.5 1.5 0 001.34 0L20 8.559z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64"
      }, e), s.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "currentColor"
      }, s.createElement("path", {
        d: "M54 18.278H10c-.414 0-.79.168-1.06.44a1.49 1.49 0 00-.44 1.06v5.5h47v-5.5c0-.414-.168-.79-.44-1.06a1.49 1.49 0 00-1.06-.44zm1.5 7.111h-47V54c0 .414.168.79.44 1.06.27.272.646.44 1.06.44h44c.414 0 .79-.168 1.06-.44.272-.27.44-.646.44-1.06V25.389z"
      }), s.createElement("path", {
        strokeLinecap: "round",
        d: "M30.222 39.556h19.556"
      }), s.createElement("rect", {
        width: 13.222,
        height: 13.222,
        x: 13.833,
        y: 34.278,
        rx: 1
      }), s.createElement("path", {
        strokeLinecap: "round",
        d: "M30.222 36.889h8.889M13.778 21.778h17.778M50.092 20.76l1.886 1.885M50.092 22.645l1.886-1.886M30.222 42.222h19.556m-19.556 2.667h16"
      }), s.createElement("circle", {
        cx: 20.444,
        cy: 39.556,
        r: 2.722
      }), s.createElement("path", {
        d: "M22.889 44.056H18c-.414 0-.79.167-1.06.439-.272.271-.44.646-.44 1.06V47.5h7.889v-1.944c0-.415-.168-.79-.44-1.061a1.49 1.49 0 00-1.06-.44z"
      }), s.createElement("path", {
        d: "M59.997.5H4.003c-.966 0-1.842.393-2.476 1.027A3.49 3.49 0 00.5 4.003v55.994c0 .966.393 1.842 1.027 2.476A3.493 3.493 0 004.003 63.5h55.994c.966 0 1.842-.393 2.476-1.027a3.493 3.493 0 001.027-2.476V4.003c0-.966-.393-1.842-1.027-2.476A3.49 3.49 0 0059.997.5zM.444 10.222h63.112"
      }), s.createElement("path", {
        d: "M5.333 4.056c-.353 0-.672.143-.903.374a1.275 1.275 0 00.903 2.181 1.275 1.275 0 001.278-1.278 1.273 1.273 0 00-1.278-1.277zm5.334 0a1.275 1.275 0 00-1.278 1.277 1.275 1.275 0 001.278 1.278 1.273 1.273 0 001.277-1.278c0-.353-.143-.672-.374-.903a1.273 1.273 0 00-.903-.374zm5.333 0a1.277 1.277 0 100 2.555 1.277 1.277 0 100-2.555z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 72 72"
      }, e), s.createElement("path", {
        d: "M68.998 0A3 3 0 0172 2.997v65.999A3.002 3.002 0 0168.998 72H3.002A3.003 3.003 0 010 68.996V2.997A2.999 2.999 0 013.002 0h65.996zM71 12H1v56.996c0 1.056.817 1.922 1.853 1.999l.15.005h65.995c1.056 0 1.92-.817 1.997-1.855l.005-.15V12zm-14.146 8.146a.5.5 0 01.057.638l-.057.07-42 42a.5.5 0 01-.765-.638l.057-.07L17.292 59H12a2 2 0 01-2-2V26a2 2 0 012-2h40.292l3.854-3.854a.5.5 0 01.708 0zM60 24a2 2 0 012 2v31a2 2 0 01-2 2H20.706l1-1H60a1 1 0 00.993-.883L61 57V33H46.707l1-1H61v-6a1 1 0 00-.883-.993L60 25h-5.293l1-1H60zm-16.708 9H11v24a1 1 0 00.883.993L12 58h6.292l8-8H16a1 1 0 01-1-1V38a1 1 0 011-1h11a1 1 0 011 1v10.292L34.292 42H32.5a.5.5 0 01-.09-.992L32.5 41h2.792l3-3H32.5a.5.5 0 01-.09-.992L32.5 37h6.792l4-4zM50.5 53a.5.5 0 01.09.992L50.5 54h-18a.5.5 0 01-.09-.992L32.5 53h18zm6-4a.5.5 0 01.09.992L56.5 50h-24a.5.5 0 01-.09-.992L32.5 49h24zM27 38H16v11h11V38zm-1.717 2.589l.069.057a.5.5 0 01.058.638l-.058.07-4.998 5a.5.5 0 01-.638.057l-.07-.057-2-2a.5.5 0 01.638-.765l.07.057L20 45.292l4.645-4.645a.5.5 0 01.638-.058zM56.5 45a.5.5 0 01.09.992L56.5 46H33.706l1-1H56.5zm0-4a.5.5 0 01.09.992L56.5 42H37.706l1.001-1H56.5zm-13-4a.5.5 0 01.09.992L43.5 38h-1.793l1-1h.793zm7.792-12H12a1 1 0 00-.993.883L11 26v6h33.292l7-7zm4.992 1.589l.07.057 1.146 1.147 1.146-1.147a.5.5 0 01.765.638l-.057.07-1.147 1.146 1.147 1.146a.5.5 0 01-.638.765l-.07-.057-1.146-1.147-1.146 1.147a.5.5 0 01-.765-.638l.057-.07 1.147-1.146-1.147-1.146a.5.5 0 01.638-.765zM33.5 28a.5.5 0 01.09.992L33.5 29h-18a.5.5 0 01-.09-.992L15.5 28h18zM68.998 1H3.002c-1.057 0-1.92.814-1.997 1.848L1 2.998V11h70V2.997a2 2 0 00-1.853-1.992L68.997 1zM6 4a2 2 0 01.15 3.995L6 8a2 2 0 01-.15-3.995L6 4zm6 0a2 2 0 01.15 3.995L12 8a2 2 0 01-.15-3.995L12 4zm6 0a2 2 0 01.15 3.995L18 8a2 2 0 01-.15-3.995L18 4zM6 5a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2z",
        fill: "#222",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M24.45 8.202a1 1 0 01.444.445L39.92 38.551A1 1 0 0139.026 40H9a1 1 0 01-.894-1.448l15-29.904a1 1 0 011.342-.446zM24 31a2 2 0 100 4 2 2 0 000-4zm0-13a2 2 0 00-2 2v7a2 2 0 104 0v-7a2 2 0 00-2-2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M12.031 9.008c.832 0 1.539.294 2.121.88.582.588.873 1.291.873 2.112 0 .83-.29 1.537-.873 2.119a2.889 2.889 0 01-2.12.872c-.822 0-1.527-.29-2.114-.872A2.87 2.87 0 019.037 12c0-.82.294-1.524.881-2.111a2.883 2.883 0 012.113-.88zm0 4.986c.551 0 1.019-.197 1.404-.592a1.96 1.96 0 00.577-1.418c0-.55-.195-1.02-.585-1.41-.39-.39-.86-.584-1.411-.584s-1.022.195-1.412.584c-.39.39-.585.86-.585 1.41 0 .55.2 1.024.6 1.418.401.395.872.592 1.412.592zm7.938-2.119c0 .021.002.042.008.063.005.02.007.041.007.062a.36.36 0 01-.007.07.36.36 0 00-.008.07c-.01.01-.016.021-.016.031v.047l-.015.016v.023c0 .005-.006.013-.016.023a8.259 8.259 0 01-1.372 2.213 8.613 8.613 0 01-1.887 1.628 8.788 8.788 0 01-2.238 1.013 8.612 8.612 0 01-2.44.35 8.612 8.612 0 01-2.441-.35 8.788 8.788 0 01-2.238-1.013 8.574 8.574 0 01-3.275-3.84v-.047l-.008-.008c-.005-.005-.007-.013-.007-.023v-.032A.12.12 0 004 12.125a.256.256 0 00-.008-.063.256.256 0 01-.008-.062.36.36 0 01.008-.07.36.36 0 00.008-.07c.01-.01.016-.021.016-.031v-.047l.015-.016v-.046A8.591 8.591 0 015.427 9.5a8.85 8.85 0 011.895-1.645 8.693 8.693 0 017.135-1.02 8.382 8.382 0 012.221 1.02A8.86 8.86 0 0118.55 9.5a8.385 8.385 0 011.372 2.22c.01.01.016.019.016.024v.023l.007.008c.006.005.008.013.008.023v.032c0 .01.005.026.016.046zm-7.985 4.612a8 8 0 002.098-.28 7.382 7.382 0 003.618-2.244A7.423 7.423 0 0018.955 12a7.535 7.535 0 00-2.908-3.373 7.45 7.45 0 00-1.942-.857 7.713 7.713 0 00-2.09-.288c-.706 0-1.406.096-2.097.288a7.55 7.55 0 00-1.957.857 7.84 7.84 0 00-1.684 1.41c-.51.56-.93 1.215-1.263 1.963a7.316 7.316 0 001.263 1.963 7.737 7.737 0 001.676 1.402 7.406 7.406 0 001.942.842c.686.187 1.382.28 2.09.28z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M19.969 11.875c0 .021.002.042.008.063.005.02.007.041.007.062a.36.36 0 01-.007.07.36.36 0 00-.008.07c-.01.01-.016.021-.016.031v.047l-.015.016v.023c0 .005-.006.013-.016.023a8.259 8.259 0 01-1.372 2.213 8.613 8.613 0 01-1.887 1.628 8.788 8.788 0 01-2.238 1.013 8.612 8.612 0 01-2.44.35 8.612 8.612 0 01-2.441-.35 8.788 8.788 0 01-2.238-1.013 8.574 8.574 0 01-3.275-3.84v-.047l-.008-.008c-.005-.005-.007-.013-.007-.023v-.032A.12.12 0 004 12.125a.256.256 0 00-.008-.063.256.256 0 01-.008-.062.36.36 0 01.008-.07.36.36 0 00.008-.07c.01-.01.016-.021.016-.031v-.047l.015-.016v-.046A8.591 8.591 0 015.427 9.5a8.85 8.85 0 011.895-1.645 8.693 8.693 0 017.135-1.02 8.382 8.382 0 012.221 1.02A8.86 8.86 0 0118.55 9.5a8.385 8.385 0 011.372 2.22c.01.01.016.019.016.024v.023l.007.008c.006.005.008.013.008.023v.032c0 .01.005.026.016.046zM12.03 9.008c-.821 0-1.526.294-2.113.88A2.878 2.878 0 009.037 12c0 .83.294 1.537.881 2.119a2.896 2.896 0 002.113.872c.832 0 1.539-.29 2.121-.872A2.884 2.884 0 0015.025 12c0-.82-.29-1.524-.873-2.111a2.876 2.876 0 00-2.12-.88z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M13 10V8.016c0-.478.103-.855.346-1.12.266-.29.702-.396 1.326-.396h.828V5h-1.688c-1.153 0-1.939.241-2.376.69-.446.456-.678 1.157-.678 2.13V10H9v1.5h1.758V19H13v-7.5h2.246l.188-1.5H13zm1-1h2.566l-.437 3.5H14V20H9.758v-7.5H8V9h1.758V7.82c0-1.214.315-2.166.962-2.83.657-.671 1.694-.99 3.092-.99H16.5v3.5h-1.828c-.366 0-.568.05-.589.072-.043.048-.083.192-.083.444V9z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M14 9h2.566l-.437 3.5H14V20H9.758v-7.5H8V9h1.758V7.82c0-1.214.315-2.166.962-2.83.657-.671 1.694-.99 3.092-.99H16.5v3.5h-1.828c-.366 0-.568.05-.589.072-.043.048-.083.192-.083.444V9z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.879 9.264l5.59-5.73a3.251 3.251 0 013.214-.924 3.347 3.347 0 012.36 2.42 3.447 3.447 0 01-.75 3.135l-.145.153-5.623 5.767a1.87 1.87 0 01-2.668-.023 1.987 1.987 0 01-.116-2.627l.099-.113 5.618-5.761c.195-.2.512-.2.708 0a.523.523 0 01.058.655l-.058.07-5.612 5.755a.94.94 0 00.011 1.295.885.885 0 001.174.09l.083-.073 5.624-5.767a2.4 2.4 0 00.628-2.296 2.333 2.333 0 00-1.645-1.686 2.264 2.264 0 00-2.117.523l-.129.127L4.587 9.99a3.866 3.866 0 000 5.371 3.64 3.64 0 005.097.139l.143-.139 6.818-6.99c.196-.2.513-.2.708 0a.523.523 0 01.058.655l-.058.071-6.818 6.99a4.626 4.626 0 01-6.656 0c-1.787-1.832-1.837-4.77-.15-6.663l.15-.16z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19 18.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h9.88a.5.5 0 0 1 .35.15l3.12 3.12a.5.5 0 0 1 .15.35v9.88zM4 5.5A1.5 1.5 0 0 1 5.5 4h9.88a1.5 1.5 0 0 1 1.06.44l3.12 3.12A1.5 1.5 0 0 1 20 8.62v9.88a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-13zm7.81 2.77a.72.72 0 0 1 .76-.14c.3.12.43.4.43.66v6.98a.7.7 0 0 1-.43.65.72.72 0 0 1-.76-.14L9.25 14H8.11c-.34 0-.62-.17-.8-.38a1.22 1.22 0 0 1-.31-.8V11.6c0-.68.57-1.05 1.11-1.05h1.14l2.56-2.28zM12 9.44l-2.22 1.98a.5.5 0 0 1-.34.13H8.11c-.06 0-.1.02-.1.03H8a.08.08 0 0 0 0 .02v1.23c0 .04.02.1.06.13a.15.15 0 0 0 .04.04h1.34a.5.5 0 0 1 .33.13L12 15.11V9.44zm3.1.77a.5.5 0 0 1 .7-.11c.67.49 1.06 1.17 1.06 1.9s-.4 1.41-1.07 1.9a.5.5 0 0 1-.58-.8c.46-.35.65-.75.65-1.1 0-.35-.18-.75-.65-1.1a.5.5 0 0 1-.11-.7z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M8 11h8l-4 4z",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        transform: "translate(0 -4)",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }, s.createElement("rect", {
        x: 6,
        y: 12,
        width: 12,
        height: 1,
        rx: .5
      }), s.createElement("rect", {
        x: 8,
        y: 15,
        width: 8,
        height: 1,
        rx: .5
      }), s.createElement("rect", {
        x: 10,
        y: 18,
        width: 4,
        height: 1,
        rx: .5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M16 14H8l4-4z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 148 32"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M16 0c8.853 0 16 7.147 16 16s-7.147 16-16 16S0 24.853 0 16 7.147 0 16 0zm0 1C7.7 1 1 7.7 1 16s6.7 15 15 15 15-6.7 15-15S24.3 1 16 1zm-4.328 14.431l.057.047 3.208 3.21a.37.37 0 01.101.189l.007.072v3.39a.37.37 0 01-.575.308l-.057-.047-3.208-3.209a.37.37 0 01-.101-.189l-.007-.072v-3.39a.37.37 0 01.575-.309zM100.137 11c2.673 0 4.5 2.035 4.5 4.987S102.784 21 100.11 21s-4.5-2.048-4.5-4.987c0-2.965 1.853-5.013 4.526-5.013zm41.114.106l2.713 3.963 2.646-3.896h1.099l-3.176 4.6L148 20.682l-1.006.213-3.043-4.389-2.938 4.309h-1.099l3.468-5.013-3.124-4.482.993-.213zm-81.746-.026l2.474 8.178 2.74-8.085h1.019l2.779 8.085 2.435-8.085h1.032l-3.017 9.68h-.874l-2.885-8.284-2.871 8.285h-.847l-2.991-9.548 1.006-.226zm-4.16.093l.145.93h-3.282v8.71h-.992v-8.71H48v-.93h7.345zm21.633 0v9.64h-1.006v-9.64h1.006zm5.668 0v8.71h3.838l.146.93h-4.976v-9.64h.992zm8.752 0v9.64h-1.005v-9.64h1.005zm27.633 0v.93h-4.01v3.365h3.203l.145.918h-3.348v4.428h-.992v-9.641h5.002zm4.795 0v8.71h3.838l.145.93h-4.975v-9.64h.992zm12.841 0v.93h-4.195v3.206h3.322l.146.93h-3.468v3.657h4.341v.918h-5.333v-9.641h5.187zm-36.556.731c-2.091 0-3.467 1.65-3.467 4.083 0 2.46 1.39 4.095 3.48 4.095 2.104 0 3.467-1.635 3.467-4.082s-1.376-4.096-3.48-4.096zM19.389 10.84a.37.37 0 01.205.062l.056.046 3.209 3.21a.37.37 0 01-.189.625l-.073.006h-7.552a.362.362 0 00-.072.718l.072.008h2.453a.37.37 0 01.205.062l.056.046 3.209 3.21a.37.37 0 01-.189.624l-.073.007h-3.784a.37.37 0 01-.205-.062l-.057-.046-5.455-5.446a.37.37 0 01-.101-.189l-.007-.073v-2.435c0-.18.128-.33.298-.366l.075-.007h7.919z",
        fill: "#FFF"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M15.646 5H4.542c-.3 0-.542.243-.542.542v7.041c0 .3.243.542.542.542h11.104c.299 0 .541-.242.541-.542V5.542c0-.3-.242-.542-.541-.542zM7.656 15.156h4.875M10.094 13.125v2.031",
        stroke: "#AEB2C1",
        strokeWidth: 1.25,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), s.createElement("path", {
        d: "M13.715 8.724h-.397a.204.204 0 01-.169-.09l-1.37-2.056a.204.204 0 00-.351.022l-2.124 4.248a.203.203 0 01-.351.022l-1.37-2.056a.204.204 0 00-.17-.09h-1.01",
        stroke: "#AEB2C1",
        strokeWidth: 1.25,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.986 6H6a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1V9a1 1 0 00-1-1h-6.414l-1.6-2zm.414-1L12 7h6a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h4.4z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16"
      }, e), s.createElement("path", {
        d: "M12.9 13.85a.6.6 0 01.6.6v.3a.6.6 0 01-.6.6H3.1a.6.6 0 01-.6-.6v-.3a.6.6 0 01.6-.6h9.8zM8.012.65c.331 0 .628.206.743.517l4.01 10.846a.473.473 0 01-.444.637h-.261a.6.6 0 01-.563-.392l-1.26-3.41H5.717l-1.245 3.408a.6.6 0 01-.563.394h-.244a.461.461 0 01-.433-.622l4.037-10.86A.794.794 0 018.012.65zm.047 2a15.302 15.302 0 01-.666 1.907L6 7.65h4L8.778 4.557a19.736 19.736 0 01-.719-1.907z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M5 20a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.794l4.646-4.648a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L6.208 19H10a.5.5 0 010 1H5zM20 4a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5.706l-4.646 4.648a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L18.792 5H15a.5.5 0 010-1h5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M21 13h10a2 2 0 012 2v18a2 2 0 01-2 2H17a2 2 0 01-2-2V19l6-6z",
        fill: "currentColor"
      }), s.createElement("path", {
        d: "M21.5 14L16 19.5V33a1 1 0 001 1h14a1 1 0 001-1V15a1 1 0 00-1-1h-9.5z",
        fill: "#FFF"
      }), s.createElement("path", {
        d: "M21.5 29a.5.5 0 110 1h-2a.5.5 0 110-1h2zm5-2a.5.5 0 110 1h-7a.5.5 0 110-1h7zm-1-2a.5.5 0 110 1h-6a.5.5 0 110-1h6zm3-2a.5.5 0 110 1h-9a.5.5 0 110-1h9zm0-2a.5.5 0 110 1h-3a.5.5 0 110-1h3zm0-2a.5.5 0 110 1h-3a.5.5 0 110-1h3zM22 13v7h-7v-1h6v-6z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M15 15h18a2 2 0 012 2v14a2 2 0 01-2 2H15a2 2 0 01-2-2V17a2 2 0 012-2z",
        fill: "currentColor"
      }), s.createElement("path", {
        d: "M15 16a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V17a1 1 0 00-1-1H15z",
        fill: "#FFF"
      }), s.createElement("path", {
        d: "M27 23l5 7H16l3.5-4 2.949 3.371L27 23zm-8.5-4a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M16.544 5.607c.384 0 .722.145 1.016.435.293.29.44.625.44 1.005V17.56c0 .38-.147.715-.44 1.005-.294.29-.632.435-1.016.435H6.456c-.384 0-.722-.145-1.016-.435-.293-.29-.44-.625-.44-1.005V7.047c0-.38.147-.714.44-1.005.294-.29.632-.435 1.016-.435H9.4c.113-.469.367-.854.762-1.155.395-.301.84-.452 1.337-.452s.942.15 1.337.452c.395.301.65.686.762 1.155h2.945zm.59 11.951V7.109c-.004-.181-.063-.304-.175-.367a.75.75 0 00-.373-.095h-1.802V7a1 1 0 01-1 1H9.216a1 1 0 01-1-1v-.353H6.483c-.21-.02-.366.022-.468.129a.507.507 0 00-.148.377v10.46c0 .168.08.295.24.381.16.087.371.128.635.124h9.53c.226.003.418-.03.577-.101.16-.07.254-.223.284-.459zM11.5 5.654a.683.683 0 00-.508.207.708.708 0 00-.203.517c0 .207.068.385.203.534.136.15.305.224.508.224a.657.657 0 00.508-.224.768.768 0 00.203-.534.708.708 0 00-.203-.517.683.683 0 00-.508-.207zm-1.428 9.38l-1.542-1.57a.433.433 0 00-.621.003.457.457 0 00.003.637l1.447 1.473a1 1 0 001.427 0l4.3-4.378a.457.457 0 000-.64.44.44 0 00-.629 0l-4.385 4.475z",
        fill: "currentcolor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M16.544 5.607c.384 0 .722.145 1.016.435.293.29.44.625.44 1.005V17.56c0 .38-.147.715-.44 1.005-.294.29-.632.435-1.016.435H6.456c-.384 0-.722-.145-1.016-.435-.293-.29-.44-.625-.44-1.005V7.047c0-.38.147-.714.44-1.005.294-.29.632-.435 1.016-.435H9.4c.113-.469.367-.854.762-1.155.395-.301.84-.452 1.337-.452s.942.15 1.337.452c.395.301.65.686.762 1.155h2.945zm-5.044.047a.683.683 0 00-.508.207.708.708 0 00-.203.517c0 .207.068.385.203.534.136.15.305.224.508.224a.657.657 0 00.508-.224.768.768 0 00.203-.534.708.708 0 00-.203-.517.683.683 0 00-.508-.207zm-1.428 9.38l-1.542-1.57a.433.433 0 00-.621.003.457.457 0 00.003.637l1.447 1.473a1 1 0 001.427 0l4.3-4.378a.457.457 0 000-.64.44.44 0 00-.629 0l-4.385 4.475z",
        fill: "currentcolor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0)),
      l = function (e) {
        return s.createElement("svg", r({
          width: "1em",
          height: "1em",
          viewBox: "0 0 12 12"
        }, e), s.createElement("circle", {
          cx: 4,
          cy: "50%",
          r: 4,
          fill: "#19BD3A",
          stroke: "none",
          strokeWidth: 1,
          fillRule: "evenodd"
        }));
      };
    t.default = l, l._raw = '\n<svg width="1em" height="1em" viewBox="0 0 12 12" >\n        <circle cx="4" cy="50%" r="4" fill="#19BD3A" stroke="none" strokeWidth="1" fillRule="evenodd" />\n    </svg>';
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0)),
      l = function (e) {
        return s.createElement("svg", r({
          width: "1em",
          height: "1em",
          viewBox: "0 0 12 12"
        }, e), s.createElement("circle", {
          cx: 4,
          cy: "50%",
          r: 4,
          fill: "#ABABAB",
          stroke: "none",
          strokeWidth: 1,
          fillRule: "evenodd"
        }));
      };
    t.default = l, l._raw = '\n<svg width="1em" height="1em" viewBox="0 0 12 12" >\n        <circle cx="4" cy="50%" r="4" fill="#ABABAB" stroke="none" strokeWidth="1" fillRule="evenodd" />\n    </svg>';
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M12 14a3 3 0 110-6 3 3 0 010 6zm0-1a2 2 0 110-4 2 2 0 010 4zm2.6 2c1.655 0 3.4 1.5 3.4 3.997v.503a.5.5 0 01-1 0v-.503C17 17.4 15.7 16 14.5 16h-5C8.3 16 7 17.3 7 18.997v.503a.5.5 0 01-1 0v-.503C6 16.5 7.745 15 9.4 15h5.2zM17 8a2 2 0 110-4 2 2 0 010 4zm0-1a1 1 0 110-2 1 1 0 010 2zm2.003 2A2.997 2.997 0 0122 11.997v.503a.5.5 0 01-1 0v-.503A2 2 0 0019.003 10H16.5c-.497 0-.5-.5-.5-.5s.003-.5.5-.5h2.503zM7 8a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 100-2 1 1 0 000 2zM4.997 9A2.997 2.997 0 002 11.997v.503a.5.5 0 001 0v-.503A2 2 0 014.997 10H7.5c.497 0 .5-.5.5-.5S7.997 9 7.5 9H4.997z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M17 8a2 2 0 110-4 2 2 0 010 4zm2.003 1A2.997 2.997 0 0122 11.997v.503a.5.5 0 01-.5.5H16c.227-.573.34-1.24.34-2 0-.83-.34-1.5-.34-1.5s.003-.5.5-.5h2.503zM7 8a2 2 0 110-4 2 2 0 010 4zM4.997 9H7.5c.497 0 .5.5.5.5s-.34.67-.34 1.5c0 .76.113 1.427.34 2H2.5a.5.5 0 01-.5-.5v-.503A2.997 2.997 0 014.997 9zM12 14a3 3 0 110-6 3 3 0 010 6zm2.404 1C16.39 15 18 16.677 18 18.746v.629a.613.613 0 01-.6.625H6.6c-.331 0-.6-.28-.6-.625v-.629C6 16.677 7.61 15 9.596 15h4.808z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M7.12 7.862a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104A.426.426 0 017.43 7h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M7.12 7.862a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104A.426.426 0 017.43 7h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104z",
        fill: "currentColor"
      }), s.createElement("circle", {
        stroke: "currentColor",
        fill: "#EA1010",
        cx: 19,
        cy: 5,
        r: 4.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19.862 14.102a.275.275 0 00.062-.093.588.588 0 00.031-.103c.083-.495.126-1 .13-1.512.003-.512-.034-.848-.11-1.006-.323-.296-.739-.557-1.248-.785a9.456 9.456 0 00-1.775-.567 18.266 18.266 0 00-2.255-.346 30.59 30.59 0 00-2.679-.129c-.963 0-1.86.041-2.693.124-.833.082-1.585.201-2.256.356-.67.155-1.262.344-1.775.568-.512.223-.93.483-1.254.779-.069.165-.101.504-.098 1.016.004.513.047 1.017.13 1.512a.276.276 0 00.046.14.774.774 0 00.056.067c.117-.02.341-.065.671-.134.33-.07.685-.141 1.063-.217l1.703-.34.01-.01a.615.615 0 00.062-.083.62.62 0 00.073-.197 26.313 26.313 0 00.403-1.435l.164-.577.589-.093c.213-.034.572-.077 1.078-.13a20.81 20.81 0 012.018-.076 26.61 26.61 0 012.028.077c.506.045.869.088 1.089.129l.578.103.155.568c.103.364.189.674.258.929.068.254.117.423.144.505a.77.77 0 00.155.28c.11.027.33.075.66.144.33.068.68.139 1.048.211.368.072.717.143 1.048.212.33.069.55.11.66.124.007.006.014.006.02 0l.011-.01zm.637.651a1.1 1.1 0 01-.371.248.714.714 0 01-.413.041 89.21 89.21 0 00-.625-.119c-.347-.065-.724-.139-1.13-.222-.406-.082-.784-.158-1.135-.227-.351-.068-.571-.113-.66-.134a.946.946 0 01-.465-.3 1.675 1.675 0 01-.34-.608l-.186-.681c-.09-.324-.166-.585-.228-.785a13.12 13.12 0 00-.996-.118 21.859 21.859 0 00-1.935-.067c-.825 0-1.477.022-1.956.067-.478.044-.81.084-.995.118-.056.193-.128.454-.217.785-.09.33-.155.557-.196.681a1.826 1.826 0 01-.155.372c-.062.11-.134.206-.217.288a.827.827 0 01-.201.15 1.103 1.103 0 01-.222.088 150.187 150.187 0 01-1.816.382l-1.125.227a9.179 9.179 0 01-.63.113c-.227.048-.458-.013-.692-.185-.233-.172-.385-.437-.454-.795l-.056-.428a10.562 10.562 0 01-.078-.986c-.014-.372 0-.74.041-1.104.042-.365.141-.627.3-.785l.01-.01c.468-.44 1.046-.798 1.734-1.074.688-.275 1.423-.49 2.203-.645a18.82 18.82 0 012.4-.314 34.704 34.704 0 012.322-.083c.73 0 1.502.03 2.317.088.816.058 1.614.165 2.395.32.78.155 1.514.368 2.198.64.685.271 1.258.624 1.719 1.058.172.158.277.418.314.779.038.361.05.727.036 1.099-.013.371-.04.7-.077.986-.038.285-.057.435-.057.449a1.397 1.397 0 01-.134.381c-.062.117-.137.22-.227.31z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M20.5 14.753a1.1 1.1 0 01-.372.248.714.714 0 01-.413.041 89.21 89.21 0 00-.625-.119c-.347-.065-.724-.139-1.13-.222-.406-.082-.784-.158-1.135-.227-.351-.068-.571-.113-.66-.134a.946.946 0 01-.465-.3 1.675 1.675 0 01-.34-.608l-.186-.681c-.09-.324-.166-.585-.228-.785a13.12 13.12 0 00-.996-.118 21.859 21.859 0 00-1.935-.067c-.825 0-1.477.022-1.956.067-.478.044-.81.084-.995.118-.056.193-.128.454-.217.785-.09.33-.155.557-.196.681a1.826 1.826 0 01-.155.372c-.062.11-.134.206-.217.288a.827.827 0 01-.201.15 1.103 1.103 0 01-.222.088 150.187 150.187 0 01-1.816.382l-1.125.227a9.179 9.179 0 01-.63.113c-.227.048-.458-.013-.692-.185-.233-.172-.385-.437-.454-.795l-.056-.428a10.562 10.562 0 01-.078-.986c-.014-.372 0-.74.041-1.104.042-.365.141-.627.3-.785l.01-.01c.468-.44 1.046-.798 1.734-1.074.688-.275 1.423-.49 2.203-.645a18.82 18.82 0 012.4-.314 34.704 34.704 0 012.322-.083c.73 0 1.502.03 2.317.088.816.058 1.614.165 2.395.32.78.155 1.514.368 2.198.64.685.271 1.258.624 1.719 1.058.172.158.277.418.314.779.038.361.05.727.036 1.099-.013.371-.04.7-.077.986-.038.285-.057.435-.057.449a1.397 1.397 0 01-.134.381c-.062.117-.137.22-.227.31z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M21.61 14.315a.336.336 0 00.075-.113.72.72 0 00.038-.126c.1-.606.153-1.222.158-1.848.004-.627-.04-1.037-.133-1.23-.395-.362-.904-.681-1.526-.959a11.557 11.557 0 00-2.17-.694 22.325 22.325 0 00-2.756-.422 37.389 37.389 0 00-3.274-.158c-1.177 0-2.274.05-3.292.151-1.018.101-1.936.246-2.756.436-.82.189-1.543.42-2.17.693-.626.274-1.137.591-1.533.953-.084.202-.124.616-.12 1.242.005.627.057 1.243.158 1.848a.338.338 0 00.057.17c.03.039.053.066.07.083.142-.026.416-.08.82-.164.403-.084.836-.173 1.299-.265l2.081-.417.013-.012a.752.752 0 00.075-.101.757.757 0 00.089-.24 32.16 32.16 0 00.492-1.753l.201-.707.72-.113c.26-.042.7-.095 1.318-.158.618-.063 1.44-.094 2.466-.094 1.034.008 1.86.04 2.478.094.619.055 1.062.107 1.331.158l.707.126.189.694c.126.446.231.824.315 1.135.084.311.143.517.177.618a.942.942 0 00.19.34c.134.035.403.093.806.177.404.085.83.17 1.28.26.45.087.877.174 1.281.258.404.084.673.134.807.151.009.008.017.008.026 0l.012-.013zm.778.796a1.344 1.344 0 01-.454.303.872.872 0 01-.505.05 109.03 109.03 0 00-.763-.145c-.425-.08-.885-.17-1.381-.271-.497-.101-.96-.194-1.388-.278a34.85 34.85 0 01-.807-.164c-.202-.05-.391-.172-.568-.366a2.047 2.047 0 01-.416-.744c-.042-.16-.118-.437-.227-.832-.11-.396-.202-.715-.278-.96-.227-.041-.633-.09-1.217-.144-.585-.055-1.373-.082-2.365-.082-1.01 0-1.806.027-2.39.082-.585.054-.991.103-1.218.145-.067.235-.156.555-.265.959-.11.403-.19.68-.24.832-.05.168-.113.32-.189.454a1.617 1.617 0 01-.265.353 1.011 1.011 0 01-.246.183 1.348 1.348 0 01-.27.108 183.566 183.566 0 01-2.22.467l-1.376.277c-.42.084-.677.13-.77.139-.277.058-.559-.017-.845-.227-.286-.21-.47-.534-.555-.972l-.07-.523c-.045-.35-.077-.75-.094-1.205-.017-.454 0-.904.05-1.35.051-.445.173-.765.367-.958l.012-.013c.572-.538 1.278-.976 2.12-1.312.84-.336 1.738-.6 2.693-.788.954-.19 1.932-.318 2.932-.385 1.001-.067 1.947-.1 2.839-.1.891 0 1.835.035 2.832.106.996.072 1.972.202 2.926.391.955.19 1.85.45 2.687.782.837.333 1.537.764 2.1 1.293.21.194.339.511.385.953.046.441.061.89.044 1.343-.017.454-.048.856-.094 1.205-.047.349-.07.532-.07.549a1.707 1.707 0 01-.164.466 1.57 1.57 0 01-.277.379z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4zm0 15.016c.969 0 1.878-.185 2.727-.555a7.064 7.064 0 002.218-1.508 7.228 7.228 0 001.5-2.226c.37-.85.555-1.758.555-2.727 0-.969-.185-1.878-.555-2.727a7.131 7.131 0 00-1.5-2.218 7.131 7.131 0 00-2.218-1.5A6.753 6.753 0 0012 5c-.969 0-1.878.185-2.727.555-.849.37-1.588.87-2.218 1.5-.63.63-1.13 1.37-1.5 2.218A6.753 6.753 0 005 12c0 .969.185 1.878.555 2.727.37.849.87 1.59 1.5 2.226a7.064 7.064 0 002.218 1.508c.85.37 1.758.555 2.727.555zm-.734-2.516v-1.266h1.25V16.5h-1.25zm.718-9c.407 0 .763.05 1.07.148.308.1.576.253.805.461.22.198.383.44.493.727.109.286.164.612.164.976 0 .271-.037.527-.11.766-.073.24-.177.469-.312.688a8.285 8.285 0 01-.508.648c-.193.224-.404.45-.633.68a2.31 2.31 0 00-.273.32.872.872 0 00-.133.274c-.021.083-.037.195-.047.335-.01.141-.016.3-.016.477h-1.203c0-.292.013-.54.04-.742.025-.203.064-.362.117-.477.041-.114.127-.247.257-.398.13-.151.3-.32.508-.508.198-.24.37-.45.516-.633.146-.182.26-.336.344-.46.083-.136.145-.28.187-.43a1.91 1.91 0 00.063-.508c0-.209-.03-.396-.086-.563a1.085 1.085 0 00-.258-.422 1.18 1.18 0 00-.414-.265 1.577 1.577 0 00-.57-.094c-.188 0-.36.026-.516.078a1.29 1.29 0 00-.422.235c-.136.093-.234.26-.297.5-.063.24-.094.458-.094.656H9.5l-.016-.047c-.01-.323.042-.662.157-1.016.114-.354.291-.63.53-.828.24-.198.511-.344.813-.437.302-.094.636-.141 1-.141z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4zm-.734 12.5v-1.266h1.25V16.5h-1.25zm.718-9c.407 0 .763.05 1.07.148.308.1.576.253.805.461.22.198.383.44.493.727.109.286.164.612.164.976 0 .271-.037.527-.11.766-.073.24-.177.469-.312.688a8.285 8.285 0 01-.508.648c-.193.224-.404.45-.633.68a2.31 2.31 0 00-.273.32.872.872 0 00-.133.274c-.021.083-.037.195-.047.335-.01.141-.016.3-.016.477h-1.203c0-.292.013-.54.04-.742.025-.203.064-.362.117-.477.041-.114.127-.247.257-.398.13-.151.3-.32.508-.508.198-.24.37-.45.516-.633.146-.182.26-.336.344-.46.083-.136.145-.28.187-.43a1.91 1.91 0 00.063-.508c0-.209-.03-.396-.086-.563a1.085 1.085 0 00-.258-.422 1.18 1.18 0 00-.414-.265 1.577 1.577 0 00-.57-.094c-.188 0-.36.026-.516.078a1.29 1.29 0 00-.422.235c-.136.093-.234.26-.297.5-.063.24-.094.458-.094.656H9.5l-.016-.047c-.01-.323.042-.662.157-1.016.114-.354.291-.63.53-.828.24-.198.511-.344.813-.437.302-.094.636-.141 1-.141z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "nonzero"
      }, s.createElement("path", {
        d: "M8 5h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1zm0 1v12h2V6H8zM14 5h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1zm0 1v12h2V6h-2z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M8 5h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1zm6 0h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M7.667 5h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778H7.667C7.298 19 7 18.652 7 18.222V5.778c0-.43.298-.778.667-.778zM13.667 5h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778h-2.666c-.369 0-.667-.348-.667-.778V5.778c0-.43.298-.778.667-.778z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1.3,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("rect", {
        x: 4.65,
        y: 3.65,
        width: 4.7,
        height: 16.7,
        rx: 1
      }), s.createElement("rect", {
        x: 13.65,
        y: 3.65,
        width: 4.7,
        height: 16.7,
        rx: 1
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "nonzero"
      }, s.createElement("path", {
        d: "M5 3h4a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V4a1 1 0 011-1zM14 3h4a1 1 0 011 1v16a1 1 0 01-1 1h-4a1 1 0 01-1-1V4a1 1 0 011-1z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M5.186 15.856l13.128-7.578c.2-.117.476-.017.614.222.138.24.087.527-.114.644L5.686 16.722c-.2.117-.476.017-.614-.222-.138-.24-.087-.527.114-.644zM11 15.45V18a1 1 0 01-1 1H8a1 1 0 01-1-1v-.256l4-2.294zm6-3.486V18a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.708l4-2.328zM8 5h2a1 1 0 011 1v4.96l-4 2.293V6a1 1 0 011-1zm6 0h2a1 1 0 011 1v1.5l-4 2.311V6a1 1 0 011-1z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M11 15.5v4.092C11 20.369 10.44 21 9.75 21h-2.5C6.56 21 6 20.37 6 19.592V18.5l5-3zm7-4v8.22c0 .707-.56 1.28-1.25 1.28h-2.5c-.69 0-1.25-.573-1.25-1.28V14.5l5-3zM7.25 3h2.5c.69 0 1.25.597 1.25 1.333V11l-5 3V4.333C6 3.597 6.56 3 7.25 3zm7 0h2.5c.69 0 1.25.558 1.25 1.247V7l-5 3V4.247C13 3.558 13.56 3 14.25 3zM3.59 17.067l16.454-9.5a.5.5 0 01.5.866l-16.454 9.5a.5.5 0 11-.5-.866z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M4.68 8.979c-.079.06-.171.128-.278.206L4.1 9.41c-.09.07-.198.165-.323.286-.134.13-.289.292-.463.485-.144.158-.243.289-.298.386-.013.023-.015.025-.016-.01.02.353.104.762.258 1.206.164.473.409.98.736 1.516a15.83 15.83 0 001.259 1.754 26.835 26.835 0 001.78 1.956 30.243 30.243 0 001.961 1.79c.611.506 1.19.924 1.737 1.255a8.56 8.56 0 001.507.74c.442.159.849.242 1.213.256-.083 0-.102.007-.08-.006.087-.05.206-.143.366-.295.191-.175.355-.333.49-.472.125-.13.223-.242.32-.367.099-.116.182-.217.251-.304.046-.058.075-.099.12-.172a.523.523 0 00.074-.155 82.97 82.97 0 00-1.407-.969c-.438-.294-.854-.56-1.231-.789a.767.767 0 00-.188.084c-.077.04-.22.116-.418.227-.203.113-.461.262-.774.446l-.577.341-.542-.393a12.988 12.988 0 01-1-.818c-.357-.32-.748-.692-1.173-1.12-.418-.418-.786-.81-1.106-1.175-.327-.373-.6-.715-.818-1.03l-.336-.48.278-.515.437-.806c.108-.198.183-.34.247-.465a.727.727 0 00.08-.187c-.35-.549-.676-1.05-.978-1.5-.281-.422-.541-.8-.78-1.135a.176.176 0 00-.026.005zm.78-.654c.263.367.552.785.866 1.256.314.47.654.992 1.02 1.566a.82.82 0 01.12.508c-.015.188-.083.39-.205.607a16.19 16.19 0 01-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.774 1.132 1.08.342.305.65.557.922.754.318-.188.583-.34.794-.458.211-.118.364-.2.458-.247.112-.066.227-.115.344-.148.117-.033.228-.05.33-.05a.851.851 0 01.436.113c.423.254.868.539 1.337.854.47.315.971.66 1.506 1.037.093.066.168.15.225.254.056.104.093.217.112.339a1.19 1.19 0 01-.042.402 1.453 1.453 0 01-.197.417 1.964 1.964 0 01-.169.24c-.075.094-.164.202-.267.324a4.953 4.953 0 01-.366.416c-.15.156-.328.327-.534.515-.197.189-.378.33-.542.424-.164.094-.307.141-.429.141a5.101 5.101 0 01-1.562-.318 9.556 9.556 0 01-1.688-.825c-.59-.358-1.21-.805-1.857-1.34a31.221 31.221 0 01-2.025-1.85 27.841 27.841 0 01-1.85-2.032c-.53-.65-.975-1.27-1.337-1.863a8.907 8.907 0 01-.823-1.7A5.323 5.323 0 012 10.54c0-.131.047-.28.14-.444a3.29 3.29 0 01.423-.558c.187-.207.356-.383.506-.529a4.86 4.86 0 01.408-.36l.324-.24c.103-.075.192-.14.267-.197.103-.076.21-.13.323-.163.113-.033.235-.049.366-.049.15 0 .284.026.401.078a.758.758 0 01.303.247zM16 12.5a.5.5 0 11-1 0A3.5 3.5 0 0011.5 9a.5.5 0 110-1 4.5 4.5 0 014.5 4.5zm3 0a.5.5 0 11-1 0A6.5 6.5 0 0011.5 6a.5.5 0 110-1 7.5 7.5 0 017.5 7.5zm3 0a.5.5 0 11-1 0A9.5 9.5 0 0011.5 3a.5.5 0 110-1C17.299 2 22 6.701 22 12.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M5.46 8.325c.263.367.552.785.866 1.256.314.47.654.992 1.02 1.566a.82.82 0 01.12.508c-.015.188-.083.39-.205.607a16.19 16.19 0 01-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.774 1.132 1.08.342.305.65.557.922.754.318-.188.583-.34.794-.458.211-.118.364-.2.458-.247.112-.066.227-.115.344-.148.117-.033.228-.05.33-.05a.851.851 0 01.436.113c.423.254.868.539 1.337.854.47.315.971.66 1.506 1.037.093.066.168.15.225.254.056.104.093.217.112.339a1.19 1.19 0 01-.042.402 1.453 1.453 0 01-.197.417 1.964 1.964 0 01-.169.24c-.075.094-.164.202-.267.324a4.953 4.953 0 01-.366.416c-.15.156-.328.327-.534.515-.197.189-.378.33-.542.424-.164.094-.307.141-.429.141a5.101 5.101 0 01-1.562-.318 9.556 9.556 0 01-1.688-.825c-.59-.358-1.21-.805-1.857-1.34a31.221 31.221 0 01-2.025-1.85 27.841 27.841 0 01-1.85-2.032c-.53-.65-.975-1.27-1.337-1.863a8.907 8.907 0 01-.823-1.7A5.323 5.323 0 012 10.54c0-.131.047-.28.14-.444a3.29 3.29 0 01.423-.558c.187-.207.356-.383.506-.529a4.86 4.86 0 01.408-.36l.324-.24c.103-.075.192-.14.267-.197.103-.076.21-.13.323-.163.113-.033.235-.049.366-.049.15 0 .284.026.401.078a.758.758 0 01.303.247zM16 12.5a.5.5 0 11-1 0A3.5 3.5 0 0011.5 9a.5.5 0 110-1 4.5 4.5 0 014.5 4.5zm3 0a.5.5 0 11-1 0A6.5 6.5 0 0011.5 6a.5.5 0 110-1 7.5 7.5 0 017.5 7.5zm3 0a.5.5 0 11-1 0A9.5 9.5 0 0011.5 3a.5.5 0 110-1C17.299 2 22 6.701 22 12.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M5.68 6.979l-.278.207-.303.223a4.085 4.085 0 00-.322.286c-.134.13-.289.292-.463.485a2.38 2.38 0 00-.298.385C4.003 8.588 4 8.591 4 8.556c.02.353.103.762.258 1.206.164.473.408.979.735 1.516a15.83 15.83 0 001.26 1.754 26.464 26.464 0 001.78 1.955 29.655 29.655 0 001.961 1.79c.611.507 1.19.925 1.736 1.256a8.56 8.56 0 001.508.739c.442.16.85.243 1.212.257-.082 0-.1.006-.079-.007.087-.048.206-.142.365-.294.193-.175.356-.332.49-.472.126-.13.224-.241.322-.367.097-.116.181-.217.25-.304.047-.058.075-.099.12-.172a.481.481 0 00.07-.141l.004-.014a86.256 86.256 0 00-1.407-.969c-.439-.294-.855-.56-1.232-.789a.871.871 0 00-.187.084c-.077.039-.219.116-.419.227-.203.113-.46.262-.773.446l-.578.341-.54-.393c-.302-.22-.635-.491-1-.818a29.297 29.297 0 01-2.28-2.294c-.327-.374-.6-.717-.818-1.031l-.336-.48.278-.515.437-.806c.108-.198.183-.34.247-.465a.761.761 0 00.08-.187 91.63 91.63 0 00-.978-1.5 48.63 48.63 0 00-.779-1.135.146.146 0 00-.027.005zm.78-.654c.263.366.552.785.866 1.256.314.47.654.992 1.02 1.566.093.151.133.32.12.508a1.473 1.473 0 01-.205.607c-.047.094-.126.245-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.773 1.132 1.08.342.306.65.556.921.755.32-.189.584-.342.795-.459.211-.117.364-.2.457-.247.113-.066.228-.116.345-.149.118-.032.227-.049.331-.049a.847.847 0 01.436.113c.422.255.867.539 1.336.854.47.315.971.661 1.505 1.037a.747.747 0 01.226.254c.056.104.093.217.112.339.01.132-.005.266-.042.402a1.478 1.478 0 01-.197.416 1.899 1.899 0 01-.169.241c-.075.093-.164.202-.267.324a5.023 5.023 0 01-.366.416c-.15.155-.328.327-.534.516a2.894 2.894 0 01-.542.422c-.164.095-.307.142-.429.142a5.136 5.136 0 01-1.562-.317 9.568 9.568 0 01-1.688-.827 15.603 15.603 0 01-1.857-1.339 31.755 31.755 0 01-2.025-1.85 27.415 27.415 0 01-1.85-2.032c-.53-.649-.976-1.27-1.337-1.863a8.941 8.941 0 01-.823-1.7A5.32 5.32 0 013 8.541c0-.132.047-.281.14-.445.094-.165.235-.351.422-.558.188-.206.357-.383.507-.529.15-.146.286-.266.408-.36.113-.085.22-.165.324-.24l.267-.197c.103-.076.211-.129.323-.163.113-.032.235-.049.366-.049a.98.98 0 01.401.078.749.749 0 01.302.247zm12.52 2.147c.189.094.366.192.532.294a3.269 3.269 0 00-.36-.548 2.88 2.88 0 00-.518-.504 3.178 3.178 0 00-.651-.377 4.29 4.29 0 00-.822-.26 5.393 5.393 0 00-.975-.113l-.964-.03-.006-1.08-1.855 1.61 1.854 1.63.002-.15.005-.994h.995c1.125 0 2.044.165 2.764.522zm-1.765.534h-.998l-.008 1.654a.31.31 0 01-.16.27.285.285 0 01-.157.028.246.246 0 01-.14-.065l-3.647-3.199a.301.301 0 01-.104-.233.301.301 0 01.104-.232l3.646-3.162a.246.246 0 01.14-.065.277.277 0 01.274.135c.029.046.044.1.044.162l.008 1.665c.41.012.795.057 1.155.135.36.078.697.185 1.01.321a3.957 3.957 0 011.551 1.172 4.1 4.1 0 01.724 1.334c.15.474.247.916.294 1.325.047.41.06.755.04 1.037-.021.283-.032.436-.032.461a.316.316 0 01-.087.181.243.243 0 01-.175.07h-.01a.214.214 0 01-.17-.079.331.331 0 01-.075-.19 5.84 5.84 0 00-.11-.48c-.073-.294-.25-.612-.532-.953-.28-.34-.703-.65-1.265-.93-.355-.177-.78-.362-1.32-.362z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M6.46 6.325c.263.366.552.785.866 1.256.314.47.654.992 1.02 1.566.093.151.133.32.12.508a1.473 1.473 0 01-.205.607c-.047.094-.126.245-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.773 1.132 1.08.342.306.65.556.921.755.32-.189.584-.342.795-.459.211-.117.364-.2.457-.247.113-.066.228-.116.345-.149.118-.032.227-.049.331-.049a.847.847 0 01.436.113c.422.255.867.539 1.336.854.47.315.971.661 1.505 1.037a.747.747 0 01.226.254c.056.104.093.217.112.339.01.132-.005.266-.042.402a1.478 1.478 0 01-.197.416 1.899 1.899 0 01-.169.241c-.075.093-.164.202-.267.324a5.023 5.023 0 01-.366.416c-.15.155-.328.327-.534.516a2.894 2.894 0 01-.542.422c-.164.095-.307.142-.429.142a5.136 5.136 0 01-1.562-.317 9.568 9.568 0 01-1.688-.827 15.603 15.603 0 01-1.857-1.339 31.755 31.755 0 01-2.025-1.85 27.415 27.415 0 01-1.85-2.032c-.53-.649-.976-1.27-1.337-1.863a8.941 8.941 0 01-.823-1.7A5.32 5.32 0 013 8.541c0-.132.047-.281.14-.445.094-.165.235-.351.422-.558.188-.206.357-.383.507-.529.15-.146.286-.266.408-.36.113-.085.22-.165.324-.24l.267-.197c.103-.076.211-.129.323-.163.113-.032.235-.049.366-.049a.98.98 0 01.401.078.749.749 0 01.302.247zm10.755 2.681h-.998l-.008 1.654a.31.31 0 01-.16.27.285.285 0 01-.157.028.246.246 0 01-.14-.065l-3.647-3.199a.301.301 0 01-.104-.233.301.301 0 01.104-.232l3.646-3.162a.246.246 0 01.14-.065.277.277 0 01.274.135c.029.046.044.1.044.162l.008 1.665c.41.012.795.057 1.155.135.36.078.697.185 1.01.321a3.957 3.957 0 011.551 1.172 4.1 4.1 0 01.724 1.334c.15.474.247.916.294 1.325.047.41.06.755.04 1.037-.021.283-.032.436-.032.461a.316.316 0 01-.087.181.243.243 0 01-.175.07h-.01a.214.214 0 01-.17-.079.331.331 0 01-.075-.19 5.84 5.84 0 00-.11-.48c-.073-.294-.25-.612-.532-.953-.28-.34-.703-.65-1.265-.93-.355-.177-.78-.362-1.32-.362z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("circle", {
        cx: 12,
        cy: 6,
        r: 1.5
      }), s.createElement("rect", {
        x: 10.5,
        y: 10.5,
        width: 3,
        height: 9,
        rx: 1.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("circle", {
        cx: 12,
        cy: 6,
        r: 2
      }), s.createElement("rect", {
        x: 10,
        y: 10,
        width: 4,
        height: 10,
        rx: 2
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM10 9a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        d: "M14 4a1 1 0 011 1l.001 2.1A5.023 5.023 0 0014 7V5H5v14h9v-2c.343 0 .678-.035 1.001-.1L15 19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h9zm0 4a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 8zm0 1a3 3 0 100 6 3 3 0 000-6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        d: "M14 4a1 1 0 011 1l.001 2.1a5 5 0 100 9.8L15 19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h9zm0 4a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 8zm0 1a3 3 0 100 6 3 3 0 000-6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.16 4.069a.625.625 0 01.271.84l-5.5 10.75a.625.625 0 01-1.112-.569l5.5-10.75a.625.625 0 01.84-.271z",
        fill: "currentColor"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 15.375c0-.345.28-.625.625-.625h5.75a.625.625 0 110 1.25h-5.75A.625.625 0 014 15.375zM9 4.625C9 4.28 9.28 4 9.625 4h5.75a.625.625 0 110 1.25h-5.75A.625.625 0 019 4.625z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M17 7.707l-4.146 4.147a.5.5 0 01-.708-.708L16.293 7H13.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V7.707zm.655 8.84c.182.119.293.312.334.58.041.269-.034.544-.225.826l-.245.32a9.873 9.873 0 01-.6.704 6.895 6.895 0 01-.758.702c-.268.214-.507.321-.716.321h-.013c-.6-.018-1.219-.164-1.856-.437a11.613 11.613 0 01-1.882-1.03A17.589 17.589 0 019.9 17.155a32.437 32.437 0 01-1.589-1.48 30.338 30.338 0 01-1.473-1.59c-.5-.578-.957-1.176-1.371-1.795a11.754 11.754 0 01-1.03-1.876c-.273-.632-.418-1.244-.436-1.835-.01-.218.093-.462.306-.73a7.4 7.4 0 01.703-.764c.255-.241.489-.444.702-.607.214-.164.326-.25.335-.26.109-.072.222-.127.34-.163A1.2 1.2 0 016.743 6c.146 0 .282.027.41.082a.667.667 0 01.3.245l.334.499c.186.277.386.577.6.9l.6.908c.187.282.303.459.348.532a.885.885 0 01.11.505c-.01.2-.069.409-.178.627-.064.11-.173.3-.327.573-.155.273-.278.496-.369.669.1.146.293.391.58.737.286.345.698.787 1.234 1.323.546.546.992.962 1.337 1.249.346.286.591.48.737.58.164-.091.384-.216.661-.375.278-.16.471-.266.58-.321.118-.064.234-.111.348-.143.114-.032.225-.048.334-.048.082 0 .16.011.232.034.073.023.141.052.205.089a140.36 140.36 0 011.453.948l.893.594c.273.182.436.295.491.34zm-.6.888a.258.258 0 00.061-.123.724.724 0 00.007-.082c-.091-.064-.268-.182-.532-.355s-.546-.36-.846-.56l-1.35-.9h-.014a.575.575 0 00-.095.014.579.579 0 00-.178.082 24.589 24.589 0 00-1.214.682l-.49.273-.45-.328c-.165-.118-.43-.327-.799-.627-.368-.3-.83-.728-1.384-1.283a24.874 24.874 0 01-1.29-1.392 11.95 11.95 0 01-.634-.805l-.313-.45.272-.478c.173-.309.32-.57.444-.784.122-.214.202-.357.238-.43a.72.72 0 00.082-.287 19.89 19.89 0 00-.34-.532 86.337 86.337 0 00-.553-.832c-.196-.291-.38-.569-.553-.833a9.743 9.743 0 00-.354-.518c0-.01-.005-.014-.014-.014h-.014a.257.257 0 00-.102.02.55.55 0 00-.089.049 8.948 8.948 0 00-1.084.914c-.341.336-.539.582-.593.737.018.409.12.857.306 1.344.187.486.453 1.003.798 1.548.346.546.767 1.12 1.262 1.72.496.6 1.057 1.219 1.685 1.855a25.587 25.587 0 001.862 1.7c.605.495 1.18.913 1.725 1.255a9.091 9.091 0 001.549.791c.486.187.934.293 1.343.32.155-.063.4-.265.737-.607a8.95 8.95 0 00.914-1.084z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19 5.707l-4.146 4.147a.5.5 0 01-.708-.708L18.293 5H15.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V5.707zm.556 11.854c.234.152.377.401.43.746.053.345-.044.699-.29 1.061l-.315.413c-.21.275-.468.576-.772.903a8.865 8.865 0 01-.973.904c-.345.275-.652.412-.92.412h-.018c-.772-.023-1.567-.21-2.386-.561a14.93 14.93 0 01-2.42-1.325 22.614 22.614 0 01-2.306-1.772 41.704 41.704 0 01-2.043-1.903 39.006 39.006 0 01-1.894-2.044 23.393 23.393 0 01-1.763-2.307c-.532-.796-.973-1.6-1.324-2.413-.35-.812-.538-1.599-.561-2.36-.012-.28.12-.593.394-.938.275-.345.576-.672.904-.982.327-.31.628-.57.903-.781.275-.21.418-.322.43-.333.14-.094.286-.164.438-.21.152-.048.304-.071.456-.071.187 0 .362.035.526.105.164.07.292.176.386.316l.43.64c.24.357.496.743.771 1.158l.772 1.167c.24.363.389.59.447.684.105.176.152.392.14.65a2.013 2.013 0 01-.228.806c-.081.14-.222.386-.42.737-.2.351-.357.638-.474.86.129.187.377.503.745.947.369.445.898 1.012 1.588 1.702.701.702 1.274 1.237 1.718 1.605.445.369.76.617.947.746.21-.117.494-.278.851-.483.357-.204.605-.342.745-.412.152-.082.301-.143.448-.184.146-.041.289-.062.43-.062.104 0 .204.015.297.044.094.03.182.068.263.114a180.466 180.466 0 011.868 1.22l1.149.763c.35.234.561.38.631.438zm-.771 1.14a.332.332 0 00.079-.157.931.931 0 00.008-.105 32.737 32.737 0 00-.684-.457c-.339-.222-.701-.462-1.087-.719l-1.736-1.158h-.018a.739.739 0 00-.123.018.744.744 0 00-.228.105 31.614 31.614 0 00-1.56.877l-.632.351-.579-.42c-.21-.153-.552-.422-1.026-.808-.473-.386-1.066-.936-1.78-1.65a31.98 31.98 0 01-1.657-1.789 15.364 15.364 0 01-.816-1.035l-.403-.579.35-.614c.223-.397.413-.734.57-1.008.159-.275.261-.46.308-.553a.926.926 0 00.105-.368c-.07-.117-.216-.345-.438-.685-.223-.339-.46-.696-.71-1.07-.252-.374-.489-.73-.711-1.07-.222-.34-.374-.561-.456-.667 0-.011-.006-.017-.018-.017h-.017a.33.33 0 00-.132.026.707.707 0 00-.114.062c-.49.35-.955.742-1.394 1.175-.438.433-.693.749-.763.947.024.527.155 1.103.395 1.728.24.626.581 1.29 1.026 1.992.444.701.985 1.438 1.622 2.21.637.772 1.36 1.567 2.166 2.386a32.898 32.898 0 002.394 2.184 21.586 21.586 0 002.219 1.614c.701.439 1.365.778 1.99 1.018.626.24 1.201.377 1.728.412.198-.082.514-.342.947-.78.432-.44.824-.904 1.175-1.395z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none"
      }, s.createElement("path", {
        d: "M11.551 20.505c3.298-1.593 5.611-3.32 7.093-5.106.24-.29 1.003-1.365 1.138-1.609.318-.574.531-1.18.631-1.806l.003-.015c.033-.177.054-.338.063-.483.01-.16.004-.41-.009-.637-.202-3.517-3.916-6.347-8.48-6.347-4.71 0-8.489 3.006-8.489 6.65 0 3.317 3.148 6.15 7.357 6.591a.989.989 0 01.879 1.093l-.186 1.67z",
        stroke: "currentColor"
      }), s.createElement("path", {
        d: "M7.047 12.6V9.59a.46.46 0 00-.92 0v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38zM9.884 13.52h-.201a.36.36 0 01-.36-.36V9.489c0-.198.161-.359.36-.359h.2c.2 0 .36.161.36.36v3.672a.36.36 0 01-.36.36zM13.6 9.589v2.12s-1.837-2.394-1.865-2.426a.458.458 0 00-.36-.154.472.472 0 00-.442.479v3.452a.46.46 0 00.92 0v-2.108s1.863 2.416 1.89 2.442c.082.077.191.125.312.126.255.002.464-.223.464-.479V9.59a.46.46 0 00-.92 0zM17.967 9.589a.46.46 0 00-.46-.46h-1.839a.46.46 0 00-.46.46v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38v-.816h1.38a.46.46 0 000-.92h-1.38v-.815h1.38a.46.46 0 00.46-.46z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M20.907 12.063a6.018 6.018 0 01-.687 1.97c-.161.29-.95 1.394-1.191 1.686-1.33 1.6-3.555 3.448-7.276 5.244a.49.49 0 01-.7-.494l.187-1.688a.489.489 0 00-.434-.54c-4.405-.462-7.805-3.46-7.805-7.089 0-3.948 4.025-7.15 8.99-7.15 4.824 0 8.76 3.024 8.978 6.818.007.11.024.462.009.699-.01.143-.03.326-.071.544zm-13.86.538V9.589a.46.46 0 00-.92 0v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38zm2.837.92a.36.36 0 00.359-.36V9.488a.36.36 0 00-.36-.359h-.2a.36.36 0 00-.36.36v3.672c0 .198.161.36.36.36h.2zm3.715-3.932v2.12s-1.836-2.394-1.864-2.426a.458.458 0 00-.36-.154.472.472 0 00-.442.479v3.452a.46.46 0 00.92 0v-2.108s1.863 2.416 1.89 2.442c.082.077.191.125.312.126.255.002.464-.223.464-.479V9.59a.46.46 0 00-.92 0zm4.368 0a.46.46 0 00-.46-.46h-1.839a.46.46 0 00-.46.46v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38v-.816h1.38a.46.46 0 000-.92h-1.38v-.815h1.38a.46.46 0 00.46-.46z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.483 11.785l-.076-.062a.836.836 0 011.056-1.295l.323.233.108.071c.585.35 1.343.261 1.835-.23l2.139-2.14.084-.09a1.503 1.503 0 00-.082-2.037l-.09-.083a1.504 1.504 0 00-2.034.086l-1.298 1.295-.073.065a.835.835 0 01-1.108-.064.835.835 0 01.004-1.18l1.298-1.295.118-.113a3.173 3.173 0 014.368.108l.112.118a3.174 3.174 0 01-.12 4.37l-2.14 2.138-.12.115a3.175 3.175 0 01-3.981.222l-.323-.232zm2.604-3.14l.323.234.075.06a.836.836 0 01-1.056 1.295l-.322-.232-.108-.071a1.505 1.505 0 00-1.835.23l-2.139 2.14-.084.09a1.503 1.503 0 00.082 2.037l.09.083c.59.5 1.475.472 2.034-.086l1.298-1.295.073-.065a.835.835 0 011.108.064.835.835 0 01-.004 1.18l-1.298 1.296-.118.112a3.173 3.173 0 01-4.368-.108l-.112-.118a3.174 3.174 0 01.12-4.369l2.14-2.14.12-.114a3.175 3.175 0 013.98-.222z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.877 8.596a.435.435 0 01-.317-.534C3.45 4.807 6.492 2.5 10.004 2.5c2.934 0 5.551 1.612 6.849 4.062l.28-2.847.014-.078a.457.457 0 01.471-.327.429.429 0 01.4.47l-.41 4.19-.017.085a.456.456 0 01-.592.295l-3.961-1.47-.072-.035a.428.428 0 01-.176-.53l.036-.071a.457.457 0 01.542-.186l2.749 1.02c-1.125-2.23-3.474-3.706-6.114-3.706-3.103 0-5.79 2.038-6.578 4.915a.447.447 0 01-.468.322l-.08-.013zm14.246 2.808l-.08-.013a.447.447 0 00-.468.322c-.787 2.877-3.475 4.915-6.579 4.915-2.64 0-4.988-1.475-6.113-3.705l2.748 1.02a.457.457 0 00.542-.187l.037-.071a.428.428 0 00-.177-.53l-.071-.034L3 11.65a.456.456 0 00-.592.294l-.017.084-.41 4.192a.429.429 0 00.4.47.457.457 0 00.47-.328l.016-.078.279-2.848c1.297 2.45 3.914 4.063 6.85 4.063 3.511 0 6.552-2.307 7.443-5.563a.435.435 0 00-.317-.533z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M4.432 12.5l1.844 1.828c.094.104.14.224.14.36a.521.521 0 01-.14.359.712.712 0 01-.172.101.484.484 0 01-.375 0 .712.712 0 01-.172-.101l-2.273-2.334a1 1 0 010-1.395l2.273-2.334a.494.494 0 01.719 0c.094.094.14.211.14.352 0 .14-.046.258-.14.351L4.463 11.5h8.625c.146 0 .266.047.36.14.093.094.14.214.14.36a.494.494 0 01-.5.5H4.432zM18.558 4c.283 0 .528.096.735.29.207.192.31.429.31.71v14a.933.933 0 01-.31.71c-.207.194-.452.29-.735.29H9.666c-.295 0-.542-.096-.744-.29A.945.945 0 018.62 19v-4.024a.492.492 0 11.984 0v3.415c0 .166.062.31.187.43s.275.179.45.179h7.736a.6.6 0 00.442-.18c.12-.12.18-.263.18-.43l-.017-12.78c0-.167-.06-.31-.18-.43a.6.6 0 00-.441-.18h-7.72a.628.628 0 00-.45.18.574.574 0 00-.188.43v3.398a.492.492 0 11-.984 0V5c0-.281.101-.518.303-.71.202-.194.45-.29.744-.29h8.892z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M4.432 12.5l1.844 1.828c.094.104.14.224.14.36a.521.521 0 01-.14.359.712.712 0 01-.172.101.484.484 0 01-.375 0 .712.712 0 01-.172-.101l-2.273-2.334a1 1 0 010-1.395l2.273-2.334a.494.494 0 01.719 0c.094.094.14.211.14.352 0 .14-.046.258-.14.351L4.463 11.5h8.625c.146 0 .266.047.36.14.093.094.14.214.14.36a.494.494 0 01-.5.5H4.432zM18.558 4c.283 0 .528.096.735.29.207.192.31.429.31.71v14a.933.933 0 01-.31.71c-.207.194-.452.29-.735.29H9.666c-.295 0-.542-.096-.744-.29A.945.945 0 018.62 19v-4.024c0-.271.22-.492.491-.492h5c2.508 0 2.639-4.984 0-4.984H9.144a.523.523 0 01-.523-.523V5c0-.281.1-.518.302-.71.202-.194.45-.29.744-.29h8.892z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M10.64 14.984h-.343a4.147 4.147 0 01-.719-.047 4.527 4.527 0 01-.476.422c-.245.198-.534.407-.868.625a9.02 9.02 0 01-1.054.594c-.37.177-.716.292-1.04.344h-.015l-.031.008a.337.337 0 01-.32-.102.376.376 0 01-.102-.265.305.305 0 01.031-.14l-.015-.001c.125-.208.299-.529.523-.961.224-.432.336-.83.336-1.195v-.032a4.44 4.44 0 01-1.125-.812 4.576 4.576 0 01-.797-1.063A5.327 5.327 0 014 9.875c0-.677.17-1.312.508-1.906a4.982 4.982 0 011.398-1.547 7.194 7.194 0 012.078-1.04A8.254 8.254 0 0110.531 5c.896 0 1.737.128 2.524.383a6.988 6.988 0 012.054 1.039 5.059 5.059 0 011.383 1.547c.339.594.508 1.229.508 1.906.01.76-.146 1.456-.469 2.086a4.83 4.83 0 01-1.343 1.617c-.573.448-1.25.794-2.032 1.04a8.37 8.37 0 01-2.515.366zm-1.468-1.078l.547.047c.24.031.458.047.656.047h.297c.76 0 1.466-.102 2.117-.305a5.26 5.26 0 001.688-.86 4.13 4.13 0 001.117-1.312c.27-.505.406-1.054.406-1.648 0-.542-.143-1.047-.43-1.516a4.189 4.189 0 00-1.164-1.226 5.953 5.953 0 00-1.734-.828A7.308 7.308 0 0010.532 6c-.761 0-1.477.102-2.15.305-.671.203-1.26.479-1.765.828A4.082 4.082 0 005.43 8.359c-.287.47-.43.974-.43 1.516 0 .646.161 1.297.484 1.953.323.656.828 1.162 1.516 1.516l.547.281-.047.61-.031.273c-.021.182-.12.513-.297.992.281-.167.56-.362.836-.586.276-.224.45-.383.523-.476l.64-.532zm10.828 0c0 .73-.177 1.373-.531 1.93-.354.557-.901 1.023-1.64 1.398v.032c0 .323.062.698.187 1.125.125.427.24.729.343.906a.305.305 0 01.032.125.318.318 0 01-.328.328h-.094c-.552-.094-1.11-.375-1.672-.844-.563-.469-.901-.776-1.016-.922-.125.01-.234.019-.328.024a5.362 5.362 0 01-.297.008h-.297a7.53 7.53 0 01-1.445-.133 6.147 6.147 0 01-1.273-.39 5.142 5.142 0 01-1.938-1.445c.021-.022.294-.032.82-.032s.732.005.618.015c.427.334.9.581 1.421.742.521.162 1.12.243 1.797.243h.305c.203 0 .357-.01.461-.032l.531-.078.29.39c.192.261.533.569 1.023.923-.042-.157-.073-.464-.094-.922l-.031-.688.484-.234c.594-.302 1.021-.654 1.281-1.055.26-.4.391-.872.391-1.414 0-.437-.076-.817-.227-1.14-.15-.323-.44-.636-.867-.938.052-.167.102-.344.149-.531.047-.188.08-.37.101-.547.657.385 1.128.839 1.414 1.36.287.52.43 1.12.43 1.796z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M10.64 14.984h-.343a4.147 4.147 0 01-.719-.047 4.527 4.527 0 01-.476.422c-.245.198-.534.407-.868.625a9.02 9.02 0 01-1.054.594c-.37.177-.716.292-1.04.344l-.046.008a.337.337 0 01-.32-.102.376.376 0 01-.102-.265.305.305 0 01.031-.14c.11-.21.284-.53.508-.962.224-.432.336-.83.336-1.195a5.475 5.475 0 01-1.125-.844 4.576 4.576 0 01-.797-1.063A5.327 5.327 0 014 9.875c0-.677.17-1.312.508-1.906a4.982 4.982 0 011.398-1.547 7.194 7.194 0 012.078-1.04A8.254 8.254 0 0110.531 5c.896 0 1.737.128 2.524.383a6.988 6.988 0 012.054 1.039 5.059 5.059 0 011.383 1.547c.339.594.508 1.229.508 1.906.01.76-.146 1.456-.469 2.086a4.83 4.83 0 01-1.343 1.617c-.573.448-1.25.794-2.032 1.04a8.37 8.37 0 01-2.515.366zM20 13.906c0 .73-.177 1.373-.531 1.93-.354.557-.901 1.023-1.64 1.398v.032c0 .323.062.698.187 1.125.125.427.24.729.343.906a.305.305 0 01.032.125.318.318 0 01-.328.328h-.094c-.552-.094-1.11-.375-1.672-.844-.563-.469-.901-.776-1.016-.922-.125.01-.234.019-.328.024a5.362 5.362 0 01-.297.008h-.297a7.53 7.53 0 01-1.445-.133 6.147 6.147 0 01-1.273-.39 5.142 5.142 0 01-1.938-1.445c.021-.022 6.804.702 8.352-4.751.047-.188.08-.37.101-.547.657.385 1.128.839 1.414 1.36.287.52.43 1.12.43 1.796z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 5a2 2 0 012 2v9a2 2 0 01-2 2H8l-2.388 1.847A1 1 0 014 19.056V7a2 2 0 012-2h12zm0 1H6a1 1 0 00-1 1v12.056L7.658 17H18a1 1 0 001-1V7a1 1 0 00-1-1zm-4.5 7a.5.5 0 010 1h-6a.5.5 0 010-1h6zm3-2a.5.5 0 010 1h-9a.5.5 0 010-1h9zm0-2a.5.5 0 010 1h-9a.5.5 0 010-1h9z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M11 12.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0v-3.794l-4.646 4.648a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L9.792 13.5H6a.5.5 0 010-1h5zM12.5 12a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.794l4.646-4.648a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L13.708 11H17.5a.5.5 0 010 1h-5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M17.1 12a.6.6 0 01-.601.6H7.501a.6.6 0 110-1.2h8.998a.6.6 0 01.601.6z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M13.229 3.071c.107.054.19.13.251.23.06.1.09.21.09.33V20.36c0 .12-.03.23-.09.33a.597.597 0 01-.251.23.447.447 0 01-.14.06.543.543 0 01-.331-.01.6.6 0 01-.172-.09l-6.428-5.043h-2.13c-.548 0-1.017-.17-1.405-.51-.389-.34-.583-.75-.583-1.23L2 9.875c0-.48.194-.888.583-1.221.388-.334.857-.5 1.406-.5h2.129l6.468-5.043a.6.6 0 01.322-.11.572.572 0 01.321.07zm5.504 9.08c0 .817-.261 1.547-.783 2.19a3.335 3.335 0 01-2.04 1.215.223.223 0 01-.07.01.612.612 0 01-.401-.15.616.616 0 01-.221-.372.587.587 0 01.09-.482.662.662 0 01.412-.282 1.996 1.996 0 001.245-.753c.322-.408.482-.867.482-1.376 0-.549-.157-1.024-.472-1.426a1.89 1.89 0 00-1.235-.723.588.588 0 01-.412-.261.652.652 0 01-.11-.483.633.633 0 01.25-.421.576.576 0 01.493-.1A3.155 3.155 0 0117.95 9.9c.522.643.783 1.393.783 2.25zm-.844-5.906a5.978 5.978 0 011.668.934c.495.395.924.85 1.285 1.366a6.31 6.31 0 01.834 5.494 6.164 6.164 0 01-.834 1.698c-.361.515-.79.97-1.285 1.366a5.978 5.978 0 01-1.668.934.929.929 0 01-.11.03.623.623 0 01-.472-.1.683.683 0 01-.241-.292.623.623 0 01.01-.502.576.576 0 01.371-.321 4.98 4.98 0 002.34-1.859 4.9 4.9 0 00.895-2.842 4.93 4.93 0 00-.894-2.862 4.859 4.859 0 00-2.34-1.838.645.645 0 01-.372-.342.578.578 0 01-.01-.482.573.573 0 01.331-.372.601.601 0 01.492-.01z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M13.229 3.071c.107.054.19.13.251.23.06.1.09.21.09.33V20.36c0 .12-.03.23-.09.33a.597.597 0 01-.251.23.447.447 0 01-.14.06.543.543 0 01-.331-.01.6.6 0 01-.172-.09l-6.428-5.043h-2.13c-.548 0-1.017-.17-1.405-.51-.389-.34-.583-.75-.583-1.23L2 9.875c0-.48.194-.888.583-1.221.388-.334.857-.5 1.406-.5h2.129l6.468-5.043a.6.6 0 01.322-.11.572.572 0 01.321.07zm-.944 16.15V4.84L6.68 9.34a.6.6 0 01-.361.12h-2.33c-.215 0-.385.047-.513.14-.127.095-.19.195-.19.302l.04 4.239c0 .107.063.21.19.311.128.1.299.15.513.15h2.33c.067 0 .13.007.19.02.061.014.118.041.172.081l5.564 4.52zM20.696 9.912L18.608 12l2.088 2.088a.43.43 0 11-.608.608L18 12.608l-2.088 2.088a.43.43 0 11-.608-.608L17.392 12l-2.088-2.088a.43.43 0 11.608-.608L18 11.392l2.088-2.088a.43.43 0 11.608.608z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M12.734 5.055a.465.465 0 01.195.18c.047.077.07.163.07.256v13.011a.488.488 0 01-.07.257.465.465 0 01-.195.179.348.348 0 01-.11.046.422.422 0 01-.258-.008.467.467 0 01-.132-.07l-5-3.921H5.578c-.427 0-.792-.133-1.094-.397-.302-.265-.453-.584-.453-.957L4 10.347c0-.374.151-.69.453-.95.302-.259.667-.389 1.094-.389h1.656l5.03-3.922a.467.467 0 01.25-.085.445.445 0 01.25.054zm4.28 7.062c0 .636-.203 1.204-.609 1.703a2.594 2.594 0 01-1.64.954.476.476 0 01-.313-.118.479.479 0 01-.172-.289.457.457 0 01.07-.375.515.515 0 01.321-.218c.396-.073.719-.269.969-.586.25-.318.375-.675.375-1.07 0-.428-.123-.797-.368-1.11a1.47 1.47 0 00-.96-.562.457.457 0 01-.32-.203.507.507 0 01-.087-.375.492.492 0 01.196-.328.448.448 0 01.383-.079c.624.105 1.14.407 1.546.907.406.5.61 1.083.61 1.75zm-.656-4.593c.48.177.912.42 1.297.727a5.09 5.09 0 011 1.062 4.908 4.908 0 01.648 4.273c-.15.48-.367.92-.648 1.32a5.09 5.09 0 01-1 1.063 4.65 4.65 0 01-1.297.726.439.439 0 01-.172.031.485.485 0 01-.28-.085.531.531 0 01-.188-.227.485.485 0 01.008-.39.448.448 0 01.289-.25 3.873 3.873 0 001.82-1.446 3.81 3.81 0 00.695-2.21c0-.813-.232-1.555-.695-2.227a3.78 3.78 0 00-1.82-1.43.502.502 0 01-.29-.265.45.45 0 01-.007-.375.446.446 0 01.258-.29.468.468 0 01.382-.007z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("circle", {
        cx: 8,
        cy: 12,
        r: 1
      }), s.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 1
      }), s.createElement("circle", {
        cx: 16,
        cy: 12,
        r: 1
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M11.984 15c-.708 0-1.3-.232-1.773-.695-.474-.464-.711-1.045-.711-1.742V6.609c0-.718.242-1.333.727-1.843.484-.51 1.07-.766 1.757-.766h.11c.677 0 1.247.253 1.71.758.464.505.696 1.122.696 1.851v5.954c0 .708-.227 1.291-.68 1.75-.453.458-1.028.687-1.726.687h-.11zM10.5 6.61v5.952c0 .428.138.774.414 1.04.276.265.633.398 1.07.398h.11c.427 0 .768-.133 1.023-.398.255-.266.383-.612.383-1.04V6.61c0-.458-.133-.84-.398-1.148A1.275 1.275 0 0012.094 5h-.11c-.406 0-.755.156-1.046.469a1.61 1.61 0 00-.438 1.14zm6 2.89a.48.48 0 01.352.148A.48.48 0 0117 10v2.078c0 1.125-.13 2.04-.39 2.742-.261.703-.597 1.253-1.008 1.649a3.288 3.288 0 01-1.368.812c-.5.146-.994.219-1.484.219h-.25V19H15a.48.48 0 01.352.148.48.48 0 01.148.352.48.48 0 01-.148.352A.48.48 0 0115 20H9a.48.48 0 01-.352-.148.48.48 0 01-.148-.352.48.48 0 01.148-.352A.48.48 0 019 19h2.5v-1.5h-.234c-.709 0-1.328-.12-1.86-.36a3.474 3.474 0 01-1.336-1.054c-.36-.464-.627-1.031-.804-1.703C7.089 13.71 7 12.943 7 12.078V10a.48.48 0 01.148-.352A.48.48 0 017.5 9.5a.48.48 0 01.352.148A.48.48 0 018 10v2.078c0 .5.036 1.013.11 1.54.072.525.223 1.002.453 1.429.229.427.56.776.992 1.047.432.27 1.002.406 1.71.406h1.485c.552 0 1.031-.091 1.438-.273a2.489 2.489 0 001.007-.82c.266-.365.466-.826.602-1.384.135-.557.203-1.205.203-1.945V10a.48.48 0 01.148-.352.48.48 0 01.352-.148z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("rect", {
        transform: "rotate(-45 12.071 11.071)",
        x: 2.571,
        y: 10.571,
        width: 19,
        height: 1,
        rx: .5
      }), s.createElement("path", {
        d: "M8.73 16.74l.717-.717c.035.024.071.048.108.07.432.272 1.002.407 1.71.407h1.485c.552 0 1.031-.091 1.438-.273a2.489 2.489 0 001.007-.82c.266-.365.466-.826.602-1.384.135-.557.203-1.205.203-1.945V10a.48.48 0 01.148-.352.48.48 0 01.352-.148.48.48 0 01.352.148A.48.48 0 0117 10v2.078c0 1.125-.13 2.04-.39 2.742-.261.703-.597 1.253-1.008 1.649a3.288 3.288 0 01-1.368.812c-.5.146-.994.219-1.484.219h-.25V19H15a.48.48 0 01.352.148.48.48 0 01.148.352.48.48 0 01-.148.352A.48.48 0 0115 20H9a.48.48 0 01-.352-.148.48.48 0 01-.148-.352.48.48 0 01.148-.352A.48.48 0 019 19h2.5v-1.5h-.234c-.709 0-1.328-.12-1.86-.36a3.506 3.506 0 01-.676-.4zm-1.545-2.697A9.578 9.578 0 017 12.078V10a.48.48 0 01.148-.352A.48.48 0 017.5 9.5a.48.48 0 01.352.148A.48.48 0 018 10v2.078c0 .358.019.723.056 1.094l-.87.87zm3.575.668l3.74-3.74v1.591c0 .709-.227 1.292-.68 1.75-.453.459-1.028.688-1.726.688h-.11c-.457 0-.865-.096-1.224-.29zM9.5 11.728V6.609c0-.718.242-1.333.727-1.843.484-.51 1.07-.766 1.757-.766h.11c.677 0 1.247.253 1.71.758.464.505.696 1.122.696 1.851v.119l-5 5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M11.981 15.75c-.85 0-1.56-.29-2.128-.87C9.284 14.302 9 13.577 9 12.704V5.262c0-.899.29-1.667.872-2.305.581-.638 1.284-.957 2.11-.957h.13c.813 0 1.497.316 2.054.947.556.632.834 1.403.834 2.315v7.441c0 .886-.272 1.615-.816 2.188-.543.573-1.234.859-2.071.859h-.132zM10.2 5.262v7.441c0 .534.166.967.497 1.299.331.332.76.498 1.284.498h.132c.512 0 .921-.166 1.228-.498.306-.332.459-.765.459-1.299V5.262c0-.573-.16-1.052-.478-1.436a1.505 1.505 0 00-1.21-.576h-.13c-.488 0-.907.195-1.257.586-.35.39-.525.866-.525 1.426zm7.2 3.613c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 1.406-.156 2.548-.469 3.427-.312.88-.715 1.566-1.21 2.06-.493.496-1.04.834-1.64 1.017-.6.182-1.193.273-1.781.273h-.3v1.875h3c.163 0 .303.062.422.186.119.123.178.27.178.439 0 .17-.06.316-.178.44A.566.566 0 0115.6 22H8.4a.566.566 0 01-.422-.186.613.613 0 01-.178-.439c0-.17.06-.316.178-.44a.566.566 0 01.422-.185h3v-1.875h-.281c-.85 0-1.594-.15-2.232-.45a4.2 4.2 0 01-1.603-1.318c-.43-.579-.753-1.289-.965-2.128-.213-.84-.319-1.8-.319-2.881V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 .625.044 1.266.131 1.923.088.658.269 1.254.544 1.788.275.533.672.97 1.19 1.308.52.339 1.204.508 2.054.508H12.9c.663 0 1.237-.114 1.725-.342.488-.228.89-.57 1.21-1.025.318-.456.559-1.032.721-1.729.163-.696.244-1.507.244-2.431V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, s.createElement("rect", {
        transform: "rotate(-45 12.041 11.24)",
        x: 1.294,
        y: 10.593,
        width: 21.494,
        height: 1.293,
        rx: .646
      }), s.createElement("path", {
        d: "M8.076 17.926l.86-.897c.043.03.086.06.13.088.518.339 1.203.508 2.053.508H12.9c.663 0 1.237-.114 1.725-.342.488-.228.89-.57 1.21-1.025.318-.456.559-1.032.721-1.729.163-.696.244-1.507.244-2.431V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 1.406-.156 2.548-.469 3.427-.312.88-.715 1.566-1.21 2.06-.493.496-1.04.834-1.64 1.017-.6.182-1.193.273-1.781.273h-.3v1.875h3c.163 0 .303.062.422.186.119.123.178.27.178.439 0 .17-.06.316-.178.44A.566.566 0 0115.6 22H8.4a.566.566 0 01-.422-.186.613.613 0 01-.178-.439c0-.17.06-.316.178-.44a.566.566 0 01.422-.185h3v-1.875h-.281c-.85 0-1.594-.15-2.232-.45a4.174 4.174 0 01-.811-.5zm-1.854-3.373A12.455 12.455 0 016 12.098V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 .447.022.903.067 1.367l-1.045 1.088zm4.29.835L15 10.713v1.99c0 .886-.272 1.615-.816 2.188-.543.573-1.234.859-2.071.859h-.132a2.96 2.96 0 01-1.47-.362zM9 11.66V5.262c0-.899.29-1.667.872-2.305.581-.638 1.284-.957 2.11-.957h.13c.813 0 1.497.316 2.054.947.556.632.834 1.403.834 2.315v.148l-6 6.25z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 18"
      }, e), s.createElement("path", {
        d: "M12.5 17a.5.5 0 110 1H.5a.5.5 0 110-1h12zm3-3a.5.5 0 110 1h-9a.5.5 0 110-1h9zM9.396 3.103l2.5 2.5L2.72 14.78a.75.75 0 01-.53.22H.75a.75.75 0 01-.75-.75v-1.44a.75.75 0 01.22-.53l9.176-9.177zM12.53 1.03l1.44 1.44a.75.75 0 010 1.06l-1.367 1.366-2.5-2.5L11.47 1.03a.75.75 0 011.06 0z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 42 38"
      }, e), s.createElement("path", {
        d: "M9.703 27.262l-2.164 2.164c-.68.261-1.326.44-1.94.535l-.123.02a.897.897 0 01-.838-.255.925.925 0 01-.266-.668c0-.079.007-.144.02-.197a.749.749 0 01.062-.157c.286-.523.743-1.328 1.328-2.415.586-1.086.879-2.087.879-3.004-1.117-.628-2.098-1.309-2.942-2.12a11.55 11.55 0 01-2.084-2.67 12.486 12.486 0 01-1.226-3.063A12.892 12.892 0 010 12.252c0-1.702.443-3.3 1.328-4.791.885-1.492 2.105-2.788 3.657-3.888 1.553-1.1 3.365-1.97 5.435-2.611C12.49.321 14.711 0 17.081 0c2.343 0 4.543.32 6.6.962 2.056.641 3.848 1.512 5.373 2.611a13.674 13.674 0 012.282 2.055l-.708.709a12.645 12.645 0 00-2.158-1.952c-1.436-1.035-3.13-1.858-5.087-2.468C21.425 1.307 19.325 1 17.08 1c-2.272 0-4.392.306-6.365.917-1.973.611-3.689 1.436-5.153 2.472C4.123 5.41 3 6.602 2.188 7.971 1.394 9.31 1 10.731 1 12.251c0 .963.126 1.94.378 2.935.25.988.626 1.927 1.128 2.818a10.55 10.55 0 001.905 2.44c.74.71 1.627 1.344 2.74 1.97a1 1 0 01.51.871c0 1.097-.34 2.256-.999 3.479-.306.57-.952 1.737-1.213 2.208.747-.116 1.563-.376 2.449-.784a23.26 23.26 0 001.805-.926zm10.394-3.323a20.451 20.451 0 003.56-.728c1.935-.582 3.6-1.4 5-2.453 1.384-1.039 2.458-2.282 3.233-3.735.764-1.432 1.134-3.013 1.109-4.772 0-.386-.026-.765-.076-1.138l.861-.862c.143.65.215 1.317.215 2 .027 1.911-.382 3.659-1.226 5.242-.845 1.584-2.016 2.939-3.514 4.065-1.499 1.125-3.27 1.996-5.313 2.61-1.563.471-3.213.762-4.951.873l1.102-1.102zm-4.677 4.677l.451-.452c3.628.128 17.504-.078 21.028-12.706.123-.5.212-.986.266-1.458 1.721 1.028 2.957 2.236 3.708 3.625.751 1.389 1.127 2.986 1.127 4.792 0 1.944-.464 3.66-1.393 5.145-.929 1.487-2.363 2.73-4.302 3.73v.083c0 .861.164 1.861.492 3 .327 1.139.628 1.944.901 2.417a.823.823 0 01.061.166.856.856 0 01-.225.792.827.827 0 01-.614.25h-.246c-1.448-.25-2.91-1-4.384-2.25-1.475-1.25-2.363-2.07-2.663-2.458-.328.027-.615.048-.86.062-.247.014-.506.021-.78.021h-.778c-1.338 0-2.601-.118-3.79-.354a15.92 15.92 0 01-3.339-1.042 13.614 13.614 0 01-2.827-1.666 13.704 13.704 0 01-1.833-1.697zm2.444.905a12.615 12.615 0 002.62 1.543c.97.429 2.013.754 3.13.976 1.123.223 2.32.335 3.595.335h.779c.255 0 .495-.006.722-.02.236-.013.513-.033.832-.06a1 1 0 01.876.385c.24.31 1.104 1.109 2.518 2.307 1.285 1.089 2.529 1.747 3.732 1.994-.27-.553-.543-1.323-.832-2.33-.352-1.222-.531-2.313-.531-3.276v-.083a1 1 0 01.542-.89c1.787-.92 3.085-2.045 3.912-3.37C40.585 25.71 41 24.18 41 22.418c0-1.645-.337-3.079-1.006-4.316-.474-.876-1.179-1.682-2.122-2.414l-.01.04c-1.67 5.987-5.642 9.81-11.16 11.83-3.121 1.144-6.27 1.594-9.256 1.628.136.114.276.226.418.336zM36.677 37c.043.086.085.168.127.243a.304.304 0 01-.024-.118c0-.008.018-.052.041-.076a.136.136 0 01.02-.016l.003-.018a5.62 5.62 0 01-.081-.015h-.086zm-20.732-7.832l.01.01c.648.038.651.038.461.002a34.013 34.013 0 01-.471-.012zM40.123.354c.195.195.216.49.047.66L4.014 37.17c-.17.17-.465.148-.66-.047-.196-.195-.217-.49-.048-.66L39.463.306c.17-.169.465-.148.66.048z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 72 72"
      }, e), s.createElement("defs", null, s.createElement("circle", {
        id: "IcnNoCRM_svg__a",
        cx: 9,
        cy: 9,
        r: 9
      })), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("g", {
        transform: "translate(10 22)"
      }, s.createElement("g", {
        fill: "currentColor",
        fillRule: "nonzero"
      }, s.createElement("path", {
        d: "M23.51 7h25.98c.282 0 .51-.224.51-.5s-.228-.5-.51-.5H23.51a.505.505 0 00-.51.5c0 .276.228.5.51.5zM23.5 12h18a.5.5 0 100-1h-18a.5.5 0 000 1z"
      })), s.createElement("circle", {
        stroke: "currentColor",
        cx: 9,
        cy: 9,
        r: 8.5
      }), s.createElement("mask", {
        id: "IcnNoCRM_svg__b",
        fill: "#fff"
      }, s.createElement("use", {
        xlinkHref: "#IcnNoCRM_svg__a"
      })), s.createElement("g", {
        mask: "url(#IcnNoCRM_svg__b)",
        fillRule: "nonzero",
        stroke: "currentColor"
      }, s.createElement("g", {
        transform: "translate(3.75 4.75)"
      }, s.createElement("circle", {
        cx: 5.25,
        cy: 2.75,
        r: 3
      }), s.createElement("rect", {
        x: .75,
        y: 7.75,
        width: 9,
        height: 7,
        rx: 2
      })))), s.createElement("path", {
        d: "M.5 4v64c0 1.929 1.57 3.5 3.5 3.5h64c1.929 0 3.5-1.57 3.5-3.5V4C71.5 2.07 69.93.5 68 .5H4C2.07.5.5 2.07.5 4zM.5 11.5h71",
        stroke: "currentColor"
      }), s.createElement("path", {
        d: "M7.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM13.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM19.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
        stroke: "currentColor"
      }), s.createElement("circle", {
        stroke: "currentColor",
        cx: 12,
        cy: 50,
        r: 2
      }), s.createElement("circle", {
        stroke: "currentColor",
        cx: 36,
        cy: 58,
        r: 2
      }), s.createElement("circle", {
        stroke: "currentColor",
        cx: 60,
        cy: 45,
        r: 2
      }), s.createElement("path", {
        d: "M.5 58l9.5-7M38 57.5l20-12M14 51l20 6.5M61.5 45.5l10 4",
        stroke: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 72 72"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M1 11h70V4c0-1.653-1.346-3-3-3H4C2.346 1 1 2.346 1 4v7zm0 1v56c0 1.653 1.346 3 3 3h64c1.653 0 3-1.346 3-3V12H1zM0 4c0-2.21 1.798-4 4-4h64c2.21 0 4 1.798 4 4v64c0 2.21-1.798 4-4 4H4c-2.21 0-4-1.798-4-4V4zm7 2a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zm5 0a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zm5 0a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), s.createElement("g", {
        transform: "translate(0 43)",
        fillRule: "nonzero",
        stroke: "currentColor"
      }, s.createElement("circle", {
        cx: 12,
        cy: 7,
        r: 2
      }), s.createElement("circle", {
        cx: 36,
        cy: 15,
        r: 2
      }), s.createElement("circle", {
        cx: 60,
        cy: 2,
        r: 2
      }), s.createElement("path", {
        d: "M.5 15L10 8M38 14.5l20-12M14 8l20 6.5M61.5 2.5l10 4"
      })), s.createElement("g", {
        transform: "translate(11 22)",
        stroke: "currentColor"
      }, s.createElement("circle", {
        cx: 8,
        cy: 8,
        r: 3.5
      }), s.createElement("path", {
        d: "M20.5 6.5h24",
        strokeLinecap: "round"
      }), s.createElement("path", {
        d: "M15.5 0v16"
      }), s.createElement("path", {
        d: "M20.5 9.5h17",
        strokeLinecap: "round"
      }), s.createElement("rect", {
        x: .5,
        y: .5,
        width: 49,
        height: 15,
        rx: 3
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.233 8.375H8.543c-.645 0-1.167.522-1.167 1.167v7.041c0 .645.522 1.167 1.167 1.167h4.927v.781h-1.813a.625.625 0 000 1.25h4.875a.625.625 0 100-1.25H14.72v-.781h4.927c.644 0 1.166-.522 1.166-1.167v-2.95c-.395.17-.834.21-1.25.12V16.5H8.625V9.625h6.347l-.17-.17a2.049 2.049 0 01-.569-1.08zm1.045 1.557a.832.832 0 00-.409.387l-1.8 3.6-.967-1.452a.828.828 0 00-.689-.368h-1.01a.625.625 0 000 1.25h.784l1.246 1.868a.827.827 0 001.43-.088l1.799-3.6.968 1.452a.829.829 0 00.688.368h.397a.625.625 0 00.582-.398l-3.019-3.02z",
        fill: "#fff"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.49 7.252L20.747 3.51a1.058 1.058 0 00-1.497 0l-3.742 3.742a1.058 1.058 0 000 1.496l3.742 3.742a1.058 1.058 0 001.497 0l3.741-3.742a1.058 1.058 0 000-1.496zM20.004 6.2h-.013c-.362 0-.643.355-.586.746l.256 1.343c.025.178.167.311.334.311H20c.167 0 .31-.133.334-.311l.257-1.343c.057-.39-.22-.742-.587-.746zm.593 3.6a.6.6 0 11-1.2 0 .6.6 0 011.2 0z",
        fill: "#AD1111"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M15.042 8.375h-6.5c-.645 0-1.167.522-1.167 1.167v7.041c0 .645.522 1.167 1.167 1.167h4.927v.781h-1.813a.625.625 0 000 1.25h4.875a.625.625 0 000-1.25H14.72v-.781h4.927c.644 0 1.166-.522 1.166-1.167V12.2h-1.25v4.3H8.626V9.625h5.707c.035-.086.077-.172.127-.256l.583-.994z",
        fill: "#fff"
      }), s.createElement("path", {
        d: "M14.426 11.203l-1.357 2.716-.969-1.452a.829.829 0 00-.688-.368h-1.01a.625.625 0 100 1.25h.784l1.246 1.868a.828.828 0 001.429-.088l1.533-3.067a1.933 1.933 0 01-.968-.86zM16.108 12.2l.52.78a.828.828 0 00.69.369h.396a.625.625 0 00.34-1.149h-1.946z",
        fill: "#fff"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.679 9.875l-3.89-6.629a.922.922 0 00-1.579 0l-3.889 6.629c-.346.59.091 1.325.79 1.325h7.778c.698 0 1.136-.735.79-1.325zM19.994 5.8h.012c.367.004.644.355.587.746l-.257 1.343c-.024.178-.167.311-.334.311h-.004c-.167 0-.31-.133-.334-.311l-.257-1.343c-.057-.39.224-.746.587-.746zM20 10a.6.6 0 100-1.2.6.6 0 000 1.2z",
        fill: "#E36A19"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.789 3.246l3.89 6.629c.346.59-.092 1.325-.79 1.325h-7.78c-.697 0-1.135-.735-.789-1.325l3.89-6.629a.922.922 0 011.579 0zm-.78 2.554h-.013c-.362 0-.643.355-.586.746l.256 1.343c.025.178.167.311.334.311h.004c.167 0 .31-.133.334-.31l.257-1.344c.057-.39-.22-.742-.587-.746zm.593 3.6a.6.6 0 11-1.2 0 .6.6 0 011.2 0z",
        fill: "#F47C22"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("defs", null, s.createElement("path", {
        d: "M12.5 5a.5.5 0 110 1h-6a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-6a.5.5 0 111 0v6a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 17.5v-11A1.5 1.5 0 016.5 5h6zm8-2a.5.5 0 01.5.5v6a.5.5 0 11-1 0V4.706l-8.146 8.148a.5.5 0 01-.708-.708L19.292 4H14.5a.5.5 0 110-1h6z",
        id: "IcnOpen_svg__a"
      })), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("use", {
        fill: "#ABABAB",
        xlinkHref: "#IcnOpen_svg__a"
      }), s.createElement("use", {
        fillOpacity: .8,
        fill: "currentColor",
        xlinkHref: "#IcnOpen_svg__a"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M5.625 4.63a.625.625 0 00-.993-.505l-1.37 1a.625.625 0 00.736 1.01l.377-.275v2.52a.625.625 0 101.25 0V4.63zM7.374 5.25c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999a.625.625 0 01-.625-.625zM7.374 10c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999A.625.625 0 017.374 10zM7.999 14.125a.625.625 0 100 1.25h8.376a.625.625 0 100-1.25H7.999zM4.668 12.255a.398.398 0 00-.285.124.463.463 0 00-.128.322.625.625 0 11-1.25 0c0-.444.17-.873.48-1.192.31-.32.736-.504 1.183-.504.448 0 .873.183 1.183.504.31.32.481.748.481 1.192 0 .231-.027.452-.118.682a2.427 2.427 0 01-.36.595c-.12.156-.416.467-.718.777h.744a.625.625 0 110 1.25H3.63a.625.625 0 01-.438-1.07l.062-.062a91.194 91.194 0 00.698-.697c.415-.419.812-.831.915-.964a1.25 1.25 0 00.184-.286.575.575 0 00.03-.225.463.463 0 00-.127-.322.398.398 0 00-.286-.124z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M18 6.707l-4.146 4.147a.5.5 0 01-.708-.708L17.293 6H14.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V6.707zm.655 8.84c.182.119.293.312.334.58.041.269-.034.544-.225.826l-.245.32a9.873 9.873 0 01-.6.704 6.895 6.895 0 01-.758.702c-.268.214-.507.321-.716.321h-.013c-.6-.018-1.219-.164-1.856-.437a11.613 11.613 0 01-1.882-1.03 17.589 17.589 0 01-1.794-1.378 32.437 32.437 0 01-1.589-1.48 30.338 30.338 0 01-1.473-1.59c-.5-.578-.957-1.176-1.371-1.795a11.754 11.754 0 01-1.03-1.876c-.273-.632-.418-1.244-.436-1.835-.01-.218.093-.462.306-.73a7.4 7.4 0 01.703-.764c.255-.241.489-.444.702-.607.214-.164.326-.25.335-.26.109-.072.222-.127.34-.163A1.2 1.2 0 017.743 5c.146 0 .282.027.41.082a.667.667 0 01.3.245l.334.499c.186.277.386.577.6.9l.6.908c.187.282.303.459.348.532a.885.885 0 01.11.505c-.01.2-.069.409-.178.627-.064.11-.173.3-.327.573-.155.273-.278.496-.369.669.1.146.293.391.58.737.286.345.698.787 1.234 1.323.546.546.992.962 1.337 1.249.346.286.591.48.737.58.164-.091.384-.216.661-.375.278-.16.471-.266.58-.321.118-.064.234-.111.348-.143.114-.032.225-.048.334-.048.082 0 .16.011.232.034.073.023.141.052.205.089a140.36 140.36 0 011.453.948l.893.594c.273.182.436.295.491.34zm-.6.888a.258.258 0 00.061-.123.724.724 0 00.007-.082c-.091-.064-.268-.182-.532-.355s-.546-.36-.846-.56l-1.35-.9h-.014a.575.575 0 00-.095.014.579.579 0 00-.178.082 24.589 24.589 0 00-1.214.682l-.49.273-.45-.328c-.165-.118-.43-.327-.799-.627-.368-.3-.83-.728-1.384-1.283a24.874 24.874 0 01-1.29-1.392 11.95 11.95 0 01-.634-.805l-.313-.45.272-.478c.173-.309.32-.57.444-.784.122-.214.202-.357.238-.43a.72.72 0 00.082-.287 19.89 19.89 0 00-.34-.532 86.337 86.337 0 00-.553-.832c-.196-.291-.38-.569-.553-.833a9.743 9.743 0 00-.354-.518c0-.01-.005-.014-.014-.014h-.014a.257.257 0 00-.102.02.55.55 0 00-.089.049 8.948 8.948 0 00-1.084.914c-.341.336-.539.582-.593.737.018.409.12.857.306 1.344.187.486.453 1.003.798 1.548.346.546.767 1.12 1.262 1.72.496.6 1.057 1.219 1.685 1.855a25.587 25.587 0 001.862 1.7c.605.495 1.18.913 1.725 1.255a9.091 9.091 0 001.549.791c.486.187.934.293 1.343.32.155-.063.4-.265.737-.607a8.95 8.95 0 00.914-1.084z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M18 6.707l-4.146 4.147a.5.5 0 01-.708-.708L17.293 6H14.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V6.707zm.655 8.84c.182.119.293.312.334.58.041.269-.034.544-.225.826l-.245.32a9.873 9.873 0 01-.6.704 6.895 6.895 0 01-.758.702c-.268.214-.507.321-.716.321h-.013c-.6-.018-1.219-.164-1.856-.437a11.613 11.613 0 01-1.882-1.03 17.589 17.589 0 01-1.794-1.378 32.437 32.437 0 01-1.589-1.48 30.338 30.338 0 01-1.473-1.59c-.5-.578-.957-1.176-1.371-1.795a11.754 11.754 0 01-1.03-1.876c-.273-.632-.418-1.244-.436-1.835-.01-.218.093-.462.306-.73a7.4 7.4 0 01.703-.764c.255-.241.489-.444.702-.607.214-.164.326-.25.335-.26.109-.072.222-.127.34-.163A1.2 1.2 0 017.743 5c.146 0 .282.027.41.082a.667.667 0 01.3.245l.334.499c.186.277.386.577.6.9l.6.908c.187.282.303.459.348.532a.885.885 0 01.11.505c-.01.2-.069.409-.178.627-.064.11-.173.3-.327.573-.155.273-.278.496-.369.669.1.146.293.391.58.737.286.345.698.787 1.234 1.323.546.546.992.962 1.337 1.249.346.286.591.48.737.58.164-.091.384-.216.661-.375.278-.16.471-.266.58-.321.118-.064.234-.111.348-.143.114-.032.225-.048.334-.048.082 0 .16.011.232.034.073.023.141.052.205.089a140.36 140.36 0 011.453.948l.893.594c.273.182.436.295.491.34z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0)),
      l = function (e) {
        return s.createElement("svg", r({
          width: "1em",
          height: "1em",
          viewBox: "0 0 10 10"
        }, e), s.createElement("path", {
          d: "M5 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM.974 9.658A.468.468 0 01.501 10c-.427 0-.563-.396-.475-.658C.763 7.13 2.458 6 5 6c2.542 0 4.237 1.13 4.974 3.342.088.262-.031.657-.474.658-.28 0-.407-.14-.474-.342C8.429 7.87 7.126 7 5 7 2.875 7 1.57 7.87.974 9.658z",
          fill: "currentColor",
          fillRule: "nonzero",
          stroke: "none",
          strokeWidth: 1
        }));
      };
    t.default = l, l._raw = '\n<svg width="1em" height="1em" viewBox="0 0 10 10" >\n        <path\n            d="M5 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM.974 9.658A.468.468 0 01.501 10c-.427 0-.563-.396-.475-.658C.763 7.13 2.458 6 5 6c2.542 0 4.237 1.13 4.974 3.342.088.262-.031.657-.474.658-.28 0-.407-.14-.474-.342C8.429 7.87 7.126 7 5 7 2.875 7 1.57 7.87.974 9.658z"\n            fill="currentColor"\n            fillRule="nonzero"\n            stroke="none"\n            strokeWidth="1"\n        />\n    </svg>';
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 16"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h2zm6 0a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1h2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M21 13h10a2 2 0 012 2v18a2 2 0 01-2 2H17a2 2 0 01-2-2V19l6-6z",
        fill: "#EA1010"
      }), s.createElement("path", {
        d: "M21.5 14L16 19.5V33a1 1 0 001 1h14a1 1 0 001-1V15a1 1 0 00-1-1h-9.5z",
        fill: "#FFF"
      }), s.createElement("path", {
        d: "M23.495 21c.709-.006.927.538.95 1.481.024.943-.477 2.448-.477 2.448.413.913 1.546 2.092 1.546 2.092s.372-.097 1.89-.133c1.523-.036 1.588.84 1.594.913.006.072.065.767-1.146.816-1.1.044-2.234-1.021-2.431-1.215l-.03-.03s-.52.084-.945.187c-.425.103-1.8.49-1.8.49s-.408.755-1.306 1.964c-.903 1.21-1.907 1.119-2.196.72-.33-.466-.07-.931.561-1.536.632-.604 2.096-1.106 2.096-1.106s.295-.544.726-1.584c.437-1.04.762-2.08.762-2.08s-.431-.997-.514-1.843c-.089-.943.012-1.578.72-1.584zm.313 4.37s-.319.968-.626 1.675l-.307.707c.06-.03.436-.213 1.134-.386.756-.194 1.075-.218 1.075-.218s-.85-.961-1.276-1.777zM22 13v7h-7v-1h6v-6z",
        fill: "#EA1010"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 11 14"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.588.155l8.3 6.036a1 1 0 010 1.618l-8.3 6.036A1 1 0 010 13.036V.964A1 1 0 011.588.155z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.91 14.991l.05.007h.08l.07-.01.029-.01a.489.489 0 00.272-.205l3.444-3.832a.596.596 0 000-.78.459.459 0 00-.632-.063l-.069.063-2.659 2.957V5.513A.504.504 0 0010 5a.5.5 0 00-.488.42l-.008.093v7.604l-2.658-2.956a.459.459 0 00-.632-.063l-.069.063a.598.598 0 00-.057.704l.057.076 3.444 3.832c.064.098.16.172.272.206l.049.012z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        d: "M15 4a1 1 0 011 1v2.212l-1 1.005V5H5v14h10v-2.305l1-1V19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10zm-5 9v3H7v-3h3zm8.36-5.37l.091.08 1.27 1.275a1 1 0 01.004 1.407L14.207 16h-2.755l-.034-2.65 5.616-5.639a1 1 0 011.327-.08zm-.617.787l-5.32 5.342.016 1.24h1.349l5.224-5.308-1.27-1.274zM13 7v3H7V7h6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        d: "M15 4a1 1 0 011 1v2.212l-5.887 5.914.05 4.249h4.158L16 15.695V19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10zm-6 9H7v3h2v-3zm9.36-5.37l.091.08 1.27 1.275a1 1 0 01.004 1.407L14.207 16h-2.755l-.034-2.65 5.616-5.639a1 1 0 011.327-.08zm-.617.787l-5.32 5.342.016 1.24h1.349l5.224-5.308-1.27-1.274zM12 7H7v3h5V7z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M6 10c1.271 0 2.305.38 3.071 1.146.467.467.722.773.888 1.156a.5.5 0 01-.918.396c-.098-.225-.3-.469-.677-.844C7.797 11.287 7.021 11 6.005 11c-.87.009-1.578.296-2.152.869-.563.563-.853 1.43-.852 2.632a.5.5 0 11-1 0c-.001-1.446.374-2.569 1.146-3.34.76-.76 1.719-1.15 2.846-1.161h.002a3 3 0 11.006 0zm9.502 3c2.122 0 3.748.542 4.853 1.646C21.46 15.751 22.002 17.378 22 19.5a.5.5 0 01-1 0c.001-1.878-.456-3.25-1.352-4.146-.896-.896-2.27-1.354-4.146-1.354H15.5c-1.877 0-3.25.458-4.147 1.354-.896.895-1.353 2.268-1.351 4.146a.5.5 0 01-1 0c-.002-2.122.54-3.75 1.645-4.854C11.75 13.542 13.378 13 15.5 13zm-.002-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 1a4.5 4.5 0 110-9 4.5 4.5 0 010 9zM6 9a2 2 0 100-4 2 2 0 000 4z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("rect", {
        x: 3.5,
        y: 4.5,
        width: 17,
        height: 14,
        rx: 1
      }), s.createElement("path", {
        d: "M6.5 20.5h11M12.5 13.5h5M12.5 7.5h5M12.5 15.5H16M12.5 9.5H16",
        strokeLinecap: "round"
      }), s.createElement("circle", {
        cx: 8.5,
        cy: 8.5,
        r: 2
      }), s.createElement("circle", {
        cx: 8.5,
        cy: 14.5,
        r: 2
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M5 4h14a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zm7.5 10h5a.5.5 0 100-1h-5a.5.5 0 100 1zm0-6h5a.5.5 0 100-1h-5a.5.5 0 100 1zm0 8H16a.5.5 0 100-1h-3.5a.5.5 0 100 1zm0-6H16a.5.5 0 100-1h-3.5a.5.5 0 100 1zm-4 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
        fill: "currentColor"
      }), s.createElement("path", {
        d: "M6.5 20.5h11",
        stroke: "currentColor",
        strokeLinecap: "round"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12 17a5 5 0 100-10 5 5 0 000 10zm0 1a6 6 0 110-12 6 6 0 010 12zm-.781-4.38l2.94-3.422a.371.371 0 01.559-.005.483.483 0 01.004.637l-3.354 3.874a.2.2 0 01-.3.002L9.28 12.7a.476.476 0 01-.003-.63.372.372 0 01.558-.003l1.384 1.554z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M6.144 9.862A.519.519 0 016 9.494a.53.53 0 01.036-.195.47.47 0 01.276-.264A.6.6 0 016.517 9h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104zm0 3A.519.519 0 016 12.494a.53.53 0 01.036-.195.47.47 0 01.276-.264.6.6 0 01.205-.035h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104zm0 3A.519.519 0 016 15.494a.53.53 0 01.036-.195.47.47 0 01.276-.264.6.6 0 01.205-.035h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M15.742 14.153l3.091 3.091a.417.417 0 11-.589.59l-3.091-3.092a5.833 5.833 0 11.59-.59zm-4.409 1.18a5 5 0 100-10 5 5 0 000 10z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19.641 4c.164 0 .27.064.317.193.047.13.023.305-.07.528l-7.19 16.77a.761.761 0 01-.237.36.501.501 0 01-.308.114.494.494 0 01-.281-.097.989.989 0 01-.264-.29L8.76 16.92a4.609 4.609 0 00-.73-.905 5.269 5.269 0 00-.904-.747L2.38 12.314c-.27-.175-.396-.372-.378-.588.017-.217.172-.39.465-.519l16.788-7.12c.07-.023.137-.043.202-.06A.701.701 0 0119.64 4zM7.723 14.266c.117.07.238.155.36.255.124.1.25.208.379.325l8.314-8.455-12.902 5.484 3.85 2.39zm4.342 5.818l5.52-12.92-8.332 8.473c.105.117.202.234.29.351.088.117.16.235.22.352l2.302 3.744z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19 10.484c.24.042.466.16.68.352a.92.92 0 01.32.71v1c0 .272-.107.49-.32.657-.214.167-.44.281-.68.344l-1.297.312a7.295 7.295 0 01-.164.446c-.057.14-.122.278-.195.414l.687 1.156c.136.208.219.448.25.719a.817.817 0 01-.25.703l-.703.703a.903.903 0 01-.719.273 1.472 1.472 0 01-.734-.226l-1.125-.719a8.21 8.21 0 01-.438.203c-.145.063-.302.12-.468.172L13.563 19a1.36 1.36 0 01-.352.68.92.92 0 01-.711.32h-1a.793.793 0 01-.656-.32A1.865 1.865 0 0110.5 19l-.313-1.281a6.402 6.402 0 01-.5-.18 5.137 5.137 0 01-.484-.227l-1.156.735c-.198.135-.44.21-.727.226A.867.867 0 016.61 18l-.72-.703a.837.837 0 01-.234-.703c.032-.271.11-.51.235-.719l.734-1.219a8.606 8.606 0 01-.18-.383 3.23 3.23 0 01-.148-.414L5 13.547a1.865 1.865 0 01-.68-.344.793.793 0 01-.32-.656v-1a.92.92 0 01.32-.711c.214-.193.44-.31.68-.352l1.281-.28a3.67 3.67 0 01.157-.438c.062-.146.124-.287.187-.422l-.734-1.219a1.775 1.775 0 01-.235-.719.837.837 0 01.235-.703L6.609 6a.867.867 0 01.711-.273c.287.015.529.09.727.226l1.156.734a5.68 5.68 0 01.969-.406L10.5 5c.052-.24.161-.466.328-.68A.808.808 0 0111.5 4h1c.281 0 .516.107.703.32.188.214.307.435.36.664l.28 1.313a6.968 6.968 0 01.907.375l1.125-.719c.208-.135.453-.21.734-.226a.903.903 0 01.72.273l.702.703a.817.817 0 01.25.703c-.031.271-.114.51-.25.719l-.687 1.156c.073.146.143.295.21.446.068.15.123.31.165.476l1.281.281zm0 1.985l.016-.89a.55.55 0 00-.22-.11l-1.858-.422-.172-.547a2.639 2.639 0 00-.125-.375 4.382 4.382 0 00-.188-.39l-.25-.5.985-1.641a.505.505 0 00.07-.125.3.3 0 00.023-.094l-.656-.64a.371.371 0 00-.203.062l-1.61 1.031-.515-.266c-.125-.062-.25-.122-.375-.18a2.031 2.031 0 00-.39-.132l-.548-.188-.406-1.89a.46.46 0 00-.047-.117L12.5 5h-.922a.364.364 0 00-.062.094.555.555 0 00-.047.156l-.453 1.813-.532.171a4.812 4.812 0 00-.813.344l-.515.266L7.484 6.78l-.078-.039a.716.716 0 00-.093-.039l-.657.656c0 .032.008.068.024.11a.88.88 0 00.07.14l1.016 1.688-.25.484c-.063.136-.118.26-.164.375-.047.115-.086.23-.118.344l-.171.547-1.891.422a.573.573 0 00-.102.047.212.212 0 01-.07.03v.923c.02.02.052.039.094.054a.85.85 0 00.156.04l1.828.468.172.531c.031.105.07.211.117.32.047.11.102.222.164.337l.235.484-1.016 1.703a.505.505 0 00-.07.125.318.318 0 00-.024.11l.657.64a.26.26 0 00.101-.023.63.63 0 00.102-.055l1.64-1.047.516.266c.135.073.27.138.406.195.136.057.271.107.406.149l.532.172.468 1.843c.01.052.024.097.04.133a.271.271 0 00.054.086h.906a.55.55 0 00.11-.203l.406-1.86.547-.187a5.483 5.483 0 00.75-.313l.515-.265 1.641 1.047.078.039a.716.716 0 00.094.039l.656-.656a.318.318 0 00-.023-.11.88.88 0 00-.07-.14l-.985-1.625.25-.5a3.07 3.07 0 00.164-.352c.047-.12.091-.242.133-.367l.172-.516 1.86-.469a.677.677 0 00.132-.039.271.271 0 00.086-.054zM12 9c.833 0 1.544.292 2.133.875A2.88 2.88 0 0115.016 12a2.88 2.88 0 01-.883 2.125c-.589.583-1.3.875-2.133.875a2.9 2.9 0 01-2.117-.875A2.88 2.88 0 019 12c0-.833.294-1.542.883-2.125A2.9 2.9 0 0112 9zm0 5c.552 0 1.023-.195 1.414-.586.39-.39.586-.862.586-1.414 0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0012 10c-.552 0-1.023.195-1.414.586-.39.39-.586.862-.586 1.414 0 .552.195 1.023.586 1.414.39.39.862.586 1.414.586z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19 10.484c.24.042.466.16.68.352a.92.92 0 01.32.71v1c0 .272-.107.49-.32.657-.214.167-.44.281-.68.344l-1.297.312a7.295 7.295 0 01-.164.446c-.057.14-.122.278-.195.414l.687 1.156c.136.208.219.448.25.719a.817.817 0 01-.25.703l-.703.703a.903.903 0 01-.719.273 1.472 1.472 0 01-.734-.226l-1.125-.719a8.21 8.21 0 01-.438.203c-.145.063-.302.12-.468.172L13.563 19a1.36 1.36 0 01-.352.68.92.92 0 01-.711.32h-1a.793.793 0 01-.656-.32A1.865 1.865 0 0110.5 19l-.313-1.281a6.402 6.402 0 01-.5-.18 5.137 5.137 0 01-.484-.227l-1.156.735c-.198.135-.44.21-.727.226A.867.867 0 016.61 18l-.72-.703a.837.837 0 01-.234-.703c.032-.271.11-.51.235-.719l.734-1.219a8.606 8.606 0 01-.18-.383 3.23 3.23 0 01-.148-.414L5 13.547a1.865 1.865 0 01-.68-.344.793.793 0 01-.32-.656v-1a.92.92 0 01.32-.711c.214-.193.44-.31.68-.352l1.281-.28a3.67 3.67 0 01.157-.438c.062-.146.124-.287.187-.422l-.734-1.219a1.775 1.775 0 01-.235-.719.837.837 0 01.235-.703L6.609 6a.867.867 0 01.711-.273c.287.015.529.09.727.226l1.156.734a5.68 5.68 0 01.969-.406L10.5 5c.052-.24.161-.466.328-.68A.808.808 0 0111.5 4h1c.281 0 .516.107.703.32.188.214.307.435.36.664l.28 1.313a6.968 6.968 0 01.907.375l1.125-.719c.208-.135.453-.21.734-.226a.903.903 0 01.72.273l.702.703a.817.817 0 01.25.703c-.031.271-.114.51-.25.719l-.687 1.156c.073.146.143.295.21.446.068.15.123.31.165.476l1.281.281zM12 9c.833 0 1.544.292 2.133.875A2.88 2.88 0 0115.016 12a2.88 2.88 0 01-.883 2.125c-.589.583-1.3.875-2.133.875a2.9 2.9 0 01-2.117-.875A2.88 2.88 0 019 12c0-.833.294-1.542.883-2.125A2.9 2.9 0 0112 9z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M6 7a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1H6zm0-1h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), s.createElement("path", {
        fill: "currentColor",
        d: "M5 7h3v10H5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M6 7a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1H6zm0-1h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M8.667 4.8c-.46 0-.834.358-.834.8v12.8c0 .442.373.8.834.8h6.666c.46 0 .834-.358.834-.8V5.6c0-.442-.373-.8-.834-.8H8.667zm0-.8h6.666C16.253 4 17 4.716 17 5.6v12.8c0 .884-.746 1.6-1.667 1.6H8.667C7.747 20 7 19.284 7 18.4V5.6C7 4.716 7.746 4 8.667 4zm2.066 1.6a.4.4 0 100 .8h2.534a.4.4 0 100-.8h-2.534zm1.234 11.2a.8.8 0 100 1.6h.066a.8.8 0 100-1.6h-.066z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 4a1 1 0 01.993.883L14 5v2.999L19 8a1 1 0 011 1v7a1 1 0 01-1 1h-9l-1.445.964A1 1 0 017 17.131V9a1 1 0 011-1l5-.001V5H5v14h8v-2h1v2a1 1 0 01-.883.993L13 20H5a1 1 0 01-.993-.883L4 19V5a1 1 0 01.883-.993L5 4h8zm0 4.999L8 9v8.131L9.697 16H19V9l-5-.001V9h-1v-.001zM14.5 13a.5.5 0 010 1h-4a.5.5 0 010-1h4zm2-2a.5.5 0 010 1h-6a.5.5 0 010-1h6zm-8-5a.5.5 0 010 1h-1a.5.5 0 010-1h1zm2 0a.5.5 0 110 1 .5.5 0 010-1z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M8.667 4h6.666C16.253 4 17 4.716 17 5.6v12.8c0 .884-.746 1.6-1.667 1.6H8.667C7.747 20 7 19.284 7 18.4V5.6C7 4.716 7.746 4 8.667 4zm2.066 1.6a.4.4 0 100 .8h2.534a.4.4 0 100-.8h-2.534zm1.234 11.2a.8.8 0 100 1.6h.066a.8.8 0 100-1.6h-.066z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 9a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 9zm0 1a3 3 0 100 6 3 3 0 000-6zm-.377-5C14.383 5 15 5.619 15 6.382l.001 1.718a5.003 5.003 0 00-.689-.09V6.382a.69.69 0 00-.69-.691H5.378a.69.69 0 00-.688.691v8.927l2.148-2.035h2.17c.013.235.042.466.086.691H7.111l-1.95 1.847A.687.687 0 014 15.309V6.382A1.38 1.38 0 015.377 5h8.246zM6.5 11h2.916a4.962 4.962 0 00-.316 1H6.5a.5.5 0 010-1h2.916zm0-2H11a5.03 5.03 0 00-1 1H6.5a.5.5 0 010-1H11zm6-2a.5.5 0 010 1h-6a.5.5 0 010-1h6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 9a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 9zm0 1a3 3 0 100 6 3 3 0 000-6zm-.377-5C14.383 5 15 5.619 15 6.382l.001 1.718A5.023 5.023 0 0014 8a4.978 4.978 0 00-3 1H6.5a.5.5 0 00-.09.992L6.5 10H10a4.996 4.996 0 00-.584 1H6.5a.5.5 0 00-.09.992L6.5 12h2.6a5.023 5.023 0 00-.007 1.965H7.111l-1.95 1.847A.687.687 0 014 15.309V6.382A1.38 1.38 0 015.377 5h8.246zM12.5 7h-6a.5.5 0 00-.09.992L6.5 8h6a.5.5 0 000-1z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M9.514 4c1.49 0 2.561.722 3.1 2.094a.625.625 0 01-1.164.457c-.35-.891-.957-1.301-1.936-1.301-.997 0-1.865.587-1.865 1.679 0 .684.292 1.066 1.214 1.517l.331.154.184.08.558.227c.976.39 1.597.693 2.052 1.088l2.387.001a.625.625 0 01.092 1.243l-.092.007h-1.518c.223.568.3 1.205.214 1.809A3.43 3.43 0 019.674 16a3.896 3.896 0 01-3.722-2.744.625.625 0 111.194-.37 2.646 2.646 0 002.528 1.864 2.181 2.181 0 002.16-1.872 2.33 2.33 0 00-.327-1.544l-.062-.089-5.82.001a.625.625 0 01-.092-1.243l.092-.007 3.667-.001-.208-.084c-1.935-.798-2.685-1.456-2.685-2.982C6.399 5.019 7.907 4 9.514 4z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a8 8 0 110 16 8 8 0 010-16zm2.997 5c-.266 0-.521.106-.71.294l-3.286 3.294L7.712 9.29a1.003 1.003 0 00-1.418 1.418l1.998 1.997a1 1 0 001.418 0l3.996-3.994A1.002 1.002 0 0012.996 7z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M12 6a9.25 9.25 0 00-2.727.39c-.849.261-1.588.618-2.218 1.07-.63.454-1.13.985-1.5 1.595A3.688 3.688 0 005 11c0 .417.062.82.188 1.21.125.392.307.759.546 1.102.24.344.532.665.875.961.344.297.74.555 1.188.774l.547.281v.703l-.016.032c0 .27-.031.539-.094.804a4.963 4.963 0 01-.25.774c.47-.22.891-.472 1.266-.758.375-.287.604-.477.688-.57l.359-.438.547.078a4.193 4.193 0 00.734.047H12a9.25 9.25 0 002.727-.39c.849-.261 1.588-.618 2.218-1.07a5.434 5.434 0 001.5-1.595 3.688 3.688 0 000-3.89c-.37-.61-.87-1.14-1.5-1.594-.63-.453-1.37-.81-2.218-1.07A9.25 9.25 0 0012 6zm0-1c1.104 0 2.143.156 3.117.469.974.312 1.823.742 2.547 1.289a6.365 6.365 0 011.711 1.906c.417.724.625 1.503.625 2.336s-.208 1.612-.625 2.336a6.365 6.365 0 01-1.71 1.906c-.725.547-1.574.977-2.548 1.29-.974.312-2.013.468-3.117.468H11.578c-.146 0-.284-.003-.414-.008a3.512 3.512 0 01-.46-.055 3.813 3.813 0 01-.493.461 9.306 9.306 0 01-1.953 1.219c-.39.182-.784.31-1.18.383h-.125a.437.437 0 01-.32-.133.437.437 0 01-.133-.32.57.57 0 01.008-.094.278.278 0 01.023-.078c.146-.26.315-.612.508-1.055.193-.442.29-.888.29-1.336 0-.01.002-.018.007-.023.005-.005.008-.013.008-.024A7.31 7.31 0 015.922 15a5.623 5.623 0 01-1.047-1.164 5.33 5.33 0 01-.648-1.344A4.885 4.885 0 014 11c0-.833.208-1.612.625-2.336a6.365 6.365 0 011.71-1.906c.725-.547 1.574-.977 2.548-1.29A10.144 10.144 0 0112 5z",
        fill: "currentColor"
      }), s.createElement("path", {
        d: "M12.116 8c.09 0 .17.022.243.067a.42.42 0 01.164.182l.706 1.466 1.623.237a.447.447 0 01.359.298.437.437 0 01-.11.444l-1.185 1.185.273 1.648a.383.383 0 01-.027.238.453.453 0 01-.283.249.506.506 0 01-.243.006.407.407 0 01-.11-.043l-1.41-.76-1.417.76a.328.328 0 01-.103.043.503.503 0 01-.247-.006.453.453 0 01-.28-.25.383.383 0 01-.027-.237l.274-1.648-1.186-1.185a.429.429 0 01.03-.642.434.434 0 01.22-.1l1.623-.237.706-1.466a.42.42 0 01.164-.182.457.457 0 01.243-.067z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M20.016 14.433c.01.031.013.06.007.085a.72.72 0 01-.023.086c0 .02.003.044.008.07a.438.438 0 01.008.086c0 .478-.091.927-.273 1.347a3.526 3.526 0 01-1.853 1.853c-.42.182-.875.273-1.363.273-.478 0-.93-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347c0-.156.007-.304.023-.444.015-.14.044-.278.085-.413a3.041 3.041 0 00-1.09-.187c-.26 0-.48.024-.662.07-.182.047-.324.091-.428.133.031.135.057.272.078.413a3.36 3.36 0 01-.241 1.775 3.526 3.526 0 01-1.854 1.853c-.42.182-.875.273-1.363.273-.477 0-.929-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347v-.218a.36.36 0 00-.008-.07.106.106 0 01.007-.07c0-.052.042-.343.125-.872l.28-1.776a301.203 301.203 0 01.499-3.053.827.827 0 01.03-.233c.042-.384.196-.846.46-1.386.265-.54.969-.81 2.11-.81.136 0 .252.05.351.148a.479.479 0 01.148.35c0 .135-.05.252-.148.35a.479.479 0 01-.35.149c-.706 0-1.135.127-1.285.381-.15.255-.252.569-.304.942a.611.611 0 01-.016.133.611.611 0 00-.015.132l-.218 1.207c-.114.628-.229 1.29-.343 1.986a3.718 3.718 0 011.013-.568c.373-.14.768-.21 1.183-.21.644 0 1.228.158 1.752.474.525.317.943.73 1.254 1.238a3.63 3.63 0 01.584-.179c.244-.057.537-.085.88-.085.332 0 .626.028.88.085.254.057.454.117.6.18a3.627 3.627 0 011.269-1.239 3.376 3.376 0 011.752-.475c.395 0 .77.065 1.13.195.357.13.682.304.973.522-.115-.696-.226-1.348-.335-1.955a541.3 541.3 0 01-.234-1.308 1.202 1.202 0 01-.008-.133 2.518 2.518 0 00-.303-.942c-.151-.254-.58-.381-1.285-.381a.492.492 0 01-.498-.498.492.492 0 01.498-.5c1.142 0 1.843.27 2.102.81.26.54.416 1.003.467 1.387a.827.827 0 01.031.234l.203 1.183c.104.602.21 1.23.32 1.885l.295 1.783c.089.535.133.828.133.88zm-12.46 2.803c.685 0 1.272-.241 1.76-.724a2.374 2.374 0 00.732-1.752A2.4 2.4 0 009.316 13a2.4 2.4 0 00-1.76-.732c-.685 0-1.277.247-1.775.74-.499.493-.748 1.077-.748 1.752 0 .664.25 1.243.748 1.736.498.494 1.09.74 1.775.74zm8.971 0c.685 0 1.272-.241 1.76-.724a2.374 2.374 0 00.732-1.752.328.328 0 00-.008-.078.256.256 0 01-.008-.062.256.256 0 00-.03-.125c0-.041-.003-.086-.009-.132a1.341 1.341 0 01-.007-.148 2.467 2.467 0 00-.865-1.386 2.383 2.383 0 00-1.565-.561c-.685 0-1.277.247-1.775.74-.499.493-.748 1.077-.748 1.752 0 .664.25 1.243.748 1.736.498.494 1.09.74 1.775.74z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M20.016 14.433c.01.031.013.06.007.085a.72.72 0 01-.023.086c0 .02.003.044.008.07a.438.438 0 01.008.086c0 .478-.091.927-.273 1.347a3.526 3.526 0 01-1.853 1.853c-.42.182-.875.273-1.363.273-.478 0-.93-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347c0-.156.007-.304.023-.444.015-.14.044-.278.085-.413a3.041 3.041 0 00-1.09-.187c-.26 0-.48.024-.662.07-.182.047-.324.091-.428.133.031.135.057.272.078.413a3.36 3.36 0 01-.241 1.775 3.526 3.526 0 01-1.854 1.853c-.42.182-.875.273-1.363.273-.477 0-.929-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347v-.218a.36.36 0 00-.008-.07.106.106 0 01.007-.07c0-.052.042-.343.125-.872l.28-1.776a301.203 301.203 0 01.499-3.053.827.827 0 01.03-.233c.042-.384.196-.846.46-1.386.265-.54.969-.81 2.11-.81.136 0 .252.05.351.148a.479.479 0 01.148.35c0 .135-.05.252-.148.35a.479.479 0 01-.35.149c-.706 0-1.135.127-1.285.381-.15.255-.252.569-.304.942a.611.611 0 01-.016.133.611.611 0 00-.015.132l-.218 1.207c-.114.628-.229 1.29-.343 1.986a3.718 3.718 0 011.013-.568c.373-.14.768-.21 1.183-.21.644 0 1.228.158 1.752.474.525.317.943.73 1.254 1.238a3.63 3.63 0 01.584-.179c.244-.057.537-.085.88-.085.332 0 .626.028.88.085.254.057.454.117.6.18a3.627 3.627 0 011.269-1.239 3.376 3.376 0 011.752-.475c.395 0 .77.065 1.13.195.357.13.682.304.973.522-.115-.696-.226-1.348-.335-1.955a541.3 541.3 0 01-.234-1.308 1.202 1.202 0 01-.008-.133 2.518 2.518 0 00-.303-.942c-.151-.254-.58-.381-1.285-.381a.492.492 0 01-.498-.498.492.492 0 01.498-.5c1.142 0 1.843.27 2.102.81.26.54.416 1.003.467 1.387a.827.827 0 01.031.234l.203 1.183c.104.602.21 1.23.32 1.885l.295 1.783c.089.535.133.828.133.88z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M4 4.01v3.463a.5.5 0 11-1 0V3.51a.5.5 0 01.5-.5h3.959a.5.5 0 010 1H4z"
      }), s.createElement("path", {
        stroke: "#FFF",
        d: "M10.576 9.905a2 2 0 112.848 0c.734.799 1.197 2.182 1.197 3.595 0 2.173-1.107 4-2.621 4s-2.621-1.827-2.621-4c0-1.413.463-2.796 1.197-3.595z"
      }), s.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M9.051 13.5a.5.5 0 100-1h-2.9a.5.5 0 100 1h2.9zm8.256 0a.5.5 0 000-1H14.52a.5.5 0 100 1h2.786zM10.13 10a.5.5 0 110 1H7.974a.5.5 0 01-.435-.253l-.853-1.5a.5.5 0 01.87-.494L8.264 10h1.865zm3.77 0a.5.5 0 000 1h2.156a.5.5 0 00.434-.253l.853-1.5a.5.5 0 00-.869-.494L15.764 10H13.9zm-6.05 7.786a.5.5 0 11-.781-.625l1.575-1.966a.5.5 0 01.384-.188L9.65 15a.5.5 0 11.012 1l-.386.004-1.427 1.782zm8.254-.008a.5.5 0 10.792-.61l-1.514-1.966a.5.5 0 00-.39-.195L14.359 15a.5.5 0 00-.011 1l.39.004 1.366 1.774zM19.959 4.01v3.463a.5.5 0 101 0V3.51a.5.5 0 00-.5-.5H16.5a.5.5 0 100 1h3.459zM4 19.973V16.51a.5.5 0 10-1 0v3.963a.5.5 0 00.5.5h3.959a.5.5 0 000-1H4zm15.959-3.463a.5.5 0 111 0v3.963a.5.5 0 01-.5.5H16.5a.5.5 0 010-1h3.459V16.51z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero"
      }, s.createElement("path", {
        d: "M4 4v3.463a.5.5 0 01-1 0V3.5a.5.5 0 01.5-.5h3.959a.5.5 0 010 1H4zm7.138 6.218c.25.176.548.272.862.272.314 0 .612-.096.862-.272l.382-.27.294.364c.607.747.962 1.917.962 3.178 0 2.173-1.044 4-2.5 4s-2.5-1.827-2.5-4c0-1.26.355-2.43.962-3.178l.294-.363.382.269z"
      }), s.createElement("path", {
        d: "M12 10.49a2 2 0 110-4 2 2 0 010 4zm-2.235 3a.5.5 0 000-1H6.48a.5.5 0 100 1h3.286zm7.755 0a.5.5 0 000-1h-3.274a.5.5 0 100 1h3.275z"
      }), s.createElement("path", {
        d: "M10.697 9.99a.5.5 0 110 1H7.974a.5.5 0 01-.435-.253l-.853-1.5a.5.5 0 01.87-.494l.709 1.247h2.432zm2.457 0a.5.5 0 000 1h2.902a.5.5 0 00.434-.253l.853-1.5a.5.5 0 00-.869-.494l-.71 1.247h-2.61zM7.85 17.776a.5.5 0 01-.781-.625l1.575-1.966a.5.5 0 01.387-.188l1.467-.007a.5.5 0 01.004 1l-1.227.006-1.426 1.78zm8.254-.007a.5.5 0 10.792-.61l-1.514-1.967a.5.5 0 00-.393-.195l-1.467-.007a.5.5 0 00-.004 1l1.221.006 1.365 1.773zM19.959 4v3.463a.5.5 0 101 0V3.5a.5.5 0 00-.5-.5H16.5a.5.5 0 100 1h3.459zM4 16.5a.5.5 0 10-1 0v3.963a.5.5 0 00.5.5h3.959a.5.5 0 100-1H4V16.5zm15.959 0a.5.5 0 111 0v3.963a.5.5 0 01-.5.5H16.5a.5.5 0 110-1h3.459V16.5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M6 6h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M6 6h12a2 2 0 012 2v1a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6 13h12a2 2 0 012 2v1a2 2 0 01-2 2H6a2 2 0 01-2-2v-1a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M10.5 5c2.281 0 3.64.05 4.078.148.438.1.797.253 1.078.461.146.115.412.214.797.297.386.084 1.089.157 2.11.219.083.01.158.029.226.055a.34.34 0 01.164.133c.021.03.206.398.555 1.101.349.703.523 1.654.523 2.852 0 1.187-.125 2.06-.375 2.617-.25.557-.38.851-.39.883a.588.588 0 01-.188.171.495.495 0 01-.25.063c-.417 0-.87.13-1.36.39-.489.261-.981.644-1.476 1.15a11.78 11.78 0 00-1.453 1.858 16.067 16.067 0 00-1.305 2.524 5.414 5.414 0 01-.39.781c-.125.198-.438.297-.938.297-.291 0-.58-.091-.867-.273a2.022 2.022 0 01-.664-.665c-.156-.26-.26-.588-.313-.984a6.949 6.949 0 01-.046-1.242c.02-.432.065-.857.132-1.273.068-.417.138-.777.211-1.079-.51 0-1.156.003-1.937.008-.781.005-1.396.008-1.844.008-.614 0-1.112-.167-1.492-.5-.38-.333-.576-.77-.586-1.313 0-.177.01-.364.031-.562.021-.198.058-.36.11-.484a3.685 3.685 0 01-.414-.508A1.286 1.286 0 014 11.438c-.01-.344.07-.641.242-.891s.33-.453.477-.61a6.245 6.245 0 00-.125-.335.97.97 0 01-.063-.43c.021-.386.146-.703.375-.953a4.3 4.3 0 01.625-.578 2.648 2.648 0 01-.039-.422 1.734 1.734 0 01.055-.5 1.38 1.38 0 01.476-.782c.256-.218.594-.395 1.016-.53a7.999 7.999 0 011.508-.305A17.05 17.05 0 0110.5 5zm7.797 2.14c-.896-.072-1.6-.163-2.11-.273-.51-.11-.89-.258-1.14-.445-.198-.156-.477-.266-.836-.328C13.85 6.03 12.615 6 10.5 6c-.313 0-.688.008-1.125.023-.438.016-.86.055-1.266.118-.406.062-.76.156-1.062.28-.302.126-.48.298-.531.516a.588.588 0 00.125.485l.171.219a.488.488 0 010 .382.481.481 0 01-.25.274c-.01 0-.182.083-.515.25-.333.167-.505.39-.516.672-.01.177.026.315.11.414a.91.91 0 01.125.164.453.453 0 01.07.36.536.536 0 01-.195.327l-.32.266a.82.82 0 00-.321.656c.01.219.11.396.297.531.187.136.286.204.297.204a.608.608 0 01.25.343.583.583 0 01-.094.406l-.125.243a1.158 1.158 0 00-.125.539c.01.406.17.646.477.719.307.073.507.109.601.109h2.727c.484 0 .9-.003 1.25-.008l.523-.008c.094 0 .177.021.25.063.073.042.13.099.172.172.052.062.08.135.086.219a.599.599 0 01-.04.25 9.04 9.04 0 00-.32 1.171c-.088.427-.15.847-.187 1.258-.036.412-.042.79-.016 1.133.026.344.097.61.211.797.073.114.141.219.204.312.062.094.218.141.468.141.031 0 .084-.026.156-.078.073-.052.157-.182.25-.39.417-1 .878-1.894 1.383-2.68a11.952 11.952 0 011.578-2c.547-.547 1.097-.977 1.649-1.29.552-.312 1.083-.494 1.594-.546.093-.198.203-.516.328-.954.125-.437.187-1.036.187-1.796 0-.771-.09-1.435-.273-1.993-.182-.557-.336-.934-.461-1.132z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M10.5 5c2.281 0 3.64.05 4.078.148.438.1.797.253 1.078.461.146.115.412.214.797.297.386.084 1.089.157 2.11.219.083.01.158.029.226.055a.34.34 0 01.164.133c.021.03.206.398.555 1.101.349.703.523 1.654.523 2.852 0 1.187-.125 2.06-.375 2.617-.25.557-.38.851-.39.883a.588.588 0 01-.188.171.495.495 0 01-.25.063c-.417 0-.87.13-1.36.39-.489.261-.981.644-1.476 1.15a11.78 11.78 0 00-1.453 1.858 16.067 16.067 0 00-1.305 2.524 5.414 5.414 0 01-.39.781c-.125.198-.438.297-.938.297-.291 0-.58-.091-.867-.273a2.022 2.022 0 01-.664-.665c-.156-.26-.26-.588-.313-.984a6.949 6.949 0 01-.046-1.242c.02-.432.065-.857.132-1.273.068-.417.138-.777.211-1.079-.51 0-1.156.003-1.937.008-.781.005-1.396.008-1.844.008-.614 0-1.112-.167-1.492-.5-.38-.333-.576-.77-.586-1.313 0-.177.01-.364.031-.562.021-.198.058-.36.11-.484a3.685 3.685 0 01-.414-.508A1.286 1.286 0 014 11.438c-.01-.344.07-.641.242-.891s.33-.453.477-.61a6.245 6.245 0 00-.125-.335.97.97 0 01-.063-.43c.021-.386.146-.703.375-.953a4.3 4.3 0 01.625-.578 2.648 2.648 0 01-.039-.422 1.734 1.734 0 01.055-.5 1.38 1.38 0 01.476-.782c.256-.218.594-.395 1.016-.53a7.999 7.999 0 011.508-.305A17.05 17.05 0 0110.5 5z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M13.53 21c-2.28 0-3.64-.05-4.078-.148-.437-.1-.797-.253-1.078-.461-.146-.115-.411-.214-.797-.297-.385-.084-1.088-.157-2.11-.219a.963.963 0 01-.226-.055.34.34 0 01-.164-.133c-.02-.03-.205-.398-.554-1.101-.35-.703-.524-1.654-.524-2.852 0-1.187.125-2.06.375-2.617.25-.557.38-.851.39-.883a.588.588 0 01.188-.172.495.495 0 01.25-.062c.417 0 .87-.13 1.36-.39.49-.261.981-.644 1.476-1.15a11.78 11.78 0 001.453-1.858c.474-.735.91-1.576 1.305-2.524.135-.323.266-.583.39-.781.126-.198.438-.297.938-.297.292 0 .58.091.867.273.287.183.508.404.664.664.157.26.26.589.313.985.052.396.068.81.047 1.242-.021.432-.065.857-.133 1.273-.068.417-.138.777-.211 1.079.51 0 1.156-.003 1.937-.008.782-.005 1.396-.008 1.844-.008.615 0 1.112.167 1.492.5.38.333.576.77.586 1.312 0 .178-.01.365-.03.563-.022.198-.058.36-.11.484.135.136.273.305.414.508.14.203.216.435.226.695.01.344-.07.641-.242.891s-.33.453-.476.61c.03.093.073.205.125.335a.97.97 0 01.062.43c-.02.386-.146.703-.375.953a4.3 4.3 0 01-.625.578c.02.105.034.245.04.422.004.177-.014.344-.056.5a1.38 1.38 0 01-.476.782c-.255.218-.594.395-1.016.53a7.999 7.999 0 01-1.508.305A17.05 17.05 0 0113.53 21zm-7.797-2.14c.896.072 1.6.163 2.11.273.51.11.89.258 1.14.445.198.156.477.266.836.328.36.063 1.597.094 3.711.094.313 0 .688-.008 1.125-.023.438-.016.86-.055 1.266-.118.406-.062.76-.156 1.062-.28.303-.126.48-.298.532-.517a.588.588 0 00-.125-.484l-.172-.219a.488.488 0 010-.382.481.481 0 01.25-.274c.01 0 .182-.083.515-.25.334-.167.506-.39.516-.672.01-.177-.026-.315-.11-.414a.91.91 0 01-.124-.164.453.453 0 01-.07-.36.536.536 0 01.195-.327l.32-.266a.82.82 0 00.32-.656.669.669 0 00-.297-.531 2.878 2.878 0 00-.296-.204.608.608 0 01-.25-.343.583.583 0 01.094-.406l.124-.243c.084-.161.125-.341.125-.539-.01-.406-.169-.646-.476-.719-.308-.073-.508-.109-.602-.109h-2.726c-.485 0-.901.003-1.25.008l-.524.008a.495.495 0 01-.25-.063.454.454 0 01-.172-.172.369.369 0 01-.086-.218.599.599 0 01.04-.25 9.04 9.04 0 00.32-1.172c.088-.427.15-.847.187-1.258.037-.412.042-.79.016-1.133-.026-.344-.096-.61-.211-.797-.073-.114-.14-.219-.203-.312-.063-.094-.219-.141-.469-.141-.031 0-.083.026-.156.078-.073.052-.156.182-.25.39-.417 1-.878 1.894-1.383 2.68a11.952 11.952 0 01-1.578 2c-.547.547-1.096.977-1.649 1.29-.552.312-1.083.494-1.593.546-.094.198-.203.516-.328.954-.125.437-.188 1.036-.188 1.796 0 .771.091 1.435.274 1.993.182.557.335.934.46 1.132z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M13.53 21c-2.28 0-3.64-.05-4.078-.148-.437-.1-.797-.253-1.078-.461-.146-.115-.411-.214-.797-.297-.385-.084-1.088-.157-2.11-.219a.963.963 0 01-.226-.055.34.34 0 01-.164-.133c-.02-.03-.205-.398-.554-1.101-.35-.703-.524-1.654-.524-2.852 0-1.187.125-2.06.375-2.617.25-.557.38-.851.39-.883a.588.588 0 01.188-.172.495.495 0 01.25-.062c.417 0 .87-.13 1.36-.39.49-.261.981-.644 1.476-1.15a11.78 11.78 0 001.453-1.858c.474-.735.91-1.576 1.305-2.524.135-.323.266-.583.39-.781.126-.198.438-.297.938-.297.292 0 .58.091.867.273.287.183.508.404.664.664.157.26.26.589.313.985.052.396.068.81.047 1.242-.021.432-.065.857-.133 1.273-.068.417-.138.777-.211 1.079.51 0 1.156-.003 1.937-.008.782-.005 1.396-.008 1.844-.008.615 0 1.112.167 1.492.5.38.333.576.77.586 1.312 0 .178-.01.365-.03.563-.022.198-.058.36-.11.484.135.136.273.305.414.508.14.203.216.435.226.695.01.344-.07.641-.242.891s-.33.453-.476.61c.03.093.073.205.125.335a.97.97 0 01.062.43c-.02.386-.146.703-.375.953a4.3 4.3 0 01-.625.578c.02.105.034.245.04.422.004.177-.014.344-.056.5a1.38 1.38 0 01-.476.782c-.255.218-.594.395-1.016.53a7.999 7.999 0 01-1.508.305A17.05 17.05 0 0113.53 21z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M4.531 18.719a.44.44 0 01-.312-.117.522.522 0 01-.157-.305c0-.042-.018-.3-.054-.774-.037-.474-.013-1.054.07-1.742.083-.687.258-1.43.524-2.226a6.74 6.74 0 011.289-2.242 6.89 6.89 0 011.234-1.133 7.514 7.514 0 011.523-.836 9.899 9.899 0 011.797-.54c.64-.13 1.326-.205 2.055-.226l.016-2.797c0-.104.026-.195.078-.273a.52.52 0 01.203-.18.537.537 0 01.281-.047c.094.01.177.047.25.11l6.485 5.312a.513.513 0 01.187.39.498.498 0 01-.188.391l-6.484 5.375a.453.453 0 01-.25.11.537.537 0 01-.281-.047.501.501 0 01-.203-.188.493.493 0 01-.078-.265l-.016-2.875c-1.75 0-3.125.234-4.125.703s-1.75.99-2.25 1.562c-.5.573-.815 1.107-.945 1.602-.13.495-.196.763-.196.805a.538.538 0 01-.132.32.387.387 0 01-.305.133H4.53zm8.485-6.125c.062 0 .125.013.187.039.063.026.12.06.172.101a.777.777 0 01.102.164c.026.058.039.123.039.196v2.312l5.203-4.312-5.203-4.266v2.25a.48.48 0 01-.149.352.48.48 0 01-.351.148c-.709 0-1.375.05-2 .149a8.793 8.793 0 00-1.743.453 7.012 7.012 0 00-1.46.75 5.65 5.65 0 00-1.157 1.039 6.162 6.162 0 00-1.148 1.89 8.291 8.291 0 00-.492 1.922c.27-.375.604-.752 1-1.133.395-.38.903-.72 1.523-1.023.62-.302 1.375-.55 2.266-.742.89-.193 1.96-.29 3.21-.29z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M4.531 18.719a.44.44 0 01-.312-.117.522.522 0 01-.157-.305c0-.042-.018-.3-.054-.774-.037-.474-.013-1.054.07-1.742.083-.687.258-1.43.524-2.226a6.74 6.74 0 011.289-2.242 6.89 6.89 0 011.234-1.133 7.514 7.514 0 011.523-.836 9.899 9.899 0 011.797-.54c.64-.13 1.326-.205 2.055-.226l.016-2.797c0-.104.026-.195.078-.273a.52.52 0 01.203-.18.537.537 0 01.281-.047c.094.01.177.047.25.11l6.485 5.312a.513.513 0 01.187.39.498.498 0 01-.188.391l-6.484 5.375a.453.453 0 01-.25.11.537.537 0 01-.281-.047.501.501 0 01-.203-.188.493.493 0 01-.078-.265l-.016-2.875c-1.75 0-3.125.234-4.125.703s-1.75.99-2.25 1.562c-.5.573-.815 1.107-.945 1.602-.13.495-.196.763-.196.805a.538.538 0 01-.132.32.387.387 0 01-.305.133H4.53z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M2.675 20a.545.545 0 01-.39-.148.662.662 0 01-.196-.386c0-.052-.023-.378-.068-.978-.046-.6-.016-1.334.088-2.203.104-.87.322-1.809.654-2.817.331-1.008.868-1.953 1.61-2.836.455-.54.97-1.017 1.542-1.432a9.354 9.354 0 011.903-1.058c.697-.29 1.445-.517 2.245-.682.8-.164 1.656-.26 2.567-.286l.02-3.538c0-.131.032-.247.097-.345a.652.652 0 01.254-.228.663.663 0 01.351-.059c.118.013.222.06.313.138l8.1 6.72a.648.648 0 01.235.494.636.636 0 01-.234.494l-8.101 6.798a.563.563 0 01-.313.139.663.663 0 01-.35-.06.63.63 0 01-.255-.237.629.629 0 01-.097-.336l-.02-3.636c-2.186 0-3.904.296-5.153.89-1.25.592-2.187 1.25-2.811 1.975-.625.725-1.018 1.4-1.181 2.026-.163.626-.244.965-.244 1.018a.685.685 0 01-.166.405.481.481 0 01-.38.168h-.02zm1.233-4.27c.726-.841 1.774-1.578 3.14-2.226 1.402-.666 3.26-.986 5.582-.986h.995l.005.994.015 2.847 7.152-6.002-7.152-5.932-.02 3.72-.966.028a13.87 13.87 0 00-2.394.267c-.74.152-1.426.36-2.062.625a8.356 8.356 0 00-1.701.944c-.507.368-.961.79-1.363 1.267-.662.787-1.135 1.62-1.427 2.505-.312.948-.515 1.822-.61 2.622a16.76 16.76 0 00-.054.51c.228-.39.516-.783.86-1.183z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("g", {
        fill: "currentColor"
      }, s.createElement("path", {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.524 0 10-4.477 10-10S17.524 2 12 2m0 17.365a7.365 7.365 0 11.001-14.73A7.365 7.365 0 0112 19.365"
      }), s.createElement("path", {
        d: "M12.625 9.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M12.625 14.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M7.625 14.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M7.625 9.5a2.083 2.083 0 114.167 0 2.083 2.083 0 01-4.167 0"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M6.25 4.625a.625.625 0 10-1.25 0v5.321c0 1.554.508 2.615 1.419 3.565C7.33 14.46 8.5 15 10 15s2.67-.539 3.581-1.49C14.492 12.56 15 11.5 15 9.947V4.625a.625.625 0 10-1.25 0v5.321a3.835 3.835 0 01-1.07 2.699c-.683.71-1.68 1.105-2.68 1.105-1 0-1.997-.394-2.68-1.105a3.835 3.835 0 01-1.07-2.699V4.625zM4.625 16.375a.625.625 0 100 1.25h10.75a.625.625 0 100-1.25H4.625z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        d: "M3 5.25a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM3 10a1.25 1.25 0 102.5 0A1.25 1.25 0 003 10zM3 14.75a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z",
        fill: "currentColor"
      }), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.374 5.25c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999a.625.625 0 01-.625-.625zM7.374 10c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999A.625.625 0 017.374 10zM7.374 14.75c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999a.625.625 0 01-.625-.625z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6.5 6a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5 5.5A5.5 5.5 0 0 0 4.5 17a.5.5 0 0 1-1 0 6.5 6.5 0 1 1 13 0 .5.5 0 0 1-1 0 5.5 5.5 0 0 0-5.5-5.5Z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M13.969 7.284H5.03c-.01 0-.018.006-.023.016A.07.07 0 005 7.331v8.938c0 .01.003.02.008.031.005.01.013.016.023.016h8.938c.01 0 .018-.006.023-.016a.07.07 0 00.008-.031v-1.953c0-.188.05-.362.148-.524a.966.966 0 01.399-.367.752.752 0 01.226-.086 1.155 1.155 0 01.532.016c.099.026.19.07.273.133L19 15.363V8.222l-3.406 1.922a.778.778 0 01-.281.133c-.105.026-.209.039-.313.039-.073 0-.148-.008-.227-.024a.968.968 0 01-.242-.086.994.994 0 01-.383-.367.984.984 0 01-.148-.523V7.33a.07.07 0 00-.008-.031c-.005-.01-.013-.016-.023-.016zm5.5-.5c.062 0 .112.008.148.024.037.015.06.023.07.023a.511.511 0 01.313.484V16.3a.485.485 0 01-.086.281.531.531 0 01-.227.188.254.254 0 00-.07.023.337.337 0 01-.133.024c-.062 0-.125-.003-.187-.008a.308.308 0 01-.188-.102L15 14.316v1.953c0 .291-.102.539-.305.742a.992.992 0 01-.726.305H5.03a.992.992 0 01-.726-.305A1.01 1.01 0 014 16.269V7.33c0-.291.102-.539.305-.742a.992.992 0 01.726-.305h8.938c.291 0 .536.102.734.305.198.203.297.45.297.742v1.985l4.031-2.375a.464.464 0 01.227-.125.977.977 0 01.21-.032z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M19.469 6.784c.062 0 .112.008.148.024.037.015.06.023.07.023a.511.511 0 01.313.484V16.3a.485.485 0 01-.086.281.531.531 0 01-.227.188.254.254 0 00-.07.023.337.337 0 01-.133.024c-.062 0-.125-.003-.187-.008a.308.308 0 01-.188-.102L15 14.316v1.953c0 .291-.102.539-.305.742a.992.992 0 01-.726.305H5.03a.992.992 0 01-.726-.305A1.01 1.01 0 014 16.269V7.33c0-.291.102-.539.305-.742a.992.992 0 01.726-.305h8.938c.291 0 .536.102.734.305.198.203.297.45.297.742v1.985l4.031-2.375a.464.464 0 01.227-.125.977.977 0 01.21-.032z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, e), s.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.4839571,2.48257108 C15.4984274,3.68383824 16.7472822,5.82510938 16.8199056,8.14643174 C17.3121575,8.25209186 17.7614539,8.53477943 18.0717546,8.9587871 C18.405147,9.41333468 18.5446611,9.98154972 18.4598079,10.5381029 L18.4598079,10.5381029 L18.0460078,13.2771457 C17.9242244,14.123486 17.3025704,14.8120628 16.473043,15.0194446 C16.1709311,15.0949726 15.8631122,15.1012086 15.5693703,15.0452811 C14.5786464,16.2874264 13.1834737,17.1463138 11.6256271,17.4715741 C11.3221568,18.0774721 10.6987469,18.4926263 9.97808081,18.4926263 C8.95790668,18.4926263 8.13262626,17.6606904 8.13262626,16.6365657 C8.13262626,15.612441 8.95790668,14.7805051 9.97808081,14.7805051 C10.8962026,14.7805051 11.6564725,15.4543218 11.799391,16.335633 C12.8798553,16.0320053 13.8487633,15.4177801 14.5861303,14.5696745 C14.4676157,14.4674982 14.3598273,14.3513074 14.2649292,14.2219338 C13.9321947,13.7674146 13.7928059,13.1997098 13.8771618,12.6430082 L13.8771618,12.6430082 L14.290879,9.9045433 C14.4118093,9.05751834 15.0335767,8.36805333 15.8636442,8.16053644 L15.7601537,8.19096812 C15.7024481,6.22501783 14.6463214,4.41057568 12.9407473,3.39350922 C11.115575,2.30512407 8.84058663,2.30512407 7.01541435,3.39350922 C5.31359575,4.40833621 4.25836768,6.21703126 4.19640361,8.17798387 C4.99692721,8.40311856 5.5905338,9.07888565 5.70776772,9.90014881 L5.70776772,9.90014881 L6.12280269,12.6427735 C6.20719405,13.1997098 6.06780528,13.7674146 5.73477256,14.2223408 C5.22903884,14.9118018 4.35648446,15.2268265 3.52695703,15.0194446 C2.6974296,14.8120628 2.07577558,14.123486 1.95455551,13.2809623 L1.95455551,13.2809623 L1.53959323,10.5388159 C1.45463183,9.98154972 1.59414589,9.41333468 1.92720561,8.95924122 C2.22868184,8.54729195 2.66106948,8.26872528 3.13713045,8.15509172 C3.20566892,5.83061785 4.45514385,3.68538294 6.47220451,2.48257108 C8.63202517,1.1946287 11.3241364,1.1946287 13.4839571,2.48257108 Z M9.97808081,15.8411111 C9.54557869,15.8411111 9.19323232,16.196299 9.19323232,16.6365657 C9.19323232,17.0768323 9.54557869,17.4320202 9.97808081,17.4320202 C10.4105829,17.4320202 10.7629293,17.0768323 10.7629293,16.6365657 C10.7629293,16.196299 10.4105829,15.8411111 9.97808081,15.8411111 Z M3.75447147,9.16631151 C3.38194477,9.11973763 3.00861681,9.27744843 2.78276471,9.58606138 C2.61545952,9.81416546 2.54544764,10.0993109 2.58817176,10.3795427 L2.58817176,10.3795427 L3.00378563,13.1260866 C3.0642069,13.5459873 3.37263249,13.8876158 3.78419178,13.9905056 C4.19575108,14.0933954 4.62865763,13.9371 4.87927261,13.5954399 C5.04652242,13.3669747 5.11658654,13.0816164 5.07415147,12.8015684 L5.07415147,12.8015684 L4.65845477,10.0544466 C4.59847726,9.63434954 4.2901007,9.29239714 3.87841396,9.18947546 L3.87841396,9.18947546 Z M17.2161955,9.58560726 C16.9655814,9.2431581 16.5325657,9.08655378 16.120879,9.18947546 C15.7091922,9.29239714 15.4008157,9.63434954 15.3402119,10.0587089 L15.3402119,10.0587089 L14.925833,12.801671 C14.8834135,13.0816164 14.9534776,13.3669747 15.1204291,13.5950329 C15.3713424,13.9371 15.8042489,14.0933954 16.2158082,13.9905056 C16.6273675,13.8876158 16.9357931,13.5459873 16.9967577,13.1224022 L16.9967577,13.1224022 L17.4112094,10.3789619 C17.4538453,10.0993109 17.3838334,9.81416546 17.2161955,9.58560726 Z",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M7 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11A.5.5 0 017 6zm5-3a.5.5 0 01.5.5v17a.5.5 0 11-1 0v-17A.5.5 0 0112 3zm5 5a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7A.5.5 0 0117 8zM9.5 8a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm5 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-10 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm15 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M7 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11A.5.5 0 017 6zm5-3a.5.5 0 01.5.5v17a.5.5 0 11-1 0v-17A.5.5 0 0112 3zm5 5a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7A.5.5 0 0117 8zM9.5 8a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm5 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-10 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm15 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, s.createElement("path", {
        d: "M0 0h24v24H0z"
      }), s.createElement("path", {
        d: "M7.5 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11a.5.5 0 01.5-.5zm4-2a.5.5 0 01.5.5v15a.5.5 0 11-1 0v-15a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm-6 0a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm4 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm12 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12.998 4.063a.502.502 0 01.201.205.605.605 0 01.073.293v14.87a.605.605 0 01-.073.293.502.502 0 01-.201.205.341.341 0 01-.113.053.396.396 0 01-.266-.009.467.467 0 01-.136-.08l-5.151-4.482H5.626c-.44 0-.816-.151-1.127-.453a1.47 1.47 0 01-.467-1.094L4 10.11c0-.427.156-.789.467-1.085a1.575 1.575 0 011.127-.445H7.3l5.183-4.482A.45.45 0 0112.74 4a.422.422 0 01.258.062zm-.757 14.3V5.629l-4.49 3.985a.439.439 0 01-.29.107H5.594a.63.63 0 00-.41.124c-.103.083-.154.172-.154.267l.032 3.753c0 .094.051.186.153.275a.602.602 0 00.41.134h1.868a.64.64 0 01.153.018.341.341 0 01.137.07l4.458 4.003zm5.167-6.26c0 .723-.209 1.37-.627 1.939-.419.569-.95.924-1.594 1.067a.121.121 0 00-.04.009.163.163 0 01-.056.008.464.464 0 01-.322-.133.558.558 0 01-.177-.329.565.565 0 01.072-.427c.08-.13.19-.213.33-.249.408-.083.74-.305.998-.667a2.05 2.05 0 00.386-1.218c0-.486-.126-.907-.378-1.263a1.493 1.493 0 00-.99-.64.469.469 0 01-.33-.232.625.625 0 01-.088-.426.574.574 0 01.2-.374.427.427 0 01.395-.089c.644.119 1.175.462 1.594 1.032.418.569.627 1.233.627 1.992zm-.676-5.23c.494.202.94.478 1.336.828.397.35.74.753 1.03 1.21.29.456.513.957.669 1.502a6.13 6.13 0 01.233 1.69c0 .569-.078 1.126-.233 1.672a5.71 5.71 0 01-.668 1.503c-.29.456-.634.86-1.03 1.21-.398.349-.843.625-1.337.826a.689.689 0 01-.088.027.467.467 0 01-.378-.089.595.595 0 01-.186-.703.479.479 0 01.298-.284c.773-.332 1.398-.88 1.876-1.645a4.66 4.66 0 00.716-2.517 4.69 4.69 0 00-.716-2.535c-.478-.765-1.103-1.307-1.876-1.627a.541.541 0 01-.298-.303.56.56 0 01-.008-.427.494.494 0 01.266-.329.44.44 0 01.394-.008z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M12.998 4.063a.502.502 0 01.201.205.605.605 0 01.073.293v14.87a.605.605 0 01-.073.293.502.502 0 01-.201.205.341.341 0 01-.113.053.396.396 0 01-.266-.009.467.467 0 01-.136-.08l-5.151-4.482H5.626c-.44 0-.816-.151-1.127-.453a1.47 1.47 0 01-.467-1.094L4 10.11c0-.427.156-.789.467-1.085a1.575 1.575 0 011.127-.445H7.3l5.183-4.482A.45.45 0 0112.74 4a.422.422 0 01.258.062zm4.41 8.04c0 .723-.209 1.37-.627 1.939-.419.569-.95.924-1.594 1.067a.121.121 0 00-.04.009.163.163 0 01-.056.008.464.464 0 01-.322-.133.558.558 0 01-.177-.329.565.565 0 01.072-.427c.08-.13.19-.213.33-.249.408-.083.74-.305.998-.667a2.05 2.05 0 00.386-1.218c0-.486-.126-.907-.378-1.263a1.493 1.493 0 00-.99-.64.469.469 0 01-.33-.232.625.625 0 01-.088-.426.574.574 0 01.2-.374.427.427 0 01.395-.089c.644.119 1.175.462 1.594 1.032.418.569.627 1.233.627 1.992zm-.676-5.23c.494.202.94.478 1.336.828.397.35.74.753 1.03 1.21.29.456.513.957.669 1.502a6.13 6.13 0 01.233 1.69c0 .569-.078 1.126-.233 1.672a5.71 5.71 0 01-.668 1.503c-.29.456-.634.86-1.03 1.21-.398.349-.843.625-1.337.826a.689.689 0 01-.088.027.467.467 0 01-.378-.089.595.595 0 01-.186-.703.479.479 0 01.298-.284c.773-.332 1.398-.88 1.876-1.645a4.66 4.66 0 00.716-2.517 4.69 4.69 0 00-.716-2.535c-.478-.765-1.103-1.307-1.876-1.627a.541.541 0 01-.298-.303.56.56 0 01-.008-.427.494.494 0 01.266-.329.44.44 0 01.394-.008z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none"
      }, e), s.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.798 14.791L11.316 3.744c-.582-.992-2.05-.992-2.632 0L2.202 14.79C1.625 15.776 2.354 17 3.518 17h12.964c1.164 0 1.893-1.224 1.316-2.209zM9.99 8h.02c.611.007 1.073.592.978 1.244l-.428 2.238c-.04.296-.278.518-.557.518h-.006c-.279 0-.516-.222-.557-.518l-.428-2.238C8.917 8.592 9.386 8 9.99 8zm.01 7a1 1 0 100-2 1 1 0 000 2z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M20 11.794c0 4.304-3.516 7.794-7.855 7.794a7.868 7.868 0 01-3.796-.97L4 20l1.418-4.182a7.712 7.712 0 01-1.127-4.024C4.29 7.489 7.807 4 12.145 4 16.485 4 20 7.49 20 11.794zm-7.855-6.553c-3.641 0-6.603 2.94-6.603 6.553 0 1.434.467 2.762 1.258 3.842l-.825 2.433 2.537-.806a6.6 6.6 0 003.634 1.084c3.64 0 6.603-2.94 6.603-6.553s-2.962-6.553-6.604-6.553zm3.967 8.348c-.049-.08-.177-.127-.37-.223-.192-.095-1.139-.558-1.315-.621-.176-.064-.305-.096-.433.095s-.497.622-.61.749c-.112.128-.225.144-.417.048-.193-.095-.813-.297-1.548-.948a5.76 5.76 0 01-1.071-1.323c-.113-.19-.012-.294.084-.39.087-.085.193-.222.289-.334.096-.112.128-.191.192-.319.065-.127.033-.239-.016-.334-.048-.096-.433-1.036-.594-1.419-.16-.382-.53-.346-.659-.346-.128 0-.48.06-.656.25-.177.192-.674.654-.674 1.594 0 .94.69 1.849.786 1.976.096.127 1.44 2.24 3.29 2.884 1.849.644 2.037.53 2.31.478.272-.052 1.004-.37 1.232-.83.228-.46.228-.907.18-.987z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(n(0));
    t.default = function (e) {
      return s.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), s.createElement("path", {
        d: "M20 11.794c0 4.304-3.516 7.794-7.855 7.794a7.868 7.868 0 01-3.796-.97L4 20l1.418-4.182a7.712 7.712 0 01-1.127-4.024C4.29 7.489 7.807 4 12.145 4 16.485 4 20 7.49 20 11.794zm-3.888 1.795c-.049-.08-.177-.127-.37-.223-.192-.095-1.139-.558-1.315-.621-.176-.064-.305-.096-.433.095s-.497.622-.61.749c-.112.128-.225.144-.417.048-.193-.095-.813-.297-1.548-.948a5.76 5.76 0 01-1.071-1.323c-.113-.19-.012-.294.084-.39.087-.085.193-.222.289-.334.096-.112.128-.191.192-.319.065-.127.033-.239-.016-.334-.048-.096-.433-1.036-.594-1.419-.16-.382-.53-.346-.659-.346-.128 0-.48.06-.656.25-.177.192-.674.654-.674 1.594 0 .94.69 1.849.786 1.976.096.127 1.44 2.24 3.29 2.884 1.849.644 2.037.53 2.31.478.272-.052 1.004-.37 1.232-.83.228-.46.228-.907.18-.987z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SvgContainer = void 0;
    var i,
      a = o(n(14));
    t.SvgContainer = (0, a.default)("div")(i || (i = r(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    & > * {\n        width: ", "px;\n        height: ", "px;\n        flex: 0 0 auto;\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    & > * {\n        width: ", "px;\n        height: ", "px;\n        flex: 0 0 auto;\n        margin: auto;\n    }\n"])), function (e) {
      return e.contentSize;
    }, function (e) {
      return e.contentSize;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BadgeVariants = t.BadgeThemeProps = t.BadgeChildrenProps = t.BadgeProps = t.Badge = void 0;
    var r = n(398);
    Object.defineProperty(t, "Badge", {
      enumerable: !0,
      get: function () {
        return r.Badge;
      }
    });
    var o = n(62);
    Object.defineProperty(t, "BadgeProps", {
      enumerable: !0,
      get: function () {
        return o.BadgeProps;
      }
    }), Object.defineProperty(t, "BadgeChildrenProps", {
      enumerable: !0,
      get: function () {
        return o.BadgeChildrenProps;
      }
    }), Object.defineProperty(t, "BadgeThemeProps", {
      enumerable: !0,
      get: function () {
        return o.BadgeThemeProps;
      }
    }), Object.defineProperty(t, "BadgeVariants", {
      enumerable: !0,
      get: function () {
        return o.BadgeVariants;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Badge = void 0;
    var u = l(n(0)),
      d = n(7),
      f = n(3),
      p = n(399),
      h = n(62),
      v = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            n = e.children,
            r = e.showZero,
            o = e.invisible,
            a = e.variant,
            s = e.position,
            l = e.themeOverride,
            c = this.getWrapperComponent();
          return "number" != typeof n && void 0 !== n ? (f.log.error("Badge component received a non-numeric content."), null) : o || void 0 === n || 0 === n && !r && a !== t.variants.danger ? null : u.createElement(c.Component, i({}, c.props), u.createElement(d.ContentFragment, null, u.createElement(p.OuterCircle, {
            key: "defaultCircle",
            className: "Twilio-Badge-OuterCircle",
            themeOverride: l.OuterCircle,
            variant: a,
            position: s
          }, u.createElement(p.InnerCircle, {
            className: "Twilio-Badge-InnerCircle",
            variant: a,
            themeOverride: l.InnerCircle
          }, u.createElement(p.TextContainer, {
            className: "Twilio-Badge-TextContainer"
          }, this.renderContent())))));
        }, t.prototype.renderContent = function () {
          var e = this.props,
            n = e.children,
            r = e.variant,
            o = e.max;
          return r === t.variants.standard ? Math.min(n, o) + (n > o ? "+" : "") : r === t.variants.dot ? null : r === t.variants.danger ? "!" : (f.log.error("Badge component received an invalid variant"), null);
        }, t.prototype.getWrapperComponent = function () {
          var e = this.props,
            n = e.programmable,
            r = (e.themeOverride, c(e, ["programmable", "themeOverride"]));
          return n ? {
            Component: d.DynamicComponent,
            props: {
              name: t.displayName,
              contentStore: t.Content,
              noContainers: !0,
              childProps: r
            }
          } : {
            Component: u.Fragment,
            props: {}
          };
        }, t.variants = h.BadgeVariants, t.displayName = "Badge", t.Content = new d.DynamicContentStore(t.displayName), t.defaultProps = {
          invisible: !1,
          showZero: !1,
          variant: t.variants.standard,
          programmable: !0,
          themeOverride: {},
          max: 9
        }, t;
      }(u.PureComponent);
    t.Badge = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = t.InnerCircle = t.OuterCircle = void 0;
    var o,
      i,
      a,
      s = n(1),
      l = n(62),
      c = function (e, t, n) {
        return function (r) {
          switch (r.variant) {
            case l.BadgeVariants.standard:
              return e;
            case l.BadgeVariants.danger:
              return n;
            default:
              return t;
          }
        };
      };
    t.OuterCircle = (0, s.styled)("div")(o || (o = r(["\n    padding: 2px;\n    border-radius: 1em;\n    font-size: 10px;\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    z-index: 2;\n    animation: popIn forwards 0.5s cubic-bezier(0.28, 0.84, 0.42, 1);\n    backface-visibility: hidden;\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0) translateZ(0);\n        }\n        50% {\n            opacity: 1;\n            transform: scale(1.1) translateZ(0);\n        }\n\n        70% {\n            transform: scale(0.9) translateZ(0);\n        }\n\n        100% {\n            transform: scale(1) translateZ(0);\n        }\n    }\n    ", "\n    ", "\n"], ["\n    padding: 2px;\n    border-radius: 1em;\n    font-size: 10px;\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    z-index: 2;\n    animation: popIn forwards 0.5s cubic-bezier(0.28, 0.84, 0.42, 1);\n    backface-visibility: hidden;\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0) translateZ(0);\n        }\n        50% {\n            opacity: 1;\n            transform: scale(1.1) translateZ(0);\n        }\n\n        70% {\n            transform: scale(0.9) translateZ(0);\n        }\n\n        100% {\n            transform: scale(1) translateZ(0);\n        }\n    }\n    ", "\n    ", "\n"])), function (e) {
      return e.position && e.position.right ? e.position.right : c("0", "8px", "4px");
    }, function (e) {
      return e.position && e.position.top ? e.position.top : c("0", "8px", "4px");
    }, function (e) {
      return e.theme.Badge.OuterCircle;
    }, function (e) {
      return e.themeOverride;
    }), t.InnerCircle = (0, s.styled)("div")(i || (i = r(["\n    line-height: ", ";\n    min-width: ", ";\n    width: ", ";\n    height: ", ";\n    padding-left: 3px;\n    padding-right: 3px;\n    text-align: center;\n    border-radius: 16px;\n    font-weight: bold;\n    box-sizing: border-box;\n\n    ", "\n    ", "\n"], ["\n    line-height: ", ";\n    min-width: ", ";\n    width: ", ";\n    height: ", ";\n    padding-left: 3px;\n    padding-right: 3px;\n    text-align: center;\n    border-radius: 16px;\n    font-weight: bold;\n    box-sizing: border-box;\n\n    ", "\n    ", "\n"])), c("15px", "8px", "15px"), c("15px", "8px", "15px"), c("auto", "8px", "auto"), c("15px", "8px", "15px"), function (e) {
      return e.theme.Badge.InnerCircle;
    }, function (e) {
      return e.themeOverride;
    }), t.TextContainer = (0, s.styled)("span")(a || (a = r(["\n    margin-left: auto;\n    margin-right: auto;\n    align-self: center;\n"], ["\n    margin-left: auto;\n    margin-right: auto;\n    align-self: center;\n"])));
  }, function (e, t) {
    e.exports = require("@material-ui/core/Button");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Link = void 0;
    var u = n(5),
      d = l(n(0)),
      f = n(100),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.roundCorners,
            r = e.themeOverride,
            o = e.children,
            a = c(e, ["className", "roundCorners", "themeOverride", "children"]);
          return d.createElement(f.Button, i({
            className: (0, u.cx)("Twilio-Link", t),
            themeOverride: r,
            roundCorners: n,
            isLink: !0
          }, a), o);
        }, t.displayName = "Link", t.defaultProps = {
          className: "",
          roundCorners: !0,
          themeOverride: {}
        }, t;
      }(d.PureComponent);
    t.Link = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessagingCanvasImpl = t.TranscriptMessagingCanvasContext = t.IconContainer = t.MessagingCanvasContext = t.MessagingCanvas = t.MessageScrollButton = t.MessageLoader = t.MessageListItem = t.MessageList = t.MessageInputActionsProps = t.MessageInputActions = t.MessageInputV2 = t.MessageInput = t.MessageCanvasTray = t.MessageBubble = t.InlineNewMessageSeparator = t.InlineMessage = t.InlineDateSeparator = t.EmailMessageItemChildrenProps = t.EmailMessageItem = t.EmailEditorChildrenProps = t.EmailEditor = void 0;
    var r = n(404);
    Object.defineProperty(t, "EmailEditor", {
      enumerable: !0,
      get: function () {
        return r.EmailEditor;
      }
    }), Object.defineProperty(t, "EmailEditorChildrenProps", {
      enumerable: !0,
      get: function () {
        return r.EmailEditorChildrenProps;
      }
    });
    var o = n(449);
    Object.defineProperty(t, "EmailMessageItem", {
      enumerable: !0,
      get: function () {
        return o.EmailMessageItem;
      }
    }), Object.defineProperty(t, "EmailMessageItemChildrenProps", {
      enumerable: !0,
      get: function () {
        return o.EmailMessageItemChildrenProps;
      }
    });
    var i = n(125);
    Object.defineProperty(t, "InlineDateSeparator", {
      enumerable: !0,
      get: function () {
        return i.InlineDateSeparator;
      }
    });
    var a = n(126);
    Object.defineProperty(t, "InlineMessage", {
      enumerable: !0,
      get: function () {
        return a.InlineMessage;
      }
    });
    var s = n(128);
    Object.defineProperty(t, "InlineNewMessageSeparator", {
      enumerable: !0,
      get: function () {
        return s.InlineNewMessageSeparator;
      }
    });
    var l = n(72);
    Object.defineProperty(t, "MessageBubble", {
      enumerable: !0,
      get: function () {
        return l.MessageBubble;
      }
    });
    var c = n(129);
    Object.defineProperty(t, "MessageCanvasTray", {
      enumerable: !0,
      get: function () {
        return c.MessageCanvasTray;
      }
    });
    var u = n(74);
    Object.defineProperty(t, "MessageInput", {
      enumerable: !0,
      get: function () {
        return u.MessageInput;
      }
    }), Object.defineProperty(t, "MessageInputV2", {
      enumerable: !0,
      get: function () {
        return u.MessageInputV2;
      }
    });
    var d = n(132);
    Object.defineProperty(t, "MessageInputActions", {
      enumerable: !0,
      get: function () {
        return d.MessageInputActions;
      }
    }), Object.defineProperty(t, "MessageInputActionsProps", {
      enumerable: !0,
      get: function () {
        return d.MessageInputActionsProps;
      }
    });
    var f = n(75);
    Object.defineProperty(t, "MessageList", {
      enumerable: !0,
      get: function () {
        return f.MessageList;
      }
    });
    var p = n(71);
    Object.defineProperty(t, "MessageListItem", {
      enumerable: !0,
      get: function () {
        return p.MessageListItem;
      }
    });
    var h = n(136);
    Object.defineProperty(t, "MessageLoader", {
      enumerable: !0,
      get: function () {
        return h.MessageLoader;
      }
    });
    var v = n(137);
    Object.defineProperty(t, "MessageScrollButton", {
      enumerable: !0,
      get: function () {
        return v.MessageScrollButton;
      }
    });
    var m = n(492);
    Object.defineProperty(t, "MessagingCanvas", {
      enumerable: !0,
      get: function () {
        return m.MessagingCanvas;
      }
    }), Object.defineProperty(t, "MessagingCanvasContext", {
      enumerable: !0,
      get: function () {
        return m.MessagingCanvasContext;
      }
    });
    var g = n(510);
    Object.defineProperty(t, "IconContainer", {
      enumerable: !0,
      get: function () {
        return g.IconContainer;
      }
    });
    var b = n(146);
    Object.defineProperty(t, "TranscriptMessagingCanvasContext", {
      enumerable: !0,
      get: function () {
        return b.TranscriptMessagingCanvasContext;
      }
    }), Object.defineProperty(t, "TranscriptMessagingCanvasImpl", {
      enumerable: !0,
      get: function () {
        return b.TranscriptMessagingCanvasImpl;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailEditorThemeProps = t.EmailEditorChildrenProps = t.EmailEditor = void 0;
    var r = n(101);
    Object.defineProperty(t, "EmailEditor", {
      enumerable: !0,
      get: function () {
        return r.EmailEditor;
      }
    });
    var o = n(106);
    Object.defineProperty(t, "EmailEditorChildrenProps", {
      enumerable: !0,
      get: function () {
        return o.EmailEditorChildrenProps;
      }
    }), Object.defineProperty(t, "EmailEditorThemeProps", {
      enumerable: !0,
      get: function () {
        return o.EmailEditorThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailAccordion = void 0;
    var s = n(5),
      l = a(n(406)),
      c = i(n(0)),
      u = n(23),
      d = n(103),
      f = n(4),
      p = n(407);
    t.EmailAccordion = function (e) {
      var t = e.header,
        n = e.defaultOpen,
        r = void 0 !== n && n,
        o = e.body,
        i = e.strongBackgroundHeader,
        a = e.accordionId,
        h = e.onToggle,
        v = (0, d.useStateRef)(r),
        m = v.state,
        g = v.dispatch,
        b = v.ref,
        y = c.useRef(null);
      c.useEffect(function () {
        r !== b.current && g(r), h && h(r, !0);
        var e = function (e) {
          e.accordionId === a && _(e.open);
        };
        return a && u.Actions.addListener("afterToggleEmailAccordion", e), function () {
          a && u.Actions.removeListener("afterToggleEmailAccordion", e);
        };
      }, [a]);
      var _ = function (e) {
        var t = void 0 === e ? !b.current : e;
        g(t), h && h(t, !1);
      };
      return c.createElement(l.default, {
        ref: y,
        expanded: m
      }, c.createElement(p.StyledSummary, {
        onClick: function () {
          return _();
        },
        className: (0, s.cx)({
          strong: i
        })
      }, c.createElement(p.IconContainer, {
        isOpen: m
      }, c.createElement(f.Icon, {
        icon: "FilterUp"
      })), c.cloneElement(t, {
        isOpen: m
      })), c.createElement(p.StyledDetails, null, o));
    }, t.EmailAccordion.defaultProps = {
      defaultOpen: !1
    };
  }, function (e, t) {
    e.exports = require("@material-ui/core/Accordion");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledDetails = t.StyledSummary = t.IconContainer = void 0;
    var i,
      a = n(1),
      s = n(26),
      l = o(n(408)),
      c = o(n(409));
    t.IconContainer = (0, a.styled)("div")(i || (i = r(["\n    svg {\n        transform-origin: 50% 50%;\n        transition: transform 0.2s;\n        transform: rotate(", ");\n    }\n"], ["\n    svg {\n        transform-origin: 50% 50%;\n        transition: transform 0.2s;\n        transform: rotate(", ");\n    }\n"])), function (e) {
      return e.isOpen ? "180deg" : "90deg";
    }), t.StyledSummary = (0, s.withStyles)(function (e) {
      return {
        root: {
          minHeight: 40,
          boxShadow: "0 1px 0 " + e.tokens.borderColors.colorBorderWeak,
          minWidth: 0,
          paddingLeft: e.tokens.spacings.space20,
          paddingRight: e.tokens.spacings.space20,
          borderRadius: "inherit",
          "&.Mui-expanded": {
            minHeight: 0,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
          },
          "&.strong": {
            background: e.tokens.backgroundColors.colorBackground
          }
        },
        content: {
          minWidth: 0,
          "&, &.Mui-expanded": {
            marginTop: e.tokens.spacings.space30,
            marginBottom: e.tokens.spacings.space30
          }
        }
      };
    })(l.default), t.StyledDetails = (0, s.withStyles)(function (e) {
      return {
        root: {
          paddingTop: e.tokens.spacings.space20,
          paddingRight: e.tokens.spacings.space40,
          paddingLeft: e.tokens.spacings.space40,
          paddingBottom: e.tokens.spacings.space40,
          transform: "translate(0,0)"
        }
      };
    })(c.default);
  }, function (e, t) {
    e.exports = require("@material-ui/core/AccordionSummary");
  }, function (e, t) {
    e.exports = require("@material-ui/core/AccordionDetails");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Title = t.Wrapper = void 0;
    var o,
      i,
      a = n(1);
    t.Wrapper = (0, a.styled)("div")(o || (o = r(["\n    padding: ", ";\n\n    ", ";\n"], ["\n    padding: ", ";\n\n    ", ";\n"])), function (e) {
      var t = e.theme.tokens.spacings;
      return "0 " + t.space50 + " " + t.space40;
    }, function (e) {
      return e.theme.Chat.EmailEditor.Wrapper;
    }), t.Title = (0, a.styled)("p")(i || (i = r(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    align-self: center;\n    ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    align-self: center;\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }, function (e) {
      return e.theme.Chat.EmailEditor.Title;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      c = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      u = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      },
      d = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailEditorBody = void 0;
    var f = n(29),
      p = n(412),
      h = n(19),
      v = n(104),
      m = d(n(63)),
      g = s(n(0)),
      b = n(31),
      y = n(23),
      _ = n(33),
      O = n(94),
      C = n(3),
      P = n(13),
      M = n(36),
      j = n(11),
      w = n(24),
      E = n(2),
      S = n(48),
      x = n(103),
      T = n(4),
      A = n(105),
      I = n(106),
      k = n(64),
      N = n(417),
      B = n(109),
      D = n(436),
      L = n(37),
      z = n(447),
      F = n(448),
      R = [{
        type: "p",
        children: [{
          text: ""
        }]
      }],
      H = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.componentDidCatch = function (e) {
          C.log.error(e);
        }, t.prototype.render = function () {
          return this.props.children;
        }, t;
      }(g.PureComponent);
    t.EmailEditorBody = function (e) {
      var t,
        n,
        r = g.useRef(e.conversationSid),
        o = (0, x.useStateRef)({
          htmlValue: R
        }),
        i = o.state,
        a = o.dispatch,
        s = o.ref,
        d = g.useState(""),
        C = d[0],
        W = d[1],
        U = g.useState(!0),
        V = U[0],
        G = U[1],
        q = g.useState(!1),
        K = q[0],
        Y = q[1],
        $ = g.useState(e.participants),
        Q = $[0],
        Z = $[1],
        J = e.conversation,
        X = e.conversationSid,
        ee = e.disabledReason,
        te = e.connectionState,
        ne = e.messageState,
        re = (0, F.useSlateRef)(),
        oe = (0, f.useTheme)(),
        ie = g.useMemo(function () {
          return new O.EmailDraftHelper(X);
        }, [X]),
        ae = g.useCallback((0, m.default)(function (e) {
          ie.saveDraft(e);
        }, 3e3), [X]),
        se = g.useCallback((0, m.default)(function (e) {
          var t;
          (null === (t = re.current) || void 0 === t ? void 0 : t.editor) && (0, M.tryInvokeAction)("SetInputText", {
            conversation: J,
            channel: J,
            body: "",
            htmlValue: e
          });
        }, 200), [J]);
      g.useEffect(function () {
        l(void 0, void 0, void 0, function () {
          var t, n, r, o, i;
          return c(this, function (l) {
            return (null === (i = re.current) || void 0 === i ? void 0 : i.editor) && s.current ? (t = e.messageState.htmlValue, n = re.current, r = n.editor, o = n.plugins, t || void 0 === e.messageState.inputText || (t = (0, v.deserializeHTMLToDocumentFragment)(r, {
              plugins: o,
              element: e.messageState.inputText || "<p></p>"
            })), t === s.current.htmlValue || (t || (t = R), t = t.map(function (e) {
              return e.type ? e : (0, h.createNode)("p", e.text);
            }), b.Transforms.select(r, (0, z.findFirstAvailablePath)(r.children, !1)), a({
              htmlValue: t
            })), [2]) : [2];
          });
        });
      }, [ne]), g.useEffect(function () {
        var e, t, n, o;
        if (r.current === X) if (V) {
          var s = ie.retrieveDraft();
          if ((null == s ? void 0 : s.emailBody) && a(s.emailBody), s) {
            var l = s.toParticipants,
              c = void 0 === l ? [] : l,
              u = s.ccParticipants;
            Z({
              to: c,
              cc: void 0 === u ? [] : u
            });
          }
          W(null !== (o = null !== (e = null == s ? void 0 : s.subject) && void 0 !== e ? e : null === (n = null === (t = J.messages[J.messages.length - 1]) || void 0 === t ? void 0 : t.source) || void 0 === n ? void 0 : n.subject) && void 0 !== o ? o : ""), G(!1);
        } else ae({
          toParticipants: Q.to,
          ccParticipants: Q.cc,
          subject: C,
          emailBody: i
        });
      }, [ie, J.messages, X, ae, Q.cc, Q.to, i, a, V, C]), g.useEffect(function () {
        y.Actions.addListener("afterCancelEmailDraftDebounce", function () {
          ae.cancel();
        });
      }, [ae]);
      var le = !Q.to.length && !Q.cc.length,
        ce = "connected" !== te || void 0 !== ee || le,
        ue = g.useRef(null);
      return g.createElement(H, null, g.createElement(k.Form, {
        onSubmit: function (t) {
          return l(void 0, void 0, void 0, function () {
            var n, r, o, a, s, d, f;
            return c(this, function (p) {
              switch (p.label) {
                case 0:
                  if (t.preventDefault(), n = J.messages, r = J.source, o = n.length ? n[n.length - 1].source.index : 0, (null == r ? void 0 : r.lastReadMessageIndex) !== o && j.Actions.updateLastReadMessageIndex(J, o), a = null == re ? void 0 : re.current, s = a.editor, d = a.plugins, !s) return [2];
                  f = (0, v.serializeHTMLFromNodes)(s, {
                    plugins: d,
                    nodes: i.htmlValue
                  }).replace(/<p><\/p>/g, "<p>&nbsp;</p>"), Y(!0), p.label = 1;
                case 1:
                  return p.trys.push([1, 3,, 4]), [4, Promise.all(Object.values(I.ParticipantLevelType).map(function (t) {
                    return function (e, t, n, r) {
                      return l(void 0, void 0, void 0, function () {
                        var o, i;
                        return c(this, function (a) {
                          return o = r[e].filter(function (t) {
                            var r = t.address;
                            return !n[e].find(function (e) {
                              return e.address === r;
                            });
                          }), i = n[e].filter(function (t) {
                            return !r[e].find(function (e) {
                              var n = e.address;
                              return t.address === n;
                            });
                          }), [2, Promise.all(u(u([], o.map(function (n) {
                            var r = n.address;
                            return y.Actions.invokeAction("AddEmailParticipant", {
                              conversationSid: t,
                              level: e,
                              email: r
                            }).catch(function (e) {
                              throw w.TelemetryBridge.emit(w.TelemetryBridgeMessageType.ERROR_EVENT, {
                                type: "email",
                                description: "Error while adding participants",
                                context: "updateConversationParticipants",
                                wrappedError: e
                              }), P.Notifications.showNotification(P.NotificationIds.EmailAddParticipantFailed, {
                                address: r,
                                conversationSid: t
                              }), e;
                            });
                          }), !0), i.map(function (e) {
                            var n = e.universalParticipantSid,
                              r = e.address;
                            return y.Actions.invokeAction("RemoveEmailParticipant", {
                              conversationSid: t,
                              participantSid: n
                            }).catch(function (e) {
                              throw w.TelemetryBridge.emit(w.TelemetryBridgeMessageType.ERROR_EVENT, {
                                type: "email",
                                description: "Error while removing participants",
                                context: "updateConversationParticipants",
                                wrappedError: e
                              }), P.Notifications.showNotification(P.NotificationIds.EmailRemoveParticipantFailed, {
                                address: r,
                                conversationSid: t
                              }), e;
                            });
                          }), !0))];
                        });
                      });
                    }(t, J.source.sid, e.participants, Q);
                  }))];
                case 2:
                  return p.sent(), [3, 4];
                case 3:
                  return p.sent(), Y(!1), [2];
                case 4:
                  return [4, (0, M.tryInvokeAction)("SendMessage", {
                    conversation: J,
                    htmlBody: f,
                    attachedFiles: e.messageState.attachedFiles,
                    subject: C
                  })];
                case 5:
                  return p.sent(), [4, (0, M.tryInvokeAction)("CancelEmailDraftDebounce")];
                case 6:
                  return p.sent(), [4, (0, M.tryInvokeAction)("ToggleEmailAccordion", {
                    open: !1,
                    accordionId: X
                  })];
                case 7:
                  return p.sent(), ie.deleteDraft(), Y(!1), P.Notifications.showNotification(P.NotificationIds.EmailSuccessfullySent, {
                    conversationSid: X
                  }), [2];
              }
            });
          });
        }
      }, g.createElement(N.EmailParticipantsInput, {
        toParticipants: Q.to,
        ccParticipants: Q.cc,
        preserveParticipantList: !!ee || K,
        onAddToParticipant: function (e) {
          Q.to.find(function (t) {
            return t.address === e;
          }) || Z(function (t) {
            return {
              to: u(u([], t.to, !0), [{
                address: e
              }], !1),
              cc: u([], t.cc, !0)
            };
          });
        },
        onDeleteToParticipant: function (e) {
          Z(function (t) {
            return {
              to: t.to.filter(function (t) {
                return t.address !== e;
              }),
              cc: t.cc
            };
          });
        },
        onAddCCParticipant: function (e) {
          Q.cc.find(function (t) {
            return t.address === e;
          }) || Z(function (t) {
            return {
              to: u([], t.to, !0),
              cc: u(u([], t.cc, !0), [{
                address: e
              }], !1)
            };
          });
        },
        onDeleteCCParticipant: function (e) {
          Z(function (t) {
            return {
              to: t.to,
              cc: t.cc.filter(function (t) {
                return t.address !== e;
              })
            };
          });
        }
      }), g.createElement(k.InputFieldContainer, {
        hasBorder: !0
      }, g.createElement(k.InputFieldLabel, {
        htmlFor: "subject"
      }, g.createElement(E.Template, {
        source: E.templates.EmailSubject
      }), ":"), g.createElement(k.InputFieldInput, {
        name: "subject",
        id: "subject",
        type: "text",
        value: C,
        onChange: function (e) {
          return W(e.target.value);
        },
        readOnly: !!ee || K
      })), g.createElement(B.HTMLEditor, {
        readOnly: !!ee || K,
        onChange: function (e) {
          i.htmlValue !== e && (a({
            htmlValue: e
          }), se(e));
        },
        value: i.htmlValue,
        scrollToBottom: function () {
          ue.current.scrollIntoView({
            behavior: "smooth"
          });
        }
      }), g.createElement(k.EmailFileContainer, null, null === (t = e.messageState.attachedFiles) || void 0 === t ? void 0 : t.map(function (e) {
        var t = "" + E.templates.RemoveAttachedFileAriaLabel({
          fileName: e.name
        });
        return g.createElement(A.FileBox, {
          noGrow: !0,
          key: e.name,
          overflow: "hidden",
          className: "Twilio-MessageInput-FileBox"
        }, g.createElement(S.FilePreview, {
          file: e
        }), g.createElement(A.RemoveFileButton, {
          className: "Twilio-MessageInput-FileBox-RemoveButton",
          title: t,
          "aria-label": t,
          sizeMultiplier: 1.2,
          icon: "Close",
          themeOverride: oe.Chat.MessageInput.RemoveFileButton,
          onClick: function () {
            return (0, M.tryInvokeAction)("DetachFile", {
              file: e,
              conversationSid: X
            });
          }
        }));
      })), g.createElement(k.Footer, null, g.createElement(D.HTMLToolbar, {
        customButtons: [g.createElement(L.StyledToolbarFileAttachment, {
          key: "file-upload",
          disabled: !1,
          onChange: function (e) {
            return l(void 0, void 0, Promise, function () {
              var t;
              return c(this, function (n) {
                return (t = e.target.files && Array.from(e.target.files)) && (0, M.tryInvokeAction)("AttachFiles", {
                  files: t,
                  conversationSid: X
                }), [2];
              });
            });
          },
          icon: "FileAttachment",
          sizeMultiplier: .8,
          multipleFiles: !0,
          conversationSid: X
        }), g.createElement(L.ToolbarSeparator, {
          key: "separator-1"
        })],
        editor: null === (n = null == re ? void 0 : re.current) || void 0 === n ? void 0 : n.editor
      }), g.createElement(k.SubmitButtonContainer, null, g.createElement(_.ActionStateListener, {
        action: ["SendMessage", "AddEmailParticipant", "RemoveEmailParticipant"],
        payload: function (e) {
          return e.conversationSid === X;
        }
      }, function (e) {
        return g.createElement("span", {
          title: le ? E.templates.EmailEditorNoParticipantButtonTooltip() : ""
        }, g.createElement(p.Button, {
          ref: ue,
          "data-test": "email-send-button",
          variant: "primary",
          size: "small",
          disabled: e.disabled || ce,
          type: "submit"
        }, K ? g.createElement(k.ButtonSpinnerContainer, null, g.createElement(T.Icon, {
          icon: "Loading",
          sizeMultiplier: 5 / 6
        })) : g.createElement(E.Template, {
          source: E.templates.EmailEditorSubmit
        })));
      })))));
    };
  }, function (e, t) {
    e.exports = require("@twilio-paste/core/button");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilePreview = void 0;
    var l = s(n(0)),
      c = n(20),
      u = n(4),
      d = n(414),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.renderIcon = function () {
          return l.isValidElement(this.props.iconOverride) ? this.props.iconOverride : l.createElement(u.Icon, {
            sizeMultiplier: 2,
            icon: (0, c.getFileIcon)(this.props.file)
          });
        }, t.prototype.customRounding = function (e) {
          switch (String(Math.round(e)).length) {
            case 1:
              return Math.round(100 * e) / 100;
            case 2:
              return Math.round(10 * e) / 10;
            default:
              return Math.round(e);
          }
        }, t.prototype.readableFileSize = function (e) {
          if (null == e) return "";
          var t = Math.ceil(e / 1024),
            n = String(t).length,
            r = "",
            o = 0;
          return n < 4 ? (r = "KB", o = t) : n < 7 ? (r = "MB", o = t / 1e3) : n < 10 ? (r = "GB", o = t / 1e6) : (r = "TB", o = t / 1e9), this.customRounding(o) + " " + r;
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.isBubble,
            n = e.isFromMe,
            r = e.subTitleLine,
            o = e.file,
            i = e.titleLine,
            a = e.disabled,
            s = /^(.+)\.(.+)?/.exec(o.name) || [],
            c = s[1],
            u = s[2],
            f = this.readableFileSize(o.size);
          return l.createElement(d.Container, {
            disabled: a
          }, l.createElement(d.FileIcon, {
            "aria-disabled": a
          }, this.renderIcon()), l.createElement(d.FileBody, null, l.createElement(d.Filename, null, i || l.createElement(l.Fragment, null, l.createElement(d.FilenameRaw, {
            "data-test": "MediaMessageBubble-FileName"
          }, c), l.createElement(d.Extension, {
            "data-test": "MediaMessageBubble-FileExtension"
          }, "." + u))), l.createElement(d.Filesize, {
            isBubble: t,
            isFromMe: n
          }, r || f)));
        }, t;
      }(l.PureComponent);
    t.FilePreview = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Filesize = t.Extension = t.FilenameRaw = t.Filename = t.FileIcon = t.FileBody = t.Container = void 0;
    var i,
      a,
      s,
      l,
      c,
      u,
      d,
      f = o(n(14));
    t.Container = (0, f.default)("div")(i || (i = r(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n    ", ";\n    color: ", ";\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n    ", ";\n    color: ", ";\n"])), function (e) {
      return e.disabled && "\n        opacity: 0.4;\n        cursor: not-allowed;\n    ";
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }), t.FileBody = (0, f.default)("div")(a || (a = r(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    padding-top: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-bottom: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    padding-top: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-bottom: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }), t.FileIcon = (0, f.default)("div")(s || (s = r(["\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: ", ";\n"], ["\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.sizings.sizeIcon90;
    }, function (e) {
      return e.theme.tokens.sizings.sizeIcon90;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextIcon;
    }), t.Filename = (0, f.default)("div")(l || (l = r(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: bold;\n    display: flex;\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: bold;\n    display: flex;\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }), t.FilenameRaw = (0, f.default)("div")(c || (c = r(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.Extension = (0, f.default)("div")(u || (u = r(["\n    flex-shrink: 0;\n"], ["\n    flex-shrink: 0;\n"]))), t.Filesize = (0, f.default)("div")(d || (d = r(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize10;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.isBubble && e.isFromMe ? e.theme.tokens.textColors.colorTextWeakest : e.theme.tokens.textColors.colorText;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      },
      c = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconButton = void 0;
    var u,
      d = n(5),
      f = c(n(416)),
      p = n(26),
      h = s(n(0)),
      v = n(4),
      m = n(1),
      g = h.forwardRef(function (e, t) {
        var n = e.className,
          i = e.disabled,
          a = e.icon,
          s = e.themeOverride,
          c = e.sizeMultiplier,
          p = e.variant,
          m = e.classes,
          g = e.theme,
          b = e.size,
          y = e.onClick,
          _ = l(e, ["className", "disabled", "icon", "themeOverride", "sizeMultiplier", "variant", "classes", "theme", "size", "onClick"]),
          O = (0, d.css)(u || (u = r(["\n        ", "\n        ", "\n    "], ["\n        ", "\n        ", "\n    "])), g.Button, s),
          C = ["success", "destructive", "link"].includes(p) ? "default" : p;
        return h.createElement(f.default, o({
          "aria-disabled": i,
          onClick: function (e) {
            i || y && y(e);
          },
          color: C,
          className: (0, d.cx)("Twilio-IconButton", "success" === p && (null == m ? void 0 : m.successVariant), "destructive" === p && (null == m ? void 0 : m.destructiveVariant), O, n),
          ref: t,
          size: "large" === b ? "medium" : b
        }, _), h.createElement(v.Icon, {
          icon: a,
          sizeMultiplier: c
        }));
      }),
      b = (0, m.withTheme)((0, p.withStyles)(function (e) {
        return {
          successVariant: {
            background: e.tokens.backgroundColors.colorBackgroundSuccess,
            color: e.tokens.textColors.colorTextWeakest,
            borderColor: e.tokens.borderColors.colorBorderSuccess,
            "&:focus-visible": {
              borderWidth: e.tokens.borderWidths.borderWidth30,
              borderColor: e.tokens.borderColors.colorBorderNeutral,
              background: e.tokens.backgroundColors.colorBackgroundSuccess
            },
            "&:hover": {
              borderColor: e.tokens.borderColors.colorBorderPrimaryStronger,
              background: e.tokens.backgroundColors.colorBackgroundSuccessStronger
            },
            "&:active": {
              background: e.tokens.backgroundColors.colorBackgroundSuccessStrong,
              borderColor: e.tokens.borderColors.colorBorderPrimaryStronger
            },
            "&:disabled": {
              background: e.tokens.backgroundColors.colorBackgroundSuccess,
              borderColor: e.tokens.borderColors.colorBorderSuccess,
              color: e.tokens.textColors.colorTextWeakest
            }
          },
          destructiveVariant: {
            background: e.tokens.backgroundColors.colorBackgroundDestructive,
            color: e.tokens.textColors.colorTextWeakest,
            borderColor: e.tokens.borderColors.colorBorderDestructive,
            "&:focus-visible": {
              borderWidth: e.tokens.borderWidths.borderWidth30,
              borderColor: e.tokens.borderColors.colorBorderNeutral,
              background: e.tokens.backgroundColors.colorBackgroundDestructive
            },
            "&:hover": {
              borderColor: e.tokens.borderColors.colorBorderDestructiveStronger,
              background: e.tokens.backgroundColors.colorBackgroundDestructiveStronger
            },
            "&:active": {
              background: e.tokens.backgroundColors.colorBackgroundDestructiveStrong,
              borderColor: e.tokens.borderColors.colorBorderDestructiveStronger
            },
            "&:disabled": {
              background: e.tokens.backgroundColors.colorBackgroundDestructive,
              borderColor: e.tokens.borderColors.colorBorderDestructive,
              color: e.tokens.textColors.colorTextWeakest
            }
          }
        };
      })(g));
    t.IconButton = b, b.displayName = "IconButton";
  }, function (e, t) {
    e.exports = require("@material-ui/core/IconButton");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailParticipantsInput = void 0;
    var a = n(107),
      s = i(n(0)),
      l = n(2),
      c = n(418),
      u = n(64);
    t.EmailParticipantsInput = function (e) {
      var t = (0, s.useState)(!1),
        n = t[0],
        r = t[1],
        o = e.toParticipants,
        i = e.ccParticipants,
        d = e.preserveParticipantList,
        f = e.onAddToParticipant,
        p = e.onDeleteToParticipant,
        h = e.onAddCCParticipant,
        v = e.onDeleteCCParticipant;
      return (0, s.useEffect)(function () {
        i.length > 0 && r(!0);
      }, [i]), s.default.createElement(s.default.Fragment, null, s.default.createElement(u.InputFieldContainer, {
        hasBorder: !n,
        "data-test": "email-To"
      }, s.default.createElement(u.InputFieldLabel, {
        htmlFor: "to"
      }, s.default.createElement(l.Template, {
        source: l.templates.EmailTo
      }), ":"), s.default.createElement(c.ChipInput, {
        onAdd: f,
        onDelete: p,
        value: o.map(function (e) {
          return e.address;
        }),
        disabled: d
      }), s.default.createElement(u.Links, null, n ? null : s.default.createElement(a.Anchor, {
        href: "#",
        "data-test": "open-Cc",
        onClick: function (e) {
          e.preventDefault(), r(!0);
        }
      }, "Cc"))), n ? s.default.createElement(u.InputFieldContainer, {
        hasBorder: !0,
        "data-test": "email-Cc"
      }, s.default.createElement(u.InputFieldLabel, {
        htmlFor: "cc"
      }, s.default.createElement(l.Template, {
        source: l.templates.EmailCc
      }), ":"), s.default.createElement(c.ChipInput, {
        onAdd: h,
        onDelete: v,
        value: i.map(function (e) {
          return e.address;
        }),
        disabled: d
      })) : null);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChipInput = void 0;
    var r = n(419);
    Object.defineProperty(t, "ChipInput", {
      enumerable: !0,
      get: function () {
        return r.ChipInput;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChipInput = void 0;
    var o = r(n(0)),
      i = n(2),
      a = n(108),
      s = n(421),
      l = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
    function c(e) {
      return Boolean(e.match(l));
    }
    function u(e, t) {
      var n = e.value,
        r = e.handleDelete;
      return o.default.createElement(s.ChipTile, {
        title: n,
        key: t,
        onRemove: r
      });
    }
    t.ChipInput = function (e) {
      var t = e.onAdd,
        n = e.onDelete,
        r = e.value,
        s = e.disabled;
      return o.default.createElement(a.StyledChipInput, {
        id: "email-to-participant-input",
        onBeforeAdd: c,
        onAdd: t,
        onDelete: function (e) {
          s || n(e);
        },
        blurBehavior: "add",
        newChipKeyCodes: [32],
        fullWidthInput: !0,
        disableUnderline: !0,
        value: r,
        readOnly: s,
        chipRenderer: u,
        InputProps: {
          onKeyPress: function (e) {
            "Enter" === e.key && e.preventDefault();
          },
          placeholder: i.templates.EmailRecipientInputPlaceholder(),
          autoComplete: "off"
        }
      });
    };
  }, function (e, t) {
    e.exports = require("material-ui-chip-input");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChipTile = void 0;
    var o = r(n(0)),
      i = n(108),
      a = n(2);
    t.ChipTile = function (e) {
      var t = e.title,
        n = e.onRemove;
      return o.default.createElement(i.Tile, null, o.default.createElement("span", {
        title: t
      }, t), o.default.createElement(i.CloseButton, {
        title: a.templates.EmailEditorRemoveEmailAddressButtonAriaLabel(),
        "aria-label": a.templates.EmailEditorRemoveEmailAddressButtonAriaLabel(),
        sizeMultiplier: 1.2,
        onClick: function () {
          return n(t);
        },
        icon: "Close"
      }));
    };
  }, function (e, t) {
    e.exports = require("@udecode/plate-trailing-block");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IframeWrapper = void 0;
    var l = a(n(0)),
      c = n(424),
      u = n(109),
      d = function (e) {
        var t = l.useRef(null),
          n = l.useRef(null);
        return l.useEffect(function () {
          var r;
          if (!(null === (r = e.contentRef) || void 0 === r ? void 0 : r.contentWindow)) return function () {};
          var o = e.contentRef.contentWindow,
            i = o.document.querySelector("html");
          return t.current || (t.current = new ResizeObserver(function (e) {
            var r;
            if (e.find(function (e) {
              return "div" === e.target.localName;
            }) && (r = n.current.offsetHeight, o.parent.postMessage("EMAIL_EDITOR_IFRAME///" + r, window.location.href)), !n.current) {
              var a = i.querySelector("div");
              a && (n.current = a, t.current.observe(n.current));
            }
          }), t.current.observe(i)), function () {
            var e;
            null === (e = t.current) || void 0 === e || e.disconnect(), t.current = null;
          };
        }, [e.contentRef]), null;
      };
    t.IframeWrapper = function (e) {
      var t = e.children,
        n = e.title,
        o = s(e, ["children", "title"]),
        i = l.useState(void 0),
        a = i[0],
        f = i[1],
        p = l.useState(100),
        h = p[0],
        v = p[1],
        m = a && a.contentWindow && a.contentWindow.document.body;
      return l.useEffect(function () {
        var e = function (e) {
          if (e.data && "string" == typeof e.data) {
            var t = e.data.split("///") || [],
              n = t[0],
              r = t[1];
            "EMAIL_EDITOR_IFRAME" === n && r && v(Number(r));
          }
        };
        return window.addEventListener("message", e), function () {
          return window.removeEventListener("message", e);
        };
      }, []), l.useEffect(function () {
        h >= u.MIN_HEIGHT_VALUE && o.scrollToBottom();
      }, [h]), l.createElement("iframe", r({}, o, {
        title: n,
        "data-test": "email-body-frame",
        ref: f,
        height: h
      }), m && (0, c.createPortal)(l.Children.only(l.createElement(l.Fragment, null, l.createElement("style", null, o.styles), t, l.createElement(d, {
        contentRef: a
      }))), m));
    };
  }, function (e, t) {
    e.exports = require("react-dom");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createPlateOptions = void 0;
    var r = n(65),
      o = n(110),
      i = n(111),
      a = n(112),
      s = n(113),
      l = n(49),
      c = n(50),
      u = n(66),
      d = n(67);
    t.createPlateOptions = function (e) {
      var t,
        n = ((t = {})[o.ELEMENT_BLOCKQUOTE] = o.DEFAULTS_BLOCKQUOTE, t[i.ELEMENT_CODE_BLOCK] = i.DEFAULTS_CODE_BLOCK, t[i.ELEMENT_CODE_LINE] = {}, t[a.ELEMENT_H1] = a.DEFAULTS_H1, t[a.ELEMENT_H2] = a.DEFAULTS_H2, t[a.ELEMENT_H3] = a.DEFAULTS_H3, t[a.ELEMENT_H4] = {}, t[a.ELEMENT_H5] = {}, t[a.ELEMENT_H6] = {}, t[s.ELEMENT_IMAGE] = {}, t[c.ELEMENT_LI] = {}, t[l.ELEMENT_LINK] = {}, t[c.ELEMENT_OL] = {}, t[u.ELEMENT_PARAGRAPH] = u.DEFAULTS_PARAGRAPH, t[d.ELEMENT_TABLE] = {}, t[d.ELEMENT_TD] = d.DEFAULTS_TD, t[d.ELEMENT_TH] = d.DEFAULTS_TH, t[d.ELEMENT_TR] = {}, t[c.ELEMENT_UL] = {}, t[r.MARK_BOLD] = r.DEFAULTS_BOLD, t[r.MARK_CODE] = r.DEFAULTS_CODE, t[r.MARK_ITALIC] = r.DEFAULTS_ITALIC, t[r.MARK_STRIKETHROUGH] = r.DEFAULTS_STRIKETHROUGH, t[r.MARK_SUBSCRIPT] = r.DEFAULTS_SUBSCRIPT, t[r.MARK_SUPERSCRIPT] = r.DEFAULTS_SUPERSCRIPT, t[r.MARK_UNDERLINE] = r.DEFAULTS_UNDERLINE, t);
      return e && Object.keys(e).forEach(function (t) {
        n[t] = e[t];
      }), Object.keys(n).forEach(function (e) {
        n[e].type || (n[e].type = e);
      }), n;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createCustomTablePlugin = void 0;
    var o = n(67),
      i = n(31);
    t.createCustomTablePlugin = function () {
      var e = (0, o.createTablePlugin)(),
        t = (0, o.getTableOnKeyDown)();
      return r(r({}, e), {
        onKeyDown: function (e) {
          return function (n) {
            if ("Tab" === n.key) {
              var r = (0, o.getTableCellEntry)(e, {});
              if (!r) return !1;
              var a = i.Node.has(e, i.Path.next(r.tableRow[1])),
                s = i.Node.has(e, i.Path.next(r.tableCell[1]));
              if (!a && !s) return !1;
            }
            return t(e)(n);
          };
        }
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getPluginComponent = t.getPluginOptions = void 0;
    var a = i(n(0));
    t.getPluginOptions = function (e) {
      return {
        deserialize: {
          getNode: function (t) {
            var n,
              r,
              o,
              i,
              a = {};
            if (t.style) {
              for (var s = 0; s < t.style.length; s++) {
                var l = t.style[s],
                  c = t.style.getPropertyValue(l);
                "initial" !== c && (a[l.replace(/-([a-z])/g, function (e, t) {
                  return t.toUpperCase();
                })] = c);
              }
              return {
                type: e,
                style: a,
                stringStyle: null === (r = null === (n = t.attributes) || void 0 === n ? void 0 : n.style) || void 0 === r ? void 0 : r.value,
                url: t.getAttribute("href")
              };
            }
            return {
              type: e,
              style: a,
              stringStyle: null === (i = null === (o = t.attributes) || void 0 === o ? void 0 : o.style) || void 0 === i ? void 0 : i.value
            };
          }
        }
      };
    };
    t.getPluginComponent = function (e) {
      return function (t) {
        var n, r;
        return a.createElement(e, {
          style: null === (n = t.element) || void 0 === n ? void 0 : n.style,
          href: null === (r = t.element) || void 0 === r ? void 0 : r.url
        }, t.children);
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createNoNewlineOnPastePlugin = void 0;
    t.createNoNewlineOnPastePlugin = function () {
      return {
        onPaste: function () {
          return function (e) {
            var t,
              n = e.clipboardData.getData("text/html");
            if (n) {
              e.preventDefault();
              var r = new DOMParser().parseFromString(n, "text/html").body;
              if ("BR" === (null === (t = r.lastElementChild) || void 0 === t ? void 0 : t.tagName)) {
                r.removeChild(r.lastElementChild);
                var o = new DataTransfer();
                o.setData("text/html", r.innerHTML), e.clipboardData = o;
              }
            }
          };
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.optionsResetBlockTypePlugin = void 0;
    var o = n(31),
      i = n(430),
      a = n(66),
      s = n(19),
      l = {
        defaultType: a.ELEMENT_PARAGRAPH
      };
    t.optionsResetBlockTypePlugin = {
      rules: [r(r({}, l), {
        hotkey: "Backspace",
        predicate: s.isSelectionAtBlockStart,
        onReset: function (e) {
          var t = o.Editor.above(e) || [],
            n = t[0],
            r = t[1];
          if (n && r) {
            var l = n;
            if ((0, s.getText)(e, r)) l.style ? (0, s.setNodes)(e, {
              style: void 0,
              stringStyle: void 0
            }) : o.Transforms.mergeNodes(e);else {
              var c = ((0, i.closestNodeMatching)(e, function (e) {
                var t;
                return 1 === (null === (t = e.children) || void 0 === t ? void 0 : t.length);
              }) || [])[1];
              o.Transforms.delete(e, {
                at: (null == c ? void 0 : c.length) ? c : [0]
              }), e.children.length || (o.Editor.insertNode(e, {
                type: a.ELEMENT_PARAGRAPH,
                children: [{
                  text: ""
                }]
              }), o.Transforms.select(e, [0, 0]));
            }
          }
        }
      })]
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.closestNodeMatching = void 0;
    var r = n(31);
    t.closestNodeMatching = function (e, t) {
      for (var n = r.Editor.above(e), o = n; n && t(n[0]) && n[1].length;) o = n, n = r.Editor.parent(e, n[1]);
      return o;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createResetNodePlugin = void 0;
    var r = n(432);
    t.createResetNodePlugin = function (e) {
      return {
        onKeyDown: (0, r.getResetNodeOnKeyDown)(e)
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getResetNodeOnKeyDown = void 0;
    var o = r(n(433)),
      i = n(19);
    t.getResetNodeOnKeyDown = function (e) {
      var t = e.rules;
      return function (e) {
        return function (n) {
          var r;
          return e.selection && (0, i.isCollapsed)(e.selection) && t.forEach(function (t) {
            var a,
              s = t.types,
              l = t.defaultType,
              c = t.hotkey,
              u = t.predicate,
              d = t.onReset;
            if (c && (0, o.default)(c, n)) {
              var f = (0, i.someNode)(e, {
                match: {
                  type: s
                }
              });
              u(e) && f && (n.preventDefault(), null === (a = d) || void 0 === a || a(e, function () {
                return (0, i.setNodes)(e, {
                  type: l
                });
              }), r = !0);
            }
          }), r;
        };
      };
    };
  }, function (e, t) {
    e.exports = require("is-hotkey");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createSpanPlugin = void 0;
    var r = n(435),
      o = n(68),
      i = n(18);
    t.createSpanPlugin = function () {
      return {
        pluginKeys: o.ELEMENT_SPAN,
        deserialize: (0, r.getSpanDeserialize)(),
        renderElement: (0, i.getRenderElement)(o.ELEMENT_SPAN),
        inlineTypes: (0, i.getPlatePluginTypes)(o.ELEMENT_SPAN)
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSpanDeserialize = void 0;
    var o = n(68),
      i = n(18),
      a = n(19);
    t.getSpanDeserialize = function () {
      return function (e) {
        var t = (0, i.getPlatePluginOptions)(e, o.ELEMENT_SPAN);
        return {
          element: (0, a.getElementDeserializer)(r({
            type: o.ELEMENT_SPAN,
            rules: [{
              nodeNames: "SPAN"
            }]
          }, t.deserialize))
        };
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HTMLToolbar = void 0;
    var l = s(n(69)),
      c = a(n(0)),
      u = s(n(437)),
      d = n(4),
      f = n(114),
      p = n(37),
      h = n(441),
      v = n(442),
      m = n(65),
      g = n(50),
      b = n(18),
      y = n(445);
    t.HTMLToolbar = function (e) {
      var t = c.useState(null),
        n = t[0],
        o = t[1],
        i = (0, b.useStoreEditorState)("main"),
        a = (0, u.default)(),
        s = a.width,
        h = a.observe;
      return c.createElement(p.Wrapper, {
        ref: h
      }, s < 300 ? c.createElement(c.Fragment, null, c.createElement(p.StyledPopover, {
        anchorEl: n,
        open: Boolean(n),
        onClose: function (e) {
          e.stopPropagation(), o(null), i && (0, f.focusOnEditor)(i);
        },
        TransitionComponent: l.default,
        key: "compactViewToolbarPopover",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        disableAutoFocus: !0,
        disableEnforceFocus: !0,
        disableRestoreFocus: !0
      }, c.createElement(p.CompactViewContainer, null, c.createElement(_, r({}, e, {
        isExtendedView: !1
      })))), e.customButtons, c.createElement(p.ExpandToolbarButton, {
        onClick: function (e) {
          e.stopPropagation(), o(e.currentTarget), i && (0, f.focusOnEditor)(i);
        },
        onMouseDown: function (e) {
          return e.preventDefault();
        },
        className: Boolean(n) ? "slate-ToolbarButton-active" : void 0
      }, c.createElement(d.Icon, {
        sizeMultiplier: 2 / 3,
        icon: "Format"
      })), c.createElement(v.ToolbarLink, {
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "Link"
        })
      })) : c.createElement(_, r({}, e, {
        isExtendedView: !0
      })));
    };
    var _ = function (e) {
      var t = b.getPlatePluginType.bind(null, e.editor || {});
      return c.createElement(c.Fragment, null, e.isExtendedView && e.customButtons, c.createElement(h.ToolbarMark, {
        type: t(m.MARK_BOLD),
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "Bold"
        })
      }), c.createElement(h.ToolbarMark, {
        type: t(m.MARK_ITALIC),
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "Italic"
        })
      }), c.createElement(h.ToolbarMark, {
        type: t(m.MARK_UNDERLINE),
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "Underline"
        })
      }), c.createElement(h.ToolbarMark, {
        type: t(m.MARK_STRIKETHROUGH),
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "Strikethrough"
        })
      }), e.isExtendedView && c.createElement(v.ToolbarLink, {
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "Link"
        })
      }), c.createElement(y.ToolbarList, {
        type: t(g.ELEMENT_UL),
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "UnorderedList"
        })
      }), c.createElement(y.ToolbarList, {
        type: t(g.ELEMENT_OL),
        icon: c.createElement(d.Icon, {
          sizeMultiplier: .85,
          icon: "OrderedList"
        })
      }));
    };
  }, function (e, t) {
    e.exports = require("react-cool-dimensions");
  }, function (e, t) {
    e.exports = require("slate-react");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      c = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AttachFileButton = void 0;
    var u = n(5),
      d = s(n(0)),
      f = n(20),
      p = n(2),
      h = n(440),
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.inputRef = d.createRef(), t.handleButtonClick = function () {
            var e;
            t.props.disabled || null === (e = t.inputRef.current) || void 0 === e || e.click();
          }, t.onChange = function (e) {
            return l(t, void 0, void 0, function () {
              return c(this, function (t) {
                switch (t.label) {
                  case 0:
                    return t.trys.push([0, 2, 3, 4]), [4, this.props.onChange(e)];
                  case 1:
                    return t.sent(), [3, 4];
                  case 2:
                    return t.sent(), [3, 4];
                  case 3:
                    return this.inputRef.current && (this.inputRef.current.value = ""), [7];
                  case 4:
                    return [2];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.disabled,
            n = e.themeOverride,
            r = e.className,
            o = e.ariaLabel,
            i = e.icon,
            a = e.sizeMultiplier,
            s = e.multipleFiles,
            l = e.onFocus,
            c = e.onBlur,
            v = e.conversationSid,
            m = e.legacy;
          return d.createElement(d.Fragment, null, d.createElement("input", {
            disabled: t,
            className: h.hiddenInputClass,
            ref: this.inputRef,
            type: "file",
            onChange: this.onChange,
            accept: (0, f.getAllowedFileExtensions)(v).map(function (e) {
              return "." + e;
            }).join(","),
            multiple: s
          }), d.createElement(h.StyledIconButton, {
            "aria-disabled": t,
            "aria-label": o,
            onClick: this.handleButtonClick,
            className: (0, u.cx)("Twilio-AttachFileButton", r),
            "data-test": "attach-file",
            icon: i,
            sizeMultiplier: a,
            title: t ? "" : p.templates.AttachFileImageTooltip(),
            themeOverride: n,
            onFocus: l,
            onBlur: c,
            legacy: {
              legacy: m
            }
          }));
        }, t.defaultProps = {
          multipleFiles: !1,
          icon: "FileAttachment",
          sizeMultiplier: .8
        }, t;
      }(d.PureComponent);
    t.AttachFileButton = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIconButton = t.hiddenInputClass = void 0;
    var o,
      i,
      a = n(5),
      s = n(15),
      l = n(1);
    t.hiddenInputClass = (0, a.css)(o || (o = r(["\n    visibility: hidden;\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"], ["\n    visibility: hidden;\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"]))), t.StyledIconButton = (0, l.styled)(s.IconButton)(i || (i = r(["\n    border-width: ", ";\n    &:focus-visible {\n        border: ", " solid\n            ", ';\n    }\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        background: inherit;\n        border: 0;\n        cursor: not-allowed;\n        &:focus-visible {\n            border: ', " solid\n                ", ";\n        }\n    }\n    ", "\n"], ["\n    border-width: ", ";\n    &:focus-visible {\n        border: ", " solid\n            ", ';\n    }\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        background: inherit;\n        border: 0;\n        cursor: not-allowed;\n        &:focus-visible {\n            border: ', " solid\n                ", ";\n        }\n    }\n    ", "\n"])), function (e) {
      return e.theme.tokens.borderWidths.borderWidth0;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return !e.legacy && "\n        width: " + e.theme.tokens.sizings.sizeIcon50 + ";\n        height: " + e.theme.tokens.sizings.sizeIcon50 + ";\n        color: " + e.theme.tokens.textColors.colorTextIconInverse + ";\n        border-radius: " + e.theme.tokens.radii.borderRadius10 + ";\n        &:hover {\n            border: " + e.theme.tokens.borderWidths.borderWidth10 + " solid\n                " + e.theme.tokens.borderColors.colorBorderPrimaryStronger + ";\n            background-color: " + e.theme.tokens.backgroundColors.colorBackgroundPrimaryWeakest + ";\n        }\n        &:focus-visible {\n            border: 0;\n            box-shadow: " + e.theme.tokens.boxShadows.shadowFocus + ";\n            background-color: " + e.theme.tokens.backgroundColors.colorBackgroundPrimaryWeakest + ";\n        }\n    ";
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ToolbarMark = void 0;
    var l = a(n(0)),
      c = n(19),
      u = n(18),
      d = n(37);
    t.ToolbarMark = function (e) {
      var t = e.type,
        n = e.clear,
        o = s(e, ["type", "clear"]),
        i = (0, u.useStoreEditorState)((0, u.useEventEditorId)("focus"));
      return l.createElement(d.ToolbarButton, r({
        active: !!(null == i ? void 0 : i.selection) && (0, c.isMarkActive)(i, t),
        onMouseDown: i ? (0, c.getPreventDefaultHandler)(c.toggleMark, i, t, n) : void 0
      }, o));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      l = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      },
      u = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ToolbarLink = void 0;
    var d = u(n(69)),
      f = n(19),
      p = n(18),
      h = n(49),
      v = a(n(0)),
      m = n(31),
      g = n(114),
      b = n(116),
      y = n(443),
      _ = n(37),
      O = n(444);
    t.ToolbarLink = function (e) {
      e.getLinkUrl;
      var t = c(e, ["getLinkUrl"]),
        n = v.useState(null),
        o = n[0],
        i = n[1],
        a = (0, p.useStoreEditorState)("main"),
        u = v.useRef(),
        C = (0, p.getPlatePluginType)(a, h.ELEMENT_LINK),
        P = !!(null == a ? void 0 : a.selection) && (0, f.someNode)(a, {
          match: {
            type: C
          }
        }),
        M = function (e) {
          var t = e.text,
            n = e.url;
          return s(void 0, void 0, void 0, function () {
            var e, r, o;
            return l(this, function (s) {
              return a ? (e = (0, f.getAbove)(a, {
                at: (0, b.getEditorSelection)(a),
                match: {
                  type: C
                }
              }), t = t || n, r = void 0 !== e && (0, f.isCollapsed)((0, b.getEditorSelection)(a)), o = (0, y.upsertLinkAtSelection)(a, {
                url: n,
                wrap: r,
                text: t
              }), i(null), (0, g.focusOnEditor)(a, o || void 0), [2]) : [2];
            });
          });
        },
        j = function () {
          a && ((0, y.removeLinkFromSelection)(a), i(null));
        };
      return v.createElement(v.Fragment, null, v.createElement(_.StyledPopover, {
        anchorEl: o,
        open: Boolean(o),
        onClose: function (e) {
          a && (e.stopPropagation(), i(null), (0, g.focusOnEditor)(a));
        },
        TransitionComponent: d.default,
        key: "compactViewToolbarPopover",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        disableAutoFocus: !0,
        disableEnforceFocus: !0,
        disableRestoreFocus: !0,
        keepMounted: !1
      }, v.createElement(_.LinkPanelWrapper, null, function (e) {
        var t,
          n = (null === (t = null == e ? void 0 : e[0]) || void 0 === t ? void 0 : t.url) || "";
        return v.createElement(v.Fragment, null, v.createElement(O.ToolbarLinkPanelForm, {
          hideText: !!e,
          url: n,
          onSubmit: M,
          onRemove: j,
          onClose: function () {
            return i(null);
          }
        }));
      }(u.current))), v.createElement(_.ToolbarButton, r({
        active: P || Boolean(o),
        onMouseDown: function (e) {
          if (e.preventDefault(), a) {
            var t = (0, f.getAbove)(a, {
                match: {
                  type: C
                }
              }),
              n = a.selection && !(0, f.isCollapsed)(a.selection) && m.Editor.node(a, a.selection);
            u.current = t || n || void 0, function (e) {
              a && (e.stopPropagation(), i(e.currentTarget), (0, g.focusOnEditor)(a));
            }(e);
          }
        }
      }, t)));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.removeLinkFromSelection = t.upsertLinkAtSelection = void 0;
    var r = n(18),
      o = n(31),
      i = n(116),
      a = n(49),
      s = n(19);
    t.upsertLinkAtSelection = function (e, t) {
      var n = t.url,
        l = void 0 === n ? "" : n,
        c = t.wrap,
        u = t.text,
        d = (0, i.getEditorSelection)(e);
      if (!d) return null;
      var f = (0, r.getPlatePluginType)(e, a.ELEMENT_LINK),
        p = l.match(/^(http(s?):\/\/|#|\/)/) ? l : "https://" + l;
      if (!c && (0, s.isCollapsed)(d)) (0, s.insertNodes)(e, {
        type: f,
        url: p,
        children: [{
          text: u || l
        }]
      }, {
        at: d
      });else {
        if (c && (0, s.isCollapsed)(d)) {
          var h = o.Editor.leaf(e, d)[1];
          o.Transforms.select(e, h);
        } else o.Transforms.select(e, d);
        (0, s.unwrapNodes)(e, {
          at: e.selection,
          match: {
            type: f
          }
        }), (0, a.wrapLink)(e, {
          at: e.selection,
          url: p
        });
      }
      return o.Transforms.collapse(e, {
        edge: "end"
      }), e.selection;
    };
    t.removeLinkFromSelection = function (e) {
      var t = (0, i.getEditorSelection)(e);
      if (t) {
        var n = (0, r.getPlatePluginType)(e, a.ELEMENT_LINK);
        if ((0, s.isCollapsed)(t)) {
          var l = o.Editor.leaf(e, t)[1];
          o.Transforms.select(e, l);
        }
        (0, s.unwrapNodes)(e, {
          at: t,
          match: {
            type: n
          }
        });
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ToolbarLinkPanelForm = void 0;
    var s = i(n(0)),
      l = a(n(117)),
      c = a(n(40)),
      u = n(37),
      d = n(4),
      f = n(2),
      p = n(17);
    t.ToolbarLinkPanelForm = function (e) {
      var t = s.useState(""),
        n = t[0],
        r = t[1],
        o = s.useState(e.url),
        i = o[0],
        a = o[1];
      return s.createElement(s.Fragment, null, s.createElement(u.LinkPanelCloseIcon, {
        onClick: function () {
          return e.onClose();
        }
      }, s.createElement(d.Icon, {
        icon: "Close"
      })), s.createElement(u.LinkPanelTitle, null, f.templates.LinkPanelTitle()), !e.hideText && s.createElement(u.LinkPanelField, null, s.createElement(l.default, {
        htmlFor: "link-panel-text-field"
      }, f.templates.LinkPanelTextLabel()), s.createElement(c.default, {
        fullWidth: !0,
        placeholder: f.templates.LinkPanelTextPlaceholder(),
        value: n,
        id: "link-panel-text-field",
        onChange: function (e) {
          return r(e.target.value);
        }
      })), s.createElement(u.LinkPanelField, null, s.createElement(l.default, {
        htmlFor: "link-panel-link-field"
      }, f.templates.LinkPanelLinkLabel()), s.createElement(c.default, {
        fullWidth: !0,
        placeholder: f.templates.LinkPanelLinkPlaceholder(),
        value: i,
        id: "link-panel-link-field",
        onChange: function (e) {
          return a(e.target.value);
        }
      })), s.createElement(u.LinkPanelButtonsContainer, null, s.createElement(p.Button, {
        variant: "primary",
        size: "small",
        disabled: !i,
        type: "button",
        onClick: function () {
          e.onSubmit({
            text: n,
            url: i
          });
        }
      }, f.templates.LinkPanelApplyButtonLabel()), s.createElement(p.Button, {
        variant: "link",
        disabled: !e.url,
        size: "small",
        onClick: function () {
          return e.onRemove();
        },
        type: "button"
      }, f.templates.LinkPanelRemoveButtonLabel())));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ToolbarList = void 0;
    var l = a(n(0)),
      c = n(19),
      u = n(18),
      d = n(50),
      f = n(446);
    t.ToolbarList = function (e) {
      var t = e.type,
        n = void 0 === t ? d.ELEMENT_UL : t,
        o = s(e, ["type"]),
        i = (0, u.useStoreEditorState)((0, u.useEventEditorId)("focus"));
      return l.createElement(f.ToolbarElement, r({
        type: n,
        onMouseDown: i && (0, c.getPreventDefaultHandler)(d.toggleList, i, {
          type: n
        })
      }, o));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ToolbarElement = void 0;
    var l = a(n(0)),
      c = n(19),
      u = n(18),
      d = n(37);
    t.ToolbarElement = function (e) {
      var t = e.type,
        n = e.inactiveType,
        o = s(e, ["type", "inactiveType"]),
        i = (0, u.useStoreEditorState)((0, u.useEventEditorId)("focus"));
      return l.createElement(d.ToolbarButton, r({
        active: !!(null == i ? void 0 : i.selection) && (0, c.someNode)(i, {
          match: {
            type: t
          }
        }),
        onMouseDown: i && (0, c.getPreventDefaultHandler)(c.toggleNodeType, i, {
          activeType: t,
          inactiveType: n
        })
      }, o));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.findFirstAvailablePath = void 0;
    var r = function (e, t, n) {
      void 0 === n && (n = []);
      var o = t ? e.length - 1 : 0;
      if (!e) return {
        path: [0, 0],
        offset: 0
      };
      n.push(o);
      var i = e[o].text;
      if (void 0 !== i) return {
        path: n,
        offset: t ? null == i ? void 0 : i.length : 0
      };
      var a = e[o];
      return r(a.children, t, n);
    };
    t.findFirstAvailablePath = function (e, t) {
      var n = r(e, t);
      return {
        anchor: n,
        focus: n
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.useSlateRef = void 0;
    var r = n(0),
      o = n(18);
    t.useSlateRef = function () {
      var e = (0, o.usePlateStore)(),
        t = (0, r.useRef)(null == e ? void 0 : e.main);
      return (0, r.useEffect)(function () {
        t.current = null == e ? void 0 : e.main;
      }, [e]), t;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailMessageItemChildrenProps = t.EmailMessageItem = void 0;
    var r = n(118);
    Object.defineProperty(t, "EmailMessageItem", {
      enumerable: !0,
      get: function () {
        return r.EmailMessageItem;
      }
    });
    var o = n(468);
    Object.defineProperty(t, "EmailMessageItemChildrenProps", {
      enumerable: !0,
      get: function () {
        return o.EmailMessageItemChildrenProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Content = t.displayName = t.EmailMessageItemImpl = t.Body = void 0;
    var l = n(29),
      c = n(119),
      u = i(n(0)),
      d = n(28),
      f = n(7),
      p = n(11),
      h = n(9),
      v = n(1),
      m = n(102),
      g = n(451),
      b = n(456),
      y = n(460),
      _ = n(120);
    t.Body = function (e) {
      var t,
        n = e.message,
        r = e.conversationSid,
        o = (0, l.useTheme)(),
        i = u.useState(!1),
        a = i[0],
        s = i[1],
        d = n.bodyAttachment || "",
        f = (null === (t = n.source) || void 0 === t ? void 0 : t.body) || "",
        p = n.source.getEmailBody("text/html"),
        h = [];
      try {
        h = n.source.getMediaByCategory(["media"]);
      } catch (e) {}
      return u.createElement(_.BodyComponent, {
        "data-test": "email-message-body"
      }, (!a || a && !d) && f, d && u.createElement(_.HTMLWrapper, {
        isLoading: !a
      }, u.createElement(g.SeamlessIframe, {
        interceptLinkClicks: !0,
        sanitizedHtml: ['<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&amp;display=swap">', (0, c.sanitize)(d)].join(""),
        onLoadCallback: function () {
          return s(!0);
        },
        customStyle: "\n                            html {\n                                overflow:hidden;\n                            }\n                            body {\n                                font-family: " + o.tokens.fonts.fontFamilyText + ";\n                                font-size: " + o.tokens.fontSizes.fontSize30 + ";\n                                -webkit-font-smoothing: antialiased;\n                                -moz-osx-font-smoothing: grayscale;\n                                line-height: " + o.tokens.lineHeights.lineHeight30 + ";\n                                margin: 0;\n                                overflow: auto;\n                                " + (p ? "" : "\n                                    word-break: break-word;\n                                    white-space: pre-line;\n                                    ") + "\n                                color: " + o.tokens.textColors.colorText + ";\n                                background: " + o.tokens.backgroundColors.colorBackgroundBody + ";\n                            }\n                            a {\n                                color: " + o.tokens.textColors.colorTextLink + ";\n                            }\n                            p {\n                               margin-top:0;\n                               margin-bottom:0;\n                            }\n                            " + (0, v.rootStyleObjectToString)(o.Chat.EmailMessageItem.Body.Iframe) + "\n                        "
      })), h && h.length > 0 && u.createElement(_.EmailFileContainer, null, h.map(function (e) {
        return u.createElement(b.EmailFileAttachment, {
          message: n,
          media: e,
          conversationSid: r,
          key: e.sid,
          disabled: !1
        });
      })));
    };
    t.EmailMessageItemImpl = function (e) {
      var n = d.ChatManager.isOrganicMessageSortingDisabled();
      return u.createElement(f.DynamicComponent, {
        contentStore: t.Content,
        name: t.displayName,
        childProps: e,
        noContainers: !0,
        rootContainerStyles: "\n                overflow: visible;\n                min-width: 0;\n            "
      }, u.createElement(_.Wrapper, {
        disableOrganicMessageSorting: n
      }, u.createElement(m.EmailAccordion, {
        key: "accordion",
        defaultOpen: e.defaultOpen,
        onToggle: function (t) {
          return a(void 0, void 0, void 0, function () {
            var n, r;
            return s(this, function (o) {
              switch (o.label) {
                case 0:
                  return !t || e.message.bodyAttachment ? [3, 3] : (n = void 0, (r = e.message.source.getEmailBody("text/html") || e.message.source.getEmailBody("text/plain")) ? [4, (0, h.fetchMediaContent)(r, "email body")] : [3, 2]);
                case 1:
                  n = o.sent(), o.label = 2;
                case 2:
                  n && p.Actions.addMessageBody(e.message.source, n), o.label = 3;
                case 3:
                  return [2];
              }
            });
          });
        },
        header: u.createElement(y.EmailMessageHeader, {
          message: e.message,
          participants: e.participants,
          avatarUrl: e.avatarUrl,
          conversationBindings: e.conversationBindings
        }),
        body: u.createElement(t.Body, {
          message: e.message,
          conversationSid: e.conversationSid
        }),
        accordionId: e.message.source.sid
      })));
    }, t.displayName = "EmailMessageItem", t.Content = new f.DynamicContentStore(t.displayName);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SeamlessIframe = void 0;
    var r = n(452);
    Object.defineProperty(t, "SeamlessIframe", {
      enumerable: !0,
      get: function () {
        return r.SeamlessIframe;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SeamlessIframe = void 0;
    var s = a(n(0)),
      l = n(9),
      c = n(51),
      u = n(453),
      d = n(454),
      f = n(455),
      p = function (e) {
        return "<script>" + e + "<\/script>";
      },
      h = function (e) {
        var t = e.customStyle,
          n = e.customOuterStyleObject,
          o = e.sanitizedHtml,
          i = e.customScript,
          a = e.interceptLinkClicks,
          h = e.preventIframeNavigation,
          v = e.customLinkClickCallback,
          m = e.customIframeNavigationInterceptedView,
          g = e.title,
          b = e.heightCorrection,
          y = e.onLoadCallback,
          _ = (0, s.useRef)(!1),
          O = (0, s.useState)(0),
          C = O[0],
          P = O[1],
          M = (0, s.useState)({
            preventing: !1,
            buffering: !1
          }),
          j = M[0],
          w = M[1],
          E = (0, s.useState)(l.Utils.getRandomValue())[0],
          S = t ? "<style>" + t + "</style>" : "",
          x = b ? p((0, f.renderResizeScript)(E, e)) : "",
          T = a ? p((0, d.getListenToLinksScript)(E)) : "",
          A = h ? p((0, u.getInterceptNavigationScript)(E)) : "",
          I = i ? p(i) : "",
          k = (0, s.useCallback)(function (e) {
            var t,
              n = "",
              r = "",
              o = "",
              i = "";
            if (e.data) {
              try {
                n = (t = JSON.parse(e.data).split("///"))[0], r = t[1], o = t[2], i = t[3];
              } catch (e) {}
              var s;
              if (n === c.POST_MESSAGE_IDENTIFIER) if (Number(r) === E) return o === c.HEIGHT_MESSAGE ? (P(Number(i)), void (_.current || (_.current = !0, y && y()))) : o === c.LINK_CLICK_MESSAGE && a ? v ? void v(i) : (s = i, void (window.confirm('Are you sure you want to open "' + s + '"?') && window.open(s, "_blank", "noopener noreferrer"))) : void (o === c.NAVIGATION_INTERCEPTED_MESSAGE && h && w({
                preventing: !1,
                buffering: !0
              }));
            }
          }, [j]);
        return (0, s.useEffect)(function () {
          return window.addEventListener("message", k), j.buffering && setTimeout(function () {
            w({
              preventing: !0,
              buffering: !1
            });
          }, 300), function () {
            return window.removeEventListener("message", k);
          };
        }, [k]), j.buffering ? s.default.createElement("div", {
          style: {
            height: C
          },
          "data-buffering": ""
        }) : j.preventing ? m || s.default.createElement("div", {
          style: {
            height: 300,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "5px solid #ccc",
            justifyContent: "center"
          }
        }, s.default.createElement("p", null, "This iframe is trying to navigate away."), s.default.createElement("button", {
          type: "button",
          onClick: function () {
            return w({
              preventing: !1,
              buffering: !1
            });
          }
        }, "Reload")) : s.default.createElement("iframe", {
          style: r({
            border: "none",
            width: "100%"
          }, n),
          sandbox: "allow-scripts",
          src: "data:text/html",
          title: g,
          srcDoc: "" + A + S + (o || "") + x + T + I,
          height: C
        });
      };
    t.SeamlessIframe = h, h.defaultProps = {
      heightCorrection: !0,
      heightCorrectionOnResize: !0,
      debounceResizeTime: 250,
      inheritParentStyle: !0,
      customStyle: "\n    body {\n      margin: 0;\n      padding: 0;\n    }\n  ",
      customOuterStyleObject: {},
      listenToLinkClick: !1,
      preventIframeNavigation: !1,
      title: ""
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getInterceptNavigationScript = void 0;
    var r = n(51);
    t.getInterceptNavigationScript = function (e) {
      return '\n{\n    const validatedMessage = () => JSON.stringify("' + r.POST_MESSAGE_IDENTIFIER + "///" + e + "///" + r.NAVIGATION_INTERCEPTED_MESSAGE + '///nope");\n    window.addEventListener("beforeunload", (e) => {\n      e.preventDefault();\n      parent.postMessage(validatedMessage(), "' + window.location.href + '");\n    });\n}\n';
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getListenToLinksScript = void 0;
    var r = n(51);
    t.getListenToLinksScript = function (e) {
      return '\n  {\n    const validatedMessage = (url) => JSON.stringify("' + r.POST_MESSAGE_IDENTIFIER + "///" + e + "///" + r.LINK_CLICK_MESSAGE + '///"+url);\n    const postMessage = (url) => parent.postMessage(validatedMessage(url), "' + window.location.href + '");\n    const listenToLinks = Array.from(document.querySelectorAll("a")).forEach(a => {\n        a.addEventListener("click", (e) => {\n          postMessage(a.getAttribute("href"));\n          return e.preventDefault();\n        });\n      });\n    window.addEventListener("load", listenToLinks);\n  }\n';
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.renderResizeScript = void 0;
    var r = n(51);
    t.renderResizeScript = function (e, t) {
      if (!t.heightCorrection) return "";
      var n = '\n    const validatedMessage = () => JSON.stringify("' + r.POST_MESSAGE_IDENTIFIER + "///" + e + "///" + r.HEIGHT_MESSAGE + '///"+document.documentElement.offsetHeight);\n    window.__seamlessHeightLoad = () => parent.postMessage(validatedMessage(), "' + window.location.href + '");\n    window.addEventListener("load", window.__seamlessHeightLoad);\n  ';
      return t.heightCorrectionOnResize ? (t.debounceResizeTime ? n += '\n        function debounce(func, wait, immediate) {\n            var timeout;\n            return function() {\n                var context = this, args = arguments;\n                var later = function() {\n                    timeout = null;\n                    if (!immediate) func.apply(context, args);\n                };\n                var callNow = immediate && !timeout;\n                clearTimeout(timeout);\n                timeout = setTimeout(later, wait);\n                if (callNow) func.apply(context, args);\n            };\n        };\n        window.__seamlessHeightResize = debounce(() => {\n            parent.postMessage(validatedMessage(), "' + window.location.href + '")\n        }, ' + t.debounceResizeTime + ");\n" : n += '\n        window.__seamlessHeightResize = () => {\n            parent.postMessage(validatedMessage(), "' + window.location.href + '")\n        };\n    ', n + 'window.addEventListener("resize", window.__seamlessHeightResize);') : n;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailFileAttachment = void 0;
    var l = s(n(0)),
      c = n(33),
      u = n(36),
      d = n(10),
      f = n(2),
      p = n(42),
      h = n(48),
      v = n(120),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            hover: !1
          }, t.downloadMedia = function (e, n) {
            return function () {
              var r = t.props,
                o = r.message,
                i = r.conversationSid;
              n || o.isSending || (0, u.tryInvokeAction)("DownloadMedia", {
                media: e,
                conversationSid: i
              });
            };
          }, t.toggleHover = function () {
            t.setState(function (e) {
              return {
                hover: !e.hover
              };
            });
          }, t;
        }
        return o(t, e), t.prototype.getDataStatus = function (e) {
          return e.error ? "EmailFileAttachment-Error" : e.isSending ? "EmailFileAttachment-Sending" : !e.isSending && e.isFromMe ? "EmailFileAttachment-Sent" : "EmailFileAttachment-Received";
        }, t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.message,
            r = t.media,
            o = t.disabled;
          return l.createElement(c.ActionStateListener, {
            action: "DownloadMedia"
          }, function (t) {
            return l.createElement(v.MediaMessageContainer, {
              className: "Twilio-Media-EmailFileAttachment",
              onClick: e.downloadMedia(r, t.disabled || o),
              disabled: o,
              "data-test": e.getDataStatus(n),
              onMouseEnter: e.toggleHover,
              onMouseLeave: e.toggleHover
            }, l.createElement(h.FilePreview, {
              file: {
                name: r.filename,
                size: r.size,
                type: r.contentType
              },
              iconOverride: n.isSending && l.createElement(p.CircularProgress, {
                size: 26,
                animating: !0,
                override: {
                  animatingBackgroundBorderColor: "transparent"
                }
              }),
              subTitleLine: e.state.hover && !o && !n.isSending && l.createElement(d.Template, {
                source: f.templates.MediaMessageClickToOpen
              })
            }), l.createElement(v.MediaMessageActions, {
              isVisible: e.state.hover,
              className: "Twilio-Media-EmailFileAttachment-Action"
            }, l.createElement(v.LinkExternalIcon, {
              icon: "Open"
            })));
          });
        }, t;
      }(l.PureComponent);
    t.EmailFileAttachment = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CircularProgress = void 0;
    var l = n(5),
      c = a(n(0)),
      u = n(458);
    t.CircularProgress = function (e) {
      void 0 === e && (e = {
        override: {},
        size: 124,
        borderWidth: 2,
        opacity: 1
      });
      var t = e.className,
        n = s(e, ["className"]);
      return c.createElement(u.StyledCircularProgress, r({
        className: (0, l.cx)("Twilio-Progress", t)
      }, n));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledCircularProgress = t.getOverriddenPropIfAvailable = void 0;
    var i = n(47),
      a = n(1);
    t.getOverriddenPropIfAvailable = function (e, t) {
      return e.override && e.override[t] || e.theme.Progress.Circular[t];
    };
    var s,
      l = function (e) {
        return (0, t.getOverriddenPropIfAvailable)(e, "animatingForegroundBorderColor");
      };
    t.StyledCircularProgress = a.styled.div(s || (s = r(["\n    display: inline-block;\n    position: relative;\n    width: ", ";\n    height: ", ';\n\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-width: ', ";\n        border-style: solid;\n        border-radius: 50%;\n        border-color: ", ';\n        box-sizing: border-box;\n    }\n\n    &:after {\n        content: "";\n        border-width: ', ";\n        border-style: solid;\n        border-color: ", " transparent transparent ", ";\n        border-radius: 100% 0 0 0;\n        box-sizing: border-box;\n        display: ", ";\n        width: 50%;\n        height: 50%;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    ", "\n\n    ", "\n"], ["\n    display: inline-block;\n    position: relative;\n    width: ", ";\n    height: ", ';\n\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-width: ', ";\n        border-style: solid;\n        border-radius: 50%;\n        border-color: ", ';\n        box-sizing: border-box;\n    }\n\n    &:after {\n        content: "";\n        border-width: ', ";\n        border-style: solid;\n        border-color: ", " transparent transparent ", ";\n        border-radius: 100% 0 0 0;\n        box-sizing: border-box;\n        display: ", ";\n        width: 50%;\n        height: 50%;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    ", "\n\n    ", "\n"])), function (e) {
      return e.size + "px";
    }, function (e) {
      return e.size + "px";
    }, function (e) {
      return e.borderWidth + "px";
    }, function (e) {
      return e.animating ? (0, t.getOverriddenPropIfAvailable)(e, "animatingBackgroundBorderColor") : (0, t.getOverriddenPropIfAvailable)(e, "staticBackgroundBorderColor");
    }, function (e) {
      return e.borderWidth + "px";
    }, l, l, function (e) {
      return e.animating ? "initial" : "none";
    }, function (e) {
      var t = e.theme.Progress.Circular;
      t.staticBackgroundBorderColor, t.animatingBackgroundBorderColor, t.animatingForegroundBorderColor;
      return o(t, ["staticBackgroundBorderColor", "animatingBackgroundBorderColor", "animatingForegroundBorderColor"]);
    }, function (e) {
      return e.animating && i.Animations.SpinAnimation(.8);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      l = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailMessageHeader = void 0;
    var c = n(29),
      u = l(n(69)),
      d = n(119),
      f = i(n(0)),
      p = n(7),
      h = n(24),
      v = n(10),
      m = n(9),
      g = n(71),
      b = n(467),
      y = function (e) {
        return e.replace(/\+[^@]*/, "");
      };
    t.EmailMessageHeader = function (e) {
      var n = e.message,
        r = e.participants,
        o = e.conversationBindings,
        i = void 0 === o ? {} : o,
        l = i.projected_address,
        _ = i.name,
        O = n.isFromMe,
        C = n.source,
        P = C.subject,
        M = C.body,
        j = C.participantSid,
        w = C.dateCreated,
        E = (0, c.useTheme)(),
        S = f.useState(null),
        x = S[0],
        T = S[1],
        A = function (e) {
          e.stopPropagation(), T(null);
        },
        I = function (e) {
          var t,
            n,
            r = null === (n = null === (t = e.source.bindings) || void 0 === t ? void 0 : t.email) || void 0 === n ? void 0 : n.address;
          return r || (!O && l ? y(l) : "");
        },
        k = function (e) {
          var t,
            n,
            r = null === (n = null === (t = null == e ? void 0 : e.source.bindings) || void 0 === t ? void 0 : t.email) || void 0 === n ? void 0 : n.name;
          return r || O || !_ || (r = _), r ? r + " - " : "";
        },
        N = Array.from(r.values()).filter(function (e) {
          return e.source.sid !== j;
        }).map(function (e) {
          return {
            sid: e.source.sid,
            name: k(e),
            address: I(e)
          };
        }),
        B = Array.from(r.values()).filter(function (e) {
          return e.source.sid === j;
        }).map(function (e) {
          return {
            sid: e.source.sid,
            name: k(e),
            address: I(e)
          };
        })[0],
        D = v.templates.EmailFrom() + " " + (n.authorName && l ? y(l) : n.source.author),
        L = n.source,
        z = L.getEmailHistory("text/html");
      return f.createElement(p.DynamicComponent, {
        name: t.EmailMessageHeader.friendlyName,
        contentStore: t.EmailMessageHeader.Content,
        noContainers: !0,
        rootContainerStyles: "\n                overflow: visible;\n            "
      }, f.createElement(b.MessageHeader, {
        isOpen: e.isOpen
      }, f.createElement(b.AvatarContainer, {
        key: "avatar-container"
      }, f.createElement(g.Avatar, {
        key: "avatar",
        avatarUrl: e.avatarUrl,
        message: {},
        messageStyle: "Rounded",
        sizeMultiplier: 1.5
      })), f.createElement(b.Details, {
        key: "details"
      }, f.createElement("div", {
        key: "heading"
      }, f.createElement(b.DetailsFirstLine, null, f.createElement(b.SubjectLine, {
        "data-test": "email-message-subject"
      }, P), f.createElement(b.DateContainer, null, w.toLocaleString())), f.createElement(b.DetailsSecondLine, {
        title: D,
        "data-test": "email-from"
      }, D)), !e.isOpen && f.createElement(b.Preview, {
        key: "preview"
      }, M)), f.createElement(b.MoreActionsMenuContainer, {
        key: "more-actions-container"
      }, f.createElement(b.MoreActionsButton, {
        key: "moreActionsButton",
        icon: "More",
        sizeMultiplier: 1,
        title: v.templates.EmailMessageActionsButtonAriaLabel(),
        "aria-label": v.templates.EmailMessageActionsButtonAriaLabel(),
        "data-test": "email-more-actions",
        onClick: function (e) {
          e.stopPropagation(), T(e.currentTarget);
        }
      }), f.createElement(b.StyledPopover, {
        anchorEl: x,
        open: Boolean(x),
        onClose: A,
        TransitionComponent: u.default,
        key: "moreActionsPopover",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        }
      }, f.createElement(b.MoreActionsInnerContainer, {
        "aria-label": v.templates.EmailMessageActionsNavAriaLabel()
      }, f.createElement(b.StyledActionItem, {
        "data-test": "full-thread",
        "aria-disabled": !z,
        onClick: function (e) {
          return h.TelemetryBridge.emit(h.TelemetryBridgeMessageType.UI_INTERACTION_EVENT, {
            name: "view_full_thread_clicked",
            category: "email",
            status: "complete"
          }), A(e), function (e) {
            var t = e.event,
              n = e.message,
              r = e.theme,
              o = e.author;
            return a(void 0, void 0, void 0, function () {
              var e, i, a, l, c, u;
              return s(this, function (s) {
                switch (s.label) {
                  case 0:
                    return t.stopPropagation(), (e = n.getEmailHistory("text/html")) ? (i = window.open("", "flexEmailThread", "menubar=no,width=640,height=800")) ? (l = '\n            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&amp;display=swap">\n            <style>' + (0, b.getThreadWindowStyle)(r) + "</style>", c = '<button onclick="window.close()" class="flex-button">Back to Flex</button>', u = v.templates.EmailThreadDetails({
                      message: n,
                      dateCreated: new Date(n.dateCreated).toLocaleString(),
                      author: o
                    }), i.document.title = v.templates.EmailThreadWindowTitle({
                      message: n
                    }), i.document.body.innerHTML = "" + l + v.templates.EmailLoadingThreadPlaceholder(), [4, (0, m.fetchMediaContent)(e, "email thread content")]) : [3, 2] : [2];
                  case 1:
                    a = s.sent(), i.document.body.innerHTML = a ? l + "\n            " + c + "\n            " + u + "\n            " + (0, d.sanitize)(a) : "" + l + c + v.templates.EmailLoadingThreadError(), s.label = 2;
                  case 2:
                    return [2];
                }
              });
            });
          }({
            event: e,
            message: L,
            theme: E,
            recipients: N,
            author: B
          });
        }
      }, z ? v.templates.EmailViewThread() : v.templates.EmailThreadNotAvailable()))))));
    }, t.EmailMessageHeader.friendlyName = "EmailMessageHeader", t.EmailMessageHeader.Content = new p.DynamicContentStore(t.EmailMessageHeader.friendlyName);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledAvatarDiv = t.AvatarLine = void 0;
    var o,
      i,
      a = n(1);
    t.AvatarLine = (0, a.styled)("div")(o || (o = r(["\n    width: 4px;\n    flex: 1 1 auto;\n    margin-left: 12px;\n    margin-right: 0px;\n\n    ", "\n"], ["\n    width: 4px;\n    flex: 1 1 auto;\n    margin-left: 12px;\n    margin-right: 0px;\n\n    ", "\n"])), function (e) {
      return e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Bubble : e.theme.Chat.MessageListItem.FromOthers.Bubble;
    }), t.StyledAvatarDiv = (0, a.styled)("div")(i || (i = r(["\n    display: flex;\n    align-self: end;\n    width: ", ";\n    height: ", ";\n    justify-content: center;\n    margin-right: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n\n    img {\n        width: 36px;\n        height: 36px;\n    }\n\n    ", "\n\n    background: ", ";\n"], ["\n    display: flex;\n    align-self: end;\n    width: ", ";\n    height: ", ";\n    justify-content: center;\n    margin-right: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n\n    img {\n        width: 36px;\n        height: 36px;\n    }\n\n    ", "\n\n    background: ", ";\n"])), function (e) {
      return 24 * e.sizeMultiplier + "px";
    }, function (e) {
      return 24 * e.sizeMultiplier + "px";
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return "Rounded" === e.messageStyle || "Wide" === e.messageStyle ? "18px" : "0px";
    }, function (e) {
      return e.theme.Chat.MessageListItem.FromOthers.Avatar;
    }, function (e) {
      var t, n;
      return (null === (t = e.message) || void 0 === t ? void 0 : t.isFromMe) || (null === (n = e.message) || void 0 === n ? void 0 : n.groupWithNext) ? "transparent" : void 0;
    }), t.StyledAvatarDiv.defaultProps = {
      sizeMultiplier: 1
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubble = void 0;
    var c = l(n(0)),
      u = n(30),
      d = n(8),
      f = n(463),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = h;
          return c.createElement(e, i({}, this.props));
        }, t.displayName = f.displayName, t.Content = f.contentStore, t;
      }(c.PureComponent);
    t.MessageBubble = p;
    var h = (0, u.connect)(function (e, t) {
      var n,
        r = t.message.source,
        o = r.author,
        i = r.conversation,
        a = r.participantSid,
        s = r.channel,
        l = d.ChatModule.stateCallback(e),
        c = l.users[o];
      return {
        participant: t.participant || l.conversations[i.sid].participants.get(o) || l.conversations[i.sid].participants.get(a) || {
          friendlyName: !!c && c.friendlyName || o,
          source: void 0
        },
        member: t.member || (null === (n = l.channels[null == s ? void 0 : s.sid]) || void 0 === n ? void 0 : n.members.get(o)) || {
          friendlyName: !!c && c.friendlyName || o,
          source: void 0
        },
        isParticipantOfConversation: "joined" === (null == i ? void 0 : i.status),
        isMemberOfChannel: "joined" === (null == i ? void 0 : i.status)
      };
    })(f.MessageBubbleImpl);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubbleImpl = t.contentStore = t.displayName = void 0;
    var u = l(n(0)),
      d = n(7),
      f = n(25),
      p = n(20),
      h = n(3),
      v = n(95),
      m = n(10),
      g = n(2),
      b = n(9),
      y = n(73),
      _ = n(464);
    t.displayName = "MessageBubble", t.contentStore = new f.DynamicContentStore(t.displayName);
    var O = function (e) {
        var t = e.children,
          n = c(e, ["children"]);
        return u.createElement("a", i({}, n, {
          target: "_blank"
        }), t);
      },
      C = function (e) {
        return function (t) {
          var n = t.children,
            r = c(t, ["children"]);
          return u.createElement(y.StyledBlockQuote, i({}, r, {
            message: e
          }), n);
        };
      },
      P = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.renderBody = function () {
          var e,
            t = this.props,
            n = t.message,
            r = t.conversationSid,
            o = t.hasMarkdownSupport,
            i = t.inFocus,
            a = null;
          "media" === n.source.type && (a = (0, p.isFileAttachmentEnabled)(r) ? u.createElement(y.MediaContainer, null, null === (e = n.source.attachedMedia) || void 0 === e ? void 0 : e.map(function (e) {
            return u.createElement(_.MessageBubbleMedia, {
              key: "" + e.sid,
              inFocus: i,
              media: e,
              message: n,
              conversationSid: r
            });
          })) : u.createElement(y.MediaMessageErrorContainer, {
            key: "media-error"
          }, u.createElement(m.Template, {
            source: g.templates.MediaMessageError,
            className: "MediaMessageError"
          })));
          var s = n.source.body || "";
          return u.createElement(y.BodyContainer, {
            key: "body",
            className: "Twilio-MessageBubble-Body",
            "data-test": "message-body"
          }, o ? u.createElement(v.Markdown, {
            options: {
              disableParsingRawHTML: !0,
              overrides: {
                a: O,
                blockquote: C(n)
              }
            }
          }, b.Utils.parseMDText(s)) : u.createElement(u.Fragment, null, b.Utils.parseText(s)), a);
        }, n.prototype.render = function () {
          var e = this.props,
            n = e.participant,
            r = e.message,
            o = e.messageStyle,
            i = e.useFriendlyName,
            a = e.authorName,
            s = e.inFocus,
            l = b.Utils.getNameForMember(i, a, n.friendlyName, r.source.author),
            c = r.source.dateCreated,
            f = null == c ? void 0 : c.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit"
            });
          try {
            this.props.timestampFormatter && c && (f = this.props.timestampFormatter(c));
          } catch (e) {
            h.log.warn("Unable to format timestamp. Falling back to original implementation.", e);
          }
          return u.createElement(d.DynamicComponent, {
            contentStore: t.contentStore,
            childProps: this.props,
            name: t.displayName,
            customChildren: this.props.children,
            vertical: !0,
            rootContainerStyles: "> :first-child {\n                    overflow: visible;\n                };"
          }, u.createElement(y.Container, {
            message: r,
            messageStyle: o,
            inFocus: s
          }, u.createElement(y.HeaderContainer, {
            key: "header",
            className: "Twilio-MessageBubble-Header",
            message: r,
            messageStyle: o
          }, u.createElement(y.UserNameContainer, {
            className: "Twilio-MessageBubble-UserName",
            "data-test": "message-sendername"
          }, l), f && u.createElement(y.TimeContainer, {
            className: "Twilio-MessageBubble-Time"
          }, f)), this.renderBody()));
        }, n.defaultProps = {
          useFriendlyName: !0
        }, n;
      }(u.PureComponent);
    t.MessageBubbleImpl = P;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubbleMedia = void 0;
    var l = n(123),
      c = s(n(0)),
      u = n(33),
      d = n(8),
      f = n(36),
      p = n(10),
      h = n(2),
      v = n(42),
      m = n(48),
      g = n(4),
      b = n(73),
      y = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            hover: !1
          }, t.downloadMedia = function (e) {
            return function () {
              var n = t.props,
                r = n.message,
                o = n.conversationSid,
                i = n.media;
              r.isSending || (null == r ? void 0 : r.error) || e || (d.ChatModule.events.emitMediaDownloaded(o), (0, f.tryInvokeAction)("DownloadMedia", {
                media: i,
                conversationSid: o,
                channelSid: o
              }));
            };
          }, t.toggleHover = function () {
            t.setState(function (e) {
              return {
                hover: !e.hover
              };
            });
          }, t;
        }
        return o(t, e), t.prototype.getDataStatus = function (e) {
          return e.error ? "MediaMessageBubble-Error" : e.isSending ? "MediaMessageBubble-Sending" : !e.isSending && e.isFromMe ? "MediaMessageBubble-Sent" : "MediaMessageBubble-Received";
        }, t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.message,
            r = t.media,
            o = t.inFocus,
            i = {
              name: r.filename || r && "unnamed." + (0, l.extension)(r.contentType),
              size: r.size,
              type: r.contentType
            };
          return c.createElement(u.ActionStateListener, {
            action: "DownloadMedia"
          }, function (t) {
            return c.createElement(b.MediaMessageContainer, {
              className: "Twilio-Media-MessageBubble",
              onClick: e.downloadMedia(t.disabled),
              "aria-disabled": !!(null == n ? void 0 : n.error),
              message: n,
              "data-test": e.getDataStatus(n),
              onMouseEnter: e.toggleHover,
              onMouseLeave: e.toggleHover,
              role: "link",
              tabIndex: Boolean(o) ? 0 : -1
            }, c.createElement(m.FilePreview, {
              file: i,
              iconOverride: n.isSending && c.createElement(v.CircularProgress, {
                size: 26,
                animating: !0,
                override: {
                  animatingBackgroundBorderColor: "transparent"
                }
              }),
              subTitleLine: e.state.hover && !(null == n ? void 0 : n.error) && !n.isSending && c.createElement(p.Template, {
                source: h.templates.MediaMessageClickToOpen
              }),
              isBubble: !0,
              isFromMe: n.isFromMe
            }), c.createElement(b.MediaMessageActions, {
              message: n,
              className: "Twilio-Media-MessageBubble-Action"
            }, c.createElement(g.Icon, {
              icon: "Open"
            })));
          });
        }, t;
      }(c.PureComponent);
    t.MessageBubbleMedia = y;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListItemImpl = t.store = t.displayName = void 0;
    var c = l(n(0)),
      u = n(7),
      d = n(11),
      f = n(10),
      p = n(2),
      h = n(6),
      v = n(4),
      m = n(72),
      g = n(121),
      b = n(124);
    t.displayName = "MessageListItem", t.store = new u.DynamicContentStore(t.displayName);
    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          isActiveElement: !1,
          isMouseDown: !1
        }, t.messageRef = c.createRef(), t.handleKeyDown = function (e) {
          var n = t.props,
            r = n.message,
            o = n.updateFocus;
          if ("ArrowUp" === e.key || "ArrowDown" === e.key) {
            var i = r.index + ("ArrowUp" === e.key ? -1 : 1);
            o && o(i);
          }
        }, t;
      }
      return o(n, e), n.prototype.renderErrorStatus = function () {
        var e = this.props.message,
          t = c.createElement(f.Template, {
            source: p.templates.MediaMessageTransferFailed
          });
        return e.deliveryStatus === d.DeliveryStatus.Undelivered ? t = c.createElement(f.Template, {
          source: p.templates.MessageDeliveryUnDelivered
        }) : e.deliveryStatus === d.DeliveryStatus.Failed && (t = c.createElement(f.Template, {
          source: p.templates.MessageDeliveryFailed
        })), c.createElement(b.MediaErrorContainer, {
          key: "media-transfer-error",
          className: "Twilio-MessageListItem-MediaMessageError",
          "data-test": "delivery-failed-error"
        }, c.createElement(v.Icon, {
          icon: "AlertError",
          sizeMultiplier: .67
        }), t);
      }, n.prototype.handleFocus = function () {
        var e = this.props,
          t = e.message,
          n = e.updateFocus;
        this.state.isMouseDown || (this.setState({
          isActiveElement: !0
        }), n && n(t.index));
      }, n.prototype.handleBlur = function () {
        this.setState({
          isActiveElement: !1
        });
      }, n.prototype.handleMouseDown = function () {
        this.setState({
          isMouseDown: !0
        });
      }, n.prototype.handleMouseUp = function () {
        this.setState({
          isMouseDown: !1
        });
      }, n.prototype.componentDidUpdate = function (e) {
        var t;
        this.props.focusable && e.focusable !== this.props.focusable && (null === (t = this.messageRef.current) || void 0 === t || t.focus());
      }, n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.message,
          o = n.messageStyle,
          a = n.avatarUrl,
          s = n.hasMarkdownSupport,
          l = n.showReadStatus,
          d = n.focusable;
        return c.createElement(u.DynamicComponent, {
          contentStore: t.store,
          childProps: i({}, this.props),
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0,
          rootContainerStyles: "\n                > :first-child {\n                    overflow: visible;\n                };"
        }, c.createElement(b.Container, {
          className: "Twilio-MessageListItem",
          message: r,
          messageStyle: o,
          role: "listitem"
        }, c.createElement(h.FlexBox, {
          key: "content",
          className: "Twilio-MessageListItem-ContentContainer"
        }, "Wide" !== o && c.createElement(h.FlexBox, {
          className: "Twilio-MessageListItem-AvatarContainer",
          noGrow: !0
        }, c.createElement(g.Avatar, {
          avatarUrl: a,
          messageStyle: o,
          message: r
        })), c.createElement(b.BubbleContainer, {
          className: "Twilio-MessageListItem-BubbleContainer",
          isFromMe: r.isFromMe,
          messageStyle: o,
          tabIndex: Boolean(d) ? 0 : -1,
          onFocus: function () {
            return e.handleFocus();
          },
          onBlur: function () {
            return e.handleBlur();
          },
          onMouseDown: function () {
            return e.handleMouseDown();
          },
          onMouseUp: function () {
            return e.handleMouseUp();
          },
          onKeyDown: function (t) {
            return e.handleKeyDown(t);
          },
          ref: this.messageRef,
          "data-message-item": !0
        }, c.createElement(m.MessageBubble, i({}, this.props, {
          inFocus: Boolean(d && this.state.isActiveElement),
          hasMarkdownSupport: s
        })), "Squared" === o && !r.groupWithNext && c.createElement(b.StyledSpike, {
          reverse: r.isFromMe
        }))), r.error && this.renderErrorStatus(), !r.error && l && c.createElement(b.MessageReadContainer, {
          key: "read-status",
          className: "Twilio-MessageListItem-ReadStatus"
        }, c.createElement(f.Template, {
          source: p.templates.Read
        }), c.createElement(v.Icon, {
          icon: "Read"
        }))));
      }, n;
    }(c.PureComponent);
    t.MessageListItemImpl = y;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Spike = void 0;
    var l = s(n(0)),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement("svg", {
            width: "8px",
            height: "8px",
            viewBox: "0 0 8 8",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            className: this.props.className
          }, l.createElement("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fillRule: "evenodd",
            fill: "currentColor"
          }, this.props.reverse ? l.createElement("polygon", {
            id: "Rectangle",
            transform: "translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) ",
            points: "0 0 8 0 4 4 0 8"
          }) : l.createElement("polygon", {
            id: "Rectangle",
            points: "0 0 8 0 4 4 0 8"
          })));
        }, t.displayName = "ChatItemSpike", t;
      }(l.PureComponent);
    t.Spike = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getThreadWindowStyle = t.MoreActionsInnerContainer = t.StyledActionItem = t.MoreActionsButton = t.MoreActionsMenuContainer = t.StyledPopover = t.AvatarContainer = t.DateContainer = t.SubjectLine = t.DetailsSecondLine = t.DetailsFirstLine = t.Details = t.Preview = t.MessageHeader = void 0;
    var i = o(n(115)),
      a = n(26),
      s = n(17),
      l = n(15),
      c = n(1),
      u = n(41);
    t.MessageHeader = (0, c.styled)("div")(d || (d = r(["\n    width: 100%;\n    display: flex;\n    min-width: 0;\n\n    ", ";\n"], ["\n    width: 100%;\n    display: flex;\n    min-width: 0;\n\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailMessageItem.Header.Wrapper;
    }), t.Preview = (0, c.styled)("div")(f || (f = r(["\n    width: 100%;\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    ", ";\n"], ["\n    width: 100%;\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space40;
    }, function (e) {
      return e.theme.tokens.spacings.space10;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.MessagePreview;
    }), t.Details = (0, c.styled)("div")(p || (p = r(["\n    width: 100%;\n    min-width: 0;\n    ", ";\n"], ["\n    width: 100%;\n    min-width: 0;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailMessageItem.Header.Details;
    }), t.DetailsFirstLine = (0, c.styled)("div")(h || (h = r(["\n    width: 100%;\n    display: flex;\n    ", ";\n"], ["\n    width: 100%;\n    display: flex;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailMessageItem.Header.DetailsFirstRow;
    }), t.DetailsSecondLine = (0, c.styled)("div")(v || (v = r(["\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    ", ";\n"], ["\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.DetailsSecondRow;
    }), t.SubjectLine = (0, c.styled)("div")(m || (m = r(["\n    width: 100%;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    word-break: break-word;\n\n    flex: 1 1 100px;\n    ", ";\n"], ["\n    width: 100%;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    word-break: break-word;\n\n    flex: 1 1 100px;\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.SubjectRow;
    }), t.DateContainer = (0, c.styled)("div")(g || (g = r(["\n    color: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    flex: 0 1 auto;\n    ", ";\n"], ["\n    color: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    flex: 0 1 auto;\n    ", ";\n"])), function (e) {
      return e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.Date;
    }), t.AvatarContainer = (0, c.styled)("div")(b || (b = r(["\n    flex: 0;\n    ", ";\n"], ["\n    flex: 0;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.EmailMessageItem.Header.AvatarContainer;
    }), t.StyledPopover = (0, a.withStyles)(function (e) {
      return u({
        paper: {
          border: e.tokens.borderWidths.borderWidth10 + " solid " + e.tokens.borderColors.colorBorderWeak,
          boxShadow: "0 3px 4px 2px rgba(0,0,0,.1)"
        }
      }, e.Chat.EmailMessageItem.Header.Popover);
    })(i.default), t.MoreActionsMenuContainer = (0, c.styled)("div")(y || (y = r(["\n    align-self: flex-start;\n    margin-top: -", ";\n    margin-left: ", ";\n    svg {\n        transform: rotate(90deg);\n    }\n\n    ", ";\n"], ["\n    align-self: flex-start;\n    margin-top: -", ";\n    margin-left: ", ";\n    svg {\n        transform: rotate(90deg);\n    }\n\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.MoreActionsMenuContainer;
    }), t.MoreActionsButton = (0, c.styled)(l.IconButton)(_ || (_ = r(['\n    &[class*="root"] {\n        padding: 0;\n        width: ', ";\n        height: ", ";\n        ", ";\n    }\n"], ['\n    &[class*="root"] {\n        padding: 0;\n        width: ', ";\n        height: ", ";\n        ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare70;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare70;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.MoreActionsButton;
    }), t.StyledActionItem = (0, c.styled)(s.Button)(O || (O = r(['\n    &[class*="root"] {\n        background: none;\n        border: none;\n        font-weight: ', ";\n        width: 100%;\n        display: block;\n        text-align: left;\n        padding: ", ";\n        color: ", ";\n\n        &:hover {\n            color: ", ";\n            text-decoration: underline;\n        }\n\n        ", ";\n    }\n"], ['\n    &[class*="root"] {\n        background: none;\n        border: none;\n        font-weight: ', ";\n        width: 100%;\n        display: block;\n        text-align: left;\n        padding: ", ";\n        color: ", ";\n\n        &:hover {\n            color: ", ";\n            text-decoration: underline;\n        }\n\n        ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.fontWeights.fontWeightNormal;
    }, function (e) {
      var t = e.theme.tokens;
      return t.spacings.space30 + " " + t.spacings.space70;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextLink;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.PopoverActionItem;
    }), t.MoreActionsInnerContainer = (0, c.styled)("div")(C || (C = r(["\n    padding-top: ", ";\n    padding-bottom: ", ";\n    ", ";\n"], ["\n    padding-top: ", ";\n    padding-bottom: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.Chat.EmailMessageItem.Header.MoreActionsInnerContainer;
    });
    var d, f, p, h, v, m, g, b, y, _, O, C;
    t.getThreadWindowStyle = function (e) {
      var t = e.tokens,
        n = t.fontSizes,
        r = t.spacings,
        o = t.lineHeights,
        i = t.radii,
        a = t.borderColors,
        s = t.borderWidths,
        l = t.backgroundColors,
        u = t.textColors,
        d = t.fonts,
        f = e.Chat.EmailMessageItem.Header.ThreadPopup;
      return "\n        body {\n            font-family: " + d.fontFamilyText + ";\n            font-size: " + n.fontSize30 + ";\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            margin: " + r.space100 + " " + r.space170 + "; \n            background: " + l.colorBackgroundBody + ";\n            color: " + (e.isLight ? u.colorText : u.colorTextInverse) + ";\n            line-height: " + o.lineHeight30 + ";\n        }\n\n        @media screen and (max-width: 512px) {\n            body {\n                margin: " + r.space50 + ";\n            }    \n        }\n        \n        .flex-button {\n            background: " + l.colorBackgroundPrimary + ";\n            border: none;\n            cursor: pointer;\n            color: white;\n            border-radius: " + i.borderRadius20 + ";\n            padding: " + r.space30 + " " + r.space40 + ";\n            font-weight: bold;\n            margin-bottom: " + r.space80 + ";\n        }\n        .flex-button:hover {\n            background: " + l.colorBackgroundPrimaryStrong + ";\n        }\n        \n        dl {\n            border-radius: " + i.borderRadius20 + ";\n            border: " + s.borderWidth10 + " solid " + a.colorBorderWeak + ";\n            padding: " + r.space70 + " " + r.space60 + ";\n            margin:0 0 " + r.space90 + ";\n        }\n        \n        dl > div {\n            display: flex;\n            flex-wrap: wrap;\n        }\n        \n        dl > div + div {\n            margin-top: " + r.space40 + ";\n        }\n        \n        dt {\n            flex: 0 1 100px;\n        }\n\n        dd {\n            margin-left: 0;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n        \n        a {\n            color: " + u.colorTextLink + ";\n        }\n\n        a:hover {\n            color: " + u.colorTextLinkStrong + ";\n        }\n        \n        " + (0, c.rootStyleObjectToString)(f) + "          \n    ";
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineDateSeparator = void 0;
    var l = s(n(0)),
      c = n(9),
      u = n(6),
      d = n(470),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.message;
          return l.createElement(u.FlexBox, {
            className: "Twilio-InlineDateSeparator",
            key: e.source.dateCreated.getTime()
          }, l.createElement(d.SeparatorLine, {
            "aria-hidden": "true"
          }), l.createElement(d.TextContainer, null, c.Utils.formatSeparatorDate(e.source.dateCreated)), l.createElement(d.SeparatorLine, {
            "aria-hidden": "true"
          }));
        }, t.displayName = "InlineDateSeparator", t;
      }(l.PureComponent);
    t.InlineDateSeparator = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = t.SeparatorLine = void 0;
    var o,
      i,
      a = n(1);
    t.SeparatorLine = (0, a.styled)("hr")(o || (o = r(["\n    flex: 1 1 1px;\n    margin: auto;\n    border-style: solid;\n    ", ";\n"], ["\n    flex: 1 1 1px;\n    margin: auto;\n    border-style: solid;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.MessageList.DateSeparatorLine;
    }), t.TextContainer = (0, a.styled)("div")(i || (i = r(["\n    flex: 0 1 auto;\n    margin-left: ", ";\n    margin-right: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    ", ";\n"], ["\n    flex: 0 1 auto;\n    margin-left: ", ";\n    margin-right: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight20;
    }, function (e) {
      return e.theme.Chat.MessageList.DateSeparatorText;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineMessage = void 0;
    var l = s(n(0)),
      c = n(7),
      u = n(21),
      d = n(127),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            n = this.props,
            r = n.message,
            o = n.children,
            i = n.isSeparator;
          return l.createElement(u.MessagingCanvasContext.Consumer, null, function (n) {
            return l.createElement(c.DynamicComponent, {
              contentStore: t.Content,
              childProps: e.props,
              name: t.friendlyName,
              customChildren: e.props.children,
              vertical: !0,
              rootContainerStyles: "\n                            overflow: visible;\n                            flex: 1 0 auto;\n                        "
            }, l.createElement(d.Container, {
              message: r,
              messageStyle: n.messageStyle,
              isSeparator: i
            }, o));
          });
        }, t.friendlyName = "InlineMessage", t.displayName = t.friendlyName, t.Content = new c.DynamicContentStore(t.friendlyName), t;
      }(l.PureComponent);
    t.InlineMessage = f;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineNewMessageSeparator = void 0;
    var l = s(n(0)),
      c = n(6),
      u = n(473),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.text;
          return l.createElement(c.FlexBox, {
            className: "Twilio-InlineTextSeparator"
          }, l.createElement(u.SeparatorLine, {
            "aria-hidden": "true"
          }), l.createElement(u.TextContainer, null, e), l.createElement(u.SeparatorLine, {
            "aria-hidden": "true"
          }));
        }, t.displayName = "InlineTextSeparator", t;
      }(l.PureComponent);
    t.InlineNewMessageSeparator = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = t.SeparatorLine = void 0;
    var o,
      i,
      a = n(1);
    t.SeparatorLine = (0, a.styled)("hr")(o || (o = r(["\n    flex: 1 1 1px;\n    margin: auto;\n    border-style: solid;\n    ", ";\n    border-bottom: none;\n"], ["\n    flex: 1 1 1px;\n    margin: auto;\n    border-style: solid;\n    ", ";\n    border-bottom: none;\n"])), function (e) {
      return e.theme.Chat.MessageList.NewMessageSeparatorLine;
    }), t.TextContainer = (0, a.styled)("div")(i || (i = r(["\n    flex: 0 1 auto;\n    margin-left: ", ";\n    margin-right: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    ", ";\n"], ["\n    flex: 0 1 auto;\n    margin-left: ", ";\n    margin-right: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize10;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.theme.Chat.MessageList.NewMessageSeparatorText;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTray = void 0;
    var u = c(n(0)),
      d = n(43),
      f = n(475),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return u.createElement(f.MessageCanvasTrayImpl, i({}, this.props));
        }, t.displayName = f.displayName, t.Content = f.contentStore, t.defaultProps = {
          onButtonClick: void 0,
          showButton: !0
        }, t = l([d.withDefaultPropsUpdate], t);
      }(u.PureComponent);
    t.MessageCanvasTray = p;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTrayImpl = t.contentStore = t.displayName = void 0;
    var l = s(n(0)),
      c = n(7),
      u = n(10),
      d = n(2),
      f = n(1),
      p = n(130);
    t.displayName = "MessageCanvasTray", t.contentStore = new c.DynamicContentStore(t.displayName);
    var h = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.render = function () {
          return l.createElement(c.DynamicComponent, {
            contentStore: t.contentStore,
            childProps: this.props,
            name: t.displayName,
            customChildren: this.props.children,
            vertical: !0
          }, l.createElement(p.Container, {
            noGrow: !0,
            noShrink: !0
          }, l.createElement(u.Template, {
            key: "text",
            source: d.templates.MessageCanvasTrayContent,
            className: "MessageCanvasTrayContent"
          }), this.props.showButton && l.createElement(p.ActionButton, {
            "data-test": "StartNewChatAreaButton",
            key: "button",
            onClick: this.props.onButtonClick,
            disabled: !1,
            roundCorners: !1,
            themeOverride: this.props.theme.Chat.MessageCanvasTray.Button,
            variant: "secondary"
          }, l.createElement(u.Template, {
            source: d.templates.MessageCanvasTrayButton
          }))));
        }, n;
      }(l.PureComponent),
      v = (0, f.withTheme)(h);
    t.MessageCanvasTrayImpl = v;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInput = void 0;
    var u = c(n(0)),
      d = n(30),
      f = n(8),
      p = n(43),
      h = n(21),
      v = n(131),
      m = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          var e = this;
          return u.createElement(h.MessagingCanvasContext.Consumer, null, function (t) {
            return u.createElement(g, i({}, e.props, {
              legacy: !0,
              conversationSid: t.sid,
              channelSid: t.sid,
              key: t.sid
            }));
          });
        }, t.displayName = v.displayName, t.Content = v.contentStore, t.defaultProps = {
          areaStyle: "Bubble",
          returnKeySendsMessage: !0,
          sendButtonAriaProps: {
            ariaLabel: "Send Message"
          },
          textAreaAriaProps: {
            ariaLabel: "Type Message"
          }
        }, t = l([p.withDefaultPropsUpdate], t);
      }(u.PureComponent);
    t.MessageInput = m;
    var g = (0, d.connect)(function (e, t) {
      return {
        channel: f.ChatModule.stateCallback(e).channels[t.conversationSid],
        conversation: f.ChatModule.stateCallback(e).conversations[t.conversationSid],
        connectionState: f.ChatModule.stateCallback(e).session.connectionState,
        messageState: f.ChatModule.stateCallback(e).conversationInput[t.conversationSid]
      };
    })(v.MessageInputImpl);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputActions = void 0;
    var l = s(n(0)),
      c = n(33),
      u = n(7),
      d = n(25),
      f = n(20),
      p = n(10),
      h = n(2),
      v = n(70),
      m = n(17),
      g = n(478),
      b = new d.DynamicContentStore("MessageInputActions"),
      y = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.conversationSid,
            n = e.theme,
            r = e.attachFileButtonAriaLabel,
            o = e.handleFileChange,
            i = e.sendMessage,
            a = e.attachFileDisabled,
            s = e.sendDisabled,
            d = e.disabledReason,
            y = e.sendButtonArialabel,
            _ = e.sendButtonAriaProps,
            O = e.matchSendMessagePayloadPredicate,
            C = e.hideSendButton;
          return l.createElement(u.DynamicComponent, {
            contentStore: b,
            childProps: this.props,
            name: "MessageInputActions",
            customChildren: this.props.children,
            vertical: !1,
            rootContainerStyles: "\n                    > div {\n                        min-width: 0;\n                        overflow: visible;\n                    };\n                "
          }, l.createElement(g.Container, null, l.createElement(u.ContentFragment, {
            align: "start"
          }, (0, f.isFileAttachmentEnabled)(t) && !(0, f.isFileAttachmentReadOnly)(t) && l.createElement(v.AttachFileButton, {
            disabled: a,
            ariaLabel: r,
            onChange: o,
            className: "Twilio-MessageInputArea-AttachFileButton",
            themeOverride: null == n ? void 0 : n.Chat.MessageInput.AttachFileButton,
            conversationSid: t,
            sizeMultiplier: .9,
            key: "attach-file-button",
            legacy: !1,
            multipleFiles: !0
          })), !C && l.createElement(u.ContentFragment, {
            align: "end"
          }, l.createElement(c.ActionStateListener, {
            key: "send-button",
            action: "SendMessage",
            payload: O
          }, function (e) {
            var t, r;
            return l.createElement(m.Button, {
              className: "Twilio-MessageInput-SendButton",
              "data-test": "send-message",
              variant: "primary",
              size: "small",
              onClick: function () {
                return i(e.disabled || s);
              },
              title: d || h.templates.SendMessageTooltip(),
              "aria-disabled": e.disabled || s,
              themeOverride: null === (r = null === (t = null == n ? void 0 : n.Chat) || void 0 === t ? void 0 : t.MessageInput) || void 0 === r ? void 0 : r.Button,
              "aria-label": y,
              "aria-live": _ && _.ariaLive,
              type: "button"
            }, l.createElement(p.Template, {
              source: h.templates.MessageInputSendButtonText
            }));
          }))));
        }, t.Content = b, t;
      }(l.PureComponent);
    t.MessageInputActions = y;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(6),
      a = n(1);
    t.Container = (0, a.styled)(i.FlexBox)(o || (o = r(["\n    display: flex;\n    overflow: visible;\n    margin-bottom: 16px;\n"], ["\n    display: flex;\n    overflow: visible;\n    margin-bottom: 16px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputArea = void 0;
    var r = n(481);
    Object.defineProperty(t, "MessageInputArea", {
      enumerable: !0,
      get: function () {
        return r.MessageInputArea;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputArea = void 0;
    var c = l(n(0)),
      u = n(8),
      d = n(10),
      f = n(2),
      p = n(42),
      h = n(48),
      v = n(1),
      m = n(105),
      g = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            inputInFocus: !1,
            fileInFocus: !1
          }, t._inputContainerElement = c.createRef(), t.handleDroppedText = function (e) {
            if (!t.props.disabled) {
              var n = e.dataTransfer.types;
              if (n && n.includes("text/plain")) {
                var r = t.props,
                  o = r.onChange,
                  i = void 0 === o ? function () {} : o,
                  a = r.messageState,
                  s = e.dataTransfer.getData("text/plain");
                i({
                  inputText: a.inputText.substring(0, a.selectionStart) + s + a.inputText.substring(a.selectionEnd, a.inputText.length),
                  selectionStart: a.selectionStart + s.length,
                  selectionEnd: a.selectionStart + s.length
                });
              }
            }
          }, t.handleInputKeyPress = function (e) {
            t.props.disabled || "Enter" !== e.code && "NumpadEnter" !== e.code || e.shiftKey || !t.props.returnKeySendsMessage || (t.props.onSendMessage(), e.preventDefault());
          }, t.handleInputFocus = function () {
            t.props.disabled || u.ChatModule.events.emitInputFocus(t.props.conversationSid);
          }, t.handleInputBlur = function () {
            u.ChatModule.events.emitInputBlur(t.props.channelSid);
          }, t.handleInputChange = function (e) {
            if (!t.props.disabled) {
              var n = t.props,
                r = n.messageState,
                o = n.onChange,
                i = e.target,
                a = i.value,
                s = i.selectionStart,
                l = i.selectionEnd;
              !(r.inputText === a && r.selectionStart === s && r.selectionEnd === l) && o && (o({
                inputText: a,
                selectionStart: s,
                selectionEnd: l
              }), t.adjustRowCountStyle());
            }
          }, t.handlePaste = function (e) {
            if (!t.props.disabled) {
              var n = e.clipboardData || window.clipboardData;
              if (n && n.files && !(n.files.length <= 0)) {
                var r = t.props.onPasteFiles,
                  o = void 0 === r ? function () {} : r,
                  i = t.getPastedFiles(n);
                i && o(i), e.preventDefault();
              }
            }
          }, t.getPastedFiles = function (e) {
            var t = e.files && Array.from(e.files);
            if (t) return t;
          }, t.resize = function () {
            var e = t.props.forwardedInputRef;
            (null == e ? void 0 : e.current) && (e.current.style.height = "", e.current.style.height = e.current.scrollHeight + "px");
          }, t.adjustRowCountStyle = function () {
            var e = t.props.forwardedInputRef;
            if (null == e ? void 0 : e.current) {
              t.resize();
              var n = Math.round(parseFloat(e.current.style.height)),
                r = window.getComputedStyle(e.current, null);
              e.current.offsetHeight < n ? "hidden" === r.overflowY && (e.current.style.overflowY = "scroll", t.resize()) : "hidden" !== r.overflowY && (e.current.style.overflowY = "hidden", t.resize());
            }
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this,
            n = this.props,
            r = n.areaStyle,
            o = n.placeholder,
            a = n.disabled,
            s = n.messageState,
            l = n.textAreaAriaProps,
            u = n.forwardedInputRef,
            d = n.onFocus,
            p = n.onBlur,
            h = n.legacy,
            v = n.rows,
            g = a ? f.templates.MessageInputDisabledAriaLabel({
              placeholder: o
            }) : l && l.ariaLabel,
            b = this.state.inputInFocus || this.state.fileInFocus;
          return c.createElement(m.TextAreaContainer, {
            className: "Twilio-MessageInputArea-TextArea",
            ref: this._inputContainerElement,
            areaStyle: r,
            showFocus: b
          }, c.createElement(m.TextArea, {
            "aria-label": g,
            areaStyle: r,
            ref: u,
            rows: v,
            placeholder: o,
            onKeyPress: this.handleInputKeyPress,
            onChange: this.handleInputChange,
            value: s.inputText,
            "aria-disabled": a,
            onSelect: this.handleInputChange,
            onPaste: this.handlePaste,
            onDrop: this.handleDroppedText,
            legacy: h,
            onFocus: function () {
              h || t.setState(i(i({}, t.state), {
                inputInFocus: !0
              })), t.handleInputFocus(), d && d();
            },
            onBlur: function () {
              h || t.setState(i(i({}, t.state), {
                inputInFocus: !1
              })), t.handleInputBlur(), p && p();
            },
            "data-test": "message-input"
          }), this.renderCharCount(), !!(null === (e = s.attachedFiles) || void 0 === e ? void 0 : e.length) && this.renderFileBox());
        }, t.prototype.renderCharCount = function () {
          var e = this.props,
            t = e.charLimit,
            n = e.inputTextLength;
          return n >= .7 * t ? c.createElement(m.CharLimit, {
            areaStyle: this.props.areaStyle,
            inputTextLength: n,
            charLimit: t
          }, n > t ? c.createElement(d.Template, {
            key: "MessageCharacterCountReachedText",
            source: f.templates.MessageCharacterCountReached,
            className: "MessageCharacterCountReached",
            currentCharCount: n,
            maxCharCount: t
          }) : c.createElement(d.Template, {
            key: "MessageCharacterCountStatusText",
            source: f.templates.MessageCharacterCountStatus,
            className: "MessageCharacterCountStatus",
            currentCharCount: n,
            maxCharCount: t
          })) : null;
        }, t.prototype.componentDidMount = function () {
          var e = this;
          setTimeout(function () {
            var t = e.props,
              n = t.forwardedInputRef,
              r = t.messageState;
            (null == n ? void 0 : n.current) && (e.adjustRowCountStyle(), n.current.selectionStart = r.selectionStart, n.current.selectionEnd = r.selectionEnd);
          }, 0);
        }, t.prototype.componentDidUpdate = function () {
          var e = this.props,
            t = e.messageState,
            n = e.forwardedInputRef;
          this.adjustRowCountStyle(), (null == n ? void 0 : n.current) && (n.current.selectionStart = t.selectionStart, n.current.selectionEnd = t.selectionEnd);
        }, t.prototype.renderFileBox = function () {
          var e = this,
            t = this.props,
            n = t.messageState.attachedFiles,
            r = t.theme,
            o = t.onRemoveAttachedFile,
            a = t.disabled,
            s = t.legacy,
            l = t.isSending,
            u = t.placeholder;
          return c.createElement(m.FileBoxContainer, {
            legacy: this.props.legacy
          }, n.map(function (t) {
            var n = a || l ? "" + f.templates.DisabledRemoveAttachedFileAriaLabel({
              fileName: t.name,
              placeholder: u
            }) : "" + f.templates.RemoveAttachedFileAriaLabel({
              fileName: t.name
            });
            return c.createElement(m.FileBox, {
              key: "" + t.name + t.size,
              noGrow: !0,
              overflow: "hidden",
              className: "Twilio-MessageInput-FileBox",
              "data-test": "attached-file",
              legacy: e.props.legacy
            }, c.createElement(h.FilePreview, {
              iconOverride: l && c.createElement(p.CircularProgress, {
                size: 26,
                animating: !0,
                override: {
                  animatingBackgroundBorderColor: "transparent"
                }
              }),
              file: t,
              disabled: !l && a,
              subTitleLine: l ? f.templates.FileSendingText() : void 0
            }), c.createElement(m.RemoveFileButton, {
              className: "Twilio-MessageInput-FileBox-RemoveButton",
              "data-test": "remove-file",
              sizeMultiplier: s ? 1.2 : 1.5,
              icon: "Close",
              themeOverride: r.Chat.MessageInput.RemoveFileButton,
              onClick: a || l || !o ? void 0 : function () {
                return o(t);
              },
              "aria-disabled": a || l,
              title: n,
              "aria-label": n,
              legacy: s,
              onFocus: s ? void 0 : function () {
                return e.setState(i(i({}, e.state), {
                  fileInFocus: !0
                }));
              },
              onBlur: s ? void 0 : function () {
                return e.setState(i(i({}, e.state), {
                  fileInFocus: !1
                }));
              }
            }));
          }));
        }, t.defaultProps = {
          returnKeySendsMessage: !0,
          forwardedInputRef: c.createRef(),
          rows: 1
        }, t.displayName = "MessageInputArea", t;
      }(c.PureComponent),
      b = (0, v.withTheme)(g);
    t.MessageInputArea = b;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextAreaContainer = t.StyledSendMessageButton = t.Container = void 0;
    var o,
      i,
      a,
      s = n(6),
      l = n(15),
      c = n(1);
    t.Container = (0, c.styled)(s.FlexBoxColumn)(o || (o = r(["\n    padding-left: ", ";\n    padding-right: ", ";\n\n    ", "\n    background: ", ";\n"], ["\n    padding-left: ", ";\n    padding-right: ", ";\n\n    ", "\n    background: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.Chat.MessageInput.Container;
    }, function (e) {
      return "Boxed" === e.areaStyle ? void 0 : "transparent";
    }), t.StyledSendMessageButton = (0, c.styled)(l.IconButton)(i || (i = r(["\n    align-self: flex-end;\n    color: ", ";\n    background: none;\n    &:focus-visible {\n        border: ", " solid\n            ", ';\n    }\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        background: inherit;\n        bordercolor: ', ";\n        color: ", ";\n    }\n"], ["\n    align-self: flex-end;\n    color: ", ";\n    background: none;\n    &:focus-visible {\n        border: ", " solid\n            ", ';\n    }\n    &[aria-disabled="true"] {\n        opacity: 0.4;\n        background: inherit;\n        bordercolor: ', ";\n        color: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundPrimary;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderPrimary;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }), t.TextAreaContainer = (0, c.styled)(s.FlexBox)(a || (a = r(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: flex-end;\n    background: ", ";\n    border: ", ";\n    border-style: solid;\n    border-color: ", ";\n    border-radius: ", ";\n"], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: flex-end;\n    background: ", ";\n    border: ", ";\n    border-style: solid;\n    border-color: ", ";\n    border-radius: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.legacy ? e.theme.tokens.spacings.space40 : e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.legacy ? e.theme.tokens.backgroundColors.colorBackground : e.theme.tokens.backgroundColors.colorBackgroundBody;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.hasChildInFocus && e.legacy ? e.theme.tokens.borderColors.colorBorderNeutral : e.theme.tokens.borderColors.colorBorderWeak;
    }, function (e) {
      return e.legacy ? "20px" : e.theme.tokens.radii.borderRadius20;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageList = void 0;
    var c = l(n(0)),
      u = n(30),
      d = n(8),
      f = n(60),
      p = n(97),
      h = n(122),
      v = n(21),
      m = n(134),
      g = n(485),
      b = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return c.createElement(f.VisibilityContextProvider.Consumer, null, function (t) {
            return c.createElement(v.MessagingCanvasContext.Consumer, null, function (n) {
              return c.createElement(y, i({}, e.props, {
                conversationSid: n.sid,
                channelSid: n.sid,
                memberDisplayOptions: n.memberDisplayOptions,
                messageStyle: n.messageStyle,
                showTypingIndicator: n.showTypingIndicator,
                showReadStatus: n.showReadStatus,
                showWelcomeMessage: n.showWelcomeMessage,
                predefinedMessage: n.predefinedMessage,
                notVisible: !t,
                conversationType: n.conversationType
              }));
            });
          });
        }, t.friendlyName = g.displayName, t.displayName = g.displayName, t.Content = g.contentStore, t.Item = h.MessageListItem, t.WelcomeMessage = m.WelcomeMessage, t.defaultProps = {
          listContainerAriaProps: {
            ariaLive: p.AriaLive.Assertive
          }
        }, t;
      }(c.Component);
    t.MessageList = b;
    var y = (0, u.connect)(function (e, t) {
      return {
        channel: d.ChatModule.stateCallback(e).channels[t.channelSid],
        conversation: d.ChatModule.stateCallback(e).conversations[t.conversationSid],
        isAppActive: d.ChatModule.stateCallback(e).session.isActive
      };
    })(g.MessageListImpl);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = void 0;
    var s,
      l = a(n(0)),
      c = n(10),
      u = (0, n(1).styled)("p")(s || (s = r(["\n    text-align: center;\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"], ["\n    text-align: center;\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), function (e) {
        return e.theme.tokens.fontSizes.fontSize20;
      }, function (e) {
        return e.theme.tokens.lineHeights.lineHeight10;
      }, function (e) {
        return e.theme.tokens.fontWeights.fontWeightBold;
      });
    t.TextContainer = function (e) {
      var t = e.source;
      return l.createElement(u, {
        className: "Twilio-WelcomeMessage-TextContainer"
      }, l.createElement(c.Template, {
        source: t
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListImpl = t.contentStore = t.displayName = void 0;
    var l = s(n(0)),
      c = n(52),
      u = n(8),
      d = n(44),
      f = n(7),
      p = n(90),
      h = s(n(11)),
      v = n(2),
      m = n(9),
      g = n(118),
      b = n(125),
      y = n(126),
      _ = n(128),
      O = n(28),
      C = n(71),
      P = n(136),
      M = n(137),
      j = n(490),
      w = n(138),
      E = n(139),
      S = n(63);
    t.displayName = "MessageList", t.contentStore = new f.DynamicContentStore(t.displayName);
    var x = function (e) {
      function n() {
        var t,
          n = e.apply(this, arguments) || this;
        return n.newMessageRef = l.createRef(), n.loadedMessagesInUpdate = !1, n.keepScrolledToBottom = !0, n.lastScrollHeight = 0, n.lastScrollTop = 0, n.inputFocused = !1, n.mediaDownloaded = !1, n.state = {
          focusIndex: n.props.conversation.messages.length ? n.props.conversation.messages[(null === (t = n.props.conversation.messages) || void 0 === t ? void 0 : t.length) - 1].index : -1,
          shouldFocusLatest: !1,
          hasSwitchedConversation: !1
        }, n.handleInputMessagePosted = function () {
          n.scrollToBottom();
        }, n.handleMediaDownloaded = function () {
          n.mediaDownloaded = !0, n.consumeLastMessageIfApplicable();
        }, n.handleInputFocus = function () {
          n.inputFocused = !0, setTimeout(function () {
            n.consumeLastMessageIfApplicable();
          }, 200);
        }, n.handleInputBlur = function () {
          n.inputFocused = !1;
        }, n.onScroll = function () {
          return n.onDebounceScroll();
        }, n.onDebounceScroll = S(function () {
          if (n.messageList) {
            var e = n.props.conversation,
              t = n.messageList,
              r = t.scrollTop,
              o = t.scrollHeight,
              i = t.clientHeight,
              a = e.unreadMessages,
              s = d.ConversationHelper.isUserParticipantOfConversation(e);
            a.length > 0 && s && n.checkForScrollBtnDisplay();
            !n.loadedMessagesInUpdate && Math.abs(r) + i >= o - 2 && n.loadMoreMessages(), n.captureBottomScrollState(), n.consumeLastMessageIfApplicable();
          }
        }, 50), n.setMessageListRef = function (e) {
          n.messageList = e;
        }, n.scrollDownClick = function (e) {
          e.stopPropagation(), n.messageList.scrollTop = n.messageList.scrollHeight;
        }, n.onClick = function () {
          var e = n.props.conversation;
          d.ConversationHelper.isUserParticipantOfConversation(e) && n.consumeLastMessageIfApplicable({
            forced: !0
          });
        }, n;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.conversation,
          o = n.children,
          i = n.showTypingIndicator,
          a = n.memberDisplayOptions,
          s = n.listContainerAriaProps,
          c = n.conversationType,
          u = O.ChatManager.isOrganicMessageSortingDisabled(),
          d = "email" !== c && i,
          p = this.state.hasSwitchedConversation || 0 === this.props.conversation.messages.length;
        return l.createElement(w.Container, {
          overflowVisible: "email" === c
        }, l.createElement(w.ListOuterContainer, {
          disableOrganicMessageSorting: u,
          ref: u ? void 0 : this.setMessageListRef,
          onScroll: u ? void 0 : this.onScroll
        }, l.createElement(f.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: o,
          noContainers: !0,
          vertical: !0,
          rootContainerStyles: "position:static;"
        }, l.createElement(w.ListContainer, {
          spacingBottom: "email" === c,
          "aria-label": s && s.ariaLabel,
          "aria-live": s && s.ariaLive,
          role: "log",
          tabIndex: p ? 0 : -1,
          onFocus: function () {
            return e.handleFocus();
          },
          onClick: this.onClick,
          disableOrganicMessageSorting: u,
          ref: u ? this.setMessageListRef : void 0,
          onScroll: u ? this.onScroll : void 0
        }, u && d && l.createElement(E.TypingIndicator, {
          key: "typing-indicator",
          typers: r.typers,
          memberDisplayOptions: a
        }), r.unreadMessages.length > 0 && r.showScrollDownBtn && l.createElement(M.MessageScrollButton, {
          key: "message-scroll-button",
          onClick: this.scrollDownClick,
          unreadMessages: r.unreadMessages
        }), this.getListItems(), !u && d && l.createElement(E.TypingIndicator, {
          key: "typing-indicator",
          typers: r.typers,
          memberDisplayOptions: a
        })))));
      }, n.prototype.componentDidMount = function () {
        var e,
          t = this,
          n = this.props,
          r = n.conversationSid,
          o = n.notVisible,
          i = n.conversation;
        u.ChatModule.events.addListener(c.ChatEvent[c.ChatEvent.chatInputFocus], this.handleInputFocus), u.ChatModule.events.addListener(c.ChatEvent[c.ChatEvent.chatInputBlur], this.handleInputBlur), u.ChatModule.events.addListener(c.ChatEvent[c.ChatEvent.chatMessagePosted], this.handleInputMessagePosted), u.ChatModule.events.addListener(c.ChatEvent[c.ChatEvent.chatMediaDownloaded], this.handleMediaDownloaded), null === (e = i.source) || void 0 === e || e.addListener("messageAdded", function () {
          return t.newMessageListener();
        }), o ? p.Actions.updateActiveConversation("") : p.Actions.updateActiveConversation(r), this.onScroll(), this.consumeLastMessageIfApplicable(), this.messageList && i && (this.messageList.scrollTop = i.lastScrollPosition);
      }, n.prototype.componentWillUnmount = function () {
        var e,
          t = this,
          n = this.props.conversation;
        this.onDebounceScroll && this.onDebounceScroll.cancel(), h.Actions.showScrollDownBtn(n, !1), u.ChatModule.events.removeListener(c.ChatEvent[c.ChatEvent.chatInputFocus], this.handleInputFocus), u.ChatModule.events.removeListener(c.ChatEvent[c.ChatEvent.chatInputBlur], this.handleInputBlur), u.ChatModule.events.removeListener(c.ChatEvent[c.ChatEvent.chatMessagePosted], this.handleInputMessagePosted), u.ChatModule.events.removeListener(c.ChatEvent[c.ChatEvent.chatMediaDownloaded], this.handleMediaDownloaded), null === (e = n.source) || void 0 === e || e.removeListener("messageAdded", function () {
          return t.newMessageListener();
        }), p.Actions.updateActiveConversation("");
      }, n.prototype.componentDidUpdate = function (e) {
        var t,
          n,
          r,
          o = this.props,
          i = o.conversationSid,
          a = o.notVisible,
          s = o.isAppActive,
          l = o.conversation,
          c = d.ConversationHelper.isUserParticipantOfConversation(l);
        this.loadedMessagesInUpdate = !1, l.unreadMessages.length > 0 && this.newMessageRef.current && l.showScrollDownBtn && c && this.checkForScrollBtnDisplay(), a ? p.Actions.updateActiveConversation("") : p.Actions.updateActiveConversation(i), (s && !e.isAppActive || (null === (t = l.messages) || void 0 === t ? void 0 : t.length) !== (null === (n = e.conversation.messages) || void 0 === n ? void 0 : n.length)) && this.consumeLastMessageIfApplicable(), ((null === (r = null == e ? void 0 : e.conversation) || void 0 === r ? void 0 : r.isLoadingMessages) && !(null == l ? void 0 : l.isLoadingMessages) || e.conversationSid !== i && !(null == l ? void 0 : l.isLoadingMessages)) && this.onScroll(), e.conversationSid !== i && (this.messageList.scrollTop = l.lastScrollPosition, this.captureBottomScrollState(), p.Actions.updateActiveConversation(i), this.setState({
          hasSwitchedConversation: !0
        }));
      }, n.prototype.scrollToBottom = function () {
        this.messageList && (this.messageList.scrollTop = 0, this.captureBottomScrollState());
      }, n.prototype.consumeLastMessageIfApplicable = function (e) {
        var t;
        void 0 === e && (e = {
          forced: !1
        });
        var n = this.props,
          r = n.isAppActive,
          o = n.notVisible,
          i = n.conversation;
        if ((null === (t = this.messageList) || void 0 === t ? void 0 : t.scrollTop) >= 0 && r && !o) {
          var a = i.messages,
            s = i.source;
          if (a.length > 0) {
            var l = a.length ? a[a.length - 1].source.index : 0;
            (null == s ? void 0 : s.lastReadMessageIndex) !== l && (this.inputFocused || this.mediaDownloaded || e.forced) && (h.Actions.updateLastReadMessageIndex(i, l), this.mediaDownloaded = !1);
          }
        }
      }, n.prototype.captureBottomScrollState = function () {
        if (this.messageList) {
          var e = this.messageList,
            t = e.scrollTop,
            n = e.scrollHeight;
          n === this.lastScrollHeight && t === this.lastScrollTop || (this.lastScrollHeight = n, this.lastScrollTop = t, p.Actions.updateScrollPosition(this.keepScrolledToBottom), h.Actions.storeLastScrollPosition(this.props.conversationSid, t));
        }
      }, n.prototype.loadMoreMessages = function () {
        var e = this.props.conversation;
        e.isLoadingMessages || h.Actions.loadMessagesFromHistory(e);
      }, n.prototype.findMyLastMessageIndex = function () {
        var e = this.props.conversation.messages.filter(function (e) {
          return e.isFromMe;
        }).slice(-1)[0];
        return e ? e.source.index : -1;
      }, n.prototype.getListItems = function () {
        var e = this,
          t = this.props,
          n = t.showReadStatus,
          r = t.conversation,
          o = t.memberDisplayOptions,
          i = t.messageStyle,
          a = t.predefinedMessage,
          s = t.showWelcomeMessage,
          c = t.conversationType,
          u = this.findMyLastMessageIndex(),
          f = function (e) {
            return n && e.source.index <= r.lastReadMessageIndex && e.source.index === u && r.participants.size > 1;
          },
          p = r.messages.map(function (t, n) {
            var a;
            return "email" === c ? l.createElement(g.EmailMessageItem, {
              key: t.source.sid,
              message: t,
              participants: r.participants,
              defaultOpen: n + 1 === r.messages.length,
              conversationBindings: null === (a = r.source) || void 0 === a ? void 0 : a.bindings.email
            }) : l.createElement(C.MessageListItem, {
              key: t.source.index,
              authorName: t.isFromMe ? o.yourDefaultName : o.theirDefaultName,
              useFriendlyName: t.isFromMe ? o.yourFriendlyNameOverride : o.theirFriendlyNameOverride,
              message: t,
              messageStyle: i,
              showReadStatus: f(t),
              focusable: t.index === e.state.focusIndex,
              updateFocus: function (t) {
                return e.updateFocus(t);
              }
            });
          }),
          h = 0;
        r.currentPaginator && r.currentPaginator.hasPrevPage || r.isLoadingMessages || (a && (this.injectPredefinedMessage(p), h += 1), s && (this.injectWelcomeMessage(p), h += 1)), r.isLoadingMessages && r.messages.length && (h = this.injectLoadingElements(p, h)), h = this.injectDateSeparatorElements(p, h);
        var v = d.ConversationHelper.isUserParticipantOfConversation(r),
          m = r.unreadMessages.some(function (e) {
            return e.index === Number(r.lastReadMessageByCurrentUserIndex) + 1;
          });
        return r.unreadMessages.length > 0 && v && m && this.injectUnreadSeparatorElements(p, h), p.push.apply(p, this.getPendingMessageElements()), O.ChatManager.isOrganicMessageSortingDisabled() && p.reverse(), p;
      }, n.prototype.getPendingMessageElements = function () {
        var e = this.props,
          t = e.memberDisplayOptions,
          n = e.messageStyle;
        return e.conversation.pendingMessages.map(function (e) {
          return l.createElement(C.MessageListItem, {
            key: "pendingMessage_" + e.index,
            authorName: t.yourDefaultName,
            useFriendlyName: t.yourFriendlyNameOverride,
            message: e,
            messageStyle: n,
            showReadStatus: !1
          });
        });
      }, n.prototype.injectDateSeparatorElements = function (e, t) {
        var n;
        return this.props.conversation.messages.forEach(function (r, o) {
          o > 0 && n && !m.Utils.isSameDate(n, r.source.dateCreated) && (e.splice(o + t, 0, l.createElement(y.InlineMessage, {
            key: r.source.dateCreated.getTime(),
            message: r
          }, l.createElement(b.InlineDateSeparator, {
            key: "date-separator",
            message: r
          }))), t += 1), n = r.source.dateCreated;
        }), t;
      }, n.prototype.injectUnreadSeparatorElements = function (e, t) {
        var n = this.props.conversation,
          r = n.messages,
          o = n.unreadMessages;
        return e.splice(r.length - o.length + t, 0, l.createElement(l.Fragment, {
          key: "new-message-ref-frag"
        }, l.createElement("div", {
          key: "new-message-ref",
          ref: this.newMessageRef
        }), l.createElement(y.InlineMessage, {
          key: "new-message-text",
          message: r[0],
          isSeparator: !0
        }, l.createElement(_.InlineNewMessageSeparator, {
          key: "new-message-separator",
          text: v.templates.NewMessageSeparatorText()
        })))), t + 1;
      }, n.prototype.injectLoadingElements = function (e, t) {
        return e.splice(0, 0, l.createElement(P.MessageLoader, {
          key: "message-loading",
          messageList: this.messageList
        })), t + 1;
      }, n.prototype.injectWelcomeMessage = function (e) {
        var t = l.createElement(j.WelcomeMessage, {
          key: "Twilio-WelcomeMessage"
        });
        e.unshift(t);
      }, n.prototype.injectPredefinedMessage = function (e) {
        var t,
          n = this.props,
          r = n.predefinedMessage,
          o = n.messageStyle,
          i = n.conversation,
          a = null === (t = null == i ? void 0 : i.source) || void 0 === t ? void 0 : t.dateCreated;
        if (r) {
          var s = {
              groupWithNext: !1,
              groupWithPrevious: !1,
              isFromMe: r.isFromMe,
              source: {
                body: T(r.body),
                dateCreated: a
              }
            },
            c = l.createElement(C.MessageListItem, {
              key: "predefinedMessage",
              message: s,
              messageStyle: o,
              showReadStatus: !1,
              participant: {
                friendlyName: T(r.authorName)
              },
              member: {
                friendlyName: T(r.authorName)
              }
            });
          e.unshift(c);
        }
      }, n.prototype.checkForScrollBtnDisplay = function () {
        var e = this.messageList,
          t = e.scrollTop,
          n = e.scrollHeight,
          r = e.clientHeight,
          o = this.props.conversation;
        if (this.newMessageRef.current) {
          var i = n + t < n - r + this.newMessageRef.current.offsetTop;
          i !== o.showScrollDownBtn && h.Actions.showScrollDownBtn(o, i);
        }
      }, n.prototype.handleFocus = function () {
        var e = this.props.conversation.messages;
        e && e.length && (this.state.hasSwitchedConversation || this.state.focusIndex < 0) && this.setState({
          focusIndex: e[e.length - 1].index
        }), this.setState({
          hasSwitchedConversation: !1
        });
      }, n.prototype.getNextFocusIndex = function (e) {
        var t = this,
          n = this.props.conversation.messages,
          r = e < 0 || e > n[n.length - 1].index,
          o = e === this.state.focusIndex;
        if (!n || !n.length || o || r) return this.state.focusIndex;
        var i = n.findIndex(function (e) {
          return e.index === t.state.focusIndex;
        });
        return n[e < this.state.focusIndex ? i - 1 : i + 1].index;
      }, n.prototype.updateFocus = function (e) {
        var t = this.props.conversation.messages,
          n = this.getNextFocusIndex(e);
        this.state.shouldFocusLatest ? this.setState({
          focusIndex: t[t.length - 1].index,
          shouldFocusLatest: !1
        }) : this.setState({
          focusIndex: n
        });
      }, n.prototype.newMessageListener = function () {
        var e;
        (null === (e = document.activeElement) || void 0 === e ? void 0 : e.hasAttribute("data-message-item")) || this.setState({
          shouldFocusLatest: !0
        });
      }, n;
    }(l.PureComponent);
    t.MessageListImpl = x;
    var T = function (e) {
      return e in v.templates ? v.templates[e]() : e;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageLoader = void 0;
    var c,
      u = n(487),
      d = l(n(0)),
      f = n(6),
      p = (0, n(1).styled)(f.FlexBox)(c || (c = o(["\n    justify-content: center;\n    margin-top: ", ";\n    margin-bottom: ", ";\n"], ["\n    justify-content: center;\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), function (e) {
        return e.theme.tokens.spacings.space70;
      }, function (e) {
        return e.theme.tokens.spacings.space30;
      }),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(t, e), t.prototype.componentDidMount = function () {
          var e = this.props.messageList;
          e && (e.scrollTop = -e.scrollHeight);
        }, t.prototype.render = function () {
          return d.createElement(d.Fragment, {
            key: "message-wrapper"
          }, d.createElement(p, {
            className: "Twilio-MessageLoader"
          }, d.createElement(u.Spinner, {
            decorative: !1,
            title: "Loading"
          })));
        }, t.displayName = "MessageLoader", t;
      }(d.PureComponent);
    t.MessageLoader = h;
  }, function (e, t) {
    e.exports = require("@twilio-paste/core/spinner");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageScrollButton = void 0;
    var l = s(n(0)),
      c = n(2),
      u = n(4),
      d = n(489),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(d.ComponentContainer, {
            className: "Twilio-MessageScrollButton",
            key: "MessageScrollButtonProps"
          }, l.createElement(d.ButtonContainer, {
            onClick: this.props.onClick
          }, l.createElement(d.TextContainer, null, this.getContent()), l.createElement(u.Icon, {
            icon: "PointerArrowDown",
            sizeMultiplier: .83
          })));
        }, t.prototype.getContent = function () {
          var e = this.props.unreadMessages.length;
          return 1 === e ? c.templates.SingleNewMessageScrollButtonText() : e >= 2 && e <= 5 ? e + " " + c.templates.FewNewMessagesScrollButtonText() : "" + c.templates.ManyNewMessagesScrollButtonText();
        }, t.displayName = "MessageScrollButton", t;
      }(l.PureComponent);
    t.MessageScrollButton = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ComponentContainer = t.TextContainer = t.ButtonContainer = void 0;
    var o,
      i,
      a,
      s = n(6),
      l = n(1);
    t.ButtonContainer = (0, l.styled)("button")(o || (o = r(["\n    ", ";\n    border-radius: ", ";\n    flex-grow: 0;\n    height: 24px;\n    font-size: ", ";\n    line-height: ", ";\n    color: #ffffff;\n    padding-top: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border: none;\n"], ["\n    ", ";\n    border-radius: ", ";\n    flex-grow: 0;\n    height: 24px;\n    font-size: ", ";\n    line-height: ", ";\n    color: #ffffff;\n    padding-top: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border: none;\n"])), function (e) {
      return e.theme.Chat.MessageList.MessageScrollButton;
    }, function (e) {
      return e.theme.tokens.radii.borderRadius30;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize40;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.spacings.space40;
    }), t.TextContainer = (0, l.styled)(s.FlexBox)(i || (i = r([""], [""]))), t.ComponentContainer = (0, l.styled)("div")(a || (a = r(["\n    justify-content: center;\n    position: absolute;\n    bottom: 12px;\n    width: 100%;\n    display: flex;\n}\n"], ["\n    justify-content: center;\n    position: absolute;\n    bottom: 12px;\n    width: 100%;\n    display: flex;\n}\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WelcomeMessage = void 0, o(n(135), t);
    var i = n(134);
    Object.defineProperty(t, "WelcomeMessage", {
      enumerable: !0,
      get: function () {
        return i.WelcomeMessage;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypingIndicatorDiv = void 0;
    var o,
      i = n(1);
    t.TypingIndicatorDiv = (0, i.styled)("div")(o || (o = r(["\n    height: 28px;\n    flex-shrink: 0;\n    display: flex;\n\n    span {\n        font-size: 10px;\n        margin-top: auto;\n        margin-bottom: auto;\n        margin-left: 12px;\n        margin-right: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", ";\n"], ["\n    height: 28px;\n    flex-shrink: 0;\n    display: flex;\n\n    span {\n        font-size: 10px;\n        margin-top: auto;\n        margin-bottom: auto;\n        margin-left: 12px;\n        margin-right: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", ";\n"])), function (e) {
      return e.theme.Chat.MessageList.TypingIndicator;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvasContextType = t.MessagingCanvasContext = t.MessagingCanvasProps = t.MessagingCanvas = t.MessageStyle = t.MemberDisplayOptions = void 0;
    var i = n(493);
    Object.defineProperty(t, "MemberDisplayOptions", {
      enumerable: !0,
      get: function () {
        return i.MemberDisplayOptions;
      }
    }), Object.defineProperty(t, "MessageStyle", {
      enumerable: !0,
      get: function () {
        return i.MessageStyle;
      }
    }), Object.defineProperty(t, "MessagingCanvas", {
      enumerable: !0,
      get: function () {
        return i.MessagingCanvas;
      }
    }), Object.defineProperty(t, "MessagingCanvasProps", {
      enumerable: !0,
      get: function () {
        return i.MessagingCanvasProps;
      }
    }), o(n(77), t);
    var a = n(21);
    Object.defineProperty(t, "MessagingCanvasContext", {
      enumerable: !0,
      get: function () {
        return a.MessagingCanvasContext;
      }
    }), Object.defineProperty(t, "MessagingCanvasContextType", {
      enumerable: !0,
      get: function () {
        return a.MessagingCanvasContextType;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvas = void 0;
    var u = c(n(0)),
      d = n(30),
      f = n(8),
      p = n(43),
      h = n(74),
      v = n(75),
      m = n(494),
      g = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          return u.createElement(b, i({}, this.props));
        }, t.displayName = m.displayName, t.Content = m.contentStore, t.Input = h.MessageInput, t.MessageList = v.MessageList, t.defaultProps = {
          avatarCallback: void 0,
          memberDisplayOptions: {
            yourDefaultName: "",
            theirDefaultName: "",
            yourFriendlyNameOverride: !0,
            theirFriendlyNameOverride: !0
          },
          messageStyle: "Rounded",
          showTypingIndicator: !0,
          showReadStatus: !0,
          showTrayOnInactive: !1,
          showWelcomeMessage: !0,
          welcomeMessageText: void 0,
          charLimit: 32768,
          autoInitConversation: !1,
          hasMarkdownSupport: !0,
          hideFooterOnInactive: !1
        }, t = l([p.withDefaultPropsUpdate], t);
      }(u.PureComponent);
    t.MessagingCanvas = g;
    var b = (0, d.connect)(function (e, t) {
      return {
        channel: f.ChatModule.stateCallback(e).channels[t.sid],
        conversation: f.ChatModule.stateCallback(e).conversations[t.sid]
      };
    })(m.MessagingCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvasImpl = t.contentStore = t.displayName = void 0;
    var c = l(n(0)),
      u = n(28),
      d = n(8),
      f = l(n(53)),
      p = n(44),
      h = n(7),
      v = n(20),
      m = n(3),
      g = n(11),
      b = n(2),
      y = n(140),
      _ = n(101),
      O = n(505),
      C = n(129),
      P = n(74),
      M = n(133),
      j = n(75),
      w = n(77),
      E = n(21);
    t.displayName = "MessagingCanvas", t.contentStore = new h.DynamicContentStore(t.displayName);
    var S = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        var e;
        m.log.debug("MessagingCanvas | Mounting: " + this.props.sid), this.props.conversation && (null === (e = this.props.conversation) || void 0 === e ? void 0 : e.source) || this.loadConversation(this.props.sid);
      }, n.prototype.componentDidUpdate = function (e) {
        e.sid !== this.props.sid && (m.log.debug("MessagingCanvas | ConversationSid update: " + e.sid + " -> " + this.props.sid), this.unloadConversations(e.sid), this.loadConversation(this.props.sid));
      }, n.prototype.componentWillUnmount = function () {
        m.log.debug("MessagingCanvas | Unmounting, starting unload conversation checks: " + this.props.sid), this.unloadConversations(this.props.sid);
      }, n.prototype.loadConversation = function (e) {
        (this.props.autoInitChannel || this.props.autoInitConversation) && (m.log.debug("MessagingCanvas | (Auto-init) Loading conversation: " + this.props.sid), g.Actions.initWithConversationSid(e));
      }, n.prototype.unloadConversations = function (e) {
        var t,
          n,
          r = d.ChatModule.state.conversations[e];
        if (r) {
          var o = (null === (t = u.ChatManager.getConversationsClient()) || void 0 === t ? void 0 : t.user.identity) || "",
            i = r.participants ? Array.from(r.participants.keys()) : [],
            a = i.some(function (e) {
              return e === o;
            }),
            s = this.props.preventConversationUnload;
          if (u.ChatManager.shouldUseLegacyUnloadConversationChecks()) if (!p.ConversationHelper.isUserParticipantOfConversation(r)) {
            if (s) return void m.log.debug("MessagingCanvas | Conversation unload prevented by prop");
            m.log.debug("MessagingCanvas | User not part of conversation (using legacy checks), unloading.\n Conversation:", r, "\n Participants:", i, "\n Current user:", o), g.Actions.unload(e);
          }
          if (i.length && !a) if (u.ChatManager.shouldUseLegacyUnloadConversationChecks()) m.log.debug("MessagingCanvas | User not part of conversation (using new checks), however, unload is prevented by legacy checks setting.\n Conversation:", r, "\n Participants:", i, "\n Current user:", o), null === (n = d.ChatModule.parentEvents) || void 0 === n || n.emit("newUnloadConversationLogicTriggered", {
            conversation: r,
            participants: i,
            currentUser: o,
            isUserParticipantOfConversation: a
          });else {
            if (s) return void m.log.debug("MessagingCanvas | Conversation unload prevented by prop");
            m.log.debug("MessagingCanvas | User not part of conversation (using new checks), unloading. Participants:", i), g.Actions.unload(e);
          }
        }
      }, n.prototype.render = function () {
        var e = this.props,
          n = e.conversation,
          r = e.conversationType,
          o = e.sid,
          a = e.inputDisabledReason;
        if (!n || !n.source) return m.log.debug("Conversation not loaded yet for MessagingCanvas", o), null;
        var s = p.ConversationHelper.isUserParticipantOfConversation(n) ? void 0 : b.templates.ChatInputUserNotMemberDisabledText(),
          l = {
            conversation: n,
            conversationType: r,
            fileAttachmentsDisabled: void 0 !== a || void 0 !== s || !(0, v.isFileAttachmentEnabled)(o)
          };
        return c.createElement(E.MessagingCanvasContext.Provider, {
          value: this.props
        }, c.createElement(w.Container, null, c.createElement(y.NotificationBar, {
          filter: function (e) {
            var t, n, r;
            return "messagingCanvas" === (null === (t = e.options) || void 0 === t ? void 0 : t.target) && (!(null === (n = e.context) || void 0 === n ? void 0 : n.conversationSid) || (null === (r = e.context) || void 0 === r ? void 0 : r.conversationSid) === o);
          }
        }), c.createElement(O.FileAttachmentDropArea, i({}, l), c.createElement(h.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, c.createElement(w.ContentContainer, {
          className: "Twilio-MessagingCanvas-Content"
        }, c.createElement(j.MessageList, {
          key: "list",
          conversationType: r
        }), this.renderFooter())))));
      }, n.prototype.renderFooter = function () {
        var e,
          t,
          n = this.props,
          r = n.conversation,
          o = n.charLimit,
          i = n.sid,
          a = n.participants,
          s = n.inputDisabledReason,
          l = n.showTrayOnInactive,
          d = n.hideFooterOnInactive,
          h = n.conversationType,
          v = p.ConversationHelper.isUserParticipantOfConversation(r),
          m = (null == r ? void 0 : r.source.attributes)[f.CHANNEL_STATUS_ATTRIBUTE],
          g = v ? void 0 : b.templates.ChatInputUserNotMemberDisabledText(),
          y = null === (t = null === (e = null == r ? void 0 : r.source) || void 0 === e ? void 0 : e.state) || void 0 === t ? void 0 : t.current,
          O = !!y && "active" !== y;
        return d && (m === f.CHANNEL_STATUS_INACTIVE || O) ? null : l && (m === f.CHANNEL_STATUS_INACTIVE || O) ? c.createElement(C.MessageCanvasTray, {
          key: "tray"
        }) : "email" === h ? c.createElement(_.EmailEditor, {
          key: "input",
          participants: a,
          disabledReason: s || g,
          conversationSid: i
        }) : u.ChatManager.shouldUseMessageInputV2() ? c.createElement(M.MessageInputV2, {
          key: "input",
          disabledReason: s || g,
          charLimit: o
        }) : c.createElement(P.MessageInput, {
          key: "input",
          disabledReason: s || g,
          charLimit: o
        });
      }, n;
    }(c.PureComponent);
    t.MessagingCanvasImpl = S;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarItem = void 0;
    var c = n(107),
      u = l(n(0)),
      d = n(81),
      f = n(13),
      p = n(2),
      h = n(496),
      v = n(142),
      m = n(143),
      g = n(501),
      b = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.closeIconOnClickHandler = function () {
            f.Notifications.dismissNotification(n.props.notification);
            var e = n.props.notification.recurrenceTimeout;
            e && window.setTimeout(function () {
              return f.Notifications.showNotification(n.props.notification.id);
            }, e);
          }, n.handleOnClick = function (e) {
            n.props.notification.onClick && n.props.notification.onClick(e);
          }, n.renderActionItem = function (e, t) {
            if (u.isValidElement(e)) {
              var r = i({}, e.props);
              e.type === m.NotificationBarAction ? e = u.cloneElement(e, i(i({}, e.props), {
                notification: n.props.notification
              })) : "function" == typeof r.onClick && (e = u.cloneElement(e, i(i({}, e.props), {
                onClick: function (e) {
                  return r.onClick(e, n.props.notification);
                }
              })));
            }
            return u.createElement(v.ActionItemContainer, {
              key: t,
              className: "Twilio-NotificationBar-ActionItemContainer"
            }, e);
          }, n.state = {
            contentExpanded: !1
          }, n;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e = this,
            t = this.props.notification.timeout;
          t && (this.timeoutID = window.setTimeout(function () {
            return e.closeIconOnClickHandler();
          }, t));
        }, t.prototype.componentDidUpdate = function (e, t) {
          var n = this;
          if (!t.contentExpanded && this.state.contentExpanded) window.clearTimeout(this.timeoutID);else if (t.contentExpanded && !this.state.contentExpanded) {
            var r = this.props.notification.timeout;
            this.timeoutID = window.setTimeout(function () {
              return n.closeIconOnClickHandler();
            }, r);
          }
        }, t.prototype.componentWillUnmount = function () {
          this.timeoutID && window.clearTimeout(this.timeoutID);
        }, t.prototype.render = function () {
          var e = this.props.notification,
            t = e.type,
            n = e.icon,
            r = e.backgroundColor,
            o = e.closeButton,
            i = e.content,
            a = e.context,
            s = e.actions,
            l = e.dropdownContent;
          return u.createElement(v.NotificationContainer, {
            className: "Twilio-NotificationBar-NotificationContainer",
            type: t,
            backgroundColor: r,
            "data-test": "notification-container"
          }, u.createElement(g.TypeIcon, {
            customIcon: n,
            type: t
          }), u.createElement(v.MessageContainer, {
            onClick: this.handleOnClick,
            className: "Twilio-NotificationBar-MessageContainer",
            "data-test": "notification-message"
          }, this.renderMessageContent(i, a), (null == l ? void 0 : l.length) ? this.renderDropdownContent(l) : null), Array.isArray(s) && s.length && u.createElement(v.ActionsContainer, {
            closeButton: o,
            className: "Twilio-NotificationBar-ActionsContainer"
          }, s.map(this.renderActionItem)), o && u.createElement(h.CloseIcon, {
            inNotificationBar: !0,
            onClick: this.closeIconOnClickHandler
          }));
        }, t.prototype.renderMessageContent = function (e, t) {
          if ("string" == typeof e && p.templates[e]) return u.createElement(p.Template, i({
            source: p.templates[e]
          }, t));
          if (u.isValidElement(e)) {
            var n = e;
            return u.cloneElement(n, i(i({}, e.props), {
              notificationContext: t
            }));
          }
          return e;
        }, t.prototype.renderDropdownContent = function (e) {
          var t = this;
          return u.createElement(u.Fragment, null, " ", u.createElement(c.Anchor, {
            title: "Toggle expanded content",
            href: "#",
            onClick: function () {
              return t.setState({
                contentExpanded: !t.state.contentExpanded
              });
            },
            "data-test": "toggle-error-bar"
          }, u.createElement(p.Template, {
            source: p.templates.AttachFileMultipleFailureExpandLink,
            expanded: this.state.contentExpanded
          })), this.state.contentExpanded ? u.createElement(v.DropdownList, {
            "aria-live": "assertive",
            "data-test": "error-list"
          }, e.map(function (e) {
            return u.createElement("li", {
              key: (0, d.v4)(),
              "data-test": "attachment-error"
            }, t.renderMessageContent(e.content, e.context));
          })) : null);
        }, t;
      }(u.PureComponent);
    t.NotificationBarItem = b;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CloseIcon = void 0;
    var r = n(497);
    Object.defineProperty(t, "CloseIcon", {
      enumerable: !0,
      get: function () {
        return r.CloseIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CloseIcon = void 0;
    var l = s(n(0)),
      c = n(2),
      u = n(4),
      d = n(498),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(d.IconButtonContainer, {
            onClick: this.props.onClick,
            className: "Twilio-NotificationBar-IconButtonContainer",
            "aria-label": this.props.inNotificationBar ? c.templates.CloseIconNotificationAriaLabel() : c.templates.CloseIconAriaLabel()
          }, l.createElement(u.Icon, {
            icon: "Close"
          }));
        }, t;
      }(l.PureComponent);
    t.CloseIcon = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconButtonContainer = void 0;
    var o,
      i = n(1);
    t.IconButtonContainer = (0, i.styled)("button")(o || (o = r(["\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    background: inherit;\n    color: inherit;\n    outline: none;\n    border: none;\n    &:focus-visible {\n        outline: ", " solid\n            ", ";\n    }\n"], ["\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    background: inherit;\n    color: inherit;\n    outline: none;\n    border: none;\n    &:focus-visible {\n        outline: ", " solid\n            ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      s = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      l = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      c = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && s(t, e, n);
        return l(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarAction = void 0;
    var u = c(n(0)),
      d = n(2),
      f = n(4),
      p = n(1),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleOnClick = function (e) {
            return t.props.onClick(e, t.props.notification);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n = this.props,
            r = n.notification,
            o = n.label,
            i = o;
          "IncomingNotificationAccept" === o ? i = "Accept" : "IncomingNotificationReject" === o && (i = "Reject");
          var a = (null === (t = null === (e = null == r ? void 0 : r.context) || void 0 === e ? void 0 : e.task) || void 0 === t ? void 0 : t.taskChannelUniqueName) || "",
            s = d.templates.NotificationActionItemAriaLabel({
              type: i,
              task: a
            });
          return u.createElement(m, {
            "aria-label": s,
            onClick: this.handleOnClick
          }, this.renderIcon(), this.renderLabel());
        }, t.prototype.renderIcon = function () {
          return this.props.icon && u.createElement(f.Icon, {
            icon: this.props.icon
          });
        }, t.prototype.renderLabel = function () {
          var e = this.props,
            t = e.notification,
            n = e.label;
          return "string" == typeof n && d.templates[n] ? u.createElement(d.Template, a({
            source: d.templates[n]
          }, t.context)) : n;
        }, t.defaultProps = {
          notification: {}
        }, t;
      }(u.PureComponent);
    t.NotificationBarAction = h;
    var v,
      m = (0, p.styled)("button")(v || (v = i(["\n    padding-right: ", ";\n    padding-left: ", ";\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    outline: none;\n    border: none;\n    cursor: pointer;\n    border-width: none;\n    border-style: none;\n    border-color: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    &:focus-visible {\n        box-shadow: 0 0 0 ", "\n            ", ";\n    }\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 12;\n    text-transform: uppercase;\n"], ["\n    padding-right: ", ";\n    padding-left: ", ";\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    outline: none;\n    border: none;\n    cursor: pointer;\n    border-width: none;\n    border-style: none;\n    border-color: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    &:focus-visible {\n        box-shadow: 0 0 0 ", "\n            ", ";\n    }\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 12;\n    text-transform: uppercase;\n"])), function (e) {
        return e.theme.tokens.spacings.space40;
      }, function (e) {
        return e.theme.tokens.spacings.space40;
      }, function (e) {
        return e.theme.tokens.borderWidths.borderWidth30;
      }, function (e) {
        return e.theme.tokens.borderColors.colorBorderNeutral;
      });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypeIcon = void 0;
    var r = n(502);
    Object.defineProperty(t, "TypeIcon", {
      enumerable: !0,
      get: function () {
        return r.TypeIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypeIcon = void 0;
    var l,
      c = s(n(0)),
      u = n(13),
      d = n(4),
      f = n(1),
      p = n(503);
    !function (e) {
      e.information = "Info", e.success = "Accept", e.warning = "AlertTriangle", e.error = "AlertError";
    }(l || (l = {}));
    var h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n = this.props,
            r = n.customIcon,
            o = n.type;
          if (r) e = r;else switch (o) {
            case u.NotificationType.success:
              e = l.success, t = this.props.theme.tokens.textColors.colorTextIconSuccess;
              break;
            case u.NotificationType.warning:
              e = l.warning, t = this.props.theme.tokens.textColors.colorTextIconWarning;
              break;
            case u.NotificationType.error:
              e = l.error, t = this.props.theme.tokens.textColors.colorTextIconError;
              break;
            default:
              e = l.information, t = this.props.theme.tokens.textColors.colorTextNeutral;
          }
          return c.createElement(p.NotificationIconContainer, {
            className: "Twilio-NotificationBar-IconTypeContainer",
            iconColor: t
          }, c.createElement(d.Icon, {
            icon: e
          }));
        }, t;
      }(c.PureComponent),
      v = (0, f.withTheme)(h);
    t.TypeIcon = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationIconContainer = void 0;
    var o,
      i = n(1);
    t.NotificationIconContainer = (0, i.styled)("div")(o || (o = r(["\n    width: 24px;\n    max-height: 24px;\n    color: ", ";\n"], ["\n    width: 24px;\n    max-height: 24px;\n    color: ", ";\n"])), function (e) {
      return e.iconColor;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBar = void 0;
    var l = s(n(0)),
      c = n(3),
      u = n(144),
      d = n(13),
      f = n(142),
      p = n(143),
      h = n(141),
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onListenerHandler = function () {
            c.log.debug("NotificationBar onListenerHandler called, forcing component update"), t.forceUpdate();
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          d.Notifications.addListener(d.NotificationEvent.notificationStatusChanged, this.onListenerHandler);
        }, t.prototype.componentWillUnmount = function () {
          d.Notifications.removeListener(d.NotificationEvent.notificationStatusChanged, this.onListenerHandler);
        }, t.prototype.render = function () {
          return l.createElement(f.NotificationBarContainer, {
            className: "Twilio-NotificationBar"
          }, u.InAppNotificationHandler.getActiveNotifications().filter(this.props.filter).map(function (e) {
            return l.createElement(h.NotificationBarItem, {
              key: e.instanceId,
              notification: e
            });
          }));
        }, t.Action = p.NotificationBarAction, t.defaultProps = {
          filter: function (e) {
            var t;
            return !(null === (t = e.options) || void 0 === t ? void 0 : t.target);
          }
        }, t;
      }(l.PureComponent);
    t.NotificationBar = v;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileAttachmentDropAreaProps = t.FileAttachmentDropArea = void 0;
    var r = n(506);
    Object.defineProperty(t, "FileAttachmentDropArea", {
      enumerable: !0,
      get: function () {
        return r.FileAttachmentDropArea;
      }
    });
    var o = n(509);
    Object.defineProperty(t, "FileAttachmentDropAreaProps", {
      enumerable: !0,
      get: function () {
        return o.FileAttachmentDropAreaProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileAttachmentDropArea = void 0;
    var r = n(30),
      o = n(8),
      i = n(507);
    t.FileAttachmentDropArea = (0, r.connect)(function (e, t) {
      var n;
      return {
        attachedFiles: (null === (n = o.ChatModule.stateCallback(e).conversationInput[t.conversation.source.sid]) || void 0 === n ? void 0 : n.attachedFiles) || []
      };
    })(i.FileAttachmentDropAreaImpl);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileAttachmentDropAreaImpl = void 0;
    var c = s(n(0)),
      u = n(20),
      d = n(36),
      f = n(10),
      p = n(508),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            dragging: !1,
            isError: !1
          }, t.checkIfError = function () {
            var e = t.props,
              n = e.attachedFiles,
              r = e.conversation,
              o = e.fileAttachmentsDisabled,
              i = (0, u.getDerivedFileLimits)(r).fileCountLimit,
              a = n.length === i;
            t.setState({
              isError: o || a
            });
          }, t.attachFiles = function (e) {
            e.length, e.item;
            var n = l(e, ["length", "item"]),
              r = t.props,
              o = r.conversation,
              i = r.channel,
              a = Object.values(n || {});
            (0, d.tryInvokeAction)("AttachFiles", {
              files: a,
              conversation: o,
              channel: i
            });
          }, t.handleDragOver = function (e) {
            t.state.dragging || t.containsFile(e.dataTransfer) && (t.checkIfError(), e.preventDefault(), e.persist(), t.setState({
              dragging: !0
            }));
          }, t.handleDrop = function (e) {
            if (e.preventDefault(), t.state.isError) t.setState({
              dragging: !1
            });else if (t.containsFile(e.dataTransfer) && t.state.dragging) {
              var n = e.dataTransfer.files;
              n && n.length && t.attachFiles(n), t.setState({
                dragging: !1
              });
            }
          }, t.handleDragLeave = function (e) {
            e.persist();
            var n = e.nativeEvent.relatedTarget;
            e.currentTarget.contains(n) || (null == n ? void 0 : n.getRootNode()) instanceof ShadowRoot || !t.state.dragging || t.setState({
              dragging: !1
            });
          }, t.containsFile = function (e) {
            return Boolean(e && e.types && e.types.find(function (e) {
              return "Files" === e;
            }));
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n = this.props,
            r = n.attachedFiles,
            o = n.conversation,
            i = n.fileAttachmentsDisabled,
            a = (0, u.getDerivedFileLimits)(o).fileCountLimit,
            s = r.length === a;
          return i ? (e = c.createElement(f.Template, {
            source: f.templates.FileAttachmentDropAreaTitleDisabled
          }), t = c.createElement(f.Template, {
            source: f.templates.FileAttachmentDropAreaSubtitleDisabled
          })) : s ? (e = c.createElement(f.Template, {
            source: f.templates.FileAttachmentDropAreaTitleFileLimitReached,
            fileCountLimit: a,
            singular: 1 === a
          }), t = c.createElement(f.Template, {
            source: f.templates.FileAttachmentDropAreaSubtitleFileLimitReached
          })) : (e = c.createElement(f.Template, {
            source: f.templates.FileAttachmentDropAreaTitle
          }), t = c.createElement(f.Template, {
            source: f.templates.FileAttachmentDropAreaSubtitle
          })), c.createElement(p.Container, {
            onDrop: this.handleDrop,
            onDragLeave: this.handleDragLeave,
            onDragOver: this.handleDragOver
          }, c.createElement(p.MainDropArea, {
            visible: this.state.dragging,
            isError: this.state.isError
          }, c.createElement(p.StyledIcon, {
            isError: this.state.isError,
            icon: this.state.isError ? "AlertError" : "FileAttachment",
            sizeMultiplier: 1.6
          }), c.createElement(p.Title, null, e), c.createElement(p.Subtitle, null, t)), this.props.children);
        }, t;
      }(c.Component);
    t.FileAttachmentDropAreaImpl = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Subtitle = t.Title = t.StyledIcon = t.MainDropArea = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(4),
      u = n(1);
    t.Container = (0, u.styled)("div")(o || (o = r(["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n"], ["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n"]))), t.MainDropArea = (0, u.styled)("div")(i || (i = r(["\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    z-index: 30;\n    border-width: 3px;\n    border-style: dashed;\n    border-radius: 3px;\n    display: ", ";\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    padding: 24px;\n    text-align: center;\n    pointer-events: none;\n    animation: ", ";\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0.9);\n        }\n        100% {\n            opacity: 1;\n            transform: scale(1);\n        }\n    }\n\n    ", "\n    ", "\n"], ["\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    z-index: 30;\n    border-width: 3px;\n    border-style: dashed;\n    border-radius: 3px;\n    display: ", ";\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    padding: 24px;\n    text-align: center;\n    pointer-events: none;\n    animation: ", ";\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0.9);\n        }\n        100% {\n            opacity: 1;\n            transform: scale(1);\n        }\n    }\n\n    ", "\n    ", "\n"])), function (e) {
      return e.visible ? "flex" : "none";
    }, function (e) {
      return e.visible ? "popIn 0.1s forwards" : "none";
    }, function (e) {
      return e.theme.Chat.FileAttachmentDropArea.MainDropArea;
    }, function (e) {
      return e.isError && e.theme.Chat.FileAttachmentDropArea.MainDropAreaError;
    }), t.StyledIcon = (0, u.styled)(c.Icon)(a || (a = r(["\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.Chat.FileAttachmentDropArea.Icon;
    }, function (e) {
      return e.isError && e.theme.Chat.FileAttachmentDropArea.IconError;
    }), t.Title = (0, u.styled)("div")(s || (s = r(["\n    font-size: 18px;\n    font-weight: bold;\n    ", "\n"], ["\n    font-size: 18px;\n    font-weight: bold;\n    ", "\n"])), function (e) {
      return e.theme.Chat.FileAttachmentDropArea.Title;
    }), t.Subtitle = (0, u.styled)("div")(l || (l = r(["\n    font-size: 14px;\n    ", "\n"], ["\n    font-size: 14px;\n    ", "\n"])), function (e) {
      return e.theme.Chat.FileAttachmentDropArea.SubTitle;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconContainer = void 0;
    var r = n(145);
    Object.defineProperty(t, "IconContainer", {
      enumerable: !0,
      get: function () {
        return r.IconContainer;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessagingCanvasImpl = t.contentStore = t.displayName = void 0;
    var s = a(n(0)),
      l = n(7),
      c = n(25),
      u = n(77),
      d = n(512),
      f = n(147);
    t.displayName = "TranscriptMessagingCanvas", t.contentStore = new c.DynamicContentStore(t.displayName);
    t.TranscriptMessagingCanvasImpl = Object.assign(function (e) {
      var n = (0, s.useMemo)(function () {
          return {
            conversation: e.conversation,
            predefinedMessage: e.predefinedMessage
          };
        }, [e]),
        o = r({}, e);
      return s.default.createElement(f.TranscriptMessagingCanvasContext.Provider, {
        value: n
      }, s.default.createElement(u.Container, null, s.default.createElement(l.DynamicComponent, {
        contentStore: t.contentStore,
        childProps: o,
        name: t.displayName,
        customChildren: e.children,
        vertical: !0
      }, s.default.createElement(u.ContentContainer, {
        className: "Twilio-TranscriptMessagingCanvas-Content"
      }, s.default.createElement(d.TranscriptMessageListImpl, {
        key: "transcriptMessageList"
      })))));
    }, {
      displayName: t.displayName
    }), t.default = t.TranscriptMessagingCanvasImpl;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessageListImpl = t.contentStore = t.displayName = void 0;
    var i = o(n(0)),
      a = n(7),
      s = n(25),
      l = n(513),
      c = n(146),
      u = n(518);
    t.displayName = "TranscriptMessageList", t.contentStore = new s.DynamicContentStore(t.displayName);
    t.TranscriptMessageListImpl = Object.assign(function (e) {
      var n = e.children,
        o = e.listContainerAriaProps,
        s = r({}, e);
      return i.default.createElement(c.TranscriptMessagingCanvasContext.Consumer, null, function (e) {
        return i.default.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: s,
          name: t.displayName,
          customChildren: n,
          noContainers: !0,
          vertical: !0,
          rootContainerStyles: "position:static;"
        }, i.default.createElement(u.ListContainer, {
          "aria-label": o && o.ariaLabel,
          "aria-live": o && o.ariaLive,
          role: "log"
        }, function (e) {
          var t,
            n = null === (t = null == e ? void 0 : e.conversation) || void 0 === t ? void 0 : t.map(function (e) {
              return i.default.createElement(l.TranscriptMessageListItemImpl, {
                "data-testid": "transcriptListItem",
                key: "" + e.sentence_index,
                message: e,
                messageStyle: "Rounded"
              });
            });
          return null == n ? void 0 : n.reverse();
        }(e)));
      });
    }, {
      displayName: t.displayName
    }), t.default = t.TranscriptMessageListImpl;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessageListItemImpl = t.store = t.displayName = void 0;
    var i = o(n(0)),
      a = n(7),
      s = n(25),
      l = n(514),
      c = n(517);
    t.displayName = "TranscriptMessageListItem", t.store = new s.DynamicContentStore(t.displayName);
    t.TranscriptMessageListItemImpl = Object.assign(function (e) {
      var n = e.message,
        o = e.messageStyle,
        s = r({}, e);
      return i.default.createElement(a.DynamicComponent, {
        contentStore: t.store,
        childProps: s,
        name: t.displayName,
        customChildren: e.children,
        vertical: !0,
        rootContainerStyles: "\n                > :first-child {\n                    overflow: visible;\n                };"
      }, i.default.createElement(c.Container, {
        className: "Twilio-TranscriptMessageListItem",
        message: n,
        messageStyle: o,
        "data-testId": "transcriptListItemContainer",
        role: "listitem"
      }, i.default.createElement(c.TranscriptMessageListItemContainer, {
        key: "transcriptListItemContainer"
      }, i.default.createElement(l.TranscriptMessageBubbleImpl, r({}, s)))));
    }, {
      displayName: t.displayName
    }), t.default = t.TranscriptMessageListItemImpl;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessageBubbleImpl = t.contentStore = t.displayName = void 0;
    var s = n(515),
      l = a(n(0)),
      c = n(80),
      u = n(7),
      d = n(25),
      f = n(2),
      p = n(4),
      h = n(145),
      v = n(516);
    t.displayName = "TranscriptMessageBubble", t.contentStore = new d.DynamicContentStore(t.displayName);
    t.TranscriptMessageBubbleImpl = Object.assign(function (e) {
      var n = e.message,
        o = n.start_time,
        i = r({}, e);
      return l.createElement(u.DynamicComponent, {
        contentStore: t.contentStore,
        childProps: i,
        name: t.displayName,
        customChildren: e.children,
        vertical: !0,
        rootContainerStyles: "> :first-child {\n                overflow: visible;\n            };"
      }, l.createElement(s.ChatMessage, {
        variant: n.role === v.ParticipantRole.END_USER ? v.MessageType.OUTBOUND : v.MessageType.INBOUND
      }, l.createElement(s.ChatBubble, {
        element: n.role === v.ParticipantRole.END_USER ? "TranscriptMessage.ChatMessage.variants.outbound.ChatBubble" : "TranscriptMessage.ChatMessage.variants.inbound.ChatBubble",
        key: "transcriptMessageBubble"
      }, n.transcript), l.createElement(s.ChatMessageMeta, {
        key: "transcriptMessageMeta",
        "aria-label": "transcript-message-meta"
      }, l.createElement(h.MessageChatMetaItemContainer, {
        key: "transcriptMessageMetaItemContainer"
      }, l.createElement(s.ChatMessageMetaItem, null, n.role !== v.ParticipantRole.END_USER ? l.createElement(l.Fragment, null, l.createElement(h.IconContainer, {
        variant: "VIRTUAL_AGENT"
      }, l.createElement(p.Icon, {
        icon: "VirtualAgent"
      })), l.createElement(h.MessageMetaContainer, null, l.createElement(c.Template, {
        "data-testid": "virtualAgentLabel",
        source: f.templates.CCAIVirtualAgent
      }), l.createElement("span", null, c.Utils.formatTimeStamp(o, "short")))) : l.createElement(l.Fragment, null, l.createElement(h.IconContainer, {
        variant: v.ParticipantRole.END_USER
      }, l.createElement(p.Icon, {
        icon: "User"
      })), l.createElement(h.MessageMetaContainer, null, l.createElement(c.Template, {
        "data-testid": "customerLabel",
        source: f.templates.CCAICustomerLabel
      }), " ", l.createElement("span", null, c.Utils.formatTimeStamp(o, "short")))))))));
    }, {
      displayName: t.displayName
    }), t.default = t.TranscriptMessageBubbleImpl;
  }, function (e, t) {
    e.exports = require("@twilio-paste/core");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageType = t.ParticipantRole = void 0, function (e) {
      e.AUTOMATED_AGENT = "AUTOMATED_AGENT", e.END_USER = "END_USER";
    }(t.ParticipantRole || (t.ParticipantRole = {})), function (e) {
      e.INBOUND = "inbound", e.OUTBOUND = "outbound";
    }(t.MessageType || (t.MessageType = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TranscriptMessageListItemContainer = t.Container = void 0;
    var i,
      a,
      s = o(n(14));
    t.Container = (0, s.default)("div")(i || (i = r(["\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n    min-width: ", ";\n    width: ", ";\n    margin-top: ", ";\n"], ["\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n    min-width: ", ";\n    width: ", ";\n    margin-top: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      var t = e.message;
      return "AUTOMATED_AGENT" === (null == t ? void 0 : t.role) ? "fit-content" : "auto";
    }, function (e) {
      var t = e.messageStyle,
        n = e.theme;
      return "Minimal" === t ? n.tokens.spacings.space70 : "Rounded" === t ? n.tokens.spacings.space60 : n.tokens.spacings.space40;
    }), t.TranscriptMessageListItemContainer = (0, s.default)("span")(a || (a = r(["\n    display: inline;\n    justify-content: flex-end;\n"], ["\n    display: inline;\n    justify-content: flex-end;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ListContainer = void 0;
    var i,
      a = o(n(14));
    t.ListContainer = (0, a.default)("div")(i || (i = r(["\n    display: flex;\n    flex-flow: column;\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n\n    &:focus-visible {\n        box-shadow: ", ";\n    }\n"], ["\n    display: flex;\n    flex-flow: column;\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n\n    &:focus-visible {\n        box-shadow: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.boxShadows.shadowFocusInset;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Combobox = void 0;
    var r = n(520);
    Object.defineProperty(t, "Combobox", {
      enumerable: !0,
      get: function () {
        return r.Combobox;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      },
      i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Combobox = void 0;
    var a = i(n(0)),
      s = i(n(521)),
      l = n(1);
    t.Combobox = (0, l.withTheme)(function (e) {
      var t = r({
          container: function (t) {
            return r(r({}, t), {
              width: e.width || "auto"
            });
          },
          clearIndicator: function () {
            return {
              display: "none"
            };
          },
          dropdownIndicator: function (e) {
            return r({}, e);
          },
          control: function (t, n) {
            var o, i, a, s, l;
            return r(r({}, t), {
              minHeight: "auto",
              cursor: "pointer",
              borderStyle: "solid",
              borderColor: null === (o = e.theme) || void 0 === o ? void 0 : o.tokens.borderColors.colorBorder,
              borderWidth: null === (i = e.theme) || void 0 === i ? void 0 : i.tokens.borderWidths.borderWidth10,
              borderRadius: null === (a = e.theme) || void 0 === a ? void 0 : a.tokens.radii.borderRadius20,
              boxShadow: n.isFocused ? "0 0 0 " + (null === (s = e.theme) || void 0 === s ? void 0 : s.tokens.borderWidths.borderWidth30) + " " + (null === (l = e.theme) || void 0 === l ? void 0 : l.tokens.borderColors.colorBorderNeutral) : ""
            });
          },
          valueContainer: function (t) {
            var n, o, i, a;
            return r(r({}, t), {
              fontSize: null === (n = e.theme) || void 0 === n ? void 0 : n.tokens.fontSizes.fontSize30,
              lineHeight: null === (o = e.theme) || void 0 === o ? void 0 : o.tokens.lineHeights.lineHeight30,
              padding: "calc(" + (null === (i = e.theme) || void 0 === i ? void 0 : i.tokens.spacings.space30) + " - 4px) " + (null === (a = e.theme) || void 0 === a ? void 0 : a.tokens.spacings.space40)
            });
          },
          menu: function (t) {
            var n;
            return r(r({}, t), {
              background: null === (n = e.theme) || void 0 === n ? void 0 : n.tokens.backgroundColors.colorBackgroundBody
            });
          },
          option: function (t, n) {
            var o, i, a, s, l, c, u;
            return r(r({}, t), {
              fontWeight: n.isSelected ? "bold" : "initial",
              color: n.isDisabled ? e.theme.tokens.textColors.colorTextWeaker : e.theme.tokens.textColors.colorText,
              padding: (null === (o = e.theme) || void 0 === o ? void 0 : o.tokens.spacings.space30) + " " + (null === (i = e.theme) || void 0 === i ? void 0 : i.tokens.spacings.space80),
              fontSize: null === (a = e.theme) || void 0 === a ? void 0 : a.tokens.fontSizes.fontSize30,
              lineHeight: null === (s = e.theme) || void 0 === s ? void 0 : s.tokens.lineHeights.lineHeight30,
              cursor: n.isDisabled ? "inherit" : "pointer",
              backgroundColor: n.isFocused ? null === (l = e.theme) || void 0 === l ? void 0 : l.tokens.backgroundColors.colorBackgroundPrimaryWeakest : n.isSelected ? null === (c = e.theme) || void 0 === c ? void 0 : c.tokens.backgroundColors.colorBackground : "inherit",
              "&:hover": {
                backgroundColor: n.isDisabled ? "inherit" : null === (u = e.theme) || void 0 === u ? void 0 : u.tokens.backgroundColors.colorBackgroundPrimaryWeakest
              }
            });
          },
          placeholder: function (e) {
            return r({}, e);
          }
        }, e.styles),
        n = (e.styles, e.theme, o(e, ["styles", "theme"]));
      return a.default.createElement(s.default, r({}, n, {
        styles: t
      }));
    });
  }, function (e, t) {
    e.exports = require("react-select");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingAnimationProps = t.ConnectingAnimation = void 0;
    var r = n(523);
    Object.defineProperty(t, "ConnectingAnimation", {
      enumerable: !0,
      get: function () {
        return r.ConnectingAnimation;
      }
    }), Object.defineProperty(t, "ConnectingAnimationProps", {
      enumerable: !0,
      get: function () {
        return r.ConnectingAnimationProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingAnimation = void 0;
    var l = s(n(0)),
      c = n(524),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.color,
            n = e.sizeMultiplier;
          return l.createElement(c.ConnectingAnimationImpl, {
            className: "Twilio-StyledConnectingAnimation",
            color: t,
            bubbleSize: 4 * n
          }, l.createElement("div", {
            className: "elipsis-1"
          }), l.createElement("div", {
            className: "elipsis-2"
          }), l.createElement("div", {
            className: "elipsis-3"
          }), l.createElement("div", {
            className: "elipsis-4"
          }));
        }, t.defaultProps = {
          color: "#FFFFFF",
          sizeMultiplier: 1
        }, t;
      }(l.PureComponent);
    t.ConnectingAnimation = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingAnimationImpl = void 0;
    var o,
      i = n(1);
    t.ConnectingAnimationImpl = (0, i.styled)("div")(o || (o = r(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    div {\n        position: absolute;\n        top: calc(50% - ", "px);\n        width: ", "px;\n        height: ", "px;\n        border-radius: 50%;\n        background-color: ", ";\n        animation-timing-function: cubic-bezier(0, 1, 1, 0);\n    }\n    div.elipsis-1 {\n        animation: loading-connection1 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-2 {\n        animation: loading-connection2 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-3 {\n        animation: loading-connection3 0.7s infinite;\n        left: calc(50% - ", "px);\n    }\n    div.elipsis-4 {\n        animation: loading-connection4 0.7s infinite;\n        left: calc(85% - ", "px);\n    }\n    @keyframes loading-connection1 {\n        0% {\n            transform: scale(0);\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n    @keyframes loading-connection2 {\n        0% {\n            left: 15%;\n        }\n        100% {\n            left: calc(50% - ", "px);\n        }\n    }\n    @keyframes loading-connection3 {\n        0% {\n            left: calc(50% - ", "px);\n        }\n        100% {\n            left: calc(85% - ", "px);\n        }\n    }\n    @keyframes loading-connection4 {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n"], ["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    div {\n        position: absolute;\n        top: calc(50% - ", "px);\n        width: ", "px;\n        height: ", "px;\n        border-radius: 50%;\n        background-color: ", ";\n        animation-timing-function: cubic-bezier(0, 1, 1, 0);\n    }\n    div.elipsis-1 {\n        animation: loading-connection1 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-2 {\n        animation: loading-connection2 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-3 {\n        animation: loading-connection3 0.7s infinite;\n        left: calc(50% - ", "px);\n    }\n    div.elipsis-4 {\n        animation: loading-connection4 0.7s infinite;\n        left: calc(85% - ", "px);\n    }\n    @keyframes loading-connection1 {\n        0% {\n            transform: scale(0);\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n    @keyframes loading-connection2 {\n        0% {\n            left: 15%;\n        }\n        100% {\n            left: calc(50% - ", "px);\n        }\n    }\n    @keyframes loading-connection3 {\n        0% {\n            left: calc(50% - ", "px);\n        }\n        100% {\n            left: calc(85% - ", "px);\n        }\n    }\n    @keyframes loading-connection4 {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n"])), function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize;
    }, function (e) {
      return e.bubbleSize;
    }, function (e) {
      return e.color;
    }, function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize;
    }, function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DataTableProps = t.DataTable = t.createSelectColumnDefinition = t.DataTableColumnDefinition = t.ColumnDefinition = void 0;
    var r = n(78);
    Object.defineProperty(t, "ColumnDefinition", {
      enumerable: !0,
      get: function () {
        return r.ColumnDefinition;
      }
    }), Object.defineProperty(t, "DataTableColumnDefinition", {
      enumerable: !0,
      get: function () {
        return r.DataTableColumnDefinition;
      }
    });
    var o = n(527);
    Object.defineProperty(t, "createSelectColumnDefinition", {
      enumerable: !0,
      get: function () {
        return o.createSelectColumnDefinition;
      }
    });
    var i = n(528);
    Object.defineProperty(t, "DataTable", {
      enumerable: !0,
      get: function () {
        return i.DataTable;
      }
    }), Object.defineProperty(t, "DataTableProps", {
      enumerable: !0,
      get: function () {
        return i.DataTableProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createSelectColumnDefinition = void 0;
    var o = n(32),
      i = r(n(83)),
      a = r(n(0)),
      s = n(78);
    t.createSelectColumnDefinition = (0, i.default)(function (e, t, n) {
      return a.default.createElement(s.ColumnDefinition, {
        key: "select",
        name: "Select",
        header: function (r) {
          var i = r.every(function (n) {
            return t[e(n)];
          });
          return a.default.createElement(o.Checkbox, {
            color: "primary",
            checked: i,
            onChange: function () {
              n(i ? r.map(function (t) {
                return e(t);
              }) : r.map(function (t) {
                return e(t);
              }).filter(function (e) {
                return !t[e];
              }));
            }
          });
        },
        content: function (r) {
          return a.default.createElement(o.Checkbox, {
            color: "primary",
            checked: !0 === t[e(r)],
            onChange: function () {
              return n(e(r));
            }
          });
        }
      });
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      },
      a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DataTable = void 0;
    var s = n(5),
      l = n(32),
      c = a(n(0)),
      u = n(3),
      d = n(78),
      f = n(148),
      p = n(529),
      h = n(531),
      v = function (e) {
        function t(t) {
          var n,
            r,
            o = e.call(this, t) || this;
          o.state = {
            sortingAsc: !1
          }, o.resetSort = function () {
            o.setState({
              sortingKey: void 0,
              sortingFn: void 0
            });
          }, o.updateColumnOrderAccPreference = function (e, t) {
            if (t.length) {
              var n = e.filter(function (e) {
                return e.props.defaultVisible;
              });
              return t.forEach(function (t) {
                var r = e.find(function (e) {
                  return e.key.includes(t);
                });
                r && n.push(r);
              }), n || e;
            }
            return e.filter(function (e) {
              return e.props.defaultVisible;
            });
          }, o.renderRows = function (e) {
            if (o.props.isLoading) return c.default.createElement(f.StyledTableRow, null, c.default.createElement(l.TableCell, {
              colSpan: e.length
            }, c.default.createElement(f.Loader, null)));
            var t = o.props,
              n = t.items,
              r = t.itemKey,
              a = t.hasHoverStyle,
              s = t.columnDataCreationContext,
              u = n;
            if (o.state.sortingFn) {
              var d = o.state.sortingFn;
              u = i([], u, !0).sort(function (e, t) {
                return (o.state.sortingAsc ? 1 : -1) * d(e, t);
              });
            }
            return u.map(function (t, n) {
              var i = t.key || (r ? r(t) : n.toString());
              return c.default.createElement(p.DataTableRow, {
                onClick: o.props.onRowClick ? function () {
                  return o.props.onRowClick(t);
                } : void 0,
                key: i,
                id: i,
                itemIndex: n,
                selected: i === o.props.selectedItemKey,
                hover: a,
                columnDefinitions: e,
                columnDataCreationContext: s,
                item: t,
                isDragTarget: n === o.state.dragTarget && n !== o.state.draggingItem,
                bottomBorderActive: void 0 !== o.state.draggingItem ? o.state.draggingItem < n : void 0,
                isDragging: n === o.state.draggingItem,
                dragStarted: o.props.onItemsReordered && function (e) {
                  o.setState({
                    draggingItem: e
                  });
                },
                dragEntered: function (e) {
                  o.setState({
                    dragTarget: e
                  });
                },
                dragEnded: o.onDragEnd
              });
            });
          }, o.onDragEnd = function () {
            if (o.state.draggingItem !== o.state.dragTarget && -1 !== o.state.draggingItem && void 0 !== o.state.draggingItem && void 0 !== o.state.dragTarget && -1 !== o.state.dragTarget) {
              var e = i([], o.props.items, !0),
                t = e.splice(o.state.draggingItem, 1)[0];
              e.splice(o.state.dragTarget, 0, t), o.props.onItemsReordered && o.props.onItemsReordered(e), o.setState({
                dragTarget: void 0,
                draggingItem: void 0
              });
            } else o.setState({
              dragTarget: void 0,
              draggingItem: void 0
            });
          };
          var a = c.default.Children.toArray(o.props.children);
          if (o.props.updatePreferenceWithNewColumns) try {
            var s = a.reduce(h.getColumsDataFromDefinitions, []);
            o.props.updatePreferenceWithNewColumns(s);
          } catch (e) {
            return o;
          }
          if (o.props.defaultSortColumn) try {
            r = a.find(function (e) {
              return e.key.match(new RegExp("\\$" + o.props.defaultSortColumn + "$"));
            });
          } catch (e) {
            return o;
          }
          return o.state = {
            sortingFn: r && r.props.sortingFn ? r.props.sortingFn : void 0,
            sortingAsc: r && "asc" === r.props.sortDirection || !1,
            sortingKey: null !== (n = r && r.key) && void 0 !== n ? n : void 0
          }, o;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.children,
            r = t.items,
            o = t.placeholder,
            a = t.preferedColumns;
          if (!this.validateChildren()) return u.log.warn("Invalid column definitions for DataTable"), null;
          if ((!r || 0 === r.length) && o) return o;
          var s = void 0 !== a ? this.updateColumnOrderAccPreference(c.default.Children.toArray(n), a) : c.default.Children.toArray(n),
            p = s.filter(function (e) {
              return !!e.props.headerColSpanKey;
            }),
            h = s.some(function (e) {
              return !!e.props.subHeader;
            }),
            v = p.length > 1,
            m = [];
          v && (m = this.createHeaderColSpans(s));
          var g = v ? m.map(function (t, n) {
            return e.createHeader(t.column, n, {
              hasSubHeaderRow: h,
              colSpan: t.colSpan
            });
          }) : s.map(function (t, n) {
            return e.createHeader(t, n, {
              hasSubHeaderRow: h
            });
          });
          this.props.onItemsReordered && (g = i([this.createHeader(c.default.createElement(d.ColumnDefinition, {
            key: "menu",
            name: "Menu",
            header: "",
            content: ""
          }), 0, {
            hasSubHeaderRow: !1
          })], g, !0));
          var b = h ? s.map(function (t, n) {
              return e.createSubHeader(t, n);
            }) : [],
            y = this.props.stickyHeader ? f.StickyTableHead : l.TableHead;
          return c.default.createElement(l.Table, null, c.default.createElement(y, null, c.default.createElement(l.TableRow, null, g), b.length > 0 && c.default.createElement(f.SubHeaderRow, null, b)), c.default.createElement(l.TableBody, null, this.renderRows(s)));
        }, t.prototype.setSortingFn = function (e, t, n) {
          e === this.state.sortingKey ? this.setState(function (e) {
            return {
              sortingAsc: !e.sortingAsc
            };
          }) : this.setState({
            sortingFn: t,
            sortingKey: e,
            sortingAsc: "asc" === n || !1
          });
        }, t.isValidColumnItem = function (e) {
          return c.default.isValidElement(e);
        }, t.prototype.validateChildren = function () {
          return !c.default.Children.toArray(this.props.children).find(function (e) {
            return !t.isValidColumnItem(e);
          });
        }, t.prototype.createHeaderColSpans = function (e) {
          return e.reduce(function (e, t) {
            var n = e.length - 1;
            return void 0 !== e[n] && void 0 !== e[n].column.props.headerColSpanKey && e[n].column.props.headerColSpanKey === t.props.headerColSpanKey ? e[n].colSpan += 1 : e.push({
              colSpan: 1,
              column: t
            }), e;
          }, []);
        }, t.prototype.createHeader = function (e, t, n) {
          var r = this,
            o = n.hasSubHeaderRow ? f.HeaderCellWithSubheader : l.TableCell;
          return c.default.createElement(o, {
            colSpan: n.colSpan,
            className: (0, s.cx)("Twilio-DataTable-Header", e.props.headerColSpanKey && "Twilio-DataTable-Header-" + e.props.headerColSpanKey, !e.props.headerColSpanKey && e.props.name && "Twilio-DataTable-Header-" + e.props.name),
            key: e.key || t,
            style: e.props.style,
            onClick: function () {
              return e.props.sortingFn && r.setSortingFn(e.key, e.props.sortingFn, e.props.sortDirection);
            }
          }, c.default.createElement(f.HeaderCellContentWrapper, {
            clickable: !!e.props.sortingFn,
            hasSubHeader: !!e.props.subHeader
          }, "function" == typeof e.props.header ? e.props.header(this.props.items, this.props.columnDataCreationContext) : e.props.header, this.state.sortingKey === e.key && !e.props.subHeader && (this.state.sortingAsc ? c.default.createElement(f.IconArrowUp, null) : c.default.createElement(f.IconArrowDown, null))));
        }, t.prototype.createSubHeader = function (e, t) {
          var n = this;
          return c.default.createElement(f.SubHeaderCell, {
            className: (0, s.cx)("Twilio-DataTable-SubHeader", e.props.name && "Twilio-DataTable-SubHeader-" + e.props.name),
            key: "subheader-" + (e.key || t),
            onClick: function () {
              return e.props.sortingFn && n.setSortingFn(e.key, e.props.sortingFn, e.props.sortDirection);
            }
          }, c.default.createElement(f.SubHeaderCellContentWrapper, {
            clickable: !!e.props.sortingFn
          }, e.props.subHeader, this.state.sortingKey === e.key && e.props.subHeader && (this.state.sortingAsc ? c.default.createElement(f.IconArrowUp, null) : c.default.createElement(f.IconArrowDown, null))));
        }, t.defaultProps = {
          hasHoverStyle: !0,
          stickyHeader: !0
        }, t;
      }(c.default.Component);
    t.DataTable = v;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      },
      u = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DataTableRow = void 0;
    var d = n(5),
      f = u(n(530)),
      p = l(n(0)),
      h = n(4),
      v = n(148),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.ref = p.createRef(), t.state = {
            dragable: !1
          }, t.onDragHandleMouseOver = function () {
            t.props.dragStarted && t.setState({
              dragable: !0
            });
          }, t.onDragHandleMouseOut = function () {
            t.props.dragStarted && t.setState({
              dragable: !1
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.item,
            n = e.columnDataCreationContext,
            r = e.columnDefinitions,
            o = e.dragStarted,
            a = e.dragEntered,
            s = e.dragEnded,
            l = e.itemIndex,
            u = c(e, ["item", "columnDataCreationContext", "columnDefinitions", "dragStarted", "dragEntered", "dragEnded", "itemIndex"]),
            m = r.map(function (e) {
              var r = e.props.content,
                o = "function" == typeof r ? r(t, n) : r;
              return p.createElement(f.default, {
                key: e.key,
                style: e.props.style,
                "data-column-name": e.props.name,
                "data-test": e.props.name,
                className: (0, d.cx)("Twilio-DataTable-Cell", e.props.name && "Twilio-DataTable-Cell-" + e.props.name)
              }, o);
            });
          return p.createElement(v.StyledTableRow, i({}, u, {
            ref: this.ref,
            draggable: !!this.props.dragStarted && this.state.dragable,
            onDragStart: function (e) {
              e.dataTransfer.effectAllowed = "move", o && o(l);
            },
            onDragEnter: function () {
              return a && a(l);
            },
            onDragEnd: function () {
              return s && s(l);
            }
          }), this.props.dragStarted ? p.createElement(f.default, {
            key: "draghandle-" + l,
            onMouseOver: this.onDragHandleMouseOver,
            onMouseOut: this.onDragHandleMouseOut,
            style: {
              cursor: "move"
            }
          }, p.createElement(h.Icon, {
            icon: "DragHandle",
            sizeMultiplier: .666
          })) : null, m);
        }, t.defaultProps = {
          selected: !1,
          hover: !0
        }, t;
      }(p.Component);
    t.DataTableRow = m;
  }, function (e, t) {
    e.exports = require("@material-ui/core/TableCell");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getColumsDataFromDefinitions = t.convertReactKeysToName = void 0;
    t.convertReactKeysToName = function (e) {
      var t = e.indexOf("$");
      return t ? e.substring(t + 1) : e;
    };
    t.getColumsDataFromDefinitions = function (e, n) {
      var r = "string" == typeof n.props.header ? n.props.header : function (e) {
          var t, n, r, o;
          return "function" == typeof (null === (n = null === (t = e.props.header) || void 0 === t ? void 0 : t.props) || void 0 === n ? void 0 : n.source) ? null === (o = null === (r = e.props.header) || void 0 === r ? void 0 : r.props) || void 0 === o ? void 0 : o.source() : "";
        }(n),
        o = "string" == typeof n.props.subHeader ? n.props.subHeader : function (e) {
          var t, n, r, o;
          return "function" == typeof (null === (n = null === (t = e.props.subHeader) || void 0 === t ? void 0 : t.props) || void 0 === n ? void 0 : n.source) ? null === (o = null === (r = e.props.subHeader) || void 0 === r ? void 0 : r.props) || void 0 === o ? void 0 : o.source() : "";
        }(n);
      return !n.props.defaultVisible && e.push({
        key: (0, t.convertReactKeysToName)(n.key),
        header: r,
        subheader: o,
        description: n.props.description || ""
      }), e;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialerThemeProps = t.DialerProps = t.Dialer = void 0;
    var r = n(533);
    Object.defineProperty(t, "Dialer", {
      enumerable: !0,
      get: function () {
        return r.Dialer;
      }
    }), Object.defineProperty(t, "DialerProps", {
      enumerable: !0,
      get: function () {
        return r.DialerProps;
      }
    }), Object.defineProperty(t, "DialerThemeProps", {
      enumerable: !0,
      get: function () {
        return r.DialerThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      c = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dialer = void 0;
    var u = s(n(0)),
      d = n(59),
      f = n(149),
      p = n(151),
      h = n(536),
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t._isMounted = !1, t.inputRef = u.createRef(), t.state = {
            phoneNumber: t.props.defaultPhoneNumber,
            selectedCountryKey: ""
          }, t.updateListeners = function (e, n) {
            n || t.updateCountryCode(e), t.setState({
              phoneNumber: e
            }), t.props.onPhoneNumberChange(e);
          }, t.onPhoneNumberReset = function () {
            t.updateListeners("");
          }, t.onDialpadClick = function (e) {
            t.props.disabled || t.updateListeners(t.state.phoneNumber + e);
          }, t.onDialpadUndo = function () {
            !t.props.disabled && t.state.phoneNumber && t.updateListeners(t.state.phoneNumber.slice(0, -1));
          }, t.onDialerPhoneInputChange = function (e) {
            var n = e.phoneNumber,
              r = e.selectedCountryKey,
              o = Boolean(r);
            o && t.setState({
              selectedCountryKey: r
            }), t.updateListeners(n, o);
          }, t.onKeyPress = function (e) {
            "ENTER" === e.key.toUpperCase() && t.state.phoneNumber.length > 0 && t.onStartOutboundCall();
          }, t.onStartOutboundCall = function () {
            var e = t.state.phoneNumber,
              n = t.props.disabled;
            e && !n && t.props.onDial(e);
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          return l(this, void 0, void 0, function () {
            var e,
              t,
              n = this;
            return c(this, function (r) {
              switch (r.label) {
                case 0:
                  return e = this.props.defaultCountryAlpha2Code, this._isMounted = !0, e ? [4, d.CountryManager.getCountryCodeForRegion(e)] : [3, 2];
                case 1:
                  (t = r.sent()) && this._isMounted && this.setState(function (r) {
                    var o = r.phoneNumber;
                    return "" === o ? {
                      phoneNumber: "+" + t,
                      selectedCountryKey: "" + e + t
                    } : (n.updateCountryCode(o), null);
                  }), r.label = 2;
                case 2:
                  return [2];
              }
            });
          });
        }, t.prototype.componentWillUnmount = function () {
          this._isMounted = !1;
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.disabled,
            n = e.defaultCountryAlpha2Code,
            r = e.hideActions,
            o = this.state,
            i = o.phoneNumber,
            a = o.selectedCountryKey,
            s = t || !i;
          return u.createElement(p.DialerContainer, {
            className: "Twilio-Dialer",
            "data-test": "dialpad"
          }, u.createElement(h.DialerPhoneInput, {
            id: "dialer-phone-input",
            ref: this.inputRef,
            value: i,
            onChange: this.onDialerPhoneInputChange,
            onKeyPress: this.onKeyPress,
            onReset: this.onPhoneNumberReset,
            disabled: t,
            defaultCountryAlpha2Code: n,
            selectedCountryKey: a
          }), u.createElement(f.Dialpad, {
            inputRef: this.inputRef,
            onClick: this.onDialpadClick,
            onUndo: this.onDialpadUndo,
            disabled: t,
            inOutboundDialer: !0
          }), !r && u.createElement(p.DialerActions, null, u.createElement(p.CallButton, {
            icon: "Call",
            variant: "primary",
            onClick: this.onStartOutboundCall,
            disabled: s
          })));
        }, t.prototype.updateCountryCode = function (e) {
          return l(this, void 0, Promise, function () {
            var t, n, r, o;
            return c(this, function (i) {
              switch (i.label) {
                case 0:
                  return t = this.state.selectedCountryKey, [4, d.CountryManager.getCountryKeyFromNumber(e)];
                case 1:
                  return n = i.sent(), r = t && t.substring(2), o = n && n.substring(2), r !== o && this.setState({
                    selectedCountryKey: n
                  }), [2];
              }
            });
          });
        }, t.defaultProps = {
          defaultPhoneNumber: "",
          onPhoneNumberChange: function () {}
        }, t;
      }(u.PureComponent);
    t.Dialer = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialpadButton = void 0;
    var l = a(n(0)),
      c = n(2),
      u = n(150),
      d = {
        "#": {
          caption: "DialpadHashCaption",
          description: "DialpadHashDescription"
        },
        "*": {
          caption: "DialpadAsteriskCaption",
          description: "DialpadAsteriskDescription"
        }
      };
    t.DialpadButton = function (e) {
      var t,
        n,
        o = e.animate,
        i = e.compact,
        a = void 0 !== i && i,
        f = e.value,
        p = e.options,
        h = e.disabled,
        v = e.handleClick,
        m = e.toggleAnimate,
        g = e.inOutboundDialer,
        b = e.longPressable,
        y = s(e, ["animate", "compact", "value", "options", "disabled", "handleClick", "toggleAnimate", "inOutboundDialer", "longPressable"]),
        _ = Number.isNaN(Number(f)) ? d[f].caption : "DialpadNum" + f + "Caption",
        O = Number.isNaN(Number(f)) ? d[f].description : "DialpadNum" + f + "Description",
        C = g ? -1 : 0;
      return l.useEffect(function () {
        return function () {
          window.clearTimeout(n), t && clearTimeout(t);
        };
      }, []), l.createElement(u.Button, r({
        compact: a,
        animate: o,
        className: "Twilio-Dialpad-Button-" + f,
        onClick: b ? void 0 : function () {
          h || null == v || v(f);
        },
        onMouseDown: b ? function () {
          t = window.setTimeout(function () {
            !h && p && (null == v || v(p)), t = null;
          }, 700);
        } : void 0,
        onMouseUp: b ? function () {
          !h && t && (null == v || v(f), window.clearTimeout(t));
        } : void 0,
        onMouseLeave: b ? function () {
          t && window.clearTimeout(t);
        } : void 0,
        onKeyPress: function (e) {
          var t = "Enter" === e.key || " " === e.key;
          !h && t && (null == v || v(f), null == m || m(f), n = window.setTimeout(function () {
            null == m || m(f);
          }, 150));
        },
        "aria-disabled": h,
        tabIndex: C,
        role: "button"
      }, y), l.createElement(u.Caption, {
        compact: a
      }, l.createElement(c.Template, {
        code: _
      })), p && l.createElement(u.Description, {
        compact: a
      }, l.createElement(c.Template, {
        code: O
      })));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialpadButtons = void 0, function (e) {
      e.ZERO = "0", e.ONE = "1", e.TWO = "2", e.THREE = "3", e.FOUR = "4", e.FIVE = "5", e.SIX = "6", e.SEVEN = "7", e.EIGHT = "8", e.NINE = "9", e.ASTERISK = "*", e.HASH = "#";
    }(t.DialpadButtons || (t.DialpadButtons = {}));
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      u = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialerPhoneInput = t.UPDATE_DIALPAD_ACTION = void 0;
    var d = l(n(0)),
      f = n(23),
      p = n(12),
      h = n(61),
      v = n(2),
      m = n(537),
      g = n(151);
    t.UPDATE_DIALPAD_ACTION = "UpdateDialPadNumber";
    var b = function (e) {
      function n() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.inputRef = d.createRef(), n.registerDialPadAction = function () {
          try {
            f.Actions.registerAction(t.UPDATE_DIALPAD_ACTION, function (e) {
              return c(n, void 0, void 0, function () {
                return u(this, function (t) {
                  return this.props.disabled || this.props.onChange({
                    phoneNumber: e
                  }), [2];
                });
              });
            });
          } catch (e) {
            throw p.ErrorManager.createAndProcessError("Registering action- UpdateDialPadNumber failed", {
              description: '"Error in registering action- UpdateDialPadNumber ',
              context: "DialerPhoneInputActions.UpdateDialPadNumber"
            });
          }
        }, n.onPhoneInputChange = function (e) {
          n.props.disabled || n.props.onChange({
            phoneNumber: e.target.value
          });
        }, n.handleKeyPress = function (e) {
          n.props.disabled || n.props.onKeyPress && n.props.onKeyPress(e);
        }, n.onCountryChange = function (e) {
          (0, n.props.onChange)({
            phoneNumber: "+" + e.code,
            selectedCountryKey: e.key
          }), n.focusOnInput();
        }, n.handleClear = function (e) {
          void 0 !== n.props.onReset && n.props.onReset(e), n.focusOnInput();
        }, n.focusOnInput = function () {
          n.inputRef.current && n.inputRef.current.focus();
        }, n;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        this.registerDialPadAction();
      }, n.prototype.render = function () {
        var e = this.props,
          t = e.id,
          n = e.forwardedRef,
          r = e.value,
          o = e.disabled,
          i = e.defaultCountryAlpha2Code,
          a = e.selectedCountryKey;
        return d.createElement(g.PhoneInputContainer, null, d.createElement(g.PhoneInput, {
          id: t,
          type: "tel",
          className: "Twilio-Dialer-PhoneInput-Input",
          "data-test": "phoneinput",
          innerRef: n,
          inputRef: this.inputRef,
          value: r,
          onChange: this.onPhoneInputChange,
          onKeyPress: this.handleKeyPress,
          "aria-disabled": o,
          autoComplete: "off",
          autoFocus: !0,
          startAdornment: d.createElement(m.CountrySelector, {
            defaultCountryAlpha2Code: i,
            selectedCountryKey: a,
            onCountryChange: this.onCountryChange,
            disabled: o
          })
        }), d.createElement(g.ClearInputButton, {
          isVisible: r.length > 0,
          onClick: this.handleClear,
          className: "Twilio-Dialer-PhoneInput-ClearButton",
          "data-test": "phoneinput-clear",
          "aria-label": v.templates.ClearButtonAriaLabel()
        }, d.createElement(h.IcnClose, {
          width: 24,
          height: 24
        })));
      }, n.defaultProps = {
        value: "",
        onReset: function () {}
      }, n;
    }(d.PureComponent);
    t.DialerPhoneInput = d.forwardRef(function (e, t) {
      return d.createElement(b, i({}, e, {
        forwardedRef: t
      }));
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountrySelector = void 0;
    var r = n(538);
    Object.defineProperty(t, "CountrySelector", {
      enumerable: !0,
      get: function () {
        return r.CountrySelector;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      c = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountrySelector = void 0;
    var u = s(n(0)),
      d = n(59),
      f = n(2),
      p = n(539),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            allCountries: [],
            filteredCountries: [],
            flagPositions: {}
          }, t.handleCountryChange = function (e) {
            if (!t.props.disabled) {
              var n = t.state.allCountries.find(function (t) {
                return t.key === e.target.value;
              });
              t.props.onCountryChange(n);
            }
          }, t.renderFlag = function (e) {
            return u.createElement(p.Flag, {
              position: t.state.flagPositions[e.substring(0, 2)]
            });
          }, t.renderCountryDetails = function (e) {
            return u.createElement(p.CountryDetails, null, u.createElement(p.CountryName, null, e.name), u.createElement(p.CountryCode, null, "(+", e.code, ")"));
          }, t.renderDefaultMenuItem = function () {
            var e = t.state.allCountries.find(function (e) {
              return e.alpha2Code === t.props.defaultCountryAlpha2Code;
            });
            return e ? u.createElement(p.StyledMenuItemWithBorder, {
              key: e.key,
              value: e.key
            }, u.createElement(p.DefaultCountry, {
              className: "Twilio-Country-Selector-Default-Country"
            }, t.renderFlag(e.key), t.renderCountryDetails(e))) : null;
          }, t.getValue = function () {
            var e,
              n = t.state.allCountries,
              r = t.props,
              o = r.selectedCountryKey,
              i = r.defaultCountryAlpha2Code;
            if (!n.length) return "";
            var a = null === (e = n.find(function (e) {
              return e.alpha2Code === i;
            })) || void 0 === e ? void 0 : e.key;
            return o || a || "";
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this._isMounted = !0, this.getCountries(), this.getFlags();
        }, t.prototype.componentWillUnmount = function () {
          this._isMounted = !1;
        }, t.prototype.getCountries = function () {
          var e;
          return l(this, void 0, void 0, function () {
            var t, n, r;
            return c(this, function (o) {
              switch (o.label) {
                case 0:
                  return [4, d.CountryManager.getAllCountries()];
                case 1:
                  return t = o.sent(), n = this.props.defaultCountryAlpha2Code, r = null === (e = t.find(function (e) {
                    return e.alpha2Code === n;
                  })) || void 0 === e ? void 0 : e.key, this._isMounted && this.setState({
                    allCountries: t,
                    filteredCountries: r ? t.filter(function (e) {
                      return e.key !== r;
                    }) : t
                  }), [2];
              }
            });
          });
        }, t.prototype.getFlags = function () {
          return l(this, void 0, void 0, function () {
            var e;
            return c(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, d.CountryManager.getAllCountriesFlagPositions()];
                case 1:
                  return e = t.sent(), this._isMounted && this.setState({
                    flagPositions: e
                  }), [2];
              }
            });
          });
        }, t.prototype.render = function () {
          var e = this,
            t = this.state.filteredCountries,
            n = this.props.disabled,
            r = {
              PaperProps: {
                component: p.SelectList,
                square: !0,
                elevation: 0
              },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              MenuListProps: {
                disablePadding: !0
              },
              getContentAnchorEl: null,
              keepMounted: !0,
              transitionDuration: 0
            };
          return u.createElement(u.Fragment, null, u.createElement(p.StyledInputLabel, {
            id: "country-selector"
          }, f.templates.CountrySelectorLabel()), u.createElement(p.StyledSelect, {
            labelId: "country-selector",
            value: this.getValue(),
            onChange: this.handleCountryChange,
            MenuProps: r,
            renderValue: this.renderFlag,
            className: "Twilio-Country-Selector",
            "data-test": "country-selector",
            "aria-disabled": n
          }, this.renderDefaultMenuItem(), t.map(function (t) {
            return u.createElement(p.StyledMenuItem, {
              disabled: n,
              key: t.key,
              value: t.key
            }, e.renderFlag(t.key), e.renderCountryDetails(t));
          })));
        }, t;
      }(u.PureComponent);
    t.CountrySelector = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountryCode = t.CountryName = t.CountryDetails = t.StyledMenuItemWithBorder = t.DefaultCountry = t.StyledMenuItem = t.SelectList = t.StyledSelect = t.StyledInputLabel = t.Flag = void 0;
    var a = i(n(117)),
      s = i(n(152)),
      l = i(n(540)),
      c = i(n(153)),
      u = n(26),
      d = n(154),
      f = n(1);
    t.Flag = (0, f.styled)("div")(p || (p = r(["\n    box-sizing: content-box;\n    width: 21px;\n    height: 14px;\n    background-repeat: no-repeat;\n    display: block;\n    margin-right: 10px;\n    flex-shrink: 0;\n    background-image: ", ";\n    background-size: 21px auto;\n    background-position: ", ";\n    border: 1px solid;\n    ", ";\n"], ["\n    box-sizing: content-box;\n    width: 21px;\n    height: 14px;\n    background-repeat: no-repeat;\n    display: block;\n    margin-right: 10px;\n    flex-shrink: 0;\n    background-image: ", ";\n    background-size: 21px auto;\n    background-position: ", ";\n    border: 1px solid;\n    ", ";\n"])), function (e) {
      return e.position && 'url("https://assets.flex.twilio.com/assets/img/flag-spritesheet.png")';
    }, function (e) {
      var t = e.position;
      return t && "0px -" + t / 2 + "px";
    }, function (e) {
      return e.theme.CountrySelector && e.theme.CountrySelector.Flag;
    });
    var p,
      h,
      v,
      m,
      g,
      b,
      y,
      _ = (0, u.withStyles)(function (e) {
        return {
          root: {
            "&:focus-visible": {
              background: "inherit"
            }
          },
          selectMenu: {
            background: "transparent"
          },
          select: {
            paddingRight: "0px !important",
            paddingLeft: e.tokens.spacings.space30
          }
        };
      })(c.default);
    t.StyledInputLabel = (0, f.styled)(a.default)(h || (h = r(["\n    display: none;\n"], ["\n    display: none;\n"]))), t.StyledSelect = (0, f.styled)(_)(v || (v = r(["\n    border-radius: 0;\n    border: 0;\n    height: 100%;\n    border-right-style: solid;\n    min-width: ", ";\n    max-width: ", ";\n    border-right-width: ", ";\n    border-right-color: ", ";\n    background: ", ";\n    padding: ", ";\n    &.MuiInput-root.Mui-focused {\n        padding: ", ";\n        border: ", " solid\n            ", ";\n        background: ", ";\n        border-right-width: ", ";\n        border-right-color: ", ';\n        border-right-style: solid;\n    }\n    &.MuiInput-root[aria-disabled="true"] {\n        opacity: 0.4;\n    }\n    & .Twilio-Dropdown {\n        height: 100%;\n        width: ', ";\n        svg {\n            top: 0;\n            bottom: 0;\n            margin: auto;\n            left: 0;\n            right: 0;\n        }\n    }\n"], ["\n    border-radius: 0;\n    border: 0;\n    height: 100%;\n    border-right-style: solid;\n    min-width: ", ";\n    max-width: ", ";\n    border-right-width: ", ";\n    border-right-color: ", ";\n    background: ", ";\n    padding: ", ";\n    &.MuiInput-root.Mui-focused {\n        padding: ", ";\n        border: ", " solid\n            ", ";\n        background: ", ";\n        border-right-width: ", ";\n        border-right-color: ", ';\n        border-right-style: solid;\n    }\n    &.MuiInput-root[aria-disabled="true"] {\n        opacity: 0.4;\n    }\n    & .Twilio-Dropdown {\n        height: 100%;\n        width: ', ";\n        svg {\n            top: 0;\n            bottom: 0;\n            margin: auto;\n            left: 0;\n            right: 0;\n        }\n    }\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare150;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare150;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderWeaker;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackground;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.spacings.space0;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackground;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderWeaker;
    }, function (e) {
      return e.theme.tokens.spacings.space70;
    }), t.SelectList = (0, u.withStyles)(function (e) {
      return {
        root: o({
          boxSizing: "border-box",
          width: 244,
          height: 170,
          overflow: "auto",
          borderStyle: "solid",
          borderWidth: 1,
          marginLeft: 1,
          borderRadius: 0,
          boxShadow: "none",
          borderTopWidth: 0,
          overflowX: "hidden",
          "& ul": {
            borderRadius: 0,
            border: 0
          }
        }, e.CountrySelector.CountryList)
      };
    })(l.default), t.StyledMenuItem = (0, u.withStyles)(function (e) {
      return {
        root: o(o({
          height: 32,
          boxSizing: "border-box",
          display: "flex",
          margin: 0,
          padding: "0 12px",
          minWidth: 0
        }, e.CountrySelector.CountryItem), {
          "&:hover, &:focus-visible": (0, d.getHover)(e.CountrySelector.CountryItem.backgroundColor, e.CountrySelector.CountryItem.lightHover),
          "&$selected": o(o({}, e.CountrySelector.CountryItem.Selected), {
            "&:hover, &:focus-visible, &:focus-visible:hover": {
              backgroundColor: e.CountrySelector.CountryItem.Selected.backgroundColor,
              backgroundImage: "initial"
            }
          })
        }),
        selected: {}
      };
    })(s.default), t.DefaultCountry = (0, f.styled)("div")(m || (m = r(["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    height: 100%;\n    align-items: center;\n    padding: 0 12px;\n    min-width: 0;\n    height: 32px;\n"], ["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    height: 100%;\n    align-items: center;\n    padding: 0 12px;\n    min-width: 0;\n    height: 32px;\n"]))), t.StyledMenuItemWithBorder = (0, u.withStyles)(function (e) {
      return {
        root: {
          padding: 0,
          borderBottom: "1px solid " + e.CountrySelector.CountryList.borderColor,
          paddingBottom: 4,
          marginBottom: 4,
          height: "auto",
          backgroundColor: "initial",
          "&:hover, &:focus-visible": {
            background: "initial",
            "& .Twilio-Country-Selector-Default-Country": (0, d.getHover)(e.CountrySelector.CountryItem.backgroundColor, e.CountrySelector.CountryItem.lightHover)
          },
          "&$selected": {
            backgroundColor: "initial",
            "&:hover, &:focus-visible, &:focus-visible:hover": {
              background: "initial"
            },
            "& .Twilio-Country-Selector-Default-Country": o({}, e.CountrySelector.CountryItem.Selected)
          }
        },
        selected: {}
      };
    })(t.StyledMenuItem), t.CountryDetails = (0, f.styled)("div")(g || (g = r(["\n    display: flex;\n    flex-grow: 1;\n    min-width: 0;\n"], ["\n    display: flex;\n    flex-grow: 1;\n    min-width: 0;\n"]))), t.CountryName = (0, f.styled)("div")(b || (b = r(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.CountryCode = (0, f.styled)("div")(y || (y = r(["\n    margin-left: 4px;\n"], ["\n    margin-left: 4px;\n"])));
  }, function (e, t) {
    e.exports = require("@material-ui/core/Paper");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SelectDropDownIcon = void 0;
    var c,
      u = l(n(542)),
      d = s(n(0)),
      f = n(6),
      p = (0, n(1).styled)(f.FlexBox)(c || (c = r(["\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    right: 0;\n    width: ", ";\n    height: ", ";\n    svg {\n        top: 0;\n        bottom: 0;\n        margin: auto;\n        left: 0;\n        right: 0;\n    }\n"], ["\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    right: 0;\n    width: ", ";\n    height: ", ";\n    svg {\n        top: 0;\n        bottom: 0;\n        margin: auto;\n        left: 0;\n        right: 0;\n    }\n"])), function (e) {
        return e.theme.tokens.spacings.space90;
      }, function (e) {
        return e.theme.tokens.spacings.space100;
      });
    t.SelectDropDownIcon = function (e) {
      return d.createElement(p, {
        className: "Twilio-Dropdown"
      }, d.createElement(u.default, o({}, e, {
        fontSize: "small"
      })));
    };
  }, function (e, t) {
    e.exports = require("@material-ui/icons/KeyboardArrowDown");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialpadButtonThemeProps = t.DialpadProps = t.Dialpad = void 0;
    var r = n(149);
    Object.defineProperty(t, "Dialpad", {
      enumerable: !0,
      get: function () {
        return r.Dialpad;
      }
    }), Object.defineProperty(t, "DialpadProps", {
      enumerable: !0,
      get: function () {
        return r.DialpadProps;
      }
    }), Object.defineProperty(t, "DialpadButtonThemeProps", {
      enumerable: !0,
      get: function () {
        return r.DialpadButtonThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessage = void 0;
    var r = n(545);
    Object.defineProperty(t, "ErrorMessage", {
      enumerable: !0,
      get: function () {
        return r.ErrorMessage;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessage = void 0;
    var l = s(n(0)),
      c = n(17),
      u = n(4),
      d = n(1),
      f = n(546),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.title,
            n = e.description,
            r = e.primaryAction,
            o = e.primaryActionTitle,
            i = e.secondaryAction,
            a = e.secondaryActionTitle,
            s = e.hideBranding;
          return l.createElement(f.ErrorMessageWrapper, null, l.createElement(u.Icon, {
            icon: "Error",
            sizeMultiplier: 1.4
          }), l.createElement("h3", null, t), n && l.createElement("h4", null, n), l.createElement(f.ActionsWrapper, null, i && a && l.createElement(c.Button, {
            id: "Twilio-error-message-secondary-action-button",
            roundCorners: !1,
            onClick: i,
            variant: "secondary"
          }, a), r && o && l.createElement(c.Button, {
            id: "Twilio-error-message-primary-action-button",
            roundCorners: !1,
            onClick: r,
            variant: "primary"
          }, o)), !s && l.createElement(f.ErrorMessageBranding, null, l.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "148",
            height: "32",
            viewBox: "0 0 148 32"
          }, l.createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
          }, l.createElement("path", {
            d: "M16,0 C24.8533333,0 32,7.14666667 32,16 C32,24.8533333 24.8533333,32 16,32 C7.14666667,32 0,24.8533333 0,16 C0,7.14666667 7.14666667,0 16,0 Z M16,1.0000029 C7.7,1.0000029 1,7.7000029 1,16.0000029 C1,24.3000029 7.7,31.0000029 16,31.0000029 C24.3,31.0000029 31,24.3000029 31,16.0000029 C31,7.7000029 24.3,1.0000029 16,1.0000029 Z"
          }), l.createElement("path", {
            d: "M11.0968035 15.7399802C11.0968035 15.4100846 11.4955068 15.2448436 11.7287493 15.4781594L11.7287493 15.4781594 14.9369883 18.6872777C15.0063822 18.7567448 15.0454391 18.8509065 15.0454391 18.9490985L15.0454391 18.9490985 15.0454391 22.3386994C15.0454391 22.6685218 14.6466625 22.8337628 14.4134933 22.600447L14.4134933 22.600447 11.205181 19.3913287C11.1357872 19.3219348 11.0968035 19.2276998 11.0968035 19.1295079L11.0968035 19.1295079zM19.3886452 10.8387068C19.4867638 10.8387068 19.5809255 10.8776904 19.6503927 10.9471576L19.6503927 10.9471576 22.8586316 14.1562759C23.0918742 14.3895917 22.9267065 14.7884415 22.5968841 14.7884415L22.5968841 14.7884415 15.0454098 14.7884415C14.8456551 14.7889545 14.6839315 14.9510445 14.6839315 15.151019 14.6839315 15.3509202 14.8456551 15.5130835 15.0454098 15.5135965L15.0454098 15.5135965 17.4977172 15.5135965C17.5959092 15.5135965 17.6899976 15.5525801 17.7593915 15.621974L17.7593915 15.621974 20.9676304 18.8311656C21.200873 19.0644081 21.0357053 19.4632579 20.7058829 19.4632579L20.7058829 19.4632579 16.9220486 19.4632579C16.8239299 19.4632579 16.7296949 19.4242743 16.6603011 19.3548071L16.6603011 19.3548071 11.205225 13.9091839C11.1358311 13.83979 11.0967742 13.7456283 11.0967742 13.6473631L11.0967742 13.6473631 11.0967742 11.2124957C11.0967742 11.0059995 11.2641402 10.8387068 11.4704166 10.8387068L11.4704166 10.8387068zM55.490105 12.1037234L52.2082216 12.1037234 52.2082216 20.8138298 51.2157165 20.8138298 51.2157165 12.1037234 48 12.1037234 48 11.1728723 55.3445376 11.1728723 55.490105 12.1037234zM71.9837349 11.1728723L68.9665195 20.8537234 68.093115 20.8537234 65.2082336 12.5691489 62.3365855 20.8537234 61.4896479 20.8537234 58.4988992 11.3058511 59.5046377 11.0797872 61.9792837 19.2579787 64.7185977 11.1728723 65.7375696 11.1728723 68.5165839 19.2579787 70.9515297 11.1728723 71.9837349 11.1728723zM76.9775393 20.8138298L75.9718008 20.8138298 75.9718008 11.1728723 76.9775393 11.1728723 76.9775393 20.8138298zM86.6295009 20.8138298L81.653742 20.8138298 81.653742 11.1728723 82.6462471 11.1728723 82.6462471 19.8829787 86.4839334 19.8829787 86.6295009 20.8138298zM91.3983374 20.8138298L90.3925989 20.8138298 90.3925989 11.1728723 91.3983374 11.1728723 91.3983374 20.8138298zM104.636551 15.9867021C104.636551 18.9388298 102.783874 21 100.110727 21 97.4375805 21 95.6113711 18.9521277 95.6113711 16.0132979 95.6113711 13.0478723 97.4640473 11 100.137194 11 102.810341 11 104.636551 13.0345745 104.636551 15.9867021zM103.591112 16C103.591112 13.5531915 102.214838 11.9042553 100.110727 11.9042553 98.0198501 11.9042553 96.6435764 13.5531915 96.6435764 15.9867021 96.6435764 18.4468085 98.0330835 20.0824468 100.123961 20.0824468 102.228072 20.0824468 103.591112 18.4468085 103.591112 16zM119.030882 12.1037234L115.021161 12.1037234 115.021161 15.4680851 118.223644 15.4680851 118.369212 16.3856383 115.021161 16.3856383 115.021161 20.8138298 114.028656 20.8138298 114.028656 11.1728723 119.030882 11.1728723 119.030882 12.1037234zM127.809439 20.8138298L122.83368 20.8138298 122.83368 11.1728723 123.826185 11.1728723 123.826185 19.8829787 127.663872 19.8829787 127.809439 20.8138298zM136.812964 20.8138298L131.479903 20.8138298 131.479903 11.1728723 136.667397 11.1728723 136.667397 12.1037234 132.472408 12.1037234 132.472408 15.3085106 135.793992 15.3085106 135.939559 16.2393617 132.472408 16.2393617 132.472408 19.8962766 136.812964 19.8962766 136.812964 20.8138298zM148 20.6808511L146.994262 20.893617 143.950579 16.5053191 141.012764 20.8138298 139.914392 20.8138298 143.381543 15.8005319 140.25846 11.3191489 141.250965 11.106383 143.963813 15.0691489 146.610493 11.1728723 147.708865 11.1728723 144.532849 15.7739362 148 20.6808511z"
          })))));
        }, t.displayName = "ErrorMessage", t.defaultProps = {
          title: "Error",
          hideBranding: !1
        }, t;
      }(l.PureComponent),
      h = (0, d.withTheme)(p);
    t.ErrorMessage = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionsWrapper = t.ErrorMessageWrapper = t.ErrorMessageBranding = void 0;
    var o,
      i,
      a,
      s = n(1);
    t.ErrorMessageBranding = s.styled.div(o || (o = r(["\n    position: absolute;\n    bottom: ", ";\n"], ["\n    position: absolute;\n    bottom: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space110;
    }), t.ErrorMessageWrapper = s.styled.div(i || (i = r(["\n    background-color: ", ";\n    color: ", ";\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: ", ";\n    box-sizing: border-box;\n    position: relative;\n\n    h3 {\n        font-size: ", ";\n        font-weight: ", ";\n        font-stretch: normal;\n        font-style: normal;\n        line-height: ", ";\n        letter-spacing: normal;\n        margin: ", ";\n        max-width: ", ";\n    }\n\n    h4 {\n        font-size: ", ";\n        font-weight: ", ";\n        font-stretch: normal;\n        font-style: normal;\n        line-height: ", ";\n        letter-spacing: normal;\n        margin: ", ";\n        max-width: ", ";\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: ", ";\n    box-sizing: border-box;\n    position: relative;\n\n    h3 {\n        font-size: ", ";\n        font-weight: ", ";\n        font-stretch: normal;\n        font-style: normal;\n        line-height: ", ";\n        letter-spacing: normal;\n        margin: ", ";\n        max-width: ", ";\n    }\n\n    h4 {\n        font-size: ", ";\n        font-weight: ", ";\n        font-stretch: normal;\n        font-style: normal;\n        line-height: ", ";\n        letter-spacing: normal;\n        margin: ", ";\n        max-width: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundBody;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }, function (e) {
      return e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize50;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightNormal;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight50;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.sizings.size70;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightNormal;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.theme.tokens.spacings.space70;
    }, function (e) {
      return e.theme.tokens.sizings.size70;
    }), t.ActionsWrapper = s.styled.div(a || (a = r(["\n    button {\n        margin: 0 ", ";\n    }\n"], ["\n    button {\n        margin: 0 ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListItemType = t.FilterDefinition = t.FiltersListProps = t.FiltersList = void 0;
    var r = n(155);
    Object.defineProperty(t, "FiltersList", {
      enumerable: !0,
      get: function () {
        return r.FiltersList;
      }
    }), Object.defineProperty(t, "FiltersListProps", {
      enumerable: !0,
      get: function () {
        return r.FiltersListProps;
      }
    }), Object.defineProperty(t, "FilterDefinition", {
      enumerable: !0,
      get: function () {
        return r.FilterDefinition;
      }
    }), Object.defineProperty(t, "FiltersListItemType", {
      enumerable: !0,
      get: function () {
        return r.FiltersListItemType;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Form = void 0;
    var o,
      i = n(1);
    t.Form = (0, i.styled)("form")(o || (o = r(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListButtons = void 0;
    var r = n(550);
    Object.defineProperty(t, "FiltersListButtons", {
      enumerable: !0,
      get: function () {
        return r.FiltersListButtons;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListButtons = void 0;
    var l = s(n(0)),
      c = n(551),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.label,
            n = e.resetLabel,
            r = e.applyLabel,
            o = e.handleResetClick,
            i = e.applyButtonDisabled,
            a = e.resetButtonDisabled;
          return l.createElement(c.Container, {
            noGrow: !0,
            className: "Twilio-FilterListButtons-Container"
          }, l.createElement("div", {
            className: "Twilio-FilterListButtons-Label"
          }, t), l.createElement("div", null, l.createElement(c.ResetButton, {
            className: "Twilio-FilterListButtons-ResetButton",
            "data-test": "reset",
            roundCorners: !1,
            onClick: o,
            disabled: a,
            variant: "secondary"
          }, n), l.createElement(c.ApplyButton, {
            className: "Twilio-FilterListButtons-ApplyButton",
            roundCorners: !1,
            disabled: i,
            variant: "primary",
            type: "submit",
            "data-test": "submit"
          }, r)));
        }, t.defaultProps = {
          applyButtonDisabled: !1,
          resetButtonDisabled: !1
        }, t;
      }(l.PureComponent);
    t.FiltersListButtons = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ResetButton = t.ApplyButton = t.Container = void 0;
    var o,
      i,
      a,
      s = n(17),
      l = n(6),
      c = n(1);
    t.Container = (0, c.styled)(l.FlexBox)(o || (o = r(["\n    align-items: center;\n    justify-content: space-between;\n    padding: ", ";\n"], ["\n    align-items: center;\n    justify-content: space-between;\n    padding: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space50;
    }), t.ApplyButton = (0, c.styled)(s.Button)(i || (i = r(["\n    margin-left: ", ";\n    ", ";\n"], ["\n    margin-left: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.FilterList.ApplyButton;
    }), t.ResetButton = (0, c.styled)(s.Button)(a || (a = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.FilterList.ResetButton;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListItem = void 0;
    var r = n(553);
    Object.defineProperty(t, "FiltersListItem", {
      enumerable: !0,
      get: function () {
        return r.FiltersListItem;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListItem = void 0;
    var c = n(554),
      u = s(n(0)),
      d = n(3),
      f = n(10),
      p = n(2),
      h = n(6),
      v = n(155),
      m = n(156),
      g = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.isChecked = function (e, t) {
            return Array.isArray(t) && t.indexOf(e) > -1 || t instanceof String && t === e;
          }, t.handleChange = function (e) {
            t.props.handleChange(e);
          }, t.handleCheckboxChange = function (e, n) {
            n = null != n ? n : [];
            var r = Array.isArray(n) ? n : [n],
              o = r.indexOf(e);
            o > -1 ? r.splice(o, 1) : r = l(l([], r, !0), [e], !1), t.handleChange(r);
          }, t.getOptionFromValue = function (e) {
            var n;
            return e && (null === (n = t.props.options) || void 0 === n ? void 0 : n.find(function (t) {
              return t.value === e;
            }));
          }, t.handleExtendClick = function (e) {
            var n = t.props,
              r = n.handleExpandClick,
              o = n.id;
            e.preventDefault(), r(o);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this.props,
            n = t.title,
            r = t.showExpandToggle,
            o = t.isExpanded,
            i = t.id;
          return r && (e = o ? p.templates.HideFilterButtonAriaLabel({
            title: n
          }) : p.templates.ExpandFilterButtonAriaLabel({
            title: n
          })), u.createElement(m.Container, {
            className: "Twilio-FilterListItem-Container",
            isExpanded: o,
            showExpandToggle: r
          }, u.createElement(m.Header, {
            className: "Twilio-FilterListItem-Header",
            htmlFor: r ? "filterFor" + i : void 0,
            isExpanded: o,
            showExpandToggle: r
          }, r && u.createElement(m.ExpandIconWrapper, null, u.createElement(m.ExpandIconButton, {
            isExpanded: o,
            icon: "Filter",
            type: "button",
            id: "filterFor" + i,
            onClick: this.handleExtendClick,
            size: "small",
            title: e,
            "aria-label": e
          })), u.createElement(h.FlexBox, {
            vertical: !0
          }, u.createElement(m.Title, {
            className: "Twilio-FilterListItem-Title"
          }, n), u.createElement(m.Label, {
            className: "Twilio-FilterListItem-Label",
            "data-test": "filter-value"
          }, this.renderLabel()))), u.createElement(m.FieldContainer, {
            className: "Twilio-FilterListItem-FieldContainer",
            "data-test": "filter-list",
            isExpanded: o,
            showExpandToggle: r
          }, this.renderField()));
        }, t.prototype.renderLabel = function () {
          var e = this.props,
            t = e.type,
            n = e.currentValue,
            r = e.customStructure,
            o = e.options,
            i = Array.isArray(n) && o && this.getOptionFromValue(n[0]);
          if (r) return r.label ? u.cloneElement(r.label, {
            currentValue: n,
            activeOption: i
          }) : (d.log.error("Please provide a `filter.customStructure.label` ReactElement."), null);
          if (t === v.FiltersListItemType.multiValue) {
            var a = p.templates.FilterItemAmountSelected;
            return (n || []).length ? 1 === n.length && (a = p.templates.FilterItemOnly) : a = p.templates.FilterItemAny, u.createElement(f.Template, {
              source: a,
              amount: Array.isArray(n) && n.length,
              item: i
            });
          }
        }, t.prototype.renderField = function () {
          var e = this,
            t = this.props,
            n = t.currentValue,
            r = t.customStructure,
            o = t.fieldName,
            i = t.options,
            a = t.type;
          return r ? r.field ? u.cloneElement(r.field, {
            options: i,
            currentValue: n,
            name: o,
            handleChange: this.handleChange
          }) : (d.log.error("Please provide a `filter.customStructure.field` ReactElement."), null) : a === v.FiltersListItemType.multiValue ? u.createElement(c.CheckboxGroup, {
            name: o,
            legend: "",
            "aria-label": o
          }, null == i ? void 0 : i.map(function (t) {
            return u.createElement(c.Checkbox, {
              id: t.value + "___" + o,
              key: t.value + "___" + o,
              "data-test": "filter-" + t.value,
              value: t.value,
              checked: e.isChecked(t.label, n),
              onChange: function () {
                return e.handleCheckboxChange(t.label, n);
              }
            }, t.label);
          })) : void 0;
        }, t;
      }(u.PureComponent);
    t.FiltersListItem = g;
  }, function (e, t) {
    e.exports = require("@twilio-paste/core/checkbox");
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LegacyFiltersItem = void 0;
    var l = n(32),
      c = s(n(0)),
      u = n(2),
      d = n(157),
      f = n(156),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            isSelectOpen: !1
          }, t.handleSelectOpen = function () {
            t.setState({
              isSelectOpen: !0
            });
          }, t.handleSelectClose = function () {
            t.setState({
              isSelectOpen: !1
            });
          }, t.handleSelectChange = function (e) {
            t.props.onSelectLegacyFilterQuery(e.target.value);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return c.createElement(f.Container, {
            className: "Twilio-FilterListItem-Container",
            isExpanded: !0,
            showExpandToggle: !1
          }, c.createElement(f.Header, {
            className: "Twilio-FilterListItem-Header",
            isExpanded: !1,
            showExpandToggle: !1
          }, c.createElement(f.Title, {
            className: "Twilio-FilterListItem-Title"
          }, c.createElement(u.Template, {
            source: u.templates.LegacyFiltersTitle
          }))), c.createElement(f.FieldContainer, {
            className: "Twilio-FilterListItem-FieldContainer",
            isExpanded: !0,
            showExpandToggle: !1
          }, c.createElement(d.StyledSelect, {
            open: this.state.isSelectOpen,
            onClose: this.handleSelectClose,
            onOpen: this.handleSelectOpen,
            value: this.props.selectedLegacyFilterQuery,
            onChange: this.handleSelectChange,
            displayEmpty: !0,
            error: !1
          }, c.createElement(l.MenuItem, {
            key: "none",
            value: ""
          }, c.createElement(u.Template, {
            source: u.templates.LegacyFiltersEmptySelectLabel
          })), this.props.filters.map(function (e) {
            return c.createElement(l.MenuItem, {
              key: e.query,
              value: e.query
            }, e.text || e.query);
          }))));
        }, t;
      }(c.Component);
    t.LegacyFiltersItem = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxGroup = t.ThumbsUpOrDownItem = t.TextareaItem = t.SelectItem = t.RadioItem = t.InputItem = t.FormAttributes = t.DynamicForm = void 0;
    var r = n(557);
    Object.defineProperty(t, "DynamicForm", {
      enumerable: !0,
      get: function () {
        return r.DynamicForm;
      }
    }), Object.defineProperty(t, "FormAttributes", {
      enumerable: !0,
      get: function () {
        return r.FormAttributes;
      }
    });
    var o = n(158);
    Object.defineProperty(t, "InputItem", {
      enumerable: !0,
      get: function () {
        return o.InputItem;
      }
    });
    var i = n(159);
    Object.defineProperty(t, "RadioItem", {
      enumerable: !0,
      get: function () {
        return i.RadioItem;
      }
    });
    var a = n(160);
    Object.defineProperty(t, "SelectItem", {
      enumerable: !0,
      get: function () {
        return a.SelectItem;
      }
    });
    var s = n(161);
    Object.defineProperty(t, "TextareaItem", {
      enumerable: !0,
      get: function () {
        return s.TextareaItem;
      }
    });
    var l = n(162);
    Object.defineProperty(t, "ThumbsUpOrDownItem", {
      enumerable: !0,
      get: function () {
        return l.ThumbsUpOrDownItem;
      }
    });
    var c = n(569);
    Object.defineProperty(t, "CheckboxGroup", {
      enumerable: !0,
      get: function () {
        return c.CheckboxGroup;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(558), t), o(n(22), t);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DynamicForm = void 0;
    var c = l(n(0)),
      u = n(2),
      d = n(17),
      f = n(158),
      p = n(159),
      h = n(160),
      v = n(161),
      m = n(162),
      g = n(22),
      b = {
        InputItem: f.InputItem,
        SelectItem: h.SelectItem,
        TextareaItem: v.TextareaItem,
        RadioItem: p.RadioItem,
        ThumbsUpOrDownItem: m.ThumbsUpOrDownItem
      },
      y = function (e) {
        function t() {
          var n = null !== e && e.apply(this, arguments) || this;
          return n.state = {
            formData: {},
            errors: {},
            touchedFields: {},
            submitDisabled: !1,
            mounted: !1
          }, n.submitForm = function (e) {
            e.preventDefault();
            var r = n.props,
              o = r.formAttributes,
              i = o.fields,
              a = o.name,
              s = r.submitFormCallback,
              l = t.getErrors(i, n.state.formData);
            t.hasErrors(l) ? n.setState({
              errors: l
            }) : s && s(n.state.formData, a);
          }, n.handleChange = function (e) {
            var r = e.target;
            n.setState(function (e) {
              var o,
                a,
                s = n.props.formAttributes.fields.find(function (e) {
                  return e.attributes.name === r.name;
                }),
                l = i(i({}, e.formData), "checkbox" === s.attributes.type ? ((o = {})[r.name] = r.checked, o) : ((a = {})[r.name] = r.value || "", a)),
                c = t.validateField(l, e.errors, s);
              return {
                formData: l,
                errors: c,
                submitDisabled: t.hasErrors(c)
              };
            });
          }, n.handleBlur = function (e) {
            var t = e.target;
            n.state.touchedFields[t.name] || n.setState(function (e) {
              var n;
              return {
                touchedFields: i(i({}, e.touchedFields), (n = {}, n[t.name] = !0, n))
              };
            });
          }, n;
        }
        return o(t, e), t.getDerivedStateFromProps = function (e, n) {
          var r = e.formAttributes,
            o = n.mounted ? n.formData : r.fields.reduce(t.getInitialFieldValue, i({}, n.formData)),
            a = n.mounted ? n.errors : t.getErrors(r.fields, o);
          return i(i({}, n), {
            formData: o,
            errors: a,
            mounted: !0,
            submitDisabled: t.hasErrors(a)
          });
        }, t.getInitialFieldValue = function (e, t) {
          var n = t,
            r = n.options && n.options.find(function (e) {
              return e.selected;
            });
          if (r) e[t.attributes.name] = r.value;else if ("checkbox" === t.attributes.type) e[t.attributes.name] = !1;else {
            var o = t.attributes.value;
            e[t.attributes.name] = void 0 !== o ? o : "";
          }
          return e;
        }, t.validateField = function (e, t, n) {
          var r = n.attributes,
            o = r.required,
            a = r.name,
            s = e[a];
          return o && !s || "checkbox" === n.attributes.type && o && !s ? t[a] = c.createElement(u.Template, {
            source: u.templates.FieldValidationRequiredField
          }) : "email" === n.attributes.type && s && !s.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? t[a] = c.createElement(u.Template, {
            source: u.templates.FieldValidationInvalidEmail
          }) : t[a] = null, i({}, t);
        }, t.prototype.render = function () {
          var e = this,
            t = this.props.formAttributes;
          return c.createElement(g.Form, {
            className: "Twilio-DynamicForm",
            onSubmit: this.submitForm
          }, t.description && c.createElement(g.Description, null, t.description), t.message && c.createElement("div", {
            className: "message"
          }, c.createElement("p", null, t.message)), t.fields.map(function (t, n) {
            var r = b[t.type];
            return r && c.createElement(r, {
              key: n,
              error: e.state.errors[t.attributes.name],
              handleChange: e.handleChange,
              handleBlur: e.handleBlur,
              message: e.props.message,
              stateData: e.state.formData[t.attributes.name],
              touched: e.state.touchedFields[t.attributes.name],
              field: t
            });
          }), c.createElement(d.Button, {
            variant: "primary",
            roundCorners: !0,
            disabled: this.state.submitDisabled,
            className: "Twilio-DynamicForm-submit"
          }, t.submitLabel || "Submit"));
        }, t.getErrors = function (e, n) {
          return e.reduce(t.validateField.bind(null, n), {});
        }, t.hasErrors = function (e) {
          return Object.keys(e).some(function (t) {
            return e[t];
          });
        }, t;
      }(c.Component);
    t.DynamicForm = y;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InputItem = void 0;
    var l = s(n(0)),
      c = n(22),
      u = n(1),
      d = n(560),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n,
            r,
            o,
            i = this.props,
            a = i.field,
            s = i.error,
            u = i.handleChange,
            f = i.stateData,
            p = i.touched,
            h = i.handleBlur,
            v = l.createElement(d.StyledInput, {
              name: null === (e = a.attributes) || void 0 === e ? void 0 : e.name,
              type: null === (t = a.attributes) || void 0 === t ? void 0 : t.type,
              onChange: u,
              onBlur: h,
              value: f,
              error: p && !!s,
              readOnly: null === (n = a.attributes) || void 0 === n ? void 0 : n.readOnly,
              placeholder: null === (r = a.attributes) || void 0 === r ? void 0 : r.placeholder
            }),
            m = (null === (o = a.attributes) || void 0 === o ? void 0 : o.required) ? " *" : "",
            g = a.label ? a.label + m : null;
          return l.createElement(d.Container, null, g && l.createElement(c.Label, null, g), v, p && s && l.createElement(c.FieldErrorMessage, null, s));
        }, t;
      }(l.PureComponent),
      p = (0, u.withTheme)(f);
    t.InputItem = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.StyledInput = void 0;
    var i,
      a,
      s = n(1),
      l = o(n(40)),
      c = n(22);
    t.StyledInput = (0, s.styled)(l.default)(i || (i = r(["\n    width: 100%;\n    box-sizing: border-box;\n    height: 32px;\n    input {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"], ["\n    width: 100%;\n    box-sizing: border-box;\n    height: 32px;\n    input {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"]))), t.Container = (0, s.styled)(c.FieldContainer)(a || (a = r(["\n    ", ";\n"], ["\n    ", ";\n"])), function (e) {
      return e.theme.FormComponents.Input;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RadioItem = void 0;
    var l = s(n(0)),
      c = n(562),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n,
            r = this.props.field,
            o = this.props.error ? {
              color: "red"
            } : void 0;
          return l.createElement(c.Container, null, l.createElement("input", {
            name: null === (e = r.attributes) || void 0 === e ? void 0 : e.name,
            type: "radio",
            onChange: this.props.handleChange,
            checked: this.props.stateData === (null === (t = r.attributes) || void 0 === t ? void 0 : t.value),
            value: null === (n = r.attributes) || void 0 === n ? void 0 : n.value
          }), r.label ? l.createElement("label", {
            style: o
          }, r.label) : l.createElement("span", null));
        }, t;
      }(l.PureComponent);
    t.RadioItem = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(1);
    t.Container = (0, i.styled)("div")(o || (o = r(["\n    display: block;\n    clear: both;\n    margin: 5px 0 5px 0;\n\n    label {\n        font-size: 12px;\n        color: #222222;\n        line-height: 1.5;\n        height: 18px;\n        margin-bottom: 4px;\n        margin-left: 7px;\n    }\n"], ["\n    display: block;\n    clear: both;\n    margin: 5px 0 5px 0;\n\n    label {\n        font-size: 12px;\n        color: #222222;\n        line-height: 1.5;\n        height: 18px;\n        margin-bottom: 4px;\n        margin-left: 7px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SelectItem = void 0;
    var c = s(n(0)),
      u = n(22),
      d = l(n(152)),
      f = n(157),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n,
            r = this.props,
            o = r.field,
            i = r.touched,
            a = r.error,
            s = r.handleBlur,
            l = r.handleChange,
            p = (null === (e = o.attributes) || void 0 === e ? void 0 : e.required) ? " *" : "",
            h = o.label ? o.label + p : null,
            v = c.createElement(f.StyledSelect, {
              name: null === (t = o.attributes) || void 0 === t ? void 0 : t.name,
              onChange: l,
              value: this.props.stateData,
              onBlur: s,
              error: i && !!a,
              readOnly: null === (n = o.attributes) || void 0 === n ? void 0 : n.readOnly
            }, o.options.map(function (e) {
              return c.createElement(d.default, {
                key: e.label + e.value,
                value: e.value
              }, e.label);
            }));
          return c.createElement(f.Container, null, o.label && c.createElement(u.Label, null, h), v, i && a && c.createElement(u.FieldErrorMessage, null, a));
        }, t;
      }(c.PureComponent);
    t.SelectItem = p;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextareaItem = void 0;
    var l = s(n(0)),
      c = n(22),
      u = n(1),
      d = n(565),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t,
            n,
            r,
            o,
            i = this.props,
            a = i.field,
            s = i.error,
            u = i.handleChange,
            f = i.touched,
            p = i.handleBlur,
            h = i.stateData,
            v = (null === (e = a.attributes) || void 0 === e ? void 0 : e.required) ? " *" : "",
            m = a.label ? a.label + v : null,
            g = l.createElement(d.StyledTextArea, {
              name: null === (t = a.attributes) || void 0 === t ? void 0 : t.name,
              onChange: u,
              onBlur: p,
              error: f && !!s,
              placeholder: null === (n = a.attributes) || void 0 === n ? void 0 : n.placeholder,
              rows: null === (r = a.attributes) || void 0 === r ? void 0 : r.rows,
              readOnly: null === (o = a.attributes) || void 0 === o ? void 0 : o.readOnly,
              value: h,
              multiline: !0
            });
          return l.createElement(d.Container, null, a.label && l.createElement(c.Label, null, m), g, f && s && l.createElement(c.FieldErrorMessage, null, s));
        }, t;
      }(l.PureComponent),
      p = (0, u.withTheme)(f);
    t.TextareaItem = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.StyledTextArea = void 0;
    var i,
      a,
      s = n(1),
      l = n(22),
      c = o(n(40));
    t.StyledTextArea = (0, s.styled)(c.default)(i || (i = r(["\n    box-sizing: border-box;\n    width: 100%;\n    resize: none;\n    outline: 0;\n    height: initial;\n    display: block;\n\n    &::placeholder {\n        opacity: 0.5;\n    }\n\n    textarea {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"], ["\n    box-sizing: border-box;\n    width: 100%;\n    resize: none;\n    outline: 0;\n    height: initial;\n    display: block;\n\n    &::placeholder {\n        opacity: 0.5;\n    }\n\n    textarea {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"]))), t.Container = (0, s.styled)(l.FieldContainer)(a || (a = r(["\n    ", ";\n"], ["\n    ", ";\n"])), function (e) {
      return e.theme.FormComponents.TextArea;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThumbsUpOrDownItem = void 0;
    var l = s(n(0)),
      c = n(567),
      u = n(163),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {}, t.handleClick = function (e) {
            var n;
            t.setState({
              selected: e
            }), e === u.ThumbDirections.up ? n = t.props.field.attributes.upValue : void 0 !== e && (n = t.props.field.attributes.downValue), t.props.handleChange({
              target: {
                value: n,
                name: t.props.field.attributes.name
              }
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(c.Container, {
            className: "Twilio-ThumbsUpThumbsDown"
          }, l.createElement("div", {
            className: "label"
          }, l.createElement("p", null, this.props.field.label)), l.createElement(c.ItemGroup, null, l.createElement(u.ThumbButton, {
            direction: u.ThumbDirections.up,
            icon: "thumbup",
            selected: this.state.selected === u.ThumbDirections.up,
            handleClick: this.handleClick
          }), l.createElement(u.ThumbButton, {
            direction: u.ThumbDirections.down,
            icon: "thumbdown",
            selected: this.state.selected === u.ThumbDirections.down,
            handleClick: this.handleClick
          })));
        }, t;
      }(l.Component);
    t.ThumbsUpOrDownItem = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ItemGroup = t.Container = void 0;
    var o,
      i,
      a = n(1);
    t.Container = (0, a.styled)("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 11px;\n\n    background: #fff;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 11px;\n\n    background: #fff;\n"]))), t.ItemGroup = (0, a.styled)("div")(i || (i = r(["\n    display: flex;\n    margin-top: 5px;\n"], ["\n    display: flex;\n    margin-top: 5px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThumbButtonContainer = void 0;
    var o,
      i = n(1);
    t.ThumbButtonContainer = (0, i.styled)("div")(o || (o = r(["\n    cursor: pointer;\n\n    input {\n        opacity: 0;\n        margin: 0;\n        height: 0;\n        width: 0;\n        padding: 0;\n        position: absolute;\n    }\n\n    .circle {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #ffffff;\n        border-radius: 50%;\n        margin: 6px;\n\n        background: #233659;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n\n    .circle-selected {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #028cff;\n        border-radius: 50%;\n        background: #028cff;\n        margin: 6px;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n"], ["\n    cursor: pointer;\n\n    input {\n        opacity: 0;\n        margin: 0;\n        height: 0;\n        width: 0;\n        padding: 0;\n        position: absolute;\n    }\n\n    .circle {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #ffffff;\n        border-radius: 50%;\n        margin: 6px;\n\n        background: #233659;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n\n    .circle-selected {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #028cff;\n        border-radius: 50%;\n        background: #028cff;\n        margin: 6px;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxGroup = void 0;
    var c = n(32),
      u = s(n(0)),
      d = n(6),
      f = n(1),
      p = n(22),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.value = [], t.handleCheckboxChange = function (e) {
            var n;
            n = e.target.checked ? l(l([], t.props.stateData.filter(function (t) {
              return t !== e.target.value;
            }), !0), [e.target.value], !1) : l([], t.props.stateData.filter(function (t) {
              return t !== e.target.value;
            }), !0), t.props.handleChange(n);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this.props,
            n = t.field,
            r = t.error,
            o = t.touched,
            i = (null === (e = n.attributes) || void 0 === e ? void 0 : e.required) ? " *" : "",
            a = n.label ? n.label + i : null;
          return u.createElement(d.FlexBox, {
            vertical: !0
          }, a && u.createElement(p.Label, null, a), this.renderInputs(), o && r && u.createElement(p.FieldErrorMessage, null, r));
        }, t.prototype.renderInputs = function () {
          var e,
            t = this,
            n = this.props,
            r = n.field,
            o = n.stateData,
            i = n.handleBlur;
          return null === (e = r.options) || void 0 === e ? void 0 : e.map(function (e) {
            var n, a, s;
            return u.createElement("div", {
              key: e.id || e.value
            }, u.createElement(c.FormControlLabel, {
              key: e.id || e.value,
              label: e.label,
              htmlFor: e.id || e.value,
              control: u.createElement(c.Checkbox, {
                id: e.id || e.value,
                value: e.value,
                name: null === (n = r.attributes) || void 0 === n ? void 0 : n.name,
                required: null === (a = r.attributes) || void 0 === a ? void 0 : a.required,
                readOnly: null === (s = r.attributes) || void 0 === s ? void 0 : s.readOnly,
                checked: (o || []).indexOf(e.value) >= 0,
                onChange: t.handleCheckboxChange,
                onBlur: i,
                color: "primary"
              })
            }));
          });
        }, t;
      }(u.PureComponent),
      v = (0, f.withTheme)(h);
    t.CheckboxGroup = v;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LegendLabelPosition = t.LegendItemProps = t.LegendProps = t.Legend = void 0;
    var r = n(571);
    Object.defineProperty(t, "Legend", {
      enumerable: !0,
      get: function () {
        return r.Legend;
      }
    }), Object.defineProperty(t, "LegendProps", {
      enumerable: !0,
      get: function () {
        return r.LegendProps;
      }
    }), Object.defineProperty(t, "LegendItemProps", {
      enumerable: !0,
      get: function () {
        return r.LegendItemProps;
      }
    });
    var o = n(164);
    Object.defineProperty(t, "LegendLabelPosition", {
      enumerable: !0,
      get: function () {
        return o.LabelPosition;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Legend = void 0;
    var c = l(n(0)),
      u = n(164),
      d = n(573),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.items,
            r = t.showLabels;
          return c.createElement(d.Container, null, n.map(function (t) {
            return c.createElement(u.LegendItem, i({
              key: t.label,
              showLabel: r,
              labelPosition: e.props.labelPosition,
              renderMarker: e.props.renderMarker
            }, t));
          }));
        }, t.defaultProps = {
          items: [],
          showLabels: !0
        }, t;
      }(c.PureComponent);
    t.Legend = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Label = t.ValueWrapper = t.Value = t.Disc = t.ItemWrapper = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(1);
    t.ItemWrapper = (0, c.styled)("div")(o || (o = r(["\n    & + & {\n        margin-left: ", ";\n    }\n"], ["\n    & + & {\n        margin-left: ", ";\n    }\n"])), function (e) {
      return e.theme.tokens.spacings.space70;
    }), t.Disc = (0, c.styled)("dt")(i || (i = r(["\n    height: ", ";\n    width: ", ";\n    line-height: ", "; // used as sizing in this case\n    border-radius: 50%;\n    background-color: ", ";\n    margin-right: ", ";\n"], ["\n    height: ", ";\n    width: ", ";\n    line-height: ", "; // used as sizing in this case\n    border-radius: 50%;\n    background-color: ", ";\n    margin-right: ", ";\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.color || e.theme.tokens.textColors.colorText;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }), t.Value = (0, c.styled)("dd")(a || (a = r(["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    }), t.ValueWrapper = (0, c.styled)("div")(s || (s = r(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n"], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n"]))), t.Label = (0, c.styled)("div")(l || (l = r(["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.theme.tokens.textColors.colorText;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var i,
      a = o(n(14));
    t.Container = (0, a.default)("div")(i || (i = r(["\n    display: flex;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    justify-content: space-between;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MenuItemProps = t.MenuItem = t.StyledUl = t.MenuThemeProps = t.MenuProps = t.Menu = void 0;
    var r = n(575);
    Object.defineProperty(t, "Menu", {
      enumerable: !0,
      get: function () {
        return r.Menu;
      }
    }), Object.defineProperty(t, "MenuProps", {
      enumerable: !0,
      get: function () {
        return r.MenuProps;
      }
    }), Object.defineProperty(t, "MenuThemeProps", {
      enumerable: !0,
      get: function () {
        return r.MenuThemeProps;
      }
    });
    var o = n(165);
    Object.defineProperty(t, "StyledUl", {
      enumerable: !0,
      get: function () {
        return o.StyledUl;
      }
    });
    var i = n(576);
    Object.defineProperty(t, "MenuItem", {
      enumerable: !0,
      get: function () {
        return i.MenuItem;
      }
    }), Object.defineProperty(t, "MenuItemProps", {
      enumerable: !0,
      get: function () {
        return i.MenuItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Menu = void 0;
    var u = n(5),
      d = l(n(0)),
      f = n(165),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = e.className,
            r = c(e, ["children", "className"]);
          return d.createElement(f.StyledUl, i({
            className: (0, u.cx)("Twilio-Menu", n)
          }, r), t);
        }, t;
      }(d.PureComponent);
    t.Menu = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MenuItem = void 0;
    var l = n(5),
      c = a(n(0)),
      u = n(577);
    t.MenuItem = c.forwardRef(function (e, t) {
      var n = e.className,
        o = e.children,
        i = s(e, ["className", "children"]);
      return c.createElement("li", null, c.createElement(u.StyledButton, r({
        ref: t,
        className: (0, l.cx)("Twilio-MenuItem", n)
      }, i), o));
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledButton = void 0;
    var o,
      i = n(1);
    t.StyledButton = i.styled.button(o || (o = r(["\n    display: block;\n    width: 100%;\n    cursor: pointer;\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    padding: ", ";\n\n    margin-top: auto;\n    margin-bottom: auto;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n    ", ";\n    color: ", ";\n    &:focus-visible {\n        color: ", ";\n        font-style: underline;\n        background: ", ";\n    }\n    &:hover {\n        color: ", ";\n        font-style: underline;\n    }\n"], ["\n    display: block;\n    width: 100%;\n    cursor: pointer;\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    padding: ", ";\n\n    margin-top: auto;\n    margin-bottom: auto;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n    ", ";\n    color: ", ";\n    &:focus-visible {\n        color: ", ";\n        font-style: underline;\n        background: ", ";\n    }\n    &:hover {\n        color: ", ";\n        font-style: underline;\n    }\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight30;
    }, function (e) {
      return e.selected ? e.theme.tokens.fontWeights.fontWeightBold : e.theme.tokens.fontWeights.fontWeightNormal;
    }, function (e) {
      return e.theme.tokens.spacings.space30 + " " + e.theme.tokens.spacings.space70;
    }, function (e) {
      return e.styleOverride && e.styleOverride.Item;
    }, function (e) {
      return e.selected && e.theme.tokens.textColors.colorTextLink;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextLink;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundStrong;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextLink;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopup = void 0;
    var l = n(5),
      c = s(n(0)),
      u = n(579),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleBlur = function (e) {
            t.props.isOpen && t.props.autoClose && (e && e.persist && e.persist(), setTimeout(function () {
              t.isChildOfRoot(e.relatedTarget) || t.hide(e);
            }, 100));
          }, t.setRootElementRef = function (e) {
            t.rootElementRef = e;
          }, t.setElementRef = function (e) {
            t.elementRef = e;
          }, t;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          e.isOpen && !this.props.isOpen && this.control && this.control.focus();
        }, t.prototype.render = function () {
          var e = this.calculateAnchorPos();
          return c.createElement(u.Container, {
            className: (0, l.cx)("Twilio-ModalPopup", this.props.className),
            onBlur: this.handleBlur,
            ref: this.setRootElementRef
          }, c.createElement(u.ModalContainer, {
            className: "Twilio-ModalPopup-ModalContainer",
            alignRight: this.props.alignRight,
            anchorX: e.X,
            anchorY: e.Y,
            isOpen: this.props.isOpen,
            ref: this.setElementRef
          }, this.props.children));
        }, t.prototype.calculateAnchorPos = function () {
          if (!this.rootElementRef || !this.elementRef) return {
            X: 0,
            Y: 0
          };
          var e = this.rootElementRef.getBoundingClientRect(),
            t = this.elementRef.getBoundingClientRect(),
            n = this.props.alignRight ? window.innerWidth - e.right : e.left;
          return n + t.width > window.innerWidth ? {
            X: 0,
            Y: e.bottom
          } : {
            X: n,
            Y: e.bottom
          };
        }, t.prototype.hide = function (e) {
          void 0 === e && (e = void 0), this.props.onBlur && this.props.onBlur(e);
        }, t.prototype.setEntryControl = function (e) {
          e && (e.onblur = this.handleBlur, this.control = e);
        }, t.prototype.isChildOfRoot = function (e) {
          for (; e;) {
            if (e === this.rootElementRef) return !0;
            e = e.parentElement;
          }
          return !1;
        }, t.displayName = "ModalPopup", t;
      }(c.PureComponent);
    t.ModalPopup = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.ModalContainer = void 0;
    var i,
      a,
      s = o(n(14)),
      l = n(47);
    t.ModalContainer = (0, s.default)("div")(i || (i = r(["\n    position: fixed;\n    top: ", "px;\n    left: ", ";\n    right: ", ";\n    bottom: auto;\n\n    ", "\n"], ["\n    position: fixed;\n    top: ", "px;\n    left: ", ";\n    right: ", ";\n    bottom: auto;\n\n    ", "\n"])), function (e) {
      return e.anchorY;
    }, function (e) {
      return e.alignRight ? "auto" : e.anchorX + "px";
    }, function (e) {
      return e.alignRight ? e.anchorX + "px" : "auto";
    }, function (e) {
      return l.Animations.FadeInOutTransition(e.isOpen);
    }), t.Container = (0, s.default)("div")(a || (a = r(["\n    position: relative;\n    z-index: 1300;\n    flex: 1;\n    display: flex;\n"], ["\n    position: relative;\n    z-index: 1300;\n    flex: 1;\n    display: flex;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopupWithEntryControlProps = t.ModalPopupWithEntryControl = void 0;
    var r = n(581);
    Object.defineProperty(t, "ModalPopupWithEntryControl", {
      enumerable: !0,
      get: function () {
        return r.ModalPopupWithEntryControl;
      }
    }), Object.defineProperty(t, "ModalPopupWithEntryControlProps", {
      enumerable: !0,
      get: function () {
        return r.ModalPopupWithEntryControlProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopupWithEntryControl = void 0;
    var l = n(5),
      c = s(n(0)),
      u = n(166),
      d = n(582),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onEntryButtonBlur = function (e) {
            t.modalPopup.handleBlur(e);
          }, t.onModalBlur = function (e) {
            var n, r;
            e.relatedTarget !== t.entryButtonRef && (null === (r = (n = t.props).onChange) || void 0 === r || r.call(n, !1));
          }, t.setEntryControlRef = function (e) {
            t.entryButtonRef = e;
          }, t.setModalPopupRef = function (e) {
            t.modalPopup = e, e && t.modalPopup.setEntryControl(t.entryButtonRef);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this,
            n = this.props.className,
            r = this.getEntryControl(),
            o = c.cloneElement(r, ((e = {
              onClick: function () {
                var e, n;
                return null === (n = (e = t.props).onChange) || void 0 === n ? void 0 : n.call(e, !t.props.isOpen);
              },
              onBlur: this.onEntryButtonBlur
            })["function" == typeof r.type ? "innerRef" : "ref"] = this.setEntryControlRef, e));
          return c.createElement(d.Container, {
            className: (0, l.cx)("Twilio-ModalPopupWithEntryControl", n)
          }, o, c.createElement(d.Container, {
            className: "Twilio-ModalPopupWithEntryControl-MenuContainer"
          }, c.createElement(u.ModalPopup, {
            alignRight: this.props.alignRight,
            autoClose: this.props.autoClose,
            isOpen: this.props.isOpen,
            onBlur: this.onModalBlur,
            ref: this.setModalPopupRef
          }, this.props.children)));
        }, t.prototype.getEntryControl = function () {
          var e = this.props.entryControl;
          return "function" == typeof e ? e(this.props.isOpen) : e;
        }, t.defaultProps = {
          className: ""
        }, t;
      }(c.PureComponent);
    t.ModalPopupWithEntryControl = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var i,
      a = o(n(14));
    t.Container = (0, a.default)("div")(i || (i = r(["\n    display: inline-flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n"], ["\n    display: inline-flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PopoverMenuItem = t.PopoverMenu = void 0;
    var r = n(584);
    Object.defineProperty(t, "PopoverMenu", {
      enumerable: !0,
      get: function () {
        return r.PopoverMenu;
      }
    }), Object.defineProperty(t, "PopoverMenuItem", {
      enumerable: !0,
      get: function () {
        return r.PopoverMenuItem;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      },
      l = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PopoverMenuItem = t.PopoverMenu = void 0;
    var c = n(32),
      u = s(n(0)),
      d = n(17),
      f = n(15),
      p = n(4),
      h = n(1),
      v = n(2),
      m = u.default.createContext({
        closeMenu: function () {}
      }),
      g = {
        vertical: "bottom",
        horizontal: "left"
      },
      b = {
        vertical: "top",
        horizontal: "left"
      };
    t.PopoverMenu = function (e) {
      var t = e.text,
        n = e.children,
        r = e.variant,
        i = void 0 === r ? "secondary" : r,
        a = e.anchorOrigin,
        s = void 0 === a ? g : a,
        h = e.transformOrigin,
        y = void 0 === h ? b : h,
        _ = e.disabled,
        O = void 0 !== _ && _,
        C = l(e, ["text", "children", "variant", "anchorOrigin", "transformOrigin", "disabled"]),
        P = u.default.useState(null),
        M = P[0],
        j = P[1],
        w = (0, u.useCallback)(function () {
          j(null);
        }, [j]),
        E = (0, u.useCallback)(function (e) {
          j(e.currentTarget);
        }, [j]);
      return u.default.createElement(u.default.Fragment, null, t ? u.default.createElement(d.Button, o({
        "aria-controls": "popover-menu",
        "aria-haspopup": "true",
        variant: i,
        onClick: E,
        disabled: O
      }, C), t, u.default.createElement(p.Icon, {
        icon: "ArrowDown"
      })) : u.default.createElement(f.IconButton, o({
        "aria-controls": "customized-menu",
        "aria-haspopup": "true",
        variant: i,
        icon: "More",
        title: v.templates.QualityManagementPopoverMenuButtonAriaLabel(),
        "aria-label": v.templates.QualityManagementPopoverMenuButtonAriaLabel(),
        onClick: E,
        themeOverride: {
          borderWidth: 0
        },
        disabled: O
      }, C)), u.default.createElement(c.Menu, {
        id: "popover-menu",
        open: Boolean(M),
        onClose: w,
        anchorEl: M,
        elevation: 0,
        keepMounted: !0,
        getContentAnchorEl: null,
        anchorOrigin: s,
        transformOrigin: y
      }, u.default.createElement(m.Provider, {
        value: {
          closeMenu: w
        }
      }, n)));
    };
    var y,
      _,
      O = h.styled.div(y || (y = r(["\n    display: flex;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    justify-content: space-between;\n"]))),
      C = (0, h.styled)(p.Icon)(_ || (_ = r(["\n    margin-left: ", ";\n"], ["\n    margin-left: ", ";\n"])), function (e) {
        return e.theme.tokens.spacings.space50;
      });
    t.PopoverMenuItem = function (e) {
      var t = e.onClick,
        n = e.icon,
        r = e.children,
        i = l(e, ["onClick", "icon", "children"]),
        a = (0, u.useContext)(m).closeMenu,
        s = (0, u.useCallback)(function (e) {
          a(), t && t(e);
        }, [t, a]);
      return u.default.createElement(c.MenuItem, o({
        tabIndex: 0,
        onClick: s
      }, i), n ? u.default.createElement(O, null, r, u.default.createElement(C, {
        icon: n
      })) : r);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScreenReaderAlert = void 0;
    var r = n(586);
    Object.defineProperty(t, "ScreenReaderAlert", {
      enumerable: !0,
      get: function () {
        return r.ScreenReaderAlert;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScreenReaderAlert = void 0;
    var c = l(n(0)),
      u = n(167),
      d = n(13),
      f = n(2),
      p = n(587),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onListenerHandler = function () {
            t.forceUpdate();
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          d.Notifications.addListener(d.NotificationEvent.notificationStatusChanged, this.onListenerHandler);
        }, t.prototype.componentWillUnmount = function () {
          d.Notifications.removeListener(d.NotificationEvent.notificationStatusChanged, this.onListenerHandler);
        }, t.prototype.renderMessageContent = function (e, t) {
          if (!e) return "";
          var n = "string" == typeof e && f.templates[e];
          if (n) return c.createElement(f.Template, i({
            source: n
          }, t));
          if (c.isValidElement(e)) {
            var r = e;
            return c.cloneElement(r, i(i({}, e.props), {
              notificationContext: t
            }));
          }
          return e;
        }, t.prototype.render = function () {
          var e = u.ScreenReaderNotificationHandler.getActiveNotifications();
          return c.createElement(p.ScreenReaderAlertContainer, {
            className: "Twilio-ScreenReaderAlert",
            "aria-live": "assertive",
            "aria-atomic": "true"
          }, this.renderMessageContent(null == e ? void 0 : e.content, null == e ? void 0 : e.context));
        }, t.defaultProps = {
          filter: function (e) {
            var t;
            return !(null === (t = e.options) || void 0 === t ? void 0 : t.target);
          }
        }, t;
      }(c.Component);
    t.ScreenReaderAlert = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScreenReaderAlertContainer = void 0;
    var o,
      i = n(1);
    t.ScreenReaderAlertContainer = (0, i.styled)("div")(o || (o = r(["\n    position: absolute;\n    text-indent: -10000px;\n"], ["\n    position: absolute;\n    text-indent: -10000px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SidePanelProps = t.SidePanel = void 0;
    var r = n(589);
    Object.defineProperty(t, "SidePanel", {
      enumerable: !0,
      get: function () {
        return r.SidePanel;
      }
    }), Object.defineProperty(t, "SidePanelProps", {
      enumerable: !0,
      get: function () {
        return r.SidePanelProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SidePanel = void 0;
    var l = s(n(0)),
      c = n(7),
      u = n(2),
      d = n(590),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = e.displayName,
            r = void 0 === n ? "SidePanel" : n,
            o = e.contentStore,
            i = e.isHidden,
            a = e.childrenProps,
            s = e.className;
          return o ? l.createElement(d.Wrapper, {
            className: s,
            isHidden: i
          }, l.createElement(c.DynamicComponent, {
            contentStore: o,
            name: r,
            childProps: a,
            customChildren: t,
            vertical: !0
          }, this.renderContent())) : l.createElement(d.Wrapper, {
            className: s,
            isHidden: i
          }, this.renderContent());
        }, t.prototype.renderContent = function () {
          var e = this.props,
            t = e.children,
            n = e.themeOverride,
            r = e.displayName;
          return l.createElement(d.MainContainer, {
            noShrink: !0,
            vertical: !0,
            themeOverride: n.Container,
            className: "Twilio-SidePanel-Container Twilio-SidePanel-" + r + "-Container"
          }, this.renderHeader(), t);
        }, t.prototype.renderHeader = function () {
          var e = this.props,
            t = e.title,
            n = e.HeaderComponent,
            r = e.themeOverride,
            o = e.handleCloseClick,
            i = e.displayName;
          return n || l.createElement(d.HeaderContainer, {
            themeOverride: r.Header,
            key: "header",
            noShrink: !0,
            noGrow: !0,
            className: "Twilio-SidePanel-HeaderContainer Twilio-SidePanel-" + i + "-HeaderContainer"
          }, l.createElement(d.Title, {
            className: "Twilio-SidePanel-Title Twilio-SidePanel-" + i + "-Title"
          }, l.createElement("h3", null, t)), l.createElement(d.StyledIconButton, {
            "data-test": "close-button",
            key: "close-button",
            icon: "Close",
            onClick: o,
            themeOverride: r.HeaderButton,
            className: "Twilio-SidePanel-IconButton Twilio-SidePanel-" + i + "-IconButton",
            variant: "secondary",
            "aria-label": u.templates.CloseOutboundDialerPadAriaLabel(),
            ref: this.props.closeRef
          }), this.props.rightButton);
        }, t.defaultProps = {
          isHidden: !1,
          childrenProps: {},
          themeOverride: {}
        }, t;
      }(l.PureComponent);
    t.SidePanel = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIconButton = t.MainContainer = t.Wrapper = t.HeaderContainer = t.Title = void 0;
    var o,
      i,
      a,
      s,
      l,
      c = n(6),
      u = n(15),
      d = n(1);
    t.Title = (0, d.styled)(c.FlexBox)(o || (o = r(["\n    align-items: center;\n    font-weight: ", ";\n    justify-content: flex-start;\n    line-height: ", ";\n    font-size: ", ";\n"], ["\n    align-items: center;\n    font-weight: ", ";\n    justify-content: flex-start;\n    line-height: ", ";\n    font-size: ", ";\n"])), function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight50;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize60;
    }), t.HeaderContainer = (0, d.styled)(c.FlexBox)(i || (i = r(["\n    padding: ", ";\n    align-items: center;\n    ", "\n    ", "\n"], ["\n    padding: ", ";\n    align-items: center;\n    ", "\n    ", "\n"])), function (e) {
      var t = e.theme.tokens.spacings;
      return t.space40 + " " + t.space50 + " " + t.space40 + " " + t.space50;
    }, function (e) {
      return e.theme.SidePanel.Header;
    }, function (e) {
      return e.themeOverride;
    }), t.Wrapper = (0, d.styled)("div")(a || (a = r(["\n    display: ", ";\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    width: 320px;\n"], ["\n    display: ", ";\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    width: 320px;\n"])), function (e) {
      return e.isHidden ? "none" : "flex";
    }), t.MainContainer = (0, d.styled)(c.FlexBox)(s || (s = r(["\n    border-width: 0 0 0 1px;\n    border-style: solid;\n    ", "\n    ", "\n"], ["\n    border-width: 0 0 0 1px;\n    border-style: solid;\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.SidePanel.Container;
    }, function (e) {
      return e.themeOverride;
    }), t.StyledIconButton = (0, d.styled)(u.IconButton)(l || (l = r(["\n    border-width: ", ";\n    color: ", ";\n    :focus {\n        border-width: ", ";\n        border-color: ", ";\n        background-color: ", ";\n    }\n    &:not(:focus) {\n        border: none;\n    }\n"], ["\n    border-width: ", ";\n    color: ", ";\n    :focus {\n        border-width: ", ";\n        border-color: ", ";\n        background-color: ", ";\n    }\n    &:not(:focus) {\n        border: none;\n    }\n"])), function (e) {
      return e.theme.tokens.borderWidths.borderWidth0;
    }, function (e) {
      return e.theme.tokens.textColors.colorTextIconInverse;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundPrimaryWeakest;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SortableList = void 0;
    var r = n(592);
    Object.defineProperty(t, "SortableList", {
      enumerable: !0,
      get: function () {
        return r.SortableList;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SortableList = void 0;
    var a = n(168),
      s = n(593),
      l = i(n(0)),
      c = n(594);
    t.SortableList = function (e) {
      var t = e.items,
        n = e.onChange,
        r = e.renderItem,
        o = (0, l.useState)(null),
        i = o[0],
        u = o[1],
        d = (0, l.useMemo)(function () {
          return t.find(function (e) {
            return e.id === (null == i ? void 0 : i.id);
          });
        }, [i, t]),
        f = (0, a.useSensors)((0, a.useSensor)(a.PointerSensor), (0, a.useSensor)(a.KeyboardSensor, {
          coordinateGetter: s.sortableKeyboardCoordinates
        }), (0, a.useSensor)(a.MouseSensor));
      return l.default.createElement(a.DndContext, {
        sensors: f,
        onDragStart: function (e) {
          var t = e.active;
          u(t);
        },
        onDragEnd: function (e) {
          var r = e.active,
            o = e.over;
          if (o && r.id !== (null == o ? void 0 : o.id)) {
            var i = t.findIndex(function (e) {
                return e.id === r.id;
              }),
              a = t.findIndex(function (e) {
                return e.id === o.id;
              });
            n((0, s.arrayMove)(t, i, a));
          }
          u(null);
        },
        onDragCancel: function () {
          u(null);
        }
      }, l.default.createElement(s.SortableContext, {
        items: t
      }, t.map(function (e) {
        return l.default.createElement(l.default.Fragment, {
          key: e.id
        }, r(e));
      })), l.default.createElement(c.SortableOverlay, null, d ? r(d) : null));
    };
  }, function (e, t) {
    e.exports = require("@dnd-kit/sortable");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SortableOverlay = void 0;
    var o = n(168),
      i = r(n(0)),
      a = {
        sideEffects: (0, o.defaultDropAnimationSideEffects)({
          styles: {
            active: {
              opacity: "0.4"
            }
          }
        })
      };
    t.SortableOverlay = function (e) {
      var t = e.children;
      return i.default.createElement(o.DragOverlay, {
        dropAnimation: a
      }, t);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LastSplitterState = t.SplitContentContainerState = t.SplitContentContainerProps = t.SplitContentContainer = void 0;
    var r = n(596);
    Object.defineProperty(t, "SplitContentContainer", {
      enumerable: !0,
      get: function () {
        return r.SplitContentContainer;
      }
    }), Object.defineProperty(t, "SplitContentContainerProps", {
      enumerable: !0,
      get: function () {
        return r.SplitContentContainerProps;
      }
    }), Object.defineProperty(t, "SplitContentContainerState", {
      enumerable: !0,
      get: function () {
        return r.SplitContentContainerState;
      }
    }), Object.defineProperty(t, "LastSplitterState", {
      enumerable: !0,
      get: function () {
        return r.LastSplitterState;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SplitContentContainer = t.LastSplitterState = void 0;
    var l = n(5),
      c = s(n(0)),
      u = n(3),
      d = n(597);
    function f() {
      window.getSelection && (window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().removeAllRanges());
    }
    var p = function () {};
    t.LastSplitterState = p;
    var h = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.lastState = {
          hasManuallyResized: !1,
          firstPanelSize: 0
        }, n.handleWindowResize = function () {
          n.reInit();
        }, n.handleMouseMove = function (e) {
          if (n.state.resizing) {
            if (0 === e.buttons) return void n.setState({
              resizing: !1
            });
            n.hasManuallyResized = !0, f();
            var t = n.props.vertical ? n.mouseDownY - e.clientY : n.mouseDownX - e.clientX;
            n.setState({
              firstPanelSize: n.clampSize(n.firstPanelSizeAtResize - t)
            }), n.props.onResize && n.props.onResize();
          }
        }, n.handleSplitterMouseDown = function (e) {
          f(), n.mouseDownX = e.clientX, n.mouseDownY = e.clientY, n.firstPanelSizeAtResize = n.state.firstPanelSize, n.setState({
            resizing: !0
          });
        }, n.handleMouseUp = function () {
          n.setState({
            resizing: !1
          });
        }, n.setContainer = function (e) {
          n.container = e;
        }, n.setSplitterDOM = function (e) {
          n.splitterDOM = e;
        }, n.state = {
          firstPanelSize: 0,
          mainContainerSize: 0,
          resizing: !1
        }, n;
      }
      return o(t, e), t.prototype.componentDidMount = function () {
        var e = this;
        window.addEventListener("resize", this.handleWindowResize), window.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("mouseup", this.handleMouseUp), "IntersectionObserver" in window && (this.onIntersection = new IntersectionObserver(function () {
          return e.reInit();
        }), this.onIntersection.observe(this.container)), this.props.lastSplitterState ? (this.lastState.hasManuallyResized = this.props.lastSplitterState.hasManuallyResized, this.lastState.firstPanelSize = this.props.lastSplitterState.firstPanelSize, this.initBasedOnLastState()) : this.reInit();
      }, t.prototype.componentDidUpdate = function (e) {
        e.vertical !== this.props.vertical && this.initBasedOnLastState();
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize), window.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), this.onIntersection && this.onIntersection.disconnect(), this.props.lastSplitterState && (this.props.lastSplitterState.firstPanelSize = this.state.firstPanelSize, this.props.lastSplitterState.hasManuallyResized = this.hasManuallyResized);
      }, t.prototype.initBasedOnLastState = function () {
        var e,
          t = this.lastState;
        this.lastState = {
          hasManuallyResized: this.hasManuallyResized,
          firstPanelSize: this.state.firstPanelSize
        }, this.hasManuallyResized = t.hasManuallyResized, this.hasManuallyResized && (e = t.firstPanelSize), this.reInit(e);
      }, t.prototype.renderPanel = function (e, t) {
        var n = {};
        if (t) {
          var r = this.state.firstPanelSize + "px";
          this.props.vertical ? n.height = r : n.width = r, n.flex = "0 0 auto";
        } else {
          r = Math.max(0, this.state.mainContainerSize - this.state.firstPanelSize) + "px";
          this.props.vertical ? n.height = r : n.width = r, n.flex = "0 0 auto";
        }
        return c.createElement(d.Pane, {
          className: "Twilio-Splitter-Pane",
          style: n
        }, e);
      }, t.prototype.reInit = function (e, t) {
        void 0 === e && (e = void 0), void 0 === t && (t = this.container);
        var n = t.getBoundingClientRect(),
          r = this.props.vertical ? n.height : n.width;
        if (!r && t.parentNode && t.parentNode.getBoundingClientRect) return this.reInit(e, t.parentNode);
        var o = this.splitterDOM.getBoundingClientRect(),
          i = this.props.vertical ? o.height : o.width;
        this.props.firstMinSize.endsWith("%") ? this.minSize = r * Number(this.props.firstMinSize.substr(0, this.props.firstMinSize.length - 1)) / 100 : this.props.firstMinSize.endsWith("px") ? this.minSize = Number(this.props.firstMinSize.substr(0, this.props.firstMinSize.length - 2)) : this.minSize = Number(this.props.firstMinSize), this.props.secondMinSize.endsWith("%") ? this.maxSize = r * (100 - Number(this.props.secondMinSize.substr(0, this.props.secondMinSize.length - 1))) / 100 : this.props.secondMinSize.endsWith("px") ? this.maxSize = r - Number(this.props.secondMinSize.substr(0, this.props.secondMinSize.length - 2)) : this.maxSize = r - Number(this.props.secondMinSize);
        var a = 0,
          s = this.props.firstInitialSize;
        a = s.endsWith("%") ? r * Number(s.substr(0, s.length - 1)) / 100 : s.endsWith("px") ? Number(s.substr(0, s.length - 2)) : Number(s), this.hasManuallyResized && (a = void 0 === e ? this.state.firstPanelSize : e), this.setState({
          firstPanelSize: this.clampSize(a),
          mainContainerSize: r - i
        });
      }, t.prototype.clampSize = function (e) {
        return Math.min(Math.max(e, this.minSize), this.maxSize);
      }, t.prototype.render = function () {
        var e = this;
        if (2 !== c.Children.count(this.props.children)) return u.log.warn("Splitter needs exactly 2 children!"), null;
        var t = [];
        return c.Children.forEach(this.props.children, function (n, r) {
          t.push(e.renderPanel(n, 0 === r));
        }), c.createElement(d.Main, {
          className: (0, l.cx)("Twilio-Splitter", this.props.vertical && "Twilio-Splitter-Vertical"),
          vertical: this.props.vertical,
          resizing: this.state.resizing,
          ref: this.setContainer
        }, this.props.panel1header && this.props.header && c.createElement(d.HiddenH3Header, {
          "data-test": "panel-1-header"
        }, this.props.panel1header), t[0], c.createElement(d.Separator, {
          vertical: this.props.vertical,
          role: "separator",
          ref: this.setSplitterDOM,
          onMouseDown: this.handleSplitterMouseDown
        }, this.props.separator), this.props.panel1header && this.props.header && c.createElement(d.HiddenH3Header, {
          "data-test": "panel-2-header"
        }, this.props.panel2header), t[1]);
      }, t;
    }(c.PureComponent);
    t.SplitContentContainer = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HiddenH3Header = t.Pane = t.Separator = t.Main = void 0;
    var i,
      a,
      s,
      l,
      c = o(n(14));
    t.Main = (0, c.default)("div")(i || (i = r(["\n    display: flex;\n    flex: 1 1 auto;\n    max-width: 100%;\n    flex-direction: ", ";\n    cursor: ", ";\n    ", "\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    max-width: 100%;\n    flex-direction: ", ";\n    cursor: ", ";\n    ", "\n    overflow: hidden;\n"])), function (e) {
      return e.vertical ? "column" : "row";
    }, function (e) {
      return e.resizing && (e.vertical ? "row-resize" : "col-resize");
    }, function (e) {
      return e.resizing && "\n       iframe {\n        pointer-events: none;\n        }\n    ";
    }), t.Separator = (0, c.default)("div")(a || (a = r(["\n    cursor: ", ";\n    position: relative;\n    z-index: 2;\n    ", "\n"], ["\n    cursor: ", ";\n    position: relative;\n    z-index: 2;\n    ", "\n"])), function (e) {
      return e.vertical ? "row-resize" : "col-resize";
    }, function (e) {
      return e.vertical ? '\n        :before{\n            content:"";\n            position: absolute;\n            height: calc(100% + 10px);\n            width: 100%;\n            left: 0px;\n            top: -5px;\n        }' : '\n        :before{\n            content:"";\n            position: absolute;\n            width: calc(100% + 10px);\n            height: 100%;\n            top: 0px;\n            left: -5px;\n        }';
    }), t.Pane = (0, c.default)("div")(s || (s = r(["\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n"], ["\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n"]))), t.HiddenH3Header = (0, c.default)("h3")(l || (l = r(["\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"], ["\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StackedBarChartProps = t.StackedBarChart = void 0;
    var r = n(599);
    Object.defineProperty(t, "StackedBarChart", {
      enumerable: !0,
      get: function () {
        return r.StackedBarChart;
      }
    }), Object.defineProperty(t, "StackedBarChartProps", {
      enumerable: !0,
      get: function () {
        return r.StackedBarChartProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StackedBarChart = void 0;
    var l = n(5),
      c = s(n(0)),
      u = n(600),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.items,
            n = e.className,
            r = t.reduce(function (e, t) {
              return e + t.value;
            }, 0);
          return c.createElement(u.Bar, {
            className: (0, l.cx)("Twilio-StackedBarChart-Bar", n),
            "aria-hidden": !0
          }, this.props.items.map(function (e) {
            return c.createElement(u.BarFragment, {
              className: "Twilio-StackedBarChart-BarFragment",
              key: e.label,
              percentageValue: 100 * e.value / (r || 1),
              "aria-label": e.label + ": " + e.value,
              title: e.label + ": " + e.value,
              color: e.color
            });
          }));
        }, t.defaultProps = {
          className: ""
        }, t;
      }(c.PureComponent);
    t.StackedBarChart = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BarFragment = t.Bar = void 0;
    var o,
      i,
      a = n(1);
    t.Bar = (0, a.styled)("div")(o || (o = r(["\n    display: flex;\n    margin-top: ", "; // To align with other AggregatedDataTiles\n    margin-bottom: ", ";\n    height: ", ";\n    background-color: ", ";\n"], ["\n    display: flex;\n    margin-top: ", "; // To align with other AggregatedDataTiles\n    margin-bottom: ", ";\n    height: ", ";\n    background-color: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare50;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundBody;
    }), t.BarFragment = (0, a.styled)("div")(i || (i = r(["\n    height: ", ";\n    width: ", "%;\n    background-color: ", ";\n    box-shadow: -2px 0 0 ", ";\n\n    &:focus {\n        outline: none;\n    }\n"], ["\n    height: ", ";\n    width: ", "%;\n    background-color: ", ";\n    box-shadow: -2px 0 0 ", ";\n\n    &:focus {\n        outline: none;\n    }\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare50;
    }, function (e) {
      return e.percentageValue;
    }, function (e) {
      return e.color;
    }, function (e) {
      return e.theme.tokens.backgroundColors.colorBackgroundBody;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TabsProps = t.Tabs = t.TabProps = t.Tab = void 0;
    var r = n(602);
    Object.defineProperty(t, "Tab", {
      enumerable: !0,
      get: function () {
        return r.Tab;
      }
    }), Object.defineProperty(t, "TabProps", {
      enumerable: !0,
      get: function () {
        return r.TabProps;
      }
    });
    var o = n(603);
    Object.defineProperty(t, "Tabs", {
      enumerable: !0,
      get: function () {
        return o.Tabs;
      }
    }), Object.defineProperty(t, "TabsProps", {
      enumerable: !0,
      get: function () {
        return o.TabsProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Tab = void 0;
    var l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return this.props.children;
      }, t;
    }(s(n(0)).Component);
    t.Tab = l;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Tabs = void 0;
    var c = n(5),
      u = l(n(0)),
      d = n(24),
      f = n(60),
      p = n(604),
      h = n(606),
      v = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            lastSelectedTabIndex: 0
          }, t;
        }
        return o(t, e), t.prototype.isChildTabVisible = function (e) {
          return !e.props.hidden;
        }, t.prototype.getFirstVisibleTabIndex = function () {
          var e = this;
          return u.Children.toArray(this.props.children).findIndex(function (t) {
            return e.isChildTabVisible(t);
          });
        }, t.prototype.render = function () {
          var e,
            t,
            n = this,
            r = this.props,
            o = r.children,
            a = r.alignment,
            s = r.selectedTabName,
            l = u.Children.toArray(o).filter(function (e) {
              return e;
            }),
            d = -1;
          s && (d = l.findIndex(function (e) {
            return e.props.uniqueName === s;
          })), -1 === d && (d = this.state.lastSelectedTabIndex), (l.length < d || !this.isChildTabVisible(l[d])) && (d = this.getFirstVisibleTabIndex());
          var v = l.map(function (e, t) {
              var r;
              return n.isChildTabVisible(e) ? u.createElement(p.TabHeader, i(i({}, e.props), {
                alignment: a,
                setActive: n.handleTabClick.bind(n, t, l[t].props.uniqueName),
                isActive: t === d,
                key: l[t].props.uniqueName,
                themeOverride: null === (r = n.props.themeOverride) || void 0 === r ? void 0 : r.Button
              })) : null;
            }),
            m = l.map(function (e, t) {
              return n.isChildTabVisible(e) && (n.props.keepTabsMounted || t === d) ? u.createElement(f.VisibilityContextProvider.Consumer, {
                key: e.key
              }, function (n) {
                return u.createElement(f.VisibilityContextProvider.Provider, {
                  value: n && t === d
                }, u.createElement(h.TabContainer, {
                  className: "Twilio-Tab",
                  isActive: t === d
                }, e));
              }) : null;
            });
          return u.createElement(h.Container, {
            className: (0, c.cx)("Twilio-Tabs", this.props.className),
            themeOverride: null === (e = this.props.themeOverride) || void 0 === e ? void 0 : e.Container
          }, u.createElement(h.LabelsContainer, {
            themeOverride: null === (t = this.props.themeOverride) || void 0 === t ? void 0 : t.LabelsContainer,
            noPadding: this.props.noLabelPadding,
            className: "Twilio-Tabs-Labels"
          }, v), u.createElement(h.PanelsContainer, {
            className: "Twilio-Tabs-Panels"
          }, m));
        }, t.prototype.handleTabClick = function (e, t) {
          d.TelemetryBridge.emit(d.TelemetryBridgeMessageType.UI_INTERACTION_EVENT, {
            name: "tab_change_successful",
            category: "flex_ui_task",
            status: "complete",
            details: {
              currenltyOnTab: t,
              tabIndex: JSON.stringify(e)
            }
          }), this.props.onTabSelected ? this.props.onTabSelected(t) : this.setState({
            lastSelectedTabIndex: e
          });
        }, t.defaultProps = {
          alignment: "left",
          keepTabsMounted: !0
        }, t;
      }(u.Component);
    t.Tabs = v;
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TabHeader = void 0;
    var l = s(n(0)),
      c = n(15),
      u = n(605),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.setActive = function () {
            return t.props.setActive && t.props.setActive();
          }, t.handleKeyPress = function (e) {
            "Enter" !== e.code && "Space" !== e.code || t.setActive();
          }, t;
        }
        return o(t, e), t.prototype.renderContent = function () {
          var e = this.props,
            t = e.isActive,
            n = e.label,
            r = e.icon,
            o = e.iconActive,
            i = t && o ? o : r;
          return n ? l.createElement(u.TabLabel, {
            tabIndex: -1,
            isActive: !!t,
            onClick: this.setActive
          }, n) : l.createElement(u.IconWrapper, null, l.createElement(c.IconButton, {
            themeOverride: this.props.theme && this.props.theme.Tabs.Button,
            icon: i,
            onClick: this.setActive
          }));
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.alignment,
            n = e.isActive,
            r = "Twilio-TabHeader-StateIndicator-" + (n ? "Active" : "Inactive");
          return l.createElement(u.TabHeaderContainer, {
            tabIndex: 0,
            onKeyPress: this.handleKeyPress,
            role: "button",
            className: "Twilio-TabHeader",
            alignment: t,
            "data-test": "customer-tab-header"
          }, this.renderContent(), l.createElement(u.TabHeaderIndicatorContainer, {
            className: r,
            isActive: n
          }));
        }, t;
      }(l.Component);
    t.TabHeader = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconWrapper = t.TabLabel = t.TabHeaderIndicatorContainer = t.TabHeaderContainer = void 0;
    var o,
      i,
      a,
      s,
      l = n(1);
    t.TabHeaderContainer = (0, l.styled)("div")(o || (o = r(["\n    display: flex;\n    position: relative;\n    justify-content: center;\n    min-width: ", ";\n    flex: 0 1 auto;\n    margin-right: ", ";\n    margin-left: ", ";\n\n    & .Twilio-IconButton {\n        margin: auto;\n    }\n\n    :focus-visible {\n        outline: ", " solid\n            ", ";\n        box-shadow: inset 0 0 0 ", "\n            ", ";\n    }\n\n    ", "\n"], ["\n    display: flex;\n    position: relative;\n    justify-content: center;\n    min-width: ", ";\n    flex: 0 1 auto;\n    margin-right: ", ";\n    margin-left: ", ";\n\n    & .Twilio-IconButton {\n        margin: auto;\n    }\n\n    :focus-visible {\n        outline: ", " solid\n            ", ";\n        box-shadow: inset 0 0 0 ", "\n            ", ";\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.tokens.spacings.space120;
    }, function (e) {
      return "center" === e.alignment ? "auto" : 0;
    }, function (e) {
      return "center" === e.alignment ? "auto" : 0;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth30;
    }, function (e) {
      return e.theme.tokens.borderColors.colorBorderNeutral;
    }, function (e) {
      return "left" === e.alignment && "\n    &:not(:first-of-type) {\n        margin-left: " + e.theme.tokens.spacings.space70 + ";\n    }\n    ";
    }), t.TabHeaderIndicatorContainer = (0, l.styled)("div")(i || (i = r(["\n    position: absolute;\n    height: ", ";\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: auto;\n\n    ", "\n"], ["\n    position: absolute;\n    height: ", ";\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: auto;\n\n    ", "\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare10;
    }, function (e) {
      return e.isActive ? e.theme.Tabs.Active : e.theme.Tabs.Inactive;
    }), t.TabLabel = (0, l.styled)("button")(a || (a = r(["\n    border: none;\n    background: none;\n    transition: color 0.2s;\n    padding: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: ", ";\n\n    :focus-visible {\n        outline: none;\n    }\n\n    :hover,\n    :focus-visible {\n        color: ", ";\n    }\n\n    ", "\n"], ["\n    border: none;\n    background: none;\n    transition: color 0.2s;\n    padding: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: ", ";\n\n    :focus-visible {\n        outline: none;\n    }\n\n    :hover,\n    :focus-visible {\n        color: ", ";\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.tokens.spacings.space30 + " " + e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.isActive ? e.theme.tokens.textColors.colorTextLink : e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightSemibold;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight20;
    }, function (e) {
      return e.theme.tokens.fonts.fontFamilyText;
    }, function (e) {
      return e.isActive ? e.theme.tokens.textColors.colorTextLink : e.theme.tokens.textColors.colorTextWeak;
    }, function (e) {
      return e.isActive ? e.theme.Tabs.LabelActive : e.theme.Tabs.LabelInactive;
    }), t.IconWrapper = (0, l.styled)("div")(s || (s = r(["\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n"], ["\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PanelsContainer = t.TabContainer = t.LabelsContainer = t.Container = void 0;
    var o,
      i,
      a,
      s,
      l = n(47),
      c = n(6),
      u = n(1);
    t.Container = (0, u.styled)(c.FlexBoxColumn)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.Tabs.Container;
    }), t.LabelsContainer = (0, u.styled)("div")(i || (i = r(["\n    display: flex;\n    border-style: solid;\n    border-width: 0 0 ", " 0;\n    box-sizing: content-box;\n    padding-left: ", ";\n    padding-right: ", ";\n    height: ", ";\n    ", "\n    ", "\n"], ["\n    display: flex;\n    border-style: solid;\n    border-width: 0 0 ", " 0;\n    box-sizing: content-box;\n    padding-left: ", ";\n    padding-right: ", ";\n    height: ", ";\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.noPadding ? e.theme.tokens.spacings.space0 : e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.noPadding ? e.theme.tokens.spacings.space0 : e.theme.tokens.spacings.space50;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare100;
    }, function (e) {
      return e.theme.Tabs.LabelsContainer;
    }, function (e) {
      return e.themeOverride;
    }), t.TabContainer = (0, u.styled)("div")(a || (a = r(["\n    display: flex;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    ", "\n"], ["\n    display: flex;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    ", "\n"])), function (e) {
      return l.Animations.FadeInOutTransition(e.isActive);
    }), t.PanelsContainer = (0, u.styled)(c.FlexBoxColumn)(s || (s = r(["\n    position: relative;\n"], ["\n    position: relative;\n"]))), t.PanelsContainer.displayName = "PanelsContainer", t.TabContainer.displayName = "TabContainer";
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      a = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      s = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
        return a(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Ticker = void 0;
    var l = n(608),
      c = s(n(0)),
      u = new l.EventEmitter(),
      d = null,
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.tick = function () {
            t.forceUpdate();
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e;
          e = this.tick, u.addListener("tick", e), d || (d = window.setInterval(function () {
            return u.emit("tick");
          }, 1e3));
        }, t.prototype.componentWillUnmount = function () {
          var e;
          e = this.tick, u.removeListener("tick", e), 0 === u.listenerCount("tick") && d && (clearInterval(d), d = null);
        }, t.prototype.render = function () {
          return this.props.children();
        }, t;
      }(c.Component);
    t.Ticker = f;
  }, function (e, t) {
    e.exports = require("eventemitter3");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserCardProps = t.UserCardState = t.UserCard = void 0;
    var r = n(610);
    Object.defineProperty(t, "UserCard", {
      enumerable: !0,
      get: function () {
        return r.UserCard;
      }
    }), Object.defineProperty(t, "UserCardState", {
      enumerable: !0,
      get: function () {
        return r.UserCardState;
      }
    }), Object.defineProperty(t, "UserCardProps", {
      enumerable: !0,
      get: function () {
        return r.UserCardProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      l = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && a(t, e, n);
        return s(t, e), t;
      },
      c = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserCard = void 0;
    var u = n(5),
      d = l(n(0)),
      f = n(2),
      p = n(611),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {}, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          this.validateImageUrl(this.props.imageUrl);
        }, t.prototype.componentDidUpdate = function (e) {
          e.imageUrl !== this.props.imageUrl && this.validateImageUrl(this.props.imageUrl);
        }, t.prototype.validateImageUrl = function (e) {
          var t = this;
          if (e) {
            var n = new Image();
            n.src = e, n.onload = function () {
              t.setState({
                verifiedImageUrl: e
              });
            };
          }
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.large,
            r = void 0 !== n && n,
            o = (e.firstLine, e.secondLine, e.imageUrl, e.isAvailable, e.onClick),
            a = e.lightHover,
            s = c(e, ["className", "large", "firstLine", "secondLine", "imageUrl", "isAvailable", "onClick", "lightHover"]);
          return o ? d.createElement(p.StyledButton, i({
            large: r,
            className: t,
            onClick: o,
            lightHover: a
          }, s), this.renderContent()) : this.renderContent();
        }, t.prototype.renderContent = function () {
          var e = this.props,
            t = e.className,
            n = e.large,
            r = e.firstLine,
            o = e.secondLine,
            i = e.isAvailable,
            a = e.selected,
            s = e.onClick,
            l = e.inWorkerItem,
            c = e.buttonRef,
            h = this.state.verifiedImageUrl,
            v = f.templates.UserCardAriaLabel({
              fullName: this.props.fullName,
              activityName: this.props.activityName
            });
          return d.createElement(p.UserCardContainer, {
            selected: a,
            className: (0, u.cx)("Twilio-UserCard-UserCardContainer", t),
            tabIndex: l ? -1 : 0,
            ref: c,
            onKeyPress: s,
            role: l ? "" : "button",
            "aria-label": v,
            inWorkerItem: l,
            "data-test": "user-card-container"
          }, d.createElement(p.AvatarContainer, {
            className: "Twilio-UserCard-AvatarContainer"
          }, d.createElement(p.StyledAvatarWrapper, {
            className: "Twilio-UserCard-StyledAvatarWrapper"
          }, h ? d.createElement(p.StyledAvatarImage, {
            src: h,
            "aria-label": f.templates.UserImageAriaLabel()
          }) : d.createElement(p.StyledDefaultAvatarIcon, {
            icon: "DefaultAvatar",
            "aria-label": f.templates.DefaultUserImageAriaLabel()
          }))), n && d.createElement(p.InfoContainer, {
            className: "Twilio-UserCard-InfoContainer"
          }, d.createElement(p.FirstLine, {
            selected: a,
            className: "Twilio-UserCard-InfoContainer-FirstLine",
            "data-test": "user-details"
          }, r), d.createElement(p.SecondLineContainer, null, d.createElement(p.StyledAvailabilityIconWrapper, {
            className: "Twilio-UserCard-StyledAvailabilityIconWrapper"
          }, d.createElement(p.StyledAvailabilityIcon, {
            available: !!i
          })), d.createElement(p.SecondLine, {
            className: "Twilio-UserCard-InfoContainer-SecondLine",
            "data-test": "status-details"
          }, o))));
        }, t;
      }(d.PureComponent);
    t.UserCard = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledButton = t.UserCardContainer = t.SecondLine = t.FirstLine = t.Line = t.InfoContainer = t.StyledAvailabilityIcon = t.SecondLineContainer = t.StyledAvailabilityIconWrapper = t.StyledDefaultAvatarIcon = t.StyledAvatarImage = t.StyledAvatarWrapper = t.AvatarContainer = void 0;
    var o,
      i,
      a,
      s,
      l,
      c,
      u,
      d,
      f,
      p,
      h,
      v,
      m,
      g = n(4),
      b = n(1);
    t.AvatarContainer = (0, b.styled)("div")(o || (o = r(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n"]))), t.StyledAvatarWrapper = (0, b.styled)("div")(i || (i = r(["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    border-style: solid;\n    border-width: ", ";\n    overflow: hidden;\n    ", "\n"], ["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    border-style: solid;\n    border-width: ", ";\n    overflow: hidden;\n    ", "\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare100;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare100;
    }, function (e) {
      return e.theme.tokens.radii.borderRadiusCircle;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.theme.UserCard.AvatarContainer;
    }), t.StyledAvatarImage = (0, b.styled)("img")(a || (a = r(["\n    margin: auto;\n    display: block;\n    max-width: ", ";\n    max-height: ", ";\n    width: auto;\n    height: auto;\n"], ["\n    margin: auto;\n    display: block;\n    max-width: ", ";\n    max-height: ", ";\n    width: auto;\n    height: auto;\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare100;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare100;
    }), t.StyledDefaultAvatarIcon = (0, b.styled)(g.Icon)(s || (s = r(["\n    margin: auto;\n"], ["\n    margin: auto;\n"]))), t.StyledAvailabilityIconWrapper = (0, b.styled)("div")(l || (l = r(["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n    border-radius: ", ";\n    background-color: inherit;\n"], ["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n    border-radius: ", ";\n    background-color: inherit;\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.radii.borderRadiusCircle;
    }), t.SecondLineContainer = (0, b.styled)("div")(c || (c = r(["\n    display: flex;\n    align-items: center;\n"], ["\n    display: flex;\n    align-items: center;\n"]))), t.StyledAvailabilityIcon = (0, b.styled)("div")(u || (u = r(["\n    margin: auto;\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    background-color: ", ";\n    ", ";\n"], ["\n    margin: auto;\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    background-color: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.theme.tokens.sizings.sizeSquare30;
    }, function (e) {
      return e.available ? e.theme.tokens.backgroundColors.colorBackgroundAvailable : e.theme.tokens.backgroundColors.colorBackgroundOffline;
    }, function (e) {
      return e.theme.UserCard.AvailabilityContainer;
    }), t.InfoContainer = (0, b.styled)("div")(d || (d = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    margin-top: auto;\n    margin-bottom: auto;\n    overflow: hidden;\n    margin-left: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    margin-top: auto;\n    margin-bottom: auto;\n    overflow: hidden;\n    margin-left: ", ";\n"])), function (e) {
      return e.theme.tokens.spacings.space40;
    }), t.Line = (0, b.styled)("div")(f || (f = r(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    text-align: left;\n    white-space: nowrap;\n    ", "\n"], ["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    text-align: left;\n    white-space: nowrap;\n    ", "\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize30;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightBold;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight20;
    }, function (e) {
      var t = e.selected,
        n = e.theme;
      return t && {
        color: n.tokens.textColors.colorTextLink
      };
    }), t.FirstLine = (0, b.styled)(t.Line)(p || (p = r(["\n    ", ";\n"], ["\n    ", ";\n"])), function (e) {
      return e.theme.UserCard.FirstLineInfoContainer;
    }), t.SecondLine = (0, b.styled)(t.Line)(h || (h = r(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    ", ";\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.tokens.fontSizes.fontSize20;
    }, function (e) {
      return e.theme.tokens.lineHeights.lineHeight10;
    }, function (e) {
      return e.theme.tokens.fontWeights.fontWeightNormal;
    }, function (e) {
      return e.theme.UserCard.SecondLineInfoContainer;
    }), t.UserCardContainer = (0, b.styled)("div")(v || (v = r(["\n    display: flex;\n    overflow: hidden;\n    margin-left: ", ";\n    margin-right: ", ";\n    padding: ", ";\n    flex: 1 1 auto;\n    align-items: center;\n    border-width: ", ";\n    border-color: transparent;\n    border-style: solid;\n    outline: none;\n    &:focus-visible {\n        ", "\n    }\n\n    ", "\n"], ["\n    display: flex;\n    overflow: hidden;\n    margin-left: ", ";\n    margin-right: ", ";\n    padding: ", ";\n    flex: 1 1 auto;\n    align-items: center;\n    border-width: ", ";\n    border-color: transparent;\n    border-style: solid;\n    outline: none;\n    &:focus-visible {\n        ", "\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space30;
    }, function (e) {
      return e.theme.tokens.spacings.space20;
    }, function (e) {
      return e.theme.tokens.borderWidths.borderWidth10;
    }, function (e) {
      return e.inWorkerItem ? {} : {
        background: e.theme.tokens.backgroundColors.colorBackgroundPrimaryWeakest,
        boxShadow: "0 0 0 " + e.theme.tokens.borderWidths.borderWidth20 + " " + e.theme.tokens.borderColors.colorBorderNeutral,
        borderRadius: e.theme.tokens.radii.borderRadius30,
        borderWidth: e.theme.tokens.borderWidths.borderWidth10,
        borderColor: e.theme.tokens.borderColors.colorBorderNeutral
      };
    }, function (e) {
      var t = e.selected,
        n = e.theme;
      return t && {
        boxShadow: "0 0 0 " + n.tokens.borderWidths.borderWidth20 + " " + n.tokens.borderColors.colorBorderNeutral,
        borderRadius: n.tokens.radii.borderRadius30,
        borderColor: n.tokens.borderColors.colorBorderNeutral,
        outline: "none"
      };
    }), t.StyledButton = (0, b.styled)("div")(m || (m = r(["\n    width: 100%;\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    cursor: pointer;\n    svg {\n        margin: auto;\n    }\n"], ["\n    width: 100%;\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    cursor: pointer;\n    svg {\n        margin: auto;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VerticalTabs = void 0;
    var r = n(613);
    Object.defineProperty(t, "VerticalTabs", {
      enumerable: !0,
      get: function () {
        return r.VerticalTabs;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      i = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VerticalTabs = t.ThemedListItem = void 0;
    var s = n(32),
      l = a(n(0)),
      c = n(2),
      u = n(1),
      d = u.styled.div(v || (v = o(["\n    width: 100%;\n    border-right: ", " solid\n        ", ";\n    padding-right: ", ";\n    display: flex;\n    flex-direction: column;\n"], ["\n    width: 100%;\n    border-right: ", " solid\n        ", ";\n    padding-right: ", ";\n    display: flex;\n    flex-direction: column;\n"])), function (e) {
        return e.theme.tokens.borderWidths.borderWidth10;
      }, function (e) {
        return e.theme.tokens.borderColors.colorBorderWeak;
      }, function (e) {
        return e.theme.tokens.spacings.space70;
      }),
      f = u.styled.div(m || (m = o(["\n    margin-bottom: ", ";\n"], ["\n    margin-bottom: ", ";\n"])), function (e) {
        return e.theme.tokens.spacings.space70;
      }),
      p = (0, u.styled)("h4")(g || (g = o(["\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"], ["\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"]))),
      h = (0, s.withStyles)(function (e) {
        return {
          root: {
            border: "0",
            borderRadius: "0",
            borderLeft: e.tokens.borderWidths.borderWidth10 + " solid " + e.tokens.borderColors.colorBorderWeak,
            color: e.tokens.textColors.colorTextWeak,
            fontWeight: e.tokens.fontWeights.fontWeightSemibold,
            lineHeight: e.tokens.lineHeights.lineHeight40,
            paddingTop: e.tokens.spacings.space0,
            paddingBottom: e.tokens.spacings.space0,
            overflowY: "auto"
          }
        };
      })(s.List);
    t.ThemedListItem = (0, s.withStyles)(function (e) {
      return {
        root: {
          "&$selected": {
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "transparent"
            }
          }
        },
        selected: {
          borderLeft: e.tokens.borderWidths.borderWidth20 + " solid " + e.tokens.borderColors.colorBorderPrimary,
          color: e.tokens.textColors.colorTextLink
        }
      };
    })(s.ListItem);
    var v,
      m,
      g,
      b = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return i(n, e), n.prototype.render = function () {
          var e = this;
          return l.default.createElement(d, null, l.default.createElement(p, null, c.templates.HiddenQualityManagementQuestionsSideNavHeader()), this.props.renderHeader && l.default.createElement(f, null, this.props.renderHeader()), l.default.createElement(h, null, this.props.tabs.map(function (n) {
            return l.default.createElement("h5", {
              key: e.props.getTabKey(n)
            }, l.default.createElement(t.ThemedListItem, {
              button: !0,
              selected: e.props.selectedTab === e.props.getTabKey(n),
              onClick: function () {
                return e.props.onTabSelect(e.props.getTabKey(n));
              }
            }, e.props.renderTab(n)));
          })));
        }, n;
      }(l.default.PureComponent);
    t.VerticalTabs = b;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      },
      a = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialize = void 0;
    var l = i(n(615)),
      c = i(n(61));
    t.initialize = function () {
      return a(this, void 0, Promise, function () {
        return s(this, function (e) {
          return function () {
            if (void 0 !== window.Handlebars) return;
            window.Handlebars = l;
          }(), l.registerHelper("unsafeString", function (e) {
            return e;
          }), l.registerHelper("icon", function (e) {
            if (!e || !e.hash || !e.hash.name) return "";
            var t = "Icn" + e.hash.name,
              n = c[t];
            return n && n._raw ? n._raw.replace("<svg", '<svg class="Twilio-Template-Icon Twilio-Icon-' + e.hash.name + '"') : "";
          }), [2, Promise.resolve()];
        });
      });
    };
  }, function (e, t) {
    e.exports = require("handlebars");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.default = {
      InputPlaceHolder: "Type message",
      TypingIndicator: "{{name}} is typing … ",
      TypingIndicatorMultiple: "{{count}} people are typing … ",
      Connecting: "Connecting …",
      Disconnected: "Connection lost",
      Read: "Read",
      MessageSendingDisabled: "Message sending has been disabled",
      Today: "Today",
      Yesterday: "Yesterday",
      MessageCanvasTrayContent: "\n        <h5>Complete</h5>\n        <p>This chat is no longer active.</p>",
      MessageCanvasTrayButton: "START NEW CHAT",
      MediaMessageError: "Media messages are not supported",
      WelcomeMessage: "Welcome to customer service",
      NotificationMessage: "Unable to perform action: {{message}}",
      Save: "Save",
      Reset: "Reset",
      MessageCharacterCountStatus: "{{currentCharCount}} / {{maxCharCount}}",
      MessageCharacterCountReached: "Character count reached - {{currentCharCount}} / {{maxCharCount}}",
      SendMessageTooltip: "Send Message",
      FieldValidationRequiredField: "Field required",
      FieldValidationInvalidEmail: "Please provide a valid email address",
      ChatInputUserNotMemberDisabledText: "You are not a chat participant",
      FilterItemAny: "Any",
      FilterItemAmountSelected: "{{amount}} selected",
      FilterItemOnly: "{{item.label}} only",
      LegacyFiltersTitle: "Custom Filters",
      LegacyFiltersEmptySelectLabel: "None",
      DialpadNum0Caption: "0",
      DialpadNum0Description: "+",
      DialpadNum1Caption: "1",
      DialpadNum1Description: "—",
      DialpadNum2Caption: "2",
      DialpadNum2Description: "ABC",
      DialpadNum3Caption: "3",
      DialpadNum3Description: "DEF",
      DialpadNum4Caption: "4",
      DialpadNum4Description: "GHI",
      DialpadNum5Caption: "5",
      DialpadNum5Description: "JKL",
      DialpadNum6Caption: "6",
      DialpadNum6Description: "MNO",
      DialpadNum7Caption: "7",
      DialpadNum7Description: "PQRS",
      DialpadNum8Caption: "8",
      DialpadNum8Description: "TUV",
      DialpadNum9Caption: "9",
      DialpadNum9Description: "WXYZ",
      DialpadHashCaption: "#",
      DialpadHashDescription: "",
      DialpadAsteriskCaption: "*",
      DialpadAsteriskDescription: "",
      NewChatMessageNotificationTitle: "New message from {{lastMessage.authorName}}",
      NewChatMessageNotificationBody: "{{#if lastMessage.source.body}} {{lastMessage.source.body}} {{else}} file sent {{/if}}",
      MediaMessageClickToOpen: "Open",
      SendMediaMessageInvalidType: "{{fileName}} file type is not supported",
      SendMediaMessageInvalidSize: "{{fileName}} is too large. Max file size {{maxFileSize}}.",
      AttachFileMultipleFailure: "{{failureCount}} files failed to attach.",
      AttachFileMultipleFailureExpandLink: "{{#if expanded}}Hide file errors{{else}}View file errors{{/if}}",
      AttachFileDuplicate: "{{fileName}} is already attached",
      AttachFileInvalidType: "{{fileName}} file type is not supported",
      AttachFileInvalidSize: "{{fileName}} is too large. Max file size {{maxFileSize}}.",
      AttachFileInvalidOverallSize: "Too many files. Max {{maxOverallFileSize}} per message.",
      AttachFileInvalidMaxAmount: "Too many files. Max {{maxAmount}} {{#if singular}}file{{else}}files{{/if}} per message.",
      AttachFileMultipleNotSupported: "Please attach one file at a time.",
      AttachFileDisabled: "File attachments are currently unavailable",
      DownloadFileInvalidType: "{{fileName}} file type is not supported",
      DownloadFileInvalidSize: "{{fileName}} is too large. Max file size {{maxFileSize}}.",
      MediaMessageTransferFailed: "Sending failed",
      MessageDeliveryFailed: "Message failed",
      MessageDeliveryUnDelivered: "Message undelivered",
      AttachFileImageTooltip: "Attach file or image",
      ManageAgentsToQueueBreadCrumb: "Manage Agents",
      QueueStatsBreadCrumb: "Queue Stats",
      FileAttachmentDropAreaTitle: "Attach a file or an image",
      FileAttachmentDropAreaTitleDisabled: "File attachments are disabled.",
      FileAttachmentDropAreaTitleFileLimitReached: "Attachment limit of {{fileCountLimit}} {{#if singular}}file{{else}}files{{/if}} has already been reached.",
      FileAttachmentDropAreaSubtitle: "Drop file here",
      FileAttachmentDropAreaSubtitleDisabled: "Drag and drop is currently unavailable.",
      FileAttachmentDropAreaSubtitleFileLimitReached: "Send this message first then attach another file.",
      EmailSubject: "Subject",
      EmailFrom: "From",
      EmailTo: "To",
      EmailCc: "Cc",
      EmailRecipientInputPlaceholder: "Type an address",
      EmailEditorTitle: "Reply",
      EmailEditorSubmit: "Send",
      EmailEditorNoParticipantButtonTooltip: "Please enter an email address to send",
      EmailEditorReply: "Reply",
      EmailEditorRemoveEmailAddressButtonAriaLabel: "Remove email address",
      EmailSentNotification: "Email sent successfully",
      EmailAddParticipantFailedNotification: "Participant {{address}} couldn't be added to the conversation.",
      EmailRemoveParticipantFailedNotification: "Participant {{address}} couldn't be removed from the conversation.",
      EmailMessageRecipientListPrefix: "To: ",
      EmailMessageActionsButtonAriaLabel: "Toggle message actions navigation",
      EmailMessageActionsNavAriaLabel: "Message actions navigation — press escape to close.",
      EmailViewThread: "View full thread",
      EmailThreadNotAvailable: "Full thread not available",
      EmailLoadingThreadPlaceholder: "<p>Loading thread...</p>",
      EmailLoadingThreadError: "<p>Couldn't load the message thread.</p>",
      EmailThreadWindowTitle: "Thread for message {{message.sid}}",
      EmailThreadDetails: "\n            <dl>\n                <div>\n                    <dt>Message ID:</dt>\n                    <dd>{{message.sid}}</dd>\n                </div>\n                <div>\n                    <dt>Created at:</dt>\n                    <dd>{{dateCreated}}</dd>\n                </div>\n                <div>\n                    <dt>From: </dt>\n                    <dd>{{author.name}} {{author.address}}</dd>\n                </div>\n                <div>\n                    <dt>Subject:</dt>\n                    <dd>{{message.subject}}</dd>\n                </div>\n            </dl>",
      LinkPanelTitle: "Add link",
      LinkPanelTextLabel: "Text",
      LinkPanelTextPlaceholder: "Text to display",
      LinkPanelLinkLabel: "Link",
      LinkPanelLinkPlaceholder: "https://example.com",
      LinkPanelApplyButtonLabel: "Apply",
      LinkPanelRemoveButtonLabel: "Remove",
      UserImageAriaLabel: "User Image. User is {{status}}.",
      DefaultUserImageAriaLabel: "Default User Image. User is {{status}}.",
      CloseIconAriaLabel: "Close",
      UserCardAriaLabel: "User {{fullName}} with status {{activityName}}.",
      CloseOutboundDialerPadAriaLabel: "Close outbound dialpad",
      NotificationActionItemAriaLabel: "{{type}} {{task}} task",
      CloseIconNotificationAriaLabel: "Close notification",
      NotConnectedSendMessageAriaLabel: "Send Button. Cannot send message. Not connected",
      NoInputSendMessageAriaLabel: "Send Button. Cannot send message. No message or attachment",
      CharLimitReachedSendMessageAriaLabel: "Send Button. Cannot send message. Character count reached - {{currentCharCount}} / {{maxCharCount}}",
      RemoveAttachedFileAriaLabel: "Remove attached file {{fileName}}",
      DisabledRemoveAttachedFileAriaLabel: "Remove attached file {{fileName}} cannot be performed as {{placeholder}}",
      ClearButtonAriaLabel: "Clear",
      AttachedFileLimitAriaLabel: "Attach File Button. Cannot attach file. Maximum number of file attachments has been reached.",
      NoMessagesConversationAriaLabel: "Attach File Button. Cannot attach file. Conversation is empty.",
      DisabledAttachFileButtonAriaLabel: "Attach File Button. Cannot attach file as {{disabledReason}}.",
      DisabledSendButtonAriaLabel: "Send Button. Cannot send message as {{disabledReason}}.",
      ExpandFilterButtonAriaLabel: "Expand {{title}} filter",
      HideFilterButtonAriaLabel: "Hide {{title}} filter",
      MessageInputDisabledAriaLabel: "Message Input. Cannot enter input as {{placeholder}}.",
      CountrySelectorLabel: "Country selector",
      MessageInputSendButtonText: "Send",
      NewMessageSeparatorText: "New",
      FileSendingText: "Sending...",
      SingleNewMessageScrollButtonText: "New message",
      FewNewMessagesScrollButtonText: "new messages",
      ManyNewMessagesScrollButtonText: "New messages",
      HiddenQualityManagementQuestionsSideNavHeader: "Question Navigation",
      QualityManagementPopoverMenuButtonAriaLabel: "More actions",
      SendMessageFailed: "Could not send message. Please try again.",
      CCAICustomerLabel: "Customer",
      CCAIVirtualAgent: "Virtual Agent"
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatConfig = t.ChatState = t.ChatSessionState = t.ChatChannelsState = t.ChatChannelState = t.ConversationsState = t.ConversationState = void 0;
    var a = i(n(11));
    t.ConversationState = a;
    var s = i(n(91));
    t.ConversationsState = s;
    var l = i(n(86));
    t.ChatChannelState = l;
    var c = i(n(85));
    t.ChatChannelsState = c;
    var u = i(n(35));
    t.ChatSessionState = u;
    var d = i(n(619));
    t.ChatState = d;
    var f = i(n(620));
    t.ChatConfig = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.current = t.setConfig = void 0;
    var r,
      o = n(169),
      i = n(3),
      a = n(10);
    t.setConfig = function (e) {
      var t, n;
      r && r.language === e.language || (t = e.language, n = o.languages[t] || o.languages.default, (0, a.initWithStrings)(n)), e.logLevel && i.log.setLevel(e.logLevel), r = e;
    }, t.current = function () {
      return r;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.preferenceDao = t.useDB = t.usePreferenceStorage = void 0;
    var o = r(n(622));
    t.preferenceDao = o.default;
    var i = n(171);
    Object.defineProperty(t, "useDB", {
      enumerable: !0,
      get: function () {
        return i.useDB;
      }
    });
    var a = n(625);
    Object.defineProperty(t, "usePreferenceStorage", {
      enumerable: !0,
      get: function () {
        return a.usePreferenceStorage;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = i(n(170)),
      s = n(79),
      l = new (function () {
        function e() {}
        return e.prototype.getDb = function () {
          return r(this, void 0, void 0, function () {
            return o(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, a.default.openDB()];
                case 1:
                  return [2, e.sent().get(s.DB_NAME)];
              }
            });
          });
        }, e.prototype.get = function (e) {
          return r(this, void 0, Promise, function () {
            var t;
            return o(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getDb()];
                case 1:
                  return [2, null == (t = n.sent()) ? void 0 : t.get(s.PREFERENCE_STORE, e)];
              }
            });
          });
        }, e.prototype.add = function (e, t) {
          return r(this, void 0, void 0, function () {
            var n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.getDb()];
                case 1:
                  return [2, null == (n = r.sent()) ? void 0 : n.add(s.PREFERENCE_STORE, {
                    id: e,
                    data: t
                  })];
              }
            });
          });
        }, e.prototype.put = function (e, t) {
          return r(this, void 0, void 0, function () {
            var n;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.getDb()];
                case 1:
                  return [2, null == (n = r.sent()) ? void 0 : n.put(s.PREFERENCE_STORE, {
                    id: e,
                    data: t
                  })];
              }
            });
          });
        }, e;
      }())();
    t.default = l;
  }, function (e, t) {
    e.exports = require("idb");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(79));
    t.default = [o.default];
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.usePreferenceStorage = void 0;
    var i = n(0),
      a = n(79),
      s = n(171);
    t.usePreferenceStorage = function (e, t) {
      var n = this,
        l = (0, i.useState)(),
        c = l[0],
        u = l[1],
        d = (0, s.useDB)(),
        f = (0, i.useState)(t),
        p = f[0],
        h = f[1];
      return (0, i.useEffect)(function () {
        d && d.has(a.DB_NAME) && u(d.get(a.DB_NAME));
      }, [d]), (0, i.useEffect)(function () {
        r(n, void 0, void 0, function () {
          var t;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return c ? [4, c.get(a.PREFERENCE_STORE, e)] : [2];
              case 1:
                return t = n.sent(), h(null == t ? void 0 : t.data), [2];
            }
          });
        });
      }, [c]), [p, function (t) {
        return r(n, void 0, void 0, function () {
          var n;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return c ? [4, c.put(a.PREFERENCE_STORE, {
                  id: e,
                  data: t
                })] : [3, 3];
              case 1:
                return r.sent(), [4, c.get(a.PREFERENCE_STORE, e)];
              case 2:
                n = r.sent(), h(n.data), r.label = 3;
              case 3:
                return [2];
            }
          });
        });
      }];
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Overrides = t.createTheme = void 0;
    var r = n(627);
    Object.defineProperty(t, "createTheme", {
      enumerable: !0,
      get: function () {
        return r.createTheme;
      }
    }), Object.defineProperty(t, "Overrides", {
      enumerable: !0,
      get: function () {
        return r.Overrides;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
        return i(t, e), t;
      },
      s = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createTheme = void 0;
    var l = a(n(628)),
      c = a(n(629)),
      u = s(n(41)),
      d = n(154);
    t.createTheme = function (e, t) {
      var n = r(r({}, t ? l.backgroundColors : c.backgroundColors), {
          colorBackgroundSuccessStrong: t ? "#0b602d" : "#7beaa5",
          colorBackgroundSuccessStronger: t ? "#0d3a1f" : "#a2f6c3",
          colorBackgroundSuccessWeak: t ? "#a2f6c3" : "#0b602d",
          colorBackgroundWarningWeak: t ? "#fac2a0" : "#c35323",
          colorBackgroundErrorWeak: t ? "#f6b1b1" : "#ad1111",
          colorBackgroundWhite: "#fff",
          colorBackgroundBlack: "#000",
          colorBackgroundVirtualAgent: "#4b5671",
          colorBackgroundCustomer: "#c8aff0"
        }),
        o = r(r({}, t ? l.boxShadows : c.boxShadows), {
          shadowBorderDecorative40Weaker: "0 0 0 1px #e7dcfa",
          shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd"
        }),
        i = {
          backgroundColors: n,
          textColors: t ? l.textColors : c.textColors,
          borderColors: t ? l.borderColors : c.borderColors,
          boxShadows: o,
          borderWidths: l.borderWidths,
          radii: l.radii,
          fontSizes: l.fontSizes,
          fontWeights: l.fontWeights,
          lineHeights: l.lineHeights,
          sizings: l.sizings,
          spacings: l.spacings,
          fonts: l.fonts
        };
      e.tokens && (i = (0, u.default)({}, i, e.tokens));
      var a = (0, d.createMuiTheme)(i, t);
      return r(r({}, a), {
        isLight: t,
        tokens: i,
        FormComponents: {
          TextArea: {
            color: i.textColors.colorText
          },
          Input: {
            color: i.textColors.colorText
          },
          Select: {
            color: i.textColors.colorText
          }
        },
        Button: {},
        Dialpad: {
          Button: {
            Container: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              lightHover: !t,
              color: i.textColors.colorText,
              disabled: {
                cursor: "not-allowed"
              }
            },
            Caption: {
              color: "inherit"
            },
            Description: {
              color: "inherit"
            }
          }
        },
        Dialer: {
          CallButton: {}
        },
        Avatar: {
          Container: {
            borderColor: i.borderColors.colorBorderWeak,
            background: i.backgroundColors.colorBackgroundBody
          },
          AvailabilityIcon: {}
        },
        Menu: {
          Item: {
            lightHover: !t
          },
          Items: {
            color: i.textColors.colorText,
            background: i.backgroundColors.colorBackgroundStrong
          }
        },
        Tabs: {
          Container: {
            color: i.textColors.colorText
          },
          LabelsContainer: {
            borderColor: i.borderColors.colorBorderWeak
          },
          Button: {},
          LabelActive: {},
          LabelInactive: {},
          Active: {
            background: i.backgroundColors.colorBackgroundPrimary
          },
          Inactive: {}
        },
        Chat: {
          MessagingCanvas: {
            Container: {
              background: i.backgroundColors.colorBackgroundBody
            }
          },
          MessageList: {
            DateSeparatorLine: {
              borderColor: i.borderColors.colorBorderWeak
            },
            DateSeparatorText: {
              color: i.textColors.colorText
            },
            NewMessageSeparatorLine: {
              borderColor: i.borderColors.colorBorderDestructive
            },
            NewMessageSeparatorText: {
              color: i.textColors.colorTextLinkDestructive
            },
            TypingIndicator: {
              color: i.textColors.colorText
            },
            MessageScrollButton: {
              backgroundColor: i.backgroundColors.colorBackgroundPrimary,
              color: i.textColors.colorTextInverse,
              ":hover": {
                color: i.textColors.colorTextWeakest,
                background: i.backgroundColors.colorBackgroundPrimaryStronger
              },
              ":active": {
                color: i.textColors.colorTextWeakest,
                background: i.backgroundColors.colorBackgroundPrimaryStrongest
              },
              ":focus": {
                color: i.textColors.colorTextWeakest,
                background: i.backgroundColors.colorBackgroundPrimaryStrongest,
                border: i.borderWidths.borderWidth10 + " solid " + i.borderColors.colorBorderNeutral,
                boxShadow: "0 0 0 " + i.borderWidths.borderWidth30 + " " + i.borderColors.colorBorderNeutral
              }
            }
          },
          MessageInput: {
            Container: {
              background: "transparent",
              color: i.textColors.colorText,
              "::placeholder": {
                color: i.textColors.colorTextWeak
              }
            },
            Button: {},
            AttachFileButton: {},
            FileBox: {
              background: i.backgroundColors.colorBackgroundBody,
              borderColor: i.borderColors.colorBorder
            },
            RemoveFileButton: {}
          },
          MessageListItem: {
            FromMe: {
              Avatar: {
                color: t ? i.textColors.colorTextInverse : i.textColors.colorText,
                background: "#1976D2"
              },
              Bubble: {
                color: i.textColors.colorTextWeakest,
                background: i.backgroundColors.colorBackgroundPrimaryStronger,
                disabled: {
                  color: i.textColors.colorTextWeak,
                  borderWidth: i.borderWidths.borderWidth10,
                  borderStyle: "dashed",
                  borderColor: i.borderColors.colorBorder,
                  background: i.backgroundColors.colorBackgroundBody
                }
              },
              Header: {
                color: i.textColors.colorTextWeakest,
                disabled: {
                  color: i.textColors.colorTextWeak
                }
              },
              Media: {
                Container: {
                  background: i.backgroundColors.colorBackgroundPrimaryStronger,
                  color: i.textColors.colorTextWeakest,
                  borderColor: i.borderColors.colorBorder,
                  lightHover: !t,
                  disabled: {
                    color: i.textColors.colorTextWeak,
                    background: i.backgroundColors.colorBackgroundBody,
                    borderColor: i.borderColors.colorBorderWeak
                  }
                },
                Actions: {
                  color: i.textColors.colorTextWeakest
                }
              }
            },
            FromOthers: {
              Avatar: {
                color: i.textColors.colorText,
                background: i.backgroundColors.colorBackground
              },
              Bubble: {
                color: i.textColors.colorText,
                background: i.backgroundColors.colorBackground
              },
              Header: {
                color: i.textColors.colorText
              },
              Media: {
                Container: {
                  background: i.backgroundColors.colorBackground,
                  color: i.textColors.colorText,
                  borderColor: i.borderColors.colorBorder,
                  lightHover: !0
                },
                Actions: {
                  color: i.textColors.colorText
                }
              }
            },
            ReadStatus: {
              color: i.textColors.colorText
            },
            ErrorStatus: {
              color: i.textColors.colorTextError
            }
          },
          MessageCanvasTray: {
            Container: {
              background: i.backgroundColors.colorBackgroundStrong,
              color: i.textColors.colorText
            },
            Button: {}
          },
          WelcomeMessage: {
            Container: {
              color: i.textColors.colorText
            },
            Icon: {
              color: i.textColors.colorText
            }
          },
          FileAttachmentDropArea: {
            MainDropArea: {
              background: t ? "rgba(255, 255, 255, 0.9)" : "rgba(0, 0, 0, 0.9)",
              borderColor: i.borderColors.colorBorderPrimary
            },
            MainDropAreaError: {
              borderColor: i.borderColors.colorBorderDestructive
            },
            Icon: {
              color: i.textColors.colorTextLink
            },
            IconError: {
              color: i.textColors.colorTextIconUnavailable
            },
            Title: {},
            SubTitle: {}
          },
          EmailMessageItem: {
            Wrapper: {},
            Header: {
              Wrapper: {},
              MessagePreview: {},
              AvatarContainer: {},
              Details: {},
              DetailsFirstRow: {},
              DetailsSecondRow: {},
              SubjectRow: {},
              Date: {},
              MoreActionsMenuContainer: {},
              MoreActionsButton: {},
              MoreActionsInnerContainer: {},
              Popover: {},
              PopoverActionItem: {},
              ThreadPopup: {}
            },
            Body: {
              Wrapper: {},
              HTMLWrapper: {},
              Iframe: {},
              FileAttachmentsContainer: {},
              FileAttachment: {}
            }
          },
          EmailEditor: {
            Wrapper: {},
            Title: {},
            EntrypointButton: {},
            Form: {},
            InputField: {
              Default: {},
              WithBorder: {}
            },
            InputFieldLabel: {},
            InputFieldInput: {},
            MessageIframe: {},
            Footer: {},
            SubmitButtonContainer: {},
            FileContainer: {},
            CCFieldToggle: {},
            ButtonSpinnerContainer: {},
            ChipInput: {},
            ChipInputTile: {},
            ChipInputCloseButton: {},
            ToolbarWrapper: {},
            ToolbarCompactViewWrapper: {},
            ToolbarSeparator: {},
            ToolbarFileAttachmentButton: {},
            ToolbarButton: {
              Default: {},
              Active: {}
            },
            ToolbarPopover: {},
            LinkPanelWrapper: {},
            LinkPanelCloseIcon: {},
            LinkPanelTitle: {},
            LinkPanelButtonsContainer: {},
            LinkPanelField: {}
          }
        },
        UserCard: {
          AvatarContainer: {
            background: i.backgroundColors.colorBackgroundBody,
            color: i.textColors.colorText,
            borderColor: i.borderColors.colorBorderWeak
          },
          AvailabilityContainer: {},
          FirstLineInfoContainer: {},
          SecondLineInfoContainer: {}
        },
        Progress: {
          Circular: {
            staticBackgroundBorderColor: i.borderColors.colorBorderInverseStrongest,
            animatingBackgroundBorderColor: i.borderColors.colorBorderWeak,
            animatingForegroundBorderColor: i.borderColors.colorBorderPrimary
          }
        },
        SidePanel: {
          Container: {
            borderColor: i.borderColors.colorBorderWeak,
            color: i.textColors.colorText
          },
          Header: {
            borderColor: i.borderColors.colorBorderWeak,
            color: i.textColors.colorText
          },
          HeaderButton: {}
        },
        FilterList: {
          ApplyButton: {},
          ResetButton: {},
          ItemContainer: {
            borderColor: i.borderColors.colorBorderWeak
          },
          ItemContainerExpanded: {
            background: i.backgroundColors.colorBackgroundBody
          }
        },
        Badge: {
          OuterCircle: {
            background: "inherit"
          },
          InnerCircle: {
            color: t ? i.textColors.colorTextInverse : i.textColors.colorText,
            background: i.backgroundColors.colorBackgroundDestructive
          }
        },
        CountrySelector: {
          CountryList: {
            backgroundColor: i.backgroundColors.colorBackgroundBody,
            borderColor: i.borderColors.colorBorder
          },
          CountryItem: {
            lightHover: !t,
            Selected: {
              backgroundColor: i.backgroundColors.colorBackgroundStrong
            }
          },
          Flag: {
            borderColor: i.borderColors.colorBorderWeak
          }
        },
        DataTable: {
          Header: {
            root: {},
            clickable: {
              "&:hover": {
                cursor: "pointer",
                textDecoration: "underline"
              }
            },
            withSubHeader: {}
          },
          SubHeader: {
            root: {},
            clickable: {
              "&:hover": {
                cursor: "pointer",
                textDecoration: "underline"
              }
            }
          }
        },
        IconContainer: {
          VirtualAgent: {
            width: l.space70,
            height: l.space70,
            backgroundColor: n.colorBackgroundVirtualAgent,
            color: n.colorBackgroundWhite
          },
          Customer: {
            width: l.space70,
            height: l.space70,
            backgroundColor: n.colorBackgroundCustomer,
            color: n.colorBackgroundBlack
          },
          TranscriptListItem: {
            width: l.space120,
            height: l.space120,
            backgroundColor: n.colorBackgroundCustomer,
            color: n.colorBackgroundBlack
          }
        },
        TranscriptMessage: {
          ChatMessage: {
            variants: {
              inbound: {
                ChatBubble: {
                  backgroundColor: t ? n.colorBackground : n.colorBackgroundBodyInverse,
                  color: t ? i.textColors.colorText : i.textColors.colorTextBrandInverse
                }
              },
              outbound: {
                ChatBubble: {
                  backgroundColor: t ? i.borderColors.colorBorderPrimaryWeakest : n.colorBackgroundInverseStrong,
                  color: t ? i.textColors.colorText : i.textColors.colorTextBrandInverse
                }
              }
            }
          }
        }
      });
    };
  }, function (e, t) {
    e.exports = require("@twilio-paste/design-tokens");
  }, function (e, t) {
    e.exports = require("@twilio-paste/design-tokens/dist/themes/dark/tokens.common");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PerformanceTracker = void 0;
    var r = n(632);
    t.PerformanceTracker = new r.PerformanceTrackerImpl();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PerformanceTrackerImpl = void 0;
    var r = function () {
      var e = this;
      this.start = function (e) {
        0 === performance.getEntriesByName(e + "-start").length && performance.mark(e + "-start");
      }, this.end = function (t) {
        var n;
        try {
          performance.mark(t + "-end"), n = {
            startTime: Math.ceil(performance.measure(t + "-duration", t + "-start", t + "-end").startTime),
            duration: Math.ceil(performance.measure(t + "-duration", t + "-start", t + "-end").duration)
          };
        } catch (e) {
          n = {
            startTime: -1,
            duration: -1
          };
        } finally {
          e.clear(t);
        }
        return n;
      }, this.clear = function (e) {
        e || (performance.clearMarks(), performance.clearMeasures()), performance.clearMarks(e + "-end"), performance.clearMeasures(e + "-duration");
      };
    };
    t.PerformanceTrackerImpl = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VERSION = void 0, t.VERSION = "2.3.2";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function () {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
      a = this && this.__spreadArray || function (e, t, n) {
        if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
        return e.concat(r || Array.prototype.slice.call(t));
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatActions = void 0;
    var s = n(123),
      l = n(23),
      c = n(28),
      u = n(8),
      d = n(27),
      f = n(12),
      p = n(16),
      h = n(20),
      v = n(3),
      m = n(13),
      g = n(36),
      b = n(46),
      y = n(11),
      _ = n(24),
      O = function () {
        function e() {}
        return e.registerActions = function () {
          l.Actions.registerAction("SendMessage", this.sendMessage, this.updateChatActionPayload), l.Actions.registerAction("SendMediaMessage", this.sendMediaMessage, this.updateChatActionPayload), l.Actions.registerAction("SendTyping", this.sendTyping, this.updateChatActionPayload), l.Actions.registerAction("SetInputText", this.setInputText, this.updateChatActionPayload), l.Actions.registerAction("AttachFile", this.attachFile, this.updateChatActionPayload), l.Actions.registerAction("AttachFiles", this.attachFiles, this.updateChatActionPayload), l.Actions.registerAction("DetachFile", this.detachFile, this.updateChatActionPayload), l.Actions.registerAction("DownloadMedia", this.downloadMedia, this.updateChatActionPayload), l.Actions.registerAction("ToggleEmailAccordion", this.toggleEmailAccordion), l.Actions.registerAction("CancelEmailDraftDebounce", e.cancelEmailDraftDebounce);
        }, e.sendMessage = function (t) {
          return o(this, void 0, Promise, function () {
            var n, r, o, a, s, l, h, v, b, y, O, C;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (n = t, o = (r = t).conversation, a = r.body, s = r.attachedFiles, l = r.conversationSid, h = Boolean(n.htmlBody), !(null == o ? void 0 : o.source)) throw Error("No valid conversation provided on sendMessage action.");
                  i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), v = "", h && (b = function (e) {
                    if (!e) return "";
                    var t = document.createElement("div");
                    t.innerHTML = e.replace(/(<\/[a-zA-Z]+>)(<[^/])/g, "$1\n$2");
                    var n = t.innerText;
                    return t.remove(), n;
                  }, t.body || (v = n.plainTextBody || b(n.htmlBody))), y = o.source.prepareMessage().setBody(t.body || v), (null == s ? void 0 : s.length) && (h || c.ChatManager.shouldUseMessageInputV2()) && (!h && e.validateSendingFiles({
                    conversation: o,
                    files: s
                  }), s.forEach(function (e) {
                    var t = new FormData();
                    t.append(e.name, e), y.addMedia(t);
                  })), t.messageAttributes && (y = y.setAttributes(t.messageAttributes)), n.subject && (y = y.setSubject(n.subject)), n.htmlBody && (y = y.setEmailBody("text/html", {
                    media: n.htmlBody,
                    contentType: "text/html"
                  })), v && (y = y.setEmailBody("text/plain", {
                    media: v,
                    contentType: "text/plain"
                  })), _.TelemetryBridge.emit(_.TelemetryBridgeMessageType.UI_INTERACTION_EVENT, {
                    name: "conversation_call_for_email_started",
                    category: "email",
                    status: "start"
                  }), [4, y.build().send()];
                case 2:
                  return O = i.sent(), _.TelemetryBridge.emit(_.TelemetryBridgeMessageType.UI_INTERACTION_EVENT, {
                    name: "conversation_call_for_email_complete",
                    category: "email",
                    status: "complete"
                  }), u.ChatModule.events.emitMessagePosted(o.source.sid, a), null == s || s.forEach(function (t) {
                    e.detachFile({
                      file: t,
                      conversation: o
                    });
                  }), (c.ChatManager.shouldUseMessageInputV2() || h) && (0, g.tryInvokeAction)("SetInputText", {
                    conversation: o,
                    body: ""
                  }), _.TelemetryBridge.emit(_.TelemetryBridgeMessageType.UI_INTERACTION_EVENT, {
                    name: "email_sent_successful",
                    category: "email",
                    status: "complete"
                  }), [2, O];
                case 3:
                  throw C = i.sent(), _.TelemetryBridge.emit(_.TelemetryBridgeMessageType.ERROR_EVENT, {
                    type: "email",
                    description: "Error while sending an email.",
                    context: "sendMessage",
                    wrappedError: C
                  }), e.dispatchInputTextAction(o, a), m.Notifications.showNotification(m.NotificationIds.SendMessageFailed, {
                    conversationSid: l
                  }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FAILED_TO_SEND_MESSAGE_TO_CHANNEL, {
                    type: d.CoreErrorType.chatSDK,
                    description: "Failed to send message to conversation " + o.source.sid,
                    context: "Chat",
                    wrappedError: C
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.sendMediaMessage = function (t) {
          var n;
          return o(this, void 0, Promise, function () {
            var r, o, a, s, l, c, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  v.log.warn("Action 'SendMediaMessage' is deprecated. Please enable new send message behaviour."), r = t.conversation, o = t.file, a = t.messageAttributes, s = t.channel, e.validateSendingFiles({
                    conversation: r,
                    files: [o]
                  }), y.Actions.addPendingMessage(o, r.source, null == s ? void 0 : s.source), (l = new FormData()).append("file", o), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, r.source.sendMessage(l, a)];
                case 2:
                  return c = i.sent(), u.ChatModule.events.emitMediaMessagePosted(r.source.sid, o), y.Actions.removePendingMessage(o, r.source), [2, c];
                case 3:
                  throw h = i.sent(), y.Actions.rejectMediaMessage(o, r.source), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
                    type: d.CoreErrorType.chatSDK,
                    description: "Failed to send media message to conversation " + (null === (n = null == r ? void 0 : r.source) || void 0 === n ? void 0 : n.sid),
                    context: "Chat|FileAttachment",
                    wrappedError: h
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.sendTyping = function (e) {
          var t, n;
          return o(this, void 0, Promise, function () {
            return i(this, function (r) {
              return null === (n = null === (t = e.conversation) || void 0 === t ? void 0 : t.source) || void 0 === n || n.typing().catch(function (t) {
                var n, r;
                return Promise.reject(f.ErrorManager.createAndProcessError(p.ErrorMessages.SEND_TYPING_FAILED, {
                  type: d.CoreErrorType.chatSDK,
                  description: "Failed to send typing indicator to conversation " + (null === (r = null === (n = e.conversation) || void 0 === n ? void 0 : n.source) || void 0 === r ? void 0 : r.sid),
                  context: "SendTyping",
                  wrappedError: t
                }));
              }), [2];
            });
          });
        }, e.setInputText = function (t) {
          return o(this, void 0, Promise, function () {
            return i(this, function (n) {
              if (!t.conversation) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.SET_INPUT_TEXT_FAILED, {
                context: "SetInputText",
                description: "conversation not defined"
              });
              return e.dispatchInputTextAction(t.conversation, t.body, t.selectionStart, t.selectionEnd, t.htmlValue), "" !== t.body && l.Actions.invokeAction("SendTyping", {
                channel: t.channel,
                channelSid: t.channelSid,
                conversation: t.conversation,
                conversationSid: t.conversationSid
              }).catch(function (e) {
                v.log.trace("Unable to send typing to indicator (might be sent already)", e);
              }), [2];
            });
          });
        }, e.attachFile = function (t) {
          return o(this, void 0, Promise, function () {
            var n, r, o;
            return i(this, function (i) {
              return n = t.conversation, r = t.conversationSid, o = t.file, [2, e.attachFiles({
                conversation: n,
                conversationSid: r,
                files: [o]
              })];
            });
          });
        }, e.attachFiles = function (t) {
          return o(this, void 0, Promise, function () {
            var n, r, o, a, s;
            return i(this, function (i) {
              if (n = t.conversation, r = t.files, o = e.validateAttachingFiles({
                conversation: n,
                files: r
              }), a = o.validFiles, s = o.errors, !a.length) throw s[0];
              return [2, b.Actions.attachFiles(n, a)];
            });
          });
        }, e.detachFile = function (e) {
          return o(this, void 0, Promise, function () {
            return i(this, function (t) {
              return [2, b.Actions.detachFile(e.conversation, e.file)];
            });
          });
        }, e.downloadMedia = function (t) {
          var n,
            r = t.media,
            a = t.conversation;
          return o(this, void 0, Promise, function () {
            var t, o, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  t = {
                    name: r.filename || "unnamed." + (0, s.extension)(r.contentType),
                    size: r.size,
                    type: r.contentType
                  }, e.validateDownloadingFile({
                    file: t,
                    conversation: a
                  }), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, r.getContentTemporaryUrl()];
                case 2:
                  return o = i.sent(), window.open(o), [3, 4];
                case 3:
                  throw l = i.sent(), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_UNABLE_TO_DOWNLOAD, {
                    type: d.CoreErrorType.chatSDK,
                    description: "Failed to download message from conversation " + (null === (n = null == a ? void 0 : a.source) || void 0 === n ? void 0 : n.sid),
                    context: "Chat|FileAttachment",
                    wrappedError: l
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.toggleEmailAccordion = function (e) {
          return o(this, void 0, void 0, function () {
            return i(this, function (t) {
              if (!e.accordionId) throw Error("EmailAccordionToggle action invoked without accordionId");
              return [2, e];
            });
          });
        }, e.cancelEmailDraftDebounce = function () {
          return o(this, void 0, void 0, function () {
            return i(this, function (e) {
              return [2, !0];
            });
          });
        }, e.dispatchInputTextAction = function (e, t, n, r, o) {
          b.Actions.setInputText(e, t, n, r, o);
        }, e.updateChatActionPayload = function (e) {
          var t, n, r, o;
          return e.conversationSid ? e.conversation || (e.conversation = u.ChatModule.state.conversations[e.conversationSid]) : e.conversationSid = null === (n = null === (t = null == e ? void 0 : e.conversation) || void 0 === t ? void 0 : t.source) || void 0 === n ? void 0 : n.sid, e.channelSid ? e.channelSid && !e.channel && (e.channel = u.ChatModule.state.channels[e.channelSid]) : e.channelSid = null === (o = null === (r = null == e ? void 0 : e.channel) || void 0 === r ? void 0 : r.source) || void 0 === o ? void 0 : o.sid, e;
        }, e.validateDownloadingFile = function (e) {
          var t = e.conversation,
            n = e.file;
          if (!t) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "conversation not defined"
          });
          if (!(null == t ? void 0 : t.source)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "conversation.source not found"
          });
          if (!(null == t ? void 0 : t.source.sid)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "conversation sid not found"
          });
          var r = t.source.sid;
          if (!(0, h.isValidFileType)(n, r)) throw m.Notifications.showNotification(m.NotificationIds.DownloadFileInvalidType, {
            conversationSid: r,
            fileName: n.name
          }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_DOWNLOAD_INVALID_TYPE, {
            context: "Chat|FileAttachment",
            severity: d.CoreErrorSeverity.user
          });
          var o = (0, h.getDerivedFileLimits)(t),
            i = o.fileSizeLimit,
            a = o.totalFileSizeLimit;
          if (n.size > i || n.size > a) throw m.Notifications.showNotification(m.NotificationIds.DownloadFileInvalidSize, {
            conversationSid: r,
            fileName: n.name,
            maxFileSize: i / 1024 / 1024 + "MB"
          }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_DOWNLOAD_INVALID_SIZE, {
            context: "Chat|FileAttachment",
            severity: d.CoreErrorSeverity.user
          });
        }, e.validateSendingFiles = function (e) {
          var t = e.conversation,
            n = e.files;
          if (!t) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "conversation not defined"
          });
          if (!(null == t ? void 0 : t.source)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "conversation.source not found"
          });
          if (!(null == t ? void 0 : t.source.sid)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "conversation sid not found"
          });
          var r = t.source.sid;
          if (!(0, h.isFileAttachmentEnabled)(r)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_DISABLED, {
            context: "Chat|FileAttachment"
          });
          if ((0, h.isFileAttachmentReadOnly)(r)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_READ_ONLY, {
            context: "Chat|FileAttachment",
            severity: d.CoreErrorSeverity.user
          });
          var o = (0, h.getDerivedFileLimits)(t),
            i = o.fileSizeLimit,
            a = o.fileCountLimit;
          if (n.length > a) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
            context: "Chat|FileAttachment",
            description: "number of attached files to send is over the limit"
          });
          n.forEach(function (e) {
            if (!(0, h.isValidFileType)(e, r)) throw m.Notifications.showNotification(m.NotificationIds.SendMediaMessageInvalidType, {
              conversationSid: r,
              fileName: e.name
            }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_TYPE, {
              context: "Chat|FileAttachment",
              severity: d.CoreErrorSeverity.user
            });
            if (e.size > i) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_SIZE, {
              context: "Chat|FileAttachment",
              severity: d.CoreErrorSeverity.user
            });
          });
        }, e.validateAttachingFiles = function (e) {
          var t = e.conversation,
            n = e.files,
            o = [],
            i = [];
          try {
            if (!t) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
              context: "Chat|FileAttachment",
              description: "conversation not defined"
            });
            if (!(null == t ? void 0 : t.source)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
              context: "Chat|FileAttachment",
              description: "conversation.source not found"
            });
            if (!(null == t ? void 0 : t.source.sid)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
              context: "Chat|FileAttachment",
              description: "conversation sid not found"
            });
            var s = t.source.sid;
            if (!(0, h.isFileAttachmentEnabled)(s)) throw m.Notifications.showNotification(m.NotificationIds.AttachFileDisabled, {
              conversationSid: s
            }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_DISABLED, {
              context: "Chat|FileAttachment"
            });
            if ((0, h.isFileAttachmentReadOnly)(s)) throw f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_READ_ONLY, {
              context: "Chat|FileAttachment",
              severity: d.CoreErrorSeverity.user
            });
          } catch (e) {
            return {
              validFiles: o,
              errors: [e]
            };
          }
          var l = t.source.sid,
            c = (0, h.getDerivedFileLimits)(t),
            v = c.fileSizeLimit,
            g = c.fileCountLimit,
            b = c.totalFileSizeLimit,
            y = u.ChatModule.state.conversationInput[l].attachedFiles,
            _ = [],
            O = !1,
            C = !1;
          return n.forEach(function (e) {
            if (!O) try {
              if (a(a(a([], o, !0), y || [], !0), [e], !1).length > g) throw O = !0, f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_TOO_MANY, {
                context: "Chat|FileAttachment",
                severity: d.CoreErrorSeverity.user
              });
              if (a(a([], y || [], !0), o, !0).find(function (t) {
                return t.name === e.name && t.size === e.size && t.type === e.type;
              })) throw _.push({
                id: m.NotificationIds.AttachFileDuplicate,
                context: {
                  fileName: e.name
                }
              }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_DUPLICATE, {
                context: "Chat|FileAttachment",
                severity: d.CoreErrorSeverity.user
              });
              if (!(0, h.isValidFileType)(e, l)) throw _.push({
                id: m.NotificationIds.AttachFileInvalidType,
                context: {
                  fileName: e.name
                }
              }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_INVALID_TYPE, {
                context: "Chat|FileAttachment",
                severity: d.CoreErrorSeverity.user
              });
              if (e.size > v) throw _.push({
                id: m.NotificationIds.AttachFileInvalidSize,
                context: {
                  fileName: e.name,
                  maxFileSize: v / 1024 / 1024 + "MB"
                }
              }), f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_INVALID_SIZE, {
                context: "Chat|FileAttachment",
                severity: d.CoreErrorSeverity.user
              });
              if (a(a(a([], o, !0), y || [], !0), [e], !1).reduce(function (e, t) {
                return e + t.size;
              }, 0) > b) throw C = !0, f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_INVALID_OVERALL_SIZE, {
                context: "Chat|FileAttachment",
                severity: d.CoreErrorSeverity.user
              });
              o.push(e);
            } catch (e) {
              i.push(e);
            }
          }), O && (_.push({
            id: m.NotificationIds.AttachFileInvalidMaxAmount,
            context: {
              maxAmount: g,
              singular: 1 === g
            }
          }), i.push(f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_TOO_MANY, {
            context: "Chat|FileAttachment",
            severity: d.CoreErrorSeverity.user
          }))), C && (_.push({
            id: m.NotificationIds.AttachFileInvalidOverallSize,
            context: {
              maxOverallFileSize: b / 1024 / 1024 + "MB"
            }
          }), i.push(f.ErrorManager.createAndProcessError(p.ErrorMessages.FILE_ATTACHMENT_ATTACH_INVALID_OVERALL_SIZE, {
            context: "Chat|FileAttachment",
            severity: d.CoreErrorSeverity.user
          }))), _.length && (1 === _.length ? m.Notifications.showNotification(_[0].id, r(r({}, _[0].context), {
            conversationSid: l
          })) : m.Notifications.showNotification(m.NotificationIds.AttachFileMultipleFailure, {
            failureCount: _.length,
            conversationSid: l
          }, _)), {
            validFiles: o,
            errors: i
          };
        }, e;
      }();
    t.ChatActions = O;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(636), n(144), n(167);
  }, function (e, t, n) {
    "use strict";

    var r,
      o = this && this.__extends || (r = function (e, t) {
        return (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function n() {
          this.constructor = e;
        }
        r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BrowserNotificationHandler = void 0;
    var a = n(13),
      s = n(76),
      l = n(2),
      c = function (e) {
        function t() {
          var t = e.call(this) || this;
          return t.id = a.DefaultNotificationHandlerType.Browser, t.isDocumentFocused = !1, t.handleInitialClick = function () {
            t.isDocumentFocused = !0, window.removeEventListener("click", t.handleInitialClick);
          }, t.handleDocumentBlur = function () {
            t.isDocumentFocused = !1;
          }, t.handleDocumentFocus = function () {
            t.isDocumentFocused = !0;
          }, t.currentNotifications = [], t.handleClose = function (e, t) {
            a.Notifications.dismissNotification(t), t.options.browser.onClose && t.options.browser.onClose(t, e);
          }, t.handleShow = function (e, t) {
            t.options.browser.onShow && t.options.browser.onShow(t, e);
          }, t.handleError = function (e, t) {
            t.options.browser.onError && t.options.browser.onError(t, e);
          }, t.handleClick = function (e, t) {
            window.focus(), e.target.close(), t.options.browser.onClick && t.options.browser.onClick(t, e);
          }, window.addEventListener("click", t.handleInitialClick), window.addEventListener("blur", t.handleDocumentBlur), window.addEventListener("focus", t.handleDocumentFocus), t;
        }
        return o(t, e), t.prototype.canHandleNotification = function (e) {
          return !!e.options && !!e.options.browser && !this.isDocumentFocused;
        }, t.prototype.handleNotification = function (e) {
          var t = this,
            n = "",
            r = i({}, e.options.browser.options);
          e.options.browser.title && (n = (o = l.templates[e.options.browser.title]) ? o(e.context) : e.options.browser.title);
          if (e.options.browser.body) {
            var o = l.templates[e.options.browser.body];
            r.body = o ? o(e.context) : e.options.browser.body;
          }
          var a = new Notification(n, r);
          a.onclose = function (n) {
            return t.handleClose(n, e);
          }, a.onclick = function (n) {
            return t.handleClick(n, e);
          }, a.onerror = function (n) {
            return t.handleError(n, e);
          }, a.onshow = function (n) {
            return t.handleShow(n, e);
          }, this.currentNotifications.length >= 5 && this.currentNotifications.shift(), this.currentNotifications.push({
            browser: a,
            inner: e
          });
        }, t.prototype.dismissNotification = function (e) {
          var t = this.currentNotifications.findIndex(function (t) {
            return t.inner === e;
          });
          t > -1 && (this.currentNotifications[t].browser.close(), this.currentNotifications.splice(t, 1));
        }, t;
      }(s.BaseNotificationHandler);
    t.BrowserNotificationHandler = c, a.Notifications.registerHandler(new c());
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function () {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
      i = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
        return o(t, e), t;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.registerNotifications = void 0;
    var a = i(n(54)),
      s = n(13);
    t.registerNotifications = function () {
      var e = {
        id: a.NewChatMessage,
        options: {
          browser: {
            title: "NewChatMessageNotificationTitle",
            body: "NewChatMessageNotificationBody"
          }
        }
      };
      s.Notifications.registerNotification(e);
      var t = {
        id: a.SendMediaMessageInvalidSize,
        content: "SendMediaMessageInvalidSize",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(t);
      var n = {
        id: a.SendMediaMessageInvalidType,
        content: "SendMediaMessageInvalidType",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(n);
      var r = {
        id: a.SendMessageFailed,
        content: "SendMessageFailed",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(r);
      var o = {
        id: a.AttachFileMultipleFailure,
        content: "AttachFileMultipleFailure",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(o);
      var i = {
        id: a.AttachFileDuplicate,
        content: "AttachFileDuplicate",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(i);
      var l = {
        id: a.AttachFileInvalidSize,
        content: "AttachFileInvalidSize",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(l);
      var c = {
        id: a.AttachFileInvalidType,
        content: "AttachFileInvalidType",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(c);
      var u = {
        id: a.AttachFileInvalidMaxAmount,
        content: "AttachFileInvalidMaxAmount",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(u);
      var d = {
        id: a.AttachFileInvalidOverallSize,
        content: "AttachFileInvalidOverallSize",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(d);
      var f = {
        id: a.AttachFileMultipleNotSupported,
        content: "AttachFileMultipleNotSupported",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(f);
      var p = {
        id: a.AttachFileDisabled,
        content: "AttachFileDisabled",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(p);
      var h = {
        id: a.DownloadFileInvalidSize,
        content: "DownloadFileInvalidSize",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(h);
      var v = {
        id: a.DownloadFileInvalidType,
        content: "DownloadFileInvalidType",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        }
      };
      s.Notifications.registerNotification(v);
      var m = {
        id: a.EmailSuccessfullySent,
        content: "EmailSentNotification",
        type: s.NotificationType.success,
        options: {
          target: "messagingCanvas"
        },
        timeout: 3e3
      };
      s.Notifications.registerNotification(m);
      var g = {
        id: a.EmailAddParticipantFailed,
        content: "EmailAddParticipantFailedNotification",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        },
        timeout: 1e4
      };
      s.Notifications.registerNotification(g);
      var b = {
        id: a.EmailRemoveParticipantFailed,
        content: "EmailRemoveParticipantFailedNotification",
        type: s.NotificationType.error,
        options: {
          target: "messagingCanvas"
        },
        timeout: 1e4
      };
      s.Notifications.registerNotification(b);
    };
  }]);
});